import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions =  {}
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** A floating point number that requires more precision than IEEE 754 binary 64 */
  BigFloat: any;
  /**
   * A signed eight-byte integer. The upper big integer values are greater than the
   * max value for a JavaScript number. Therefore all big integers will be output as
   * strings and not numbers.
   */
  BigInt: any;
  /** A location in a connection that can be used for resuming pagination. */
  Cursor: any;
  /** The day, does not include a time. */
  Date: any;
  /** DateTime custom scalar type */
  DateTime: any;
  /**
   * A point in time as described by the [ISO
   * 8601](https://en.wikipedia.org/wiki/ISO_8601) standard. May or may not include a timezone.
   */
  Datetime: any;
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: any;
  NonNullableInt: any;
  NonNullablePhoneNumber: any;
  NonNullableText: any;
  NonNullableTimestamptz: any;
  NonNullableUsPostalCode: any;
  /** The exact time of day, does not include the date. May or may not have a timezone offset. */
  Time: any;
  /** A universally unique identifier as defined by [RFC 4122](https://tools.ietf.org/html/rfc4122). */
  UUID: any;
  UsPostalCode: any;
  /** ZipCode custom scalar type */
  ZipCode: any;
};

export enum ActivationEnum {
  EMS = 'EMS',
  POLICE = 'POLICE'
}

export type AddEncounterInput = {
  appointmentId: Scalars['Int'];
  channelAttributionId: Scalars['Int'];
  genderRequirement?: InputMaybe<SexEnum>;
  modules?: InputMaybe<Array<InputMaybe<ModuleNameEnum>>>;
  patientId: Scalars['Int'];
  reasonForEncounter: Scalars['NonNullableText'];
  serviceLineId: Scalars['Int'];
  systemLastUpdatedBy: SystemOfOriginEnum;
};

export type AddEncounterPayload = {
  __typename: 'AddEncounterPayload';
  encounter?: Maybe<Encounter>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** All input for the `addStandingOrder` mutation. */
export type AddStandingOrderInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  vCode?: InputMaybe<Scalars['String']>;
  vDiagnosisCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  vEndedAt?: InputMaybe<Scalars['Date']>;
  vName?: InputMaybe<Scalars['String']>;
  vNpi?: InputMaybe<Scalars['String']>;
  vNumber?: InputMaybe<Scalars['String']>;
  vOrderType?: InputMaybe<StandingOrderLookupTypeEnum>;
  vProcedureCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  vStartedAt?: InputMaybe<Scalars['Date']>;
  vState?: InputMaybe<Scalars['String']>;
  vUrl?: InputMaybe<Scalars['String']>;
  vVersion?: InputMaybe<Scalars['String']>;
};

/** The output of our `addStandingOrder` mutation. */
export type AddStandingOrderPayload = {
  __typename: 'AddStandingOrderPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  integer?: Maybe<Scalars['Int']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** A connection to a list of `Addendum` values. */
export type AddendaConnection = {
  __typename: 'AddendaConnection';
  /** A list of edges which contains the `Addendum` and cursor to aid in pagination. */
  edges: Array<AddendaEdge>;
  /** A list of `Addendum` objects. */
  nodes: Array<Addendum>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Addendum` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Addendum` edge in the connection. */
export type AddendaEdge = {
  __typename: 'AddendaEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `Addendum` at the end of the edge. */
  node: Addendum;
};

/** Methods to use when ordering `Addendum`. */
export enum AddendaOrderBy {
  ADDENDUM_ID_ASC = 'ADDENDUM_ID_ASC',
  ADDENDUM_ID_DESC = 'ADDENDUM_ID_DESC',
  ENCOUNTER_ID_ASC = 'ENCOUNTER_ID_ASC',
  ENCOUNTER_ID_DESC = 'ENCOUNTER_ID_DESC',
  MIGRATION_SOURCE_ASC = 'MIGRATION_SOURCE_ASC',
  MIGRATION_SOURCE_DESC = 'MIGRATION_SOURCE_DESC',
  NATURAL = 'NATURAL',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC'
}

/** Contains information about addendums to an encounter */
export type Addendum = Node & {
  __typename: 'Addendum';
  /** Reads and enables pagination through a set of `AddendumAttachment`. */
  addendumAttachments: AddendumAttachmentsConnection;
  /** Reads and enables pagination through a set of `AddendumAttachment`. */
  addendumAttachmentsList: Array<AddendumAttachment>;
  addendumId: Scalars['Int'];
  createdAt: Scalars['Datetime'];
  createdBy: Scalars['Int'];
  deletedAt?: Maybe<Scalars['Datetime']>;
  deletedBy?: Maybe<Scalars['Int']>;
  /** Reads a single `Encounter` that is related to this `Addendum`. */
  encounter?: Maybe<Encounter>;
  encounterId: Scalars['Int'];
  migrationSource?: Maybe<Scalars['String']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  note: Scalars['String'];
  user?: Maybe<User>;
};


/** Contains information about addendums to an encounter */
export type AddendumaddendumAttachmentsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<AddendumAttachmentCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AddendumAttachmentsOrderBy>>;
};


/** Contains information about addendums to an encounter */
export type AddendumaddendumAttachmentsListArgs = {
  condition?: InputMaybe<AddendumAttachmentCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AddendumAttachmentsOrderBy>>;
};

/** Contains information about attachments to an addendum */
export type AddendumAttachment = Node & {
  __typename: 'AddendumAttachment';
  /** Reads a single `Addendum` that is related to this `AddendumAttachment`. */
  addendum?: Maybe<Addendum>;
  addendumAttachmentId: Scalars['Int'];
  addendumId?: Maybe<Scalars['Int']>;
  createdAt: Scalars['Datetime'];
  createdById?: Maybe<Scalars['Int']>;
  deletedAt?: Maybe<Scalars['Datetime']>;
  deletedById?: Maybe<Scalars['Int']>;
  description?: Maybe<Scalars['String']>;
  isDeleted: Scalars['Boolean'];
  migrationSource?: Maybe<Scalars['String']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  type?: Maybe<AddendumAttachmentTypeEnum>;
  url?: Maybe<Scalars['String']>;
};

/**
 * A condition to be used against `AddendumAttachment` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type AddendumAttachmentCondition = {
  /** Checks for equality with the object’s `addendumAttachmentId` field. */
  addendumAttachmentId?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `addendumId` field. */
  addendumId?: InputMaybe<Scalars['Int']>;
};

export enum AddendumAttachmentTypeEnum {
  FORMS = 'FORMS'
}

/** A connection to a list of `AddendumAttachment` values. */
export type AddendumAttachmentsConnection = {
  __typename: 'AddendumAttachmentsConnection';
  /** A list of edges which contains the `AddendumAttachment` and cursor to aid in pagination. */
  edges: Array<AddendumAttachmentsEdge>;
  /** A list of `AddendumAttachment` objects. */
  nodes: Array<AddendumAttachment>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `AddendumAttachment` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `AddendumAttachment` edge in the connection. */
export type AddendumAttachmentsEdge = {
  __typename: 'AddendumAttachmentsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `AddendumAttachment` at the end of the edge. */
  node: AddendumAttachment;
};

/** Methods to use when ordering `AddendumAttachment`. */
export enum AddendumAttachmentsOrderBy {
  ADDENDUM_ATTACHMENT_ID_ASC = 'ADDENDUM_ATTACHMENT_ID_ASC',
  ADDENDUM_ATTACHMENT_ID_DESC = 'ADDENDUM_ATTACHMENT_ID_DESC',
  ADDENDUM_ID_ASC = 'ADDENDUM_ID_ASC',
  ADDENDUM_ID_DESC = 'ADDENDUM_ID_DESC',
  NATURAL = 'NATURAL',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC'
}

/**
 * A condition to be used against `Addendum` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type AddendumCondition = {
  /** Checks for equality with the object’s `addendumId` field. */
  addendumId?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `encounterId` field. */
  encounterId?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `migrationSource` field. */
  migrationSource?: InputMaybe<Scalars['String']>;
};

/** A connection to a list of `AllergicCriticality` values. */
export type AllergicCriticalitiesConnection = {
  __typename: 'AllergicCriticalitiesConnection';
  /** A list of edges which contains the `AllergicCriticality` and cursor to aid in pagination. */
  edges: Array<AllergicCriticalitiesEdge>;
  /** A list of `AllergicCriticality` objects. */
  nodes: Array<AllergicCriticality>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `AllergicCriticality` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `AllergicCriticality` edge in the connection. */
export type AllergicCriticalitiesEdge = {
  __typename: 'AllergicCriticalitiesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `AllergicCriticality` at the end of the edge. */
  node: AllergicCriticality;
};

/** Methods to use when ordering `AllergicCriticality`. */
export enum AllergicCriticalitiesOrderBy {
  ALLERGIC_CRITICALITY_ID_ASC = 'ALLERGIC_CRITICALITY_ID_ASC',
  ALLERGIC_CRITICALITY_ID_DESC = 'ALLERGIC_CRITICALITY_ID_DESC',
  NATURAL = 'NATURAL',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC'
}

/** Contains information about allergic criticality */
export type AllergicCriticality = Node & {
  __typename: 'AllergicCriticality';
  allergicCriticalityId: Scalars['Int'];
  /** Reads and enables pagination through a set of `AllergicReaction`. */
  allergicReactionsByPatientAllergyAllergicCriticalityIdAndAllergicReactionId: AllergicCriticalityAllergicReactionsByPatientAllergyAllergicCriticalityIdAndAllergicReactionIdManyToManyConnection;
  /** Reads and enables pagination through a set of `AllergicReaction`. */
  allergicReactionsByPatientAllergyAllergicCriticalityIdAndAllergicReactionIdList: Array<AllergicReaction>;
  /** Reads and enables pagination through a set of `AllergicSeverity`. */
  allergicSeveritiesByPatientAllergyAllergicCriticalityIdAndAllergicSeverityId: AllergicCriticalityAllergicSeveritiesByPatientAllergyAllergicCriticalityIdAndAllergicSeverityIdManyToManyConnection;
  /** Reads and enables pagination through a set of `AllergicSeverity`. */
  allergicSeveritiesByPatientAllergyAllergicCriticalityIdAndAllergicSeverityIdList: Array<AllergicSeverity>;
  /** Reads and enables pagination through a set of `AllergicStatus`. */
  allergicStatusesByPatientAllergyAllergicCriticalityIdAndAllergicStatusId: AllergicCriticalityAllergicStatusesByPatientAllergyAllergicCriticalityIdAndAllergicStatusIdManyToManyConnection;
  /** Reads and enables pagination through a set of `AllergicStatus`. */
  allergicStatusesByPatientAllergyAllergicCriticalityIdAndAllergicStatusIdList: Array<AllergicStatus>;
  /** Reads and enables pagination through a set of `Allergy`. */
  allergiesByPatientAllergyAllergicCriticalityIdAndAllergyId: AllergicCriticalityAllergiesByPatientAllergyAllergicCriticalityIdAndAllergyIdManyToManyConnection;
  /** Reads and enables pagination through a set of `Allergy`. */
  allergiesByPatientAllergyAllergicCriticalityIdAndAllergyIdList: Array<Allergy>;
  code: Scalars['String'];
  codeSystemId?: Maybe<Scalars['Int']>;
  isDeleted: Scalars['Boolean'];
  name: Scalars['String'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  /** Reads and enables pagination through a set of `PatientAllergy`. */
  patientAllergies: PatientAllergiesConnection;
  /** Reads and enables pagination through a set of `PatientAllergy`. */
  patientAllergiesList: Array<PatientAllergy>;
};


/** Contains information about allergic criticality */
export type AllergicCriticalityallergicReactionsByPatientAllergyAllergicCriticalityIdAndAllergicReactionIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<AllergicReactionCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AllergicReactionsOrderBy>>;
};


/** Contains information about allergic criticality */
export type AllergicCriticalityallergicReactionsByPatientAllergyAllergicCriticalityIdAndAllergicReactionIdListArgs = {
  condition?: InputMaybe<AllergicReactionCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AllergicReactionsOrderBy>>;
};


/** Contains information about allergic criticality */
export type AllergicCriticalityallergicSeveritiesByPatientAllergyAllergicCriticalityIdAndAllergicSeverityIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<AllergicSeverityCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AllergicSeveritiesOrderBy>>;
};


/** Contains information about allergic criticality */
export type AllergicCriticalityallergicSeveritiesByPatientAllergyAllergicCriticalityIdAndAllergicSeverityIdListArgs = {
  condition?: InputMaybe<AllergicSeverityCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AllergicSeveritiesOrderBy>>;
};


/** Contains information about allergic criticality */
export type AllergicCriticalityallergicStatusesByPatientAllergyAllergicCriticalityIdAndAllergicStatusIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<AllergicStatusCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AllergicStatusesOrderBy>>;
};


/** Contains information about allergic criticality */
export type AllergicCriticalityallergicStatusesByPatientAllergyAllergicCriticalityIdAndAllergicStatusIdListArgs = {
  condition?: InputMaybe<AllergicStatusCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AllergicStatusesOrderBy>>;
};


/** Contains information about allergic criticality */
export type AllergicCriticalityallergiesByPatientAllergyAllergicCriticalityIdAndAllergyIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<AllergyCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AllergiesOrderBy>>;
};


/** Contains information about allergic criticality */
export type AllergicCriticalityallergiesByPatientAllergyAllergicCriticalityIdAndAllergyIdListArgs = {
  condition?: InputMaybe<AllergyCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AllergiesOrderBy>>;
};


/** Contains information about allergic criticality */
export type AllergicCriticalitypatientAllergiesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<PatientAllergyCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PatientAllergiesOrderBy>>;
};


/** Contains information about allergic criticality */
export type AllergicCriticalitypatientAllergiesListArgs = {
  condition?: InputMaybe<PatientAllergyCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PatientAllergiesOrderBy>>;
};

/** A connection to a list of `AllergicReaction` values, with data from `PatientAllergy`. */
export type AllergicCriticalityAllergicReactionsByPatientAllergyAllergicCriticalityIdAndAllergicReactionIdManyToManyConnection = {
  __typename: 'AllergicCriticalityAllergicReactionsByPatientAllergyAllergicCriticalityIdAndAllergicReactionIdManyToManyConnection';
  /** A list of edges which contains the `AllergicReaction`, info from the `PatientAllergy`, and the cursor to aid in pagination. */
  edges: Array<AllergicCriticalityAllergicReactionsByPatientAllergyAllergicCriticalityIdAndAllergicReactionIdManyToManyEdge>;
  /** A list of `AllergicReaction` objects. */
  nodes: Array<AllergicReaction>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `AllergicReaction` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `AllergicReaction` edge in the connection, with data from `PatientAllergy`. */
export type AllergicCriticalityAllergicReactionsByPatientAllergyAllergicCriticalityIdAndAllergicReactionIdManyToManyEdge = {
  __typename: 'AllergicCriticalityAllergicReactionsByPatientAllergyAllergicCriticalityIdAndAllergicReactionIdManyToManyEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `AllergicReaction` at the end of the edge. */
  node: AllergicReaction;
  /** Reads and enables pagination through a set of `PatientAllergy`. */
  patientAllergies: PatientAllergiesConnection;
  /** Reads and enables pagination through a set of `PatientAllergy`. */
  patientAllergiesList: Array<PatientAllergy>;
};


/** A `AllergicReaction` edge in the connection, with data from `PatientAllergy`. */
export type AllergicCriticalityAllergicReactionsByPatientAllergyAllergicCriticalityIdAndAllergicReactionIdManyToManyEdgepatientAllergiesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<PatientAllergyCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PatientAllergiesOrderBy>>;
};


/** A `AllergicReaction` edge in the connection, with data from `PatientAllergy`. */
export type AllergicCriticalityAllergicReactionsByPatientAllergyAllergicCriticalityIdAndAllergicReactionIdManyToManyEdgepatientAllergiesListArgs = {
  condition?: InputMaybe<PatientAllergyCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PatientAllergiesOrderBy>>;
};

/** A connection to a list of `AllergicSeverity` values, with data from `PatientAllergy`. */
export type AllergicCriticalityAllergicSeveritiesByPatientAllergyAllergicCriticalityIdAndAllergicSeverityIdManyToManyConnection = {
  __typename: 'AllergicCriticalityAllergicSeveritiesByPatientAllergyAllergicCriticalityIdAndAllergicSeverityIdManyToManyConnection';
  /** A list of edges which contains the `AllergicSeverity`, info from the `PatientAllergy`, and the cursor to aid in pagination. */
  edges: Array<AllergicCriticalityAllergicSeveritiesByPatientAllergyAllergicCriticalityIdAndAllergicSeverityIdManyToManyEdge>;
  /** A list of `AllergicSeverity` objects. */
  nodes: Array<AllergicSeverity>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `AllergicSeverity` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `AllergicSeverity` edge in the connection, with data from `PatientAllergy`. */
export type AllergicCriticalityAllergicSeveritiesByPatientAllergyAllergicCriticalityIdAndAllergicSeverityIdManyToManyEdge = {
  __typename: 'AllergicCriticalityAllergicSeveritiesByPatientAllergyAllergicCriticalityIdAndAllergicSeverityIdManyToManyEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `AllergicSeverity` at the end of the edge. */
  node: AllergicSeverity;
  /** Reads and enables pagination through a set of `PatientAllergy`. */
  patientAllergies: PatientAllergiesConnection;
  /** Reads and enables pagination through a set of `PatientAllergy`. */
  patientAllergiesList: Array<PatientAllergy>;
};


/** A `AllergicSeverity` edge in the connection, with data from `PatientAllergy`. */
export type AllergicCriticalityAllergicSeveritiesByPatientAllergyAllergicCriticalityIdAndAllergicSeverityIdManyToManyEdgepatientAllergiesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<PatientAllergyCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PatientAllergiesOrderBy>>;
};


/** A `AllergicSeverity` edge in the connection, with data from `PatientAllergy`. */
export type AllergicCriticalityAllergicSeveritiesByPatientAllergyAllergicCriticalityIdAndAllergicSeverityIdManyToManyEdgepatientAllergiesListArgs = {
  condition?: InputMaybe<PatientAllergyCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PatientAllergiesOrderBy>>;
};

/** A connection to a list of `AllergicStatus` values, with data from `PatientAllergy`. */
export type AllergicCriticalityAllergicStatusesByPatientAllergyAllergicCriticalityIdAndAllergicStatusIdManyToManyConnection = {
  __typename: 'AllergicCriticalityAllergicStatusesByPatientAllergyAllergicCriticalityIdAndAllergicStatusIdManyToManyConnection';
  /** A list of edges which contains the `AllergicStatus`, info from the `PatientAllergy`, and the cursor to aid in pagination. */
  edges: Array<AllergicCriticalityAllergicStatusesByPatientAllergyAllergicCriticalityIdAndAllergicStatusIdManyToManyEdge>;
  /** A list of `AllergicStatus` objects. */
  nodes: Array<AllergicStatus>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `AllergicStatus` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `AllergicStatus` edge in the connection, with data from `PatientAllergy`. */
export type AllergicCriticalityAllergicStatusesByPatientAllergyAllergicCriticalityIdAndAllergicStatusIdManyToManyEdge = {
  __typename: 'AllergicCriticalityAllergicStatusesByPatientAllergyAllergicCriticalityIdAndAllergicStatusIdManyToManyEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `AllergicStatus` at the end of the edge. */
  node: AllergicStatus;
  /** Reads and enables pagination through a set of `PatientAllergy`. */
  patientAllergies: PatientAllergiesConnection;
  /** Reads and enables pagination through a set of `PatientAllergy`. */
  patientAllergiesList: Array<PatientAllergy>;
};


/** A `AllergicStatus` edge in the connection, with data from `PatientAllergy`. */
export type AllergicCriticalityAllergicStatusesByPatientAllergyAllergicCriticalityIdAndAllergicStatusIdManyToManyEdgepatientAllergiesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<PatientAllergyCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PatientAllergiesOrderBy>>;
};


/** A `AllergicStatus` edge in the connection, with data from `PatientAllergy`. */
export type AllergicCriticalityAllergicStatusesByPatientAllergyAllergicCriticalityIdAndAllergicStatusIdManyToManyEdgepatientAllergiesListArgs = {
  condition?: InputMaybe<PatientAllergyCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PatientAllergiesOrderBy>>;
};

/** A connection to a list of `Allergy` values, with data from `PatientAllergy`. */
export type AllergicCriticalityAllergiesByPatientAllergyAllergicCriticalityIdAndAllergyIdManyToManyConnection = {
  __typename: 'AllergicCriticalityAllergiesByPatientAllergyAllergicCriticalityIdAndAllergyIdManyToManyConnection';
  /** A list of edges which contains the `Allergy`, info from the `PatientAllergy`, and the cursor to aid in pagination. */
  edges: Array<AllergicCriticalityAllergiesByPatientAllergyAllergicCriticalityIdAndAllergyIdManyToManyEdge>;
  /** A list of `Allergy` objects. */
  nodes: Array<Allergy>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Allergy` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Allergy` edge in the connection, with data from `PatientAllergy`. */
export type AllergicCriticalityAllergiesByPatientAllergyAllergicCriticalityIdAndAllergyIdManyToManyEdge = {
  __typename: 'AllergicCriticalityAllergiesByPatientAllergyAllergicCriticalityIdAndAllergyIdManyToManyEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `Allergy` at the end of the edge. */
  node: Allergy;
  /** Reads and enables pagination through a set of `PatientAllergy`. */
  patientAllergies: PatientAllergiesConnection;
  /** Reads and enables pagination through a set of `PatientAllergy`. */
  patientAllergiesList: Array<PatientAllergy>;
};


/** A `Allergy` edge in the connection, with data from `PatientAllergy`. */
export type AllergicCriticalityAllergiesByPatientAllergyAllergicCriticalityIdAndAllergyIdManyToManyEdgepatientAllergiesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<PatientAllergyCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PatientAllergiesOrderBy>>;
};


/** A `Allergy` edge in the connection, with data from `PatientAllergy`. */
export type AllergicCriticalityAllergiesByPatientAllergyAllergicCriticalityIdAndAllergyIdManyToManyEdgepatientAllergiesListArgs = {
  condition?: InputMaybe<PatientAllergyCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PatientAllergiesOrderBy>>;
};

/**
 * A condition to be used against `AllergicCriticality` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type AllergicCriticalityCondition = {
  /** Checks for equality with the object’s `allergicCriticalityId` field. */
  allergicCriticalityId?: InputMaybe<Scalars['Int']>;
};

/** Contains information about allergic reactions */
export type AllergicReaction = Node & {
  __typename: 'AllergicReaction';
  /** Reads and enables pagination through a set of `AllergicCriticality`. */
  allergicCriticalitiesByPatientAllergyAllergicReactionIdAndAllergicCriticalityId: AllergicReactionAllergicCriticalitiesByPatientAllergyAllergicReactionIdAndAllergicCriticalityIdManyToManyConnection;
  /** Reads and enables pagination through a set of `AllergicCriticality`. */
  allergicCriticalitiesByPatientAllergyAllergicReactionIdAndAllergicCriticalityIdList: Array<AllergicCriticality>;
  allergicReactionId: Scalars['Int'];
  /** Reads and enables pagination through a set of `AllergicSeverity`. */
  allergicSeveritiesByPatientAllergyAllergicReactionIdAndAllergicSeverityId: AllergicReactionAllergicSeveritiesByPatientAllergyAllergicReactionIdAndAllergicSeverityIdManyToManyConnection;
  /** Reads and enables pagination through a set of `AllergicSeverity`. */
  allergicSeveritiesByPatientAllergyAllergicReactionIdAndAllergicSeverityIdList: Array<AllergicSeverity>;
  /** Reads and enables pagination through a set of `AllergicStatus`. */
  allergicStatusesByPatientAllergyAllergicReactionIdAndAllergicStatusId: AllergicReactionAllergicStatusesByPatientAllergyAllergicReactionIdAndAllergicStatusIdManyToManyConnection;
  /** Reads and enables pagination through a set of `AllergicStatus`. */
  allergicStatusesByPatientAllergyAllergicReactionIdAndAllergicStatusIdList: Array<AllergicStatus>;
  /** Reads and enables pagination through a set of `Allergy`. */
  allergiesByPatientAllergyAllergicReactionIdAndAllergyId: AllergicReactionAllergiesByPatientAllergyAllergicReactionIdAndAllergyIdManyToManyConnection;
  /** Reads and enables pagination through a set of `Allergy`. */
  allergiesByPatientAllergyAllergicReactionIdAndAllergyIdList: Array<Allergy>;
  code: Scalars['String'];
  codeSystemId?: Maybe<Scalars['Int']>;
  isDeleted: Scalars['Boolean'];
  name: Scalars['String'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  /** Reads and enables pagination through a set of `PatientAllergy`. */
  patientAllergies: PatientAllergiesConnection;
  /** Reads and enables pagination through a set of `PatientAllergy`. */
  patientAllergiesList: Array<PatientAllergy>;
};


/** Contains information about allergic reactions */
export type AllergicReactionallergicCriticalitiesByPatientAllergyAllergicReactionIdAndAllergicCriticalityIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<AllergicCriticalityCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AllergicCriticalitiesOrderBy>>;
};


/** Contains information about allergic reactions */
export type AllergicReactionallergicCriticalitiesByPatientAllergyAllergicReactionIdAndAllergicCriticalityIdListArgs = {
  condition?: InputMaybe<AllergicCriticalityCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AllergicCriticalitiesOrderBy>>;
};


/** Contains information about allergic reactions */
export type AllergicReactionallergicSeveritiesByPatientAllergyAllergicReactionIdAndAllergicSeverityIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<AllergicSeverityCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AllergicSeveritiesOrderBy>>;
};


/** Contains information about allergic reactions */
export type AllergicReactionallergicSeveritiesByPatientAllergyAllergicReactionIdAndAllergicSeverityIdListArgs = {
  condition?: InputMaybe<AllergicSeverityCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AllergicSeveritiesOrderBy>>;
};


/** Contains information about allergic reactions */
export type AllergicReactionallergicStatusesByPatientAllergyAllergicReactionIdAndAllergicStatusIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<AllergicStatusCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AllergicStatusesOrderBy>>;
};


/** Contains information about allergic reactions */
export type AllergicReactionallergicStatusesByPatientAllergyAllergicReactionIdAndAllergicStatusIdListArgs = {
  condition?: InputMaybe<AllergicStatusCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AllergicStatusesOrderBy>>;
};


/** Contains information about allergic reactions */
export type AllergicReactionallergiesByPatientAllergyAllergicReactionIdAndAllergyIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<AllergyCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AllergiesOrderBy>>;
};


/** Contains information about allergic reactions */
export type AllergicReactionallergiesByPatientAllergyAllergicReactionIdAndAllergyIdListArgs = {
  condition?: InputMaybe<AllergyCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AllergiesOrderBy>>;
};


/** Contains information about allergic reactions */
export type AllergicReactionpatientAllergiesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<PatientAllergyCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PatientAllergiesOrderBy>>;
};


/** Contains information about allergic reactions */
export type AllergicReactionpatientAllergiesListArgs = {
  condition?: InputMaybe<PatientAllergyCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PatientAllergiesOrderBy>>;
};

/** A connection to a list of `AllergicCriticality` values, with data from `PatientAllergy`. */
export type AllergicReactionAllergicCriticalitiesByPatientAllergyAllergicReactionIdAndAllergicCriticalityIdManyToManyConnection = {
  __typename: 'AllergicReactionAllergicCriticalitiesByPatientAllergyAllergicReactionIdAndAllergicCriticalityIdManyToManyConnection';
  /** A list of edges which contains the `AllergicCriticality`, info from the `PatientAllergy`, and the cursor to aid in pagination. */
  edges: Array<AllergicReactionAllergicCriticalitiesByPatientAllergyAllergicReactionIdAndAllergicCriticalityIdManyToManyEdge>;
  /** A list of `AllergicCriticality` objects. */
  nodes: Array<AllergicCriticality>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `AllergicCriticality` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `AllergicCriticality` edge in the connection, with data from `PatientAllergy`. */
export type AllergicReactionAllergicCriticalitiesByPatientAllergyAllergicReactionIdAndAllergicCriticalityIdManyToManyEdge = {
  __typename: 'AllergicReactionAllergicCriticalitiesByPatientAllergyAllergicReactionIdAndAllergicCriticalityIdManyToManyEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `AllergicCriticality` at the end of the edge. */
  node: AllergicCriticality;
  /** Reads and enables pagination through a set of `PatientAllergy`. */
  patientAllergies: PatientAllergiesConnection;
  /** Reads and enables pagination through a set of `PatientAllergy`. */
  patientAllergiesList: Array<PatientAllergy>;
};


/** A `AllergicCriticality` edge in the connection, with data from `PatientAllergy`. */
export type AllergicReactionAllergicCriticalitiesByPatientAllergyAllergicReactionIdAndAllergicCriticalityIdManyToManyEdgepatientAllergiesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<PatientAllergyCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PatientAllergiesOrderBy>>;
};


/** A `AllergicCriticality` edge in the connection, with data from `PatientAllergy`. */
export type AllergicReactionAllergicCriticalitiesByPatientAllergyAllergicReactionIdAndAllergicCriticalityIdManyToManyEdgepatientAllergiesListArgs = {
  condition?: InputMaybe<PatientAllergyCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PatientAllergiesOrderBy>>;
};

/** A connection to a list of `AllergicSeverity` values, with data from `PatientAllergy`. */
export type AllergicReactionAllergicSeveritiesByPatientAllergyAllergicReactionIdAndAllergicSeverityIdManyToManyConnection = {
  __typename: 'AllergicReactionAllergicSeveritiesByPatientAllergyAllergicReactionIdAndAllergicSeverityIdManyToManyConnection';
  /** A list of edges which contains the `AllergicSeverity`, info from the `PatientAllergy`, and the cursor to aid in pagination. */
  edges: Array<AllergicReactionAllergicSeveritiesByPatientAllergyAllergicReactionIdAndAllergicSeverityIdManyToManyEdge>;
  /** A list of `AllergicSeverity` objects. */
  nodes: Array<AllergicSeverity>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `AllergicSeverity` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `AllergicSeverity` edge in the connection, with data from `PatientAllergy`. */
export type AllergicReactionAllergicSeveritiesByPatientAllergyAllergicReactionIdAndAllergicSeverityIdManyToManyEdge = {
  __typename: 'AllergicReactionAllergicSeveritiesByPatientAllergyAllergicReactionIdAndAllergicSeverityIdManyToManyEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `AllergicSeverity` at the end of the edge. */
  node: AllergicSeverity;
  /** Reads and enables pagination through a set of `PatientAllergy`. */
  patientAllergies: PatientAllergiesConnection;
  /** Reads and enables pagination through a set of `PatientAllergy`. */
  patientAllergiesList: Array<PatientAllergy>;
};


/** A `AllergicSeverity` edge in the connection, with data from `PatientAllergy`. */
export type AllergicReactionAllergicSeveritiesByPatientAllergyAllergicReactionIdAndAllergicSeverityIdManyToManyEdgepatientAllergiesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<PatientAllergyCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PatientAllergiesOrderBy>>;
};


/** A `AllergicSeverity` edge in the connection, with data from `PatientAllergy`. */
export type AllergicReactionAllergicSeveritiesByPatientAllergyAllergicReactionIdAndAllergicSeverityIdManyToManyEdgepatientAllergiesListArgs = {
  condition?: InputMaybe<PatientAllergyCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PatientAllergiesOrderBy>>;
};

/** A connection to a list of `AllergicStatus` values, with data from `PatientAllergy`. */
export type AllergicReactionAllergicStatusesByPatientAllergyAllergicReactionIdAndAllergicStatusIdManyToManyConnection = {
  __typename: 'AllergicReactionAllergicStatusesByPatientAllergyAllergicReactionIdAndAllergicStatusIdManyToManyConnection';
  /** A list of edges which contains the `AllergicStatus`, info from the `PatientAllergy`, and the cursor to aid in pagination. */
  edges: Array<AllergicReactionAllergicStatusesByPatientAllergyAllergicReactionIdAndAllergicStatusIdManyToManyEdge>;
  /** A list of `AllergicStatus` objects. */
  nodes: Array<AllergicStatus>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `AllergicStatus` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `AllergicStatus` edge in the connection, with data from `PatientAllergy`. */
export type AllergicReactionAllergicStatusesByPatientAllergyAllergicReactionIdAndAllergicStatusIdManyToManyEdge = {
  __typename: 'AllergicReactionAllergicStatusesByPatientAllergyAllergicReactionIdAndAllergicStatusIdManyToManyEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `AllergicStatus` at the end of the edge. */
  node: AllergicStatus;
  /** Reads and enables pagination through a set of `PatientAllergy`. */
  patientAllergies: PatientAllergiesConnection;
  /** Reads and enables pagination through a set of `PatientAllergy`. */
  patientAllergiesList: Array<PatientAllergy>;
};


/** A `AllergicStatus` edge in the connection, with data from `PatientAllergy`. */
export type AllergicReactionAllergicStatusesByPatientAllergyAllergicReactionIdAndAllergicStatusIdManyToManyEdgepatientAllergiesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<PatientAllergyCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PatientAllergiesOrderBy>>;
};


/** A `AllergicStatus` edge in the connection, with data from `PatientAllergy`. */
export type AllergicReactionAllergicStatusesByPatientAllergyAllergicReactionIdAndAllergicStatusIdManyToManyEdgepatientAllergiesListArgs = {
  condition?: InputMaybe<PatientAllergyCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PatientAllergiesOrderBy>>;
};

/** A connection to a list of `Allergy` values, with data from `PatientAllergy`. */
export type AllergicReactionAllergiesByPatientAllergyAllergicReactionIdAndAllergyIdManyToManyConnection = {
  __typename: 'AllergicReactionAllergiesByPatientAllergyAllergicReactionIdAndAllergyIdManyToManyConnection';
  /** A list of edges which contains the `Allergy`, info from the `PatientAllergy`, and the cursor to aid in pagination. */
  edges: Array<AllergicReactionAllergiesByPatientAllergyAllergicReactionIdAndAllergyIdManyToManyEdge>;
  /** A list of `Allergy` objects. */
  nodes: Array<Allergy>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Allergy` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Allergy` edge in the connection, with data from `PatientAllergy`. */
export type AllergicReactionAllergiesByPatientAllergyAllergicReactionIdAndAllergyIdManyToManyEdge = {
  __typename: 'AllergicReactionAllergiesByPatientAllergyAllergicReactionIdAndAllergyIdManyToManyEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `Allergy` at the end of the edge. */
  node: Allergy;
  /** Reads and enables pagination through a set of `PatientAllergy`. */
  patientAllergies: PatientAllergiesConnection;
  /** Reads and enables pagination through a set of `PatientAllergy`. */
  patientAllergiesList: Array<PatientAllergy>;
};


/** A `Allergy` edge in the connection, with data from `PatientAllergy`. */
export type AllergicReactionAllergiesByPatientAllergyAllergicReactionIdAndAllergyIdManyToManyEdgepatientAllergiesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<PatientAllergyCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PatientAllergiesOrderBy>>;
};


/** A `Allergy` edge in the connection, with data from `PatientAllergy`. */
export type AllergicReactionAllergiesByPatientAllergyAllergicReactionIdAndAllergyIdManyToManyEdgepatientAllergiesListArgs = {
  condition?: InputMaybe<PatientAllergyCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PatientAllergiesOrderBy>>;
};

/**
 * A condition to be used against `AllergicReaction` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type AllergicReactionCondition = {
  /** Checks for equality with the object’s `allergicReactionId` field. */
  allergicReactionId?: InputMaybe<Scalars['Int']>;
};

/** A connection to a list of `AllergicReaction` values. */
export type AllergicReactionsConnection = {
  __typename: 'AllergicReactionsConnection';
  /** A list of edges which contains the `AllergicReaction` and cursor to aid in pagination. */
  edges: Array<AllergicReactionsEdge>;
  /** A list of `AllergicReaction` objects. */
  nodes: Array<AllergicReaction>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `AllergicReaction` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `AllergicReaction` edge in the connection. */
export type AllergicReactionsEdge = {
  __typename: 'AllergicReactionsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `AllergicReaction` at the end of the edge. */
  node: AllergicReaction;
};

/** Methods to use when ordering `AllergicReaction`. */
export enum AllergicReactionsOrderBy {
  ALLERGIC_REACTION_ID_ASC = 'ALLERGIC_REACTION_ID_ASC',
  ALLERGIC_REACTION_ID_DESC = 'ALLERGIC_REACTION_ID_DESC',
  NATURAL = 'NATURAL',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC'
}

/** A connection to a list of `AllergicSeverity` values. */
export type AllergicSeveritiesConnection = {
  __typename: 'AllergicSeveritiesConnection';
  /** A list of edges which contains the `AllergicSeverity` and cursor to aid in pagination. */
  edges: Array<AllergicSeveritiesEdge>;
  /** A list of `AllergicSeverity` objects. */
  nodes: Array<AllergicSeverity>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `AllergicSeverity` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `AllergicSeverity` edge in the connection. */
export type AllergicSeveritiesEdge = {
  __typename: 'AllergicSeveritiesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `AllergicSeverity` at the end of the edge. */
  node: AllergicSeverity;
};

/** Methods to use when ordering `AllergicSeverity`. */
export enum AllergicSeveritiesOrderBy {
  ALLERGIC_SEVERITY_ID_ASC = 'ALLERGIC_SEVERITY_ID_ASC',
  ALLERGIC_SEVERITY_ID_DESC = 'ALLERGIC_SEVERITY_ID_DESC',
  NATURAL = 'NATURAL',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC'
}

/** Contains information about allergic severity */
export type AllergicSeverity = Node & {
  __typename: 'AllergicSeverity';
  /** Reads and enables pagination through a set of `AllergicCriticality`. */
  allergicCriticalitiesByPatientAllergyAllergicSeverityIdAndAllergicCriticalityId: AllergicSeverityAllergicCriticalitiesByPatientAllergyAllergicSeverityIdAndAllergicCriticalityIdManyToManyConnection;
  /** Reads and enables pagination through a set of `AllergicCriticality`. */
  allergicCriticalitiesByPatientAllergyAllergicSeverityIdAndAllergicCriticalityIdList: Array<AllergicCriticality>;
  /** Reads and enables pagination through a set of `AllergicReaction`. */
  allergicReactionsByPatientAllergyAllergicSeverityIdAndAllergicReactionId: AllergicSeverityAllergicReactionsByPatientAllergyAllergicSeverityIdAndAllergicReactionIdManyToManyConnection;
  /** Reads and enables pagination through a set of `AllergicReaction`. */
  allergicReactionsByPatientAllergyAllergicSeverityIdAndAllergicReactionIdList: Array<AllergicReaction>;
  allergicSeverityId: Scalars['Int'];
  /** Reads and enables pagination through a set of `AllergicStatus`. */
  allergicStatusesByPatientAllergyAllergicSeverityIdAndAllergicStatusId: AllergicSeverityAllergicStatusesByPatientAllergyAllergicSeverityIdAndAllergicStatusIdManyToManyConnection;
  /** Reads and enables pagination through a set of `AllergicStatus`. */
  allergicStatusesByPatientAllergyAllergicSeverityIdAndAllergicStatusIdList: Array<AllergicStatus>;
  /** Reads and enables pagination through a set of `Allergy`. */
  allergiesByPatientAllergyAllergicSeverityIdAndAllergyId: AllergicSeverityAllergiesByPatientAllergyAllergicSeverityIdAndAllergyIdManyToManyConnection;
  /** Reads and enables pagination through a set of `Allergy`. */
  allergiesByPatientAllergyAllergicSeverityIdAndAllergyIdList: Array<Allergy>;
  code: Scalars['String'];
  codeSystemId?: Maybe<Scalars['Int']>;
  isDeleted: Scalars['Boolean'];
  name: Scalars['String'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  /** Reads and enables pagination through a set of `PatientAllergy`. */
  patientAllergies: PatientAllergiesConnection;
  /** Reads and enables pagination through a set of `PatientAllergy`. */
  patientAllergiesList: Array<PatientAllergy>;
};


/** Contains information about allergic severity */
export type AllergicSeverityallergicCriticalitiesByPatientAllergyAllergicSeverityIdAndAllergicCriticalityIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<AllergicCriticalityCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AllergicCriticalitiesOrderBy>>;
};


/** Contains information about allergic severity */
export type AllergicSeverityallergicCriticalitiesByPatientAllergyAllergicSeverityIdAndAllergicCriticalityIdListArgs = {
  condition?: InputMaybe<AllergicCriticalityCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AllergicCriticalitiesOrderBy>>;
};


/** Contains information about allergic severity */
export type AllergicSeverityallergicReactionsByPatientAllergyAllergicSeverityIdAndAllergicReactionIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<AllergicReactionCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AllergicReactionsOrderBy>>;
};


/** Contains information about allergic severity */
export type AllergicSeverityallergicReactionsByPatientAllergyAllergicSeverityIdAndAllergicReactionIdListArgs = {
  condition?: InputMaybe<AllergicReactionCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AllergicReactionsOrderBy>>;
};


/** Contains information about allergic severity */
export type AllergicSeverityallergicStatusesByPatientAllergyAllergicSeverityIdAndAllergicStatusIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<AllergicStatusCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AllergicStatusesOrderBy>>;
};


/** Contains information about allergic severity */
export type AllergicSeverityallergicStatusesByPatientAllergyAllergicSeverityIdAndAllergicStatusIdListArgs = {
  condition?: InputMaybe<AllergicStatusCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AllergicStatusesOrderBy>>;
};


/** Contains information about allergic severity */
export type AllergicSeverityallergiesByPatientAllergyAllergicSeverityIdAndAllergyIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<AllergyCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AllergiesOrderBy>>;
};


/** Contains information about allergic severity */
export type AllergicSeverityallergiesByPatientAllergyAllergicSeverityIdAndAllergyIdListArgs = {
  condition?: InputMaybe<AllergyCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AllergiesOrderBy>>;
};


/** Contains information about allergic severity */
export type AllergicSeveritypatientAllergiesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<PatientAllergyCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PatientAllergiesOrderBy>>;
};


/** Contains information about allergic severity */
export type AllergicSeveritypatientAllergiesListArgs = {
  condition?: InputMaybe<PatientAllergyCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PatientAllergiesOrderBy>>;
};

/** A connection to a list of `AllergicCriticality` values, with data from `PatientAllergy`. */
export type AllergicSeverityAllergicCriticalitiesByPatientAllergyAllergicSeverityIdAndAllergicCriticalityIdManyToManyConnection = {
  __typename: 'AllergicSeverityAllergicCriticalitiesByPatientAllergyAllergicSeverityIdAndAllergicCriticalityIdManyToManyConnection';
  /** A list of edges which contains the `AllergicCriticality`, info from the `PatientAllergy`, and the cursor to aid in pagination. */
  edges: Array<AllergicSeverityAllergicCriticalitiesByPatientAllergyAllergicSeverityIdAndAllergicCriticalityIdManyToManyEdge>;
  /** A list of `AllergicCriticality` objects. */
  nodes: Array<AllergicCriticality>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `AllergicCriticality` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `AllergicCriticality` edge in the connection, with data from `PatientAllergy`. */
export type AllergicSeverityAllergicCriticalitiesByPatientAllergyAllergicSeverityIdAndAllergicCriticalityIdManyToManyEdge = {
  __typename: 'AllergicSeverityAllergicCriticalitiesByPatientAllergyAllergicSeverityIdAndAllergicCriticalityIdManyToManyEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `AllergicCriticality` at the end of the edge. */
  node: AllergicCriticality;
  /** Reads and enables pagination through a set of `PatientAllergy`. */
  patientAllergies: PatientAllergiesConnection;
  /** Reads and enables pagination through a set of `PatientAllergy`. */
  patientAllergiesList: Array<PatientAllergy>;
};


/** A `AllergicCriticality` edge in the connection, with data from `PatientAllergy`. */
export type AllergicSeverityAllergicCriticalitiesByPatientAllergyAllergicSeverityIdAndAllergicCriticalityIdManyToManyEdgepatientAllergiesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<PatientAllergyCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PatientAllergiesOrderBy>>;
};


/** A `AllergicCriticality` edge in the connection, with data from `PatientAllergy`. */
export type AllergicSeverityAllergicCriticalitiesByPatientAllergyAllergicSeverityIdAndAllergicCriticalityIdManyToManyEdgepatientAllergiesListArgs = {
  condition?: InputMaybe<PatientAllergyCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PatientAllergiesOrderBy>>;
};

/** A connection to a list of `AllergicReaction` values, with data from `PatientAllergy`. */
export type AllergicSeverityAllergicReactionsByPatientAllergyAllergicSeverityIdAndAllergicReactionIdManyToManyConnection = {
  __typename: 'AllergicSeverityAllergicReactionsByPatientAllergyAllergicSeverityIdAndAllergicReactionIdManyToManyConnection';
  /** A list of edges which contains the `AllergicReaction`, info from the `PatientAllergy`, and the cursor to aid in pagination. */
  edges: Array<AllergicSeverityAllergicReactionsByPatientAllergyAllergicSeverityIdAndAllergicReactionIdManyToManyEdge>;
  /** A list of `AllergicReaction` objects. */
  nodes: Array<AllergicReaction>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `AllergicReaction` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `AllergicReaction` edge in the connection, with data from `PatientAllergy`. */
export type AllergicSeverityAllergicReactionsByPatientAllergyAllergicSeverityIdAndAllergicReactionIdManyToManyEdge = {
  __typename: 'AllergicSeverityAllergicReactionsByPatientAllergyAllergicSeverityIdAndAllergicReactionIdManyToManyEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `AllergicReaction` at the end of the edge. */
  node: AllergicReaction;
  /** Reads and enables pagination through a set of `PatientAllergy`. */
  patientAllergies: PatientAllergiesConnection;
  /** Reads and enables pagination through a set of `PatientAllergy`. */
  patientAllergiesList: Array<PatientAllergy>;
};


/** A `AllergicReaction` edge in the connection, with data from `PatientAllergy`. */
export type AllergicSeverityAllergicReactionsByPatientAllergyAllergicSeverityIdAndAllergicReactionIdManyToManyEdgepatientAllergiesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<PatientAllergyCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PatientAllergiesOrderBy>>;
};


/** A `AllergicReaction` edge in the connection, with data from `PatientAllergy`. */
export type AllergicSeverityAllergicReactionsByPatientAllergyAllergicSeverityIdAndAllergicReactionIdManyToManyEdgepatientAllergiesListArgs = {
  condition?: InputMaybe<PatientAllergyCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PatientAllergiesOrderBy>>;
};

/** A connection to a list of `AllergicStatus` values, with data from `PatientAllergy`. */
export type AllergicSeverityAllergicStatusesByPatientAllergyAllergicSeverityIdAndAllergicStatusIdManyToManyConnection = {
  __typename: 'AllergicSeverityAllergicStatusesByPatientAllergyAllergicSeverityIdAndAllergicStatusIdManyToManyConnection';
  /** A list of edges which contains the `AllergicStatus`, info from the `PatientAllergy`, and the cursor to aid in pagination. */
  edges: Array<AllergicSeverityAllergicStatusesByPatientAllergyAllergicSeverityIdAndAllergicStatusIdManyToManyEdge>;
  /** A list of `AllergicStatus` objects. */
  nodes: Array<AllergicStatus>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `AllergicStatus` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `AllergicStatus` edge in the connection, with data from `PatientAllergy`. */
export type AllergicSeverityAllergicStatusesByPatientAllergyAllergicSeverityIdAndAllergicStatusIdManyToManyEdge = {
  __typename: 'AllergicSeverityAllergicStatusesByPatientAllergyAllergicSeverityIdAndAllergicStatusIdManyToManyEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `AllergicStatus` at the end of the edge. */
  node: AllergicStatus;
  /** Reads and enables pagination through a set of `PatientAllergy`. */
  patientAllergies: PatientAllergiesConnection;
  /** Reads and enables pagination through a set of `PatientAllergy`. */
  patientAllergiesList: Array<PatientAllergy>;
};


/** A `AllergicStatus` edge in the connection, with data from `PatientAllergy`. */
export type AllergicSeverityAllergicStatusesByPatientAllergyAllergicSeverityIdAndAllergicStatusIdManyToManyEdgepatientAllergiesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<PatientAllergyCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PatientAllergiesOrderBy>>;
};


/** A `AllergicStatus` edge in the connection, with data from `PatientAllergy`. */
export type AllergicSeverityAllergicStatusesByPatientAllergyAllergicSeverityIdAndAllergicStatusIdManyToManyEdgepatientAllergiesListArgs = {
  condition?: InputMaybe<PatientAllergyCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PatientAllergiesOrderBy>>;
};

/** A connection to a list of `Allergy` values, with data from `PatientAllergy`. */
export type AllergicSeverityAllergiesByPatientAllergyAllergicSeverityIdAndAllergyIdManyToManyConnection = {
  __typename: 'AllergicSeverityAllergiesByPatientAllergyAllergicSeverityIdAndAllergyIdManyToManyConnection';
  /** A list of edges which contains the `Allergy`, info from the `PatientAllergy`, and the cursor to aid in pagination. */
  edges: Array<AllergicSeverityAllergiesByPatientAllergyAllergicSeverityIdAndAllergyIdManyToManyEdge>;
  /** A list of `Allergy` objects. */
  nodes: Array<Allergy>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Allergy` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Allergy` edge in the connection, with data from `PatientAllergy`. */
export type AllergicSeverityAllergiesByPatientAllergyAllergicSeverityIdAndAllergyIdManyToManyEdge = {
  __typename: 'AllergicSeverityAllergiesByPatientAllergyAllergicSeverityIdAndAllergyIdManyToManyEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `Allergy` at the end of the edge. */
  node: Allergy;
  /** Reads and enables pagination through a set of `PatientAllergy`. */
  patientAllergies: PatientAllergiesConnection;
  /** Reads and enables pagination through a set of `PatientAllergy`. */
  patientAllergiesList: Array<PatientAllergy>;
};


/** A `Allergy` edge in the connection, with data from `PatientAllergy`. */
export type AllergicSeverityAllergiesByPatientAllergyAllergicSeverityIdAndAllergyIdManyToManyEdgepatientAllergiesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<PatientAllergyCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PatientAllergiesOrderBy>>;
};


/** A `Allergy` edge in the connection, with data from `PatientAllergy`. */
export type AllergicSeverityAllergiesByPatientAllergyAllergicSeverityIdAndAllergyIdManyToManyEdgepatientAllergiesListArgs = {
  condition?: InputMaybe<PatientAllergyCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PatientAllergiesOrderBy>>;
};

/**
 * A condition to be used against `AllergicSeverity` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type AllergicSeverityCondition = {
  /** Checks for equality with the object’s `allergicSeverityId` field. */
  allergicSeverityId?: InputMaybe<Scalars['Int']>;
};

/** Contains information about allergic statuses */
export type AllergicStatus = Node & {
  __typename: 'AllergicStatus';
  /** Reads and enables pagination through a set of `AllergicCriticality`. */
  allergicCriticalitiesByPatientAllergyAllergicStatusIdAndAllergicCriticalityId: AllergicStatusAllergicCriticalitiesByPatientAllergyAllergicStatusIdAndAllergicCriticalityIdManyToManyConnection;
  /** Reads and enables pagination through a set of `AllergicCriticality`. */
  allergicCriticalitiesByPatientAllergyAllergicStatusIdAndAllergicCriticalityIdList: Array<AllergicCriticality>;
  /** Reads and enables pagination through a set of `AllergicReaction`. */
  allergicReactionsByPatientAllergyAllergicStatusIdAndAllergicReactionId: AllergicStatusAllergicReactionsByPatientAllergyAllergicStatusIdAndAllergicReactionIdManyToManyConnection;
  /** Reads and enables pagination through a set of `AllergicReaction`. */
  allergicReactionsByPatientAllergyAllergicStatusIdAndAllergicReactionIdList: Array<AllergicReaction>;
  /** Reads and enables pagination through a set of `AllergicSeverity`. */
  allergicSeveritiesByPatientAllergyAllergicStatusIdAndAllergicSeverityId: AllergicStatusAllergicSeveritiesByPatientAllergyAllergicStatusIdAndAllergicSeverityIdManyToManyConnection;
  /** Reads and enables pagination through a set of `AllergicSeverity`. */
  allergicSeveritiesByPatientAllergyAllergicStatusIdAndAllergicSeverityIdList: Array<AllergicSeverity>;
  allergicStatusId: Scalars['Int'];
  /** Reads and enables pagination through a set of `Allergy`. */
  allergiesByPatientAllergyAllergicStatusIdAndAllergyId: AllergicStatusAllergiesByPatientAllergyAllergicStatusIdAndAllergyIdManyToManyConnection;
  /** Reads and enables pagination through a set of `Allergy`. */
  allergiesByPatientAllergyAllergicStatusIdAndAllergyIdList: Array<Allergy>;
  code: Scalars['String'];
  codeSystemId?: Maybe<Scalars['Int']>;
  isDeleted: Scalars['Boolean'];
  name: Scalars['String'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  /** Reads and enables pagination through a set of `PatientAllergy`. */
  patientAllergies: PatientAllergiesConnection;
  /** Reads and enables pagination through a set of `PatientAllergy`. */
  patientAllergiesList: Array<PatientAllergy>;
};


/** Contains information about allergic statuses */
export type AllergicStatusallergicCriticalitiesByPatientAllergyAllergicStatusIdAndAllergicCriticalityIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<AllergicCriticalityCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AllergicCriticalitiesOrderBy>>;
};


/** Contains information about allergic statuses */
export type AllergicStatusallergicCriticalitiesByPatientAllergyAllergicStatusIdAndAllergicCriticalityIdListArgs = {
  condition?: InputMaybe<AllergicCriticalityCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AllergicCriticalitiesOrderBy>>;
};


/** Contains information about allergic statuses */
export type AllergicStatusallergicReactionsByPatientAllergyAllergicStatusIdAndAllergicReactionIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<AllergicReactionCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AllergicReactionsOrderBy>>;
};


/** Contains information about allergic statuses */
export type AllergicStatusallergicReactionsByPatientAllergyAllergicStatusIdAndAllergicReactionIdListArgs = {
  condition?: InputMaybe<AllergicReactionCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AllergicReactionsOrderBy>>;
};


/** Contains information about allergic statuses */
export type AllergicStatusallergicSeveritiesByPatientAllergyAllergicStatusIdAndAllergicSeverityIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<AllergicSeverityCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AllergicSeveritiesOrderBy>>;
};


/** Contains information about allergic statuses */
export type AllergicStatusallergicSeveritiesByPatientAllergyAllergicStatusIdAndAllergicSeverityIdListArgs = {
  condition?: InputMaybe<AllergicSeverityCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AllergicSeveritiesOrderBy>>;
};


/** Contains information about allergic statuses */
export type AllergicStatusallergiesByPatientAllergyAllergicStatusIdAndAllergyIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<AllergyCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AllergiesOrderBy>>;
};


/** Contains information about allergic statuses */
export type AllergicStatusallergiesByPatientAllergyAllergicStatusIdAndAllergyIdListArgs = {
  condition?: InputMaybe<AllergyCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AllergiesOrderBy>>;
};


/** Contains information about allergic statuses */
export type AllergicStatuspatientAllergiesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<PatientAllergyCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PatientAllergiesOrderBy>>;
};


/** Contains information about allergic statuses */
export type AllergicStatuspatientAllergiesListArgs = {
  condition?: InputMaybe<PatientAllergyCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PatientAllergiesOrderBy>>;
};

/** A connection to a list of `AllergicCriticality` values, with data from `PatientAllergy`. */
export type AllergicStatusAllergicCriticalitiesByPatientAllergyAllergicStatusIdAndAllergicCriticalityIdManyToManyConnection = {
  __typename: 'AllergicStatusAllergicCriticalitiesByPatientAllergyAllergicStatusIdAndAllergicCriticalityIdManyToManyConnection';
  /** A list of edges which contains the `AllergicCriticality`, info from the `PatientAllergy`, and the cursor to aid in pagination. */
  edges: Array<AllergicStatusAllergicCriticalitiesByPatientAllergyAllergicStatusIdAndAllergicCriticalityIdManyToManyEdge>;
  /** A list of `AllergicCriticality` objects. */
  nodes: Array<AllergicCriticality>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `AllergicCriticality` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `AllergicCriticality` edge in the connection, with data from `PatientAllergy`. */
export type AllergicStatusAllergicCriticalitiesByPatientAllergyAllergicStatusIdAndAllergicCriticalityIdManyToManyEdge = {
  __typename: 'AllergicStatusAllergicCriticalitiesByPatientAllergyAllergicStatusIdAndAllergicCriticalityIdManyToManyEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `AllergicCriticality` at the end of the edge. */
  node: AllergicCriticality;
  /** Reads and enables pagination through a set of `PatientAllergy`. */
  patientAllergies: PatientAllergiesConnection;
  /** Reads and enables pagination through a set of `PatientAllergy`. */
  patientAllergiesList: Array<PatientAllergy>;
};


/** A `AllergicCriticality` edge in the connection, with data from `PatientAllergy`. */
export type AllergicStatusAllergicCriticalitiesByPatientAllergyAllergicStatusIdAndAllergicCriticalityIdManyToManyEdgepatientAllergiesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<PatientAllergyCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PatientAllergiesOrderBy>>;
};


/** A `AllergicCriticality` edge in the connection, with data from `PatientAllergy`. */
export type AllergicStatusAllergicCriticalitiesByPatientAllergyAllergicStatusIdAndAllergicCriticalityIdManyToManyEdgepatientAllergiesListArgs = {
  condition?: InputMaybe<PatientAllergyCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PatientAllergiesOrderBy>>;
};

/** A connection to a list of `AllergicReaction` values, with data from `PatientAllergy`. */
export type AllergicStatusAllergicReactionsByPatientAllergyAllergicStatusIdAndAllergicReactionIdManyToManyConnection = {
  __typename: 'AllergicStatusAllergicReactionsByPatientAllergyAllergicStatusIdAndAllergicReactionIdManyToManyConnection';
  /** A list of edges which contains the `AllergicReaction`, info from the `PatientAllergy`, and the cursor to aid in pagination. */
  edges: Array<AllergicStatusAllergicReactionsByPatientAllergyAllergicStatusIdAndAllergicReactionIdManyToManyEdge>;
  /** A list of `AllergicReaction` objects. */
  nodes: Array<AllergicReaction>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `AllergicReaction` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `AllergicReaction` edge in the connection, with data from `PatientAllergy`. */
export type AllergicStatusAllergicReactionsByPatientAllergyAllergicStatusIdAndAllergicReactionIdManyToManyEdge = {
  __typename: 'AllergicStatusAllergicReactionsByPatientAllergyAllergicStatusIdAndAllergicReactionIdManyToManyEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `AllergicReaction` at the end of the edge. */
  node: AllergicReaction;
  /** Reads and enables pagination through a set of `PatientAllergy`. */
  patientAllergies: PatientAllergiesConnection;
  /** Reads and enables pagination through a set of `PatientAllergy`. */
  patientAllergiesList: Array<PatientAllergy>;
};


/** A `AllergicReaction` edge in the connection, with data from `PatientAllergy`. */
export type AllergicStatusAllergicReactionsByPatientAllergyAllergicStatusIdAndAllergicReactionIdManyToManyEdgepatientAllergiesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<PatientAllergyCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PatientAllergiesOrderBy>>;
};


/** A `AllergicReaction` edge in the connection, with data from `PatientAllergy`. */
export type AllergicStatusAllergicReactionsByPatientAllergyAllergicStatusIdAndAllergicReactionIdManyToManyEdgepatientAllergiesListArgs = {
  condition?: InputMaybe<PatientAllergyCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PatientAllergiesOrderBy>>;
};

/** A connection to a list of `AllergicSeverity` values, with data from `PatientAllergy`. */
export type AllergicStatusAllergicSeveritiesByPatientAllergyAllergicStatusIdAndAllergicSeverityIdManyToManyConnection = {
  __typename: 'AllergicStatusAllergicSeveritiesByPatientAllergyAllergicStatusIdAndAllergicSeverityIdManyToManyConnection';
  /** A list of edges which contains the `AllergicSeverity`, info from the `PatientAllergy`, and the cursor to aid in pagination. */
  edges: Array<AllergicStatusAllergicSeveritiesByPatientAllergyAllergicStatusIdAndAllergicSeverityIdManyToManyEdge>;
  /** A list of `AllergicSeverity` objects. */
  nodes: Array<AllergicSeverity>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `AllergicSeverity` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `AllergicSeverity` edge in the connection, with data from `PatientAllergy`. */
export type AllergicStatusAllergicSeveritiesByPatientAllergyAllergicStatusIdAndAllergicSeverityIdManyToManyEdge = {
  __typename: 'AllergicStatusAllergicSeveritiesByPatientAllergyAllergicStatusIdAndAllergicSeverityIdManyToManyEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `AllergicSeverity` at the end of the edge. */
  node: AllergicSeverity;
  /** Reads and enables pagination through a set of `PatientAllergy`. */
  patientAllergies: PatientAllergiesConnection;
  /** Reads and enables pagination through a set of `PatientAllergy`. */
  patientAllergiesList: Array<PatientAllergy>;
};


/** A `AllergicSeverity` edge in the connection, with data from `PatientAllergy`. */
export type AllergicStatusAllergicSeveritiesByPatientAllergyAllergicStatusIdAndAllergicSeverityIdManyToManyEdgepatientAllergiesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<PatientAllergyCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PatientAllergiesOrderBy>>;
};


/** A `AllergicSeverity` edge in the connection, with data from `PatientAllergy`. */
export type AllergicStatusAllergicSeveritiesByPatientAllergyAllergicStatusIdAndAllergicSeverityIdManyToManyEdgepatientAllergiesListArgs = {
  condition?: InputMaybe<PatientAllergyCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PatientAllergiesOrderBy>>;
};

/** A connection to a list of `Allergy` values, with data from `PatientAllergy`. */
export type AllergicStatusAllergiesByPatientAllergyAllergicStatusIdAndAllergyIdManyToManyConnection = {
  __typename: 'AllergicStatusAllergiesByPatientAllergyAllergicStatusIdAndAllergyIdManyToManyConnection';
  /** A list of edges which contains the `Allergy`, info from the `PatientAllergy`, and the cursor to aid in pagination. */
  edges: Array<AllergicStatusAllergiesByPatientAllergyAllergicStatusIdAndAllergyIdManyToManyEdge>;
  /** A list of `Allergy` objects. */
  nodes: Array<Allergy>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Allergy` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Allergy` edge in the connection, with data from `PatientAllergy`. */
export type AllergicStatusAllergiesByPatientAllergyAllergicStatusIdAndAllergyIdManyToManyEdge = {
  __typename: 'AllergicStatusAllergiesByPatientAllergyAllergicStatusIdAndAllergyIdManyToManyEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `Allergy` at the end of the edge. */
  node: Allergy;
  /** Reads and enables pagination through a set of `PatientAllergy`. */
  patientAllergies: PatientAllergiesConnection;
  /** Reads and enables pagination through a set of `PatientAllergy`. */
  patientAllergiesList: Array<PatientAllergy>;
};


/** A `Allergy` edge in the connection, with data from `PatientAllergy`. */
export type AllergicStatusAllergiesByPatientAllergyAllergicStatusIdAndAllergyIdManyToManyEdgepatientAllergiesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<PatientAllergyCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PatientAllergiesOrderBy>>;
};


/** A `Allergy` edge in the connection, with data from `PatientAllergy`. */
export type AllergicStatusAllergiesByPatientAllergyAllergicStatusIdAndAllergyIdManyToManyEdgepatientAllergiesListArgs = {
  condition?: InputMaybe<PatientAllergyCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PatientAllergiesOrderBy>>;
};

/**
 * A condition to be used against `AllergicStatus` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type AllergicStatusCondition = {
  /** Checks for equality with the object’s `allergicStatusId` field. */
  allergicStatusId?: InputMaybe<Scalars['Int']>;
};

/** A connection to a list of `AllergicStatus` values. */
export type AllergicStatusesConnection = {
  __typename: 'AllergicStatusesConnection';
  /** A list of edges which contains the `AllergicStatus` and cursor to aid in pagination. */
  edges: Array<AllergicStatusesEdge>;
  /** A list of `AllergicStatus` objects. */
  nodes: Array<AllergicStatus>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `AllergicStatus` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `AllergicStatus` edge in the connection. */
export type AllergicStatusesEdge = {
  __typename: 'AllergicStatusesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `AllergicStatus` at the end of the edge. */
  node: AllergicStatus;
};

/** Methods to use when ordering `AllergicStatus`. */
export enum AllergicStatusesOrderBy {
  ALLERGIC_STATUS_ID_ASC = 'ALLERGIC_STATUS_ID_ASC',
  ALLERGIC_STATUS_ID_DESC = 'ALLERGIC_STATUS_ID_DESC',
  NATURAL = 'NATURAL',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC'
}

/** A connection to a list of `Allergy` values. */
export type AllergiesConnection = {
  __typename: 'AllergiesConnection';
  /** A list of edges which contains the `Allergy` and cursor to aid in pagination. */
  edges: Array<AllergiesEdge>;
  /** A list of `Allergy` objects. */
  nodes: Array<Allergy>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Allergy` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Allergy` edge in the connection. */
export type AllergiesEdge = {
  __typename: 'AllergiesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `Allergy` at the end of the edge. */
  node: Allergy;
};

/** Methods to use when ordering `Allergy`. */
export enum AllergiesOrderBy {
  ALLERGY_ID_ASC = 'ALLERGY_ID_ASC',
  ALLERGY_ID_DESC = 'ALLERGY_ID_DESC',
  ALLERGY_SUBSTANCE_ID_ASC = 'ALLERGY_SUBSTANCE_ID_ASC',
  ALLERGY_SUBSTANCE_ID_DESC = 'ALLERGY_SUBSTANCE_ID_DESC',
  ALLERGY_TYPE_ID_ASC = 'ALLERGY_TYPE_ID_ASC',
  ALLERGY_TYPE_ID_DESC = 'ALLERGY_TYPE_ID_DESC',
  NATURAL = 'NATURAL',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC'
}

/** Contains information about allergies */
export type Allergy = Node & {
  __typename: 'Allergy';
  /** Reads and enables pagination through a set of `AllergicCriticality`. */
  allergicCriticalitiesByPatientAllergyAllergyIdAndAllergicCriticalityId: AllergyAllergicCriticalitiesByPatientAllergyAllergyIdAndAllergicCriticalityIdManyToManyConnection;
  /** Reads and enables pagination through a set of `AllergicCriticality`. */
  allergicCriticalitiesByPatientAllergyAllergyIdAndAllergicCriticalityIdList: Array<AllergicCriticality>;
  /** Reads and enables pagination through a set of `AllergicReaction`. */
  allergicReactionsByPatientAllergyAllergyIdAndAllergicReactionId: AllergyAllergicReactionsByPatientAllergyAllergyIdAndAllergicReactionIdManyToManyConnection;
  /** Reads and enables pagination through a set of `AllergicReaction`. */
  allergicReactionsByPatientAllergyAllergyIdAndAllergicReactionIdList: Array<AllergicReaction>;
  /** Reads and enables pagination through a set of `AllergicSeverity`. */
  allergicSeveritiesByPatientAllergyAllergyIdAndAllergicSeverityId: AllergyAllergicSeveritiesByPatientAllergyAllergyIdAndAllergicSeverityIdManyToManyConnection;
  /** Reads and enables pagination through a set of `AllergicSeverity`. */
  allergicSeveritiesByPatientAllergyAllergyIdAndAllergicSeverityIdList: Array<AllergicSeverity>;
  /** Reads and enables pagination through a set of `AllergicStatus`. */
  allergicStatusesByPatientAllergyAllergyIdAndAllergicStatusId: AllergyAllergicStatusesByPatientAllergyAllergyIdAndAllergicStatusIdManyToManyConnection;
  /** Reads and enables pagination through a set of `AllergicStatus`. */
  allergicStatusesByPatientAllergyAllergyIdAndAllergicStatusIdList: Array<AllergicStatus>;
  allergyId: Scalars['Int'];
  /** Reads a single `AllergySubstance` that is related to this `Allergy`. */
  allergySubstance?: Maybe<AllergySubstance>;
  allergySubstanceId?: Maybe<Scalars['Int']>;
  /** Reads a single `AllergyType` that is related to this `Allergy`. */
  allergyType?: Maybe<AllergyType>;
  allergyTypeId?: Maybe<Scalars['Int']>;
  code: Scalars['String'];
  codeSystemId: Scalars['Int'];
  isDeleted: Scalars['Boolean'];
  name: Scalars['String'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  /** Reads and enables pagination through a set of `PatientAllergy`. */
  patientAllergies: PatientAllergiesConnection;
  /** Reads and enables pagination through a set of `PatientAllergy`. */
  patientAllergiesList: Array<PatientAllergy>;
};


/** Contains information about allergies */
export type AllergyallergicCriticalitiesByPatientAllergyAllergyIdAndAllergicCriticalityIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<AllergicCriticalityCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AllergicCriticalitiesOrderBy>>;
};


/** Contains information about allergies */
export type AllergyallergicCriticalitiesByPatientAllergyAllergyIdAndAllergicCriticalityIdListArgs = {
  condition?: InputMaybe<AllergicCriticalityCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AllergicCriticalitiesOrderBy>>;
};


/** Contains information about allergies */
export type AllergyallergicReactionsByPatientAllergyAllergyIdAndAllergicReactionIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<AllergicReactionCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AllergicReactionsOrderBy>>;
};


/** Contains information about allergies */
export type AllergyallergicReactionsByPatientAllergyAllergyIdAndAllergicReactionIdListArgs = {
  condition?: InputMaybe<AllergicReactionCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AllergicReactionsOrderBy>>;
};


/** Contains information about allergies */
export type AllergyallergicSeveritiesByPatientAllergyAllergyIdAndAllergicSeverityIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<AllergicSeverityCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AllergicSeveritiesOrderBy>>;
};


/** Contains information about allergies */
export type AllergyallergicSeveritiesByPatientAllergyAllergyIdAndAllergicSeverityIdListArgs = {
  condition?: InputMaybe<AllergicSeverityCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AllergicSeveritiesOrderBy>>;
};


/** Contains information about allergies */
export type AllergyallergicStatusesByPatientAllergyAllergyIdAndAllergicStatusIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<AllergicStatusCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AllergicStatusesOrderBy>>;
};


/** Contains information about allergies */
export type AllergyallergicStatusesByPatientAllergyAllergyIdAndAllergicStatusIdListArgs = {
  condition?: InputMaybe<AllergicStatusCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AllergicStatusesOrderBy>>;
};


/** Contains information about allergies */
export type AllergypatientAllergiesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<PatientAllergyCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PatientAllergiesOrderBy>>;
};


/** Contains information about allergies */
export type AllergypatientAllergiesListArgs = {
  condition?: InputMaybe<PatientAllergyCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PatientAllergiesOrderBy>>;
};

/** A connection to a list of `AllergicCriticality` values, with data from `PatientAllergy`. */
export type AllergyAllergicCriticalitiesByPatientAllergyAllergyIdAndAllergicCriticalityIdManyToManyConnection = {
  __typename: 'AllergyAllergicCriticalitiesByPatientAllergyAllergyIdAndAllergicCriticalityIdManyToManyConnection';
  /** A list of edges which contains the `AllergicCriticality`, info from the `PatientAllergy`, and the cursor to aid in pagination. */
  edges: Array<AllergyAllergicCriticalitiesByPatientAllergyAllergyIdAndAllergicCriticalityIdManyToManyEdge>;
  /** A list of `AllergicCriticality` objects. */
  nodes: Array<AllergicCriticality>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `AllergicCriticality` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `AllergicCriticality` edge in the connection, with data from `PatientAllergy`. */
export type AllergyAllergicCriticalitiesByPatientAllergyAllergyIdAndAllergicCriticalityIdManyToManyEdge = {
  __typename: 'AllergyAllergicCriticalitiesByPatientAllergyAllergyIdAndAllergicCriticalityIdManyToManyEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `AllergicCriticality` at the end of the edge. */
  node: AllergicCriticality;
  /** Reads and enables pagination through a set of `PatientAllergy`. */
  patientAllergies: PatientAllergiesConnection;
  /** Reads and enables pagination through a set of `PatientAllergy`. */
  patientAllergiesList: Array<PatientAllergy>;
};


/** A `AllergicCriticality` edge in the connection, with data from `PatientAllergy`. */
export type AllergyAllergicCriticalitiesByPatientAllergyAllergyIdAndAllergicCriticalityIdManyToManyEdgepatientAllergiesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<PatientAllergyCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PatientAllergiesOrderBy>>;
};


/** A `AllergicCriticality` edge in the connection, with data from `PatientAllergy`. */
export type AllergyAllergicCriticalitiesByPatientAllergyAllergyIdAndAllergicCriticalityIdManyToManyEdgepatientAllergiesListArgs = {
  condition?: InputMaybe<PatientAllergyCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PatientAllergiesOrderBy>>;
};

/** A connection to a list of `AllergicReaction` values, with data from `PatientAllergy`. */
export type AllergyAllergicReactionsByPatientAllergyAllergyIdAndAllergicReactionIdManyToManyConnection = {
  __typename: 'AllergyAllergicReactionsByPatientAllergyAllergyIdAndAllergicReactionIdManyToManyConnection';
  /** A list of edges which contains the `AllergicReaction`, info from the `PatientAllergy`, and the cursor to aid in pagination. */
  edges: Array<AllergyAllergicReactionsByPatientAllergyAllergyIdAndAllergicReactionIdManyToManyEdge>;
  /** A list of `AllergicReaction` objects. */
  nodes: Array<AllergicReaction>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `AllergicReaction` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `AllergicReaction` edge in the connection, with data from `PatientAllergy`. */
export type AllergyAllergicReactionsByPatientAllergyAllergyIdAndAllergicReactionIdManyToManyEdge = {
  __typename: 'AllergyAllergicReactionsByPatientAllergyAllergyIdAndAllergicReactionIdManyToManyEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `AllergicReaction` at the end of the edge. */
  node: AllergicReaction;
  /** Reads and enables pagination through a set of `PatientAllergy`. */
  patientAllergies: PatientAllergiesConnection;
  /** Reads and enables pagination through a set of `PatientAllergy`. */
  patientAllergiesList: Array<PatientAllergy>;
};


/** A `AllergicReaction` edge in the connection, with data from `PatientAllergy`. */
export type AllergyAllergicReactionsByPatientAllergyAllergyIdAndAllergicReactionIdManyToManyEdgepatientAllergiesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<PatientAllergyCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PatientAllergiesOrderBy>>;
};


/** A `AllergicReaction` edge in the connection, with data from `PatientAllergy`. */
export type AllergyAllergicReactionsByPatientAllergyAllergyIdAndAllergicReactionIdManyToManyEdgepatientAllergiesListArgs = {
  condition?: InputMaybe<PatientAllergyCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PatientAllergiesOrderBy>>;
};

/** A connection to a list of `AllergicSeverity` values, with data from `PatientAllergy`. */
export type AllergyAllergicSeveritiesByPatientAllergyAllergyIdAndAllergicSeverityIdManyToManyConnection = {
  __typename: 'AllergyAllergicSeveritiesByPatientAllergyAllergyIdAndAllergicSeverityIdManyToManyConnection';
  /** A list of edges which contains the `AllergicSeverity`, info from the `PatientAllergy`, and the cursor to aid in pagination. */
  edges: Array<AllergyAllergicSeveritiesByPatientAllergyAllergyIdAndAllergicSeverityIdManyToManyEdge>;
  /** A list of `AllergicSeverity` objects. */
  nodes: Array<AllergicSeverity>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `AllergicSeverity` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `AllergicSeverity` edge in the connection, with data from `PatientAllergy`. */
export type AllergyAllergicSeveritiesByPatientAllergyAllergyIdAndAllergicSeverityIdManyToManyEdge = {
  __typename: 'AllergyAllergicSeveritiesByPatientAllergyAllergyIdAndAllergicSeverityIdManyToManyEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `AllergicSeverity` at the end of the edge. */
  node: AllergicSeverity;
  /** Reads and enables pagination through a set of `PatientAllergy`. */
  patientAllergies: PatientAllergiesConnection;
  /** Reads and enables pagination through a set of `PatientAllergy`. */
  patientAllergiesList: Array<PatientAllergy>;
};


/** A `AllergicSeverity` edge in the connection, with data from `PatientAllergy`. */
export type AllergyAllergicSeveritiesByPatientAllergyAllergyIdAndAllergicSeverityIdManyToManyEdgepatientAllergiesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<PatientAllergyCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PatientAllergiesOrderBy>>;
};


/** A `AllergicSeverity` edge in the connection, with data from `PatientAllergy`. */
export type AllergyAllergicSeveritiesByPatientAllergyAllergyIdAndAllergicSeverityIdManyToManyEdgepatientAllergiesListArgs = {
  condition?: InputMaybe<PatientAllergyCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PatientAllergiesOrderBy>>;
};

/** A connection to a list of `AllergicStatus` values, with data from `PatientAllergy`. */
export type AllergyAllergicStatusesByPatientAllergyAllergyIdAndAllergicStatusIdManyToManyConnection = {
  __typename: 'AllergyAllergicStatusesByPatientAllergyAllergyIdAndAllergicStatusIdManyToManyConnection';
  /** A list of edges which contains the `AllergicStatus`, info from the `PatientAllergy`, and the cursor to aid in pagination. */
  edges: Array<AllergyAllergicStatusesByPatientAllergyAllergyIdAndAllergicStatusIdManyToManyEdge>;
  /** A list of `AllergicStatus` objects. */
  nodes: Array<AllergicStatus>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `AllergicStatus` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `AllergicStatus` edge in the connection, with data from `PatientAllergy`. */
export type AllergyAllergicStatusesByPatientAllergyAllergyIdAndAllergicStatusIdManyToManyEdge = {
  __typename: 'AllergyAllergicStatusesByPatientAllergyAllergyIdAndAllergicStatusIdManyToManyEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `AllergicStatus` at the end of the edge. */
  node: AllergicStatus;
  /** Reads and enables pagination through a set of `PatientAllergy`. */
  patientAllergies: PatientAllergiesConnection;
  /** Reads and enables pagination through a set of `PatientAllergy`. */
  patientAllergiesList: Array<PatientAllergy>;
};


/** A `AllergicStatus` edge in the connection, with data from `PatientAllergy`. */
export type AllergyAllergicStatusesByPatientAllergyAllergyIdAndAllergicStatusIdManyToManyEdgepatientAllergiesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<PatientAllergyCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PatientAllergiesOrderBy>>;
};


/** A `AllergicStatus` edge in the connection, with data from `PatientAllergy`. */
export type AllergyAllergicStatusesByPatientAllergyAllergyIdAndAllergicStatusIdManyToManyEdgepatientAllergiesListArgs = {
  condition?: InputMaybe<PatientAllergyCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PatientAllergiesOrderBy>>;
};

/** A condition to be used against `Allergy` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type AllergyCondition = {
  /** Checks for equality with the object’s `allergyId` field. */
  allergyId?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `allergySubstanceId` field. */
  allergySubstanceId?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `allergyTypeId` field. */
  allergyTypeId?: InputMaybe<Scalars['Int']>;
};

/** Contains information about allergy substances */
export type AllergySubstance = Node & {
  __typename: 'AllergySubstance';
  /** Reads and enables pagination through a set of `Allergy`. */
  allergies: AllergiesConnection;
  /** Reads and enables pagination through a set of `Allergy`. */
  allergiesList: Array<Allergy>;
  allergySubstanceId: Scalars['Int'];
  /** Reads and enables pagination through a set of `AllergyType`. */
  allergyTypesByAllergyAllergySubstanceIdAndAllergyTypeId: AllergySubstanceAllergyTypesByAllergyAllergySubstanceIdAndAllergyTypeIdManyToManyConnection;
  /** Reads and enables pagination through a set of `AllergyType`. */
  allergyTypesByAllergyAllergySubstanceIdAndAllergyTypeIdList: Array<AllergyType>;
  code: Scalars['String'];
  codeSystemId?: Maybe<Scalars['Int']>;
  isDeleted: Scalars['Boolean'];
  name: Scalars['String'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
};


/** Contains information about allergy substances */
export type AllergySubstanceallergiesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<AllergyCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AllergiesOrderBy>>;
};


/** Contains information about allergy substances */
export type AllergySubstanceallergiesListArgs = {
  condition?: InputMaybe<AllergyCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AllergiesOrderBy>>;
};


/** Contains information about allergy substances */
export type AllergySubstanceallergyTypesByAllergyAllergySubstanceIdAndAllergyTypeIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<AllergyTypeCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AllergyTypesOrderBy>>;
};


/** Contains information about allergy substances */
export type AllergySubstanceallergyTypesByAllergyAllergySubstanceIdAndAllergyTypeIdListArgs = {
  condition?: InputMaybe<AllergyTypeCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AllergyTypesOrderBy>>;
};

/** A connection to a list of `AllergyType` values, with data from `Allergy`. */
export type AllergySubstanceAllergyTypesByAllergyAllergySubstanceIdAndAllergyTypeIdManyToManyConnection = {
  __typename: 'AllergySubstanceAllergyTypesByAllergyAllergySubstanceIdAndAllergyTypeIdManyToManyConnection';
  /** A list of edges which contains the `AllergyType`, info from the `Allergy`, and the cursor to aid in pagination. */
  edges: Array<AllergySubstanceAllergyTypesByAllergyAllergySubstanceIdAndAllergyTypeIdManyToManyEdge>;
  /** A list of `AllergyType` objects. */
  nodes: Array<AllergyType>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `AllergyType` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `AllergyType` edge in the connection, with data from `Allergy`. */
export type AllergySubstanceAllergyTypesByAllergyAllergySubstanceIdAndAllergyTypeIdManyToManyEdge = {
  __typename: 'AllergySubstanceAllergyTypesByAllergyAllergySubstanceIdAndAllergyTypeIdManyToManyEdge';
  /** Reads and enables pagination through a set of `Allergy`. */
  allergies: AllergiesConnection;
  /** Reads and enables pagination through a set of `Allergy`. */
  allergiesList: Array<Allergy>;
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `AllergyType` at the end of the edge. */
  node: AllergyType;
};


/** A `AllergyType` edge in the connection, with data from `Allergy`. */
export type AllergySubstanceAllergyTypesByAllergyAllergySubstanceIdAndAllergyTypeIdManyToManyEdgeallergiesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<AllergyCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AllergiesOrderBy>>;
};


/** A `AllergyType` edge in the connection, with data from `Allergy`. */
export type AllergySubstanceAllergyTypesByAllergyAllergySubstanceIdAndAllergyTypeIdManyToManyEdgeallergiesListArgs = {
  condition?: InputMaybe<AllergyCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AllergiesOrderBy>>;
};

/**
 * A condition to be used against `AllergySubstance` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type AllergySubstanceCondition = {
  /** Checks for equality with the object’s `allergySubstanceId` field. */
  allergySubstanceId?: InputMaybe<Scalars['Int']>;
};

/** A connection to a list of `AllergySubstance` values. */
export type AllergySubstancesConnection = {
  __typename: 'AllergySubstancesConnection';
  /** A list of edges which contains the `AllergySubstance` and cursor to aid in pagination. */
  edges: Array<AllergySubstancesEdge>;
  /** A list of `AllergySubstance` objects. */
  nodes: Array<AllergySubstance>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `AllergySubstance` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `AllergySubstance` edge in the connection. */
export type AllergySubstancesEdge = {
  __typename: 'AllergySubstancesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `AllergySubstance` at the end of the edge. */
  node: AllergySubstance;
};

/** Methods to use when ordering `AllergySubstance`. */
export enum AllergySubstancesOrderBy {
  ALLERGY_SUBSTANCE_ID_ASC = 'ALLERGY_SUBSTANCE_ID_ASC',
  ALLERGY_SUBSTANCE_ID_DESC = 'ALLERGY_SUBSTANCE_ID_DESC',
  NATURAL = 'NATURAL',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC'
}

/** Contains information about allergy types */
export type AllergyType = Node & {
  __typename: 'AllergyType';
  /** Reads and enables pagination through a set of `Allergy`. */
  allergies: AllergiesConnection;
  /** Reads and enables pagination through a set of `Allergy`. */
  allergiesList: Array<Allergy>;
  /** Reads and enables pagination through a set of `AllergySubstance`. */
  allergySubstancesByAllergyAllergyTypeIdAndAllergySubstanceId: AllergyTypeAllergySubstancesByAllergyAllergyTypeIdAndAllergySubstanceIdManyToManyConnection;
  /** Reads and enables pagination through a set of `AllergySubstance`. */
  allergySubstancesByAllergyAllergyTypeIdAndAllergySubstanceIdList: Array<AllergySubstance>;
  allergyTypeId: Scalars['Int'];
  code: Scalars['String'];
  codeSystemId?: Maybe<Scalars['Int']>;
  isDeleted: Scalars['Boolean'];
  name: Scalars['String'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
};


/** Contains information about allergy types */
export type AllergyTypeallergiesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<AllergyCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AllergiesOrderBy>>;
};


/** Contains information about allergy types */
export type AllergyTypeallergiesListArgs = {
  condition?: InputMaybe<AllergyCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AllergiesOrderBy>>;
};


/** Contains information about allergy types */
export type AllergyTypeallergySubstancesByAllergyAllergyTypeIdAndAllergySubstanceIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<AllergySubstanceCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AllergySubstancesOrderBy>>;
};


/** Contains information about allergy types */
export type AllergyTypeallergySubstancesByAllergyAllergyTypeIdAndAllergySubstanceIdListArgs = {
  condition?: InputMaybe<AllergySubstanceCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AllergySubstancesOrderBy>>;
};

/** A connection to a list of `AllergySubstance` values, with data from `Allergy`. */
export type AllergyTypeAllergySubstancesByAllergyAllergyTypeIdAndAllergySubstanceIdManyToManyConnection = {
  __typename: 'AllergyTypeAllergySubstancesByAllergyAllergyTypeIdAndAllergySubstanceIdManyToManyConnection';
  /** A list of edges which contains the `AllergySubstance`, info from the `Allergy`, and the cursor to aid in pagination. */
  edges: Array<AllergyTypeAllergySubstancesByAllergyAllergyTypeIdAndAllergySubstanceIdManyToManyEdge>;
  /** A list of `AllergySubstance` objects. */
  nodes: Array<AllergySubstance>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `AllergySubstance` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `AllergySubstance` edge in the connection, with data from `Allergy`. */
export type AllergyTypeAllergySubstancesByAllergyAllergyTypeIdAndAllergySubstanceIdManyToManyEdge = {
  __typename: 'AllergyTypeAllergySubstancesByAllergyAllergyTypeIdAndAllergySubstanceIdManyToManyEdge';
  /** Reads and enables pagination through a set of `Allergy`. */
  allergies: AllergiesConnection;
  /** Reads and enables pagination through a set of `Allergy`. */
  allergiesList: Array<Allergy>;
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `AllergySubstance` at the end of the edge. */
  node: AllergySubstance;
};


/** A `AllergySubstance` edge in the connection, with data from `Allergy`. */
export type AllergyTypeAllergySubstancesByAllergyAllergyTypeIdAndAllergySubstanceIdManyToManyEdgeallergiesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<AllergyCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AllergiesOrderBy>>;
};


/** A `AllergySubstance` edge in the connection, with data from `Allergy`. */
export type AllergyTypeAllergySubstancesByAllergyAllergyTypeIdAndAllergySubstanceIdManyToManyEdgeallergiesListArgs = {
  condition?: InputMaybe<AllergyCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AllergiesOrderBy>>;
};

/**
 * A condition to be used against `AllergyType` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type AllergyTypeCondition = {
  /** Checks for equality with the object’s `allergyTypeId` field. */
  allergyTypeId?: InputMaybe<Scalars['Int']>;
};

/** A connection to a list of `AllergyType` values. */
export type AllergyTypesConnection = {
  __typename: 'AllergyTypesConnection';
  /** A list of edges which contains the `AllergyType` and cursor to aid in pagination. */
  edges: Array<AllergyTypesEdge>;
  /** A list of `AllergyType` objects. */
  nodes: Array<AllergyType>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `AllergyType` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `AllergyType` edge in the connection. */
export type AllergyTypesEdge = {
  __typename: 'AllergyTypesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `AllergyType` at the end of the edge. */
  node: AllergyType;
};

/** Methods to use when ordering `AllergyType`. */
export enum AllergyTypesOrderBy {
  ALLERGY_TYPE_ID_ASC = 'ALLERGY_TYPE_ID_ASC',
  ALLERGY_TYPE_ID_DESC = 'ALLERGY_TYPE_ID_DESC',
  NATURAL = 'NATURAL',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC'
}

export type ApplicationClient = {
  __typename: 'ApplicationClient';
  machine?: Maybe<MachineApplication>;
  name?: Maybe<Scalars['String']>;
  type?: Maybe<ApplicationClientTypeEnum>;
  user?: Maybe<User>;
  uuid?: Maybe<Scalars['UUID']>;
};

export enum ApplicationClientTypeEnum {
  MACHINE_APPLICATION = 'MACHINE_APPLICATION',
  READYCORE_USER = 'READYCORE_USER'
}

/** Contains information about the appointment */
export type Appointment = Node & {
  __typename: 'Appointment';
  address1?: Maybe<Scalars['String']>;
  address2?: Maybe<Scalars['String']>;
  addressLat?: Maybe<Scalars['Float']>;
  addressLng?: Maybe<Scalars['Float']>;
  /** Reads and enables pagination through a set of `AppointmentDispatch`. */
  appointmentDispatches: AppointmentDispatchesConnection;
  /** Reads and enables pagination through a set of `AppointmentDispatch`. */
  appointmentDispatchesList: Array<AppointmentDispatch>;
  appointmentId: Scalars['Int'];
  availabilityOverride?: Maybe<Scalars['Boolean']>;
  cancelledAt?: Maybe<Scalars['Datetime']>;
  cancelledBy?: Maybe<ApplicationClient>;
  cancelledByClientUuid?: Maybe<Scalars['UUID']>;
  cancelledReason?: Maybe<CancellationReasonEnum>;
  cancelledReasonOther?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  /** calculates the appointment completed_at timestamp based off the max related appointment_dispatch completed_at timestamps */
  completedAt?: Maybe<Scalars['Datetime']>;
  contactName?: Maybe<Scalars['String']>;
  createdAt: Scalars['Datetime'];
  createdBy?: Maybe<Scalars['Int']>;
  deletedAt?: Maybe<Scalars['Datetime']>;
  dispatchFailedAt?: Maybe<Scalars['Datetime']>;
  /** Reads and enables pagination through a set of `Encounter`. */
  encounters: EncountersConnection;
  /** Reads and enables pagination through a set of `Encounter`. */
  encountersList: Array<Encounter>;
  estimatedDuration?: Maybe<Interval>;
  globalId: Scalars['UUID'];
  humanizedStatus?: Maybe<Scalars['String']>;
  /** Reads and enables pagination through a set of `InsuranceRecord`. */
  insuranceRecordsByEncounterAppointmentIdAndPrimaryInsurance: AppointmentInsuranceRecordsByEncounterAppointmentIdAndPrimaryInsuranceManyToManyConnection;
  /** Reads and enables pagination through a set of `InsuranceRecord`. */
  insuranceRecordsByEncounterAppointmentIdAndPrimaryInsuranceList: Array<InsuranceRecord>;
  /** Reads and enables pagination through a set of `InsuranceRecord`. */
  insuranceRecordsByEncounterAppointmentIdAndSecondaryInsurance: AppointmentInsuranceRecordsByEncounterAppointmentIdAndSecondaryInsuranceManyToManyConnection;
  /** Reads and enables pagination through a set of `InsuranceRecord`. */
  insuranceRecordsByEncounterAppointmentIdAndSecondaryInsuranceList: Array<InsuranceRecord>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  location?: Maybe<Scalars['String']>;
  /** Reads a single `Market` that is related to this `Appointment`. */
  market?: Maybe<Market>;
  marketId: Scalars['Int'];
  marketOverride?: Maybe<Scalars['Boolean']>;
  migrationSource?: Maybe<Scalars['String']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  partnership?: Maybe<Scalars['String']>;
  /** Reads and enables pagination through a set of `Patient`. */
  patientsByEncounterAppointmentIdAndPatientId: AppointmentPatientsByEncounterAppointmentIdAndPatientIdManyToManyConnection;
  /** Reads and enables pagination through a set of `Patient`. */
  patientsByEncounterAppointmentIdAndPatientIdList: Array<Patient>;
  primaryPhone?: Maybe<Scalars['String']>;
  rescheduledAt?: Maybe<Scalars['Datetime']>;
  rescheduledFrom: Array<Maybe<Scalars['Int']>>;
  rescheduledReason?: Maybe<RescheduleReasonEnum>;
  rescheduledTo?: Maybe<Appointment>;
  /** Reads and enables pagination through a set of `ResponderRole`. */
  responderRolesByAppointmentDispatchAppointmentIdAndResponderId: AppointmentResponderRolesByAppointmentDispatchAppointmentIdAndResponderIdManyToManyConnection;
  /** Reads and enables pagination through a set of `ResponderRole`. */
  responderRolesByAppointmentDispatchAppointmentIdAndResponderIdList: Array<ResponderRole>;
  scheduledFor: Scalars['Datetime'];
  scheduledForDate?: Maybe<Scalars['String']>;
  scheduledForTime?: Maybe<Scalars['String']>;
  /** Reads and enables pagination through a set of `ServiceLine`. */
  serviceLinesByEncounterAppointmentIdAndServiceLineId: AppointmentServiceLinesByEncounterAppointmentIdAndServiceLineIdManyToManyConnection;
  /** Reads and enables pagination through a set of `ServiceLine`. */
  serviceLinesByEncounterAppointmentIdAndServiceLineIdList: Array<ServiceLine>;
  skeduloJobId?: Maybe<Scalars['UUID']>;
  source?: Maybe<Scalars['String']>;
  specialInstructions?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  /** calculates the appointment status based off the set timestamp fields */
  status?: Maybe<AppointmentStatusEnum>;
  systemLastUpdatedBy: SystemOfOriginEnum;
  systemOfOrigin: SystemOfOriginEnum;
  unit?: Maybe<Scalars['String']>;
  updatedAt: Scalars['Datetime'];
  updatedBy?: Maybe<Scalars['Int']>;
  /** Reads a single `User` that is related to this `Appointment`. */
  userByCreatedBy?: Maybe<User>;
  zip?: Maybe<Scalars['String']>;
  zipCode: Scalars['String'];
  zoneId: Scalars['Int'];
};


/** Contains information about the appointment */
export type AppointmentappointmentDispatchesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<AppointmentDispatchCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AppointmentDispatchesOrderBy>>;
};


/** Contains information about the appointment */
export type AppointmentappointmentDispatchesListArgs = {
  condition?: InputMaybe<AppointmentDispatchCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AppointmentDispatchesOrderBy>>;
};


/** Contains information about the appointment */
export type AppointmentencountersArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<EncounterCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EncountersOrderBy>>;
};


/** Contains information about the appointment */
export type AppointmentencountersListArgs = {
  condition?: InputMaybe<EncounterCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EncountersOrderBy>>;
};


/** Contains information about the appointment */
export type AppointmentinsuranceRecordsByEncounterAppointmentIdAndPrimaryInsuranceArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<InsuranceRecordCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InsuranceRecordsOrderBy>>;
};


/** Contains information about the appointment */
export type AppointmentinsuranceRecordsByEncounterAppointmentIdAndPrimaryInsuranceListArgs = {
  condition?: InputMaybe<InsuranceRecordCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InsuranceRecordsOrderBy>>;
};


/** Contains information about the appointment */
export type AppointmentinsuranceRecordsByEncounterAppointmentIdAndSecondaryInsuranceArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<InsuranceRecordCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InsuranceRecordsOrderBy>>;
};


/** Contains information about the appointment */
export type AppointmentinsuranceRecordsByEncounterAppointmentIdAndSecondaryInsuranceListArgs = {
  condition?: InputMaybe<InsuranceRecordCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InsuranceRecordsOrderBy>>;
};


/** Contains information about the appointment */
export type AppointmentpatientsByEncounterAppointmentIdAndPatientIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<PatientCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PatientsOrderBy>>;
};


/** Contains information about the appointment */
export type AppointmentpatientsByEncounterAppointmentIdAndPatientIdListArgs = {
  condition?: InputMaybe<PatientCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PatientsOrderBy>>;
};


/** Contains information about the appointment */
export type AppointmentresponderRolesByAppointmentDispatchAppointmentIdAndResponderIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ResponderRoleCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ResponderRolesOrderBy>>;
};


/** Contains information about the appointment */
export type AppointmentresponderRolesByAppointmentDispatchAppointmentIdAndResponderIdListArgs = {
  condition?: InputMaybe<ResponderRoleCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ResponderRolesOrderBy>>;
};


/** Contains information about the appointment */
export type AppointmentserviceLinesByEncounterAppointmentIdAndServiceLineIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ServiceLineCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ServiceLinesOrderBy>>;
};


/** Contains information about the appointment */
export type AppointmentserviceLinesByEncounterAppointmentIdAndServiceLineIdListArgs = {
  condition?: InputMaybe<ServiceLineCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ServiceLinesOrderBy>>;
};

export type AppointmentAddress = {
  address: Scalars['String'];
  address_lat: Scalars['Float'];
  address_lng: Scalars['Float'];
  marketId: Scalars['Int'];
  zipcode: Scalars['String'];
  zoneId: Scalars['Int'];
};

export type AppointmentAvailability = {
  __typename: 'AppointmentAvailability';
  appointmentSlots: Array<Maybe<AppointmentSlots>>;
  jobDuration?: Maybe<Scalars['Int']>;
  jobTags?: Maybe<Array<Maybe<AppointmentJobTag>>>;
  jobType: Scalars['String'];
  requiredResponders?: Maybe<Scalars['Int']>;
};

/**
 * A condition to be used against `Appointment` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type AppointmentCondition = {
  /** Checks for equality with the object’s `appointmentId` field. */
  appointmentId?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `createdBy` field. */
  createdBy?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `globalId` field. */
  globalId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `marketId` field. */
  marketId?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `migrationSource` field. */
  migrationSource?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `rescheduledFrom` field. */
  rescheduledFrom?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Checks for equality with the object’s `scheduledFor` field. */
  scheduledFor?: InputMaybe<Scalars['Datetime']>;
  /** Filters to records matching skeduloJobId */
  skeduloJobId?: InputMaybe<Scalars['UUID']>;
};

/** Contains information mapping 1-to-many dispatched responders to an appointment */
export type AppointmentDispatch = Node & {
  __typename: 'AppointmentDispatch';
  /** Reads a single `Appointment` that is related to this `AppointmentDispatch`. */
  appointment?: Maybe<Appointment>;
  appointmentDispatchId: Scalars['Int'];
  appointmentId: Scalars['Int'];
  atPatientAt?: Maybe<Scalars['Datetime']>;
  cancelledAt?: Maybe<Scalars['Datetime']>;
  completedAt?: Maybe<Scalars['Datetime']>;
  createdAt: Scalars['Datetime'];
  dispatchedAt?: Maybe<Scalars['Datetime']>;
  enRouteAt?: Maybe<Scalars['Datetime']>;
  migrationSource?: Maybe<Scalars['String']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  onSceneAt?: Maybe<Scalars['Datetime']>;
  removedAt?: Maybe<Scalars['Datetime']>;
  removedBy?: Maybe<Scalars['Int']>;
  removedReason?: Maybe<Scalars['String']>;
  /** Reads a single `ResponderRole` that is related to this `AppointmentDispatch`. */
  responder?: Maybe<ResponderRole>;
  responderId: Scalars['Int'];
  skeduloJobAllocationId?: Maybe<Scalars['UUID']>;
  /** calculates the appointment_dispatch status based off the set timestamp fields */
  status?: Maybe<AppointmentDispatchStatusEnum>;
  updatedAt?: Maybe<Scalars['Datetime']>;
};

/**
 * A condition to be used against `AppointmentDispatch` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type AppointmentDispatchCondition = {
  /** Checks for equality with the object’s `appointmentDispatchId` field. */
  appointmentDispatchId?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `appointmentId` field. */
  appointmentId?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `migrationSource` field. */
  migrationSource?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `responderId` field. */
  responderId?: InputMaybe<Scalars['Int']>;
  /** Filters on records matching `skedulo_job_allocation_id` */
  skedulo_job_allocation_id?: InputMaybe<Scalars['String']>;
  /** Filters on records that do not include `status` */
  statusIsNot?: InputMaybe<Array<InputMaybe<AppointmentDispatchStatusConditionEnum>>>;
};

/** An input for mutations affecting `AppointmentDispatch` */
export type AppointmentDispatchInput = {
  appointmentDispatchId?: InputMaybe<Scalars['Int']>;
  appointmentId: Scalars['Int'];
  atPatientAt?: InputMaybe<Scalars['Datetime']>;
  cancelledAt?: InputMaybe<Scalars['Datetime']>;
  completedAt?: InputMaybe<Scalars['Datetime']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  dispatchedAt?: InputMaybe<Scalars['Datetime']>;
  enRouteAt?: InputMaybe<Scalars['Datetime']>;
  migrationSource?: InputMaybe<Scalars['String']>;
  onSceneAt?: InputMaybe<Scalars['Datetime']>;
  removedAt?: InputMaybe<Scalars['Datetime']>;
  removedBy?: InputMaybe<Scalars['Int']>;
  removedReason?: InputMaybe<Scalars['String']>;
  responderId: Scalars['Int'];
  skeduloJobAllocationId?: InputMaybe<Scalars['UUID']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** Represents an update to a `AppointmentDispatch`. Fields that are set will be updated. */
export type AppointmentDispatchPatch = {
  appointmentDispatchId?: InputMaybe<Scalars['Int']>;
  appointmentId?: InputMaybe<Scalars['Int']>;
  atPatientAt?: InputMaybe<Scalars['Datetime']>;
  cancelledAt?: InputMaybe<Scalars['Datetime']>;
  completedAt?: InputMaybe<Scalars['Datetime']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  dispatchedAt?: InputMaybe<Scalars['Datetime']>;
  enRouteAt?: InputMaybe<Scalars['Datetime']>;
  migrationSource?: InputMaybe<Scalars['String']>;
  onSceneAt?: InputMaybe<Scalars['Datetime']>;
  removedAt?: InputMaybe<Scalars['Datetime']>;
  removedBy?: InputMaybe<Scalars['Int']>;
  removedReason?: InputMaybe<Scalars['String']>;
  responderId?: InputMaybe<Scalars['Int']>;
  skeduloJobAllocationId?: InputMaybe<Scalars['UUID']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

export enum AppointmentDispatchStatusConditionEnum {
  AT_PATIENT = 'AT_PATIENT',
  CANCELLED = 'CANCELLED',
  COMPLETED = 'COMPLETED',
  DISPATCHED = 'DISPATCHED',
  EN_ROUTE = 'EN_ROUTE',
  ON_SCENE = 'ON_SCENE',
  PENDING_DISPATCH = 'PENDING_DISPATCH',
  REMOVED = 'REMOVED'
}

export enum AppointmentDispatchStatusEnum {
  AT_PATIENT = 'AT_PATIENT',
  CANCELLED = 'CANCELLED',
  COMPLETED = 'COMPLETED',
  DISPATCHED = 'DISPATCHED',
  EN_ROUTE = 'EN_ROUTE',
  ON_SCENE = 'ON_SCENE',
  PENDING_DISPATCH = 'PENDING_DISPATCH',
  REMOVED = 'REMOVED'
}

/** A connection to a list of `AppointmentDispatch` values. */
export type AppointmentDispatchesConnection = {
  __typename: 'AppointmentDispatchesConnection';
  /** A list of edges which contains the `AppointmentDispatch` and cursor to aid in pagination. */
  edges: Array<AppointmentDispatchesEdge>;
  /** A list of `AppointmentDispatch` objects. */
  nodes: Array<AppointmentDispatch>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `AppointmentDispatch` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `AppointmentDispatch` edge in the connection. */
export type AppointmentDispatchesEdge = {
  __typename: 'AppointmentDispatchesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `AppointmentDispatch` at the end of the edge. */
  node: AppointmentDispatch;
};

/** Methods to use when ordering `AppointmentDispatch`. */
export enum AppointmentDispatchesOrderBy {
  APPOINTMENT_DISPATCH_ID_ASC = 'APPOINTMENT_DISPATCH_ID_ASC',
  APPOINTMENT_DISPATCH_ID_DESC = 'APPOINTMENT_DISPATCH_ID_DESC',
  APPOINTMENT_ID_ASC = 'APPOINTMENT_ID_ASC',
  APPOINTMENT_ID_DESC = 'APPOINTMENT_ID_DESC',
  MIGRATION_SOURCE_ASC = 'MIGRATION_SOURCE_ASC',
  MIGRATION_SOURCE_DESC = 'MIGRATION_SOURCE_DESC',
  NATURAL = 'NATURAL',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  RESPONDER_ID_ASC = 'RESPONDER_ID_ASC',
  RESPONDER_ID_DESC = 'RESPONDER_ID_DESC'
}

export type AppointmentFilter = {
  markets?: InputMaybe<Array<Scalars['Int']>>;
  scheduledAfter?: InputMaybe<Scalars['String']>;
  scheduledBefore?: InputMaybe<Scalars['String']>;
  serviceLines?: InputMaybe<Array<Scalars['Int']>>;
  status?: InputMaybe<Array<AppointmentStatusEnum>>;
};

/** A connection to a list of `InsuranceRecord` values, with data from `Encounter`. */
export type AppointmentInsuranceRecordsByEncounterAppointmentIdAndPrimaryInsuranceManyToManyConnection = {
  __typename: 'AppointmentInsuranceRecordsByEncounterAppointmentIdAndPrimaryInsuranceManyToManyConnection';
  /** A list of edges which contains the `InsuranceRecord`, info from the `Encounter`, and the cursor to aid in pagination. */
  edges: Array<AppointmentInsuranceRecordsByEncounterAppointmentIdAndPrimaryInsuranceManyToManyEdge>;
  /** A list of `InsuranceRecord` objects. */
  nodes: Array<InsuranceRecord>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `InsuranceRecord` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `InsuranceRecord` edge in the connection, with data from `Encounter`. */
export type AppointmentInsuranceRecordsByEncounterAppointmentIdAndPrimaryInsuranceManyToManyEdge = {
  __typename: 'AppointmentInsuranceRecordsByEncounterAppointmentIdAndPrimaryInsuranceManyToManyEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** Reads and enables pagination through a set of `Encounter`. */
  encountersByPrimaryInsurance: EncountersConnection;
  /** Reads and enables pagination through a set of `Encounter`. */
  encountersByPrimaryInsuranceList: Array<Encounter>;
  /** The `InsuranceRecord` at the end of the edge. */
  node: InsuranceRecord;
};


/** A `InsuranceRecord` edge in the connection, with data from `Encounter`. */
export type AppointmentInsuranceRecordsByEncounterAppointmentIdAndPrimaryInsuranceManyToManyEdgeencountersByPrimaryInsuranceArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<EncounterCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EncountersOrderBy>>;
};


/** A `InsuranceRecord` edge in the connection, with data from `Encounter`. */
export type AppointmentInsuranceRecordsByEncounterAppointmentIdAndPrimaryInsuranceManyToManyEdgeencountersByPrimaryInsuranceListArgs = {
  condition?: InputMaybe<EncounterCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EncountersOrderBy>>;
};

/** A connection to a list of `InsuranceRecord` values, with data from `Encounter`. */
export type AppointmentInsuranceRecordsByEncounterAppointmentIdAndSecondaryInsuranceManyToManyConnection = {
  __typename: 'AppointmentInsuranceRecordsByEncounterAppointmentIdAndSecondaryInsuranceManyToManyConnection';
  /** A list of edges which contains the `InsuranceRecord`, info from the `Encounter`, and the cursor to aid in pagination. */
  edges: Array<AppointmentInsuranceRecordsByEncounterAppointmentIdAndSecondaryInsuranceManyToManyEdge>;
  /** A list of `InsuranceRecord` objects. */
  nodes: Array<InsuranceRecord>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `InsuranceRecord` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `InsuranceRecord` edge in the connection, with data from `Encounter`. */
export type AppointmentInsuranceRecordsByEncounterAppointmentIdAndSecondaryInsuranceManyToManyEdge = {
  __typename: 'AppointmentInsuranceRecordsByEncounterAppointmentIdAndSecondaryInsuranceManyToManyEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** Reads and enables pagination through a set of `Encounter`. */
  encountersBySecondaryInsurance: EncountersConnection;
  /** Reads and enables pagination through a set of `Encounter`. */
  encountersBySecondaryInsuranceList: Array<Encounter>;
  /** The `InsuranceRecord` at the end of the edge. */
  node: InsuranceRecord;
};


/** A `InsuranceRecord` edge in the connection, with data from `Encounter`. */
export type AppointmentInsuranceRecordsByEncounterAppointmentIdAndSecondaryInsuranceManyToManyEdgeencountersBySecondaryInsuranceArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<EncounterCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EncountersOrderBy>>;
};


/** A `InsuranceRecord` edge in the connection, with data from `Encounter`. */
export type AppointmentInsuranceRecordsByEncounterAppointmentIdAndSecondaryInsuranceManyToManyEdgeencountersBySecondaryInsuranceListArgs = {
  condition?: InputMaybe<EncounterCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EncountersOrderBy>>;
};

export type AppointmentJobTag = {
  __typename: 'AppointmentJobTag';
  id: Scalars['UUID'];
};

/** Represents an update to a `Appointment`. Fields that are set will be updated. */
export type AppointmentPatch = {
  address1?: InputMaybe<Scalars['String']>;
  address2?: InputMaybe<Scalars['String']>;
  addressLat?: InputMaybe<Scalars['Float']>;
  addressLng?: InputMaybe<Scalars['Float']>;
  cancelledReason?: InputMaybe<CancellationReasonEnum>;
  cancelledReasonOther?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  marketId?: InputMaybe<Scalars['Int']>;
  marketOverride?: InputMaybe<Scalars['Boolean']>;
  partnership?: InputMaybe<Scalars['String']>;
  primaryPhone?: InputMaybe<Scalars['String']>;
  rescheduledReason?: InputMaybe<RescheduleReasonEnum>;
  scheduledFor?: InputMaybe<Scalars['Datetime']>;
  skeduloJobId?: InputMaybe<Scalars['UUID']>;
  specialInstructions?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  systemLastUpdatedBy?: InputMaybe<SystemOfOriginEnum>;
  unit?: InputMaybe<Scalars['String']>;
  zip?: InputMaybe<Scalars['String']>;
  zipCode?: InputMaybe<Scalars['String']>;
  zoneId?: InputMaybe<Scalars['Int']>;
};

/** A connection to a list of `Patient` values, with data from `Encounter`. */
export type AppointmentPatientsByEncounterAppointmentIdAndPatientIdManyToManyConnection = {
  __typename: 'AppointmentPatientsByEncounterAppointmentIdAndPatientIdManyToManyConnection';
  /** A list of edges which contains the `Patient`, info from the `Encounter`, and the cursor to aid in pagination. */
  edges: Array<AppointmentPatientsByEncounterAppointmentIdAndPatientIdManyToManyEdge>;
  /** A list of `Patient` objects. */
  nodes: Array<Patient>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Patient` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Patient` edge in the connection, with data from `Encounter`. */
export type AppointmentPatientsByEncounterAppointmentIdAndPatientIdManyToManyEdge = {
  __typename: 'AppointmentPatientsByEncounterAppointmentIdAndPatientIdManyToManyEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** Reads and enables pagination through a set of `Encounter`. */
  encounters: EncountersConnection;
  /** Reads and enables pagination through a set of `Encounter`. */
  encountersList: Array<Encounter>;
  /** The `Patient` at the end of the edge. */
  node: Patient;
};


/** A `Patient` edge in the connection, with data from `Encounter`. */
export type AppointmentPatientsByEncounterAppointmentIdAndPatientIdManyToManyEdgeencountersArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<EncounterCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EncountersOrderBy>>;
};


/** A `Patient` edge in the connection, with data from `Encounter`. */
export type AppointmentPatientsByEncounterAppointmentIdAndPatientIdManyToManyEdgeencountersListArgs = {
  condition?: InputMaybe<EncounterCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EncountersOrderBy>>;
};

/** A connection to a list of `ResponderRole` values, with data from `AppointmentDispatch`. */
export type AppointmentResponderRolesByAppointmentDispatchAppointmentIdAndResponderIdManyToManyConnection = {
  __typename: 'AppointmentResponderRolesByAppointmentDispatchAppointmentIdAndResponderIdManyToManyConnection';
  /** A list of edges which contains the `ResponderRole`, info from the `AppointmentDispatch`, and the cursor to aid in pagination. */
  edges: Array<AppointmentResponderRolesByAppointmentDispatchAppointmentIdAndResponderIdManyToManyEdge>;
  /** A list of `ResponderRole` objects. */
  nodes: Array<ResponderRole>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ResponderRole` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `ResponderRole` edge in the connection, with data from `AppointmentDispatch`. */
export type AppointmentResponderRolesByAppointmentDispatchAppointmentIdAndResponderIdManyToManyEdge = {
  __typename: 'AppointmentResponderRolesByAppointmentDispatchAppointmentIdAndResponderIdManyToManyEdge';
  /** Reads and enables pagination through a set of `AppointmentDispatch`. */
  appointmentDispatchesByResponderId: AppointmentDispatchesConnection;
  /** Reads and enables pagination through a set of `AppointmentDispatch`. */
  appointmentDispatchesByResponderIdList: Array<AppointmentDispatch>;
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `ResponderRole` at the end of the edge. */
  node: ResponderRole;
};


/** A `ResponderRole` edge in the connection, with data from `AppointmentDispatch`. */
export type AppointmentResponderRolesByAppointmentDispatchAppointmentIdAndResponderIdManyToManyEdgeappointmentDispatchesByResponderIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<AppointmentDispatchCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AppointmentDispatchesOrderBy>>;
};


/** A `ResponderRole` edge in the connection, with data from `AppointmentDispatch`. */
export type AppointmentResponderRolesByAppointmentDispatchAppointmentIdAndResponderIdManyToManyEdgeappointmentDispatchesByResponderIdListArgs = {
  condition?: InputMaybe<AppointmentDispatchCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AppointmentDispatchesOrderBy>>;
};

/** A connection to a list of `ServiceLine` values, with data from `Encounter`. */
export type AppointmentServiceLinesByEncounterAppointmentIdAndServiceLineIdManyToManyConnection = {
  __typename: 'AppointmentServiceLinesByEncounterAppointmentIdAndServiceLineIdManyToManyConnection';
  /** A list of edges which contains the `ServiceLine`, info from the `Encounter`, and the cursor to aid in pagination. */
  edges: Array<AppointmentServiceLinesByEncounterAppointmentIdAndServiceLineIdManyToManyEdge>;
  /** A list of `ServiceLine` objects. */
  nodes: Array<ServiceLine>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ServiceLine` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `ServiceLine` edge in the connection, with data from `Encounter`. */
export type AppointmentServiceLinesByEncounterAppointmentIdAndServiceLineIdManyToManyEdge = {
  __typename: 'AppointmentServiceLinesByEncounterAppointmentIdAndServiceLineIdManyToManyEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** Reads and enables pagination through a set of `Encounter`. */
  encounters: EncountersConnection;
  /** Reads and enables pagination through a set of `Encounter`. */
  encountersList: Array<Encounter>;
  /** The `ServiceLine` at the end of the edge. */
  node: ServiceLine;
};


/** A `ServiceLine` edge in the connection, with data from `Encounter`. */
export type AppointmentServiceLinesByEncounterAppointmentIdAndServiceLineIdManyToManyEdgeencountersArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<EncounterCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EncountersOrderBy>>;
};


/** A `ServiceLine` edge in the connection, with data from `Encounter`. */
export type AppointmentServiceLinesByEncounterAppointmentIdAndServiceLineIdManyToManyEdgeencountersListArgs = {
  condition?: InputMaybe<EncounterCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EncountersOrderBy>>;
};

export type AppointmentSlots = {
  __typename: 'AppointmentSlots';
  end: Scalars['String'];
  respondersAvailable: Scalars['Int'];
  start: Scalars['String'];
};

export enum AppointmentStatusEnum {
  AT_PATIENT = 'AT_PATIENT',
  CANCELLED = 'CANCELLED',
  COMPLETED = 'COMPLETED',
  DISPATCH_FAILED = 'DISPATCH_FAILED',
  EN_ROUTE = 'EN_ROUTE',
  ON_SCENE = 'ON_SCENE',
  RESCHEDULED = 'RESCHEDULED',
  SCHEDULED = 'SCHEDULED'
}

export type AppointmentTag = Node & {
  __typename: 'AppointmentTag';
  appointmentTag?: Maybe<Scalars['String']>;
  appointmentTagId: Scalars['String'];
  createdAt?: Maybe<Scalars['Datetime']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  skeduloJobTagId?: Maybe<Scalars['String']>;
};

/**
 * A condition to be used against `AppointmentTag` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type AppointmentTagCondition = {
  /** Checks for equality with the object’s `appointmentTagId` field. */
  appointmentTagId?: InputMaybe<Scalars['String']>;
  /** Filters on records matching `appointmentTagId` */
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

/** An input for mutations affecting `AppointmentTag` */
export type AppointmentTagInput = {
  appointmentTag?: InputMaybe<Scalars['String']>;
  appointmentTagId: Scalars['String'];
  createdAt?: InputMaybe<Scalars['Datetime']>;
  skeduloJobTagId?: InputMaybe<Scalars['String']>;
};

/** Represents an update to a `AppointmentTag`. Fields that are set will be updated. */
export type AppointmentTagPatch = {
  appointmentTag?: InputMaybe<Scalars['String']>;
  appointmentTagId?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  skeduloJobTagId?: InputMaybe<Scalars['String']>;
};

/** A connection to a list of `AppointmentTag` values. */
export type AppointmentTagsConnection = {
  __typename: 'AppointmentTagsConnection';
  /** A list of edges which contains the `AppointmentTag` and cursor to aid in pagination. */
  edges: Array<AppointmentTagsEdge>;
  /** A list of `AppointmentTag` objects. */
  nodes: Array<AppointmentTag>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `AppointmentTag` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `AppointmentTag` edge in the connection. */
export type AppointmentTagsEdge = {
  __typename: 'AppointmentTagsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `AppointmentTag` at the end of the edge. */
  node: AppointmentTag;
};

/** Methods to use when ordering `AppointmentTag`. */
export enum AppointmentTagsOrderBy {
  APPOINTMENT_TAG_ID_ASC = 'APPOINTMENT_TAG_ID_ASC',
  APPOINTMENT_TAG_ID_DESC = 'APPOINTMENT_TAG_ID_DESC',
  NATURAL = 'NATURAL',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC'
}

/** A connection to a list of `Appointment` values. */
export type AppointmentsConnection = {
  __typename: 'AppointmentsConnection';
  /** A list of edges which contains the `Appointment` and cursor to aid in pagination. */
  edges: Array<AppointmentsEdge>;
  /** A list of `Appointment` objects. */
  nodes: Array<Appointment>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Appointment` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Appointment` edge in the connection. */
export type AppointmentsEdge = {
  __typename: 'AppointmentsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `Appointment` at the end of the edge. */
  node: Appointment;
};

/** Methods to use when ordering `Appointment`. */
export enum AppointmentsOrderBy {
  APPOINTMENT_ID_ASC = 'APPOINTMENT_ID_ASC',
  APPOINTMENT_ID_DESC = 'APPOINTMENT_ID_DESC',
  CREATED_BY_ASC = 'CREATED_BY_ASC',
  CREATED_BY_DESC = 'CREATED_BY_DESC',
  GLOBAL_ID_ASC = 'GLOBAL_ID_ASC',
  GLOBAL_ID_DESC = 'GLOBAL_ID_DESC',
  MARKET_ID_ASC = 'MARKET_ID_ASC',
  MARKET_ID_DESC = 'MARKET_ID_DESC',
  MIGRATION_SOURCE_ASC = 'MIGRATION_SOURCE_ASC',
  MIGRATION_SOURCE_DESC = 'MIGRATION_SOURCE_DESC',
  NATURAL = 'NATURAL',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  RESCHEDULED_FROM_ASC = 'RESCHEDULED_FROM_ASC',
  RESCHEDULED_FROM_DESC = 'RESCHEDULED_FROM_DESC',
  SCHEDULED_FOR_ASC = 'SCHEDULED_FOR_ASC',
  SCHEDULED_FOR_DESC = 'SCHEDULED_FOR_DESC'
}

/** Contains Billing Diagnostic information */
export type BillingDiagnostic = Node & {
  __typename: 'BillingDiagnostic';
  billingDiagnosticsId: Scalars['Int'];
  createdAt: Scalars['Datetime'];
  deletedAt?: Maybe<Scalars['Datetime']>;
  /** Reads a single `EncounterTask` that is related to this `BillingDiagnostic`. */
  encounterTask?: Maybe<EncounterTask>;
  encounterTaskId?: Maybe<Scalars['Int']>;
  isDeleted: Scalars['Boolean'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  /** Reads a single `ProcedureCodeReference` that is related to this `BillingDiagnostic`. */
  procedureCodeReference?: Maybe<ProcedureCodeReference>;
  procedureCodeReferenceId?: Maybe<Scalars['Int']>;
  updatedAt: Scalars['Datetime'];
};

/**
 * A condition to be used against `BillingDiagnostic` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type BillingDiagnosticCondition = {
  /** Checks for equality with the object’s `billingDiagnosticsId` field. */
  billingDiagnosticsId?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `encounterTaskId` field. */
  encounterTaskId?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `procedureCodeReferenceId` field. */
  procedureCodeReferenceId?: InputMaybe<Scalars['Int']>;
};

/** A connection to a list of `BillingDiagnostic` values. */
export type BillingDiagnosticsConnection = {
  __typename: 'BillingDiagnosticsConnection';
  /** A list of edges which contains the `BillingDiagnostic` and cursor to aid in pagination. */
  edges: Array<BillingDiagnosticsEdge>;
  /** A list of `BillingDiagnostic` objects. */
  nodes: Array<BillingDiagnostic>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `BillingDiagnostic` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `BillingDiagnostic` edge in the connection. */
export type BillingDiagnosticsEdge = {
  __typename: 'BillingDiagnosticsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `BillingDiagnostic` at the end of the edge. */
  node: BillingDiagnostic;
};

/** Methods to use when ordering `BillingDiagnostic`. */
export enum BillingDiagnosticsOrderBy {
  BILLING_DIAGNOSTICS_ID_ASC = 'BILLING_DIAGNOSTICS_ID_ASC',
  BILLING_DIAGNOSTICS_ID_DESC = 'BILLING_DIAGNOSTICS_ID_DESC',
  ENCOUNTER_TASK_ID_ASC = 'ENCOUNTER_TASK_ID_ASC',
  ENCOUNTER_TASK_ID_DESC = 'ENCOUNTER_TASK_ID_DESC',
  NATURAL = 'NATURAL',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  PROCEDURE_CODE_REFERENCE_ID_ASC = 'PROCEDURE_CODE_REFERENCE_ID_ASC',
  PROCEDURE_CODE_REFERENCE_ID_DESC = 'PROCEDURE_CODE_REFERENCE_ID_DESC'
}

/** All input for the `CancelAppointmentByGlobalId` mutation. */
export type CancelAppointmentByGlobalIdInput = {
  cancelledReason: CancellationReasonEnum;
  cancelledReasonOther?: InputMaybe<Scalars['String']>;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  globalId: Scalars['String'];
  systemLastUpdatedBy?: InputMaybe<SystemOfOriginEnum>;
};

/** All input for the `CancelAppointment` mutation. */
export type CancelAppointmentInput = {
  appointmentId: Scalars['Int'];
  cancelledReason: CancellationReasonEnum;
  cancelledReasonOther?: InputMaybe<Scalars['String']>;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  systemLastUpdatedBy?: InputMaybe<SystemOfOriginEnum>;
};

/** The output of our `CancelAppointment` mutation. */
export type CancelAppointmentPayload = {
  __typename: 'CancelAppointmentPayload';
  appointment?: Maybe<Appointment>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

export type CancelEncountersInput = {
  cancellationReason: CancellationReasonEnum;
  cancellationReasonOther?: InputMaybe<Scalars['String']>;
  encounterIds?: InputMaybe<Array<Scalars['Int']>>;
};

export enum CancellationReasonEnum {
  CALL_ERROR = 'CALL_ERROR',
  CAPACITY_RELATED = 'CAPACITY_RELATED',
  COVID_RESULT_SPEED = 'COVID_RESULT_SPEED',
  FINANCIAL = 'FINANCIAL',
  NO_CALL_NO_SHOW = 'NO_CALL_NO_SHOW',
  OTHER = 'OTHER',
  PATIENT_CHANGED_MIND = 'PATIENT_CHANGED_MIND',
  PATIENT_CONDITION_IMPROVED = 'PATIENT_CONDITION_IMPROVED',
  PATIENT_WAIT_TIME = 'PATIENT_WAIT_TIME',
  REFUSED_RESCHEDULING = 'REFUSED_RESCHEDULING',
  SERVICES_NOT_AVAILABLE = 'SERVICES_NOT_AVAILABLE',
  SOUGHT_CARE_ELSEWHERE = 'SOUGHT_CARE_ELSEWHERE',
  TEST_CALL = 'TEST_CALL',
  TEXT_CANCELLATION = 'TEXT_CANCELLATION',
  TIME_NO_LONGER_WORKS = 'TIME_NO_LONGER_WORKS'
}

/** Contains contains information about the cer role and mapping to user relation. */
export type CerRole = Node & {
  __typename: 'CerRole';
  isDeleted?: Maybe<Scalars['Boolean']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  updatedAt?: Maybe<Scalars['Datetime']>;
  updatedBy?: Maybe<Scalars['Int']>;
  /** Reads a single `User` that is related to this `CerRole`. */
  user?: Maybe<User>;
  userId: Scalars['Int'];
};

/** A condition to be used against `CerRole` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type CerRoleCondition = {
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars['Int']>;
};

/** A connection to a list of `CerRole` values. */
export type CerRolesConnection = {
  __typename: 'CerRolesConnection';
  /** A list of edges which contains the `CerRole` and cursor to aid in pagination. */
  edges: Array<CerRolesEdge>;
  /** A list of `CerRole` objects. */
  nodes: Array<CerRole>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `CerRole` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `CerRole` edge in the connection. */
export type CerRolesEdge = {
  __typename: 'CerRolesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `CerRole` at the end of the edge. */
  node: CerRole;
};

/** Methods to use when ordering `CerRole`. */
export enum CerRolesOrderBy {
  NATURAL = 'NATURAL',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  USER_ID_ASC = 'USER_ID_ASC',
  USER_ID_DESC = 'USER_ID_DESC'
}

/** Contains information about channel attribution */
export type ChannelAttribution = Node & {
  __typename: 'ChannelAttribution';
  channel: Scalars['String'];
  channelAttributionId: Scalars['Int'];
  createdAt: Scalars['Datetime'];
  createdBy?: Maybe<Scalars['Int']>;
  createdByClientUuid?: Maybe<Scalars['UUID']>;
  deletedAt?: Maybe<Scalars['Datetime']>;
  deletedBy?: Maybe<Scalars['Int']>;
  deletedByClientUuid?: Maybe<Scalars['UUID']>;
  globalId: Scalars['UUID'];
  institutionType: ChannelAttributionInstitutionTypeEnum;
  isDeleted: Scalars['Boolean'];
  /** List of Markets for a `ChannelAttribution`. */
  markets?: Maybe<Array<Maybe<Market>>>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  referralType?: Maybe<ChannelAttributionReferralTypeEnum>;
  tagSystem: ChannelAttributionTagSystemEnum;
  trackingNumber?: Maybe<Scalars['String']>;
};

/**
 * A condition to be used against `ChannelAttribution` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type ChannelAttributionCondition = {
  /** Checks for equality with the object’s `channelAttributionId` field. */
  channelAttributionId?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `globalId` field. */
  globalId?: InputMaybe<Scalars['UUID']>;
  /** Filters on records matching `isDeleted` */
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  /** Filters on records matching `marketId` */
  marketId?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Filters on records matching `tagSystem` */
  tagSystem?: InputMaybe<ChannelAttributionTagSystemConditionEnum>;
  /** Filters on records matching `trackingNumber` */
  trackingNumber?: InputMaybe<Scalars['String']>;
};

export enum ChannelAttributionInstitutionTypeEnum {
  COMMUNITY_BASED_ORGANIZATION = 'COMMUNITY_BASED_ORGANIZATION',
  EMPLOYER = 'EMPLOYER',
  EMS = 'EMS',
  GOVERNMENT = 'GOVERNMENT',
  HEALTH_PLAN = 'HEALTH_PLAN',
  HEALTH_SYSTEM = 'HEALTH_SYSTEM',
  HOME_CARE = 'HOME_CARE',
  MARKETING = 'MARKETING',
  PRIMARY_CARE = 'PRIMARY_CARE',
  PRIVATE_BUSINESS = 'PRIVATE_BUSINESS',
  SPECIALIST_GROUP = 'SPECIALIST_GROUP',
  TRAINING = 'TRAINING',
  UNKNOWN = 'UNKNOWN'
}

export enum ChannelAttributionReferralTypeEnum {
  CLINICAL_REFERRAL = 'CLINICAL_REFERRAL',
  DNE = 'DNE',
  EMPLOYER_REFERRAL = 'EMPLOYER_REFERRAL',
  PATIENT_MARKETING = 'PATIENT_MARKETING'
}

export enum ChannelAttributionTagSystemConditionEnum {
  CALLRAIL = 'CALLRAIL',
  MANUAL = 'MANUAL'
}

export enum ChannelAttributionTagSystemEnum {
  CALLRAIL = 'CALLRAIL',
  MANUAL = 'MANUAL'
}

/** A connection to a list of `ChannelAttribution` values. */
export type ChannelAttributionsConnection = {
  __typename: 'ChannelAttributionsConnection';
  /** A list of edges which contains the `ChannelAttribution` and cursor to aid in pagination. */
  edges: Array<ChannelAttributionsEdge>;
  /** A list of `ChannelAttribution` objects. */
  nodes: Array<ChannelAttribution>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ChannelAttribution` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `ChannelAttribution` edge in the connection. */
export type ChannelAttributionsEdge = {
  __typename: 'ChannelAttributionsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `ChannelAttribution` at the end of the edge. */
  node: ChannelAttribution;
};

/** Methods to use when ordering `ChannelAttribution`. */
export enum ChannelAttributionsOrderBy {
  CHANNEL_ATTRIBUTION_ID_ASC = 'CHANNEL_ATTRIBUTION_ID_ASC',
  CHANNEL_ATTRIBUTION_ID_DESC = 'CHANNEL_ATTRIBUTION_ID_DESC',
  GLOBAL_ID_ASC = 'GLOBAL_ID_ASC',
  GLOBAL_ID_DESC = 'GLOBAL_ID_DESC',
  NATURAL = 'NATURAL',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC'
}

/** Contains data related to Chief Complaint and Histoy of Present Illness */
export type ChiefComplaintAndHpi = Node & {
  __typename: 'ChiefComplaintAndHpi';
  chiefComplaint?: Maybe<Scalars['String']>;
  chiefComplaintAndHpiId: Scalars['Int'];
  createdAt: Scalars['Datetime'];
  deletedAt?: Maybe<Scalars['Datetime']>;
  /** Reads a single `EncounterTask` that is related to this `ChiefComplaintAndHpi`. */
  encounterTask?: Maybe<EncounterTask>;
  encounterTaskId: Scalars['Int'];
  historyOfPresentIllness?: Maybe<Scalars['String']>;
  isDeleted: Scalars['Boolean'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  updatedAt: Scalars['Datetime'];
};

/**
 * A condition to be used against `ChiefComplaintAndHpi` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type ChiefComplaintAndHpiCondition = {
  /** Checks for equality with the object’s `chiefComplaintAndHpiId` field. */
  chiefComplaintAndHpiId?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `encounterTaskId` field. */
  encounterTaskId?: InputMaybe<Scalars['Int']>;
};

/** A connection to a list of `ChiefComplaintAndHpi` values. */
export type ChiefComplaintAndHpisConnection = {
  __typename: 'ChiefComplaintAndHpisConnection';
  /** A list of edges which contains the `ChiefComplaintAndHpi` and cursor to aid in pagination. */
  edges: Array<ChiefComplaintAndHpisEdge>;
  /** A list of `ChiefComplaintAndHpi` objects. */
  nodes: Array<ChiefComplaintAndHpi>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ChiefComplaintAndHpi` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `ChiefComplaintAndHpi` edge in the connection. */
export type ChiefComplaintAndHpisEdge = {
  __typename: 'ChiefComplaintAndHpisEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `ChiefComplaintAndHpi` at the end of the edge. */
  node: ChiefComplaintAndHpi;
};

/** Methods to use when ordering `ChiefComplaintAndHpi`. */
export enum ChiefComplaintAndHpisOrderBy {
  CHIEF_COMPLAINT_AND_HPI_ID_ASC = 'CHIEF_COMPLAINT_AND_HPI_ID_ASC',
  CHIEF_COMPLAINT_AND_HPI_ID_DESC = 'CHIEF_COMPLAINT_AND_HPI_ID_DESC',
  ENCOUNTER_TASK_ID_ASC = 'ENCOUNTER_TASK_ID_ASC',
  ENCOUNTER_TASK_ID_DESC = 'ENCOUNTER_TASK_ID_DESC',
  NATURAL = 'NATURAL',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC'
}

export type ClaimEncounterInput = {
  encounterId: Scalars['Int'];
};

export type ClaimEncounterPayload = {
  __typename: 'ClaimEncounterPayload';
  encounter?: Maybe<Encounter>;
};

export type Clinic = Node & {
  __typename: 'Clinic';
  address?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  clinicId: Scalars['Int'];
  dosespotClinicId?: Maybe<Scalars['String']>;
  dosespotClinicKey?: Maybe<Scalars['String']>;
  fax?: Maybe<Scalars['String']>;
  isDeleted: Scalars['Boolean'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  phone?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  updatedAt: Scalars['Datetime'];
  updatedBy: Scalars['Int'];
  zipcode?: Maybe<Scalars['String']>;
};

/** A condition to be used against `Clinic` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type ClinicCondition = {
  /** Checks for equality with the object’s `address` field. */
  address?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `clinicId` field. */
  clinicId?: InputMaybe<Scalars['Int']>;
};

/** An input for mutations affecting `Clinic` */
export type ClinicInput = {
  address?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  dosespotClinicId?: InputMaybe<Scalars['String']>;
  dosespotClinicKey?: InputMaybe<Scalars['String']>;
  fax?: InputMaybe<Scalars['String']>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  phone?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  updatedBy: Scalars['Int'];
  zipcode?: InputMaybe<Scalars['String']>;
};

/** Represents an update to a `Clinic`. Fields that are set will be updated. */
export type ClinicPatch = {
  address?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  dosespotClinicId?: InputMaybe<Scalars['String']>;
  dosespotClinicKey?: InputMaybe<Scalars['String']>;
  fax?: InputMaybe<Scalars['String']>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  phone?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  updatedBy?: InputMaybe<Scalars['Int']>;
  zipcode?: InputMaybe<Scalars['String']>;
};

/** Contains contains information about the clinician role and mapping to user relation. */
export type ClinicianRole = Node & {
  __typename: 'ClinicianRole';
  deputyId?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  redoxId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['Datetime']>;
  updatedBy?: Maybe<Scalars['Int']>;
  /** Reads a single `User` that is related to this `ClinicianRole`. */
  user?: Maybe<User>;
  userId: Scalars['Int'];
};

/**
 * A condition to be used against `ClinicianRole` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type ClinicianRoleCondition = {
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars['Int']>;
};

/** A connection to a list of `ClinicianRole` values. */
export type ClinicianRolesConnection = {
  __typename: 'ClinicianRolesConnection';
  /** A list of edges which contains the `ClinicianRole` and cursor to aid in pagination. */
  edges: Array<ClinicianRolesEdge>;
  /** A list of `ClinicianRole` objects. */
  nodes: Array<ClinicianRole>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ClinicianRole` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `ClinicianRole` edge in the connection. */
export type ClinicianRolesEdge = {
  __typename: 'ClinicianRolesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `ClinicianRole` at the end of the edge. */
  node: ClinicianRole;
};

/** Methods to use when ordering `ClinicianRole`. */
export enum ClinicianRolesOrderBy {
  NATURAL = 'NATURAL',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  USER_ID_ASC = 'USER_ID_ASC',
  USER_ID_DESC = 'USER_ID_DESC'
}

/** A connection to a list of `Clinic` values. */
export type ClinicsConnection = {
  __typename: 'ClinicsConnection';
  /** A list of edges which contains the `Clinic` and cursor to aid in pagination. */
  edges: Array<ClinicsEdge>;
  /** A list of `Clinic` objects. */
  nodes: Array<Clinic>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Clinic` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Clinic` edge in the connection. */
export type ClinicsEdge = {
  __typename: 'ClinicsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `Clinic` at the end of the edge. */
  node: Clinic;
};

/** Methods to use when ordering `Clinic`. */
export enum ClinicsOrderBy {
  ADDRESS_ASC = 'ADDRESS_ASC',
  ADDRESS_DESC = 'ADDRESS_DESC',
  CLINIC_ID_ASC = 'CLINIC_ID_ASC',
  CLINIC_ID_DESC = 'CLINIC_ID_DESC',
  NATURAL = 'NATURAL',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC'
}

export type CodeSystem = Node & {
  __typename: 'CodeSystem';
  codeSystemId: Scalars['Int'];
  name: Scalars['String'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  oid?: Maybe<Scalars['String']>;
  version?: Maybe<Scalars['String']>;
};

/**
 * A condition to be used against `CodeSystem` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type CodeSystemCondition = {
  /** Checks for equality with the object’s `codeSystemId` field. */
  codeSystemId?: InputMaybe<Scalars['Int']>;
};

/** An input for mutations affecting `CodeSystem` */
export type CodeSystemInput = {
  name: Scalars['String'];
  oid?: InputMaybe<Scalars['String']>;
  version?: InputMaybe<Scalars['String']>;
};

/** Represents an update to a `CodeSystem`. Fields that are set will be updated. */
export type CodeSystemPatch = {
  name?: InputMaybe<Scalars['String']>;
  oid?: InputMaybe<Scalars['String']>;
  version?: InputMaybe<Scalars['String']>;
};

/** A connection to a list of `CodeSystem` values. */
export type CodeSystemsConnection = {
  __typename: 'CodeSystemsConnection';
  /** A list of edges which contains the `CodeSystem` and cursor to aid in pagination. */
  edges: Array<CodeSystemsEdge>;
  /** A list of `CodeSystem` objects. */
  nodes: Array<CodeSystem>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `CodeSystem` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `CodeSystem` edge in the connection. */
export type CodeSystemsEdge = {
  __typename: 'CodeSystemsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `CodeSystem` at the end of the edge. */
  node: CodeSystem;
};

/** Methods to use when ordering `CodeSystem`. */
export enum CodeSystemsOrderBy {
  CODE_SYSTEM_ID_ASC = 'CODE_SYSTEM_ID_ASC',
  CODE_SYSTEM_ID_DESC = 'CODE_SYSTEM_ID_DESC',
  NATURAL = 'NATURAL',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC'
}

export enum CommunicationNeedEnum {
  BLIND = 'BLIND',
  BRAIL = 'BRAIL',
  DEAF = 'DEAF',
  LIP_READER = 'LIP_READER',
  NONE = 'NONE',
  SIGN_LANGUAGE = 'SIGN_LANGUAGE',
  TRANSLATOR_INTERPRETER = 'TRANSLATOR_INTERPRETER'
}

export type CreateAddendumAttachmentImageInput = {
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  url?: InputMaybe<Scalars['String']>;
};

export type CreateAddendumAttachmentInput = {
  images?: InputMaybe<Array<InputMaybe<CreateAddendumAttachmentImageInput>>>;
  title?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<AddendumAttachmentTypeEnum>;
};

export type CreateAddendumInput = {
  attachments?: InputMaybe<Array<InputMaybe<CreateAddendumAttachmentInput>>>;
  encounterId: Scalars['Int'];
  note: Scalars['String'];
  userId: Scalars['Int'];
};

export type CreateAddendumPayload = {
  __typename: 'CreateAddendumPayload';
  addendum?: Maybe<Addendum>;
  clientMutationId?: Maybe<Scalars['String']>;
  encounter?: Maybe<Encounter>;
  query?: Maybe<Query>;
};

/** All input for the create `AppointmentDispatch` mutation. */
export type CreateAppointmentDispatchInput = {
  /** The `AppointmentDispatch` to be created by this mutation. */
  appointmentDispatch: AppointmentDispatchInput;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

/** The output of our create `AppointmentDispatch` mutation. */
export type CreateAppointmentDispatchPayload = {
  __typename: 'CreateAppointmentDispatchPayload';
  /** Reads a single `Appointment` that is related to this `AppointmentDispatch`. */
  appointment?: Maybe<Appointment>;
  /** The `AppointmentDispatch` that was created by this mutation. */
  appointmentDispatch?: Maybe<AppointmentDispatch>;
  /** An edge for our `AppointmentDispatch`. May be used by Relay 1. */
  appointmentDispatchEdge?: Maybe<AppointmentDispatchesEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `ResponderRole` that is related to this `AppointmentDispatch`. */
  responder?: Maybe<ResponderRole>;
};


/** The output of our create `AppointmentDispatch` mutation. */
export type CreateAppointmentDispatchPayloadappointmentDispatchEdgeArgs = {
  orderBy?: InputMaybe<Array<AppointmentDispatchesOrderBy>>;
};

/** All input for the `createAppointment` mutation. */
export type CreateAppointmentInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  input: CreateAppointmentInputRecordInput;
};

/** An input for mutations affecting `CreateAppointmentInputRecord` */
export type CreateAppointmentInputRecordInput = {
  address1: Scalars['NonNullableText'];
  address2?: InputMaybe<Scalars['String']>;
  addressLat?: InputMaybe<Scalars['Float']>;
  addressLng?: InputMaybe<Scalars['Float']>;
  availabilityOverride?: InputMaybe<Scalars['Boolean']>;
  city?: InputMaybe<Scalars['String']>;
  contactName: Scalars['NonNullableText'];
  createdBy?: InputMaybe<Scalars['Int']>;
  encounters?: InputMaybe<Array<InputMaybe<CreateEncounterInputRecordInput>>>;
  estimatedDuration?: InputMaybe<Scalars['String']>;
  marketId: Scalars['NonNullableInt'];
  marketOverride?: InputMaybe<Scalars['Boolean']>;
  partnership?: InputMaybe<Scalars['String']>;
  primaryPhone: Scalars['NonNullablePhoneNumber'];
  scheduledFor: Scalars['NonNullableTimestamptz'];
  source?: InputMaybe<Scalars['String']>;
  specialInstructions?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  systemOfOrigin: NonNullableSystemOfOrigin;
  unit?: InputMaybe<Scalars['String']>;
  zipCode: Scalars['NonNullableUsPostalCode'];
  zoneId: Scalars['NonNullableInt'];
};

/** The output of our `createAppointment` mutation. */
export type CreateAppointmentPayload = {
  __typename: 'CreateAppointmentPayload';
  appointment?: Maybe<Appointment>;
  /** An edge for our `Appointment`. May be used by Relay 1. */
  appointmentEdge?: Maybe<AppointmentsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Market` that is related to this `Appointment`. */
  market?: Maybe<Market>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `Appointment`. */
  userByCreatedBy?: Maybe<User>;
};


/** The output of our `createAppointment` mutation. */
export type CreateAppointmentPayloadappointmentEdgeArgs = {
  orderBy?: InputMaybe<Array<AppointmentsOrderBy>>;
};

/** All input for the create `AppointmentTag` mutation. */
export type CreateAppointmentTagInput = {
  /** The `AppointmentTag` to be created by this mutation. */
  appointmentTag: AppointmentTagInput;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

/** The output of our create `AppointmentTag` mutation. */
export type CreateAppointmentTagPayload = {
  __typename: 'CreateAppointmentTagPayload';
  /** The `AppointmentTag` that was created by this mutation. */
  appointmentTag?: Maybe<AppointmentTag>;
  /** An edge for our `AppointmentTag`. May be used by Relay 1. */
  appointmentTagEdge?: Maybe<AppointmentTagsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `AppointmentTag` mutation. */
export type CreateAppointmentTagPayloadappointmentTagEdgeArgs = {
  orderBy?: InputMaybe<Array<AppointmentTagsOrderBy>>;
};

/** All input for the `CreateChannelAttribution` mutation. */
export type CreateChannelAttributionInput = {
  channel: Scalars['String'];
  globalId?: InputMaybe<Scalars['UUID']>;
  institutionType: ChannelAttributionInstitutionTypeEnum;
  marketIds: Array<InputMaybe<Scalars['Int']>>;
  referralType?: InputMaybe<ChannelAttributionReferralTypeEnum>;
  tagSystem: ChannelAttributionTagSystemEnum;
  trackingNumber?: InputMaybe<Scalars['String']>;
};

/** All input for the create `Clinic` mutation. */
export type CreateClinicInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `Clinic` to be created by this mutation. */
  clinic: ClinicInput;
};

/** The output of our create `Clinic` mutation. */
export type CreateClinicPayload = {
  __typename: 'CreateClinicPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `Clinic` that was created by this mutation. */
  clinic?: Maybe<Clinic>;
  /** An edge for our `Clinic`. May be used by Relay 1. */
  clinicEdge?: Maybe<ClinicsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `Clinic` mutation. */
export type CreateClinicPayloadclinicEdgeArgs = {
  orderBy?: InputMaybe<Array<ClinicsOrderBy>>;
};

export type CreateClinicianEncounterSignatureInput = {
  encounterId: Scalars['Int'];
  userId: Scalars['Int'];
};

/** All input for the create `CodeSystem` mutation. */
export type CreateCodeSystemInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `CodeSystem` to be created by this mutation. */
  codeSystem: CodeSystemInput;
};

/** The output of our create `CodeSystem` mutation. */
export type CreateCodeSystemPayload = {
  __typename: 'CreateCodeSystemPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `CodeSystem` that was created by this mutation. */
  codeSystem?: Maybe<CodeSystem>;
  /** An edge for our `CodeSystem`. May be used by Relay 1. */
  codeSystemEdge?: Maybe<CodeSystemsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `CodeSystem` mutation. */
export type CreateCodeSystemPayloadcodeSystemEdgeArgs = {
  orderBy?: InputMaybe<Array<CodeSystemsOrderBy>>;
};

/** An input for mutations affecting `CreateEncounterInputRecord` */
export type CreateEncounterInputRecordInput = {
  channelAttributionId?: InputMaybe<Scalars['Int']>;
  genderRequirement?: InputMaybe<SexEnum>;
  modules?: InputMaybe<Array<InputMaybe<ModuleNameEnum>>>;
  noInsuranceReason?: InputMaybe<NoInsuranceReasonEnum>;
  patientId: Scalars['NonNullableInt'];
  paymentMode?: InputMaybe<EncounterPaymentModeEnum>;
  primaryInsurance?: InputMaybe<CreateInsuranceRecordInputRecordInput>;
  primaryInsuranceId?: InputMaybe<Scalars['Int']>;
  reasonForEncounter: Scalars['NonNullableText'];
  secondaryInsurance?: InputMaybe<CreateInsuranceRecordInputRecordInput>;
  secondaryInsuranceId?: InputMaybe<Scalars['Int']>;
  serviceLineId: Scalars['NonNullableInt'];
  stripeId?: InputMaybe<Scalars['String']>;
  systemLastUpdatedBy?: InputMaybe<SystemOfOriginEnum>;
};

/** All input for the create `EncounterSignature` mutation. */
export type CreateEncounterSignatureInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `EncounterSignature` to be created by this mutation. */
  encounterSignature: EncounterSignatureInput;
};

/** The output of our create `EncounterSignature` mutation. */
export type CreateEncounterSignaturePayload = {
  __typename: 'CreateEncounterSignaturePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Encounter` that is related to this `EncounterSignature`. */
  encounter?: Maybe<Encounter>;
  /** The `EncounterSignature` that was created by this mutation. */
  encounterSignature?: Maybe<EncounterSignature>;
  /** An edge for our `EncounterSignature`. May be used by Relay 1. */
  encounterSignatureEdge?: Maybe<EncounterSignaturesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `EncounterSignature` mutation. */
export type CreateEncounterSignaturePayloadencounterSignatureEdgeArgs = {
  orderBy?: InputMaybe<Array<EncounterSignaturesOrderBy>>;
};

/** All input for the create `EncounterTaskAttachment` mutation. */
export type CreateEncounterTaskAttachmentInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `EncounterTaskAttachment` to be created by this mutation. */
  encounterTaskAttachment: EncounterTaskAttachmentInput;
};

/** The output of our create `EncounterTaskAttachment` mutation. */
export type CreateEncounterTaskAttachmentPayload = {
  __typename: 'CreateEncounterTaskAttachmentPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `EncounterTask` that is related to this `EncounterTaskAttachment`. */
  encounterTask?: Maybe<EncounterTask>;
  /** The `EncounterTaskAttachment` that was created by this mutation. */
  encounterTaskAttachment?: Maybe<EncounterTaskAttachment>;
  /** An edge for our `EncounterTaskAttachment`. May be used by Relay 1. */
  encounterTaskAttachmentEdge?: Maybe<EncounterTaskAttachmentsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `EncounterTaskAttachment` mutation. */
export type CreateEncounterTaskAttachmentPayloadencounterTaskAttachmentEdgeArgs = {
  orderBy?: InputMaybe<Array<EncounterTaskAttachmentsOrderBy>>;
};

/** All input for the create `FeatureGate` mutation. */
export type CreateFeatureGateInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `FeatureGate` to be created by this mutation. */
  featureGate: FeatureGateInput;
};

/** The output of our create `FeatureGate` mutation. */
export type CreateFeatureGatePayload = {
  __typename: 'CreateFeatureGatePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `FeatureGate` that was created by this mutation. */
  featureGate?: Maybe<FeatureGate>;
  /** An edge for our `FeatureGate`. May be used by Relay 1. */
  featureGateEdge?: Maybe<FeatureGatesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `FeatureGate` mutation. */
export type CreateFeatureGatePayloadfeatureGateEdgeArgs = {
  orderBy?: InputMaybe<Array<FeatureGatesOrderBy>>;
};

/** All input for the create `InsuranceRecord` mutation. */
export type CreateInsuranceRecordInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `InsuranceRecord` to be created by this mutation. */
  insuranceRecord: InsuranceRecordInput;
};

/** An input for mutations affecting `CreateInsuranceRecordInputRecord` */
export type CreateInsuranceRecordInputRecordInput = {
  address1?: InputMaybe<Scalars['String']>;
  address2?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  company?: InputMaybe<Scalars['String']>;
  groupNumber?: InputMaybe<Scalars['String']>;
  memberId?: InputMaybe<Scalars['String']>;
  noInsuranceCards?: InputMaybe<Scalars['Boolean']>;
  packageId?: InputMaybe<Scalars['String']>;
  planType?: InputMaybe<Scalars['String']>;
  policyHolderDob?: InputMaybe<Scalars['Date']>;
  policyHolderFirstName?: InputMaybe<Scalars['String']>;
  policyHolderGender?: InputMaybe<SexEnum>;
  policyHolderLastName?: InputMaybe<Scalars['String']>;
  relationshipToPolicyHolder?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  systemLastUpdatedBy?: InputMaybe<SystemOfOriginEnum>;
  zip?: InputMaybe<Scalars['UsPostalCode']>;
};

/** The output of our create `InsuranceRecord` mutation. */
export type CreateInsuranceRecordPayload = {
  __typename: 'CreateInsuranceRecordPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `InsuranceRecord` that was created by this mutation. */
  insuranceRecord?: Maybe<InsuranceRecord>;
  /** An edge for our `InsuranceRecord`. May be used by Relay 1. */
  insuranceRecordEdge?: Maybe<InsuranceRecordsEdge>;
  /** Reads a single `Patient` that is related to this `InsuranceRecord`. */
  patient?: Maybe<Patient>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `InsuranceRecord` mutation. */
export type CreateInsuranceRecordPayloadinsuranceRecordEdgeArgs = {
  orderBy?: InputMaybe<Array<InsuranceRecordsOrderBy>>;
};

/** All input for the create `MarketClinic` mutation. */
export type CreateMarketClinicInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `MarketClinic` to be created by this mutation. */
  marketClinic: MarketClinicInput;
};

/** The output of our create `MarketClinic` mutation. */
export type CreateMarketClinicPayload = {
  __typename: 'CreateMarketClinicPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Market` that is related to this `MarketClinic`. */
  market?: Maybe<Market>;
  /** The `MarketClinic` that was created by this mutation. */
  marketClinic?: Maybe<MarketClinic>;
  /** An edge for our `MarketClinic`. May be used by Relay 1. */
  marketClinicEdge?: Maybe<MarketClinicsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `MarketClinic` mutation. */
export type CreateMarketClinicPayloadmarketClinicEdgeArgs = {
  orderBy?: InputMaybe<Array<MarketClinicsOrderBy>>;
};

/** All input for the create `MedicalDirector` mutation. */
export type CreateMedicalDirectorInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `MedicalDirector` to be created by this mutation. */
  medicalDirector: MedicalDirectorInput;
};

/** The output of our create `MedicalDirector` mutation. */
export type CreateMedicalDirectorPayload = {
  __typename: 'CreateMedicalDirectorPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `MedicalDirector` that was created by this mutation. */
  medicalDirector?: Maybe<MedicalDirector>;
  /** An edge for our `MedicalDirector`. May be used by Relay 1. */
  medicalDirectorEdge?: Maybe<MedicalDirectorsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `MedicalDirector` mutation. */
export type CreateMedicalDirectorPayloadmedicalDirectorEdgeArgs = {
  orderBy?: InputMaybe<Array<MedicalDirectorsOrderBy>>;
};

/** All input for the `createPatientForm` mutation. */
export type CreatePatientFormInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  encounterTaskId?: InputMaybe<Scalars['Int']>;
  fieldResponse?: InputMaybe<Scalars['JSON']>;
  fieldResponseJson?: InputMaybe<Scalars['JSON']>;
  formstackId?: InputMaybe<Scalars['Int']>;
  patientFormLookupId?: InputMaybe<Scalars['Int']>;
  signedAt?: InputMaybe<Scalars['Datetime']>;
};

/** The output of our `createPatientForm` mutation. */
export type CreatePatientFormPayload = {
  __typename: 'CreatePatientFormPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  patientForm?: Maybe<PatientForm>;
  /** An edge for our `PatientForm`. May be used by Relay 1. */
  patientFormEdge?: Maybe<PatientFormsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our `createPatientForm` mutation. */
export type CreatePatientFormPayloadpatientFormEdgeArgs = {
  orderBy?: InputMaybe<Array<PatientFormsOrderBy>>;
};

/** All input for the `createPatient` mutation. */
export type CreatePatientInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  patient: PatientInputRecordInput;
};

/** All input for the `createPatientNote` mutation. */
export type CreatePatientNoteInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  patientNote: PatientNoteInputRecordInput;
};

/** The output of our `createPatientNote` mutation. */
export type CreatePatientNotePayload = {
  __typename: 'CreatePatientNotePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Patient` that is related to this `PatientNote`. */
  patient?: Maybe<Patient>;
  patientNote?: Maybe<PatientNote>;
  /** An edge for our `PatientNote`. May be used by Relay 1. */
  patientNoteEdge?: Maybe<PatientNotesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `PatientNote`. */
  userByCreatedBy?: Maybe<User>;
};


/** The output of our `createPatientNote` mutation. */
export type CreatePatientNotePayloadpatientNoteEdgeArgs = {
  orderBy?: InputMaybe<Array<PatientNotesOrderBy>>;
};

/** The output of our `createPatient` mutation. */
export type CreatePatientPayload = {
  __typename: 'CreatePatientPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** A ReadyCoreStatusCodeEnum indicating the result status of the operation. */
  code?: Maybe<ReadyCoreStatusCodeEnum>;
  /**
   * A status message indicating if the operation was successful, or the reason
   * for failure.
   */
  msg?: Maybe<Scalars['String']>;
  patient?: Maybe<Patient>;
  /** An edge for our `Patient`. May be used by Relay 1. */
  patientEdge?: Maybe<PatientsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our `createPatient` mutation. */
export type CreatePatientPayloadpatientEdgeArgs = {
  orderBy?: InputMaybe<Array<PatientsOrderBy>>;
};

/** All input for the create `PhysicalExam` mutation. */
export type CreatePhysicalExamInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `PhysicalExam` to be created by this mutation. */
  physicalExam: PhysicalExamInput;
};

/** The output of our create `PhysicalExam` mutation. */
export type CreatePhysicalExamPayload = {
  __typename: 'CreatePhysicalExamPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `PhysicalExam` that was created by this mutation. */
  physicalExam?: Maybe<PhysicalExam>;
  /** An edge for our `PhysicalExam`. May be used by Relay 1. */
  physicalExamEdge?: Maybe<PhysicalExamsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `PhysicalExam` mutation. */
export type CreatePhysicalExamPayloadphysicalExamEdgeArgs = {
  orderBy?: InputMaybe<Array<PhysicalExamsOrderBy>>;
};

export type CreateResponderEncounterSignatureInput = {
  encounterId: Scalars['Int'];
  userId: Scalars['Int'];
};

export type CreateSkeduloAppointmentInput = {
  address1: Scalars['String'];
  addressLat: Scalars['Float'];
  addressLng: Scalars['Float'];
  callRailNumber?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  contactName: Scalars['String'];
  createdBy?: InputMaybe<Scalars['Int']>;
  date?: InputMaybe<Scalars['Date']>;
  duration?: InputMaybe<Scalars['Int']>;
  forceScheduling: Scalars['Boolean'];
  jobTags?: InputMaybe<Array<InputMaybe<JobTagsInput>>>;
  jobType?: InputMaybe<Scalars['String']>;
  marketId: Scalars['Int'];
  marketOverride: Scalars['Boolean'];
  primaryPhone: Scalars['String'];
  resourceRequired?: InputMaybe<Scalars['Int']>;
  specialInstructions?: InputMaybe<Scalars['String']>;
  startTimes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  state?: InputMaybe<Scalars['String']>;
  systemOfOrigin: SystemOfOriginEnum;
  unit?: InputMaybe<Scalars['String']>;
  zipCode: Scalars['NonNullableUsPostalCode'];
  zoneId: Scalars['Int'];
};

export type CreateSkeduloInsuranceInput = {
  company: Scalars['String'];
  groupNumber?: InputMaybe<Scalars['String']>;
  memberId: Scalars['String'];
  packageId?: InputMaybe<Scalars['String']>;
  planType?: InputMaybe<Scalars['String']>;
  policyHolderDob?: InputMaybe<Scalars['Date']>;
  policyHolderFirstName?: InputMaybe<Scalars['String']>;
  policyHolderGender?: InputMaybe<SexEnum>;
  policyHolderLastName?: InputMaybe<Scalars['String']>;
  relationshipToPolicyHolder?: InputMaybe<Scalars['String']>;
};

export type CreateSkeduloPatientInput = {
  dob?: InputMaybe<Scalars['Date']>;
  email?: InputMaybe<Scalars['String']>;
  encounters?: InputMaybe<Array<InputMaybe<SkeduloEncounterInput>>>;
  firstName?: InputMaybe<Scalars['String']>;
  highPriorityNoteIds?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  lastName?: InputMaybe<Scalars['String']>;
  patientId?: InputMaybe<Scalars['Int']>;
  paymentMode?: InputMaybe<Scalars['Int']>;
  preferredPhoneNumber?: InputMaybe<Scalars['String']>;
  sex?: InputMaybe<SexEnum>;
};

/** All input for the `CreateStandingOrderInput` mutation. */
export type CreateStandingOrderInput = {
  clinicianId: Scalars['Int'];
  diagnosisCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  endedAt: Scalars['Datetime'];
  lookupId: Scalars['Int'];
  lookupType: StandingOrderLookupTypeEnum;
  name: Scalars['String'];
  number: Scalars['String'];
  orderUrl: Scalars['String'];
  procedureCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  startedAt: Scalars['Datetime'];
  state: StateEnum;
  version: Scalars['String'];
};

export enum CredentialsEnum {
  DO = 'DO',
  LCSW = 'LCSW',
  MD = 'MD',
  MSW = 'MSW',
  NP = 'NP',
  PA = 'PA',
  RESPONDER = 'RESPONDER'
}

/** All input for the `deleteAppointmentTagByNodeId` mutation. */
export type DeleteAppointmentTagByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `AppointmentTag` to be deleted. */
  nodeId: Scalars['ID'];
};

/** All input for the `deleteAppointmentTag` mutation. */
export type DeleteAppointmentTagInput = {
  appointmentTagId: Scalars['String'];
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

/** The output of our delete `AppointmentTag` mutation. */
export type DeleteAppointmentTagPayload = {
  __typename: 'DeleteAppointmentTagPayload';
  /** The `AppointmentTag` that was deleted by this mutation. */
  appointmentTag?: Maybe<AppointmentTag>;
  /** An edge for our `AppointmentTag`. May be used by Relay 1. */
  appointmentTagEdge?: Maybe<AppointmentTagsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedAppointmentTagNodeId?: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our delete `AppointmentTag` mutation. */
export type DeleteAppointmentTagPayloadappointmentTagEdgeArgs = {
  orderBy?: InputMaybe<Array<AppointmentTagsOrderBy>>;
};

/** All input for the `deleteClinicByNodeId` mutation. */
export type DeleteClinicByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `Clinic` to be deleted. */
  nodeId: Scalars['ID'];
};

/** All input for the `deleteClinic` mutation. */
export type DeleteClinicInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  clinicId: Scalars['Int'];
};

/** The output of our delete `Clinic` mutation. */
export type DeleteClinicPayload = {
  __typename: 'DeleteClinicPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `Clinic` that was deleted by this mutation. */
  clinic?: Maybe<Clinic>;
  /** An edge for our `Clinic`. May be used by Relay 1. */
  clinicEdge?: Maybe<ClinicsEdge>;
  deletedClinicNodeId?: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our delete `Clinic` mutation. */
export type DeleteClinicPayloadclinicEdgeArgs = {
  orderBy?: InputMaybe<Array<ClinicsOrderBy>>;
};

/** All input for the `deleteCodeSystemByNodeId` mutation. */
export type DeleteCodeSystemByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `CodeSystem` to be deleted. */
  nodeId: Scalars['ID'];
};

/** All input for the `deleteCodeSystem` mutation. */
export type DeleteCodeSystemInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  codeSystemId: Scalars['Int'];
};

/** The output of our delete `CodeSystem` mutation. */
export type DeleteCodeSystemPayload = {
  __typename: 'DeleteCodeSystemPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `CodeSystem` that was deleted by this mutation. */
  codeSystem?: Maybe<CodeSystem>;
  /** An edge for our `CodeSystem`. May be used by Relay 1. */
  codeSystemEdge?: Maybe<CodeSystemsEdge>;
  deletedCodeSystemNodeId?: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our delete `CodeSystem` mutation. */
export type DeleteCodeSystemPayloadcodeSystemEdgeArgs = {
  orderBy?: InputMaybe<Array<CodeSystemsOrderBy>>;
};

/** All input for the `deleteFeatureGateByNodeId` mutation. */
export type DeleteFeatureGateByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `FeatureGate` to be deleted. */
  nodeId: Scalars['ID'];
};

/** All input for the `deleteFeatureGate` mutation. */
export type DeleteFeatureGateInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  featureId: Scalars['String'];
};

/** The output of our delete `FeatureGate` mutation. */
export type DeleteFeatureGatePayload = {
  __typename: 'DeleteFeatureGatePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedFeatureGateNodeId?: Maybe<Scalars['ID']>;
  /** The `FeatureGate` that was deleted by this mutation. */
  featureGate?: Maybe<FeatureGate>;
  /** An edge for our `FeatureGate`. May be used by Relay 1. */
  featureGateEdge?: Maybe<FeatureGatesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our delete `FeatureGate` mutation. */
export type DeleteFeatureGatePayloadfeatureGateEdgeArgs = {
  orderBy?: InputMaybe<Array<FeatureGatesOrderBy>>;
};

/** All input for the `deleteMarketClinicByNodeId` mutation. */
export type DeleteMarketClinicByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `MarketClinic` to be deleted. */
  nodeId: Scalars['ID'];
};

/** All input for the `deleteMarketClinic` mutation. */
export type DeleteMarketClinicInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  clinicId: Scalars['Int'];
  marketId: Scalars['Int'];
};

/** The output of our delete `MarketClinic` mutation. */
export type DeleteMarketClinicPayload = {
  __typename: 'DeleteMarketClinicPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedMarketClinicNodeId?: Maybe<Scalars['ID']>;
  /** Reads a single `Market` that is related to this `MarketClinic`. */
  market?: Maybe<Market>;
  /** The `MarketClinic` that was deleted by this mutation. */
  marketClinic?: Maybe<MarketClinic>;
  /** An edge for our `MarketClinic`. May be used by Relay 1. */
  marketClinicEdge?: Maybe<MarketClinicsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our delete `MarketClinic` mutation. */
export type DeleteMarketClinicPayloadmarketClinicEdgeArgs = {
  orderBy?: InputMaybe<Array<MarketClinicsOrderBy>>;
};

/** All input for the `deleteMedicalDirectorByNodeId` mutation. */
export type DeleteMedicalDirectorByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `MedicalDirector` to be deleted. */
  nodeId: Scalars['ID'];
};

/** All input for the `deleteMedicalDirector` mutation. */
export type DeleteMedicalDirectorInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  medicalDirectorId: Scalars['Int'];
};

/** The output of our delete `MedicalDirector` mutation. */
export type DeleteMedicalDirectorPayload = {
  __typename: 'DeleteMedicalDirectorPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedMedicalDirectorNodeId?: Maybe<Scalars['ID']>;
  /** The `MedicalDirector` that was deleted by this mutation. */
  medicalDirector?: Maybe<MedicalDirector>;
  /** An edge for our `MedicalDirector`. May be used by Relay 1. */
  medicalDirectorEdge?: Maybe<MedicalDirectorsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our delete `MedicalDirector` mutation. */
export type DeleteMedicalDirectorPayloadmedicalDirectorEdgeArgs = {
  orderBy?: InputMaybe<Array<MedicalDirectorsOrderBy>>;
};

/** All input for the `deletePhysicalExamByNodeId` mutation. */
export type DeletePhysicalExamByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `PhysicalExam` to be deleted. */
  nodeId: Scalars['ID'];
};

/** All input for the `deletePhysicalExam` mutation. */
export type DeletePhysicalExamInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  physicalExamId: Scalars['Int'];
};

/** The output of our delete `PhysicalExam` mutation. */
export type DeletePhysicalExamPayload = {
  __typename: 'DeletePhysicalExamPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedPhysicalExamNodeId?: Maybe<Scalars['ID']>;
  /** The `PhysicalExam` that was deleted by this mutation. */
  physicalExam?: Maybe<PhysicalExam>;
  /** An edge for our `PhysicalExam`. May be used by Relay 1. */
  physicalExamEdge?: Maybe<PhysicalExamsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our delete `PhysicalExam` mutation. */
export type DeletePhysicalExamPayloadphysicalExamEdgeArgs = {
  orderBy?: InputMaybe<Array<PhysicalExamsOrderBy>>;
};

/** Contains Diagnosis Codes */
export type DiagnosisCodeReference = Node & {
  __typename: 'DiagnosisCodeReference';
  code: Scalars['String'];
  diagnosisCodeReferenceId: Scalars['Int'];
  /** Reads and enables pagination through a set of `EncounterTask`. */
  encounterTasksByPatientDiagnosisDiagnosisCodeReferenceIdAndEncounterTaskId: DiagnosisCodeReferenceEncounterTasksByPatientDiagnosisDiagnosisCodeReferenceIdAndEncounterTaskIdManyToManyConnection;
  /** Reads and enables pagination through a set of `EncounterTask`. */
  encounterTasksByPatientDiagnosisDiagnosisCodeReferenceIdAndEncounterTaskIdList: Array<EncounterTask>;
  endDate?: Maybe<Scalars['Datetime']>;
  isBillable: Scalars['Boolean'];
  name: Scalars['String'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  /** Reads and enables pagination through a set of `PatientDiagnosis`. */
  patientDiagnoses: PatientDiagnosesConnection;
  /** Reads and enables pagination through a set of `PatientDiagnosis`. */
  patientDiagnosesList: Array<PatientDiagnosis>;
  startDate: Scalars['Datetime'];
  system: Scalars['String'];
};


/** Contains Diagnosis Codes */
export type DiagnosisCodeReferenceencounterTasksByPatientDiagnosisDiagnosisCodeReferenceIdAndEncounterTaskIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<EncounterTaskCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EncounterTasksOrderBy>>;
};


/** Contains Diagnosis Codes */
export type DiagnosisCodeReferenceencounterTasksByPatientDiagnosisDiagnosisCodeReferenceIdAndEncounterTaskIdListArgs = {
  condition?: InputMaybe<EncounterTaskCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EncounterTasksOrderBy>>;
};


/** Contains Diagnosis Codes */
export type DiagnosisCodeReferencepatientDiagnosesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<PatientDiagnosisCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PatientDiagnosesOrderBy>>;
};


/** Contains Diagnosis Codes */
export type DiagnosisCodeReferencepatientDiagnosesListArgs = {
  condition?: InputMaybe<PatientDiagnosisCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PatientDiagnosesOrderBy>>;
};

/**
 * A condition to be used against `DiagnosisCodeReference` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type DiagnosisCodeReferenceCondition = {
  /** Checks for equality with the object’s `code` field. */
  code?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `diagnosisCodeReferenceId` field. */
  diagnosisCodeReferenceId?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `startDate` field. */
  startDate?: InputMaybe<Scalars['Datetime']>;
};

/** A connection to a list of `EncounterTask` values, with data from `PatientDiagnosis`. */
export type DiagnosisCodeReferenceEncounterTasksByPatientDiagnosisDiagnosisCodeReferenceIdAndEncounterTaskIdManyToManyConnection = {
  __typename: 'DiagnosisCodeReferenceEncounterTasksByPatientDiagnosisDiagnosisCodeReferenceIdAndEncounterTaskIdManyToManyConnection';
  /** A list of edges which contains the `EncounterTask`, info from the `PatientDiagnosis`, and the cursor to aid in pagination. */
  edges: Array<DiagnosisCodeReferenceEncounterTasksByPatientDiagnosisDiagnosisCodeReferenceIdAndEncounterTaskIdManyToManyEdge>;
  /** A list of `EncounterTask` objects. */
  nodes: Array<EncounterTask>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `EncounterTask` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `EncounterTask` edge in the connection, with data from `PatientDiagnosis`. */
export type DiagnosisCodeReferenceEncounterTasksByPatientDiagnosisDiagnosisCodeReferenceIdAndEncounterTaskIdManyToManyEdge = {
  __typename: 'DiagnosisCodeReferenceEncounterTasksByPatientDiagnosisDiagnosisCodeReferenceIdAndEncounterTaskIdManyToManyEdge';
  createdAt: Scalars['Datetime'];
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  deletedAt?: Maybe<Scalars['Datetime']>;
  isDeleted: Scalars['Boolean'];
  /** The `EncounterTask` at the end of the edge. */
  node: EncounterTask;
  order: Scalars['Int'];
  patientDiagnosisId: Scalars['Int'];
  updatedAt: Scalars['Datetime'];
};

/** A connection to a list of `DiagnosisCodeReference` values. */
export type DiagnosisCodeReferencesConnection = {
  __typename: 'DiagnosisCodeReferencesConnection';
  /** A list of edges which contains the `DiagnosisCodeReference` and cursor to aid in pagination. */
  edges: Array<DiagnosisCodeReferencesEdge>;
  /** A list of `DiagnosisCodeReference` objects. */
  nodes: Array<DiagnosisCodeReference>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `DiagnosisCodeReference` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `DiagnosisCodeReference` edge in the connection. */
export type DiagnosisCodeReferencesEdge = {
  __typename: 'DiagnosisCodeReferencesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `DiagnosisCodeReference` at the end of the edge. */
  node: DiagnosisCodeReference;
};

/** Methods to use when ordering `DiagnosisCodeReference`. */
export enum DiagnosisCodeReferencesOrderBy {
  CODE_ASC = 'CODE_ASC',
  CODE_DESC = 'CODE_DESC',
  DIAGNOSIS_CODE_REFERENCE_ID_ASC = 'DIAGNOSIS_CODE_REFERENCE_ID_ASC',
  DIAGNOSIS_CODE_REFERENCE_ID_DESC = 'DIAGNOSIS_CODE_REFERENCE_ID_DESC',
  NATURAL = 'NATURAL',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  START_DATE_ASC = 'START_DATE_ASC',
  START_DATE_DESC = 'START_DATE_DESC'
}

export enum DispositionEnum {
  COMPLETED = 'COMPLETED',
  DISCHARGED = 'DISCHARGED',
  DISCHARGED_WITH_ACTIVATION = 'DISCHARGED_WITH_ACTIVATION',
  DISCHARGED_WITH_SERVICE_REFUSAL = 'DISCHARGED_WITH_SERVICE_REFUSAL',
  PATIENT_DECLINED_SERVICES = 'PATIENT_DECLINED_SERVICES',
  REACHED = 'REACHED',
  RESPONDER_INITIATED_ACTIVATION = 'RESPONDER_INITIATED_ACTIVATION',
  UNABLE_TO_REACH_INCORRECT_NUMBER = 'UNABLE_TO_REACH_INCORRECT_NUMBER',
  UNABLE_TO_REACH_LEFT_VOICEMAIL = 'UNABLE_TO_REACH_LEFT_VOICEMAIL',
  UNABLE_TO_REACH_NO_VOICEMAIL = 'UNABLE_TO_REACH_NO_VOICEMAIL'
}

export type DoseSpotNotificationsResponse = {
  __typename: 'DoseSpotNotificationsResponse';
  notificationCount?: Maybe<Scalars['Int']>;
  notificationsUrl?: Maybe<Scalars['String']>;
};

/** A connection to a list of `DosespotDrugAllergy` values. */
export type DosespotDrugAllergiesConnection = {
  __typename: 'DosespotDrugAllergiesConnection';
  /** A list of edges which contains the `DosespotDrugAllergy` and cursor to aid in pagination. */
  edges: Array<DosespotDrugAllergiesEdge>;
  /** A list of `DosespotDrugAllergy` objects. */
  nodes: Array<DosespotDrugAllergy>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `DosespotDrugAllergy` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `DosespotDrugAllergy` edge in the connection. */
export type DosespotDrugAllergiesEdge = {
  __typename: 'DosespotDrugAllergiesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `DosespotDrugAllergy` at the end of the edge. */
  node: DosespotDrugAllergy;
};

/** Methods to use when ordering `DosespotDrugAllergy`. */
export enum DosespotDrugAllergiesOrderBy {
  DOSESPOT_DRUG_ALLERGY_ID_ASC = 'DOSESPOT_DRUG_ALLERGY_ID_ASC',
  DOSESPOT_DRUG_ALLERGY_ID_DESC = 'DOSESPOT_DRUG_ALLERGY_ID_DESC',
  NATURAL = 'NATURAL',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC'
}

export type DosespotDrugAllergy = Node & {
  __typename: 'DosespotDrugAllergy';
  code?: Maybe<Scalars['String']>;
  codeType?: Maybe<Scalars['String']>;
  dosespotAllergyId?: Maybe<Scalars['String']>;
  dosespotDrugAllergyId: Scalars['Int'];
  encounterId?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  onsetDate?: Maybe<Scalars['Datetime']>;
  patientId?: Maybe<Scalars['Int']>;
  reaction?: Maybe<Scalars['String']>;
  reactionType?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
};

/**
 * A condition to be used against `DosespotDrugAllergy` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type DosespotDrugAllergyCondition = {
  /** Checks for equality with the object’s `dosespotDrugAllergyId` field. */
  dosespotDrugAllergyId?: InputMaybe<Scalars['Int']>;
};

export type DosespotPatientPrescription = Node & {
  __typename: 'DosespotPatientPrescription';
  dispenseUnit?: Maybe<Scalars['String']>;
  doseForm?: Maybe<Scalars['String']>;
  dosespotEncounterId?: Maybe<Scalars['String']>;
  dosespotPatientPrescriptionId?: Maybe<Scalars['Int']>;
  drugCode?: Maybe<Scalars['String']>;
  drugCodeSystem?: Maybe<Scalars['String']>;
  drugName?: Maybe<Scalars['String']>;
  effectiveDate?: Maybe<Scalars['Datetime']>;
  encounterId?: Maybe<Scalars['Int']>;
  endDate?: Maybe<Scalars['Datetime']>;
  medicationStatus?: Maybe<Scalars['String']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  patientFriendlyInstructions?: Maybe<Scalars['String']>;
  patientMedicationId?: Maybe<Scalars['Int']>;
  patientPrescriptionId: Scalars['Int'];
  prescriptionStatus?: Maybe<Scalars['String']>;
  prescriptionType?: Maybe<Scalars['String']>;
  quantity?: Maybe<Scalars['String']>;
  refills?: Maybe<Scalars['String']>;
  route?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['Datetime']>;
  strength?: Maybe<Scalars['String']>;
};

/**
 * A condition to be used against `DosespotPatientPrescription` object types. All
 * fields are tested for equality and combined with a logical ‘and.’
 */
export type DosespotPatientPrescriptionCondition = {
  /** Checks for equality with the object’s `patientPrescriptionId` field. */
  patientPrescriptionId?: InputMaybe<Scalars['Int']>;
};

/** A connection to a list of `DosespotPatientPrescription` values. */
export type DosespotPatientPrescriptionsConnection = {
  __typename: 'DosespotPatientPrescriptionsConnection';
  /** A list of edges which contains the `DosespotPatientPrescription` and cursor to aid in pagination. */
  edges: Array<DosespotPatientPrescriptionsEdge>;
  /** A list of `DosespotPatientPrescription` objects. */
  nodes: Array<DosespotPatientPrescription>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `DosespotPatientPrescription` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `DosespotPatientPrescription` edge in the connection. */
export type DosespotPatientPrescriptionsEdge = {
  __typename: 'DosespotPatientPrescriptionsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `DosespotPatientPrescription` at the end of the edge. */
  node: DosespotPatientPrescription;
};

/** Methods to use when ordering `DosespotPatientPrescription`. */
export enum DosespotPatientPrescriptionsOrderBy {
  NATURAL = 'NATURAL',
  PATIENT_PRESCRIPTION_ID_ASC = 'PATIENT_PRESCRIPTION_ID_ASC',
  PATIENT_PRESCRIPTION_ID_DESC = 'PATIENT_PRESCRIPTION_ID_DESC',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC'
}

export type DosespotPatientReportedMedication = Node & {
  __typename: 'DosespotPatientReportedMedication';
  dispenseUnit?: Maybe<Scalars['String']>;
  doseForm?: Maybe<Scalars['String']>;
  dosespotEncounterId?: Maybe<Scalars['String']>;
  dosespotPatientReportedMedicationId?: Maybe<Scalars['Int']>;
  drugCode?: Maybe<Scalars['String']>;
  drugCodeSystem?: Maybe<Scalars['String']>;
  drugName?: Maybe<Scalars['String']>;
  encounterId?: Maybe<Scalars['Int']>;
  endDate?: Maybe<Scalars['Datetime']>;
  medicationStatus?: Maybe<Scalars['String']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  patientFriendlyInstructions?: Maybe<Scalars['String']>;
  patientMedicationId?: Maybe<Scalars['Int']>;
  patientReportedMedicationId: Scalars['Int'];
  quantity?: Maybe<Scalars['String']>;
  refills?: Maybe<Scalars['String']>;
  route?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['Datetime']>;
  strength?: Maybe<Scalars['String']>;
};

/**
 * A condition to be used against `DosespotPatientReportedMedication` object types.
 * All fields are tested for equality and combined with a logical ‘and.’
 */
export type DosespotPatientReportedMedicationCondition = {
  /** Checks for equality with the object’s `patientReportedMedicationId` field. */
  patientReportedMedicationId?: InputMaybe<Scalars['Int']>;
};

/** A connection to a list of `DosespotPatientReportedMedication` values. */
export type DosespotPatientReportedMedicationsConnection = {
  __typename: 'DosespotPatientReportedMedicationsConnection';
  /** A list of edges which contains the `DosespotPatientReportedMedication` and cursor to aid in pagination. */
  edges: Array<DosespotPatientReportedMedicationsEdge>;
  /** A list of `DosespotPatientReportedMedication` objects. */
  nodes: Array<DosespotPatientReportedMedication>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `DosespotPatientReportedMedication` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `DosespotPatientReportedMedication` edge in the connection. */
export type DosespotPatientReportedMedicationsEdge = {
  __typename: 'DosespotPatientReportedMedicationsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `DosespotPatientReportedMedication` at the end of the edge. */
  node: DosespotPatientReportedMedication;
};

/** Methods to use when ordering `DosespotPatientReportedMedication`. */
export enum DosespotPatientReportedMedicationsOrderBy {
  NATURAL = 'NATURAL',
  PATIENT_REPORTED_MEDICATION_ID_ASC = 'PATIENT_REPORTED_MEDICATION_ID_ASC',
  PATIENT_REPORTED_MEDICATION_ID_DESC = 'PATIENT_REPORTED_MEDICATION_ID_DESC',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC'
}

/** Contains information about drugs and drug manufacturers. */
export type Drug = Node & {
  __typename: 'Drug';
  createdAt: Scalars['Datetime'];
  drugCode: Scalars['String'];
  drugCodeSystem: Scalars['String'];
  drugId: Scalars['Int'];
  drugName: Scalars['String'];
  isDeleted: Scalars['Boolean'];
  manufacturerCode: Scalars['String'];
  manufacturerCodeSystem: Scalars['String'];
  manufacturerName: Scalars['String'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  routeCode: Scalars['String'];
  routeCodeSystem: Scalars['String'];
  routeName: Scalars['String'];
};

/** A condition to be used against `Drug` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type DrugCondition = {
  /** Checks for equality with the object’s `drugCode` field. */
  drugCode?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `drugId` field. */
  drugId?: InputMaybe<Scalars['Int']>;
};

/** A connection to a list of `Drug` values. */
export type DrugsConnection = {
  __typename: 'DrugsConnection';
  /** A list of edges which contains the `Drug` and cursor to aid in pagination. */
  edges: Array<DrugsEdge>;
  /** A list of `Drug` objects. */
  nodes: Array<Drug>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Drug` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Drug` edge in the connection. */
export type DrugsEdge = {
  __typename: 'DrugsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `Drug` at the end of the edge. */
  node: Drug;
};

/** Methods to use when ordering `Drug`. */
export enum DrugsOrderBy {
  DRUG_CODE_ASC = 'DRUG_CODE_ASC',
  DRUG_CODE_DESC = 'DRUG_CODE_DESC',
  DRUG_ID_ASC = 'DRUG_ID_ASC',
  DRUG_ID_DESC = 'DRUG_ID_DESC',
  NATURAL = 'NATURAL',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC'
}

export type EmrAuditLogInput = {
  action: Scalars['String'];
  args?: InputMaybe<Scalars['String']>;
  patientId: Scalars['Int'];
  query?: InputMaybe<Scalars['String']>;
};

export type EmrAuditLogPayload = {
  __typename: 'EmrAuditLogPayload';
  msg?: Maybe<Scalars['String']>;
};

/** Contains information about an encounter */
export type Encounter = Node & {
  __typename: 'Encounter';
  activation?: Maybe<ActivationEnum>;
  /** Reads and enables pagination through a set of `Addendum`. */
  addenda: AddendaConnection;
  /** Reads and enables pagination through a set of `Addendum`. */
  addendaList: Array<Addendum>;
  /** Reads a single `Appointment` that is related to this `Encounter`. */
  appointment?: Maybe<Appointment>;
  appointmentId: Scalars['Int'];
  cancellationReason?: Maybe<CancellationReasonEnum>;
  cancellationReasonOther?: Maybe<Scalars['String']>;
  cancelledAt?: Maybe<Scalars['Datetime']>;
  channelAttribution?: Maybe<ChannelAttribution>;
  channelAttributionId: Scalars['Int'];
  claimedAt?: Maybe<Scalars['Datetime']>;
  clinician?: Maybe<User>;
  clinicianId?: Maybe<Scalars['Int']>;
  clinicianIncluded?: Maybe<Scalars['Boolean']>;
  clinicianStatus?: Maybe<EncounterClinicianStatusEnum>;
  createdAt: Scalars['Datetime'];
  disposition?: Maybe<DispositionEnum>;
  encounterId: Scalars['Int'];
  /** Reads and enables pagination through a set of `EncounterSignature`. */
  encounterSignatures: EncounterSignaturesConnection;
  /** Reads and enables pagination through a set of `EncounterSignature`. */
  encounterSignaturesList: Array<EncounterSignature>;
  /** Reads and enables pagination through a set of `EncounterTask`. */
  encounterTasks: EncounterTasksConnection;
  /** Reads and enables pagination through a set of `EncounterTask`. */
  encounterTasksList: Array<EncounterTask>;
  genderRequirement?: Maybe<SexEnum>;
  globalUuid: Scalars['UUID'];
  humanizedClinicianStatus?: Maybe<Scalars['String']>;
  humanizedModuleEncounterTags?: Maybe<Array<Maybe<Scalars['String']>>>;
  humanizedResponderStatus?: Maybe<Scalars['String']>;
  inProgressAt?: Maybe<Scalars['Datetime']>;
  inQueueAt?: Maybe<Scalars['Datetime']>;
  migrationSource?: Maybe<Scalars['String']>;
  modules?: Maybe<Array<Maybe<ModuleNameEnum>>>;
  noInsuranceReason?: Maybe<NoInsuranceReasonEnum>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  otherInsurance?: Maybe<Scalars['Int']>;
  parentEncounterId?: Maybe<Scalars['Int']>;
  /** Reads a single `Patient` that is related to this `Encounter`. */
  patient?: Maybe<Patient>;
  patientId: Scalars['Int'];
  paymentMode?: Maybe<EncounterPaymentModeEnum>;
  primaryInsurance?: Maybe<Scalars['Int']>;
  /** Reads a single `InsuranceRecord` that is related to this `Encounter`. */
  primaryInsuranceRecord?: Maybe<InsuranceRecord>;
  reasonForEncounter?: Maybe<Scalars['String']>;
  rescheduledAt?: Maybe<Scalars['Datetime']>;
  rescheduledReason?: Maybe<RescheduleReasonEnum>;
  responderStatus?: Maybe<EncounterResponderStatusEnum>;
  secondaryInsurance?: Maybe<Scalars['Int']>;
  /** Reads a single `InsuranceRecord` that is related to this `Encounter`. */
  secondaryInsuranceRecord?: Maybe<InsuranceRecord>;
  /** Reads a single `ServiceLine` that is related to this `Encounter`. */
  serviceLine?: Maybe<ServiceLine>;
  serviceLineId?: Maybe<Scalars['Int']>;
  stripeCharge?: Maybe<Scalars['JSON']>;
  stripeId?: Maybe<Scalars['String']>;
  systemLastUpdatedBy: SystemOfOriginEnum;
  telehealthMeeting?: Maybe<TelehealthMeeting>;
  terminatedAt?: Maybe<Scalars['Datetime']>;
  updatedAt?: Maybe<Scalars['Datetime']>;
  visitId?: Maybe<Scalars['String']>;
};


/** Contains information about an encounter */
export type EncounteraddendaArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<AddendumCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AddendaOrderBy>>;
};


/** Contains information about an encounter */
export type EncounteraddendaListArgs = {
  condition?: InputMaybe<AddendumCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AddendaOrderBy>>;
};


/** Contains information about an encounter */
export type EncounterencounterSignaturesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<EncounterSignatureCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EncounterSignaturesOrderBy>>;
};


/** Contains information about an encounter */
export type EncounterencounterSignaturesListArgs = {
  condition?: InputMaybe<EncounterSignatureCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EncounterSignaturesOrderBy>>;
};


/** Contains information about an encounter */
export type EncounterencounterTasksArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<EncounterTaskCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EncounterTasksOrderBy>>;
};


/** Contains information about an encounter */
export type EncounterencounterTasksListArgs = {
  condition?: InputMaybe<EncounterTaskCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EncounterTasksOrderBy>>;
};

export enum EncounterAppointmentStatusConditionEnum {
  AT_PATIENT = 'AT_PATIENT',
  CANCELLED = 'CANCELLED',
  COMPLETED = 'COMPLETED',
  DISPATCH_FAILED = 'DISPATCH_FAILED',
  EN_ROUTE = 'EN_ROUTE',
  ON_SCENE = 'ON_SCENE',
  RESCHEDULED = 'RESCHEDULED',
  SCHEDULED = 'SCHEDULED'
}

export enum EncounterClinicianStatusConditionEnum {
  CANCELLED = 'CANCELLED',
  COMPLETED = 'COMPLETED',
  IN_PROGRESS = 'IN_PROGRESS',
  IN_QUEUE = 'IN_QUEUE',
  NOT_STARTED = 'NOT_STARTED',
  NO_CLINICIAN = 'NO_CLINICIAN',
  RESCHEDULED = 'RESCHEDULED',
  TERMINATED = 'TERMINATED'
}

export enum EncounterClinicianStatusEnum {
  CANCELLED = 'CANCELLED',
  COMPLETED = 'COMPLETED',
  IN_PROGRESS = 'IN_PROGRESS',
  IN_QUEUE = 'IN_QUEUE',
  NOT_STARTED = 'NOT_STARTED',
  NO_CLINICIAN = 'NO_CLINICIAN',
  RESCHEDULED = 'RESCHEDULED',
  TERMINATED = 'TERMINATED'
}

/**
 * A condition to be used against `Encounter` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type EncounterCondition = {
  /** Checks for equality with the object’s `appointmentId` field. */
  appointmentId?: InputMaybe<Scalars['Int']>;
  /** Filters on records matching `appointmentStatus` */
  appointmentStatus?: InputMaybe<Array<InputMaybe<EncounterAppointmentStatusConditionEnum>>>;
  /** Filters to encounter records with matching `clinicianIds` */
  clinicianIds?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Filters on records matching `responderStatus` */
  clinicianStatus?: InputMaybe<Array<InputMaybe<EncounterClinicianStatusConditionEnum>>>;
  /** Filters to records where `completedAt` is after or equal to completed_at */
  completedAtAfter?: InputMaybe<Scalars['String']>;
  /** Filters to records where `completedAt` is before or equal to completed_at */
  completedAtBefore?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `encounterId` field. */
  encounterId?: InputMaybe<Scalars['Int']>;
  /** Filters to records matching `encounterIds` */
  encounterIds?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Filters to records matching `marketId` */
  marketId?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Checks for equality with the object’s `migrationSource` field. */
  migrationSource?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `patientId` field. */
  patientId?: InputMaybe<Scalars['Int']>;
  /** Filters on records matching `paymentMode` */
  paymentMode?: InputMaybe<Array<InputMaybe<EncounterPaymentModeConditionEnum>>>;
  /** Checks for equality with the object’s `primaryInsurance` field. */
  primaryInsurance?: InputMaybe<Scalars['Int']>;
  /** Filters to records matching `responderId` */
  responderId?: InputMaybe<Scalars['Int']>;
  /** Filters on records matching `responderStatus` */
  responderStatus?: InputMaybe<Array<InputMaybe<EncounterResponderStatusConditionEnum>>>;
  /** Filters to records where `scheduledFor` is after or equal to scheduled_for */
  scheduledForAfter?: InputMaybe<Scalars['String']>;
  /** Filters to records where `scheduledFor` is before or equal to scheduled_for */
  scheduledForBefore?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `secondaryInsurance` field. */
  secondaryInsurance?: InputMaybe<Scalars['Int']>;
  /** Filters on records matching `serviceLineId` */
  serviceLine?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Checks for equality with the object’s `serviceLineId` field. */
  serviceLineId?: InputMaybe<Scalars['Int']>;
};

/** Represents an update to a `Encounter`. Fields that are set will be updated. */
export type EncounterPatch = {
  activation?: InputMaybe<ActivationEnum>;
  cancellationReason?: InputMaybe<CancellationReasonEnum>;
  cancellationReasonOther?: InputMaybe<Scalars['String']>;
  cancelledAt?: InputMaybe<Scalars['Datetime']>;
  channelAttributionId?: InputMaybe<Scalars['Int']>;
  clinicianId?: InputMaybe<Scalars['Int']>;
  clinicianIncluded?: InputMaybe<Scalars['Boolean']>;
  disposition?: InputMaybe<DispositionEnum>;
  genderRequirement?: InputMaybe<SexEnum>;
  modules?: InputMaybe<Array<InputMaybe<ModuleNameEnum>>>;
  noInsuranceReason?: InputMaybe<NoInsuranceReasonEnum>;
  paymentMode?: InputMaybe<EncounterPaymentModeEnum>;
  primaryInsurance?: InputMaybe<Scalars['Int']>;
  reasonForEncounter?: InputMaybe<Scalars['String']>;
  rescheduledReason?: InputMaybe<RescheduleReasonEnum>;
  secondaryInsurance?: InputMaybe<Scalars['Int']>;
  serviceLineId?: InputMaybe<Scalars['Int']>;
  stripeCharge?: InputMaybe<Scalars['JSON']>;
  systemLastUpdatedBy?: InputMaybe<SystemOfOriginEnum>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

export enum EncounterPaymentModeConditionEnum {
  EMPLOYEE_BENEFIT = 'EMPLOYEE_BENEFIT',
  INSURANCE = 'INSURANCE',
  INVOICE = 'INVOICE',
  NO_INSURANCE = 'NO_INSURANCE',
  PARTNERSHIP = 'PARTNERSHIP',
  PREPAID = 'PREPAID',
  UNINSURED = 'UNINSURED'
}

export enum EncounterPaymentModeEnum {
  EMPLOYEE_BENEFIT = 'EMPLOYEE_BENEFIT',
  INSURANCE = 'INSURANCE',
  INVOICE = 'INVOICE',
  NO_INSURANCE = 'NO_INSURANCE',
  PARTNERSHIP = 'PARTNERSHIP',
  PREPAID = 'PREPAID',
  UNINSURED = 'UNINSURED'
}

export enum EncounterResponderStatusConditionEnum {
  CANCELLED = 'CANCELLED',
  COMPLETED = 'COMPLETED',
  IN_PROGRESS = 'IN_PROGRESS',
  NOT_STARTED = 'NOT_STARTED',
  RESCHEDULED = 'RESCHEDULED',
  TERMINATED = 'TERMINATED'
}

export enum EncounterResponderStatusEnum {
  CANCELLED = 'CANCELLED',
  COMPLETED = 'COMPLETED',
  IN_PROGRESS = 'IN_PROGRESS',
  NOT_STARTED = 'NOT_STARTED',
  RESCHEDULED = 'RESCHEDULED',
  TERMINATED = 'TERMINATED'
}

/** Contains information about signatures for an encounter */
export type EncounterSignature = Node & {
  __typename: 'EncounterSignature';
  createdAt: Scalars['Datetime'];
  /** Reads a single `Encounter` that is related to this `EncounterSignature`. */
  encounter?: Maybe<Encounter>;
  encounterId: Scalars['Int'];
  encounterSignatureId: Scalars['Int'];
  migrationSource?: Maybe<Scalars['String']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  operatingAsRole?: Maybe<UserRoleEnum>;
  user?: Maybe<User>;
  userId: Scalars['Int'];
};

/**
 * A condition to be used against `EncounterSignature` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type EncounterSignatureCondition = {
  /** Checks for equality with the object’s `encounterId` field. */
  encounterId?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `encounterSignatureId` field. */
  encounterSignatureId?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `migrationSource` field. */
  migrationSource?: InputMaybe<Scalars['String']>;
};

/** An input for mutations affecting `EncounterSignature` */
export type EncounterSignatureInput = {
  createdAt?: InputMaybe<Scalars['Datetime']>;
  encounterId: Scalars['Int'];
  encounterSignatureId?: InputMaybe<Scalars['Int']>;
  migrationSource?: InputMaybe<Scalars['String']>;
  operatingAsRole?: InputMaybe<UserRoleEnum>;
  userId: Scalars['Int'];
};

/** A connection to a list of `EncounterSignature` values. */
export type EncounterSignaturesConnection = {
  __typename: 'EncounterSignaturesConnection';
  /** A list of edges which contains the `EncounterSignature` and cursor to aid in pagination. */
  edges: Array<EncounterSignaturesEdge>;
  /** A list of `EncounterSignature` objects. */
  nodes: Array<EncounterSignature>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `EncounterSignature` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `EncounterSignature` edge in the connection. */
export type EncounterSignaturesEdge = {
  __typename: 'EncounterSignaturesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `EncounterSignature` at the end of the edge. */
  node: EncounterSignature;
};

/** Methods to use when ordering `EncounterSignature`. */
export enum EncounterSignaturesOrderBy {
  ENCOUNTER_ID_ASC = 'ENCOUNTER_ID_ASC',
  ENCOUNTER_ID_DESC = 'ENCOUNTER_ID_DESC',
  ENCOUNTER_SIGNATURE_ID_ASC = 'ENCOUNTER_SIGNATURE_ID_ASC',
  ENCOUNTER_SIGNATURE_ID_DESC = 'ENCOUNTER_SIGNATURE_ID_DESC',
  MIGRATION_SOURCE_ASC = 'MIGRATION_SOURCE_ASC',
  MIGRATION_SOURCE_DESC = 'MIGRATION_SOURCE_DESC',
  NATURAL = 'NATURAL',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC'
}

/** Contains information related to encounter tasks */
export type EncounterTask = Node & {
  __typename: 'EncounterTask';
  assigneeId?: Maybe<Scalars['Int']>;
  /** Reads and enables pagination through a set of `BillingDiagnostic`. */
  billingDiagnostics: BillingDiagnosticsConnection;
  /** Reads and enables pagination through a set of `BillingDiagnostic`. */
  billingDiagnosticsList: Array<BillingDiagnostic>;
  /** Reads a single `ChiefComplaintAndHpi` that is related to this `EncounterTask`. */
  chiefComplaintAndHpi?: Maybe<ChiefComplaintAndHpi>;
  /**
   * Reads and enables pagination through a set of `ChiefComplaintAndHpi`.
   * @deprecated Please use chiefComplaintAndHpi instead
   */
  chiefComplaintAndHpis: ChiefComplaintAndHpisConnection;
  clinicianReviewedAt?: Maybe<Scalars['Datetime']>;
  clinicianReviewedBy?: Maybe<Scalars['Int']>;
  corrections?: Maybe<Array<Maybe<EncounterTaskCorrection>>>;
  createdAt: Scalars['Datetime'];
  dataCategory?: Maybe<Scalars['String']>;
  dataType: Scalars['String'];
  deletedAt?: Maybe<Scalars['Datetime']>;
  /** Reads and enables pagination through a set of `DiagnosisCodeReference`. */
  diagnosisCodeReferencesByPatientDiagnosisEncounterTaskIdAndDiagnosisCodeReferenceId: EncounterTaskDiagnosisCodeReferencesByPatientDiagnosisEncounterTaskIdAndDiagnosisCodeReferenceIdManyToManyConnection;
  /** Reads and enables pagination through a set of `DiagnosisCodeReference`. */
  diagnosisCodeReferencesByPatientDiagnosisEncounterTaskIdAndDiagnosisCodeReferenceIdList: Array<DiagnosisCodeReference>;
  /** Reads a single `Encounter` that is related to this `EncounterTask`. */
  encounter?: Maybe<Encounter>;
  encounterId: Scalars['Int'];
  /** Reads and enables pagination through a set of `EncounterTaskAttachment`. */
  encounterTaskAttachments: EncounterTaskAttachmentsConnection;
  /** Reads and enables pagination through a set of `EncounterTaskAttachment`. */
  encounterTaskAttachmentsList: Array<EncounterTaskAttachment>;
  encounterTaskId: Scalars['Int'];
  group: Scalars['String'];
  inProgressAt?: Maybe<Scalars['Datetime']>;
  isDeleted: Scalars['Boolean'];
  medicalDecisionMaking?: Maybe<MedicalDecisionMaking>;
  migrationSource?: Maybe<Scalars['String']>;
  modifiedByResponderIds?: Maybe<Array<Maybe<Scalars['Int']>>>;
  modifiedByResponders?: Maybe<Array<Maybe<User>>>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  patientAllergyList?: Maybe<Array<Maybe<PatientAllergy>>>;
  /** Reads and enables pagination through a set of `PatientDiagnosis`. */
  patientDiagnoses: PatientDiagnosesConnection;
  /** Reads and enables pagination through a set of `PatientDiagnosis`. */
  patientDiagnosesList: Array<PatientDiagnosis>;
  patientForm?: Maybe<PatientForm>;
  patientFormLookup?: Maybe<PatientFormLookup>;
  patientId: Scalars['Int'];
  patientInstructions?: Maybe<Array<Maybe<PatientInstruction>>>;
  patientProblemList?: Maybe<Array<Maybe<PatientProblem>>>;
  physicalExam?: Maybe<PhysicalExam>;
  pointOfCareTest?: Maybe<PointOfCareTest>;
  pointOfCareTestLookup?: Maybe<PointOfCareTestLookup>;
  /** Reads and enables pagination through a set of `PointOfCareTestLookup`. */
  pointOfCareTestLookupsByPointOfCareTestEncounterTaskIdAndPointOfCareTestLookupId: EncounterTaskPointOfCareTestLookupsByPointOfCareTestEncounterTaskIdAndPointOfCareTestLookupIdManyToManyConnection;
  /** Reads and enables pagination through a set of `PointOfCareTestLookup`. */
  pointOfCareTestLookupsByPointOfCareTestEncounterTaskIdAndPointOfCareTestLookupIdList: Array<PointOfCareTestLookup>;
  /** Reads and enables pagination through a set of `PointOfCareTest`. */
  pointOfCareTests: PointOfCareTestsConnection;
  /** Reads and enables pagination through a set of `PointOfCareTest`. */
  pointOfCareTestsList: Array<PointOfCareTest>;
  /** Reads and enables pagination through a set of `ProcedureCodeReference`. */
  procedureCodeReferencesByBillingDiagnosticEncounterTaskIdAndProcedureCodeReferenceId: EncounterTaskProcedureCodeReferencesByBillingDiagnosticEncounterTaskIdAndProcedureCodeReferenceIdManyToManyConnection;
  /** Reads and enables pagination through a set of `ProcedureCodeReference`. */
  procedureCodeReferencesByBillingDiagnosticEncounterTaskIdAndProcedureCodeReferenceIdList: Array<ProcedureCodeReference>;
  progressNote?: Maybe<ProgressNote>;
  responderCompletedAt?: Maybe<Scalars['Datetime']>;
  responderCompletedBy?: Maybe<Scalars['Int']>;
  reviewOfSystems?: Maybe<Array<Maybe<ReviewOfSystemPayload>>>;
  skippedAt?: Maybe<Scalars['Datetime']>;
  skippedBy?: Maybe<Scalars['String']>;
  skippedReason?: Maybe<Scalars['String']>;
  status?: Maybe<EncounterTaskStatusEnum>;
  taskName: Scalars['String'];
  taskRoles: Array<Maybe<UserRoleEnum>>;
  telehealthMeeting?: Maybe<TelehealthMeeting>;
  updatedAt?: Maybe<Scalars['Datetime']>;
  vaccine?: Maybe<Vaccine>;
  vaccineLookups?: Maybe<Array<Maybe<VaccineLookup>>>;
  /** Reads and enables pagination through a set of `Vaccine`. */
  vaccines: VaccinesConnection;
  /** Reads and enables pagination through a set of `Vaccine`. */
  vaccinesList: Array<Vaccine>;
  vitalLookups?: Maybe<Array<Maybe<VitalLookup>>>;
  /** Reads and enables pagination through a set of `VitalLookup`. */
  vitalLookupsByVitalEncounterTaskIdAndVitalLookupId: EncounterTaskVitalLookupsByVitalEncounterTaskIdAndVitalLookupIdManyToManyConnection;
  /** Reads and enables pagination through a set of `VitalLookup`. */
  vitalLookupsByVitalEncounterTaskIdAndVitalLookupIdList: Array<VitalLookup>;
  /** Reads and enables pagination through a set of `Vital`. */
  vitals: VitalsConnection;
  /** Reads and enables pagination through a set of `Vital`. */
  vitalsList: Array<Vital>;
};


/** Contains information related to encounter tasks */
export type EncounterTaskbillingDiagnosticsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<BillingDiagnosticCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<BillingDiagnosticsOrderBy>>;
};


/** Contains information related to encounter tasks */
export type EncounterTaskbillingDiagnosticsListArgs = {
  condition?: InputMaybe<BillingDiagnosticCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<BillingDiagnosticsOrderBy>>;
};


/** Contains information related to encounter tasks */
export type EncounterTaskchiefComplaintAndHpisArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ChiefComplaintAndHpiCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ChiefComplaintAndHpisOrderBy>>;
};


/** Contains information related to encounter tasks */
export type EncounterTaskdiagnosisCodeReferencesByPatientDiagnosisEncounterTaskIdAndDiagnosisCodeReferenceIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<DiagnosisCodeReferenceCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<DiagnosisCodeReferencesOrderBy>>;
};


/** Contains information related to encounter tasks */
export type EncounterTaskdiagnosisCodeReferencesByPatientDiagnosisEncounterTaskIdAndDiagnosisCodeReferenceIdListArgs = {
  condition?: InputMaybe<DiagnosisCodeReferenceCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<DiagnosisCodeReferencesOrderBy>>;
};


/** Contains information related to encounter tasks */
export type EncounterTaskencounterTaskAttachmentsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<EncounterTaskAttachmentCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EncounterTaskAttachmentsOrderBy>>;
};


/** Contains information related to encounter tasks */
export type EncounterTaskencounterTaskAttachmentsListArgs = {
  condition?: InputMaybe<EncounterTaskAttachmentCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EncounterTaskAttachmentsOrderBy>>;
};


/** Contains information related to encounter tasks */
export type EncounterTaskpatientDiagnosesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<PatientDiagnosisCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PatientDiagnosesOrderBy>>;
};


/** Contains information related to encounter tasks */
export type EncounterTaskpatientDiagnosesListArgs = {
  condition?: InputMaybe<PatientDiagnosisCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PatientDiagnosesOrderBy>>;
};


/** Contains information related to encounter tasks */
export type EncounterTaskpointOfCareTestLookupsByPointOfCareTestEncounterTaskIdAndPointOfCareTestLookupIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<PointOfCareTestLookupCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PointOfCareTestLookupsOrderBy>>;
};


/** Contains information related to encounter tasks */
export type EncounterTaskpointOfCareTestLookupsByPointOfCareTestEncounterTaskIdAndPointOfCareTestLookupIdListArgs = {
  condition?: InputMaybe<PointOfCareTestLookupCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PointOfCareTestLookupsOrderBy>>;
};


/** Contains information related to encounter tasks */
export type EncounterTaskpointOfCareTestsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<PointOfCareTestCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PointOfCareTestsOrderBy>>;
};


/** Contains information related to encounter tasks */
export type EncounterTaskpointOfCareTestsListArgs = {
  condition?: InputMaybe<PointOfCareTestCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PointOfCareTestsOrderBy>>;
};


/** Contains information related to encounter tasks */
export type EncounterTaskprocedureCodeReferencesByBillingDiagnosticEncounterTaskIdAndProcedureCodeReferenceIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ProcedureCodeReferenceCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProcedureCodeReferencesOrderBy>>;
};


/** Contains information related to encounter tasks */
export type EncounterTaskprocedureCodeReferencesByBillingDiagnosticEncounterTaskIdAndProcedureCodeReferenceIdListArgs = {
  condition?: InputMaybe<ProcedureCodeReferenceCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProcedureCodeReferencesOrderBy>>;
};


/** Contains information related to encounter tasks */
export type EncounterTaskvaccinesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<VaccineCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VaccinesOrderBy>>;
};


/** Contains information related to encounter tasks */
export type EncounterTaskvaccinesListArgs = {
  condition?: InputMaybe<VaccineCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VaccinesOrderBy>>;
};


/** Contains information related to encounter tasks */
export type EncounterTaskvitalLookupsByVitalEncounterTaskIdAndVitalLookupIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<VitalLookupCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VitalLookupsOrderBy>>;
};


/** Contains information related to encounter tasks */
export type EncounterTaskvitalLookupsByVitalEncounterTaskIdAndVitalLookupIdListArgs = {
  condition?: InputMaybe<VitalLookupCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VitalLookupsOrderBy>>;
};


/** Contains information related to encounter tasks */
export type EncounterTaskvitalsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<VitalCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VitalsOrderBy>>;
};


/** Contains information related to encounter tasks */
export type EncounterTaskvitalsListArgs = {
  condition?: InputMaybe<VitalCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VitalsOrderBy>>;
};

/** Contains attachments related to an encounter task */
export type EncounterTaskAttachment = Node & {
  __typename: 'EncounterTaskAttachment';
  createdAt: Scalars['Datetime'];
  createdById?: Maybe<Scalars['Int']>;
  deletedAt?: Maybe<Scalars['Datetime']>;
  description?: Maybe<Scalars['String']>;
  encounterId?: Maybe<Scalars['Int']>;
  /** Reads a single `EncounterTask` that is related to this `EncounterTaskAttachment`. */
  encounterTask?: Maybe<EncounterTask>;
  encounterTaskAttachmentId: Scalars['Int'];
  encounterTaskId?: Maybe<Scalars['Int']>;
  isDeleted: Scalars['Boolean'];
  isRequired: Scalars['Boolean'];
  migrationSource?: Maybe<Scalars['String']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  patientId?: Maybe<Scalars['Int']>;
  type: EncounterTaskAttachmentTypeEnum;
  url?: Maybe<Scalars['String']>;
};

/**
 * A condition to be used against `EncounterTaskAttachment` object types. All
 * fields are tested for equality and combined with a logical ‘and.’
 */
export type EncounterTaskAttachmentCondition = {
  /** Checks for equality with the object’s `encounterTaskAttachmentId` field. */
  encounterTaskAttachmentId?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `encounterTaskId` field. */
  encounterTaskId?: InputMaybe<Scalars['Int']>;
  /** Returns encoutner_task_attachments with matching encounter_task_id that are not deleted */
  encounterTaskIds?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Filters on records matching "isDeleted". */
  isDeleted?: InputMaybe<Scalars['Boolean']>;
};

/** An input for mutations affecting `EncounterTaskAttachment` */
export type EncounterTaskAttachmentInput = {
  createdById?: InputMaybe<Scalars['Int']>;
  deletedAt?: InputMaybe<Scalars['Datetime']>;
  description?: InputMaybe<Scalars['String']>;
  encounterId?: InputMaybe<Scalars['Int']>;
  encounterTaskId?: InputMaybe<Scalars['Int']>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  patientId?: InputMaybe<Scalars['Int']>;
  type: EncounterTaskAttachmentTypeEnum;
  url?: InputMaybe<Scalars['String']>;
};

/** Represents an update to a `EncounterTaskAttachment`. Fields that are set will be updated. */
export type EncounterTaskAttachmentPatch = {
  createdById?: InputMaybe<Scalars['Int']>;
  deletedAt?: InputMaybe<Scalars['Datetime']>;
  description?: InputMaybe<Scalars['String']>;
  encounterId?: InputMaybe<Scalars['Int']>;
  encounterTaskId?: InputMaybe<Scalars['Int']>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  patientId?: InputMaybe<Scalars['Int']>;
  type?: InputMaybe<EncounterTaskAttachmentTypeEnum>;
  url?: InputMaybe<Scalars['String']>;
};

export enum EncounterTaskAttachmentTypeEnum {
  BARCODE = 'BARCODE',
  FORMS = 'FORMS',
  GUARDIANSHIP = 'GUARDIANSHIP',
  LAB_RESULT = 'LAB_RESULT',
  LEAVE_BEHIND = 'LEAVE_BEHIND',
  LOT_NUMBER = 'LOT_NUMBER',
  PATIENT_ID_BACK = 'PATIENT_ID_BACK',
  PATIENT_ID_FRONT = 'PATIENT_ID_FRONT',
  PHYSICAL_EXAM = 'PHYSICAL_EXAM',
  REQUISITION_FORM = 'REQUISITION_FORM',
  SHIPPING_LABEL = 'SHIPPING_LABEL',
  SPECIMEN_LABEL = 'SPECIMEN_LABEL',
  STANDING_ORDER = 'STANDING_ORDER',
  TEST_RESULT = 'TEST_RESULT',
  TRANSFER_OF_CARE = 'TRANSFER_OF_CARE',
  VACCINATION_LETTER = 'VACCINATION_LETTER',
  WORK_SCHOOL_NOTE = 'WORK_SCHOOL_NOTE'
}

/** A connection to a list of `EncounterTaskAttachment` values. */
export type EncounterTaskAttachmentsConnection = {
  __typename: 'EncounterTaskAttachmentsConnection';
  /** A list of edges which contains the `EncounterTaskAttachment` and cursor to aid in pagination. */
  edges: Array<EncounterTaskAttachmentsEdge>;
  /** A list of `EncounterTaskAttachment` objects. */
  nodes: Array<EncounterTaskAttachment>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `EncounterTaskAttachment` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `EncounterTaskAttachment` edge in the connection. */
export type EncounterTaskAttachmentsEdge = {
  __typename: 'EncounterTaskAttachmentsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `EncounterTaskAttachment` at the end of the edge. */
  node: EncounterTaskAttachment;
};

/** Methods to use when ordering `EncounterTaskAttachment`. */
export enum EncounterTaskAttachmentsOrderBy {
  ENCOUNTER_TASK_ATTACHMENT_ID_ASC = 'ENCOUNTER_TASK_ATTACHMENT_ID_ASC',
  ENCOUNTER_TASK_ATTACHMENT_ID_DESC = 'ENCOUNTER_TASK_ATTACHMENT_ID_DESC',
  ENCOUNTER_TASK_ID_ASC = 'ENCOUNTER_TASK_ID_ASC',
  ENCOUNTER_TASK_ID_DESC = 'ENCOUNTER_TASK_ID_DESC',
  NATURAL = 'NATURAL',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC'
}

/** Contains comments related to an encounter task */
export type EncounterTaskComment = Node & {
  __typename: 'EncounterTaskComment';
  comment?: Maybe<Scalars['String']>;
  createdAt: Scalars['Datetime'];
  createdById?: Maybe<Scalars['Int']>;
  deletedAt?: Maybe<Scalars['Datetime']>;
  encounterId?: Maybe<Scalars['Int']>;
  encounterTaskCommentId: Scalars['Int'];
  encounterTaskId?: Maybe<Scalars['Int']>;
  isDeleted: Scalars['Boolean'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
};

/**
 * A condition to be used against `EncounterTaskComment` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type EncounterTaskCommentCondition = {
  /** Checks for equality with the object’s `encounterTaskCommentId` field. */
  encounterTaskCommentId?: InputMaybe<Scalars['Int']>;
};

/** A connection to a list of `EncounterTaskComment` values. */
export type EncounterTaskCommentsConnection = {
  __typename: 'EncounterTaskCommentsConnection';
  /** A list of edges which contains the `EncounterTaskComment` and cursor to aid in pagination. */
  edges: Array<EncounterTaskCommentsEdge>;
  /** A list of `EncounterTaskComment` objects. */
  nodes: Array<EncounterTaskComment>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `EncounterTaskComment` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `EncounterTaskComment` edge in the connection. */
export type EncounterTaskCommentsEdge = {
  __typename: 'EncounterTaskCommentsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `EncounterTaskComment` at the end of the edge. */
  node: EncounterTaskComment;
};

/** Methods to use when ordering `EncounterTaskComment`. */
export enum EncounterTaskCommentsOrderBy {
  ENCOUNTER_TASK_COMMENT_ID_ASC = 'ENCOUNTER_TASK_COMMENT_ID_ASC',
  ENCOUNTER_TASK_COMMENT_ID_DESC = 'ENCOUNTER_TASK_COMMENT_ID_DESC',
  NATURAL = 'NATURAL',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC'
}

/**
 * A condition to be used against `EncounterTask` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type EncounterTaskCondition = {
  /** Checks for equality with the object’s `encounterId` field. */
  encounterId?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `encounterTaskId` field. */
  encounterTaskId?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `migrationSource` field. */
  migrationSource?: InputMaybe<Scalars['String']>;
};

/** Contains correction data for an encounter task */
export type EncounterTaskCorrection = Node & {
  __typename: 'EncounterTaskCorrection';
  correctionReason: Scalars['String'];
  createdAt: Scalars['Datetime'];
  createdBy: Scalars['Int'];
  dataType: EncounterTaskDataTypeEnum;
  encounterTaskCorrectionId: Scalars['Int'];
  encounterTaskId: Scalars['Int'];
  jsonValue: Scalars['JSON'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  version: Scalars['Int'];
};

/**
 * A condition to be used against `EncounterTaskCorrection` object types. All
 * fields are tested for equality and combined with a logical ‘and.’
 */
export type EncounterTaskCorrectionCondition = {
  /** Checks for equality with the object’s `encounterTaskCorrectionId` field. */
  encounterTaskCorrectionId?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `encounterTaskId` field. */
  encounterTaskId?: InputMaybe<Scalars['Int']>;
};

/** A connection to a list of `EncounterTaskCorrection` values. */
export type EncounterTaskCorrectionsConnection = {
  __typename: 'EncounterTaskCorrectionsConnection';
  /** A list of edges which contains the `EncounterTaskCorrection` and cursor to aid in pagination. */
  edges: Array<EncounterTaskCorrectionsEdge>;
  /** A list of `EncounterTaskCorrection` objects. */
  nodes: Array<EncounterTaskCorrection>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `EncounterTaskCorrection` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `EncounterTaskCorrection` edge in the connection. */
export type EncounterTaskCorrectionsEdge = {
  __typename: 'EncounterTaskCorrectionsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `EncounterTaskCorrection` at the end of the edge. */
  node: EncounterTaskCorrection;
};

/** Methods to use when ordering `EncounterTaskCorrection`. */
export enum EncounterTaskCorrectionsOrderBy {
  ENCOUNTER_TASK_CORRECTION_ID_ASC = 'ENCOUNTER_TASK_CORRECTION_ID_ASC',
  ENCOUNTER_TASK_CORRECTION_ID_DESC = 'ENCOUNTER_TASK_CORRECTION_ID_DESC',
  ENCOUNTER_TASK_ID_ASC = 'ENCOUNTER_TASK_ID_ASC',
  ENCOUNTER_TASK_ID_DESC = 'ENCOUNTER_TASK_ID_DESC',
  NATURAL = 'NATURAL',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC'
}

export enum EncounterTaskDataTypeEnum {
  ATTACHMENT = 'ATTACHMENT',
  BILLING_DIAGNOSTICS = 'BILLING_DIAGNOSTICS',
  CHIEF_COMPLAINT_AND_HPI = 'CHIEF_COMPLAINT_AND_HPI',
  DISPOSITION = 'DISPOSITION',
  ENCOUNTER = 'ENCOUNTER',
  LAB_TEST = 'LAB_TEST',
  MEDICAL_DECISION_MAKING = 'MEDICAL_DECISION_MAKING',
  PATIENT = 'PATIENT',
  PATIENT_ALLERGY = 'PATIENT_ALLERGY',
  PATIENT_FORM = 'PATIENT_FORM',
  PATIENT_PROBLEM = 'PATIENT_PROBLEM',
  PHYSICAL_EXAM = 'PHYSICAL_EXAM',
  POINT_OF_CARE_TEST = 'POINT_OF_CARE_TEST',
  PROGRESS_NOTE = 'PROGRESS_NOTE',
  QUESTIONNAIRE = 'QUESTIONNAIRE',
  REVIEWING_CLINICIAN = 'REVIEWING_CLINICIAN',
  TELADOC = 'TELADOC',
  TELEHEALTH_MEETING = 'TELEHEALTH_MEETING',
  VACCINE = 'VACCINE',
  VITAL = 'VITAL'
}

/** A connection to a list of `DiagnosisCodeReference` values, with data from `PatientDiagnosis`. */
export type EncounterTaskDiagnosisCodeReferencesByPatientDiagnosisEncounterTaskIdAndDiagnosisCodeReferenceIdManyToManyConnection = {
  __typename: 'EncounterTaskDiagnosisCodeReferencesByPatientDiagnosisEncounterTaskIdAndDiagnosisCodeReferenceIdManyToManyConnection';
  /** A list of edges which contains the `DiagnosisCodeReference`, info from the `PatientDiagnosis`, and the cursor to aid in pagination. */
  edges: Array<EncounterTaskDiagnosisCodeReferencesByPatientDiagnosisEncounterTaskIdAndDiagnosisCodeReferenceIdManyToManyEdge>;
  /** A list of `DiagnosisCodeReference` objects. */
  nodes: Array<DiagnosisCodeReference>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `DiagnosisCodeReference` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `DiagnosisCodeReference` edge in the connection, with data from `PatientDiagnosis`. */
export type EncounterTaskDiagnosisCodeReferencesByPatientDiagnosisEncounterTaskIdAndDiagnosisCodeReferenceIdManyToManyEdge = {
  __typename: 'EncounterTaskDiagnosisCodeReferencesByPatientDiagnosisEncounterTaskIdAndDiagnosisCodeReferenceIdManyToManyEdge';
  createdAt: Scalars['Datetime'];
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  deletedAt?: Maybe<Scalars['Datetime']>;
  isDeleted: Scalars['Boolean'];
  /** The `DiagnosisCodeReference` at the end of the edge. */
  node: DiagnosisCodeReference;
  order: Scalars['Int'];
  patientDiagnosisId: Scalars['Int'];
  updatedAt: Scalars['Datetime'];
};

/** Represents an update to a `EncounterTask`. Fields that are set will be updated. */
export type EncounterTaskPatch = {
  clinicianReviewedAt?: InputMaybe<Scalars['Datetime']>;
  inProgressAt?: InputMaybe<Scalars['Datetime']>;
  responderCompletedAt?: InputMaybe<Scalars['Datetime']>;
  skippedAt?: InputMaybe<Scalars['Datetime']>;
  skippedBy?: InputMaybe<Scalars['String']>;
  skippedReason?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** A connection to a list of `PointOfCareTestLookup` values, with data from `PointOfCareTest`. */
export type EncounterTaskPointOfCareTestLookupsByPointOfCareTestEncounterTaskIdAndPointOfCareTestLookupIdManyToManyConnection = {
  __typename: 'EncounterTaskPointOfCareTestLookupsByPointOfCareTestEncounterTaskIdAndPointOfCareTestLookupIdManyToManyConnection';
  /** A list of edges which contains the `PointOfCareTestLookup`, info from the `PointOfCareTest`, and the cursor to aid in pagination. */
  edges: Array<EncounterTaskPointOfCareTestLookupsByPointOfCareTestEncounterTaskIdAndPointOfCareTestLookupIdManyToManyEdge>;
  /** A list of `PointOfCareTestLookup` objects. */
  nodes: Array<PointOfCareTestLookup>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `PointOfCareTestLookup` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `PointOfCareTestLookup` edge in the connection, with data from `PointOfCareTest`. */
export type EncounterTaskPointOfCareTestLookupsByPointOfCareTestEncounterTaskIdAndPointOfCareTestLookupIdManyToManyEdge = {
  __typename: 'EncounterTaskPointOfCareTestLookupsByPointOfCareTestEncounterTaskIdAndPointOfCareTestLookupIdManyToManyEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `PointOfCareTestLookup` at the end of the edge. */
  node: PointOfCareTestLookup;
  /** Reads and enables pagination through a set of `PointOfCareTest`. */
  pointOfCareTests: PointOfCareTestsConnection;
  /** Reads and enables pagination through a set of `PointOfCareTest`. */
  pointOfCareTestsList: Array<PointOfCareTest>;
};


/** A `PointOfCareTestLookup` edge in the connection, with data from `PointOfCareTest`. */
export type EncounterTaskPointOfCareTestLookupsByPointOfCareTestEncounterTaskIdAndPointOfCareTestLookupIdManyToManyEdgepointOfCareTestsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<PointOfCareTestCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PointOfCareTestsOrderBy>>;
};


/** A `PointOfCareTestLookup` edge in the connection, with data from `PointOfCareTest`. */
export type EncounterTaskPointOfCareTestLookupsByPointOfCareTestEncounterTaskIdAndPointOfCareTestLookupIdManyToManyEdgepointOfCareTestsListArgs = {
  condition?: InputMaybe<PointOfCareTestCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PointOfCareTestsOrderBy>>;
};

/** A connection to a list of `ProcedureCodeReference` values, with data from `BillingDiagnostic`. */
export type EncounterTaskProcedureCodeReferencesByBillingDiagnosticEncounterTaskIdAndProcedureCodeReferenceIdManyToManyConnection = {
  __typename: 'EncounterTaskProcedureCodeReferencesByBillingDiagnosticEncounterTaskIdAndProcedureCodeReferenceIdManyToManyConnection';
  /** A list of edges which contains the `ProcedureCodeReference`, info from the `BillingDiagnostic`, and the cursor to aid in pagination. */
  edges: Array<EncounterTaskProcedureCodeReferencesByBillingDiagnosticEncounterTaskIdAndProcedureCodeReferenceIdManyToManyEdge>;
  /** A list of `ProcedureCodeReference` objects. */
  nodes: Array<ProcedureCodeReference>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ProcedureCodeReference` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `ProcedureCodeReference` edge in the connection, with data from `BillingDiagnostic`. */
export type EncounterTaskProcedureCodeReferencesByBillingDiagnosticEncounterTaskIdAndProcedureCodeReferenceIdManyToManyEdge = {
  __typename: 'EncounterTaskProcedureCodeReferencesByBillingDiagnosticEncounterTaskIdAndProcedureCodeReferenceIdManyToManyEdge';
  billingDiagnosticsId: Scalars['Int'];
  createdAt: Scalars['Datetime'];
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  deletedAt?: Maybe<Scalars['Datetime']>;
  isDeleted: Scalars['Boolean'];
  /** The `ProcedureCodeReference` at the end of the edge. */
  node: ProcedureCodeReference;
  updatedAt: Scalars['Datetime'];
};

export enum EncounterTaskStatusEnum {
  CLINICIAN_REVIEWED = 'CLINICIAN_REVIEWED',
  IN_PROGRESS = 'IN_PROGRESS',
  NOT_STARTED = 'NOT_STARTED',
  RESPONDER_COMPLETED = 'RESPONDER_COMPLETED',
  SKIPPED = 'SKIPPED'
}

/** A connection to a list of `VitalLookup` values, with data from `Vital`. */
export type EncounterTaskVitalLookupsByVitalEncounterTaskIdAndVitalLookupIdManyToManyConnection = {
  __typename: 'EncounterTaskVitalLookupsByVitalEncounterTaskIdAndVitalLookupIdManyToManyConnection';
  /** A list of edges which contains the `VitalLookup`, info from the `Vital`, and the cursor to aid in pagination. */
  edges: Array<EncounterTaskVitalLookupsByVitalEncounterTaskIdAndVitalLookupIdManyToManyEdge>;
  /** A list of `VitalLookup` objects. */
  nodes: Array<VitalLookup>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `VitalLookup` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `VitalLookup` edge in the connection, with data from `Vital`. */
export type EncounterTaskVitalLookupsByVitalEncounterTaskIdAndVitalLookupIdManyToManyEdge = {
  __typename: 'EncounterTaskVitalLookupsByVitalEncounterTaskIdAndVitalLookupIdManyToManyEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `VitalLookup` at the end of the edge. */
  node: VitalLookup;
  /** Reads and enables pagination through a set of `Vital`. */
  vitals: VitalsConnection;
  /** Reads and enables pagination through a set of `Vital`. */
  vitalsList: Array<Vital>;
};


/** A `VitalLookup` edge in the connection, with data from `Vital`. */
export type EncounterTaskVitalLookupsByVitalEncounterTaskIdAndVitalLookupIdManyToManyEdgevitalsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<VitalCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VitalsOrderBy>>;
};


/** A `VitalLookup` edge in the connection, with data from `Vital`. */
export type EncounterTaskVitalLookupsByVitalEncounterTaskIdAndVitalLookupIdManyToManyEdgevitalsListArgs = {
  condition?: InputMaybe<VitalCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VitalsOrderBy>>;
};

/** A connection to a list of `EncounterTask` values. */
export type EncounterTasksConnection = {
  __typename: 'EncounterTasksConnection';
  /** A list of edges which contains the `EncounterTask` and cursor to aid in pagination. */
  edges: Array<EncounterTasksEdge>;
  /** A list of `EncounterTask` objects. */
  nodes: Array<EncounterTask>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `EncounterTask` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `EncounterTask` edge in the connection. */
export type EncounterTasksEdge = {
  __typename: 'EncounterTasksEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `EncounterTask` at the end of the edge. */
  node: EncounterTask;
};

/** Methods to use when ordering `EncounterTask`. */
export enum EncounterTasksOrderBy {
  ENCOUNTER_ID_ASC = 'ENCOUNTER_ID_ASC',
  ENCOUNTER_ID_DESC = 'ENCOUNTER_ID_DESC',
  ENCOUNTER_TASK_ID_ASC = 'ENCOUNTER_TASK_ID_ASC',
  ENCOUNTER_TASK_ID_DESC = 'ENCOUNTER_TASK_ID_DESC',
  MIGRATION_SOURCE_ASC = 'MIGRATION_SOURCE_ASC',
  MIGRATION_SOURCE_DESC = 'MIGRATION_SOURCE_DESC',
  NATURAL = 'NATURAL',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC'
}

/** A connection to a list of `Encounter` values. */
export type EncountersConnection = {
  __typename: 'EncountersConnection';
  /** A list of edges which contains the `Encounter` and cursor to aid in pagination. */
  edges: Array<EncountersEdge>;
  /** A list of `Encounter` objects. */
  nodes: Array<Encounter>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Encounter` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Encounter` edge in the connection. */
export type EncountersEdge = {
  __typename: 'EncountersEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `Encounter` at the end of the edge. */
  node: Encounter;
};

/** Methods to use when ordering `Encounter`. */
export enum EncountersOrderBy {
  APPOINTMENT_ID_ASC = 'APPOINTMENT_ID_ASC',
  APPOINTMENT_ID_DESC = 'APPOINTMENT_ID_DESC',
  ENCOUNTER_ID_ASC = 'ENCOUNTER_ID_ASC',
  ENCOUNTER_ID_DESC = 'ENCOUNTER_ID_DESC',
  MIGRATION_SOURCE_ASC = 'MIGRATION_SOURCE_ASC',
  MIGRATION_SOURCE_DESC = 'MIGRATION_SOURCE_DESC',
  NATURAL = 'NATURAL',
  PATIENT_ID_ASC = 'PATIENT_ID_ASC',
  PATIENT_ID_DESC = 'PATIENT_ID_DESC',
  PRIMARY_INSURANCE_ASC = 'PRIMARY_INSURANCE_ASC',
  PRIMARY_INSURANCE_DESC = 'PRIMARY_INSURANCE_DESC',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  SCHEDULED_FOR_ASC = 'SCHEDULED_FOR_ASC',
  SCHEDULED_FOR_DESC = 'SCHEDULED_FOR_DESC',
  SECONDARY_INSURANCE_ASC = 'SECONDARY_INSURANCE_ASC',
  SECONDARY_INSURANCE_DESC = 'SECONDARY_INSURANCE_DESC',
  SERVICE_LINE_ID_ASC = 'SERVICE_LINE_ID_ASC',
  SERVICE_LINE_ID_DESC = 'SERVICE_LINE_ID_DESC'
}

export type FeatureGate = Node & {
  __typename: 'FeatureGate';
  createdAt: Scalars['Datetime'];
  featureId: Scalars['String'];
  isActive: Scalars['Boolean'];
  marketId: Array<Maybe<Scalars['Int']>>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  updatedAt: Scalars['Datetime'];
  zoneId: Array<Maybe<Scalars['Int']>>;
};

/**
 * A condition to be used against `FeatureGate` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type FeatureGateCondition = {
  /** Checks for equality with the object’s `featureId` field. */
  featureId?: InputMaybe<Scalars['String']>;
};

/** An input for mutations affecting `FeatureGate` */
export type FeatureGateInput = {
  createdAt?: InputMaybe<Scalars['Datetime']>;
  featureId: Scalars['String'];
  isActive?: InputMaybe<Scalars['Boolean']>;
  marketId?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  zoneId?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
};

/** Represents an update to a `FeatureGate`. Fields that are set will be updated. */
export type FeatureGatePatch = {
  createdAt?: InputMaybe<Scalars['Datetime']>;
  featureId?: InputMaybe<Scalars['String']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  marketId?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  zoneId?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
};

export type FeatureGateResultOutput = {
  __typename: 'FeatureGateResultOutput';
  result?: Maybe<Scalars['Boolean']>;
};

/** A connection to a list of `FeatureGate` values. */
export type FeatureGatesConnection = {
  __typename: 'FeatureGatesConnection';
  /** A list of edges which contains the `FeatureGate` and cursor to aid in pagination. */
  edges: Array<FeatureGatesEdge>;
  /** A list of `FeatureGate` objects. */
  nodes: Array<FeatureGate>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `FeatureGate` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `FeatureGate` edge in the connection. */
export type FeatureGatesEdge = {
  __typename: 'FeatureGatesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `FeatureGate` at the end of the edge. */
  node: FeatureGate;
};

/** Methods to use when ordering `FeatureGate`. */
export enum FeatureGatesOrderBy {
  FEATURE_ID_ASC = 'FEATURE_ID_ASC',
  FEATURE_ID_DESC = 'FEATURE_ID_DESC',
  NATURAL = 'NATURAL',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC'
}

export enum GenderIdentityEnum {
  FEMALE = 'FEMALE',
  MALE = 'MALE',
  NON_BINARY = 'NON_BINARY',
  NON_DISCLOSE = 'NON_DISCLOSE',
  OTHER = 'OTHER',
  TRANSGENDER_FEMALE = 'TRANSGENDER_FEMALE',
  TRANSGENDER_MALE = 'TRANSGENDER_MALE'
}

export enum GenderPronounEnum {
  HE_HIM = 'HE_HIM',
  SHE_HER = 'SHE_HER',
  THEY_THEM = 'THEY_THEM'
}

export type GenerateDoseSpotURLRequest = {
  encounterId?: InputMaybe<Scalars['Int']>;
  marketId: Scalars['Int'];
  patientId: Scalars['Int'];
};

/** All input for the `grantItRole` mutation. */
export type GrantItRoleInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
};

/** The output of our `grantItRole` mutation. */
export type GrantItRolePayload = {
  __typename: 'GrantItRolePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  user?: Maybe<User>;
  /** An edge for our `User`. May be used by Relay 1. */
  userEdge?: Maybe<UsersEdge>;
};


/** The output of our `grantItRole` mutation. */
export type GrantItRolePayloaduserEdgeArgs = {
  orderBy?: InputMaybe<Array<UsersOrderBy>>;
};

export type GrantRoleInput = {
  patch: GrantRolePatchRecordInput;
  userId: Scalars['Int'];
};

export type GrantRolePatchRecordInput = {
  credentials?: InputMaybe<Array<InputMaybe<CredentialsEnum>>>;
  dob?: InputMaybe<Scalars['Date']>;
  markets?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  npi?: InputMaybe<Scalars['String']>;
  registeredFirstName?: InputMaybe<Scalars['String']>;
  registeredLastName?: InputMaybe<Scalars['String']>;
  role?: InputMaybe<UserRoleEnum>;
};

export type GrantRolePayload = {
  __typename: 'GrantRolePayload';
  query?: Maybe<Query>;
  user?: Maybe<User>;
};

export enum IdentifierTypeEnum {
  DOSESPOT = 'DOSESPOT',
  NPI = 'NPI'
}

/** Contains information an insurance record associated with a patient */
export type InsuranceRecord = Node & {
  __typename: 'InsuranceRecord';
  address1?: Maybe<Scalars['String']>;
  address2?: Maybe<Scalars['String']>;
  /** Reads and enables pagination through a set of `Appointment`. */
  appointmentsByEncounterPrimaryInsuranceAndAppointmentId: InsuranceRecordAppointmentsByEncounterPrimaryInsuranceAndAppointmentIdManyToManyConnection;
  /** Reads and enables pagination through a set of `Appointment`. */
  appointmentsByEncounterPrimaryInsuranceAndAppointmentIdList: Array<Appointment>;
  /** Reads and enables pagination through a set of `Appointment`. */
  appointmentsByEncounterSecondaryInsuranceAndAppointmentId: InsuranceRecordAppointmentsByEncounterSecondaryInsuranceAndAppointmentIdManyToManyConnection;
  /** Reads and enables pagination through a set of `Appointment`. */
  appointmentsByEncounterSecondaryInsuranceAndAppointmentIdList: Array<Appointment>;
  attachmentBackUrl?: Maybe<Scalars['JSON']>;
  attachmentFrontUrl?: Maybe<Scalars['JSON']>;
  city?: Maybe<Scalars['String']>;
  company?: Maybe<Scalars['String']>;
  /** Reads and enables pagination through a set of `Encounter`. */
  encountersByPrimaryInsurance: EncountersConnection;
  /** Reads and enables pagination through a set of `Encounter`. */
  encountersByPrimaryInsuranceList: Array<Encounter>;
  /** Reads and enables pagination through a set of `Encounter`. */
  encountersBySecondaryInsurance: EncountersConnection;
  /** Reads and enables pagination through a set of `Encounter`. */
  encountersBySecondaryInsuranceList: Array<Encounter>;
  groupNumber?: Maybe<Scalars['String']>;
  /** Integer Primary Key for record */
  insuranceRecordId: Scalars['Int'];
  /** Reads and enables pagination through a set of `InsuranceRecord`. */
  insuranceRecordsByEncounterPrimaryInsuranceAndSecondaryInsurance: InsuranceRecordInsuranceRecordsByEncounterPrimaryInsuranceAndSecondaryInsuranceManyToManyConnection;
  /** Reads and enables pagination through a set of `InsuranceRecord`. */
  insuranceRecordsByEncounterPrimaryInsuranceAndSecondaryInsuranceList: Array<InsuranceRecord>;
  /** Reads and enables pagination through a set of `InsuranceRecord`. */
  insuranceRecordsByEncounterSecondaryInsuranceAndPrimaryInsurance: InsuranceRecordInsuranceRecordsByEncounterSecondaryInsuranceAndPrimaryInsuranceManyToManyConnection;
  /** Reads and enables pagination through a set of `InsuranceRecord`. */
  insuranceRecordsByEncounterSecondaryInsuranceAndPrimaryInsuranceList: Array<InsuranceRecord>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  memberId?: Maybe<Scalars['String']>;
  noInsuranceCards?: Maybe<Scalars['Boolean']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  packageId?: Maybe<Scalars['String']>;
  /** Reads a single `Patient` that is related to this `InsuranceRecord`. */
  patient?: Maybe<Patient>;
  patientId: Scalars['Int'];
  /** Reads and enables pagination through a set of `Patient`. */
  patientsByEncounterPrimaryInsuranceAndPatientId: InsuranceRecordPatientsByEncounterPrimaryInsuranceAndPatientIdManyToManyConnection;
  /** Reads and enables pagination through a set of `Patient`. */
  patientsByEncounterPrimaryInsuranceAndPatientIdList: Array<Patient>;
  /** Reads and enables pagination through a set of `Patient`. */
  patientsByEncounterSecondaryInsuranceAndPatientId: InsuranceRecordPatientsByEncounterSecondaryInsuranceAndPatientIdManyToManyConnection;
  /** Reads and enables pagination through a set of `Patient`. */
  patientsByEncounterSecondaryInsuranceAndPatientIdList: Array<Patient>;
  planType?: Maybe<Scalars['String']>;
  policyHolderDob?: Maybe<Scalars['Date']>;
  policyHolderFirstName?: Maybe<Scalars['String']>;
  policyHolderGender?: Maybe<SexEnum>;
  policyHolderLastName?: Maybe<Scalars['String']>;
  relationshipToPolicyHolder?: Maybe<Scalars['String']>;
  /** Reads and enables pagination through a set of `ServiceLine`. */
  serviceLinesByEncounterPrimaryInsuranceAndServiceLineId: InsuranceRecordServiceLinesByEncounterPrimaryInsuranceAndServiceLineIdManyToManyConnection;
  /** Reads and enables pagination through a set of `ServiceLine`. */
  serviceLinesByEncounterPrimaryInsuranceAndServiceLineIdList: Array<ServiceLine>;
  /** Reads and enables pagination through a set of `ServiceLine`. */
  serviceLinesByEncounterSecondaryInsuranceAndServiceLineId: InsuranceRecordServiceLinesByEncounterSecondaryInsuranceAndServiceLineIdManyToManyConnection;
  /** Reads and enables pagination through a set of `ServiceLine`. */
  serviceLinesByEncounterSecondaryInsuranceAndServiceLineIdList: Array<ServiceLine>;
  state?: Maybe<Scalars['String']>;
  systemLastUpdatedBy: SystemOfOriginEnum;
  /** Timestamp of when the record was last updated */
  updatedAt?: Maybe<Scalars['Datetime']>;
  zip?: Maybe<Scalars['String']>;
};


/** Contains information an insurance record associated with a patient */
export type InsuranceRecordappointmentsByEncounterPrimaryInsuranceAndAppointmentIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<AppointmentCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AppointmentsOrderBy>>;
};


/** Contains information an insurance record associated with a patient */
export type InsuranceRecordappointmentsByEncounterPrimaryInsuranceAndAppointmentIdListArgs = {
  condition?: InputMaybe<AppointmentCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AppointmentsOrderBy>>;
};


/** Contains information an insurance record associated with a patient */
export type InsuranceRecordappointmentsByEncounterSecondaryInsuranceAndAppointmentIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<AppointmentCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AppointmentsOrderBy>>;
};


/** Contains information an insurance record associated with a patient */
export type InsuranceRecordappointmentsByEncounterSecondaryInsuranceAndAppointmentIdListArgs = {
  condition?: InputMaybe<AppointmentCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AppointmentsOrderBy>>;
};


/** Contains information an insurance record associated with a patient */
export type InsuranceRecordencountersByPrimaryInsuranceArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<EncounterCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EncountersOrderBy>>;
};


/** Contains information an insurance record associated with a patient */
export type InsuranceRecordencountersByPrimaryInsuranceListArgs = {
  condition?: InputMaybe<EncounterCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EncountersOrderBy>>;
};


/** Contains information an insurance record associated with a patient */
export type InsuranceRecordencountersBySecondaryInsuranceArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<EncounterCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EncountersOrderBy>>;
};


/** Contains information an insurance record associated with a patient */
export type InsuranceRecordencountersBySecondaryInsuranceListArgs = {
  condition?: InputMaybe<EncounterCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EncountersOrderBy>>;
};


/** Contains information an insurance record associated with a patient */
export type InsuranceRecordinsuranceRecordsByEncounterPrimaryInsuranceAndSecondaryInsuranceArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<InsuranceRecordCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InsuranceRecordsOrderBy>>;
};


/** Contains information an insurance record associated with a patient */
export type InsuranceRecordinsuranceRecordsByEncounterPrimaryInsuranceAndSecondaryInsuranceListArgs = {
  condition?: InputMaybe<InsuranceRecordCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InsuranceRecordsOrderBy>>;
};


/** Contains information an insurance record associated with a patient */
export type InsuranceRecordinsuranceRecordsByEncounterSecondaryInsuranceAndPrimaryInsuranceArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<InsuranceRecordCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InsuranceRecordsOrderBy>>;
};


/** Contains information an insurance record associated with a patient */
export type InsuranceRecordinsuranceRecordsByEncounterSecondaryInsuranceAndPrimaryInsuranceListArgs = {
  condition?: InputMaybe<InsuranceRecordCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InsuranceRecordsOrderBy>>;
};


/** Contains information an insurance record associated with a patient */
export type InsuranceRecordpatientsByEncounterPrimaryInsuranceAndPatientIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<PatientCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PatientsOrderBy>>;
};


/** Contains information an insurance record associated with a patient */
export type InsuranceRecordpatientsByEncounterPrimaryInsuranceAndPatientIdListArgs = {
  condition?: InputMaybe<PatientCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PatientsOrderBy>>;
};


/** Contains information an insurance record associated with a patient */
export type InsuranceRecordpatientsByEncounterSecondaryInsuranceAndPatientIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<PatientCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PatientsOrderBy>>;
};


/** Contains information an insurance record associated with a patient */
export type InsuranceRecordpatientsByEncounterSecondaryInsuranceAndPatientIdListArgs = {
  condition?: InputMaybe<PatientCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PatientsOrderBy>>;
};


/** Contains information an insurance record associated with a patient */
export type InsuranceRecordserviceLinesByEncounterPrimaryInsuranceAndServiceLineIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ServiceLineCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ServiceLinesOrderBy>>;
};


/** Contains information an insurance record associated with a patient */
export type InsuranceRecordserviceLinesByEncounterPrimaryInsuranceAndServiceLineIdListArgs = {
  condition?: InputMaybe<ServiceLineCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ServiceLinesOrderBy>>;
};


/** Contains information an insurance record associated with a patient */
export type InsuranceRecordserviceLinesByEncounterSecondaryInsuranceAndServiceLineIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ServiceLineCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ServiceLinesOrderBy>>;
};


/** Contains information an insurance record associated with a patient */
export type InsuranceRecordserviceLinesByEncounterSecondaryInsuranceAndServiceLineIdListArgs = {
  condition?: InputMaybe<ServiceLineCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ServiceLinesOrderBy>>;
};

/** A connection to a list of `Appointment` values, with data from `Encounter`. */
export type InsuranceRecordAppointmentsByEncounterPrimaryInsuranceAndAppointmentIdManyToManyConnection = {
  __typename: 'InsuranceRecordAppointmentsByEncounterPrimaryInsuranceAndAppointmentIdManyToManyConnection';
  /** A list of edges which contains the `Appointment`, info from the `Encounter`, and the cursor to aid in pagination. */
  edges: Array<InsuranceRecordAppointmentsByEncounterPrimaryInsuranceAndAppointmentIdManyToManyEdge>;
  /** A list of `Appointment` objects. */
  nodes: Array<Appointment>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Appointment` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Appointment` edge in the connection, with data from `Encounter`. */
export type InsuranceRecordAppointmentsByEncounterPrimaryInsuranceAndAppointmentIdManyToManyEdge = {
  __typename: 'InsuranceRecordAppointmentsByEncounterPrimaryInsuranceAndAppointmentIdManyToManyEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** Reads and enables pagination through a set of `Encounter`. */
  encounters: EncountersConnection;
  /** Reads and enables pagination through a set of `Encounter`. */
  encountersList: Array<Encounter>;
  /** The `Appointment` at the end of the edge. */
  node: Appointment;
};


/** A `Appointment` edge in the connection, with data from `Encounter`. */
export type InsuranceRecordAppointmentsByEncounterPrimaryInsuranceAndAppointmentIdManyToManyEdgeencountersArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<EncounterCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EncountersOrderBy>>;
};


/** A `Appointment` edge in the connection, with data from `Encounter`. */
export type InsuranceRecordAppointmentsByEncounterPrimaryInsuranceAndAppointmentIdManyToManyEdgeencountersListArgs = {
  condition?: InputMaybe<EncounterCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EncountersOrderBy>>;
};

/** A connection to a list of `Appointment` values, with data from `Encounter`. */
export type InsuranceRecordAppointmentsByEncounterSecondaryInsuranceAndAppointmentIdManyToManyConnection = {
  __typename: 'InsuranceRecordAppointmentsByEncounterSecondaryInsuranceAndAppointmentIdManyToManyConnection';
  /** A list of edges which contains the `Appointment`, info from the `Encounter`, and the cursor to aid in pagination. */
  edges: Array<InsuranceRecordAppointmentsByEncounterSecondaryInsuranceAndAppointmentIdManyToManyEdge>;
  /** A list of `Appointment` objects. */
  nodes: Array<Appointment>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Appointment` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Appointment` edge in the connection, with data from `Encounter`. */
export type InsuranceRecordAppointmentsByEncounterSecondaryInsuranceAndAppointmentIdManyToManyEdge = {
  __typename: 'InsuranceRecordAppointmentsByEncounterSecondaryInsuranceAndAppointmentIdManyToManyEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** Reads and enables pagination through a set of `Encounter`. */
  encounters: EncountersConnection;
  /** Reads and enables pagination through a set of `Encounter`. */
  encountersList: Array<Encounter>;
  /** The `Appointment` at the end of the edge. */
  node: Appointment;
};


/** A `Appointment` edge in the connection, with data from `Encounter`. */
export type InsuranceRecordAppointmentsByEncounterSecondaryInsuranceAndAppointmentIdManyToManyEdgeencountersArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<EncounterCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EncountersOrderBy>>;
};


/** A `Appointment` edge in the connection, with data from `Encounter`. */
export type InsuranceRecordAppointmentsByEncounterSecondaryInsuranceAndAppointmentIdManyToManyEdgeencountersListArgs = {
  condition?: InputMaybe<EncounterCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EncountersOrderBy>>;
};

/**
 * A condition to be used against `InsuranceRecord` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type InsuranceRecordCondition = {
  /** Checks for equality with the object’s `insuranceRecordId` field. */
  insuranceRecordId?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `patientId` field. */
  patientId?: InputMaybe<Scalars['Int']>;
};

/** An input for mutations affecting `InsuranceRecord` */
export type InsuranceRecordInput = {
  address1?: InputMaybe<Scalars['String']>;
  address2?: InputMaybe<Scalars['String']>;
  attachmentBackUrl?: InputMaybe<Scalars['JSON']>;
  attachmentFrontUrl?: InputMaybe<Scalars['JSON']>;
  city?: InputMaybe<Scalars['String']>;
  company?: InputMaybe<Scalars['String']>;
  groupNumber?: InputMaybe<Scalars['String']>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  memberId?: InputMaybe<Scalars['String']>;
  noInsuranceCards?: InputMaybe<Scalars['Boolean']>;
  packageId?: InputMaybe<Scalars['String']>;
  patientId: Scalars['Int'];
  planType?: InputMaybe<Scalars['String']>;
  policyHolderDob?: InputMaybe<Scalars['Date']>;
  policyHolderFirstName?: InputMaybe<Scalars['String']>;
  policyHolderGender?: InputMaybe<SexEnum>;
  policyHolderLastName?: InputMaybe<Scalars['String']>;
  relationshipToPolicyHolder?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  systemLastUpdatedBy?: InputMaybe<SystemOfOriginEnum>;
  zip?: InputMaybe<Scalars['String']>;
};

/** A connection to a list of `InsuranceRecord` values, with data from `Encounter`. */
export type InsuranceRecordInsuranceRecordsByEncounterPrimaryInsuranceAndSecondaryInsuranceManyToManyConnection = {
  __typename: 'InsuranceRecordInsuranceRecordsByEncounterPrimaryInsuranceAndSecondaryInsuranceManyToManyConnection';
  /** A list of edges which contains the `InsuranceRecord`, info from the `Encounter`, and the cursor to aid in pagination. */
  edges: Array<InsuranceRecordInsuranceRecordsByEncounterPrimaryInsuranceAndSecondaryInsuranceManyToManyEdge>;
  /** A list of `InsuranceRecord` objects. */
  nodes: Array<InsuranceRecord>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `InsuranceRecord` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `InsuranceRecord` edge in the connection, with data from `Encounter`. */
export type InsuranceRecordInsuranceRecordsByEncounterPrimaryInsuranceAndSecondaryInsuranceManyToManyEdge = {
  __typename: 'InsuranceRecordInsuranceRecordsByEncounterPrimaryInsuranceAndSecondaryInsuranceManyToManyEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** Reads and enables pagination through a set of `Encounter`. */
  encountersBySecondaryInsurance: EncountersConnection;
  /** Reads and enables pagination through a set of `Encounter`. */
  encountersBySecondaryInsuranceList: Array<Encounter>;
  /** The `InsuranceRecord` at the end of the edge. */
  node: InsuranceRecord;
};


/** A `InsuranceRecord` edge in the connection, with data from `Encounter`. */
export type InsuranceRecordInsuranceRecordsByEncounterPrimaryInsuranceAndSecondaryInsuranceManyToManyEdgeencountersBySecondaryInsuranceArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<EncounterCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EncountersOrderBy>>;
};


/** A `InsuranceRecord` edge in the connection, with data from `Encounter`. */
export type InsuranceRecordInsuranceRecordsByEncounterPrimaryInsuranceAndSecondaryInsuranceManyToManyEdgeencountersBySecondaryInsuranceListArgs = {
  condition?: InputMaybe<EncounterCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EncountersOrderBy>>;
};

/** A connection to a list of `InsuranceRecord` values, with data from `Encounter`. */
export type InsuranceRecordInsuranceRecordsByEncounterSecondaryInsuranceAndPrimaryInsuranceManyToManyConnection = {
  __typename: 'InsuranceRecordInsuranceRecordsByEncounterSecondaryInsuranceAndPrimaryInsuranceManyToManyConnection';
  /** A list of edges which contains the `InsuranceRecord`, info from the `Encounter`, and the cursor to aid in pagination. */
  edges: Array<InsuranceRecordInsuranceRecordsByEncounterSecondaryInsuranceAndPrimaryInsuranceManyToManyEdge>;
  /** A list of `InsuranceRecord` objects. */
  nodes: Array<InsuranceRecord>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `InsuranceRecord` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `InsuranceRecord` edge in the connection, with data from `Encounter`. */
export type InsuranceRecordInsuranceRecordsByEncounterSecondaryInsuranceAndPrimaryInsuranceManyToManyEdge = {
  __typename: 'InsuranceRecordInsuranceRecordsByEncounterSecondaryInsuranceAndPrimaryInsuranceManyToManyEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** Reads and enables pagination through a set of `Encounter`. */
  encountersByPrimaryInsurance: EncountersConnection;
  /** Reads and enables pagination through a set of `Encounter`. */
  encountersByPrimaryInsuranceList: Array<Encounter>;
  /** The `InsuranceRecord` at the end of the edge. */
  node: InsuranceRecord;
};


/** A `InsuranceRecord` edge in the connection, with data from `Encounter`. */
export type InsuranceRecordInsuranceRecordsByEncounterSecondaryInsuranceAndPrimaryInsuranceManyToManyEdgeencountersByPrimaryInsuranceArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<EncounterCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EncountersOrderBy>>;
};


/** A `InsuranceRecord` edge in the connection, with data from `Encounter`. */
export type InsuranceRecordInsuranceRecordsByEncounterSecondaryInsuranceAndPrimaryInsuranceManyToManyEdgeencountersByPrimaryInsuranceListArgs = {
  condition?: InputMaybe<EncounterCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EncountersOrderBy>>;
};

/** Represents an update to a `InsuranceRecord`. Fields that are set will be updated. */
export type InsuranceRecordPatch = {
  address1?: InputMaybe<Scalars['String']>;
  address2?: InputMaybe<Scalars['String']>;
  attachmentBackUrl?: InputMaybe<Scalars['JSON']>;
  attachmentFrontUrl?: InputMaybe<Scalars['JSON']>;
  city?: InputMaybe<Scalars['String']>;
  company?: InputMaybe<Scalars['String']>;
  groupNumber?: InputMaybe<Scalars['String']>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  memberId?: InputMaybe<Scalars['String']>;
  noInsuranceCards?: InputMaybe<Scalars['Boolean']>;
  packageId?: InputMaybe<Scalars['String']>;
  patientId?: InputMaybe<Scalars['Int']>;
  planType?: InputMaybe<Scalars['String']>;
  policyHolderDob?: InputMaybe<Scalars['Date']>;
  policyHolderFirstName?: InputMaybe<Scalars['String']>;
  policyHolderGender?: InputMaybe<SexEnum>;
  policyHolderLastName?: InputMaybe<Scalars['String']>;
  relationshipToPolicyHolder?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  systemLastUpdatedBy?: InputMaybe<SystemOfOriginEnum>;
  /** Timestamp of when the record was last updated */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  zip?: InputMaybe<Scalars['String']>;
};

/** A connection to a list of `Patient` values, with data from `Encounter`. */
export type InsuranceRecordPatientsByEncounterPrimaryInsuranceAndPatientIdManyToManyConnection = {
  __typename: 'InsuranceRecordPatientsByEncounterPrimaryInsuranceAndPatientIdManyToManyConnection';
  /** A list of edges which contains the `Patient`, info from the `Encounter`, and the cursor to aid in pagination. */
  edges: Array<InsuranceRecordPatientsByEncounterPrimaryInsuranceAndPatientIdManyToManyEdge>;
  /** A list of `Patient` objects. */
  nodes: Array<Patient>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Patient` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Patient` edge in the connection, with data from `Encounter`. */
export type InsuranceRecordPatientsByEncounterPrimaryInsuranceAndPatientIdManyToManyEdge = {
  __typename: 'InsuranceRecordPatientsByEncounterPrimaryInsuranceAndPatientIdManyToManyEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** Reads and enables pagination through a set of `Encounter`. */
  encounters: EncountersConnection;
  /** Reads and enables pagination through a set of `Encounter`. */
  encountersList: Array<Encounter>;
  /** The `Patient` at the end of the edge. */
  node: Patient;
};


/** A `Patient` edge in the connection, with data from `Encounter`. */
export type InsuranceRecordPatientsByEncounterPrimaryInsuranceAndPatientIdManyToManyEdgeencountersArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<EncounterCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EncountersOrderBy>>;
};


/** A `Patient` edge in the connection, with data from `Encounter`. */
export type InsuranceRecordPatientsByEncounterPrimaryInsuranceAndPatientIdManyToManyEdgeencountersListArgs = {
  condition?: InputMaybe<EncounterCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EncountersOrderBy>>;
};

/** A connection to a list of `Patient` values, with data from `Encounter`. */
export type InsuranceRecordPatientsByEncounterSecondaryInsuranceAndPatientIdManyToManyConnection = {
  __typename: 'InsuranceRecordPatientsByEncounterSecondaryInsuranceAndPatientIdManyToManyConnection';
  /** A list of edges which contains the `Patient`, info from the `Encounter`, and the cursor to aid in pagination. */
  edges: Array<InsuranceRecordPatientsByEncounterSecondaryInsuranceAndPatientIdManyToManyEdge>;
  /** A list of `Patient` objects. */
  nodes: Array<Patient>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Patient` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Patient` edge in the connection, with data from `Encounter`. */
export type InsuranceRecordPatientsByEncounterSecondaryInsuranceAndPatientIdManyToManyEdge = {
  __typename: 'InsuranceRecordPatientsByEncounterSecondaryInsuranceAndPatientIdManyToManyEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** Reads and enables pagination through a set of `Encounter`. */
  encounters: EncountersConnection;
  /** Reads and enables pagination through a set of `Encounter`. */
  encountersList: Array<Encounter>;
  /** The `Patient` at the end of the edge. */
  node: Patient;
};


/** A `Patient` edge in the connection, with data from `Encounter`. */
export type InsuranceRecordPatientsByEncounterSecondaryInsuranceAndPatientIdManyToManyEdgeencountersArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<EncounterCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EncountersOrderBy>>;
};


/** A `Patient` edge in the connection, with data from `Encounter`. */
export type InsuranceRecordPatientsByEncounterSecondaryInsuranceAndPatientIdManyToManyEdgeencountersListArgs = {
  condition?: InputMaybe<EncounterCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EncountersOrderBy>>;
};

/** A connection to a list of `ServiceLine` values, with data from `Encounter`. */
export type InsuranceRecordServiceLinesByEncounterPrimaryInsuranceAndServiceLineIdManyToManyConnection = {
  __typename: 'InsuranceRecordServiceLinesByEncounterPrimaryInsuranceAndServiceLineIdManyToManyConnection';
  /** A list of edges which contains the `ServiceLine`, info from the `Encounter`, and the cursor to aid in pagination. */
  edges: Array<InsuranceRecordServiceLinesByEncounterPrimaryInsuranceAndServiceLineIdManyToManyEdge>;
  /** A list of `ServiceLine` objects. */
  nodes: Array<ServiceLine>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ServiceLine` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `ServiceLine` edge in the connection, with data from `Encounter`. */
export type InsuranceRecordServiceLinesByEncounterPrimaryInsuranceAndServiceLineIdManyToManyEdge = {
  __typename: 'InsuranceRecordServiceLinesByEncounterPrimaryInsuranceAndServiceLineIdManyToManyEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** Reads and enables pagination through a set of `Encounter`. */
  encounters: EncountersConnection;
  /** Reads and enables pagination through a set of `Encounter`. */
  encountersList: Array<Encounter>;
  /** The `ServiceLine` at the end of the edge. */
  node: ServiceLine;
};


/** A `ServiceLine` edge in the connection, with data from `Encounter`. */
export type InsuranceRecordServiceLinesByEncounterPrimaryInsuranceAndServiceLineIdManyToManyEdgeencountersArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<EncounterCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EncountersOrderBy>>;
};


/** A `ServiceLine` edge in the connection, with data from `Encounter`. */
export type InsuranceRecordServiceLinesByEncounterPrimaryInsuranceAndServiceLineIdManyToManyEdgeencountersListArgs = {
  condition?: InputMaybe<EncounterCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EncountersOrderBy>>;
};

/** A connection to a list of `ServiceLine` values, with data from `Encounter`. */
export type InsuranceRecordServiceLinesByEncounterSecondaryInsuranceAndServiceLineIdManyToManyConnection = {
  __typename: 'InsuranceRecordServiceLinesByEncounterSecondaryInsuranceAndServiceLineIdManyToManyConnection';
  /** A list of edges which contains the `ServiceLine`, info from the `Encounter`, and the cursor to aid in pagination. */
  edges: Array<InsuranceRecordServiceLinesByEncounterSecondaryInsuranceAndServiceLineIdManyToManyEdge>;
  /** A list of `ServiceLine` objects. */
  nodes: Array<ServiceLine>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ServiceLine` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `ServiceLine` edge in the connection, with data from `Encounter`. */
export type InsuranceRecordServiceLinesByEncounterSecondaryInsuranceAndServiceLineIdManyToManyEdge = {
  __typename: 'InsuranceRecordServiceLinesByEncounterSecondaryInsuranceAndServiceLineIdManyToManyEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** Reads and enables pagination through a set of `Encounter`. */
  encounters: EncountersConnection;
  /** Reads and enables pagination through a set of `Encounter`. */
  encountersList: Array<Encounter>;
  /** The `ServiceLine` at the end of the edge. */
  node: ServiceLine;
};


/** A `ServiceLine` edge in the connection, with data from `Encounter`. */
export type InsuranceRecordServiceLinesByEncounterSecondaryInsuranceAndServiceLineIdManyToManyEdgeencountersArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<EncounterCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EncountersOrderBy>>;
};


/** A `ServiceLine` edge in the connection, with data from `Encounter`. */
export type InsuranceRecordServiceLinesByEncounterSecondaryInsuranceAndServiceLineIdManyToManyEdgeencountersListArgs = {
  condition?: InputMaybe<EncounterCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EncountersOrderBy>>;
};

/** A connection to a list of `InsuranceRecord` values. */
export type InsuranceRecordsConnection = {
  __typename: 'InsuranceRecordsConnection';
  /** A list of edges which contains the `InsuranceRecord` and cursor to aid in pagination. */
  edges: Array<InsuranceRecordsEdge>;
  /** A list of `InsuranceRecord` objects. */
  nodes: Array<InsuranceRecord>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `InsuranceRecord` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `InsuranceRecord` edge in the connection. */
export type InsuranceRecordsEdge = {
  __typename: 'InsuranceRecordsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `InsuranceRecord` at the end of the edge. */
  node: InsuranceRecord;
};

/** Methods to use when ordering `InsuranceRecord`. */
export enum InsuranceRecordsOrderBy {
  INSURANCE_RECORD_ID_ASC = 'INSURANCE_RECORD_ID_ASC',
  INSURANCE_RECORD_ID_DESC = 'INSURANCE_RECORD_ID_DESC',
  NATURAL = 'NATURAL',
  PATIENT_ID_ASC = 'PATIENT_ID_ASC',
  PATIENT_ID_DESC = 'PATIENT_ID_DESC',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC'
}

/** An interval of time that has passed where the smallest distinct unit is a second. */
export type Interval = {
  __typename: 'Interval';
  /** A quantity of days. */
  days?: Maybe<Scalars['Int']>;
  /** A quantity of hours. */
  hours?: Maybe<Scalars['Int']>;
  /** A quantity of minutes. */
  minutes?: Maybe<Scalars['Int']>;
  /** A quantity of months. */
  months?: Maybe<Scalars['Int']>;
  /**
   * A quantity of seconds. This is the only non-integer field, as all the other
   * fields will dump their overflow into a smaller unit of time. Intervals don’t
   * have a smaller unit than seconds.
   */
  seconds?: Maybe<Scalars['Float']>;
  /** A quantity of years. */
  years?: Maybe<Scalars['Int']>;
};

/** Contains contains information about the it role and mapping to user relation. */
export type ItRole = Node & {
  __typename: 'ItRole';
  dosespotId?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  updatedAt: Scalars['Datetime'];
  updatedBy?: Maybe<Scalars['Int']>;
  /** Reads a single `User` that is related to this `ItRole`. */
  user?: Maybe<User>;
  userId: Scalars['Int'];
};

/** A condition to be used against `ItRole` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type ItRoleCondition = {
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars['Int']>;
};

/** A connection to a list of `ItRole` values. */
export type ItRolesConnection = {
  __typename: 'ItRolesConnection';
  /** A list of edges which contains the `ItRole` and cursor to aid in pagination. */
  edges: Array<ItRolesEdge>;
  /** A list of `ItRole` objects. */
  nodes: Array<ItRole>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ItRole` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `ItRole` edge in the connection. */
export type ItRolesEdge = {
  __typename: 'ItRolesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `ItRole` at the end of the edge. */
  node: ItRole;
};

/** Methods to use when ordering `ItRole`. */
export enum ItRolesOrderBy {
  NATURAL = 'NATURAL',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  USER_ID_ASC = 'USER_ID_ASC',
  USER_ID_DESC = 'USER_ID_DESC'
}

export type JobTagsInput = {
  id: Scalars['UUID'];
};

export type JoinTelehealthMeetingInput = {
  encounterTaskId: Scalars['Int'];
};

export type JoinTelehealthMeetingPayload = {
  __typename: 'JoinTelehealthMeetingPayload';
  telehealthMeeting?: Maybe<TelehealthMeeting>;
};

export enum LanguagesEnum {
  ALBANIAN = 'ALBANIAN',
  AMHARIC = 'AMHARIC',
  ARABIC = 'ARABIC',
  ARMENIAN = 'ARMENIAN',
  BENGALI = 'BENGALI',
  CHINESE = 'CHINESE',
  CROATION = 'CROATION',
  CZECH = 'CZECH',
  DANISH = 'DANISH',
  DUTCH = 'DUTCH',
  ENGLISH = 'ENGLISH',
  FINNISH = 'FINNISH',
  FRENCH = 'FRENCH',
  FRYSIAN = 'FRYSIAN',
  GERMAN = 'GERMAN',
  GREEK = 'GREEK',
  GUJARATI = 'GUJARATI',
  HAITIAN_CREOLE = 'HAITIAN_CREOLE',
  HINDI = 'HINDI',
  HMONG = 'HMONG',
  IBO = 'IBO',
  ILOCANO = 'ILOCANO',
  ITALIAN = 'ITALIAN',
  JAPANESE = 'JAPANESE',
  KOREAN = 'KOREAN',
  KRU = 'KRU',
  LAOTIAN = 'LAOTIAN',
  MONKHMER_CAMBODIAN = 'MONKHMER_CAMBODIAN',
  NORWEGIAN = 'NORWEGIAN',
  PANJABI = 'PANJABI',
  PERSIAN = 'PERSIAN',
  POLISH = 'POLISH',
  PORTUGUESE = 'PORTUGUESE',
  PUNJABI = 'PUNJABI',
  RUSSIAN = 'RUSSIAN',
  SAMOAN = 'SAMOAN',
  SERBIAN = 'SERBIAN',
  SPANISH = 'SPANISH',
  SWEDISH = 'SWEDISH',
  TAGALOG = 'TAGALOG',
  TELEGU = 'TELEGU',
  THAI = 'THAI',
  URDU = 'URDU',
  VIETNAMESE = 'VIETNAMESE',
  YIDDISH = 'YIDDISH',
  YORUBA = 'YORUBA'
}

/** Contains information about the machine_application relation. */
export type MachineApplication = Node & {
  __typename: 'MachineApplication';
  createdAt: Scalars['Datetime'];
  deletedAt?: Maybe<Scalars['Datetime']>;
  isDeleted: Scalars['Boolean'];
  machineApplicationId: Scalars['Int'];
  machineApplicationUuid: Scalars['UUID'];
  machineName: Scalars['String'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
};

/**
 * A condition to be used against `MachineApplication` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type MachineApplicationCondition = {
  /** Checks for equality with the object’s `machineApplicationId` field. */
  machineApplicationId?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `machineApplicationUuid` field. */
  machineApplicationUuid?: InputMaybe<Scalars['UUID']>;
};

/** A connection to a list of `MachineApplication` values. */
export type MachineApplicationsConnection = {
  __typename: 'MachineApplicationsConnection';
  /** A list of edges which contains the `MachineApplication` and cursor to aid in pagination. */
  edges: Array<MachineApplicationsEdge>;
  /** A list of `MachineApplication` objects. */
  nodes: Array<MachineApplication>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `MachineApplication` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `MachineApplication` edge in the connection. */
export type MachineApplicationsEdge = {
  __typename: 'MachineApplicationsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `MachineApplication` at the end of the edge. */
  node: MachineApplication;
};

/** Methods to use when ordering `MachineApplication`. */
export enum MachineApplicationsOrderBy {
  MACHINE_APPLICATION_ID_ASC = 'MACHINE_APPLICATION_ID_ASC',
  MACHINE_APPLICATION_ID_DESC = 'MACHINE_APPLICATION_ID_DESC',
  MACHINE_APPLICATION_UUID_ASC = 'MACHINE_APPLICATION_UUID_ASC',
  MACHINE_APPLICATION_UUID_DESC = 'MACHINE_APPLICATION_UUID_DESC',
  NATURAL = 'NATURAL',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC'
}

/** Contains information about a market */
export type Market = Node & {
  __typename: 'Market';
  /** Reads and enables pagination through a set of `Appointment`. */
  appointments: AppointmentsConnection;
  /** Reads and enables pagination through a set of `Appointment`. */
  appointmentsList: Array<Appointment>;
  createdAt: Scalars['Datetime'];
  endTimes: Array<Maybe<Scalars['Time']>>;
  frozenById?: Maybe<Scalars['Int']>;
  frozenByUser?: Maybe<User>;
  frozenReason?: Maybe<Scalars['String']>;
  isActive: Scalars['Boolean'];
  isDeleted?: Maybe<Scalars['Boolean']>;
  isFrozen: Scalars['Boolean'];
  launchTimestamp?: Maybe<Scalars['Datetime']>;
  /** Reads and enables pagination through a set of `MarketChannelAttributionLookup`. */
  marketChannelAttributionLookups: MarketChannelAttributionLookupsConnection;
  /** Reads and enables pagination through a set of `MarketChannelAttributionLookup`. */
  marketChannelAttributionLookupsList: Array<MarketChannelAttributionLookup>;
  /** Reads and enables pagination through a set of `MarketClinic`. */
  marketClinics: MarketClinicsConnection;
  /** Reads and enables pagination through a set of `MarketClinic`. */
  marketClinicsList: Array<MarketClinic>;
  marketId: Scalars['Int'];
  /** Reads and enables pagination through a set of `MarketPatientFormLookup`. */
  marketPatientFormLookups: MarketPatientFormLookupsConnection;
  /** Reads and enables pagination through a set of `MarketPatientFormLookup`. */
  marketPatientFormLookupsList: Array<MarketPatientFormLookup>;
  name: Scalars['String'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  operationalDays?: Maybe<Array<Maybe<Scalars['Int']>>>;
  scheduledFreezeById?: Maybe<Scalars['Int']>;
  scheduledFreezeByUser?: Maybe<User>;
  scheduledFreezeEndTime?: Maybe<Scalars['Datetime']>;
  scheduledFreezeReason?: Maybe<Scalars['String']>;
  scheduledFreezeStartTime?: Maybe<Scalars['Datetime']>;
  startTimes: Array<Maybe<Scalars['Time']>>;
  timezone?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['Datetime']>;
  /** Reads and enables pagination through a set of `User`. */
  usersByAppointmentMarketIdAndCreatedBy: MarketUsersByAppointmentMarketIdAndCreatedByManyToManyConnection;
  /** Reads and enables pagination through a set of `User`. */
  usersByAppointmentMarketIdAndCreatedByList: Array<User>;
  /** Reads and enables pagination through a set of `Zone`. */
  zones: ZonesConnection;
  /** Reads and enables pagination through a set of `Zone`. */
  zonesList: Array<Zone>;
};


/** Contains information about a market */
export type MarketappointmentsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<AppointmentCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AppointmentsOrderBy>>;
};


/** Contains information about a market */
export type MarketappointmentsListArgs = {
  condition?: InputMaybe<AppointmentCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AppointmentsOrderBy>>;
};


/** Contains information about a market */
export type MarketmarketChannelAttributionLookupsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<MarketChannelAttributionLookupCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<MarketChannelAttributionLookupsOrderBy>>;
};


/** Contains information about a market */
export type MarketmarketChannelAttributionLookupsListArgs = {
  condition?: InputMaybe<MarketChannelAttributionLookupCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<MarketChannelAttributionLookupsOrderBy>>;
};


/** Contains information about a market */
export type MarketmarketClinicsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<MarketClinicCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<MarketClinicsOrderBy>>;
};


/** Contains information about a market */
export type MarketmarketClinicsListArgs = {
  condition?: InputMaybe<MarketClinicCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<MarketClinicsOrderBy>>;
};


/** Contains information about a market */
export type MarketmarketPatientFormLookupsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<MarketPatientFormLookupCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<MarketPatientFormLookupsOrderBy>>;
};


/** Contains information about a market */
export type MarketmarketPatientFormLookupsListArgs = {
  condition?: InputMaybe<MarketPatientFormLookupCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<MarketPatientFormLookupsOrderBy>>;
};


/** Contains information about a market */
export type MarketusersByAppointmentMarketIdAndCreatedByArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<UserCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UsersOrderBy>>;
};


/** Contains information about a market */
export type MarketusersByAppointmentMarketIdAndCreatedByListArgs = {
  condition?: InputMaybe<UserCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UsersOrderBy>>;
};


/** Contains information about a market */
export type MarketzonesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ZoneCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ZonesOrderBy>>;
};


/** Contains information about a market */
export type MarketzonesListArgs = {
  condition?: InputMaybe<ZoneCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ZonesOrderBy>>;
};

/** Lookup table mapping markets to channel attribution */
export type MarketChannelAttributionLookup = Node & {
  __typename: 'MarketChannelAttributionLookup';
  channelAttributionId: Scalars['Int'];
  /** Reads a single `Market` that is related to this `MarketChannelAttributionLookup`. */
  market?: Maybe<Market>;
  marketId: Scalars['Int'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
};

/**
 * A condition to be used against `MarketChannelAttributionLookup` object types.
 * All fields are tested for equality and combined with a logical ‘and.’
 */
export type MarketChannelAttributionLookupCondition = {
  /** Checks for equality with the object’s `marketId` field. */
  marketId?: InputMaybe<Scalars['Int']>;
};

/** A connection to a list of `MarketChannelAttributionLookup` values. */
export type MarketChannelAttributionLookupsConnection = {
  __typename: 'MarketChannelAttributionLookupsConnection';
  /** A list of edges which contains the `MarketChannelAttributionLookup` and cursor to aid in pagination. */
  edges: Array<MarketChannelAttributionLookupsEdge>;
  /** A list of `MarketChannelAttributionLookup` objects. */
  nodes: Array<MarketChannelAttributionLookup>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `MarketChannelAttributionLookup` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `MarketChannelAttributionLookup` edge in the connection. */
export type MarketChannelAttributionLookupsEdge = {
  __typename: 'MarketChannelAttributionLookupsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `MarketChannelAttributionLookup` at the end of the edge. */
  node: MarketChannelAttributionLookup;
};

/** Methods to use when ordering `MarketChannelAttributionLookup`. */
export enum MarketChannelAttributionLookupsOrderBy {
  MARKET_ID_ASC = 'MARKET_ID_ASC',
  MARKET_ID_DESC = 'MARKET_ID_DESC',
  NATURAL = 'NATURAL',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC'
}

export type MarketClinic = Node & {
  __typename: 'MarketClinic';
  clinicId: Scalars['Int'];
  isDeleted: Scalars['Boolean'];
  /** Reads a single `Market` that is related to this `MarketClinic`. */
  market?: Maybe<Market>;
  marketId: Scalars['Int'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  updatedAt: Scalars['Datetime'];
  updatedBy: Scalars['Int'];
};

/**
 * A condition to be used against `MarketClinic` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type MarketClinicCondition = {
  /** Checks for equality with the object’s `marketId` field. */
  marketId?: InputMaybe<Scalars['Int']>;
};

/** An input for mutations affecting `MarketClinic` */
export type MarketClinicInput = {
  clinicId: Scalars['Int'];
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  marketId: Scalars['Int'];
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  updatedBy: Scalars['Int'];
};

/** Represents an update to a `MarketClinic`. Fields that are set will be updated. */
export type MarketClinicPatch = {
  clinicId?: InputMaybe<Scalars['Int']>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  marketId?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  updatedBy?: InputMaybe<Scalars['Int']>;
};

/** A connection to a list of `MarketClinic` values. */
export type MarketClinicsConnection = {
  __typename: 'MarketClinicsConnection';
  /** A list of edges which contains the `MarketClinic` and cursor to aid in pagination. */
  edges: Array<MarketClinicsEdge>;
  /** A list of `MarketClinic` objects. */
  nodes: Array<MarketClinic>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `MarketClinic` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `MarketClinic` edge in the connection. */
export type MarketClinicsEdge = {
  __typename: 'MarketClinicsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `MarketClinic` at the end of the edge. */
  node: MarketClinic;
};

/** Methods to use when ordering `MarketClinic`. */
export enum MarketClinicsOrderBy {
  MARKET_ID_ASC = 'MARKET_ID_ASC',
  MARKET_ID_DESC = 'MARKET_ID_DESC',
  NATURAL = 'NATURAL',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC'
}

/** A condition to be used against `Market` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type MarketCondition = {
  /** Filters to records matching isActive */
  isActive?: InputMaybe<Scalars['Boolean']>;
  /** Filters to records matching isDeleted */
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  /** Filters to records matching isFrozen */
  isFrozen?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `marketId` field. */
  marketId?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']>;
};

/** Contains information about the mapping between the market table and the patient_form_lookup table */
export type MarketPatientFormLookup = Node & {
  __typename: 'MarketPatientFormLookup';
  /** Reads a single `Market` that is related to this `MarketPatientFormLookup`. */
  market?: Maybe<Market>;
  marketId: Scalars['Int'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  patientFormLookupId: Scalars['Int'];
};

/**
 * A condition to be used against `MarketPatientFormLookup` object types. All
 * fields are tested for equality and combined with a logical ‘and.’
 */
export type MarketPatientFormLookupCondition = {
  /** Checks for equality with the object’s `marketId` field. */
  marketId?: InputMaybe<Scalars['Int']>;
};

/** A connection to a list of `MarketPatientFormLookup` values. */
export type MarketPatientFormLookupsConnection = {
  __typename: 'MarketPatientFormLookupsConnection';
  /** A list of edges which contains the `MarketPatientFormLookup` and cursor to aid in pagination. */
  edges: Array<MarketPatientFormLookupsEdge>;
  /** A list of `MarketPatientFormLookup` objects. */
  nodes: Array<MarketPatientFormLookup>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `MarketPatientFormLookup` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `MarketPatientFormLookup` edge in the connection. */
export type MarketPatientFormLookupsEdge = {
  __typename: 'MarketPatientFormLookupsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `MarketPatientFormLookup` at the end of the edge. */
  node: MarketPatientFormLookup;
};

/** Methods to use when ordering `MarketPatientFormLookup`. */
export enum MarketPatientFormLookupsOrderBy {
  MARKET_ID_ASC = 'MARKET_ID_ASC',
  MARKET_ID_DESC = 'MARKET_ID_DESC',
  NATURAL = 'NATURAL',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC'
}

/** Contains information about questionnaire markets */
export type MarketQuestionnaireLookup = Node & {
  __typename: 'MarketQuestionnaireLookup';
  marketId: Scalars['Int'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  questionnaireLookupId: Scalars['Int'];
};

/**
 * A condition to be used against `MarketQuestionnaireLookup` object types. All
 * fields are tested for equality and combined with a logical ‘and.’
 */
export type MarketQuestionnaireLookupCondition = {
  /** Checks for equality with the object’s `marketId` field. */
  marketId?: InputMaybe<Scalars['Int']>;
};

/** A connection to a list of `MarketQuestionnaireLookup` values. */
export type MarketQuestionnaireLookupsConnection = {
  __typename: 'MarketQuestionnaireLookupsConnection';
  /** A list of edges which contains the `MarketQuestionnaireLookup` and cursor to aid in pagination. */
  edges: Array<MarketQuestionnaireLookupsEdge>;
  /** A list of `MarketQuestionnaireLookup` objects. */
  nodes: Array<MarketQuestionnaireLookup>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `MarketQuestionnaireLookup` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `MarketQuestionnaireLookup` edge in the connection. */
export type MarketQuestionnaireLookupsEdge = {
  __typename: 'MarketQuestionnaireLookupsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `MarketQuestionnaireLookup` at the end of the edge. */
  node: MarketQuestionnaireLookup;
};

/** Methods to use when ordering `MarketQuestionnaireLookup`. */
export enum MarketQuestionnaireLookupsOrderBy {
  MARKET_ID_ASC = 'MARKET_ID_ASC',
  MARKET_ID_DESC = 'MARKET_ID_DESC',
  NATURAL = 'NATURAL',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC'
}

/** A connection to a list of `User` values, with data from `Appointment`. */
export type MarketUsersByAppointmentMarketIdAndCreatedByManyToManyConnection = {
  __typename: 'MarketUsersByAppointmentMarketIdAndCreatedByManyToManyConnection';
  /** A list of edges which contains the `User`, info from the `Appointment`, and the cursor to aid in pagination. */
  edges: Array<MarketUsersByAppointmentMarketIdAndCreatedByManyToManyEdge>;
  /** A list of `User` objects. */
  nodes: Array<User>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `User` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `User` edge in the connection, with data from `Appointment`. */
export type MarketUsersByAppointmentMarketIdAndCreatedByManyToManyEdge = {
  __typename: 'MarketUsersByAppointmentMarketIdAndCreatedByManyToManyEdge';
  /** Reads and enables pagination through a set of `Appointment`. */
  appointmentsByCreatedBy: AppointmentsConnection;
  /** Reads and enables pagination through a set of `Appointment`. */
  appointmentsByCreatedByList: Array<Appointment>;
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `User` at the end of the edge. */
  node: User;
};


/** A `User` edge in the connection, with data from `Appointment`. */
export type MarketUsersByAppointmentMarketIdAndCreatedByManyToManyEdgeappointmentsByCreatedByArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<AppointmentCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AppointmentsOrderBy>>;
};


/** A `User` edge in the connection, with data from `Appointment`. */
export type MarketUsersByAppointmentMarketIdAndCreatedByManyToManyEdgeappointmentsByCreatedByListArgs = {
  condition?: InputMaybe<AppointmentCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AppointmentsOrderBy>>;
};

/** A connection to a list of `Market` values. */
export type MarketsConnection = {
  __typename: 'MarketsConnection';
  /** A list of edges which contains the `Market` and cursor to aid in pagination. */
  edges: Array<MarketsEdge>;
  /** A list of `Market` objects. */
  nodes: Array<Market>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Market` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Market` edge in the connection. */
export type MarketsEdge = {
  __typename: 'MarketsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `Market` at the end of the edge. */
  node: Market;
};

/** Methods to use when ordering `Market`. */
export enum MarketsOrderBy {
  MARKET_ID_ASC = 'MARKET_ID_ASC',
  MARKET_ID_DESC = 'MARKET_ID_DESC',
  NAME_ASC = 'NAME_ASC',
  NAME_DESC = 'NAME_DESC',
  NATURAL = 'NATURAL',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC'
}

/** Contains data related to Medical Decision Making */
export type MedicalDecisionMaking = Node & {
  __typename: 'MedicalDecisionMaking';
  createdAt: Scalars['Datetime'];
  deletedAt?: Maybe<Scalars['Datetime']>;
  encounterTaskId?: Maybe<Scalars['Int']>;
  isDeleted: Scalars['Boolean'];
  medicalDecisionMakingId: Scalars['Int'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  note?: Maybe<Scalars['String']>;
  updatedAt: Scalars['Datetime'];
};

/**
 * A condition to be used against `MedicalDecisionMaking` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type MedicalDecisionMakingCondition = {
  /** Checks for equality with the object’s `medicalDecisionMakingId` field. */
  medicalDecisionMakingId?: InputMaybe<Scalars['Int']>;
};

/** A connection to a list of `MedicalDecisionMaking` values. */
export type MedicalDecisionMakingsConnection = {
  __typename: 'MedicalDecisionMakingsConnection';
  /** A list of edges which contains the `MedicalDecisionMaking` and cursor to aid in pagination. */
  edges: Array<MedicalDecisionMakingsEdge>;
  /** A list of `MedicalDecisionMaking` objects. */
  nodes: Array<MedicalDecisionMaking>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `MedicalDecisionMaking` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `MedicalDecisionMaking` edge in the connection. */
export type MedicalDecisionMakingsEdge = {
  __typename: 'MedicalDecisionMakingsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `MedicalDecisionMaking` at the end of the edge. */
  node: MedicalDecisionMaking;
};

/** Methods to use when ordering `MedicalDecisionMaking`. */
export enum MedicalDecisionMakingsOrderBy {
  MEDICAL_DECISION_MAKING_ID_ASC = 'MEDICAL_DECISION_MAKING_ID_ASC',
  MEDICAL_DECISION_MAKING_ID_DESC = 'MEDICAL_DECISION_MAKING_ID_DESC',
  NATURAL = 'NATURAL',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC'
}

export type MedicalDirector = Node & {
  __typename: 'MedicalDirector';
  clinicId: Scalars['Int'];
  createdAt: Scalars['Datetime'];
  deletedAt?: Maybe<Scalars['Datetime']>;
  dosespotAuthId?: Maybe<Scalars['String']>;
  isDeleted: Scalars['Boolean'];
  medicalDirectorId: Scalars['Int'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  updatedAt: Scalars['Datetime'];
  userId?: Maybe<Scalars['Int']>;
};

/**
 * A condition to be used against `MedicalDirector` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type MedicalDirectorCondition = {
  /** Checks for equality with the object’s `medicalDirectorId` field. */
  medicalDirectorId?: InputMaybe<Scalars['Int']>;
};

/** An input for mutations affecting `MedicalDirector` */
export type MedicalDirectorInput = {
  clinicId: Scalars['Int'];
  createdAt?: InputMaybe<Scalars['Datetime']>;
  deletedAt?: InputMaybe<Scalars['Datetime']>;
  dosespotAuthId?: InputMaybe<Scalars['String']>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  userId?: InputMaybe<Scalars['Int']>;
};

/** Represents an update to a `MedicalDirector`. Fields that are set will be updated. */
export type MedicalDirectorPatch = {
  clinicId?: InputMaybe<Scalars['Int']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  deletedAt?: InputMaybe<Scalars['Datetime']>;
  dosespotAuthId?: InputMaybe<Scalars['String']>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  userId?: InputMaybe<Scalars['Int']>;
};

/** A connection to a list of `MedicalDirector` values. */
export type MedicalDirectorsConnection = {
  __typename: 'MedicalDirectorsConnection';
  /** A list of edges which contains the `MedicalDirector` and cursor to aid in pagination. */
  edges: Array<MedicalDirectorsEdge>;
  /** A list of `MedicalDirector` objects. */
  nodes: Array<MedicalDirector>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `MedicalDirector` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `MedicalDirector` edge in the connection. */
export type MedicalDirectorsEdge = {
  __typename: 'MedicalDirectorsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `MedicalDirector` at the end of the edge. */
  node: MedicalDirector;
};

/** Methods to use when ordering `MedicalDirector`. */
export enum MedicalDirectorsOrderBy {
  MEDICAL_DIRECTOR_ID_ASC = 'MEDICAL_DIRECTOR_ID_ASC',
  MEDICAL_DIRECTOR_ID_DESC = 'MEDICAL_DIRECTOR_ID_DESC',
  NATURAL = 'NATURAL',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC'
}

/** Contains information about ReadyCore modules */
export type Module = Node & {
  __typename: 'Module';
  createdAt: Scalars['Datetime'];
  name: ModuleNameEnum;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  skeduloTag?: Maybe<Scalars['String']>;
};

/** A condition to be used against `Module` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type ModuleCondition = {
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<ModuleNameEnum>;
};

export enum ModuleNameEnum {
  CLINICIAN = 'CLINICIAN',
  CLINICIAN_ACTIVATION = 'CLINICIAN_ACTIVATION',
  DEFAULT = 'DEFAULT',
  EMS_ACTIVATION = 'EMS_ACTIVATION',
  FORM_ABN_NONCOVERAGE = 'FORM_ABN_NONCOVERAGE',
  FORM_AMA = 'FORM_AMA',
  FORM_AUDIT_C = 'FORM_AUDIT_C',
  FORM_COMMUNITY_CARE = 'FORM_COMMUNITY_CARE',
  FORM_DAST_10 = 'FORM_DAST_10',
  FORM_GAD_7 = 'FORM_GAD_7',
  FORM_KATZ_ADL = 'FORM_KATZ_ADL',
  FORM_MORISKY_RX_ADHERENCE = 'FORM_MORISKY_RX_ADHERENCE',
  FORM_MORSE_FALL = 'FORM_MORSE_FALL',
  FORM_PAIN = 'FORM_PAIN',
  FORM_PHQ = 'FORM_PHQ',
  FORM_POSTPARTUM_DEPRESSION = 'FORM_POSTPARTUM_DEPRESSION',
  FORM_RAD_GENERAL = 'FORM_RAD_GENERAL',
  FORM_RELEASE_MEDICAL = 'FORM_RELEASE_MEDICAL',
  FORM_SDOH = 'FORM_SDOH',
  FORM_TECHNOLOGY = 'FORM_TECHNOLOGY',
  NOTE = 'NOTE',
  TEST_A1C = 'TEST_A1C',
  TEST_A1C_ORDER = 'TEST_A1C_ORDER',
  TEST_COVID = 'TEST_COVID',
  TEST_COVID_ANTIBODY = 'TEST_COVID_ANTIBODY',
  TEST_COVID_ORDER = 'TEST_COVID_ORDER',
  TEST_FLU_ANTIGEN = 'TEST_FLU_ANTIGEN',
  TEST_FLU_ANTIGEN_ORDER = 'TEST_FLU_ANTIGEN_ORDER',
  TEST_GLUCOSE = 'TEST_GLUCOSE',
  TEST_GLUCOSE_ORDER = 'TEST_GLUCOSE_ORDER',
  TEST_PREGNANCY = 'TEST_PREGNANCY',
  TEST_PREGNANCY_ORDER = 'TEST_PREGNANCY_ORDER',
  TEST_RSV = 'TEST_RSV',
  TEST_RSV_ORDER = 'TEST_RSV_ORDER',
  TEST_STREP = 'TEST_STREP',
  TEST_STREP_ORDER = 'TEST_STREP_ORDER',
  VACCINE_COVID = 'VACCINE_COVID',
  VACCINE_FLU = 'VACCINE_FLU',
  VITALS = 'VITALS',
  VITALS_ADDITIONAL = 'VITALS_ADDITIONAL'
}

/** Contains information about the mapping between the module table and the encounter_task table */
export type ModuleTaskMapping = Node & {
  __typename: 'ModuleTaskMapping';
  createdAt: Scalars['Datetime'];
  dataCategory?: Maybe<Scalars['String']>;
  dataType: Scalars['String'];
  deletedAt?: Maybe<Scalars['Datetime']>;
  group: Scalars['String'];
  isDeleted: Scalars['Boolean'];
  moduleName: ModuleNameEnum;
  moduleTaskMappingId: Scalars['Int'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  partner: Scalars['String'];
  rank?: Maybe<Scalars['BigFloat']>;
  taskName: Scalars['String'];
  taskRoles: Array<Maybe<UserRoleEnum>>;
};

/**
 * A condition to be used against `ModuleTaskMapping` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type ModuleTaskMappingCondition = {
  /** Checks for equality with the object’s `isDeleted` field. */
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `moduleTaskMappingId` field. */
  moduleTaskMappingId?: InputMaybe<Scalars['Int']>;
};

/** A connection to a list of `ModuleTaskMapping` values. */
export type ModuleTaskMappingsConnection = {
  __typename: 'ModuleTaskMappingsConnection';
  /** A list of edges which contains the `ModuleTaskMapping` and cursor to aid in pagination. */
  edges: Array<ModuleTaskMappingsEdge>;
  /** A list of `ModuleTaskMapping` objects. */
  nodes: Array<ModuleTaskMapping>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ModuleTaskMapping` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `ModuleTaskMapping` edge in the connection. */
export type ModuleTaskMappingsEdge = {
  __typename: 'ModuleTaskMappingsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `ModuleTaskMapping` at the end of the edge. */
  node: ModuleTaskMapping;
};

/** Methods to use when ordering `ModuleTaskMapping`. */
export enum ModuleTaskMappingsOrderBy {
  IS_DELETED_ASC = 'IS_DELETED_ASC',
  IS_DELETED_DESC = 'IS_DELETED_DESC',
  MODULE_TASK_MAPPING_ID_ASC = 'MODULE_TASK_MAPPING_ID_ASC',
  MODULE_TASK_MAPPING_ID_DESC = 'MODULE_TASK_MAPPING_ID_DESC',
  NATURAL = 'NATURAL',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC'
}

/** A connection to a list of `Module` values. */
export type ModulesConnection = {
  __typename: 'ModulesConnection';
  /** A list of edges which contains the `Module` and cursor to aid in pagination. */
  edges: Array<ModulesEdge>;
  /** A list of `Module` objects. */
  nodes: Array<Module>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Module` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Module` edge in the connection. */
export type ModulesEdge = {
  __typename: 'ModulesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `Module` at the end of the edge. */
  node: Module;
};

/** Methods to use when ordering `Module`. */
export enum ModulesOrderBy {
  NAME_ASC = 'NAME_ASC',
  NAME_DESC = 'NAME_DESC',
  NATURAL = 'NATURAL',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC'
}

/** The root mutation type which contains root level fields which mutate data. */
export type Mutation = {
  __typename: 'Mutation';
  addEncounter?: Maybe<AddEncounterPayload>;
  addStandingOrder?: Maybe<AddStandingOrderPayload>;
  /** Cancels a single `Appointment` using a unique key and a patch. */
  cancelAppointment?: Maybe<CancelAppointmentPayload>;
  /** Cancels a single `Appointment` using a unique globalId key and a patch. */
  cancelAppointmentByGlobalId?: Maybe<CancelAppointmentPayload>;
  cancelEncounters?: Maybe<Array<Maybe<Encounter>>>;
  claimEncounter?: Maybe<ClaimEncounterPayload>;
  createAddendum?: Maybe<CreateAddendumPayload>;
  /** Takes a create_appointment_input and creates a new appointment with associated encounters and insurance records */
  createAppointment?: Maybe<CreateAppointmentPayload>;
  /** Creates a single `AppointmentDispatch`. */
  createAppointmentDispatch?: Maybe<CreateAppointmentDispatchPayload>;
  /** Creates a single `AppointmentTag`. */
  createAppointmentTag?: Maybe<CreateAppointmentTagPayload>;
  /** Creates a single `ChannelAttribution`. */
  createChannelAttribution?: Maybe<SaveChannelAttributionPayload>;
  /** Creates a single `Clinic`. */
  createClinic?: Maybe<CreateClinicPayload>;
  createClinicianEncounterSignature?: Maybe<UpsertClinicianSignaturePayload>;
  /** Creates a single `CodeSystem`. */
  createCodeSystem?: Maybe<CreateCodeSystemPayload>;
  createEmrAuditLogs?: Maybe<EmrAuditLogPayload>;
  /** Creates a single `EncounterSignature`. */
  createEncounterSignature?: Maybe<CreateEncounterSignaturePayload>;
  /** Creates a single `EncounterTaskAttachment`. */
  createEncounterTaskAttachment?: Maybe<CreateEncounterTaskAttachmentPayload>;
  /** Creates a single `FeatureGate`. */
  createFeatureGate?: Maybe<CreateFeatureGatePayload>;
  /** Creates a single `InsuranceRecord`. */
  createInsuranceRecord?: Maybe<CreateInsuranceRecordPayload>;
  /** Creates a single `MarketClinic`. */
  createMarketClinic?: Maybe<CreateMarketClinicPayload>;
  /** Creates a single `MedicalDirector`. */
  createMedicalDirector?: Maybe<CreateMedicalDirectorPayload>;
  /** Takes a PatientInput and creates a new patient or returns existing if match on global patient id exists. */
  createPatient?: Maybe<CreatePatientPayload>;
  /** Takes encounter_task_id, patient_form_lookup_id, formstack_id, signed_at, field_response and creates a new patient_form record */
  createPatientForm?: Maybe<CreatePatientFormPayload>;
  /** Takes a createPatientNote and creates a new PatientNote. */
  createPatientNote?: Maybe<CreatePatientNotePayload>;
  /** Creates a single `PhysicalExam`. */
  createPhysicalExam?: Maybe<CreatePhysicalExamPayload>;
  createResponderEncounterSignature?: Maybe<UpsertResponderSignaturePayload>;
  createSkeduloAppointment?: Maybe<SkeduloAppointmentCreationPayload>;
  createStandingOrder?: Maybe<SaveStandingOrderPayload>;
  /** Deletes a single `AppointmentTag` using a unique key. */
  deleteAppointmentTag?: Maybe<DeleteAppointmentTagPayload>;
  /** Deletes a single `AppointmentTag` using its globally unique id. */
  deleteAppointmentTagByNodeId?: Maybe<DeleteAppointmentTagPayload>;
  /** Deletes a single `Clinic` using a unique key. */
  deleteClinic?: Maybe<DeleteClinicPayload>;
  /** Deletes a single `Clinic` using its globally unique id. */
  deleteClinicByNodeId?: Maybe<DeleteClinicPayload>;
  /** Deletes a single `CodeSystem` using a unique key. */
  deleteCodeSystem?: Maybe<DeleteCodeSystemPayload>;
  /** Deletes a single `CodeSystem` using its globally unique id. */
  deleteCodeSystemByNodeId?: Maybe<DeleteCodeSystemPayload>;
  /** Deletes a single `FeatureGate` using a unique key. */
  deleteFeatureGate?: Maybe<DeleteFeatureGatePayload>;
  /** Deletes a single `FeatureGate` using its globally unique id. */
  deleteFeatureGateByNodeId?: Maybe<DeleteFeatureGatePayload>;
  /** Deletes a single `MarketClinic` using a unique key. */
  deleteMarketClinic?: Maybe<DeleteMarketClinicPayload>;
  /** Deletes a single `MarketClinic` using its globally unique id. */
  deleteMarketClinicByNodeId?: Maybe<DeleteMarketClinicPayload>;
  /** Deletes a single `MedicalDirector` using a unique key. */
  deleteMedicalDirector?: Maybe<DeleteMedicalDirectorPayload>;
  /** Deletes a single `MedicalDirector` using its globally unique id. */
  deleteMedicalDirectorByNodeId?: Maybe<DeleteMedicalDirectorPayload>;
  /** Deletes a single `PhysicalExam` using a unique key. */
  deletePhysicalExam?: Maybe<DeletePhysicalExamPayload>;
  /** Deletes a single `PhysicalExam` using its globally unique id. */
  deletePhysicalExamByNodeId?: Maybe<DeletePhysicalExamPayload>;
  generateDoseSpotURL?: Maybe<Scalars['String']>;
  /** creates it role for user */
  grantItRole?: Maybe<GrantItRolePayload>;
  grantRole?: Maybe<GrantRolePayload>;
  joinTelehealthMeeting?: Maybe<JoinTelehealthMeetingPayload>;
  rescheduleSkeduloAppointment?: Maybe<RescheduleAppointmentCreationPayload>;
  revertTransitionEncounterTaskToClinicianReviewed?: Maybe<RevertTransitionEncounterTaskToClinicianReviewedPayload>;
  revertTransitionEncounterTaskToResponderCompleted?: Maybe<RevertTransitionEncounterTaskToResponderCompletedPayload>;
  /** deletes it role for user */
  revokeItRole?: Maybe<RevokeItRolePayload>;
  revokeRole?: Maybe<RevokeRolePayload>;
  /**
   * Syncs data from SkeduloJobAllocation input data to a
   * single `AppointmentDispatch` using a unique resourceId
   * and jobAllocationId keys.
   */
  syncSkeduloJobToAppointmentDispatch?: Maybe<SyncSkeduloJobToAppointmentDispatchPayload>;
  unclaimEncounter?: Maybe<UnclaimEncounterPayload>;
  /** Updates a single `Appointment` using a unique key and a patch. */
  updateAppointment?: Maybe<UpdateAppointmentPayload>;
  /** Updates a single `Appointment` using a unique globalId key and a patch. */
  updateAppointmentByGlobalId?: Maybe<UpdateAppointmentPayload>;
  /** Updates a single `AppointmentDispatch` using a unique key and a patch. */
  updateAppointmentDispatch?: Maybe<UpdateAppointmentDispatchPayload>;
  /** Updates a single `AppointmentDispatch` using its globally unique id and a patch. */
  updateAppointmentDispatchByNodeId?: Maybe<UpdateAppointmentDispatchPayload>;
  /** Updates a single `AppointmentTag` using a unique key and a patch. */
  updateAppointmentTag?: Maybe<UpdateAppointmentTagPayload>;
  /** Updates a single `AppointmentTag` using its globally unique id and a patch. */
  updateAppointmentTagByNodeId?: Maybe<UpdateAppointmentTagPayload>;
  /** Updates a single `ChannelAttribution`. */
  updateChannelAttribution?: Maybe<SaveChannelAttributionPayload>;
  /** Updates a single `Clinic` using a unique key and a patch. */
  updateClinic?: Maybe<UpdateClinicPayload>;
  /** Updates a single `Clinic` using its globally unique id and a patch. */
  updateClinicByNodeId?: Maybe<UpdateClinicPayload>;
  /** Updates a single `CodeSystem` using a unique key and a patch. */
  updateCodeSystem?: Maybe<UpdateCodeSystemPayload>;
  /** Updates a single `CodeSystem` using its globally unique id and a patch. */
  updateCodeSystemByNodeId?: Maybe<UpdateCodeSystemPayload>;
  /** Updates a single `Encounter` using a unique key and a patch. */
  updateEncounter?: Maybe<UpdateEncounterPayload>;
  /** Updates a single `Encounter` using its globally unique id and a patch. */
  updateEncounterByNodeId?: Maybe<UpdateEncounterPayload>;
  /** Updates a single `EncounterTask` using a unique key and a patch. */
  updateEncounterTask?: Maybe<UpdateEncounterTaskPayload>;
  /** Updates a single `EncounterTaskAttachment` using a unique key and a patch. */
  updateEncounterTaskAttachment?: Maybe<UpdateEncounterTaskAttachmentPayload>;
  /** Updates a single `EncounterTaskAttachment` using its globally unique id and a patch. */
  updateEncounterTaskAttachmentByNodeId?: Maybe<UpdateEncounterTaskAttachmentPayload>;
  /** Updates a single `EncounterTask` using its globally unique id and a patch. */
  updateEncounterTaskByNodeId?: Maybe<UpdateEncounterTaskPayload>;
  updateEncounterTaskTaskRoles?: Maybe<UpdateEncounterTaskTaskRolesPayload>;
  updateEncounterTaskTaskRolesOnEncounterComplete?: Maybe<UpdateEncounterTaskTaskRolesOnEncounterCompletePayload>;
  /** Updates a single `FeatureGate` using a unique key and a patch. */
  updateFeatureGate?: Maybe<UpdateFeatureGatePayload>;
  /** Updates a single `FeatureGate` using its globally unique id and a patch. */
  updateFeatureGateByNodeId?: Maybe<UpdateFeatureGatePayload>;
  /** Updates a single `InsuranceRecord` using a unique key and a patch. */
  updateInsuranceRecord?: Maybe<UpdateInsuranceRecordPayload>;
  /** Updates a single `InsuranceRecord` using its globally unique id and a patch. */
  updateInsuranceRecordByNodeId?: Maybe<UpdateInsuranceRecordPayload>;
  /** Updates a single `MarketClinic` using a unique key and a patch. */
  updateMarketClinic?: Maybe<UpdateMarketClinicPayload>;
  /** Updates a single `MarketClinic` using its globally unique id and a patch. */
  updateMarketClinicByNodeId?: Maybe<UpdateMarketClinicPayload>;
  /** Updates a single `MedicalDirector` using a unique key and a patch. */
  updateMedicalDirector?: Maybe<UpdateMedicalDirectorPayload>;
  /** Updates a single `MedicalDirector` using its globally unique id and a patch. */
  updateMedicalDirectorByNodeId?: Maybe<UpdateMedicalDirectorPayload>;
  /** Takes a PatientPatch and creates and updates matching patient if exists, returning updated patient. */
  updatePatient?: Maybe<UpdatePatientPayload>;
  /** Updates a single `PatientAttachment` using a unique key and a patch. */
  updatePatientAttachment?: Maybe<UpdatePatientAttachmentPayload>;
  /** Updates a single `PatientAttachment` using its globally unique id and a patch. */
  updatePatientAttachmentByNodeId?: Maybe<UpdatePatientAttachmentPayload>;
  /** Takes a PatientNotePatch and updates patient_note by patient_note_id if exists. */
  updatePatientNote?: Maybe<UpdatePatientNotePayload>;
  /** Updates a single `PhysicalExam` using a unique key and a patch. */
  updatePhysicalExam?: Maybe<UpdatePhysicalExamPayload>;
  /** Updates a single `PhysicalExam` using its globally unique id and a patch. */
  updatePhysicalExamByNodeId?: Maybe<UpdatePhysicalExamPayload>;
  /** Updates `ResponderRole` using an input. */
  updateResponderDeputyId?: Maybe<UpdateResponderDeputyIdPayload>;
  updateStandingOrder?: Maybe<SaveStandingOrderPayload>;
  updateUser?: Maybe<UpdateUserPayload>;
  updateVideoConference?: Maybe<UpdateVideoConferencePayload>;
  upsertEncounterTask?: Maybe<UpsertEncounterTaskPayload>;
  upsertMarkets?: Maybe<UpsertMarketsPayload>;
  /** takes an array of user_profiles and will upsert each matching user record with the profile data */
  upsertUsers?: Maybe<UpsertUsersPayload>;
  upsertZipcodes?: Maybe<UpsertZipcodesPayload>;
  upsertZoneZipcodes?: Maybe<UpsertZoneZipcodePayload>;
  upsertZones?: Maybe<UpsertZonesPayload>;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationaddEncounterArgs = {
  input: AddEncounterInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationaddStandingOrderArgs = {
  input: AddStandingOrderInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationcancelAppointmentArgs = {
  input: CancelAppointmentInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationcancelAppointmentByGlobalIdArgs = {
  input: CancelAppointmentByGlobalIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationcancelEncountersArgs = {
  input?: InputMaybe<CancelEncountersInput>;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationclaimEncounterArgs = {
  input: ClaimEncounterInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationcreateAddendumArgs = {
  input: CreateAddendumInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationcreateAppointmentArgs = {
  input: CreateAppointmentInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationcreateAppointmentDispatchArgs = {
  input: CreateAppointmentDispatchInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationcreateAppointmentTagArgs = {
  input: CreateAppointmentTagInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationcreateChannelAttributionArgs = {
  input: CreateChannelAttributionInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationcreateClinicArgs = {
  input: CreateClinicInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationcreateClinicianEncounterSignatureArgs = {
  input: CreateClinicianEncounterSignatureInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationcreateCodeSystemArgs = {
  input: CreateCodeSystemInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationcreateEmrAuditLogsArgs = {
  logs?: InputMaybe<Array<InputMaybe<EmrAuditLogInput>>>;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationcreateEncounterSignatureArgs = {
  input: CreateEncounterSignatureInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationcreateEncounterTaskAttachmentArgs = {
  input: CreateEncounterTaskAttachmentInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationcreateFeatureGateArgs = {
  input: CreateFeatureGateInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationcreateInsuranceRecordArgs = {
  input: CreateInsuranceRecordInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationcreateMarketClinicArgs = {
  input: CreateMarketClinicInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationcreateMedicalDirectorArgs = {
  input: CreateMedicalDirectorInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationcreatePatientArgs = {
  input: CreatePatientInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationcreatePatientFormArgs = {
  input: CreatePatientFormInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationcreatePatientNoteArgs = {
  input: CreatePatientNoteInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationcreatePhysicalExamArgs = {
  input: CreatePhysicalExamInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationcreateResponderEncounterSignatureArgs = {
  input: CreateResponderEncounterSignatureInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationcreateSkeduloAppointmentArgs = {
  input?: InputMaybe<SkeduloAppointmentInput>;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationcreateStandingOrderArgs = {
  input?: InputMaybe<CreateStandingOrderInput>;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationdeleteAppointmentTagArgs = {
  input: DeleteAppointmentTagInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationdeleteAppointmentTagByNodeIdArgs = {
  input: DeleteAppointmentTagByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationdeleteClinicArgs = {
  input: DeleteClinicInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationdeleteClinicByNodeIdArgs = {
  input: DeleteClinicByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationdeleteCodeSystemArgs = {
  input: DeleteCodeSystemInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationdeleteCodeSystemByNodeIdArgs = {
  input: DeleteCodeSystemByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationdeleteFeatureGateArgs = {
  input: DeleteFeatureGateInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationdeleteFeatureGateByNodeIdArgs = {
  input: DeleteFeatureGateByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationdeleteMarketClinicArgs = {
  input: DeleteMarketClinicInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationdeleteMarketClinicByNodeIdArgs = {
  input: DeleteMarketClinicByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationdeleteMedicalDirectorArgs = {
  input: DeleteMedicalDirectorInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationdeleteMedicalDirectorByNodeIdArgs = {
  input: DeleteMedicalDirectorByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationdeletePhysicalExamArgs = {
  input: DeletePhysicalExamInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationdeletePhysicalExamByNodeIdArgs = {
  input: DeletePhysicalExamByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationgenerateDoseSpotURLArgs = {
  input: GenerateDoseSpotURLRequest;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationgrantItRoleArgs = {
  input: GrantItRoleInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationgrantRoleArgs = {
  input: GrantRoleInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationjoinTelehealthMeetingArgs = {
  input: JoinTelehealthMeetingInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationrescheduleSkeduloAppointmentArgs = {
  input?: InputMaybe<RescheduleAppointmentInput>;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationrevertTransitionEncounterTaskToClinicianReviewedArgs = {
  input: RevertTransitionEncounterTaskToClinicianReviewedInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationrevertTransitionEncounterTaskToResponderCompletedArgs = {
  input: RevertTransitionEncounterTaskToResponderCompletedInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationrevokeItRoleArgs = {
  input: RevokeItRoleInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationrevokeRoleArgs = {
  input: RevokeRoleInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationsyncSkeduloJobToAppointmentDispatchArgs = {
  input: SyncSkeduloJobToAppointmentDispatchInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationunclaimEncounterArgs = {
  input: UnclaimEncounterInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationupdateAppointmentArgs = {
  input: UpdateAppointmentInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationupdateAppointmentByGlobalIdArgs = {
  input: UpdateAppointmentByGlobalIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationupdateAppointmentDispatchArgs = {
  input: UpdateAppointmentDispatchInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationupdateAppointmentDispatchByNodeIdArgs = {
  input: UpdateAppointmentDispatchByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationupdateAppointmentTagArgs = {
  input: UpdateAppointmentTagInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationupdateAppointmentTagByNodeIdArgs = {
  input: UpdateAppointmentTagByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationupdateChannelAttributionArgs = {
  input: UpdateChannelAttributionInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationupdateClinicArgs = {
  input: UpdateClinicInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationupdateClinicByNodeIdArgs = {
  input: UpdateClinicByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationupdateCodeSystemArgs = {
  input: UpdateCodeSystemInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationupdateCodeSystemByNodeIdArgs = {
  input: UpdateCodeSystemByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationupdateEncounterArgs = {
  input: UpdateEncounterInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationupdateEncounterByNodeIdArgs = {
  input: UpdateEncounterByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationupdateEncounterTaskArgs = {
  input: UpdateEncounterTaskInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationupdateEncounterTaskAttachmentArgs = {
  input: UpdateEncounterTaskAttachmentInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationupdateEncounterTaskAttachmentByNodeIdArgs = {
  input: UpdateEncounterTaskAttachmentByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationupdateEncounterTaskByNodeIdArgs = {
  input: UpdateEncounterTaskByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationupdateEncounterTaskTaskRolesArgs = {
  input: UpdateEncounterTaskTaskRolesInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationupdateEncounterTaskTaskRolesOnEncounterCompleteArgs = {
  input: UpdateEncounterTaskTaskRolesOnEncounterCompleteInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationupdateFeatureGateArgs = {
  input: UpdateFeatureGateInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationupdateFeatureGateByNodeIdArgs = {
  input: UpdateFeatureGateByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationupdateInsuranceRecordArgs = {
  input: UpdateInsuranceRecordInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationupdateInsuranceRecordByNodeIdArgs = {
  input: UpdateInsuranceRecordByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationupdateMarketClinicArgs = {
  input: UpdateMarketClinicInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationupdateMarketClinicByNodeIdArgs = {
  input: UpdateMarketClinicByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationupdateMedicalDirectorArgs = {
  input: UpdateMedicalDirectorInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationupdateMedicalDirectorByNodeIdArgs = {
  input: UpdateMedicalDirectorByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationupdatePatientArgs = {
  input: UpdatePatientInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationupdatePatientAttachmentArgs = {
  input: UpdatePatientAttachmentInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationupdatePatientAttachmentByNodeIdArgs = {
  input: UpdatePatientAttachmentByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationupdatePatientNoteArgs = {
  input: UpdatePatientNoteInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationupdatePhysicalExamArgs = {
  input: UpdatePhysicalExamInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationupdatePhysicalExamByNodeIdArgs = {
  input: UpdatePhysicalExamByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationupdateResponderDeputyIdArgs = {
  input: UpdateResponderDeputyIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationupdateStandingOrderArgs = {
  input: UpdateStandingOrderInput;
  standingOrderId: Scalars['Int'];
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationupdateUserArgs = {
  input: UpdateUserInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationupdateVideoConferenceArgs = {
  input: UpdateVideoConferenceInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationupsertEncounterTaskArgs = {
  input: UpsertEncounterTaskInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationupsertMarketsArgs = {
  input: UpsertMarketsInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationupsertUsersArgs = {
  input: UpsertUsersInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationupsertZipcodesArgs = {
  input: UpsertZipcodesInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationupsertZoneZipcodesArgs = {
  input: UpsertZoneZipcodeInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationupsertZonesArgs = {
  input: UpsertZonesInput;
};

export enum NoInsuranceReasonEnum {
  CANNOT_FIND_INSURANCE_CARDS = 'CANNOT_FIND_INSURANCE_CARDS',
  UNINSURED = 'UNINSURED'
}

export enum NoSsnReasonEnum {
  DOES_NOT_HAVE_ONE = 'DOES_NOT_HAVE_ONE',
  REFUSED = 'REFUSED'
}

/** An object with a globally unique `ID`. */
export type Node = {
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
};

export enum NonNullableSystemOfOrigin {
  READY_CARE = 'READY_CARE',
  READY_HEALTH_1 = 'READY_HEALTH_1',
  READY_HEALTH_2 = 'READY_HEALTH_2',
  READY_OPS = 'READY_OPS',
  READY_WEBHOOKS = 'READY_WEBHOOKS',
  READY_ZEN = 'READY_ZEN',
  WEB_BOOKING = 'WEB_BOOKING'
}

/** Contains contains information about the ops role and mapping to user relation. */
export type OpsRole = Node & {
  __typename: 'OpsRole';
  isDeleted?: Maybe<Scalars['Boolean']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  opsAdmin: Scalars['Boolean'];
  skeduloId?: Maybe<Scalars['UUID']>;
  updatedAt?: Maybe<Scalars['Datetime']>;
  updatedBy?: Maybe<Scalars['Int']>;
  /** Reads a single `User` that is related to this `OpsRole`. */
  user?: Maybe<User>;
  userId: Scalars['Int'];
};

/** A condition to be used against `OpsRole` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type OpsRoleCondition = {
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars['Int']>;
};

/** A connection to a list of `OpsRole` values. */
export type OpsRolesConnection = {
  __typename: 'OpsRolesConnection';
  /** A list of edges which contains the `OpsRole` and cursor to aid in pagination. */
  edges: Array<OpsRolesEdge>;
  /** A list of `OpsRole` objects. */
  nodes: Array<OpsRole>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `OpsRole` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `OpsRole` edge in the connection. */
export type OpsRolesEdge = {
  __typename: 'OpsRolesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `OpsRole` at the end of the edge. */
  node: OpsRole;
};

/** Methods to use when ordering `OpsRole`. */
export enum OpsRolesOrderBy {
  NATURAL = 'NATURAL',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  USER_ID_ASC = 'USER_ID_ASC',
  USER_ID_DESC = 'USER_ID_DESC'
}

/** Contains contains information about the outreach role and mapping to user relation. */
export type OutreachRole = Node & {
  __typename: 'OutreachRole';
  isDeleted?: Maybe<Scalars['Boolean']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  updatedAt?: Maybe<Scalars['Datetime']>;
  updatedBy?: Maybe<Scalars['Int']>;
  /** Reads a single `User` that is related to this `OutreachRole`. */
  user?: Maybe<User>;
  userId: Scalars['Int'];
};

/**
 * A condition to be used against `OutreachRole` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type OutreachRoleCondition = {
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars['Int']>;
};

/** A connection to a list of `OutreachRole` values. */
export type OutreachRolesConnection = {
  __typename: 'OutreachRolesConnection';
  /** A list of edges which contains the `OutreachRole` and cursor to aid in pagination. */
  edges: Array<OutreachRolesEdge>;
  /** A list of `OutreachRole` objects. */
  nodes: Array<OutreachRole>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `OutreachRole` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `OutreachRole` edge in the connection. */
export type OutreachRolesEdge = {
  __typename: 'OutreachRolesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `OutreachRole` at the end of the edge. */
  node: OutreachRole;
};

/** Methods to use when ordering `OutreachRole`. */
export enum OutreachRolesOrderBy {
  NATURAL = 'NATURAL',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  USER_ID_ASC = 'USER_ID_ASC',
  USER_ID_DESC = 'USER_ID_DESC'
}

/** Information about pagination in a connection. */
export type PageInfo = {
  __typename: 'PageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['Cursor']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean'];
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['Cursor']>;
};

/** Contains information about the patient relation. */
export type Patient = Node & {
  __typename: 'Patient';
  address1?: Maybe<Scalars['String']>;
  address2?: Maybe<Scalars['String']>;
  addressLat?: Maybe<Scalars['Float']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  addressLng?: Maybe<Scalars['Float']>;
  age?: Maybe<Scalars['Int']>;
  /** Reads and enables pagination through a set of `Appointment`. */
  appointmentsByEncounterPatientIdAndAppointmentId: PatientAppointmentsByEncounterPatientIdAndAppointmentIdManyToManyConnection;
  /** Reads and enables pagination through a set of `Appointment`. */
  appointmentsByEncounterPatientIdAndAppointmentIdList: Array<Appointment>;
  cannotProvideSsn?: Maybe<Scalars['Boolean']>;
  city?: Maybe<Scalars['String']>;
  communicationNeed?: Maybe<Array<Maybe<CommunicationNeedEnum>>>;
  createdAt: Scalars['Datetime'];
  deletedAt?: Maybe<Scalars['Datetime']>;
  dob?: Maybe<Scalars['Date']>;
  dosespotId?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  /** Reads and enables pagination through a set of `Encounter`. */
  encounters: EncountersConnection;
  /** Reads and enables pagination through a set of `Encounter`. */
  encountersList: Array<Encounter>;
  firstName?: Maybe<Scalars['String']>;
  fullName?: Maybe<Scalars['String']>;
  genderIdentity?: Maybe<GenderIdentityEnum>;
  genderPronoun?: Maybe<GenderPronounEnum>;
  /** global_human_id is a truncated version of the global_patient_id */
  globalHumanId?: Maybe<Scalars['String']>;
  /** global_patient_id is an algorithmically-generated identifier for the patient that is used throughout our applications at Ready */
  globalPatientId: Scalars['String'];
  hasDifferentGenderIdentity?: Maybe<Scalars['Boolean']>;
  hasPreferredName?: Maybe<Scalars['Boolean']>;
  humanizedCommunicationNeed?: Maybe<Array<Maybe<Scalars['String']>>>;
  humanizedGenderIdentity?: Maybe<Scalars['String']>;
  humanizedGenderPronoun?: Maybe<Scalars['String']>;
  humanizedGlobalHumanId?: Maybe<Scalars['String']>;
  humanizedLanguages?: Maybe<Array<Maybe<Scalars['String']>>>;
  humanizedNoSsnReason?: Maybe<Array<Maybe<Scalars['String']>>>;
  humanizedRaces?: Maybe<Array<Maybe<Scalars['String']>>>;
  humanizedSex?: Maybe<Scalars['String']>;
  /** Reads and enables pagination through a set of `InsuranceRecord`. */
  insuranceRecords: InsuranceRecordsConnection;
  /** Reads and enables pagination through a set of `InsuranceRecord`. */
  insuranceRecordsByEncounterPatientIdAndPrimaryInsurance: PatientInsuranceRecordsByEncounterPatientIdAndPrimaryInsuranceManyToManyConnection;
  /** Reads and enables pagination through a set of `InsuranceRecord`. */
  insuranceRecordsByEncounterPatientIdAndPrimaryInsuranceList: Array<InsuranceRecord>;
  /** Reads and enables pagination through a set of `InsuranceRecord`. */
  insuranceRecordsByEncounterPatientIdAndSecondaryInsurance: PatientInsuranceRecordsByEncounterPatientIdAndSecondaryInsuranceManyToManyConnection;
  /** Reads and enables pagination through a set of `InsuranceRecord`. */
  insuranceRecordsByEncounterPatientIdAndSecondaryInsuranceList: Array<InsuranceRecord>;
  /** Reads and enables pagination through a set of `InsuranceRecord`. */
  insuranceRecordsList: Array<InsuranceRecord>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  languages?: Maybe<Array<Maybe<LanguagesEnum>>>;
  lastName?: Maybe<Scalars['String']>;
  location?: Maybe<Scalars['String']>;
  middleName?: Maybe<Scalars['String']>;
  /** Meta column describing the data source from which the record migrated from. Default is null. */
  migrationSource?: Maybe<Scalars['String']>;
  noSsnReason?: Maybe<Array<Maybe<NoSsnReasonEnum>>>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  /** Reads and enables pagination through a set of `PatientAttachment`. */
  patientAttachments: PatientAttachmentsConnection;
  /** Reads and enables pagination through a set of `PatientAttachment`. */
  patientAttachmentsList: Array<PatientAttachment>;
  /** Reads and enables pagination through a set of `PatientGuardian`. */
  patientGuardians: PatientGuardiansConnection;
  /** Reads and enables pagination through a set of `PatientGuardian`. */
  patientGuardiansList: Array<PatientGuardian>;
  patientId: Scalars['Int'];
  /** Reads and enables pagination through a set of `PatientNote`. */
  patientNotes: PatientNotesConnection;
  /** Reads and enables pagination through a set of `PatientNote`. */
  patientNotesList: Array<PatientNote>;
  preferredName?: Maybe<Scalars['String']>;
  preferredPhoneNumber?: Maybe<Scalars['String']>;
  prefix?: Maybe<Scalars['String']>;
  races?: Maybe<Array<Maybe<RaceEnum>>>;
  respondersSeenBy?: Maybe<Array<Maybe<Scalars['Int']>>>;
  /** Reads and enables pagination through a set of `ServiceLine`. */
  serviceLinesByEncounterPatientIdAndServiceLineId: PatientServiceLinesByEncounterPatientIdAndServiceLineIdManyToManyConnection;
  /** Reads and enables pagination through a set of `ServiceLine`. */
  serviceLinesByEncounterPatientIdAndServiceLineIdList: Array<ServiceLine>;
  sex?: Maybe<SexEnum>;
  skeduloContactId?: Maybe<Scalars['UUID']>;
  specialInstructions?: Maybe<Scalars['String']>;
  ssnSerial?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  suffix?: Maybe<PatientSuffixEnum>;
  systemLastUpdatedBy: SystemOfOriginEnum;
  teladocPass?: Maybe<Scalars['String']>;
  teladocUser?: Maybe<Scalars['String']>;
  unit?: Maybe<Scalars['String']>;
  updatedAt: Scalars['Datetime'];
  /** Reads and enables pagination through a set of `User`. */
  usersByPatientNotePatientIdAndCreatedBy: PatientUsersByPatientNotePatientIdAndCreatedByManyToManyConnection;
  /** Reads and enables pagination through a set of `User`. */
  usersByPatientNotePatientIdAndCreatedByList: Array<User>;
  zip?: Maybe<Scalars['String']>;
};


/** Contains information about the patient relation. */
export type PatientappointmentsByEncounterPatientIdAndAppointmentIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<AppointmentCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AppointmentsOrderBy>>;
};


/** Contains information about the patient relation. */
export type PatientappointmentsByEncounterPatientIdAndAppointmentIdListArgs = {
  condition?: InputMaybe<AppointmentCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AppointmentsOrderBy>>;
};


/** Contains information about the patient relation. */
export type PatientencountersArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<EncounterCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EncountersOrderBy>>;
};


/** Contains information about the patient relation. */
export type PatientencountersListArgs = {
  condition?: InputMaybe<EncounterCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EncountersOrderBy>>;
};


/** Contains information about the patient relation. */
export type PatientinsuranceRecordsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<InsuranceRecordCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InsuranceRecordsOrderBy>>;
};


/** Contains information about the patient relation. */
export type PatientinsuranceRecordsByEncounterPatientIdAndPrimaryInsuranceArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<InsuranceRecordCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InsuranceRecordsOrderBy>>;
};


/** Contains information about the patient relation. */
export type PatientinsuranceRecordsByEncounterPatientIdAndPrimaryInsuranceListArgs = {
  condition?: InputMaybe<InsuranceRecordCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InsuranceRecordsOrderBy>>;
};


/** Contains information about the patient relation. */
export type PatientinsuranceRecordsByEncounterPatientIdAndSecondaryInsuranceArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<InsuranceRecordCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InsuranceRecordsOrderBy>>;
};


/** Contains information about the patient relation. */
export type PatientinsuranceRecordsByEncounterPatientIdAndSecondaryInsuranceListArgs = {
  condition?: InputMaybe<InsuranceRecordCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InsuranceRecordsOrderBy>>;
};


/** Contains information about the patient relation. */
export type PatientinsuranceRecordsListArgs = {
  condition?: InputMaybe<InsuranceRecordCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InsuranceRecordsOrderBy>>;
};


/** Contains information about the patient relation. */
export type PatientpatientAttachmentsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<PatientAttachmentCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PatientAttachmentsOrderBy>>;
};


/** Contains information about the patient relation. */
export type PatientpatientAttachmentsListArgs = {
  condition?: InputMaybe<PatientAttachmentCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PatientAttachmentsOrderBy>>;
};


/** Contains information about the patient relation. */
export type PatientpatientGuardiansArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<PatientGuardianCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PatientGuardiansOrderBy>>;
};


/** Contains information about the patient relation. */
export type PatientpatientGuardiansListArgs = {
  condition?: InputMaybe<PatientGuardianCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PatientGuardiansOrderBy>>;
};


/** Contains information about the patient relation. */
export type PatientpatientNotesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<PatientNoteCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PatientNotesOrderBy>>;
};


/** Contains information about the patient relation. */
export type PatientpatientNotesListArgs = {
  condition?: InputMaybe<PatientNoteCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PatientNotesOrderBy>>;
};


/** Contains information about the patient relation. */
export type PatientserviceLinesByEncounterPatientIdAndServiceLineIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ServiceLineCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ServiceLinesOrderBy>>;
};


/** Contains information about the patient relation. */
export type PatientserviceLinesByEncounterPatientIdAndServiceLineIdListArgs = {
  condition?: InputMaybe<ServiceLineCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ServiceLinesOrderBy>>;
};


/** Contains information about the patient relation. */
export type PatientusersByPatientNotePatientIdAndCreatedByArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<UserCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UsersOrderBy>>;
};


/** Contains information about the patient relation. */
export type PatientusersByPatientNotePatientIdAndCreatedByListArgs = {
  condition?: InputMaybe<UserCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UsersOrderBy>>;
};

/** A connection to a list of `PatientAllergy` values. */
export type PatientAllergiesConnection = {
  __typename: 'PatientAllergiesConnection';
  /** A list of edges which contains the `PatientAllergy` and cursor to aid in pagination. */
  edges: Array<PatientAllergiesEdge>;
  /** A list of `PatientAllergy` objects. */
  nodes: Array<PatientAllergy>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `PatientAllergy` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `PatientAllergy` edge in the connection. */
export type PatientAllergiesEdge = {
  __typename: 'PatientAllergiesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `PatientAllergy` at the end of the edge. */
  node: PatientAllergy;
};

/** Methods to use when ordering `PatientAllergy`. */
export enum PatientAllergiesOrderBy {
  ALLERGIC_CRITICALITY_ID_ASC = 'ALLERGIC_CRITICALITY_ID_ASC',
  ALLERGIC_CRITICALITY_ID_DESC = 'ALLERGIC_CRITICALITY_ID_DESC',
  ALLERGIC_REACTION_ID_ASC = 'ALLERGIC_REACTION_ID_ASC',
  ALLERGIC_REACTION_ID_DESC = 'ALLERGIC_REACTION_ID_DESC',
  ALLERGIC_SEVERITY_ID_ASC = 'ALLERGIC_SEVERITY_ID_ASC',
  ALLERGIC_SEVERITY_ID_DESC = 'ALLERGIC_SEVERITY_ID_DESC',
  ALLERGIC_STATUS_ID_ASC = 'ALLERGIC_STATUS_ID_ASC',
  ALLERGIC_STATUS_ID_DESC = 'ALLERGIC_STATUS_ID_DESC',
  ALLERGY_ID_ASC = 'ALLERGY_ID_ASC',
  ALLERGY_ID_DESC = 'ALLERGY_ID_DESC',
  NATURAL = 'NATURAL',
  PATIENT_ALLERGY_ID_ASC = 'PATIENT_ALLERGY_ID_ASC',
  PATIENT_ALLERGY_ID_DESC = 'PATIENT_ALLERGY_ID_DESC',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC'
}

/** Contains information about patient allergies */
export type PatientAllergy = Node & {
  __typename: 'PatientAllergy';
  /** Reads a single `AllergicCriticality` that is related to this `PatientAllergy`. */
  allergicCriticality?: Maybe<AllergicCriticality>;
  allergicCriticalityId?: Maybe<Scalars['Int']>;
  /** Reads a single `AllergicReaction` that is related to this `PatientAllergy`. */
  allergicReaction?: Maybe<AllergicReaction>;
  allergicReactionId?: Maybe<Scalars['Int']>;
  /** Reads a single `AllergicSeverity` that is related to this `PatientAllergy`. */
  allergicSeverity?: Maybe<AllergicSeverity>;
  allergicSeverityId?: Maybe<Scalars['Int']>;
  /** Reads a single `AllergicStatus` that is related to this `PatientAllergy`. */
  allergicStatus?: Maybe<AllergicStatus>;
  allergicStatusId?: Maybe<Scalars['Int']>;
  /** Reads a single `Allergy` that is related to this `PatientAllergy`. */
  allergy?: Maybe<Allergy>;
  allergyId: Scalars['Int'];
  createdAt: Scalars['Datetime'];
  createdBy: Scalars['Int'];
  deletedAt?: Maybe<Scalars['Datetime']>;
  deletedBy?: Maybe<Scalars['Int']>;
  encounterTaskId: Scalars['Int'];
  endedAt?: Maybe<Scalars['Datetime']>;
  finalizedAt?: Maybe<Scalars['Datetime']>;
  finalizedBy?: Maybe<Scalars['Int']>;
  isCurrent: Scalars['Boolean'];
  isDeleted: Scalars['Boolean'];
  isFinalized: Scalars['Boolean'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  note?: Maybe<Scalars['String']>;
  patientAllergyId: Scalars['Int'];
  patientId: Scalars['Int'];
  startedAt: Scalars['Datetime'];
};

/**
 * A condition to be used against `PatientAllergy` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type PatientAllergyCondition = {
  /** Checks for equality with the object’s `allergicCriticalityId` field. */
  allergicCriticalityId?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `allergicReactionId` field. */
  allergicReactionId?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `allergicSeverityId` field. */
  allergicSeverityId?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `allergicStatusId` field. */
  allergicStatusId?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `allergyId` field. */
  allergyId?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `patientAllergyId` field. */
  patientAllergyId?: InputMaybe<Scalars['Int']>;
};

/** A connection to a list of `Appointment` values, with data from `Encounter`. */
export type PatientAppointmentsByEncounterPatientIdAndAppointmentIdManyToManyConnection = {
  __typename: 'PatientAppointmentsByEncounterPatientIdAndAppointmentIdManyToManyConnection';
  /** A list of edges which contains the `Appointment`, info from the `Encounter`, and the cursor to aid in pagination. */
  edges: Array<PatientAppointmentsByEncounterPatientIdAndAppointmentIdManyToManyEdge>;
  /** A list of `Appointment` objects. */
  nodes: Array<Appointment>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Appointment` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Appointment` edge in the connection, with data from `Encounter`. */
export type PatientAppointmentsByEncounterPatientIdAndAppointmentIdManyToManyEdge = {
  __typename: 'PatientAppointmentsByEncounterPatientIdAndAppointmentIdManyToManyEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** Reads and enables pagination through a set of `Encounter`. */
  encounters: EncountersConnection;
  /** Reads and enables pagination through a set of `Encounter`. */
  encountersList: Array<Encounter>;
  /** The `Appointment` at the end of the edge. */
  node: Appointment;
};


/** A `Appointment` edge in the connection, with data from `Encounter`. */
export type PatientAppointmentsByEncounterPatientIdAndAppointmentIdManyToManyEdgeencountersArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<EncounterCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EncountersOrderBy>>;
};


/** A `Appointment` edge in the connection, with data from `Encounter`. */
export type PatientAppointmentsByEncounterPatientIdAndAppointmentIdManyToManyEdgeencountersListArgs = {
  condition?: InputMaybe<EncounterCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EncountersOrderBy>>;
};

/** Contains information about the patient attachments */
export type PatientAttachment = Node & {
  __typename: 'PatientAttachment';
  createdAt: Scalars['Datetime'];
  description?: Maybe<Scalars['String']>;
  isDeleted: Scalars['Boolean'];
  migrationSource?: Maybe<Scalars['String']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  /** Reads a single `Patient` that is related to this `PatientAttachment`. */
  patient?: Maybe<Patient>;
  patientAttachmentId: Scalars['Int'];
  patientId: Scalars['Int'];
  type: PatientAttachmentTypeEnum;
  url: Scalars['JSON'];
};

/**
 * A condition to be used against `PatientAttachment` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type PatientAttachmentCondition = {
  /** Checks for equality with the object’s `migrationSource` field. */
  migrationSource?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `patientAttachmentId` field. */
  patientAttachmentId?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `patientId` field. */
  patientId?: InputMaybe<Scalars['Int']>;
};

/** Represents an update to a `PatientAttachment`. Fields that are set will be updated. */
export type PatientAttachmentPatch = {
  createdAt?: InputMaybe<Scalars['Datetime']>;
  description?: InputMaybe<Scalars['String']>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  migrationSource?: InputMaybe<Scalars['String']>;
  patientAttachmentId?: InputMaybe<Scalars['Int']>;
  patientId?: InputMaybe<Scalars['Int']>;
  type?: InputMaybe<PatientAttachmentTypeEnum>;
  url?: InputMaybe<Scalars['JSON']>;
};

export enum PatientAttachmentTypeEnum {
  FORMS = 'FORMS',
  GUARDIANSHIP = 'GUARDIANSHIP',
  PATIENT_ID = 'PATIENT_ID',
  PROFILE_PICTURE = 'PROFILE_PICTURE'
}

/** A connection to a list of `PatientAttachment` values. */
export type PatientAttachmentsConnection = {
  __typename: 'PatientAttachmentsConnection';
  /** A list of edges which contains the `PatientAttachment` and cursor to aid in pagination. */
  edges: Array<PatientAttachmentsEdge>;
  /** A list of `PatientAttachment` objects. */
  nodes: Array<PatientAttachment>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `PatientAttachment` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `PatientAttachment` edge in the connection. */
export type PatientAttachmentsEdge = {
  __typename: 'PatientAttachmentsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `PatientAttachment` at the end of the edge. */
  node: PatientAttachment;
};

/** Methods to use when ordering `PatientAttachment`. */
export enum PatientAttachmentsOrderBy {
  MIGRATION_SOURCE_ASC = 'MIGRATION_SOURCE_ASC',
  MIGRATION_SOURCE_DESC = 'MIGRATION_SOURCE_DESC',
  NATURAL = 'NATURAL',
  PATIENT_ATTACHMENT_ID_ASC = 'PATIENT_ATTACHMENT_ID_ASC',
  PATIENT_ATTACHMENT_ID_DESC = 'PATIENT_ATTACHMENT_ID_DESC',
  PATIENT_ID_ASC = 'PATIENT_ID_ASC',
  PATIENT_ID_DESC = 'PATIENT_ID_DESC',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC'
}

/** A condition to be used against `Patient` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type PatientCondition = {
  /** Filters to records matching `globalHumanId`: checks against globalPatientId */
  globalHumanIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Checks for equality with the object’s `globalPatientId` field. */
  globalPatientId?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `migrationSource` field. */
  migrationSource?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `patientId` field. */
  patientId?: InputMaybe<Scalars['Int']>;
  /** Filters to records matching `patientId` */
  patientIds?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Filters to records where `updatedAt` is after or equal to updated_at */
  updatedAtAfter?: InputMaybe<Scalars['String']>;
};

/** A connection to a list of `PatientDiagnosis` values. */
export type PatientDiagnosesConnection = {
  __typename: 'PatientDiagnosesConnection';
  /** A list of edges which contains the `PatientDiagnosis` and cursor to aid in pagination. */
  edges: Array<PatientDiagnosesEdge>;
  /** A list of `PatientDiagnosis` objects. */
  nodes: Array<PatientDiagnosis>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `PatientDiagnosis` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `PatientDiagnosis` edge in the connection. */
export type PatientDiagnosesEdge = {
  __typename: 'PatientDiagnosesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `PatientDiagnosis` at the end of the edge. */
  node: PatientDiagnosis;
};

/** Methods to use when ordering `PatientDiagnosis`. */
export enum PatientDiagnosesOrderBy {
  DIAGNOSIS_CODE_REFERENCE_ID_ASC = 'DIAGNOSIS_CODE_REFERENCE_ID_ASC',
  DIAGNOSIS_CODE_REFERENCE_ID_DESC = 'DIAGNOSIS_CODE_REFERENCE_ID_DESC',
  ENCOUNTER_TASK_ID_ASC = 'ENCOUNTER_TASK_ID_ASC',
  ENCOUNTER_TASK_ID_DESC = 'ENCOUNTER_TASK_ID_DESC',
  NATURAL = 'NATURAL',
  PATIENT_DIAGNOSIS_ID_ASC = 'PATIENT_DIAGNOSIS_ID_ASC',
  PATIENT_DIAGNOSIS_ID_DESC = 'PATIENT_DIAGNOSIS_ID_DESC',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC'
}

/** Contains Patient Diagnosis information */
export type PatientDiagnosis = Node & {
  __typename: 'PatientDiagnosis';
  createdAt: Scalars['Datetime'];
  deletedAt?: Maybe<Scalars['Datetime']>;
  /** Reads a single `DiagnosisCodeReference` that is related to this `PatientDiagnosis`. */
  diagnosisCodeReference?: Maybe<DiagnosisCodeReference>;
  diagnosisCodeReferenceId?: Maybe<Scalars['Int']>;
  /** Reads a single `EncounterTask` that is related to this `PatientDiagnosis`. */
  encounterTask?: Maybe<EncounterTask>;
  encounterTaskId?: Maybe<Scalars['Int']>;
  isDeleted: Scalars['Boolean'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  order: Scalars['Int'];
  patientDiagnosisId: Scalars['Int'];
  updatedAt: Scalars['Datetime'];
};

/**
 * A condition to be used against `PatientDiagnosis` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type PatientDiagnosisCondition = {
  /** Checks for equality with the object’s `diagnosisCodeReferenceId` field. */
  diagnosisCodeReferenceId?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `encounterTaskId` field. */
  encounterTaskId?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `patientDiagnosisId` field. */
  patientDiagnosisId?: InputMaybe<Scalars['Int']>;
};

export type PatientEncounterRequest = {
  modules: Array<Scalars['String']>;
  responderGender?: InputMaybe<Scalars['String']>;
  serviceLineId: Scalars['Int'];
};

/** Contains information linking a patient to a completed form for a given task / encounter */
export type PatientForm = Node & {
  __typename: 'PatientForm';
  createdAt: Scalars['Datetime'];
  deletedAt?: Maybe<Scalars['Datetime']>;
  encounterId?: Maybe<Scalars['Int']>;
  encounterTaskId: Scalars['Int'];
  /** @deprecated Use `field_response_json` for valid JSON. This field remains to preserve existing data. */
  fieldResponse?: Maybe<Scalars['JSON']>;
  fieldResponseJson?: Maybe<Scalars['JSON']>;
  formstackId?: Maybe<Scalars['String']>;
  isDeleted: Scalars['Boolean'];
  migrationSource?: Maybe<Scalars['String']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  patientFormId: Scalars['Int'];
  patientFormLookupId: Scalars['Int'];
  patientId?: Maybe<Scalars['Int']>;
  signedAt?: Maybe<Scalars['Datetime']>;
  updatedAt?: Maybe<Scalars['Datetime']>;
};

export enum PatientFormCategoryEnum {
  ABN_NONCOVERAGE = 'ABN_NONCOVERAGE',
  AMA = 'AMA',
  AUDIT_C = 'AUDIT_C',
  CC_CLOSURE = 'CC_CLOSURE',
  CC_GENERAL = 'CC_GENERAL',
  COVID_CONTRAINDICATIONS = 'COVID_CONTRAINDICATIONS',
  DAST_10 = 'DAST_10',
  EMS_ACTIVATION = 'EMS_ACTIVATION',
  EXACT_SCIENCES_QUESTIONS = 'EXACT_SCIENCES_QUESTIONS',
  FLU_CONTRAINDICATIONS = 'FLU_CONTRAINDICATIONS',
  GAD_7 = 'GAD_7',
  HHS_COVID = 'HHS_COVID',
  KATZ_ADL = 'KATZ_ADL',
  MORISKY_RX_ADHERENCE = 'MORISKY_RX_ADHERENCE',
  MORSE_FALL = 'MORSE_FALL',
  PAIN = 'PAIN',
  PATIENT_CONSENT = 'PATIENT_CONSENT',
  PATIENT_CONSENT_EXACT_SCIENCES = 'PATIENT_CONSENT_EXACT_SCIENCES',
  PHQ = 'PHQ',
  POSTPARTUM_DEPRESSION = 'POSTPARTUM_DEPRESSION',
  PRIVACY_PRACTICES = 'PRIVACY_PRACTICES',
  RAD_GENERAL = 'RAD_GENERAL',
  RELEASE_MEDICAL = 'RELEASE_MEDICAL',
  RELEASE_MENTAL_HEALTH = 'RELEASE_MENTAL_HEALTH',
  RELEASE_PSYCHOTHERAPY = 'RELEASE_PSYCHOTHERAPY',
  SDOH = 'SDOH',
  TECHNOLOGY = 'TECHNOLOGY'
}

/**
 * A condition to be used against `PatientForm` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type PatientFormCondition = {
  /** Checks for equality with the object’s `migrationSource` field. */
  migrationSource?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `patientFormId` field. */
  patientFormId?: InputMaybe<Scalars['Int']>;
};

/** Contains information about patient form defintions and the url to form document */
export type PatientFormLookup = Node & {
  __typename: 'PatientFormLookup';
  createdAt?: Maybe<Scalars['Datetime']>;
  formUrl?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isNonStandard: Scalars['Boolean'];
  language?: Maybe<LanguagesEnum>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  patientFormCategory: PatientFormCategoryEnum;
  patientFormLookupId: Scalars['Int'];
  title?: Maybe<Scalars['String']>;
  version?: Maybe<Scalars['String']>;
};

/**
 * A condition to be used against `PatientFormLookup` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type PatientFormLookupCondition = {
  /** Checks for equality with the object’s `patientFormLookupId` field. */
  patientFormLookupId?: InputMaybe<Scalars['Int']>;
};

/** A connection to a list of `PatientFormLookup` values. */
export type PatientFormLookupsConnection = {
  __typename: 'PatientFormLookupsConnection';
  /** A list of edges which contains the `PatientFormLookup` and cursor to aid in pagination. */
  edges: Array<PatientFormLookupsEdge>;
  /** A list of `PatientFormLookup` objects. */
  nodes: Array<PatientFormLookup>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `PatientFormLookup` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `PatientFormLookup` edge in the connection. */
export type PatientFormLookupsEdge = {
  __typename: 'PatientFormLookupsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `PatientFormLookup` at the end of the edge. */
  node: PatientFormLookup;
};

/** Methods to use when ordering `PatientFormLookup`. */
export enum PatientFormLookupsOrderBy {
  NATURAL = 'NATURAL',
  PATIENT_FORM_LOOKUP_ID_ASC = 'PATIENT_FORM_LOOKUP_ID_ASC',
  PATIENT_FORM_LOOKUP_ID_DESC = 'PATIENT_FORM_LOOKUP_ID_DESC',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC'
}

/** A connection to a list of `PatientForm` values. */
export type PatientFormsConnection = {
  __typename: 'PatientFormsConnection';
  /** A list of edges which contains the `PatientForm` and cursor to aid in pagination. */
  edges: Array<PatientFormsEdge>;
  /** A list of `PatientForm` objects. */
  nodes: Array<PatientForm>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `PatientForm` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `PatientForm` edge in the connection. */
export type PatientFormsEdge = {
  __typename: 'PatientFormsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `PatientForm` at the end of the edge. */
  node: PatientForm;
};

/** Methods to use when ordering `PatientForm`. */
export enum PatientFormsOrderBy {
  MIGRATION_SOURCE_ASC = 'MIGRATION_SOURCE_ASC',
  MIGRATION_SOURCE_DESC = 'MIGRATION_SOURCE_DESC',
  NATURAL = 'NATURAL',
  PATIENT_FORM_ID_ASC = 'PATIENT_FORM_ID_ASC',
  PATIENT_FORM_ID_DESC = 'PATIENT_FORM_ID_DESC',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC'
}

/** Contains information about the relationship between the patients and guardians. */
export type PatientGuardian = Node & {
  __typename: 'PatientGuardian';
  createdAt?: Maybe<Scalars['Datetime']>;
  deletedAt?: Maybe<Scalars['Datetime']>;
  guardianId: Scalars['Int'];
  guardianRelationship: Scalars['String'];
  isDeleted?: Maybe<Scalars['Boolean']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  /** Reads a single `Patient` that is related to this `PatientGuardian`. */
  patient?: Maybe<Patient>;
  patientId: Scalars['Int'];
  updatedAt?: Maybe<Scalars['Datetime']>;
};

/**
 * A condition to be used against `PatientGuardian` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type PatientGuardianCondition = {
  /** Checks for equality with the object’s `patientId` field. */
  patientId?: InputMaybe<Scalars['Int']>;
};

/** A connection to a list of `PatientGuardian` values. */
export type PatientGuardiansConnection = {
  __typename: 'PatientGuardiansConnection';
  /** A list of edges which contains the `PatientGuardian` and cursor to aid in pagination. */
  edges: Array<PatientGuardiansEdge>;
  /** A list of `PatientGuardian` objects. */
  nodes: Array<PatientGuardian>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `PatientGuardian` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `PatientGuardian` edge in the connection. */
export type PatientGuardiansEdge = {
  __typename: 'PatientGuardiansEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `PatientGuardian` at the end of the edge. */
  node: PatientGuardian;
};

/** Methods to use when ordering `PatientGuardian`. */
export enum PatientGuardiansOrderBy {
  NATURAL = 'NATURAL',
  PATIENT_ID_ASC = 'PATIENT_ID_ASC',
  PATIENT_ID_DESC = 'PATIENT_ID_DESC',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC'
}

/** An input for mutations affecting `PatientInputRecord` */
export type PatientInputRecordInput = {
  address1?: InputMaybe<Scalars['String']>;
  address2?: InputMaybe<Scalars['String']>;
  addressLat?: InputMaybe<Scalars['Float']>;
  addressLng?: InputMaybe<Scalars['Float']>;
  cannotProvideSsn?: InputMaybe<Scalars['Boolean']>;
  city?: InputMaybe<Scalars['String']>;
  communicationNeed?: InputMaybe<Array<InputMaybe<CommunicationNeedEnum>>>;
  dob: Scalars['Date'];
  email?: InputMaybe<Scalars['String']>;
  firstName: Scalars['String'];
  genderIdentity?: InputMaybe<GenderIdentityEnum>;
  genderPronoun?: InputMaybe<GenderPronounEnum>;
  hasDifferentGenderIdentity?: InputMaybe<Scalars['Boolean']>;
  hasPreferredName?: InputMaybe<Scalars['Boolean']>;
  languages?: InputMaybe<Array<InputMaybe<LanguagesEnum>>>;
  lastName: Scalars['String'];
  middleName?: InputMaybe<Scalars['String']>;
  noSsnReason?: InputMaybe<Array<InputMaybe<NoSsnReasonEnum>>>;
  preferredName?: InputMaybe<Scalars['String']>;
  preferredPhoneNumber?: InputMaybe<Scalars['String']>;
  prefix?: InputMaybe<Scalars['String']>;
  races?: InputMaybe<Array<InputMaybe<RaceEnum>>>;
  sex?: InputMaybe<SexEnum>;
  skeduloContactId?: InputMaybe<Scalars['UUID']>;
  specialInstructions?: InputMaybe<Scalars['String']>;
  ssn?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  suffix?: InputMaybe<PatientSuffixEnum>;
  systemLastUpdatedBy?: InputMaybe<SystemOfOriginEnum>;
  teladocPass?: InputMaybe<Scalars['String']>;
  teladocUser?: InputMaybe<Scalars['String']>;
  unit?: InputMaybe<Scalars['String']>;
  zip?: InputMaybe<Scalars['String']>;
};

/** Contains data related to Patient Instructions */
export type PatientInstruction = Node & {
  __typename: 'PatientInstruction';
  careInstructions?: Maybe<Scalars['String']>;
  createdAt: Scalars['Datetime'];
  createdBy?: Maybe<Scalars['Int']>;
  deletedAt?: Maybe<Scalars['Datetime']>;
  encounterTaskId: Scalars['Int'];
  excusedUntilDate?: Maybe<Scalars['Date']>;
  isDeleted: Scalars['Boolean'];
  levelOfCare?: Maybe<PatientInstructionLevelOfCareEnum>;
  levelOfCareOther?: Maybe<Scalars['String']>;
  medicalRestrictions?: Maybe<Scalars['String']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  patientInstructionId: Scalars['Int'];
  relevantPastMedicalHistory?: Maybe<Scalars['String']>;
  timeframeUnit?: Maybe<PatientInstructionTimeframeEnum>;
  timeframeValue?: Maybe<Scalars['Int']>;
  type: PatientInstructionTypeEnum;
};

/**
 * A condition to be used against `PatientInstruction` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type PatientInstructionCondition = {
  /** Checks for equality with the object’s `encounterTaskId` field. */
  encounterTaskId?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `patientInstructionId` field. */
  patientInstructionId?: InputMaybe<Scalars['Int']>;
};

export enum PatientInstructionLevelOfCareEnum {
  BEHAVIORAL_HEALTH_PROVIDER = 'BEHAVIORAL_HEALTH_PROVIDER',
  EMS = 'EMS',
  OTHER = 'OTHER',
  PRIMARY_CARE = 'PRIMARY_CARE',
  READY = 'READY',
  SOCIAL_WORKER = 'SOCIAL_WORKER',
  SPECIALIST_PROVIDER = 'SPECIALIST_PROVIDER',
  URGENT_CARE = 'URGENT_CARE'
}

export enum PatientInstructionTimeframeEnum {
  AS_SOON_AS_POSSIBLE = 'AS_SOON_AS_POSSIBLE',
  DAY = 'DAY',
  HOUR = 'HOUR',
  IMMEDIATELY = 'IMMEDIATELY',
  MONTH = 'MONTH',
  WEEK = 'WEEK'
}

export enum PatientInstructionTypeEnum {
  FOLLOW_UP = 'FOLLOW_UP',
  GENERAL_CARE_INSTRUCTIONS = 'GENERAL_CARE_INSTRUCTIONS',
  NEGATIVE_COVID_19_TRAVEL_NOTE = 'NEGATIVE_COVID_19_TRAVEL_NOTE',
  TRANSFER_OF_CARE = 'TRANSFER_OF_CARE',
  WORK_OR_SCHOOL_NOTE = 'WORK_OR_SCHOOL_NOTE'
}

/** A connection to a list of `PatientInstruction` values. */
export type PatientInstructionsConnection = {
  __typename: 'PatientInstructionsConnection';
  /** A list of edges which contains the `PatientInstruction` and cursor to aid in pagination. */
  edges: Array<PatientInstructionsEdge>;
  /** A list of `PatientInstruction` objects. */
  nodes: Array<PatientInstruction>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `PatientInstruction` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `PatientInstruction` edge in the connection. */
export type PatientInstructionsEdge = {
  __typename: 'PatientInstructionsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `PatientInstruction` at the end of the edge. */
  node: PatientInstruction;
};

/** Methods to use when ordering `PatientInstruction`. */
export enum PatientInstructionsOrderBy {
  ENCOUNTER_TASK_ID_ASC = 'ENCOUNTER_TASK_ID_ASC',
  ENCOUNTER_TASK_ID_DESC = 'ENCOUNTER_TASK_ID_DESC',
  NATURAL = 'NATURAL',
  PATIENT_INSTRUCTION_ID_ASC = 'PATIENT_INSTRUCTION_ID_ASC',
  PATIENT_INSTRUCTION_ID_DESC = 'PATIENT_INSTRUCTION_ID_DESC',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC'
}

/** A connection to a list of `InsuranceRecord` values, with data from `Encounter`. */
export type PatientInsuranceRecordsByEncounterPatientIdAndPrimaryInsuranceManyToManyConnection = {
  __typename: 'PatientInsuranceRecordsByEncounterPatientIdAndPrimaryInsuranceManyToManyConnection';
  /** A list of edges which contains the `InsuranceRecord`, info from the `Encounter`, and the cursor to aid in pagination. */
  edges: Array<PatientInsuranceRecordsByEncounterPatientIdAndPrimaryInsuranceManyToManyEdge>;
  /** A list of `InsuranceRecord` objects. */
  nodes: Array<InsuranceRecord>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `InsuranceRecord` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `InsuranceRecord` edge in the connection, with data from `Encounter`. */
export type PatientInsuranceRecordsByEncounterPatientIdAndPrimaryInsuranceManyToManyEdge = {
  __typename: 'PatientInsuranceRecordsByEncounterPatientIdAndPrimaryInsuranceManyToManyEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** Reads and enables pagination through a set of `Encounter`. */
  encountersByPrimaryInsurance: EncountersConnection;
  /** Reads and enables pagination through a set of `Encounter`. */
  encountersByPrimaryInsuranceList: Array<Encounter>;
  /** The `InsuranceRecord` at the end of the edge. */
  node: InsuranceRecord;
};


/** A `InsuranceRecord` edge in the connection, with data from `Encounter`. */
export type PatientInsuranceRecordsByEncounterPatientIdAndPrimaryInsuranceManyToManyEdgeencountersByPrimaryInsuranceArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<EncounterCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EncountersOrderBy>>;
};


/** A `InsuranceRecord` edge in the connection, with data from `Encounter`. */
export type PatientInsuranceRecordsByEncounterPatientIdAndPrimaryInsuranceManyToManyEdgeencountersByPrimaryInsuranceListArgs = {
  condition?: InputMaybe<EncounterCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EncountersOrderBy>>;
};

/** A connection to a list of `InsuranceRecord` values, with data from `Encounter`. */
export type PatientInsuranceRecordsByEncounterPatientIdAndSecondaryInsuranceManyToManyConnection = {
  __typename: 'PatientInsuranceRecordsByEncounterPatientIdAndSecondaryInsuranceManyToManyConnection';
  /** A list of edges which contains the `InsuranceRecord`, info from the `Encounter`, and the cursor to aid in pagination. */
  edges: Array<PatientInsuranceRecordsByEncounterPatientIdAndSecondaryInsuranceManyToManyEdge>;
  /** A list of `InsuranceRecord` objects. */
  nodes: Array<InsuranceRecord>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `InsuranceRecord` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `InsuranceRecord` edge in the connection, with data from `Encounter`. */
export type PatientInsuranceRecordsByEncounterPatientIdAndSecondaryInsuranceManyToManyEdge = {
  __typename: 'PatientInsuranceRecordsByEncounterPatientIdAndSecondaryInsuranceManyToManyEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** Reads and enables pagination through a set of `Encounter`. */
  encountersBySecondaryInsurance: EncountersConnection;
  /** Reads and enables pagination through a set of `Encounter`. */
  encountersBySecondaryInsuranceList: Array<Encounter>;
  /** The `InsuranceRecord` at the end of the edge. */
  node: InsuranceRecord;
};


/** A `InsuranceRecord` edge in the connection, with data from `Encounter`. */
export type PatientInsuranceRecordsByEncounterPatientIdAndSecondaryInsuranceManyToManyEdgeencountersBySecondaryInsuranceArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<EncounterCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EncountersOrderBy>>;
};


/** A `InsuranceRecord` edge in the connection, with data from `Encounter`. */
export type PatientInsuranceRecordsByEncounterPatientIdAndSecondaryInsuranceManyToManyEdgeencountersBySecondaryInsuranceListArgs = {
  condition?: InputMaybe<EncounterCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EncountersOrderBy>>;
};

/** Contains information about patient notes */
export type PatientNote = Node & {
  __typename: 'PatientNote';
  createdAt: Scalars['Datetime'];
  createdBy?: Maybe<Scalars['Int']>;
  formattedCreatedAt?: Maybe<Scalars['String']>;
  globalPatientId: Scalars['String'];
  isDeleted?: Maybe<Scalars['Boolean']>;
  isHighPriority?: Maybe<Scalars['Boolean']>;
  label?: Maybe<PatientNoteLabel>;
  migrationSource?: Maybe<Scalars['String']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  note: Scalars['String'];
  /** Reads a single `Patient` that is related to this `PatientNote`. */
  patient?: Maybe<Patient>;
  patientId: Scalars['Int'];
  patientNoteId: Scalars['Int'];
  systemLastUpdatedBy: SystemOfOriginEnum;
  updatedAt: Scalars['Datetime'];
  updatedBy?: Maybe<Scalars['Int']>;
  /** Reads a single `User` that is related to this `PatientNote`. */
  userByCreatedBy?: Maybe<User>;
};

/**
 * A condition to be used against `PatientNote` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type PatientNoteCondition = {
  /** Checks for equality with the object’s `createdBy` field. */
  createdBy?: InputMaybe<Scalars['Int']>;
  /** Filters to records matching isDeleted */
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  /** Filters to records matching isHighPriority */
  isHighPriority?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `patientId` field. */
  patientId?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `patientNoteId` field. */
  patientNoteId?: InputMaybe<Scalars['Int']>;
};

/** An input for mutations affecting `PatientNoteInputRecord` */
export type PatientNoteInputRecordInput = {
  isHighPriority?: InputMaybe<Scalars['Boolean']>;
  label?: InputMaybe<PatientNoteLabel>;
  note: Scalars['String'];
  patientId: Scalars['Int'];
  systemLastUpdatedBy?: InputMaybe<SystemOfOriginEnum>;
};

export enum PatientNoteLabel {
  CLINICAL = 'CLINICAL',
  SAFETY = 'SAFETY'
}

/** An input for mutations affecting `PatientNotePatchRecord` */
export type PatientNotePatchRecordInput = {
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isHighPriority?: InputMaybe<Scalars['Boolean']>;
  label?: InputMaybe<PatientNoteLabel>;
  note?: InputMaybe<Scalars['String']>;
  systemLastUpdatedBy?: InputMaybe<SystemOfOriginEnum>;
};

/** A connection to a list of `PatientNote` values. */
export type PatientNotesConnection = {
  __typename: 'PatientNotesConnection';
  /** A list of edges which contains the `PatientNote` and cursor to aid in pagination. */
  edges: Array<PatientNotesEdge>;
  /** A list of `PatientNote` objects. */
  nodes: Array<PatientNote>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `PatientNote` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `PatientNote` edge in the connection. */
export type PatientNotesEdge = {
  __typename: 'PatientNotesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `PatientNote` at the end of the edge. */
  node: PatientNote;
};

/** Methods to use when ordering `PatientNote`. */
export enum PatientNotesOrderBy {
  CREATED_BY_ASC = 'CREATED_BY_ASC',
  CREATED_BY_DESC = 'CREATED_BY_DESC',
  NATURAL = 'NATURAL',
  PATIENT_ID_ASC = 'PATIENT_ID_ASC',
  PATIENT_ID_DESC = 'PATIENT_ID_DESC',
  PATIENT_NOTE_ID_ASC = 'PATIENT_NOTE_ID_ASC',
  PATIENT_NOTE_ID_DESC = 'PATIENT_NOTE_ID_DESC',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC'
}

/** An input for mutations affecting `PatientPatchRecord` */
export type PatientPatchRecordInput = {
  address1?: InputMaybe<Scalars['String']>;
  address2?: InputMaybe<Scalars['String']>;
  addressLat?: InputMaybe<Scalars['Float']>;
  addressLng?: InputMaybe<Scalars['Float']>;
  cannotProvideSsn?: InputMaybe<Scalars['Boolean']>;
  city?: InputMaybe<Scalars['String']>;
  communicationNeed?: InputMaybe<Array<InputMaybe<CommunicationNeedEnum>>>;
  dob?: InputMaybe<Scalars['Date']>;
  dosespotId?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  genderIdentity?: InputMaybe<GenderIdentityEnum>;
  genderPronoun?: InputMaybe<GenderPronounEnum>;
  hasDifferentGenderIdentity?: InputMaybe<Scalars['Boolean']>;
  hasPreferredName?: InputMaybe<Scalars['Boolean']>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  languages?: InputMaybe<Array<InputMaybe<LanguagesEnum>>>;
  lastName?: InputMaybe<Scalars['String']>;
  middleName?: InputMaybe<Scalars['String']>;
  noSsnReason?: InputMaybe<Array<InputMaybe<NoSsnReasonEnum>>>;
  preferredName?: InputMaybe<Scalars['String']>;
  preferredPhoneNumber?: InputMaybe<Scalars['String']>;
  prefix?: InputMaybe<Scalars['String']>;
  races?: InputMaybe<Array<InputMaybe<RaceEnum>>>;
  sex?: InputMaybe<SexEnum>;
  skeduloContactId?: InputMaybe<Scalars['UUID']>;
  specialInstructions?: InputMaybe<Scalars['String']>;
  ssn?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  suffix?: InputMaybe<PatientSuffixEnum>;
  systemLastUpdatedBy?: InputMaybe<SystemOfOriginEnum>;
  teladocPass?: InputMaybe<Scalars['String']>;
  teladocUser?: InputMaybe<Scalars['String']>;
  unit?: InputMaybe<Scalars['String']>;
  zip?: InputMaybe<Scalars['String']>;
};

/** Contains information about patient problem lists */
export type PatientProblem = Node & {
  __typename: 'PatientProblem';
  addedAt: Scalars['Datetime'];
  createdAt: Scalars['Datetime'];
  createdBy: Scalars['Int'];
  deletedAt?: Maybe<Scalars['Datetime']>;
  deletedBy?: Maybe<Scalars['Int']>;
  encounterTaskId: Scalars['Int'];
  endedAt?: Maybe<Scalars['Datetime']>;
  finalizedAt?: Maybe<Scalars['Datetime']>;
  finalizedBy?: Maybe<Scalars['Int']>;
  isCurrent: Scalars['Boolean'];
  isDeleted: Scalars['Boolean'];
  isFinalized: Scalars['Boolean'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  note?: Maybe<Scalars['String']>;
  patientId: Scalars['Int'];
  patientProblemId: Scalars['Int'];
  /** Reads a single `Problem` that is related to this `PatientProblem`. */
  problem?: Maybe<Problem>;
  /** Reads a single `ProblemCategory` that is related to this `PatientProblem`. */
  problemCategory?: Maybe<ProblemCategory>;
  problemCategoryId?: Maybe<Scalars['Int']>;
  problemId?: Maybe<Scalars['Int']>;
  /** Reads a single `ProblemStatus` that is related to this `PatientProblem`. */
  problemStatus?: Maybe<ProblemStatus>;
  problemStatusId?: Maybe<Scalars['Int']>;
  problemText?: Maybe<Scalars['String']>;
  startedAt?: Maybe<Scalars['Datetime']>;
};

/**
 * A condition to be used against `PatientProblem` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type PatientProblemCondition = {
  /** Checks for equality with the object’s `patientProblemId` field. */
  patientProblemId?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `problemCategoryId` field. */
  problemCategoryId?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `problemId` field. */
  problemId?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `problemStatusId` field. */
  problemStatusId?: InputMaybe<Scalars['Int']>;
};

/** A connection to a list of `PatientProblem` values. */
export type PatientProblemsConnection = {
  __typename: 'PatientProblemsConnection';
  /** A list of edges which contains the `PatientProblem` and cursor to aid in pagination. */
  edges: Array<PatientProblemsEdge>;
  /** A list of `PatientProblem` objects. */
  nodes: Array<PatientProblem>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `PatientProblem` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `PatientProblem` edge in the connection. */
export type PatientProblemsEdge = {
  __typename: 'PatientProblemsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `PatientProblem` at the end of the edge. */
  node: PatientProblem;
};

/** Methods to use when ordering `PatientProblem`. */
export enum PatientProblemsOrderBy {
  NATURAL = 'NATURAL',
  PATIENT_PROBLEM_ID_ASC = 'PATIENT_PROBLEM_ID_ASC',
  PATIENT_PROBLEM_ID_DESC = 'PATIENT_PROBLEM_ID_DESC',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  PROBLEM_CATEGORY_ID_ASC = 'PROBLEM_CATEGORY_ID_ASC',
  PROBLEM_CATEGORY_ID_DESC = 'PROBLEM_CATEGORY_ID_DESC',
  PROBLEM_ID_ASC = 'PROBLEM_ID_ASC',
  PROBLEM_ID_DESC = 'PROBLEM_ID_DESC',
  PROBLEM_STATUS_ID_ASC = 'PROBLEM_STATUS_ID_ASC',
  PROBLEM_STATUS_ID_DESC = 'PROBLEM_STATUS_ID_DESC'
}

/** A connection to a list of `ServiceLine` values, with data from `Encounter`. */
export type PatientServiceLinesByEncounterPatientIdAndServiceLineIdManyToManyConnection = {
  __typename: 'PatientServiceLinesByEncounterPatientIdAndServiceLineIdManyToManyConnection';
  /** A list of edges which contains the `ServiceLine`, info from the `Encounter`, and the cursor to aid in pagination. */
  edges: Array<PatientServiceLinesByEncounterPatientIdAndServiceLineIdManyToManyEdge>;
  /** A list of `ServiceLine` objects. */
  nodes: Array<ServiceLine>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ServiceLine` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `ServiceLine` edge in the connection, with data from `Encounter`. */
export type PatientServiceLinesByEncounterPatientIdAndServiceLineIdManyToManyEdge = {
  __typename: 'PatientServiceLinesByEncounterPatientIdAndServiceLineIdManyToManyEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** Reads and enables pagination through a set of `Encounter`. */
  encounters: EncountersConnection;
  /** Reads and enables pagination through a set of `Encounter`. */
  encountersList: Array<Encounter>;
  /** The `ServiceLine` at the end of the edge. */
  node: ServiceLine;
};


/** A `ServiceLine` edge in the connection, with data from `Encounter`. */
export type PatientServiceLinesByEncounterPatientIdAndServiceLineIdManyToManyEdgeencountersArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<EncounterCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EncountersOrderBy>>;
};


/** A `ServiceLine` edge in the connection, with data from `Encounter`. */
export type PatientServiceLinesByEncounterPatientIdAndServiceLineIdManyToManyEdgeencountersListArgs = {
  condition?: InputMaybe<EncounterCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EncountersOrderBy>>;
};

export enum PatientSuffixEnum {
  II = 'II',
  III = 'III',
  IV = 'IV',
  JR = 'JR',
  SR = 'SR'
}

/** A connection to a list of `User` values, with data from `PatientNote`. */
export type PatientUsersByPatientNotePatientIdAndCreatedByManyToManyConnection = {
  __typename: 'PatientUsersByPatientNotePatientIdAndCreatedByManyToManyConnection';
  /** A list of edges which contains the `User`, info from the `PatientNote`, and the cursor to aid in pagination. */
  edges: Array<PatientUsersByPatientNotePatientIdAndCreatedByManyToManyEdge>;
  /** A list of `User` objects. */
  nodes: Array<User>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `User` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `User` edge in the connection, with data from `PatientNote`. */
export type PatientUsersByPatientNotePatientIdAndCreatedByManyToManyEdge = {
  __typename: 'PatientUsersByPatientNotePatientIdAndCreatedByManyToManyEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `User` at the end of the edge. */
  node: User;
  /** Reads and enables pagination through a set of `PatientNote`. */
  patientNotesByCreatedBy: PatientNotesConnection;
  /** Reads and enables pagination through a set of `PatientNote`. */
  patientNotesByCreatedByList: Array<PatientNote>;
};


/** A `User` edge in the connection, with data from `PatientNote`. */
export type PatientUsersByPatientNotePatientIdAndCreatedByManyToManyEdgepatientNotesByCreatedByArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<PatientNoteCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PatientNotesOrderBy>>;
};


/** A `User` edge in the connection, with data from `PatientNote`. */
export type PatientUsersByPatientNotePatientIdAndCreatedByManyToManyEdgepatientNotesByCreatedByListArgs = {
  condition?: InputMaybe<PatientNoteCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PatientNotesOrderBy>>;
};

/** A connection to a list of `Patient` values. */
export type PatientsConnection = {
  __typename: 'PatientsConnection';
  /** A list of edges which contains the `Patient` and cursor to aid in pagination. */
  edges: Array<PatientsEdge>;
  /** A list of `Patient` objects. */
  nodes: Array<Patient>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Patient` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Patient` edge in the connection. */
export type PatientsEdge = {
  __typename: 'PatientsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `Patient` at the end of the edge. */
  node: Patient;
};

/** Methods to use when ordering `Patient`. */
export enum PatientsOrderBy {
  GLOBAL_PATIENT_ID_ASC = 'GLOBAL_PATIENT_ID_ASC',
  GLOBAL_PATIENT_ID_DESC = 'GLOBAL_PATIENT_ID_DESC',
  MIGRATION_SOURCE_ASC = 'MIGRATION_SOURCE_ASC',
  MIGRATION_SOURCE_DESC = 'MIGRATION_SOURCE_DESC',
  NATURAL = 'NATURAL',
  PATIENT_ID_ASC = 'PATIENT_ID_ASC',
  PATIENT_ID_DESC = 'PATIENT_ID_DESC',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC'
}

export type PhysicalExam = Node & {
  __typename: 'PhysicalExam';
  createdAt: Scalars['Datetime'];
  deletedAt?: Maybe<Scalars['Datetime']>;
  encounterTaskId?: Maybe<Scalars['Int']>;
  isDeleted: Scalars['Boolean'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  note?: Maybe<Scalars['String']>;
  physicalExamId: Scalars['Int'];
};

/**
 * A condition to be used against `PhysicalExam` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type PhysicalExamCondition = {
  /** Checks for equality with the object’s `physicalExamId` field. */
  physicalExamId?: InputMaybe<Scalars['Int']>;
};

/** An input for mutations affecting `PhysicalExam` */
export type PhysicalExamInput = {
  createdAt?: InputMaybe<Scalars['Datetime']>;
  deletedAt?: InputMaybe<Scalars['Datetime']>;
  encounterTaskId?: InputMaybe<Scalars['Int']>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  note?: InputMaybe<Scalars['String']>;
};

/** Represents an update to a `PhysicalExam`. Fields that are set will be updated. */
export type PhysicalExamPatch = {
  createdAt?: InputMaybe<Scalars['Datetime']>;
  deletedAt?: InputMaybe<Scalars['Datetime']>;
  encounterTaskId?: InputMaybe<Scalars['Int']>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  note?: InputMaybe<Scalars['String']>;
};

/** A connection to a list of `PhysicalExam` values. */
export type PhysicalExamsConnection = {
  __typename: 'PhysicalExamsConnection';
  /** A list of edges which contains the `PhysicalExam` and cursor to aid in pagination. */
  edges: Array<PhysicalExamsEdge>;
  /** A list of `PhysicalExam` objects. */
  nodes: Array<PhysicalExam>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `PhysicalExam` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `PhysicalExam` edge in the connection. */
export type PhysicalExamsEdge = {
  __typename: 'PhysicalExamsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `PhysicalExam` at the end of the edge. */
  node: PhysicalExam;
};

/** Methods to use when ordering `PhysicalExam`. */
export enum PhysicalExamsOrderBy {
  NATURAL = 'NATURAL',
  PHYSICAL_EXAM_ID_ASC = 'PHYSICAL_EXAM_ID_ASC',
  PHYSICAL_EXAM_ID_DESC = 'PHYSICAL_EXAM_ID_DESC',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC'
}

/** Contains information about the ReadyCore poct_critical_value_confirmation table */
export type PoctCriticalValueConfirmation = Node & {
  __typename: 'PoctCriticalValueConfirmation';
  attestedAt: Scalars['Datetime'];
  attestedBy: Scalars['Int'];
  createdAt: Scalars['Datetime'];
  isDeleted: Scalars['Boolean'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  operatingAsRole: UserRoleEnum;
  poctCriticalValueConfirmationId: Scalars['Int'];
  pointOfCareTestId: Scalars['Int'];
  updatedAt: Scalars['Datetime'];
  user?: Maybe<User>;
};

/**
 * A condition to be used against `PoctCriticalValueConfirmation` object types. All
 * fields are tested for equality and combined with a logical ‘and.’
 */
export type PoctCriticalValueConfirmationCondition = {
  /** Checks for equality with the object’s `poctCriticalValueConfirmationId` field. */
  poctCriticalValueConfirmationId?: InputMaybe<Scalars['Int']>;
};

/** A connection to a list of `PoctCriticalValueConfirmation` values. */
export type PoctCriticalValueConfirmationsConnection = {
  __typename: 'PoctCriticalValueConfirmationsConnection';
  /** A list of edges which contains the `PoctCriticalValueConfirmation` and cursor to aid in pagination. */
  edges: Array<PoctCriticalValueConfirmationsEdge>;
  /** A list of `PoctCriticalValueConfirmation` objects. */
  nodes: Array<PoctCriticalValueConfirmation>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `PoctCriticalValueConfirmation` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `PoctCriticalValueConfirmation` edge in the connection. */
export type PoctCriticalValueConfirmationsEdge = {
  __typename: 'PoctCriticalValueConfirmationsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `PoctCriticalValueConfirmation` at the end of the edge. */
  node: PoctCriticalValueConfirmation;
};

/** Methods to use when ordering `PoctCriticalValueConfirmation`. */
export enum PoctCriticalValueConfirmationsOrderBy {
  NATURAL = 'NATURAL',
  POCT_CRITICAL_VALUE_CONFIRMATION_ID_ASC = 'POCT_CRITICAL_VALUE_CONFIRMATION_ID_ASC',
  POCT_CRITICAL_VALUE_CONFIRMATION_ID_DESC = 'POCT_CRITICAL_VALUE_CONFIRMATION_ID_DESC',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC'
}

/** Contains information about a point of care test for a test configuration */
export type PointOfCareTest = Node & {
  __typename: 'PointOfCareTest';
  clinician?: Maybe<User>;
  clinicianFirstName?: Maybe<Scalars['String']>;
  clinicianId?: Maybe<Scalars['Int']>;
  clinicianLastName?: Maybe<Scalars['String']>;
  createdAt: Scalars['Datetime'];
  criticalValueConfirmations?: Maybe<Array<Maybe<PoctCriticalValueConfirmation>>>;
  encounterId?: Maybe<Scalars['Int']>;
  /** Reads a single `EncounterTask` that is related to this `PointOfCareTest`. */
  encounterTask?: Maybe<EncounterTask>;
  encounterTaskId: Scalars['Int'];
  expirationDate?: Maybe<Scalars['Date']>;
  humidity?: Maybe<Scalars['Int']>;
  internalControlAcceptable?: Maybe<Scalars['Boolean']>;
  isDeleted: Scalars['Boolean'];
  lotNumber?: Maybe<Scalars['String']>;
  migrationSource?: Maybe<Scalars['String']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  patientId?: Maybe<Scalars['Int']>;
  pointOfCareTestId: Scalars['Int'];
  /** Reads a single `PointOfCareTestLookup` that is related to this `PointOfCareTest`. */
  pointOfCareTestLookup?: Maybe<PointOfCareTestLookup>;
  pointOfCareTestLookupId: Scalars['Int'];
  result?: Maybe<Scalars['String']>;
  standingOrder?: Maybe<StandingOrder>;
  standingOrderAddedAt?: Maybe<Scalars['Datetime']>;
  standingOrderId?: Maybe<Scalars['Int']>;
  systemLastUpdatedBy: SystemOfOriginEnum;
  temperature?: Maybe<Scalars['Float']>;
  updatedAt: Scalars['Datetime'];
};

export enum PointOfCareTestCategoryEnum {
  A1C = 'A1C',
  A1C_PERCENT = 'A1C_PERCENT',
  COVID = 'COVID',
  COVID_ANTIBODY = 'COVID_ANTIBODY',
  FLU_ANTIGEN = 'FLU_ANTIGEN',
  GLUCOSE = 'GLUCOSE',
  PREGNANCY = 'PREGNANCY',
  RSV = 'RSV',
  STREP = 'STREP',
  URINALYSIS = 'URINALYSIS'
}

/**
 * A condition to be used against `PointOfCareTest` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type PointOfCareTestCondition = {
  /** Checks for equality with the object’s `encounterTaskId` field. */
  encounterTaskId?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `migrationSource` field. */
  migrationSource?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `pointOfCareTestId` field. */
  pointOfCareTestId?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `pointOfCareTestLookupId` field. */
  pointOfCareTestLookupId?: InputMaybe<Scalars['Int']>;
};

/** Contains information about a point of care test lookup for a test configuration */
export type PointOfCareTestLookup = Node & {
  __typename: 'PointOfCareTestLookup';
  code?: Maybe<Scalars['String']>;
  createdAt: Scalars['Datetime'];
  /** Reads and enables pagination through a set of `EncounterTask`. */
  encounterTasksByPointOfCareTestPointOfCareTestLookupIdAndEncounterTaskId: PointOfCareTestLookupEncounterTasksByPointOfCareTestPointOfCareTestLookupIdAndEncounterTaskIdManyToManyConnection;
  /** Reads and enables pagination through a set of `EncounterTask`. */
  encounterTasksByPointOfCareTestPointOfCareTestLookupIdAndEncounterTaskIdList: Array<EncounterTask>;
  isDeleted: Scalars['Boolean'];
  name: Scalars['String'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  pointOfCareTestCategory: PointOfCareTestCategoryEnum;
  pointOfCareTestLookupId: Scalars['Int'];
  /** Reads and enables pagination through a set of `PointOfCareTest`. */
  pointOfCareTests: PointOfCareTestsConnection;
  /** Reads and enables pagination through a set of `PointOfCareTest`. */
  pointOfCareTestsList: Array<PointOfCareTest>;
  standingOrders?: Maybe<Array<Maybe<StandingOrder>>>;
  system?: Maybe<Scalars['String']>;
  unit?: Maybe<Scalars['String']>;
};


/** Contains information about a point of care test lookup for a test configuration */
export type PointOfCareTestLookupencounterTasksByPointOfCareTestPointOfCareTestLookupIdAndEncounterTaskIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<EncounterTaskCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EncounterTasksOrderBy>>;
};


/** Contains information about a point of care test lookup for a test configuration */
export type PointOfCareTestLookupencounterTasksByPointOfCareTestPointOfCareTestLookupIdAndEncounterTaskIdListArgs = {
  condition?: InputMaybe<EncounterTaskCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EncounterTasksOrderBy>>;
};


/** Contains information about a point of care test lookup for a test configuration */
export type PointOfCareTestLookuppointOfCareTestsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<PointOfCareTestCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PointOfCareTestsOrderBy>>;
};


/** Contains information about a point of care test lookup for a test configuration */
export type PointOfCareTestLookuppointOfCareTestsListArgs = {
  condition?: InputMaybe<PointOfCareTestCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PointOfCareTestsOrderBy>>;
};

/**
 * A condition to be used against `PointOfCareTestLookup` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type PointOfCareTestLookupCondition = {
  /** Checks for equality with the object’s `pointOfCareTestLookupId` field. */
  pointOfCareTestLookupId?: InputMaybe<Scalars['Int']>;
};

/** A connection to a list of `EncounterTask` values, with data from `PointOfCareTest`. */
export type PointOfCareTestLookupEncounterTasksByPointOfCareTestPointOfCareTestLookupIdAndEncounterTaskIdManyToManyConnection = {
  __typename: 'PointOfCareTestLookupEncounterTasksByPointOfCareTestPointOfCareTestLookupIdAndEncounterTaskIdManyToManyConnection';
  /** A list of edges which contains the `EncounterTask`, info from the `PointOfCareTest`, and the cursor to aid in pagination. */
  edges: Array<PointOfCareTestLookupEncounterTasksByPointOfCareTestPointOfCareTestLookupIdAndEncounterTaskIdManyToManyEdge>;
  /** A list of `EncounterTask` objects. */
  nodes: Array<EncounterTask>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `EncounterTask` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `EncounterTask` edge in the connection, with data from `PointOfCareTest`. */
export type PointOfCareTestLookupEncounterTasksByPointOfCareTestPointOfCareTestLookupIdAndEncounterTaskIdManyToManyEdge = {
  __typename: 'PointOfCareTestLookupEncounterTasksByPointOfCareTestPointOfCareTestLookupIdAndEncounterTaskIdManyToManyEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `EncounterTask` at the end of the edge. */
  node: EncounterTask;
  /** Reads and enables pagination through a set of `PointOfCareTest`. */
  pointOfCareTests: PointOfCareTestsConnection;
  /** Reads and enables pagination through a set of `PointOfCareTest`. */
  pointOfCareTestsList: Array<PointOfCareTest>;
};


/** A `EncounterTask` edge in the connection, with data from `PointOfCareTest`. */
export type PointOfCareTestLookupEncounterTasksByPointOfCareTestPointOfCareTestLookupIdAndEncounterTaskIdManyToManyEdgepointOfCareTestsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<PointOfCareTestCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PointOfCareTestsOrderBy>>;
};


/** A `EncounterTask` edge in the connection, with data from `PointOfCareTest`. */
export type PointOfCareTestLookupEncounterTasksByPointOfCareTestPointOfCareTestLookupIdAndEncounterTaskIdManyToManyEdgepointOfCareTestsListArgs = {
  condition?: InputMaybe<PointOfCareTestCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PointOfCareTestsOrderBy>>;
};

/** A connection to a list of `PointOfCareTestLookup` values. */
export type PointOfCareTestLookupsConnection = {
  __typename: 'PointOfCareTestLookupsConnection';
  /** A list of edges which contains the `PointOfCareTestLookup` and cursor to aid in pagination. */
  edges: Array<PointOfCareTestLookupsEdge>;
  /** A list of `PointOfCareTestLookup` objects. */
  nodes: Array<PointOfCareTestLookup>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `PointOfCareTestLookup` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `PointOfCareTestLookup` edge in the connection. */
export type PointOfCareTestLookupsEdge = {
  __typename: 'PointOfCareTestLookupsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `PointOfCareTestLookup` at the end of the edge. */
  node: PointOfCareTestLookup;
};

/** Methods to use when ordering `PointOfCareTestLookup`. */
export enum PointOfCareTestLookupsOrderBy {
  NATURAL = 'NATURAL',
  POINT_OF_CARE_TEST_LOOKUP_ID_ASC = 'POINT_OF_CARE_TEST_LOOKUP_ID_ASC',
  POINT_OF_CARE_TEST_LOOKUP_ID_DESC = 'POINT_OF_CARE_TEST_LOOKUP_ID_DESC',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC'
}

/** A connection to a list of `PointOfCareTest` values. */
export type PointOfCareTestsConnection = {
  __typename: 'PointOfCareTestsConnection';
  /** A list of edges which contains the `PointOfCareTest` and cursor to aid in pagination. */
  edges: Array<PointOfCareTestsEdge>;
  /** A list of `PointOfCareTest` objects. */
  nodes: Array<PointOfCareTest>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `PointOfCareTest` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `PointOfCareTest` edge in the connection. */
export type PointOfCareTestsEdge = {
  __typename: 'PointOfCareTestsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `PointOfCareTest` at the end of the edge. */
  node: PointOfCareTest;
};

/** Methods to use when ordering `PointOfCareTest`. */
export enum PointOfCareTestsOrderBy {
  ENCOUNTER_TASK_ID_ASC = 'ENCOUNTER_TASK_ID_ASC',
  ENCOUNTER_TASK_ID_DESC = 'ENCOUNTER_TASK_ID_DESC',
  MIGRATION_SOURCE_ASC = 'MIGRATION_SOURCE_ASC',
  MIGRATION_SOURCE_DESC = 'MIGRATION_SOURCE_DESC',
  NATURAL = 'NATURAL',
  POINT_OF_CARE_TEST_ID_ASC = 'POINT_OF_CARE_TEST_ID_ASC',
  POINT_OF_CARE_TEST_ID_DESC = 'POINT_OF_CARE_TEST_ID_DESC',
  POINT_OF_CARE_TEST_LOOKUP_ID_ASC = 'POINT_OF_CARE_TEST_LOOKUP_ID_ASC',
  POINT_OF_CARE_TEST_LOOKUP_ID_DESC = 'POINT_OF_CARE_TEST_LOOKUP_ID_DESC',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC'
}

/** Contains information about problem lists */
export type Problem = Node & {
  __typename: 'Problem';
  code: Scalars['String'];
  codeSystemId: Scalars['Int'];
  isDeleted: Scalars['Boolean'];
  name: Scalars['String'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  /** Reads and enables pagination through a set of `PatientProblem`. */
  patientProblems: PatientProblemsConnection;
  /** Reads and enables pagination through a set of `PatientProblem`. */
  patientProblemsList: Array<PatientProblem>;
  /** Reads and enables pagination through a set of `ProblemCategory`. */
  problemCategoriesByPatientProblemProblemIdAndProblemCategoryId: ProblemProblemCategoriesByPatientProblemProblemIdAndProblemCategoryIdManyToManyConnection;
  /** Reads and enables pagination through a set of `ProblemCategory`. */
  problemCategoriesByPatientProblemProblemIdAndProblemCategoryIdList: Array<ProblemCategory>;
  problemCategoryId?: Maybe<Scalars['Int']>;
  problemId: Scalars['Int'];
  /** Reads and enables pagination through a set of `ProblemStatus`. */
  problemStatusesByPatientProblemProblemIdAndProblemStatusId: ProblemProblemStatusesByPatientProblemProblemIdAndProblemStatusIdManyToManyConnection;
  /** Reads and enables pagination through a set of `ProblemStatus`. */
  problemStatusesByPatientProblemProblemIdAndProblemStatusIdList: Array<ProblemStatus>;
};


/** Contains information about problem lists */
export type ProblempatientProblemsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<PatientProblemCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PatientProblemsOrderBy>>;
};


/** Contains information about problem lists */
export type ProblempatientProblemsListArgs = {
  condition?: InputMaybe<PatientProblemCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PatientProblemsOrderBy>>;
};


/** Contains information about problem lists */
export type ProblemproblemCategoriesByPatientProblemProblemIdAndProblemCategoryIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ProblemCategoryCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProblemCategoriesOrderBy>>;
};


/** Contains information about problem lists */
export type ProblemproblemCategoriesByPatientProblemProblemIdAndProblemCategoryIdListArgs = {
  condition?: InputMaybe<ProblemCategoryCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProblemCategoriesOrderBy>>;
};


/** Contains information about problem lists */
export type ProblemproblemStatusesByPatientProblemProblemIdAndProblemStatusIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ProblemStatusCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProblemStatusesOrderBy>>;
};


/** Contains information about problem lists */
export type ProblemproblemStatusesByPatientProblemProblemIdAndProblemStatusIdListArgs = {
  condition?: InputMaybe<ProblemStatusCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProblemStatusesOrderBy>>;
};

/** A connection to a list of `ProblemCategory` values. */
export type ProblemCategoriesConnection = {
  __typename: 'ProblemCategoriesConnection';
  /** A list of edges which contains the `ProblemCategory` and cursor to aid in pagination. */
  edges: Array<ProblemCategoriesEdge>;
  /** A list of `ProblemCategory` objects. */
  nodes: Array<ProblemCategory>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ProblemCategory` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `ProblemCategory` edge in the connection. */
export type ProblemCategoriesEdge = {
  __typename: 'ProblemCategoriesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `ProblemCategory` at the end of the edge. */
  node: ProblemCategory;
};

/** Methods to use when ordering `ProblemCategory`. */
export enum ProblemCategoriesOrderBy {
  NATURAL = 'NATURAL',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  PROBLEM_CATEGORY_ID_ASC = 'PROBLEM_CATEGORY_ID_ASC',
  PROBLEM_CATEGORY_ID_DESC = 'PROBLEM_CATEGORY_ID_DESC'
}

/** Contains information about problem list categories */
export type ProblemCategory = Node & {
  __typename: 'ProblemCategory';
  code: Scalars['String'];
  codeSystemId?: Maybe<Scalars['Int']>;
  isDeleted: Scalars['Boolean'];
  name: Scalars['String'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  /** Reads and enables pagination through a set of `PatientProblem`. */
  patientProblems: PatientProblemsConnection;
  /** Reads and enables pagination through a set of `PatientProblem`. */
  patientProblemsList: Array<PatientProblem>;
  problemCategoryId: Scalars['Int'];
  /** Reads and enables pagination through a set of `ProblemStatus`. */
  problemStatusesByPatientProblemProblemCategoryIdAndProblemStatusId: ProblemCategoryProblemStatusesByPatientProblemProblemCategoryIdAndProblemStatusIdManyToManyConnection;
  /** Reads and enables pagination through a set of `ProblemStatus`. */
  problemStatusesByPatientProblemProblemCategoryIdAndProblemStatusIdList: Array<ProblemStatus>;
  /** Reads and enables pagination through a set of `Problem`. */
  problemsByPatientProblemProblemCategoryIdAndProblemId: ProblemCategoryProblemsByPatientProblemProblemCategoryIdAndProblemIdManyToManyConnection;
  /** Reads and enables pagination through a set of `Problem`. */
  problemsByPatientProblemProblemCategoryIdAndProblemIdList: Array<Problem>;
};


/** Contains information about problem list categories */
export type ProblemCategorypatientProblemsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<PatientProblemCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PatientProblemsOrderBy>>;
};


/** Contains information about problem list categories */
export type ProblemCategorypatientProblemsListArgs = {
  condition?: InputMaybe<PatientProblemCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PatientProblemsOrderBy>>;
};


/** Contains information about problem list categories */
export type ProblemCategoryproblemStatusesByPatientProblemProblemCategoryIdAndProblemStatusIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ProblemStatusCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProblemStatusesOrderBy>>;
};


/** Contains information about problem list categories */
export type ProblemCategoryproblemStatusesByPatientProblemProblemCategoryIdAndProblemStatusIdListArgs = {
  condition?: InputMaybe<ProblemStatusCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProblemStatusesOrderBy>>;
};


/** Contains information about problem list categories */
export type ProblemCategoryproblemsByPatientProblemProblemCategoryIdAndProblemIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ProblemCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProblemsOrderBy>>;
};


/** Contains information about problem list categories */
export type ProblemCategoryproblemsByPatientProblemProblemCategoryIdAndProblemIdListArgs = {
  condition?: InputMaybe<ProblemCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProblemsOrderBy>>;
};

/**
 * A condition to be used against `ProblemCategory` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type ProblemCategoryCondition = {
  /** Checks for equality with the object’s `problemCategoryId` field. */
  problemCategoryId?: InputMaybe<Scalars['Int']>;
};

/** A connection to a list of `ProblemStatus` values, with data from `PatientProblem`. */
export type ProblemCategoryProblemStatusesByPatientProblemProblemCategoryIdAndProblemStatusIdManyToManyConnection = {
  __typename: 'ProblemCategoryProblemStatusesByPatientProblemProblemCategoryIdAndProblemStatusIdManyToManyConnection';
  /** A list of edges which contains the `ProblemStatus`, info from the `PatientProblem`, and the cursor to aid in pagination. */
  edges: Array<ProblemCategoryProblemStatusesByPatientProblemProblemCategoryIdAndProblemStatusIdManyToManyEdge>;
  /** A list of `ProblemStatus` objects. */
  nodes: Array<ProblemStatus>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ProblemStatus` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `ProblemStatus` edge in the connection, with data from `PatientProblem`. */
export type ProblemCategoryProblemStatusesByPatientProblemProblemCategoryIdAndProblemStatusIdManyToManyEdge = {
  __typename: 'ProblemCategoryProblemStatusesByPatientProblemProblemCategoryIdAndProblemStatusIdManyToManyEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `ProblemStatus` at the end of the edge. */
  node: ProblemStatus;
  /** Reads and enables pagination through a set of `PatientProblem`. */
  patientProblems: PatientProblemsConnection;
  /** Reads and enables pagination through a set of `PatientProblem`. */
  patientProblemsList: Array<PatientProblem>;
};


/** A `ProblemStatus` edge in the connection, with data from `PatientProblem`. */
export type ProblemCategoryProblemStatusesByPatientProblemProblemCategoryIdAndProblemStatusIdManyToManyEdgepatientProblemsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<PatientProblemCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PatientProblemsOrderBy>>;
};


/** A `ProblemStatus` edge in the connection, with data from `PatientProblem`. */
export type ProblemCategoryProblemStatusesByPatientProblemProblemCategoryIdAndProblemStatusIdManyToManyEdgepatientProblemsListArgs = {
  condition?: InputMaybe<PatientProblemCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PatientProblemsOrderBy>>;
};

/** A connection to a list of `Problem` values, with data from `PatientProblem`. */
export type ProblemCategoryProblemsByPatientProblemProblemCategoryIdAndProblemIdManyToManyConnection = {
  __typename: 'ProblemCategoryProblemsByPatientProblemProblemCategoryIdAndProblemIdManyToManyConnection';
  /** A list of edges which contains the `Problem`, info from the `PatientProblem`, and the cursor to aid in pagination. */
  edges: Array<ProblemCategoryProblemsByPatientProblemProblemCategoryIdAndProblemIdManyToManyEdge>;
  /** A list of `Problem` objects. */
  nodes: Array<Problem>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Problem` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Problem` edge in the connection, with data from `PatientProblem`. */
export type ProblemCategoryProblemsByPatientProblemProblemCategoryIdAndProblemIdManyToManyEdge = {
  __typename: 'ProblemCategoryProblemsByPatientProblemProblemCategoryIdAndProblemIdManyToManyEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `Problem` at the end of the edge. */
  node: Problem;
  /** Reads and enables pagination through a set of `PatientProblem`. */
  patientProblems: PatientProblemsConnection;
  /** Reads and enables pagination through a set of `PatientProblem`. */
  patientProblemsList: Array<PatientProblem>;
};


/** A `Problem` edge in the connection, with data from `PatientProblem`. */
export type ProblemCategoryProblemsByPatientProblemProblemCategoryIdAndProblemIdManyToManyEdgepatientProblemsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<PatientProblemCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PatientProblemsOrderBy>>;
};


/** A `Problem` edge in the connection, with data from `PatientProblem`. */
export type ProblemCategoryProblemsByPatientProblemProblemCategoryIdAndProblemIdManyToManyEdgepatientProblemsListArgs = {
  condition?: InputMaybe<PatientProblemCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PatientProblemsOrderBy>>;
};

/** A condition to be used against `Problem` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type ProblemCondition = {
  /** Checks for equality with the object’s `problemId` field. */
  problemId?: InputMaybe<Scalars['Int']>;
};

/** A connection to a list of `ProblemCategory` values, with data from `PatientProblem`. */
export type ProblemProblemCategoriesByPatientProblemProblemIdAndProblemCategoryIdManyToManyConnection = {
  __typename: 'ProblemProblemCategoriesByPatientProblemProblemIdAndProblemCategoryIdManyToManyConnection';
  /** A list of edges which contains the `ProblemCategory`, info from the `PatientProblem`, and the cursor to aid in pagination. */
  edges: Array<ProblemProblemCategoriesByPatientProblemProblemIdAndProblemCategoryIdManyToManyEdge>;
  /** A list of `ProblemCategory` objects. */
  nodes: Array<ProblemCategory>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ProblemCategory` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `ProblemCategory` edge in the connection, with data from `PatientProblem`. */
export type ProblemProblemCategoriesByPatientProblemProblemIdAndProblemCategoryIdManyToManyEdge = {
  __typename: 'ProblemProblemCategoriesByPatientProblemProblemIdAndProblemCategoryIdManyToManyEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `ProblemCategory` at the end of the edge. */
  node: ProblemCategory;
  /** Reads and enables pagination through a set of `PatientProblem`. */
  patientProblems: PatientProblemsConnection;
  /** Reads and enables pagination through a set of `PatientProblem`. */
  patientProblemsList: Array<PatientProblem>;
};


/** A `ProblemCategory` edge in the connection, with data from `PatientProblem`. */
export type ProblemProblemCategoriesByPatientProblemProblemIdAndProblemCategoryIdManyToManyEdgepatientProblemsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<PatientProblemCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PatientProblemsOrderBy>>;
};


/** A `ProblemCategory` edge in the connection, with data from `PatientProblem`. */
export type ProblemProblemCategoriesByPatientProblemProblemIdAndProblemCategoryIdManyToManyEdgepatientProblemsListArgs = {
  condition?: InputMaybe<PatientProblemCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PatientProblemsOrderBy>>;
};

/** A connection to a list of `ProblemStatus` values, with data from `PatientProblem`. */
export type ProblemProblemStatusesByPatientProblemProblemIdAndProblemStatusIdManyToManyConnection = {
  __typename: 'ProblemProblemStatusesByPatientProblemProblemIdAndProblemStatusIdManyToManyConnection';
  /** A list of edges which contains the `ProblemStatus`, info from the `PatientProblem`, and the cursor to aid in pagination. */
  edges: Array<ProblemProblemStatusesByPatientProblemProblemIdAndProblemStatusIdManyToManyEdge>;
  /** A list of `ProblemStatus` objects. */
  nodes: Array<ProblemStatus>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ProblemStatus` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `ProblemStatus` edge in the connection, with data from `PatientProblem`. */
export type ProblemProblemStatusesByPatientProblemProblemIdAndProblemStatusIdManyToManyEdge = {
  __typename: 'ProblemProblemStatusesByPatientProblemProblemIdAndProblemStatusIdManyToManyEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `ProblemStatus` at the end of the edge. */
  node: ProblemStatus;
  /** Reads and enables pagination through a set of `PatientProblem`. */
  patientProblems: PatientProblemsConnection;
  /** Reads and enables pagination through a set of `PatientProblem`. */
  patientProblemsList: Array<PatientProblem>;
};


/** A `ProblemStatus` edge in the connection, with data from `PatientProblem`. */
export type ProblemProblemStatusesByPatientProblemProblemIdAndProblemStatusIdManyToManyEdgepatientProblemsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<PatientProblemCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PatientProblemsOrderBy>>;
};


/** A `ProblemStatus` edge in the connection, with data from `PatientProblem`. */
export type ProblemProblemStatusesByPatientProblemProblemIdAndProblemStatusIdManyToManyEdgepatientProblemsListArgs = {
  condition?: InputMaybe<PatientProblemCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PatientProblemsOrderBy>>;
};

/** Contains information about problem list statuses */
export type ProblemStatus = Node & {
  __typename: 'ProblemStatus';
  code: Scalars['String'];
  codeSystemId?: Maybe<Scalars['Int']>;
  isDeleted: Scalars['Boolean'];
  name: Scalars['String'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  /** Reads and enables pagination through a set of `PatientProblem`. */
  patientProblems: PatientProblemsConnection;
  /** Reads and enables pagination through a set of `PatientProblem`. */
  patientProblemsList: Array<PatientProblem>;
  /** Reads and enables pagination through a set of `ProblemCategory`. */
  problemCategoriesByPatientProblemProblemStatusIdAndProblemCategoryId: ProblemStatusProblemCategoriesByPatientProblemProblemStatusIdAndProblemCategoryIdManyToManyConnection;
  /** Reads and enables pagination through a set of `ProblemCategory`. */
  problemCategoriesByPatientProblemProblemStatusIdAndProblemCategoryIdList: Array<ProblemCategory>;
  problemStatusId: Scalars['Int'];
  /** Reads and enables pagination through a set of `Problem`. */
  problemsByPatientProblemProblemStatusIdAndProblemId: ProblemStatusProblemsByPatientProblemProblemStatusIdAndProblemIdManyToManyConnection;
  /** Reads and enables pagination through a set of `Problem`. */
  problemsByPatientProblemProblemStatusIdAndProblemIdList: Array<Problem>;
};


/** Contains information about problem list statuses */
export type ProblemStatuspatientProblemsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<PatientProblemCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PatientProblemsOrderBy>>;
};


/** Contains information about problem list statuses */
export type ProblemStatuspatientProblemsListArgs = {
  condition?: InputMaybe<PatientProblemCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PatientProblemsOrderBy>>;
};


/** Contains information about problem list statuses */
export type ProblemStatusproblemCategoriesByPatientProblemProblemStatusIdAndProblemCategoryIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ProblemCategoryCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProblemCategoriesOrderBy>>;
};


/** Contains information about problem list statuses */
export type ProblemStatusproblemCategoriesByPatientProblemProblemStatusIdAndProblemCategoryIdListArgs = {
  condition?: InputMaybe<ProblemCategoryCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProblemCategoriesOrderBy>>;
};


/** Contains information about problem list statuses */
export type ProblemStatusproblemsByPatientProblemProblemStatusIdAndProblemIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ProblemCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProblemsOrderBy>>;
};


/** Contains information about problem list statuses */
export type ProblemStatusproblemsByPatientProblemProblemStatusIdAndProblemIdListArgs = {
  condition?: InputMaybe<ProblemCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProblemsOrderBy>>;
};

/**
 * A condition to be used against `ProblemStatus` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type ProblemStatusCondition = {
  /** Checks for equality with the object’s `problemStatusId` field. */
  problemStatusId?: InputMaybe<Scalars['Int']>;
};

/** A connection to a list of `ProblemCategory` values, with data from `PatientProblem`. */
export type ProblemStatusProblemCategoriesByPatientProblemProblemStatusIdAndProblemCategoryIdManyToManyConnection = {
  __typename: 'ProblemStatusProblemCategoriesByPatientProblemProblemStatusIdAndProblemCategoryIdManyToManyConnection';
  /** A list of edges which contains the `ProblemCategory`, info from the `PatientProblem`, and the cursor to aid in pagination. */
  edges: Array<ProblemStatusProblemCategoriesByPatientProblemProblemStatusIdAndProblemCategoryIdManyToManyEdge>;
  /** A list of `ProblemCategory` objects. */
  nodes: Array<ProblemCategory>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ProblemCategory` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `ProblemCategory` edge in the connection, with data from `PatientProblem`. */
export type ProblemStatusProblemCategoriesByPatientProblemProblemStatusIdAndProblemCategoryIdManyToManyEdge = {
  __typename: 'ProblemStatusProblemCategoriesByPatientProblemProblemStatusIdAndProblemCategoryIdManyToManyEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `ProblemCategory` at the end of the edge. */
  node: ProblemCategory;
  /** Reads and enables pagination through a set of `PatientProblem`. */
  patientProblems: PatientProblemsConnection;
  /** Reads and enables pagination through a set of `PatientProblem`. */
  patientProblemsList: Array<PatientProblem>;
};


/** A `ProblemCategory` edge in the connection, with data from `PatientProblem`. */
export type ProblemStatusProblemCategoriesByPatientProblemProblemStatusIdAndProblemCategoryIdManyToManyEdgepatientProblemsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<PatientProblemCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PatientProblemsOrderBy>>;
};


/** A `ProblemCategory` edge in the connection, with data from `PatientProblem`. */
export type ProblemStatusProblemCategoriesByPatientProblemProblemStatusIdAndProblemCategoryIdManyToManyEdgepatientProblemsListArgs = {
  condition?: InputMaybe<PatientProblemCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PatientProblemsOrderBy>>;
};

/** A connection to a list of `Problem` values, with data from `PatientProblem`. */
export type ProblemStatusProblemsByPatientProblemProblemStatusIdAndProblemIdManyToManyConnection = {
  __typename: 'ProblemStatusProblemsByPatientProblemProblemStatusIdAndProblemIdManyToManyConnection';
  /** A list of edges which contains the `Problem`, info from the `PatientProblem`, and the cursor to aid in pagination. */
  edges: Array<ProblemStatusProblemsByPatientProblemProblemStatusIdAndProblemIdManyToManyEdge>;
  /** A list of `Problem` objects. */
  nodes: Array<Problem>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Problem` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Problem` edge in the connection, with data from `PatientProblem`. */
export type ProblemStatusProblemsByPatientProblemProblemStatusIdAndProblemIdManyToManyEdge = {
  __typename: 'ProblemStatusProblemsByPatientProblemProblemStatusIdAndProblemIdManyToManyEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `Problem` at the end of the edge. */
  node: Problem;
  /** Reads and enables pagination through a set of `PatientProblem`. */
  patientProblems: PatientProblemsConnection;
  /** Reads and enables pagination through a set of `PatientProblem`. */
  patientProblemsList: Array<PatientProblem>;
};


/** A `Problem` edge in the connection, with data from `PatientProblem`. */
export type ProblemStatusProblemsByPatientProblemProblemStatusIdAndProblemIdManyToManyEdgepatientProblemsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<PatientProblemCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PatientProblemsOrderBy>>;
};


/** A `Problem` edge in the connection, with data from `PatientProblem`. */
export type ProblemStatusProblemsByPatientProblemProblemStatusIdAndProblemIdManyToManyEdgepatientProblemsListArgs = {
  condition?: InputMaybe<PatientProblemCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PatientProblemsOrderBy>>;
};

/** A connection to a list of `ProblemStatus` values. */
export type ProblemStatusesConnection = {
  __typename: 'ProblemStatusesConnection';
  /** A list of edges which contains the `ProblemStatus` and cursor to aid in pagination. */
  edges: Array<ProblemStatusesEdge>;
  /** A list of `ProblemStatus` objects. */
  nodes: Array<ProblemStatus>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ProblemStatus` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `ProblemStatus` edge in the connection. */
export type ProblemStatusesEdge = {
  __typename: 'ProblemStatusesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `ProblemStatus` at the end of the edge. */
  node: ProblemStatus;
};

/** Methods to use when ordering `ProblemStatus`. */
export enum ProblemStatusesOrderBy {
  NATURAL = 'NATURAL',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  PROBLEM_STATUS_ID_ASC = 'PROBLEM_STATUS_ID_ASC',
  PROBLEM_STATUS_ID_DESC = 'PROBLEM_STATUS_ID_DESC'
}

/** A connection to a list of `Problem` values. */
export type ProblemsConnection = {
  __typename: 'ProblemsConnection';
  /** A list of edges which contains the `Problem` and cursor to aid in pagination. */
  edges: Array<ProblemsEdge>;
  /** A list of `Problem` objects. */
  nodes: Array<Problem>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Problem` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Problem` edge in the connection. */
export type ProblemsEdge = {
  __typename: 'ProblemsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `Problem` at the end of the edge. */
  node: Problem;
};

/** Methods to use when ordering `Problem`. */
export enum ProblemsOrderBy {
  NATURAL = 'NATURAL',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  PROBLEM_ID_ASC = 'PROBLEM_ID_ASC',
  PROBLEM_ID_DESC = 'PROBLEM_ID_DESC'
}

/** Contains Procedure Codes */
export type ProcedureCodeReference = Node & {
  __typename: 'ProcedureCodeReference';
  /** Reads and enables pagination through a set of `BillingDiagnostic`. */
  billingDiagnostics: BillingDiagnosticsConnection;
  /** Reads and enables pagination through a set of `BillingDiagnostic`. */
  billingDiagnosticsList: Array<BillingDiagnostic>;
  code: Scalars['String'];
  /** Reads and enables pagination through a set of `EncounterTask`. */
  encounterTasksByBillingDiagnosticProcedureCodeReferenceIdAndEncounterTaskId: ProcedureCodeReferenceEncounterTasksByBillingDiagnosticProcedureCodeReferenceIdAndEncounterTaskIdManyToManyConnection;
  /** Reads and enables pagination through a set of `EncounterTask`. */
  encounterTasksByBillingDiagnosticProcedureCodeReferenceIdAndEncounterTaskIdList: Array<EncounterTask>;
  endDate?: Maybe<Scalars['Datetime']>;
  name: Scalars['String'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  procedureCodeReferenceId: Scalars['Int'];
  startDate: Scalars['Datetime'];
  system: Scalars['String'];
};


/** Contains Procedure Codes */
export type ProcedureCodeReferencebillingDiagnosticsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<BillingDiagnosticCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<BillingDiagnosticsOrderBy>>;
};


/** Contains Procedure Codes */
export type ProcedureCodeReferencebillingDiagnosticsListArgs = {
  condition?: InputMaybe<BillingDiagnosticCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<BillingDiagnosticsOrderBy>>;
};


/** Contains Procedure Codes */
export type ProcedureCodeReferenceencounterTasksByBillingDiagnosticProcedureCodeReferenceIdAndEncounterTaskIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<EncounterTaskCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EncounterTasksOrderBy>>;
};


/** Contains Procedure Codes */
export type ProcedureCodeReferenceencounterTasksByBillingDiagnosticProcedureCodeReferenceIdAndEncounterTaskIdListArgs = {
  condition?: InputMaybe<EncounterTaskCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EncounterTasksOrderBy>>;
};

/**
 * A condition to be used against `ProcedureCodeReference` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type ProcedureCodeReferenceCondition = {
  /** Checks for equality with the object’s `code` field. */
  code?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `procedureCodeReferenceId` field. */
  procedureCodeReferenceId?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `startDate` field. */
  startDate?: InputMaybe<Scalars['Datetime']>;
};

/** A connection to a list of `EncounterTask` values, with data from `BillingDiagnostic`. */
export type ProcedureCodeReferenceEncounterTasksByBillingDiagnosticProcedureCodeReferenceIdAndEncounterTaskIdManyToManyConnection = {
  __typename: 'ProcedureCodeReferenceEncounterTasksByBillingDiagnosticProcedureCodeReferenceIdAndEncounterTaskIdManyToManyConnection';
  /** A list of edges which contains the `EncounterTask`, info from the `BillingDiagnostic`, and the cursor to aid in pagination. */
  edges: Array<ProcedureCodeReferenceEncounterTasksByBillingDiagnosticProcedureCodeReferenceIdAndEncounterTaskIdManyToManyEdge>;
  /** A list of `EncounterTask` objects. */
  nodes: Array<EncounterTask>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `EncounterTask` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `EncounterTask` edge in the connection, with data from `BillingDiagnostic`. */
export type ProcedureCodeReferenceEncounterTasksByBillingDiagnosticProcedureCodeReferenceIdAndEncounterTaskIdManyToManyEdge = {
  __typename: 'ProcedureCodeReferenceEncounterTasksByBillingDiagnosticProcedureCodeReferenceIdAndEncounterTaskIdManyToManyEdge';
  billingDiagnosticsId: Scalars['Int'];
  createdAt: Scalars['Datetime'];
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  deletedAt?: Maybe<Scalars['Datetime']>;
  isDeleted: Scalars['Boolean'];
  /** The `EncounterTask` at the end of the edge. */
  node: EncounterTask;
  updatedAt: Scalars['Datetime'];
};

/** A connection to a list of `ProcedureCodeReference` values. */
export type ProcedureCodeReferencesConnection = {
  __typename: 'ProcedureCodeReferencesConnection';
  /** A list of edges which contains the `ProcedureCodeReference` and cursor to aid in pagination. */
  edges: Array<ProcedureCodeReferencesEdge>;
  /** A list of `ProcedureCodeReference` objects. */
  nodes: Array<ProcedureCodeReference>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ProcedureCodeReference` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `ProcedureCodeReference` edge in the connection. */
export type ProcedureCodeReferencesEdge = {
  __typename: 'ProcedureCodeReferencesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `ProcedureCodeReference` at the end of the edge. */
  node: ProcedureCodeReference;
};

/** Methods to use when ordering `ProcedureCodeReference`. */
export enum ProcedureCodeReferencesOrderBy {
  CODE_ASC = 'CODE_ASC',
  CODE_DESC = 'CODE_DESC',
  NATURAL = 'NATURAL',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  PROCEDURE_CODE_REFERENCE_ID_ASC = 'PROCEDURE_CODE_REFERENCE_ID_ASC',
  PROCEDURE_CODE_REFERENCE_ID_DESC = 'PROCEDURE_CODE_REFERENCE_ID_DESC',
  START_DATE_ASC = 'START_DATE_ASC',
  START_DATE_DESC = 'START_DATE_DESC'
}

/** Contains information about progress notes for an encounter task */
export type ProgressNote = Node & {
  __typename: 'ProgressNote';
  createdAt: Scalars['Datetime'];
  deletedAt?: Maybe<Scalars['Datetime']>;
  encounterTaskId?: Maybe<Scalars['Int']>;
  isDeleted: Scalars['Boolean'];
  migrationSource?: Maybe<Scalars['String']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  note?: Maybe<Scalars['String']>;
  progressNoteId: Scalars['Int'];
  updatedAt: Scalars['Datetime'];
};

/**
 * A condition to be used against `ProgressNote` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type ProgressNoteCondition = {
  /** Checks for equality with the object’s `migrationSource` field. */
  migrationSource?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `progressNoteId` field. */
  progressNoteId?: InputMaybe<Scalars['Int']>;
};

/** A connection to a list of `ProgressNote` values. */
export type ProgressNotesConnection = {
  __typename: 'ProgressNotesConnection';
  /** A list of edges which contains the `ProgressNote` and cursor to aid in pagination. */
  edges: Array<ProgressNotesEdge>;
  /** A list of `ProgressNote` objects. */
  nodes: Array<ProgressNote>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ProgressNote` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `ProgressNote` edge in the connection. */
export type ProgressNotesEdge = {
  __typename: 'ProgressNotesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `ProgressNote` at the end of the edge. */
  node: ProgressNote;
};

/** Methods to use when ordering `ProgressNote`. */
export enum ProgressNotesOrderBy {
  MIGRATION_SOURCE_ASC = 'MIGRATION_SOURCE_ASC',
  MIGRATION_SOURCE_DESC = 'MIGRATION_SOURCE_DESC',
  NATURAL = 'NATURAL',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  PROGRESS_NOTE_ID_ASC = 'PROGRESS_NOTE_ID_ASC',
  PROGRESS_NOTE_ID_DESC = 'PROGRESS_NOTE_ID_DESC'
}

/** The root query type which gives access points into the data universe. */
export type Query = Node & {
  __typename: 'Query';
  /** Reads and enables pagination through a set of `Addendum`. */
  addenda?: Maybe<AddendaConnection>;
  /** Reads a set of `Addendum`. */
  addendaList?: Maybe<Array<Addendum>>;
  addendum?: Maybe<Addendum>;
  addendumAttachment?: Maybe<AddendumAttachment>;
  /** Reads a single `AddendumAttachment` using its globally unique `ID`. */
  addendumAttachmentByNodeId?: Maybe<AddendumAttachment>;
  /** Reads and enables pagination through a set of `AddendumAttachment`. */
  addendumAttachments?: Maybe<AddendumAttachmentsConnection>;
  /** Reads a set of `AddendumAttachment`. */
  addendumAttachmentsList?: Maybe<Array<AddendumAttachment>>;
  /** Reads a single `Addendum` using its globally unique `ID`. */
  addendumByNodeId?: Maybe<Addendum>;
  /** Reads and enables pagination through a set of `AllergicCriticality`. */
  allergicCriticalities?: Maybe<AllergicCriticalitiesConnection>;
  /** Reads a set of `AllergicCriticality`. */
  allergicCriticalitiesList?: Maybe<Array<AllergicCriticality>>;
  allergicCriticality?: Maybe<AllergicCriticality>;
  /** Reads a single `AllergicCriticality` using its globally unique `ID`. */
  allergicCriticalityByNodeId?: Maybe<AllergicCriticality>;
  allergicReaction?: Maybe<AllergicReaction>;
  /** Reads a single `AllergicReaction` using its globally unique `ID`. */
  allergicReactionByNodeId?: Maybe<AllergicReaction>;
  /** Reads and enables pagination through a set of `AllergicReaction`. */
  allergicReactions?: Maybe<AllergicReactionsConnection>;
  /** Reads a set of `AllergicReaction`. */
  allergicReactionsList?: Maybe<Array<AllergicReaction>>;
  /** Reads and enables pagination through a set of `AllergicSeverity`. */
  allergicSeverities?: Maybe<AllergicSeveritiesConnection>;
  /** Reads a set of `AllergicSeverity`. */
  allergicSeveritiesList?: Maybe<Array<AllergicSeverity>>;
  allergicSeverity?: Maybe<AllergicSeverity>;
  /** Reads a single `AllergicSeverity` using its globally unique `ID`. */
  allergicSeverityByNodeId?: Maybe<AllergicSeverity>;
  allergicStatus?: Maybe<AllergicStatus>;
  /** Reads a single `AllergicStatus` using its globally unique `ID`. */
  allergicStatusByNodeId?: Maybe<AllergicStatus>;
  /** Reads and enables pagination through a set of `AllergicStatus`. */
  allergicStatuses?: Maybe<AllergicStatusesConnection>;
  /** Reads a set of `AllergicStatus`. */
  allergicStatusesList?: Maybe<Array<AllergicStatus>>;
  /** Reads and enables pagination through a set of `Allergy`. */
  allergies?: Maybe<AllergiesConnection>;
  /** Reads a set of `Allergy`. */
  allergiesList?: Maybe<Array<Allergy>>;
  allergy?: Maybe<Allergy>;
  /** Reads a single `Allergy` using its globally unique `ID`. */
  allergyByNodeId?: Maybe<Allergy>;
  allergySubstance?: Maybe<AllergySubstance>;
  /** Reads a single `AllergySubstance` using its globally unique `ID`. */
  allergySubstanceByNodeId?: Maybe<AllergySubstance>;
  /** Reads and enables pagination through a set of `AllergySubstance`. */
  allergySubstances?: Maybe<AllergySubstancesConnection>;
  /** Reads a set of `AllergySubstance`. */
  allergySubstancesList?: Maybe<Array<AllergySubstance>>;
  allergyType?: Maybe<AllergyType>;
  /** Reads a single `AllergyType` using its globally unique `ID`. */
  allergyTypeByNodeId?: Maybe<AllergyType>;
  /** Reads and enables pagination through a set of `AllergyType`. */
  allergyTypes?: Maybe<AllergyTypesConnection>;
  /** Reads a set of `AllergyType`. */
  allergyTypesList?: Maybe<Array<AllergyType>>;
  appointment?: Maybe<Appointment>;
  /** Reads a single `Appointment` using its globally unique `ID`. */
  appointmentByNodeId?: Maybe<Appointment>;
  appointmentDispatch?: Maybe<AppointmentDispatch>;
  /** Reads a single `AppointmentDispatch` using its globally unique `ID`. */
  appointmentDispatchByNodeId?: Maybe<AppointmentDispatch>;
  /** Reads and enables pagination through a set of `AppointmentDispatch`. */
  appointmentDispatches?: Maybe<AppointmentDispatchesConnection>;
  /** Reads a set of `AppointmentDispatch`. */
  appointmentDispatchesList?: Maybe<Array<AppointmentDispatch>>;
  appointmentTag?: Maybe<AppointmentTag>;
  /** Reads a single `AppointmentTag` using its globally unique `ID`. */
  appointmentTagByNodeId?: Maybe<AppointmentTag>;
  /** Reads and enables pagination through a set of `AppointmentTag`. */
  appointmentTags?: Maybe<AppointmentTagsConnection>;
  /** Reads a set of `AppointmentTag`. */
  appointmentTagsList?: Maybe<Array<AppointmentTag>>;
  /** Reads and enables pagination through a set of `Appointment`. */
  appointments?: Maybe<AppointmentsConnection>;
  /** Reads a set of `Appointment`. */
  appointmentsList?: Maybe<Array<Appointment>>;
  billingDiagnostic?: Maybe<BillingDiagnostic>;
  billingDiagnosticByEncounterTaskIdAndProcedureCodeReferenceId?: Maybe<BillingDiagnostic>;
  /** Reads a single `BillingDiagnostic` using its globally unique `ID`. */
  billingDiagnosticByNodeId?: Maybe<BillingDiagnostic>;
  /** Reads and enables pagination through a set of `BillingDiagnostic`. */
  billingDiagnostics?: Maybe<BillingDiagnosticsConnection>;
  /** Reads a set of `BillingDiagnostic`. */
  billingDiagnosticsList?: Maybe<Array<BillingDiagnostic>>;
  cerRole?: Maybe<CerRole>;
  /** Reads a single `CerRole` using its globally unique `ID`. */
  cerRoleByNodeId?: Maybe<CerRole>;
  /** Reads and enables pagination through a set of `CerRole`. */
  cerRoles?: Maybe<CerRolesConnection>;
  /** Reads a set of `CerRole`. */
  cerRolesList?: Maybe<Array<CerRole>>;
  channelAttribution?: Maybe<ChannelAttribution>;
  channelAttributionByGlobalId?: Maybe<ChannelAttribution>;
  /** Reads a single `ChannelAttribution` using its globally unique `ID`. */
  channelAttributionByNodeId?: Maybe<ChannelAttribution>;
  /** Reads and enables pagination through a set of `ChannelAttribution`. */
  channelAttributions?: Maybe<ChannelAttributionsConnection>;
  /** Reads a set of `ChannelAttribution`. */
  channelAttributionsList?: Maybe<Array<ChannelAttribution>>;
  chiefComplaintAndHpi?: Maybe<ChiefComplaintAndHpi>;
  chiefComplaintAndHpiByEncounterTaskId?: Maybe<ChiefComplaintAndHpi>;
  /** Reads a single `ChiefComplaintAndHpi` using its globally unique `ID`. */
  chiefComplaintAndHpiByNodeId?: Maybe<ChiefComplaintAndHpi>;
  /** Reads and enables pagination through a set of `ChiefComplaintAndHpi`. */
  chiefComplaintAndHpis?: Maybe<ChiefComplaintAndHpisConnection>;
  /** Reads a set of `ChiefComplaintAndHpi`. */
  chiefComplaintAndHpisList?: Maybe<Array<ChiefComplaintAndHpi>>;
  clinic?: Maybe<Clinic>;
  /** Reads a single `Clinic` using its globally unique `ID`. */
  clinicByNodeId?: Maybe<Clinic>;
  clinicianRole?: Maybe<ClinicianRole>;
  /** Reads a single `ClinicianRole` using its globally unique `ID`. */
  clinicianRoleByNodeId?: Maybe<ClinicianRole>;
  /** Reads and enables pagination through a set of `ClinicianRole`. */
  clinicianRoles?: Maybe<ClinicianRolesConnection>;
  /** Reads a set of `ClinicianRole`. */
  clinicianRolesList?: Maybe<Array<ClinicianRole>>;
  /** Reads and enables pagination through a set of `Clinic`. */
  clinics?: Maybe<ClinicsConnection>;
  /** Reads a set of `Clinic`. */
  clinicsList?: Maybe<Array<Clinic>>;
  codeSystem?: Maybe<CodeSystem>;
  /** Reads a single `CodeSystem` using its globally unique `ID`. */
  codeSystemByNodeId?: Maybe<CodeSystem>;
  /** Reads and enables pagination through a set of `CodeSystem`. */
  codeSystems?: Maybe<CodeSystemsConnection>;
  /** Reads a set of `CodeSystem`. */
  codeSystemsList?: Maybe<Array<CodeSystem>>;
  createAddOnTask: Encounter;
  diagnosisCodeReference?: Maybe<DiagnosisCodeReference>;
  /** Reads a single `DiagnosisCodeReference` using its globally unique `ID`. */
  diagnosisCodeReferenceByNodeId?: Maybe<DiagnosisCodeReference>;
  /** Reads and enables pagination through a set of `DiagnosisCodeReference`. */
  diagnosisCodeReferences?: Maybe<DiagnosisCodeReferencesConnection>;
  /** Reads a set of `DiagnosisCodeReference`. */
  diagnosisCodeReferencesList?: Maybe<Array<DiagnosisCodeReference>>;
  /** Reads and enables pagination through a set of `DosespotDrugAllergy`. */
  dosespotDrugAllergies?: Maybe<DosespotDrugAllergiesConnection>;
  /** Reads a set of `DosespotDrugAllergy`. */
  dosespotDrugAllergiesList?: Maybe<Array<DosespotDrugAllergy>>;
  dosespotDrugAllergy?: Maybe<DosespotDrugAllergy>;
  /** Reads a single `DosespotDrugAllergy` using its globally unique `ID`. */
  dosespotDrugAllergyByNodeId?: Maybe<DosespotDrugAllergy>;
  dosespotPatientPrescription?: Maybe<DosespotPatientPrescription>;
  /** Reads a single `DosespotPatientPrescription` using its globally unique `ID`. */
  dosespotPatientPrescriptionByNodeId?: Maybe<DosespotPatientPrescription>;
  /** Reads and enables pagination through a set of `DosespotPatientPrescription`. */
  dosespotPatientPrescriptions?: Maybe<DosespotPatientPrescriptionsConnection>;
  /** Reads a set of `DosespotPatientPrescription`. */
  dosespotPatientPrescriptionsList?: Maybe<Array<DosespotPatientPrescription>>;
  dosespotPatientReportedMedication?: Maybe<DosespotPatientReportedMedication>;
  /** Reads a single `DosespotPatientReportedMedication` using its globally unique `ID`. */
  dosespotPatientReportedMedicationByNodeId?: Maybe<DosespotPatientReportedMedication>;
  /** Reads and enables pagination through a set of `DosespotPatientReportedMedication`. */
  dosespotPatientReportedMedications?: Maybe<DosespotPatientReportedMedicationsConnection>;
  /** Reads a set of `DosespotPatientReportedMedication`. */
  dosespotPatientReportedMedicationsList?: Maybe<Array<DosespotPatientReportedMedication>>;
  drug?: Maybe<Drug>;
  /** Reads a single `Drug` using its globally unique `ID`. */
  drugByNodeId?: Maybe<Drug>;
  /** Reads and enables pagination through a set of `Drug`. */
  drugs?: Maybe<DrugsConnection>;
  /** Reads a set of `Drug`. */
  drugsList?: Maybe<Array<Drug>>;
  encounter?: Maybe<Encounter>;
  /** Reads a single `Encounter` using its globally unique `ID`. */
  encounterByNodeId?: Maybe<Encounter>;
  encounterSignature?: Maybe<EncounterSignature>;
  /** Reads a single `EncounterSignature` using its globally unique `ID`. */
  encounterSignatureByNodeId?: Maybe<EncounterSignature>;
  /** Reads and enables pagination through a set of `EncounterSignature`. */
  encounterSignatures?: Maybe<EncounterSignaturesConnection>;
  /** Reads a set of `EncounterSignature`. */
  encounterSignaturesList?: Maybe<Array<EncounterSignature>>;
  encounterTask?: Maybe<EncounterTask>;
  encounterTaskAttachment?: Maybe<EncounterTaskAttachment>;
  /** Reads a single `EncounterTaskAttachment` using its globally unique `ID`. */
  encounterTaskAttachmentByNodeId?: Maybe<EncounterTaskAttachment>;
  /** Reads and enables pagination through a set of `EncounterTaskAttachment`. */
  encounterTaskAttachments?: Maybe<EncounterTaskAttachmentsConnection>;
  /** Reads a set of `EncounterTaskAttachment`. */
  encounterTaskAttachmentsList?: Maybe<Array<EncounterTaskAttachment>>;
  /** Reads a single `EncounterTask` using its globally unique `ID`. */
  encounterTaskByNodeId?: Maybe<EncounterTask>;
  encounterTaskComment?: Maybe<EncounterTaskComment>;
  /** Reads a single `EncounterTaskComment` using its globally unique `ID`. */
  encounterTaskCommentByNodeId?: Maybe<EncounterTaskComment>;
  /** Reads and enables pagination through a set of `EncounterTaskComment`. */
  encounterTaskComments?: Maybe<EncounterTaskCommentsConnection>;
  /** Reads a set of `EncounterTaskComment`. */
  encounterTaskCommentsList?: Maybe<Array<EncounterTaskComment>>;
  encounterTaskCorrection?: Maybe<EncounterTaskCorrection>;
  /** Reads a single `EncounterTaskCorrection` using its globally unique `ID`. */
  encounterTaskCorrectionByNodeId?: Maybe<EncounterTaskCorrection>;
  /** Reads and enables pagination through a set of `EncounterTaskCorrection`. */
  encounterTaskCorrections?: Maybe<EncounterTaskCorrectionsConnection>;
  /** Reads a set of `EncounterTaskCorrection`. */
  encounterTaskCorrectionsList?: Maybe<Array<EncounterTaskCorrection>>;
  /** Reads and enables pagination through a set of `EncounterTask`. */
  encounterTasks?: Maybe<EncounterTasksConnection>;
  /** Reads a set of `EncounterTask`. */
  encounterTasksList?: Maybe<Array<EncounterTask>>;
  /** Reads and enables pagination through a set of `Encounter`. */
  encounters?: Maybe<EncountersConnection>;
  /** Reads a set of `Encounter`. */
  encountersList?: Maybe<Array<Encounter>>;
  featureGate?: Maybe<FeatureGate>;
  /** Reads a single `FeatureGate` using its globally unique `ID`. */
  featureGateByNodeId?: Maybe<FeatureGate>;
  /** Reads and enables pagination through a set of `FeatureGate`. */
  featureGates?: Maybe<FeatureGatesConnection>;
  /** Reads a set of `FeatureGate`. */
  featureGatesList?: Maybe<Array<FeatureGate>>;
  getAllergicStatusId?: Maybe<Scalars['Int']>;
  getAllergyTypeId?: Maybe<Scalars['Int']>;
  getAppointmentAvailabilities: AppointmentAvailability;
  getCodeSystemId?: Maybe<Scalars['Int']>;
  /** returns all related appointment history for a given appointment id */
  getCompleteAppointmentHistory?: Maybe<AppointmentsConnection>;
  /** returns all related appointment history for a given appointment id */
  getCompleteAppointmentHistoryList?: Maybe<Array<Appointment>>;
  getCurrentUser?: Maybe<User>;
  getDoseSpotNotificationDetails: DoseSpotNotificationsResponse;
  getFeatureGate?: Maybe<FeatureGateResultOutput>;
  /** Public helper function to get all guardian patient objects for a patient */
  getPatientGuardians?: Maybe<PatientGuardiansConnection>;
  /** Public helper function to get all guardian patient objects for a patient */
  getPatientGuardiansList?: Maybe<Array<PatientGuardian>>;
  getProblemStatusId?: Maybe<Scalars['Int']>;
  /** returns all previous rescheduled appointment history for a given appointment id */
  getRescheduledFromAppointmentHistory?: Maybe<AppointmentsConnection>;
  /** returns all previous rescheduled appointment history for a given appointment id */
  getRescheduledFromAppointmentHistoryList?: Maybe<Array<Appointment>>;
  getUser?: Maybe<User>;
  insuranceRecord?: Maybe<InsuranceRecord>;
  /** Reads a single `InsuranceRecord` using its globally unique `ID`. */
  insuranceRecordByNodeId?: Maybe<InsuranceRecord>;
  /** Reads and enables pagination through a set of `InsuranceRecord`. */
  insuranceRecords?: Maybe<InsuranceRecordsConnection>;
  /** Reads a set of `InsuranceRecord`. */
  insuranceRecordsList?: Maybe<Array<InsuranceRecord>>;
  itRole?: Maybe<ItRole>;
  /** Reads a single `ItRole` using its globally unique `ID`. */
  itRoleByNodeId?: Maybe<ItRole>;
  /** Reads and enables pagination through a set of `ItRole`. */
  itRoles?: Maybe<ItRolesConnection>;
  /** Reads a set of `ItRole`. */
  itRolesList?: Maybe<Array<ItRole>>;
  /** Public helper function to paginate through a list of clinicians */
  listClinicians?: Maybe<UsersConnection>;
  /** Public helper function to paginate through a list of clinicians */
  listCliniciansList?: Maybe<Array<User>>;
  /** Public helper function to paginate through a list of responders */
  listResponders?: Maybe<UsersConnection>;
  /** Public helper function to paginate through a list of responders */
  listRespondersList?: Maybe<Array<User>>;
  /** Reads a single `MachineApplication` using its globally unique `ID`. */
  machineApplicationByNodeId?: Maybe<MachineApplication>;
  /** Reads and enables pagination through a set of `MachineApplication`. */
  machineApplications?: Maybe<MachineApplicationsConnection>;
  /** Reads a set of `MachineApplication`. */
  machineApplicationsList?: Maybe<Array<MachineApplication>>;
  market?: Maybe<Market>;
  marketByName?: Maybe<Market>;
  /** Reads a single `Market` using its globally unique `ID`. */
  marketByNodeId?: Maybe<Market>;
  marketChannelAttributionLookup?: Maybe<MarketChannelAttributionLookup>;
  /** Reads a single `MarketChannelAttributionLookup` using its globally unique `ID`. */
  marketChannelAttributionLookupByNodeId?: Maybe<MarketChannelAttributionLookup>;
  /** Reads and enables pagination through a set of `MarketChannelAttributionLookup`. */
  marketChannelAttributionLookups?: Maybe<MarketChannelAttributionLookupsConnection>;
  /** Reads a set of `MarketChannelAttributionLookup`. */
  marketChannelAttributionLookupsList?: Maybe<Array<MarketChannelAttributionLookup>>;
  marketClinic?: Maybe<MarketClinic>;
  /** Reads a single `MarketClinic` using its globally unique `ID`. */
  marketClinicByNodeId?: Maybe<MarketClinic>;
  /** Reads and enables pagination through a set of `MarketClinic`. */
  marketClinics?: Maybe<MarketClinicsConnection>;
  /** Reads a set of `MarketClinic`. */
  marketClinicsList?: Maybe<Array<MarketClinic>>;
  marketPatientFormLookup?: Maybe<MarketPatientFormLookup>;
  /** Reads a single `MarketPatientFormLookup` using its globally unique `ID`. */
  marketPatientFormLookupByNodeId?: Maybe<MarketPatientFormLookup>;
  /** Reads and enables pagination through a set of `MarketPatientFormLookup`. */
  marketPatientFormLookups?: Maybe<MarketPatientFormLookupsConnection>;
  /** Reads a set of `MarketPatientFormLookup`. */
  marketPatientFormLookupsList?: Maybe<Array<MarketPatientFormLookup>>;
  marketQuestionnaireLookup?: Maybe<MarketQuestionnaireLookup>;
  /** Reads a single `MarketQuestionnaireLookup` using its globally unique `ID`. */
  marketQuestionnaireLookupByNodeId?: Maybe<MarketQuestionnaireLookup>;
  /** Reads and enables pagination through a set of `MarketQuestionnaireLookup`. */
  marketQuestionnaireLookups?: Maybe<MarketQuestionnaireLookupsConnection>;
  /** Reads a set of `MarketQuestionnaireLookup`. */
  marketQuestionnaireLookupsList?: Maybe<Array<MarketQuestionnaireLookup>>;
  /** Reads and enables pagination through a set of `Market`. */
  markets?: Maybe<MarketsConnection>;
  /** Reads a set of `Market`. */
  marketsList?: Maybe<Array<Market>>;
  medicalDecisionMaking?: Maybe<MedicalDecisionMaking>;
  /** Reads a single `MedicalDecisionMaking` using its globally unique `ID`. */
  medicalDecisionMakingByNodeId?: Maybe<MedicalDecisionMaking>;
  /** Reads and enables pagination through a set of `MedicalDecisionMaking`. */
  medicalDecisionMakings?: Maybe<MedicalDecisionMakingsConnection>;
  /** Reads a set of `MedicalDecisionMaking`. */
  medicalDecisionMakingsList?: Maybe<Array<MedicalDecisionMaking>>;
  medicalDirector?: Maybe<MedicalDirector>;
  /** Reads a single `MedicalDirector` using its globally unique `ID`. */
  medicalDirectorByNodeId?: Maybe<MedicalDirector>;
  /** Reads and enables pagination through a set of `MedicalDirector`. */
  medicalDirectors?: Maybe<MedicalDirectorsConnection>;
  /** Reads a set of `MedicalDirector`. */
  medicalDirectorsList?: Maybe<Array<MedicalDirector>>;
  module?: Maybe<Module>;
  /** Reads a single `Module` using its globally unique `ID`. */
  moduleByNodeId?: Maybe<Module>;
  moduleTaskMapping?: Maybe<ModuleTaskMapping>;
  /** Reads a single `ModuleTaskMapping` using its globally unique `ID`. */
  moduleTaskMappingByNodeId?: Maybe<ModuleTaskMapping>;
  /** Reads and enables pagination through a set of `ModuleTaskMapping`. */
  moduleTaskMappings?: Maybe<ModuleTaskMappingsConnection>;
  /** Reads a set of `ModuleTaskMapping`. */
  moduleTaskMappingsList?: Maybe<Array<ModuleTaskMapping>>;
  /** Reads and enables pagination through a set of `Module`. */
  modules?: Maybe<ModulesConnection>;
  /** Reads a set of `Module`. */
  modulesList?: Maybe<Array<Module>>;
  /** Fetches an object given its globally unique `ID`. */
  node?: Maybe<Node>;
  /** The root query type must be a `Node` to work well with Relay 1 mutations. This just resolves to `query`. */
  nodeId: Scalars['ID'];
  opsRole?: Maybe<OpsRole>;
  /** Reads a single `OpsRole` using its globally unique `ID`. */
  opsRoleByNodeId?: Maybe<OpsRole>;
  /** Reads and enables pagination through a set of `OpsRole`. */
  opsRoles?: Maybe<OpsRolesConnection>;
  /** Reads a set of `OpsRole`. */
  opsRolesList?: Maybe<Array<OpsRole>>;
  outreachRole?: Maybe<OutreachRole>;
  /** Reads a single `OutreachRole` using its globally unique `ID`. */
  outreachRoleByNodeId?: Maybe<OutreachRole>;
  /** Reads and enables pagination through a set of `OutreachRole`. */
  outreachRoles?: Maybe<OutreachRolesConnection>;
  /** Reads a set of `OutreachRole`. */
  outreachRolesList?: Maybe<Array<OutreachRole>>;
  patient?: Maybe<Patient>;
  /** Reads and enables pagination through a set of `PatientAllergy`. */
  patientAllergies?: Maybe<PatientAllergiesConnection>;
  /** Reads a set of `PatientAllergy`. */
  patientAllergiesList?: Maybe<Array<PatientAllergy>>;
  patientAllergy?: Maybe<PatientAllergy>;
  /** Reads a single `PatientAllergy` using its globally unique `ID`. */
  patientAllergyByNodeId?: Maybe<PatientAllergy>;
  patientAttachment?: Maybe<PatientAttachment>;
  /** Reads a single `PatientAttachment` using its globally unique `ID`. */
  patientAttachmentByNodeId?: Maybe<PatientAttachment>;
  /** Reads and enables pagination through a set of `PatientAttachment`. */
  patientAttachments?: Maybe<PatientAttachmentsConnection>;
  /** Reads a set of `PatientAttachment`. */
  patientAttachmentsList?: Maybe<Array<PatientAttachment>>;
  patientByGlobalPatientId?: Maybe<Patient>;
  /** Reads a single `Patient` using its globally unique `ID`. */
  patientByNodeId?: Maybe<Patient>;
  /** Reads and enables pagination through a set of `PatientDiagnosis`. */
  patientDiagnoses?: Maybe<PatientDiagnosesConnection>;
  /** Reads a set of `PatientDiagnosis`. */
  patientDiagnosesList?: Maybe<Array<PatientDiagnosis>>;
  patientDiagnosis?: Maybe<PatientDiagnosis>;
  patientDiagnosisByEncounterTaskIdAndDiagnosisCodeReferenceId?: Maybe<PatientDiagnosis>;
  /** Reads a single `PatientDiagnosis` using its globally unique `ID`. */
  patientDiagnosisByNodeId?: Maybe<PatientDiagnosis>;
  patientForm?: Maybe<PatientForm>;
  /** Reads a single `PatientForm` using its globally unique `ID`. */
  patientFormByNodeId?: Maybe<PatientForm>;
  patientFormLookup?: Maybe<PatientFormLookup>;
  /** Reads a single `PatientFormLookup` using its globally unique `ID`. */
  patientFormLookupByNodeId?: Maybe<PatientFormLookup>;
  /** Reads and enables pagination through a set of `PatientFormLookup`. */
  patientFormLookups?: Maybe<PatientFormLookupsConnection>;
  /** Reads a set of `PatientFormLookup`. */
  patientFormLookupsList?: Maybe<Array<PatientFormLookup>>;
  /** Reads and enables pagination through a set of `PatientForm`. */
  patientForms?: Maybe<PatientFormsConnection>;
  /** Reads a set of `PatientForm`. */
  patientFormsList?: Maybe<Array<PatientForm>>;
  patientGuardian?: Maybe<PatientGuardian>;
  /** Reads a single `PatientGuardian` using its globally unique `ID`. */
  patientGuardianByNodeId?: Maybe<PatientGuardian>;
  /** Reads and enables pagination through a set of `PatientGuardian`. */
  patientGuardians?: Maybe<PatientGuardiansConnection>;
  /** Reads a set of `PatientGuardian`. */
  patientGuardiansList?: Maybe<Array<PatientGuardian>>;
  patientInstruction?: Maybe<PatientInstruction>;
  /** Reads a single `PatientInstruction` using its globally unique `ID`. */
  patientInstructionByNodeId?: Maybe<PatientInstruction>;
  /** Reads and enables pagination through a set of `PatientInstruction`. */
  patientInstructions?: Maybe<PatientInstructionsConnection>;
  /** Reads a set of `PatientInstruction`. */
  patientInstructionsList?: Maybe<Array<PatientInstruction>>;
  patientNote?: Maybe<PatientNote>;
  /** Reads a single `PatientNote` using its globally unique `ID`. */
  patientNoteByNodeId?: Maybe<PatientNote>;
  /** Reads and enables pagination through a set of `PatientNote`. */
  patientNotes?: Maybe<PatientNotesConnection>;
  /** Reads a set of `PatientNote`. */
  patientNotesList?: Maybe<Array<PatientNote>>;
  patientProblem?: Maybe<PatientProblem>;
  /** Reads a single `PatientProblem` using its globally unique `ID`. */
  patientProblemByNodeId?: Maybe<PatientProblem>;
  /** Reads and enables pagination through a set of `PatientProblem`. */
  patientProblems?: Maybe<PatientProblemsConnection>;
  /** Reads a set of `PatientProblem`. */
  patientProblemsList?: Maybe<Array<PatientProblem>>;
  /** Reads and enables pagination through a set of `Patient`. */
  patients?: Maybe<PatientsConnection>;
  /** Reads a set of `Patient`. */
  patientsList?: Maybe<Array<Patient>>;
  physicalExam?: Maybe<PhysicalExam>;
  /** Reads a single `PhysicalExam` using its globally unique `ID`. */
  physicalExamByNodeId?: Maybe<PhysicalExam>;
  /** Reads and enables pagination through a set of `PhysicalExam`. */
  physicalExams?: Maybe<PhysicalExamsConnection>;
  /** Reads a set of `PhysicalExam`. */
  physicalExamsList?: Maybe<Array<PhysicalExam>>;
  poctCriticalValueConfirmation?: Maybe<PoctCriticalValueConfirmation>;
  /** Reads a single `PoctCriticalValueConfirmation` using its globally unique `ID`. */
  poctCriticalValueConfirmationByNodeId?: Maybe<PoctCriticalValueConfirmation>;
  /** Reads and enables pagination through a set of `PoctCriticalValueConfirmation`. */
  poctCriticalValueConfirmations?: Maybe<PoctCriticalValueConfirmationsConnection>;
  /** Reads a set of `PoctCriticalValueConfirmation`. */
  poctCriticalValueConfirmationsList?: Maybe<Array<PoctCriticalValueConfirmation>>;
  pointOfCareTest?: Maybe<PointOfCareTest>;
  /** Reads a single `PointOfCareTest` using its globally unique `ID`. */
  pointOfCareTestByNodeId?: Maybe<PointOfCareTest>;
  pointOfCareTestLookup?: Maybe<PointOfCareTestLookup>;
  /** Reads a single `PointOfCareTestLookup` using its globally unique `ID`. */
  pointOfCareTestLookupByNodeId?: Maybe<PointOfCareTestLookup>;
  /** Reads and enables pagination through a set of `PointOfCareTestLookup`. */
  pointOfCareTestLookups?: Maybe<PointOfCareTestLookupsConnection>;
  /** Reads a set of `PointOfCareTestLookup`. */
  pointOfCareTestLookupsList?: Maybe<Array<PointOfCareTestLookup>>;
  /** Reads and enables pagination through a set of `PointOfCareTest`. */
  pointOfCareTests?: Maybe<PointOfCareTestsConnection>;
  /** Reads a set of `PointOfCareTest`. */
  pointOfCareTestsList?: Maybe<Array<PointOfCareTest>>;
  problem?: Maybe<Problem>;
  /** Reads a single `Problem` using its globally unique `ID`. */
  problemByNodeId?: Maybe<Problem>;
  /** Reads and enables pagination through a set of `ProblemCategory`. */
  problemCategories?: Maybe<ProblemCategoriesConnection>;
  /** Reads a set of `ProblemCategory`. */
  problemCategoriesList?: Maybe<Array<ProblemCategory>>;
  problemCategory?: Maybe<ProblemCategory>;
  /** Reads a single `ProblemCategory` using its globally unique `ID`. */
  problemCategoryByNodeId?: Maybe<ProblemCategory>;
  problemStatus?: Maybe<ProblemStatus>;
  /** Reads a single `ProblemStatus` using its globally unique `ID`. */
  problemStatusByNodeId?: Maybe<ProblemStatus>;
  /** Reads and enables pagination through a set of `ProblemStatus`. */
  problemStatuses?: Maybe<ProblemStatusesConnection>;
  /** Reads a set of `ProblemStatus`. */
  problemStatusesList?: Maybe<Array<ProblemStatus>>;
  /** Reads and enables pagination through a set of `Problem`. */
  problems?: Maybe<ProblemsConnection>;
  /** Reads a set of `Problem`. */
  problemsList?: Maybe<Array<Problem>>;
  procedureCodeReference?: Maybe<ProcedureCodeReference>;
  /** Reads a single `ProcedureCodeReference` using its globally unique `ID`. */
  procedureCodeReferenceByNodeId?: Maybe<ProcedureCodeReference>;
  /** Reads and enables pagination through a set of `ProcedureCodeReference`. */
  procedureCodeReferences?: Maybe<ProcedureCodeReferencesConnection>;
  /** Reads a set of `ProcedureCodeReference`. */
  procedureCodeReferencesList?: Maybe<Array<ProcedureCodeReference>>;
  progressNote?: Maybe<ProgressNote>;
  /** Reads a single `ProgressNote` using its globally unique `ID`. */
  progressNoteByNodeId?: Maybe<ProgressNote>;
  /** Reads and enables pagination through a set of `ProgressNote`. */
  progressNotes?: Maybe<ProgressNotesConnection>;
  /** Reads a set of `ProgressNote`. */
  progressNotesList?: Maybe<Array<ProgressNote>>;
  questionnaire?: Maybe<Questionnaire>;
  /** Reads a single `Questionnaire` using its globally unique `ID`. */
  questionnaireByNodeId?: Maybe<Questionnaire>;
  /** Reads and enables pagination through a set of `QuestionnaireCategory`. */
  questionnaireCategories?: Maybe<QuestionnaireCategoriesConnection>;
  /** Reads a set of `QuestionnaireCategory`. */
  questionnaireCategoriesList?: Maybe<Array<QuestionnaireCategory>>;
  questionnaireCategory?: Maybe<QuestionnaireCategory>;
  /** Reads a single `QuestionnaireCategory` using its globally unique `ID`. */
  questionnaireCategoryByNodeId?: Maybe<QuestionnaireCategory>;
  questionnaireLookup?: Maybe<QuestionnaireLookup>;
  /** Reads a single `QuestionnaireLookup` using its globally unique `ID`. */
  questionnaireLookupByNodeId?: Maybe<QuestionnaireLookup>;
  /** Reads and enables pagination through a set of `QuestionnaireLookup`. */
  questionnaireLookups?: Maybe<QuestionnaireLookupsConnection>;
  /** Reads a set of `QuestionnaireLookup`. */
  questionnaireLookupsList?: Maybe<Array<QuestionnaireLookup>>;
  /** Reads and enables pagination through a set of `Questionnaire`. */
  questionnaires?: Maybe<QuestionnairesConnection>;
  /** Reads a set of `Questionnaire`. */
  questionnairesList?: Maybe<Array<Questionnaire>>;
  readResponderAppointments: Array<Appointment>;
  responderRole?: Maybe<ResponderRole>;
  /** Reads a single `ResponderRole` using its globally unique `ID`. */
  responderRoleByNodeId?: Maybe<ResponderRole>;
  /** Reads and enables pagination through a set of `ResponderRole`. */
  responderRoles?: Maybe<ResponderRolesConnection>;
  /** Reads a set of `ResponderRole`. */
  responderRolesList?: Maybe<Array<ResponderRole>>;
  reviewOfSystem?: Maybe<ReviewOfSystem>;
  reviewOfSystemByEncounterTaskIdAndTemplate?: Maybe<ReviewOfSystem>;
  /** Reads a single `ReviewOfSystem` using its globally unique `ID`. */
  reviewOfSystemByNodeId?: Maybe<ReviewOfSystem>;
  reviewOfSystemSystem?: Maybe<ReviewOfSystemSystem>;
  /** Reads a single `ReviewOfSystemSystem` using its globally unique `ID`. */
  reviewOfSystemSystemByNodeId?: Maybe<ReviewOfSystemSystem>;
  reviewOfSystemSystemByReviewOfSystemIdAndSystem?: Maybe<ReviewOfSystemSystem>;
  /** Reads and enables pagination through a set of `ReviewOfSystemSystem`. */
  reviewOfSystemSystems?: Maybe<ReviewOfSystemSystemsConnection>;
  /** Reads a set of `ReviewOfSystemSystem`. */
  reviewOfSystemSystemsList?: Maybe<Array<ReviewOfSystemSystem>>;
  /** Reads and enables pagination through a set of `ReviewOfSystem`. */
  reviewOfSystems?: Maybe<ReviewOfSystemsConnection>;
  /** Reads a set of `ReviewOfSystem`. */
  reviewOfSystemsList?: Maybe<Array<ReviewOfSystem>>;
  searchAllergyCodes?: Maybe<Array<Allergy>>;
  searchAppointments?: Maybe<Array<Appointment>>;
  /** Reads and enables pagination through a set of `Appointment`. */
  searchAppointmentsQuery?: Maybe<AppointmentsConnection>;
  /** Reads and enables pagination through a set of `Appointment`. */
  searchAppointmentsQueryList?: Maybe<Array<Appointment>>;
  searchCPTCodes?: Maybe<Array<ProcedureCodeReference>>;
  searchClinicians?: Maybe<Array<User>>;
  searchICDCodes?: Maybe<Array<DiagnosisCodeReference>>;
  searchPatients?: Maybe<Array<Patient>>;
  searchReactionCodes?: Maybe<Array<AllergicReaction>>;
  searchResponders?: Maybe<Array<User>>;
  serviceLine?: Maybe<ServiceLine>;
  /** Reads a single `ServiceLine` using its globally unique `ID`. */
  serviceLineByNodeId?: Maybe<ServiceLine>;
  /** Reads and enables pagination through a set of `ServiceLine`. */
  serviceLines?: Maybe<ServiceLinesConnection>;
  /** Reads a set of `ServiceLine`. */
  serviceLinesList?: Maybe<Array<ServiceLine>>;
  standingOrder?: Maybe<StandingOrder>;
  /** Reads a single `StandingOrder` using its globally unique `ID`. */
  standingOrderByNodeId?: Maybe<StandingOrder>;
  standingOrderByNumberAndStateAndVersion?: Maybe<StandingOrder>;
  /** Reads and enables pagination through a set of `StandingOrder`. */
  standingOrders?: Maybe<StandingOrdersConnection>;
  /** Reads a set of `StandingOrder`. */
  standingOrdersList?: Maybe<Array<StandingOrder>>;
  startEncounter: Encounter;
  supervisorRole?: Maybe<SupervisorRole>;
  /** Reads a single `SupervisorRole` using its globally unique `ID`. */
  supervisorRoleByNodeId?: Maybe<SupervisorRole>;
  /** Reads and enables pagination through a set of `SupervisorRole`. */
  supervisorRoles?: Maybe<SupervisorRolesConnection>;
  /** Reads a set of `SupervisorRole`. */
  supervisorRolesList?: Maybe<Array<SupervisorRole>>;
  telehealthMeeting?: Maybe<TelehealthMeeting>;
  /** Reads a single `TelehealthMeeting` using its globally unique `ID`. */
  telehealthMeetingByNodeId?: Maybe<TelehealthMeeting>;
  /** Reads and enables pagination through a set of `TelehealthMeeting`. */
  telehealthMeetings?: Maybe<TelehealthMeetingsConnection>;
  /** Reads a set of `TelehealthMeeting`. */
  telehealthMeetingsList?: Maybe<Array<TelehealthMeeting>>;
  user?: Maybe<User>;
  userByEmployeeId?: Maybe<User>;
  /** Reads a single `User` using its globally unique `ID`. */
  userByNodeId?: Maybe<User>;
  /** Reads and enables pagination through a set of `UserMarket`. */
  userMarkets?: Maybe<UserMarketsConnection>;
  /** Reads a set of `UserMarket`. */
  userMarketsList?: Maybe<Array<UserMarket>>;
  userPatient?: Maybe<UserPatient>;
  /** Reads a single `UserPatient` using its globally unique `ID`. */
  userPatientByNodeId?: Maybe<UserPatient>;
  /** Reads and enables pagination through a set of `UserPatient`. */
  userPatients?: Maybe<UserPatientsConnection>;
  /** Reads a set of `UserPatient`. */
  userPatientsList?: Maybe<Array<UserPatient>>;
  /** Reads and enables pagination through a set of `User`. */
  users?: Maybe<UsersConnection>;
  /** Reads a set of `User`. */
  usersList?: Maybe<Array<User>>;
  /** Reads and enables pagination through a set of `VRedoxPatientExport`. */
  vRedoxPatientExports?: Maybe<VRedoxPatientExportsConnection>;
  /** Reads a set of `VRedoxPatientExport`. */
  vRedoxPatientExportsList?: Maybe<Array<VRedoxPatientExport>>;
  vaccine?: Maybe<Vaccine>;
  /** Reads a single `Vaccine` using its globally unique `ID`. */
  vaccineByNodeId?: Maybe<Vaccine>;
  vaccineLookup?: Maybe<VaccineLookup>;
  /** Reads a single `VaccineLookup` using its globally unique `ID`. */
  vaccineLookupByNodeId?: Maybe<VaccineLookup>;
  /** Reads and enables pagination through a set of `VaccineLookup`. */
  vaccineLookups?: Maybe<VaccineLookupsConnection>;
  /** Reads a set of `VaccineLookup`. */
  vaccineLookupsList?: Maybe<Array<VaccineLookup>>;
  /** Reads and enables pagination through a set of `Vaccine`. */
  vaccines?: Maybe<VaccinesConnection>;
  /** Reads a set of `Vaccine`. */
  vaccinesList?: Maybe<Array<Vaccine>>;
  videoConference?: Maybe<VideoConference>;
  /** Reads a single `VideoConference` using its globally unique `ID`. */
  videoConferenceByNodeId?: Maybe<VideoConference>;
  /** Reads and enables pagination through a set of `VideoConference`. */
  videoConferences?: Maybe<VideoConferencesConnection>;
  /** Reads a set of `VideoConference`. */
  videoConferencesList?: Maybe<Array<VideoConference>>;
  vital?: Maybe<Vital>;
  /** Reads a single `Vital` using its globally unique `ID`. */
  vitalByNodeId?: Maybe<Vital>;
  vitalLookup?: Maybe<VitalLookup>;
  /** Reads a single `VitalLookup` using its globally unique `ID`. */
  vitalLookupByNodeId?: Maybe<VitalLookup>;
  /** Reads and enables pagination through a set of `VitalLookup`. */
  vitalLookups?: Maybe<VitalLookupsConnection>;
  /** Reads a set of `VitalLookup`. */
  vitalLookupsList?: Maybe<Array<VitalLookup>>;
  /** Reads and enables pagination through a set of `Vital`. */
  vitals?: Maybe<VitalsConnection>;
  /** Reads a set of `Vital`. */
  vitalsList?: Maybe<Array<Vital>>;
  zipcode?: Maybe<Zipcode>;
  /** Reads a single `Zipcode` using its globally unique `ID`. */
  zipcodeByNodeId?: Maybe<Zipcode>;
  /** Reads and enables pagination through a set of `Zipcode`. */
  zipcodes?: Maybe<ZipcodesConnection>;
  /** Reads a set of `Zipcode`. */
  zipcodesList?: Maybe<Array<Zipcode>>;
  zone?: Maybe<Zone>;
  /** Reads a single `Zone` using its globally unique `ID`. */
  zoneByNodeId?: Maybe<Zone>;
  zoneZipcode?: Maybe<ZoneZipcode>;
  /** Reads a single `ZoneZipcode` using its globally unique `ID`. */
  zoneZipcodeByNodeId?: Maybe<ZoneZipcode>;
  /** Reads and enables pagination through a set of `ZoneZipcode`. */
  zoneZipcodes?: Maybe<ZoneZipcodesConnection>;
  /** Reads a set of `ZoneZipcode`. */
  zoneZipcodesList?: Maybe<Array<ZoneZipcode>>;
  /** Reads and enables pagination through a set of `Zone`. */
  zones?: Maybe<ZonesConnection>;
  /** Reads a set of `Zone`. */
  zonesList?: Maybe<Array<Zone>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryaddendaArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<AddendumCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AddendaOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryaddendaListArgs = {
  condition?: InputMaybe<AddendumCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AddendaOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryaddendumArgs = {
  addendumId: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type QueryaddendumAttachmentArgs = {
  addendumAttachmentId: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type QueryaddendumAttachmentByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryaddendumAttachmentsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<AddendumAttachmentCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AddendumAttachmentsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryaddendumAttachmentsListArgs = {
  condition?: InputMaybe<AddendumAttachmentCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AddendumAttachmentsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryaddendumByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryallergicCriticalitiesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<AllergicCriticalityCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AllergicCriticalitiesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryallergicCriticalitiesListArgs = {
  condition?: InputMaybe<AllergicCriticalityCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AllergicCriticalitiesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryallergicCriticalityArgs = {
  allergicCriticalityId: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type QueryallergicCriticalityByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryallergicReactionArgs = {
  allergicReactionId: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type QueryallergicReactionByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryallergicReactionsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<AllergicReactionCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AllergicReactionsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryallergicReactionsListArgs = {
  condition?: InputMaybe<AllergicReactionCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AllergicReactionsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryallergicSeveritiesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<AllergicSeverityCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AllergicSeveritiesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryallergicSeveritiesListArgs = {
  condition?: InputMaybe<AllergicSeverityCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AllergicSeveritiesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryallergicSeverityArgs = {
  allergicSeverityId: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type QueryallergicSeverityByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryallergicStatusArgs = {
  allergicStatusId: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type QueryallergicStatusByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryallergicStatusesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<AllergicStatusCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AllergicStatusesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryallergicStatusesListArgs = {
  condition?: InputMaybe<AllergicStatusCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AllergicStatusesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryallergiesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<AllergyCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AllergiesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryallergiesListArgs = {
  condition?: InputMaybe<AllergyCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AllergiesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryallergyArgs = {
  allergyId: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type QueryallergyByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryallergySubstanceArgs = {
  allergySubstanceId: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type QueryallergySubstanceByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryallergySubstancesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<AllergySubstanceCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AllergySubstancesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryallergySubstancesListArgs = {
  condition?: InputMaybe<AllergySubstanceCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AllergySubstancesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryallergyTypeArgs = {
  allergyTypeId: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type QueryallergyTypeByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryallergyTypesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<AllergyTypeCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AllergyTypesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryallergyTypesListArgs = {
  condition?: InputMaybe<AllergyTypeCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AllergyTypesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryappointmentArgs = {
  appointmentId: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type QueryappointmentByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryappointmentDispatchArgs = {
  appointmentDispatchId: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type QueryappointmentDispatchByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryappointmentDispatchesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<AppointmentDispatchCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AppointmentDispatchesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryappointmentDispatchesListArgs = {
  condition?: InputMaybe<AppointmentDispatchCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AppointmentDispatchesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryappointmentTagArgs = {
  appointmentTagId: Scalars['String'];
};


/** The root query type which gives access points into the data universe. */
export type QueryappointmentTagByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryappointmentTagsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<AppointmentTagCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AppointmentTagsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryappointmentTagsListArgs = {
  condition?: InputMaybe<AppointmentTagCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AppointmentTagsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryappointmentsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<AppointmentCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AppointmentsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryappointmentsListArgs = {
  condition?: InputMaybe<AppointmentCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AppointmentsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QuerybillingDiagnosticArgs = {
  billingDiagnosticsId: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type QuerybillingDiagnosticByEncounterTaskIdAndProcedureCodeReferenceIdArgs = {
  encounterTaskId: Scalars['Int'];
  procedureCodeReferenceId: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type QuerybillingDiagnosticByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QuerybillingDiagnosticsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<BillingDiagnosticCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<BillingDiagnosticsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QuerybillingDiagnosticsListArgs = {
  condition?: InputMaybe<BillingDiagnosticCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<BillingDiagnosticsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QuerycerRoleArgs = {
  userId: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type QuerycerRoleByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QuerycerRolesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<CerRoleCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CerRolesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QuerycerRolesListArgs = {
  condition?: InputMaybe<CerRoleCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CerRolesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QuerychannelAttributionArgs = {
  channelAttributionId: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type QuerychannelAttributionByGlobalIdArgs = {
  globalId: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QuerychannelAttributionByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QuerychannelAttributionsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ChannelAttributionCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ChannelAttributionsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QuerychannelAttributionsListArgs = {
  condition?: InputMaybe<ChannelAttributionCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ChannelAttributionsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QuerychiefComplaintAndHpiArgs = {
  chiefComplaintAndHpiId: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type QuerychiefComplaintAndHpiByEncounterTaskIdArgs = {
  encounterTaskId: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type QuerychiefComplaintAndHpiByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QuerychiefComplaintAndHpisArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ChiefComplaintAndHpiCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ChiefComplaintAndHpisOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QuerychiefComplaintAndHpisListArgs = {
  condition?: InputMaybe<ChiefComplaintAndHpiCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ChiefComplaintAndHpisOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryclinicArgs = {
  clinicId: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type QueryclinicByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryclinicianRoleArgs = {
  userId: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type QueryclinicianRoleByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryclinicianRolesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ClinicianRoleCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ClinicianRolesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryclinicianRolesListArgs = {
  condition?: InputMaybe<ClinicianRoleCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ClinicianRolesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryclinicsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ClinicCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ClinicsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryclinicsListArgs = {
  condition?: InputMaybe<ClinicCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ClinicsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QuerycodeSystemArgs = {
  codeSystemId: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type QuerycodeSystemByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QuerycodeSystemsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<CodeSystemCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CodeSystemsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QuerycodeSystemsListArgs = {
  condition?: InputMaybe<CodeSystemCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CodeSystemsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QuerycreateAddOnTaskArgs = {
  encounterId: Scalars['Int'];
  moduleName: ModuleNameEnum;
};


/** The root query type which gives access points into the data universe. */
export type QuerydiagnosisCodeReferenceArgs = {
  diagnosisCodeReferenceId: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type QuerydiagnosisCodeReferenceByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QuerydiagnosisCodeReferencesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<DiagnosisCodeReferenceCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<DiagnosisCodeReferencesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QuerydiagnosisCodeReferencesListArgs = {
  condition?: InputMaybe<DiagnosisCodeReferenceCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<DiagnosisCodeReferencesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QuerydosespotDrugAllergiesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<DosespotDrugAllergyCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<DosespotDrugAllergiesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QuerydosespotDrugAllergiesListArgs = {
  condition?: InputMaybe<DosespotDrugAllergyCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<DosespotDrugAllergiesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QuerydosespotDrugAllergyArgs = {
  dosespotDrugAllergyId: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type QuerydosespotDrugAllergyByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QuerydosespotPatientPrescriptionArgs = {
  patientPrescriptionId: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type QuerydosespotPatientPrescriptionByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QuerydosespotPatientPrescriptionsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<DosespotPatientPrescriptionCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<DosespotPatientPrescriptionsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QuerydosespotPatientPrescriptionsListArgs = {
  condition?: InputMaybe<DosespotPatientPrescriptionCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<DosespotPatientPrescriptionsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QuerydosespotPatientReportedMedicationArgs = {
  patientReportedMedicationId: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type QuerydosespotPatientReportedMedicationByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QuerydosespotPatientReportedMedicationsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<DosespotPatientReportedMedicationCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<DosespotPatientReportedMedicationsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QuerydosespotPatientReportedMedicationsListArgs = {
  condition?: InputMaybe<DosespotPatientReportedMedicationCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<DosespotPatientReportedMedicationsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QuerydrugArgs = {
  drugId: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type QuerydrugByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QuerydrugsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<DrugCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<DrugsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QuerydrugsListArgs = {
  condition?: InputMaybe<DrugCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<DrugsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryencounterArgs = {
  encounterId: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type QueryencounterByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryencounterSignatureArgs = {
  encounterSignatureId: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type QueryencounterSignatureByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryencounterSignaturesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<EncounterSignatureCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EncounterSignaturesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryencounterSignaturesListArgs = {
  condition?: InputMaybe<EncounterSignatureCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EncounterSignaturesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryencounterTaskArgs = {
  encounterTaskId: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type QueryencounterTaskAttachmentArgs = {
  encounterTaskAttachmentId: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type QueryencounterTaskAttachmentByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryencounterTaskAttachmentsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<EncounterTaskAttachmentCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EncounterTaskAttachmentsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryencounterTaskAttachmentsListArgs = {
  condition?: InputMaybe<EncounterTaskAttachmentCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EncounterTaskAttachmentsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryencounterTaskByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryencounterTaskCommentArgs = {
  encounterTaskCommentId: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type QueryencounterTaskCommentByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryencounterTaskCommentsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<EncounterTaskCommentCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EncounterTaskCommentsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryencounterTaskCommentsListArgs = {
  condition?: InputMaybe<EncounterTaskCommentCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EncounterTaskCommentsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryencounterTaskCorrectionArgs = {
  encounterTaskCorrectionId: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type QueryencounterTaskCorrectionByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryencounterTaskCorrectionsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<EncounterTaskCorrectionCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EncounterTaskCorrectionsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryencounterTaskCorrectionsListArgs = {
  condition?: InputMaybe<EncounterTaskCorrectionCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EncounterTaskCorrectionsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryencounterTasksArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<EncounterTaskCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EncounterTasksOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryencounterTasksListArgs = {
  condition?: InputMaybe<EncounterTaskCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EncounterTasksOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryencountersArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<EncounterCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EncountersOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryencountersListArgs = {
  condition?: InputMaybe<EncounterCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EncountersOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryfeatureGateArgs = {
  featureId: Scalars['String'];
};


/** The root query type which gives access points into the data universe. */
export type QueryfeatureGateByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryfeatureGatesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<FeatureGateCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<FeatureGatesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryfeatureGatesListArgs = {
  condition?: InputMaybe<FeatureGateCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<FeatureGatesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QuerygetAllergicStatusIdArgs = {
  searchName: Scalars['String'];
};


/** The root query type which gives access points into the data universe. */
export type QuerygetAllergyTypeIdArgs = {
  searchName: Scalars['String'];
};


/** The root query type which gives access points into the data universe. */
export type QuerygetAppointmentAvailabilitiesArgs = {
  appointment: AppointmentAddress;
  end: Scalars['String'];
  patients: Array<InputMaybe<PatientEncounterRequest>>;
  start: Scalars['String'];
};


/** The root query type which gives access points into the data universe. */
export type QuerygetCodeSystemIdArgs = {
  searchName: Scalars['String'];
  searchVersion: Scalars['String'];
};


/** The root query type which gives access points into the data universe. */
export type QuerygetCompleteAppointmentHistoryArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  appointmentId?: InputMaybe<Scalars['Int']>;
  before?: InputMaybe<Scalars['Cursor']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


/** The root query type which gives access points into the data universe. */
export type QuerygetCompleteAppointmentHistoryListArgs = {
  appointmentId?: InputMaybe<Scalars['Int']>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


/** The root query type which gives access points into the data universe. */
export type QuerygetFeatureGateArgs = {
  featureId: Scalars['String'];
  marketId?: InputMaybe<Scalars['Int']>;
  zoneId?: InputMaybe<Scalars['Int']>;
};


/** The root query type which gives access points into the data universe. */
export type QuerygetPatientGuardiansArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  patientId?: InputMaybe<Scalars['Int']>;
};


/** The root query type which gives access points into the data universe. */
export type QuerygetPatientGuardiansListArgs = {
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  patientId?: InputMaybe<Scalars['Int']>;
};


/** The root query type which gives access points into the data universe. */
export type QuerygetProblemStatusIdArgs = {
  searchName: Scalars['String'];
};


/** The root query type which gives access points into the data universe. */
export type QuerygetRescheduledFromAppointmentHistoryArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  appointmentId?: InputMaybe<Scalars['Int']>;
  before?: InputMaybe<Scalars['Cursor']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


/** The root query type which gives access points into the data universe. */
export type QuerygetRescheduledFromAppointmentHistoryListArgs = {
  appointmentId?: InputMaybe<Scalars['Int']>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


/** The root query type which gives access points into the data universe. */
export type QuerygetUserArgs = {
  userId: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type QueryinsuranceRecordArgs = {
  insuranceRecordId: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type QueryinsuranceRecordByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryinsuranceRecordsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<InsuranceRecordCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InsuranceRecordsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryinsuranceRecordsListArgs = {
  condition?: InputMaybe<InsuranceRecordCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InsuranceRecordsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryitRoleArgs = {
  userId: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type QueryitRoleByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryitRolesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ItRoleCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ItRolesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryitRolesListArgs = {
  condition?: InputMaybe<ItRoleCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ItRolesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QuerylistCliniciansArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  size?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
};


/** The root query type which gives access points into the data universe. */
export type QuerylistCliniciansListArgs = {
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  size?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
};


/** The root query type which gives access points into the data universe. */
export type QuerylistRespondersArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  size?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
};


/** The root query type which gives access points into the data universe. */
export type QuerylistRespondersListArgs = {
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  size?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
};


/** The root query type which gives access points into the data universe. */
export type QuerymachineApplicationByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QuerymachineApplicationsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<MachineApplicationCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<MachineApplicationsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QuerymachineApplicationsListArgs = {
  condition?: InputMaybe<MachineApplicationCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<MachineApplicationsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QuerymarketArgs = {
  marketId: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type QuerymarketByNameArgs = {
  name: Scalars['String'];
};


/** The root query type which gives access points into the data universe. */
export type QuerymarketByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QuerymarketChannelAttributionLookupArgs = {
  channelAttributionId: Scalars['Int'];
  marketId: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type QuerymarketChannelAttributionLookupByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QuerymarketChannelAttributionLookupsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<MarketChannelAttributionLookupCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<MarketChannelAttributionLookupsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QuerymarketChannelAttributionLookupsListArgs = {
  condition?: InputMaybe<MarketChannelAttributionLookupCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<MarketChannelAttributionLookupsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QuerymarketClinicArgs = {
  clinicId: Scalars['Int'];
  marketId: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type QuerymarketClinicByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QuerymarketClinicsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<MarketClinicCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<MarketClinicsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QuerymarketClinicsListArgs = {
  condition?: InputMaybe<MarketClinicCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<MarketClinicsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QuerymarketPatientFormLookupArgs = {
  marketId: Scalars['Int'];
  patientFormLookupId: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type QuerymarketPatientFormLookupByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QuerymarketPatientFormLookupsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<MarketPatientFormLookupCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<MarketPatientFormLookupsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QuerymarketPatientFormLookupsListArgs = {
  condition?: InputMaybe<MarketPatientFormLookupCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<MarketPatientFormLookupsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QuerymarketQuestionnaireLookupArgs = {
  marketId: Scalars['Int'];
  questionnaireLookupId: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type QuerymarketQuestionnaireLookupByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QuerymarketQuestionnaireLookupsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<MarketQuestionnaireLookupCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<MarketQuestionnaireLookupsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QuerymarketQuestionnaireLookupsListArgs = {
  condition?: InputMaybe<MarketQuestionnaireLookupCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<MarketQuestionnaireLookupsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QuerymarketsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<MarketCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<MarketsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QuerymarketsListArgs = {
  condition?: InputMaybe<MarketCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<MarketsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QuerymedicalDecisionMakingArgs = {
  medicalDecisionMakingId: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type QuerymedicalDecisionMakingByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QuerymedicalDecisionMakingsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<MedicalDecisionMakingCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<MedicalDecisionMakingsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QuerymedicalDecisionMakingsListArgs = {
  condition?: InputMaybe<MedicalDecisionMakingCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<MedicalDecisionMakingsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QuerymedicalDirectorArgs = {
  medicalDirectorId: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type QuerymedicalDirectorByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QuerymedicalDirectorsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<MedicalDirectorCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<MedicalDirectorsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QuerymedicalDirectorsListArgs = {
  condition?: InputMaybe<MedicalDirectorCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<MedicalDirectorsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QuerymoduleArgs = {
  name: ModuleNameEnum;
};


/** The root query type which gives access points into the data universe. */
export type QuerymoduleByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QuerymoduleTaskMappingArgs = {
  moduleTaskMappingId: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type QuerymoduleTaskMappingByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QuerymoduleTaskMappingsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ModuleTaskMappingCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ModuleTaskMappingsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QuerymoduleTaskMappingsListArgs = {
  condition?: InputMaybe<ModuleTaskMappingCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ModuleTaskMappingsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QuerymodulesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ModuleCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ModulesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QuerymodulesListArgs = {
  condition?: InputMaybe<ModuleCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ModulesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QuerynodeArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryopsRoleArgs = {
  userId: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type QueryopsRoleByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryopsRolesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<OpsRoleCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<OpsRolesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryopsRolesListArgs = {
  condition?: InputMaybe<OpsRoleCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<OpsRolesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryoutreachRoleArgs = {
  userId: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type QueryoutreachRoleByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryoutreachRolesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<OutreachRoleCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<OutreachRolesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryoutreachRolesListArgs = {
  condition?: InputMaybe<OutreachRoleCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<OutreachRolesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QuerypatientArgs = {
  patientId: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type QuerypatientAllergiesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<PatientAllergyCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PatientAllergiesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QuerypatientAllergiesListArgs = {
  condition?: InputMaybe<PatientAllergyCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PatientAllergiesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QuerypatientAllergyArgs = {
  patientAllergyId: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type QuerypatientAllergyByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QuerypatientAttachmentArgs = {
  patientAttachmentId: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type QuerypatientAttachmentByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QuerypatientAttachmentsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<PatientAttachmentCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PatientAttachmentsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QuerypatientAttachmentsListArgs = {
  condition?: InputMaybe<PatientAttachmentCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PatientAttachmentsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QuerypatientByGlobalPatientIdArgs = {
  globalPatientId: Scalars['String'];
};


/** The root query type which gives access points into the data universe. */
export type QuerypatientByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QuerypatientDiagnosesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<PatientDiagnosisCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PatientDiagnosesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QuerypatientDiagnosesListArgs = {
  condition?: InputMaybe<PatientDiagnosisCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PatientDiagnosesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QuerypatientDiagnosisArgs = {
  patientDiagnosisId: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type QuerypatientDiagnosisByEncounterTaskIdAndDiagnosisCodeReferenceIdArgs = {
  diagnosisCodeReferenceId: Scalars['Int'];
  encounterTaskId: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type QuerypatientDiagnosisByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QuerypatientFormArgs = {
  patientFormId: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type QuerypatientFormByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QuerypatientFormLookupArgs = {
  patientFormLookupId: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type QuerypatientFormLookupByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QuerypatientFormLookupsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<PatientFormLookupCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PatientFormLookupsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QuerypatientFormLookupsListArgs = {
  condition?: InputMaybe<PatientFormLookupCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PatientFormLookupsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QuerypatientFormsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<PatientFormCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PatientFormsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QuerypatientFormsListArgs = {
  condition?: InputMaybe<PatientFormCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PatientFormsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QuerypatientGuardianArgs = {
  guardianId: Scalars['Int'];
  patientId: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type QuerypatientGuardianByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QuerypatientGuardiansArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<PatientGuardianCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PatientGuardiansOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QuerypatientGuardiansListArgs = {
  condition?: InputMaybe<PatientGuardianCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PatientGuardiansOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QuerypatientInstructionArgs = {
  patientInstructionId: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type QuerypatientInstructionByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QuerypatientInstructionsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<PatientInstructionCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PatientInstructionsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QuerypatientInstructionsListArgs = {
  condition?: InputMaybe<PatientInstructionCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PatientInstructionsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QuerypatientNoteArgs = {
  patientNoteId: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type QuerypatientNoteByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QuerypatientNotesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<PatientNoteCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PatientNotesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QuerypatientNotesListArgs = {
  condition?: InputMaybe<PatientNoteCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PatientNotesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QuerypatientProblemArgs = {
  patientProblemId: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type QuerypatientProblemByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QuerypatientProblemsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<PatientProblemCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PatientProblemsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QuerypatientProblemsListArgs = {
  condition?: InputMaybe<PatientProblemCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PatientProblemsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QuerypatientsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<PatientCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PatientsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QuerypatientsListArgs = {
  condition?: InputMaybe<PatientCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PatientsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryphysicalExamArgs = {
  physicalExamId: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type QueryphysicalExamByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryphysicalExamsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<PhysicalExamCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PhysicalExamsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryphysicalExamsListArgs = {
  condition?: InputMaybe<PhysicalExamCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PhysicalExamsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QuerypoctCriticalValueConfirmationArgs = {
  poctCriticalValueConfirmationId: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type QuerypoctCriticalValueConfirmationByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QuerypoctCriticalValueConfirmationsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<PoctCriticalValueConfirmationCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PoctCriticalValueConfirmationsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QuerypoctCriticalValueConfirmationsListArgs = {
  condition?: InputMaybe<PoctCriticalValueConfirmationCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PoctCriticalValueConfirmationsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QuerypointOfCareTestArgs = {
  pointOfCareTestId: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type QuerypointOfCareTestByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QuerypointOfCareTestLookupArgs = {
  pointOfCareTestLookupId: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type QuerypointOfCareTestLookupByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QuerypointOfCareTestLookupsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<PointOfCareTestLookupCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PointOfCareTestLookupsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QuerypointOfCareTestLookupsListArgs = {
  condition?: InputMaybe<PointOfCareTestLookupCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PointOfCareTestLookupsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QuerypointOfCareTestsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<PointOfCareTestCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PointOfCareTestsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QuerypointOfCareTestsListArgs = {
  condition?: InputMaybe<PointOfCareTestCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PointOfCareTestsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryproblemArgs = {
  problemId: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type QueryproblemByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryproblemCategoriesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ProblemCategoryCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProblemCategoriesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryproblemCategoriesListArgs = {
  condition?: InputMaybe<ProblemCategoryCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProblemCategoriesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryproblemCategoryArgs = {
  problemCategoryId: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type QueryproblemCategoryByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryproblemStatusArgs = {
  problemStatusId: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type QueryproblemStatusByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryproblemStatusesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ProblemStatusCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProblemStatusesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryproblemStatusesListArgs = {
  condition?: InputMaybe<ProblemStatusCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProblemStatusesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryproblemsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ProblemCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProblemsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryproblemsListArgs = {
  condition?: InputMaybe<ProblemCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProblemsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryprocedureCodeReferenceArgs = {
  procedureCodeReferenceId: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type QueryprocedureCodeReferenceByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryprocedureCodeReferencesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ProcedureCodeReferenceCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProcedureCodeReferencesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryprocedureCodeReferencesListArgs = {
  condition?: InputMaybe<ProcedureCodeReferenceCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProcedureCodeReferencesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryprogressNoteArgs = {
  progressNoteId: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type QueryprogressNoteByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryprogressNotesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ProgressNoteCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProgressNotesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryprogressNotesListArgs = {
  condition?: InputMaybe<ProgressNoteCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProgressNotesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryquestionnaireArgs = {
  questionnaireId: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type QueryquestionnaireByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryquestionnaireCategoriesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<QuestionnaireCategoryCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<QuestionnaireCategoriesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryquestionnaireCategoriesListArgs = {
  condition?: InputMaybe<QuestionnaireCategoryCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<QuestionnaireCategoriesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryquestionnaireCategoryArgs = {
  category: Scalars['String'];
};


/** The root query type which gives access points into the data universe. */
export type QueryquestionnaireCategoryByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryquestionnaireLookupArgs = {
  questionnaireLookupId: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type QueryquestionnaireLookupByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryquestionnaireLookupsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<QuestionnaireLookupCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<QuestionnaireLookupsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryquestionnaireLookupsListArgs = {
  condition?: InputMaybe<QuestionnaireLookupCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<QuestionnaireLookupsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryquestionnairesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<QuestionnaireCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<QuestionnairesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryquestionnairesListArgs = {
  condition?: InputMaybe<QuestionnaireCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<QuestionnairesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryreadResponderAppointmentsArgs = {
  filter?: InputMaybe<ResponderAppointmentFilter>;
  responderId: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type QueryresponderRoleArgs = {
  userId: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type QueryresponderRoleByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryresponderRolesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ResponderRoleCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ResponderRolesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryresponderRolesListArgs = {
  condition?: InputMaybe<ResponderRoleCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ResponderRolesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryreviewOfSystemArgs = {
  reviewOfSystemId: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type QueryreviewOfSystemByEncounterTaskIdAndTemplateArgs = {
  encounterTaskId: Scalars['Int'];
  template: ReviewOfSystemTemplateEnum;
};


/** The root query type which gives access points into the data universe. */
export type QueryreviewOfSystemByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryreviewOfSystemSystemArgs = {
  reviewOfSystemSystemId: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type QueryreviewOfSystemSystemByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryreviewOfSystemSystemByReviewOfSystemIdAndSystemArgs = {
  reviewOfSystemId: Scalars['Int'];
  system: ReviewOfSystemSystemEnum;
};


/** The root query type which gives access points into the data universe. */
export type QueryreviewOfSystemSystemsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ReviewOfSystemSystemCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ReviewOfSystemSystemsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryreviewOfSystemSystemsListArgs = {
  condition?: InputMaybe<ReviewOfSystemSystemCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ReviewOfSystemSystemsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryreviewOfSystemsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ReviewOfSystemCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ReviewOfSystemsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryreviewOfSystemsListArgs = {
  condition?: InputMaybe<ReviewOfSystemCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ReviewOfSystemsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QuerysearchAllergyCodesArgs = {
  allergyTypeGroup: SearchAllergyCodesTypeGroup;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<SearchAllergyCodesOrderBy>;
  searchTerms: Scalars['String'];
};


/** The root query type which gives access points into the data universe. */
export type QuerysearchAppointmentsArgs = {
  condition?: InputMaybe<AppointmentFilter>;
  limit?: InputMaybe<Scalars['Int']>;
  nameQuery?: InputMaybe<Scalars['String']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<SearchAppointmentsOrderByEnum>;
};


/** The root query type which gives access points into the data universe. */
export type QuerysearchAppointmentsQueryArgs = {
  _limit?: InputMaybe<Scalars['Int']>;
  _offset?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  nameQuery?: InputMaybe<Scalars['String']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['String']>;
};


/** The root query type which gives access points into the data universe. */
export type QuerysearchAppointmentsQueryListArgs = {
  _limit?: InputMaybe<Scalars['Int']>;
  _offset?: InputMaybe<Scalars['Int']>;
  first?: InputMaybe<Scalars['Int']>;
  nameQuery?: InputMaybe<Scalars['String']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['String']>;
};


/** The root query type which gives access points into the data universe. */
export type QuerysearchCPTCodesArgs = {
  activeDate: Scalars['Date'];
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<SearchCptCodesOrderBy>;
  searchTerms: Scalars['String'];
};


/** The root query type which gives access points into the data universe. */
export type QuerysearchCliniciansArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  nameQuery: Scalars['String'];
  orderBy?: InputMaybe<SearchCliniciansOrderBy>;
};


/** The root query type which gives access points into the data universe. */
export type QuerysearchICDCodesArgs = {
  activeDate: Scalars['Date'];
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<SearchIcdCodesOrderBy>;
  searchTerms: Scalars['String'];
};


/** The root query type which gives access points into the data universe. */
export type QuerysearchPatientsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  nameQuery: Scalars['String'];
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<SearchPatientsOrderBy>;
};


/** The root query type which gives access points into the data universe. */
export type QuerysearchReactionCodesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<SearchReactionCodesOrderBy>;
  searchTerms: Scalars['String'];
};


/** The root query type which gives access points into the data universe. */
export type QuerysearchRespondersArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  nameQuery: Scalars['String'];
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<SearchRespondersOrderBy>;
};


/** The root query type which gives access points into the data universe. */
export type QueryserviceLineArgs = {
  serviceLineId: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type QueryserviceLineByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryserviceLinesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ServiceLineCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ServiceLinesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryserviceLinesListArgs = {
  condition?: InputMaybe<ServiceLineCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ServiceLinesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QuerystandingOrderArgs = {
  standingOrderId: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type QuerystandingOrderByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QuerystandingOrderByNumberAndStateAndVersionArgs = {
  number: Scalars['String'];
  state: StateEnum;
  version: Scalars['String'];
};


/** The root query type which gives access points into the data universe. */
export type QuerystandingOrdersArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<StandingOrderCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<StandingOrdersOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QuerystandingOrdersListArgs = {
  condition?: InputMaybe<StandingOrderCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<StandingOrdersOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QuerystartEncounterArgs = {
  encounterId: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type QuerysupervisorRoleArgs = {
  userId: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type QuerysupervisorRoleByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QuerysupervisorRolesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<SupervisorRoleCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<SupervisorRolesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QuerysupervisorRolesListArgs = {
  condition?: InputMaybe<SupervisorRoleCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<SupervisorRolesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QuerytelehealthMeetingArgs = {
  telehealthMeetingId: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type QuerytelehealthMeetingByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QuerytelehealthMeetingsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<TelehealthMeetingCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TelehealthMeetingsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QuerytelehealthMeetingsListArgs = {
  condition?: InputMaybe<TelehealthMeetingCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TelehealthMeetingsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryuserArgs = {
  userId: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type QueryuserByEmployeeIdArgs = {
  employeeId: Scalars['String'];
};


/** The root query type which gives access points into the data universe. */
export type QueryuserByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryuserMarketsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserMarketsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryuserMarketsListArgs = {
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserMarketsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryuserPatientArgs = {
  patientId: Scalars['Int'];
  userId: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type QueryuserPatientByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryuserPatientsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<UserPatientCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserPatientsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryuserPatientsListArgs = {
  condition?: InputMaybe<UserPatientCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserPatientsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryusersArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<UserCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UsersOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryusersListArgs = {
  condition?: InputMaybe<UserCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UsersOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryvRedoxPatientExportsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VRedoxPatientExportsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryvRedoxPatientExportsListArgs = {
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VRedoxPatientExportsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryvaccineArgs = {
  vaccineId: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type QueryvaccineByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryvaccineLookupArgs = {
  vaccineLookupId: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type QueryvaccineLookupByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryvaccineLookupsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<VaccineLookupCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VaccineLookupsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryvaccineLookupsListArgs = {
  condition?: InputMaybe<VaccineLookupCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VaccineLookupsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryvaccinesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<VaccineCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VaccinesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryvaccinesListArgs = {
  condition?: InputMaybe<VaccineCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VaccinesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryvideoConferenceArgs = {
  videoConferenceId: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type QueryvideoConferenceByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryvideoConferencesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<VideoConferenceCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VideoConferencesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryvideoConferencesListArgs = {
  condition?: InputMaybe<VideoConferenceCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VideoConferencesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryvitalArgs = {
  vitalId: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type QueryvitalByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryvitalLookupArgs = {
  vitalLookupId: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type QueryvitalLookupByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryvitalLookupsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<VitalLookupCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VitalLookupsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryvitalLookupsListArgs = {
  condition?: InputMaybe<VitalLookupCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VitalLookupsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryvitalsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<VitalCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VitalsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryvitalsListArgs = {
  condition?: InputMaybe<VitalCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VitalsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryzipcodeArgs = {
  zipCode: Scalars['String'];
};


/** The root query type which gives access points into the data universe. */
export type QueryzipcodeByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryzipcodesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ZipcodeCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ZipcodesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryzipcodesListArgs = {
  condition?: InputMaybe<ZipcodeCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ZipcodesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryzoneArgs = {
  zoneId: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type QueryzoneByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryzoneZipcodeArgs = {
  zipCode: Scalars['UsPostalCode'];
  zoneId: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type QueryzoneZipcodeByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryzoneZipcodesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ZoneZipcodeCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ZoneZipcodesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryzoneZipcodesListArgs = {
  condition?: InputMaybe<ZoneZipcodeCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ZoneZipcodesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryzonesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ZoneCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ZonesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryzonesListArgs = {
  condition?: InputMaybe<ZoneCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ZonesOrderBy>>;
};

/** Contains information about questionnaire responses */
export type Questionnaire = Node & {
  __typename: 'Questionnaire';
  createdAt: Scalars['Datetime'];
  encounterId?: Maybe<Scalars['Int']>;
  encounterTaskId: Scalars['Int'];
  migrationSource: Scalars['String'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  patientId?: Maybe<Scalars['Int']>;
  questionnaireId: Scalars['Int'];
  questionnaireLookupId: Scalars['Int'];
  response: Scalars['JSON'];
};

/** A connection to a list of `QuestionnaireCategory` values. */
export type QuestionnaireCategoriesConnection = {
  __typename: 'QuestionnaireCategoriesConnection';
  /** A list of edges which contains the `QuestionnaireCategory` and cursor to aid in pagination. */
  edges: Array<QuestionnaireCategoriesEdge>;
  /** A list of `QuestionnaireCategory` objects. */
  nodes: Array<QuestionnaireCategory>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `QuestionnaireCategory` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `QuestionnaireCategory` edge in the connection. */
export type QuestionnaireCategoriesEdge = {
  __typename: 'QuestionnaireCategoriesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `QuestionnaireCategory` at the end of the edge. */
  node: QuestionnaireCategory;
};

/** Methods to use when ordering `QuestionnaireCategory`. */
export enum QuestionnaireCategoriesOrderBy {
  CATEGORY_ASC = 'CATEGORY_ASC',
  CATEGORY_DESC = 'CATEGORY_DESC',
  NATURAL = 'NATURAL',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC'
}

/** Contains information about questionnaire categories */
export type QuestionnaireCategory = Node & {
  __typename: 'QuestionnaireCategory';
  category: Scalars['String'];
  createdAt: Scalars['Datetime'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
};

/**
 * A condition to be used against `QuestionnaireCategory` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type QuestionnaireCategoryCondition = {
  /** Checks for equality with the object’s `category` field. */
  category?: InputMaybe<Scalars['String']>;
};

/**
 * A condition to be used against `Questionnaire` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type QuestionnaireCondition = {
  /** Checks for equality with the object’s `migrationSource` field. */
  migrationSource?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `questionnaireId` field. */
  questionnaireId?: InputMaybe<Scalars['Int']>;
};

/** Contains information about questionnaire lookups */
export type QuestionnaireLookup = Node & {
  __typename: 'QuestionnaireLookup';
  createdAt: Scalars['Datetime'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  question: Scalars['String'];
  questionCategory: Scalars['String'];
  questionType: QuestionnaireTypeEnum;
  questionnaireLookupId: Scalars['Int'];
};

/**
 * A condition to be used against `QuestionnaireLookup` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type QuestionnaireLookupCondition = {
  /** Checks for equality with the object’s `questionnaireLookupId` field. */
  questionnaireLookupId?: InputMaybe<Scalars['Int']>;
};

/** A connection to a list of `QuestionnaireLookup` values. */
export type QuestionnaireLookupsConnection = {
  __typename: 'QuestionnaireLookupsConnection';
  /** A list of edges which contains the `QuestionnaireLookup` and cursor to aid in pagination. */
  edges: Array<QuestionnaireLookupsEdge>;
  /** A list of `QuestionnaireLookup` objects. */
  nodes: Array<QuestionnaireLookup>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `QuestionnaireLookup` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `QuestionnaireLookup` edge in the connection. */
export type QuestionnaireLookupsEdge = {
  __typename: 'QuestionnaireLookupsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `QuestionnaireLookup` at the end of the edge. */
  node: QuestionnaireLookup;
};

/** Methods to use when ordering `QuestionnaireLookup`. */
export enum QuestionnaireLookupsOrderBy {
  NATURAL = 'NATURAL',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  QUESTIONNAIRE_LOOKUP_ID_ASC = 'QUESTIONNAIRE_LOOKUP_ID_ASC',
  QUESTIONNAIRE_LOOKUP_ID_DESC = 'QUESTIONNAIRE_LOOKUP_ID_DESC'
}

export enum QuestionnaireTypeEnum {
  HHS_COVID_CONGREGATE_CARE_RESIDENCE = 'HHS_COVID_CONGREGATE_CARE_RESIDENCE',
  HHS_COVID_DATE_OF_ONSET = 'HHS_COVID_DATE_OF_ONSET',
  HHS_COVID_EMPLOYER_ADDRESS = 'HHS_COVID_EMPLOYER_ADDRESS',
  HHS_COVID_EMPLOYER_NAME = 'HHS_COVID_EMPLOYER_NAME',
  HHS_COVID_EMPLOYER_PHONE_NUMBER = 'HHS_COVID_EMPLOYER_PHONE_NUMBER',
  HHS_COVID_HAS_TESTED_BEFORE = 'HHS_COVID_HAS_TESTED_BEFORE',
  HHS_COVID_IN_A_SCHOOL = 'HHS_COVID_IN_A_SCHOOL',
  HHS_COVID_IS_ADDRESS_DIFFERENT = 'HHS_COVID_IS_ADDRESS_DIFFERENT',
  HHS_COVID_IS_EMPLOYED = 'HHS_COVID_IS_EMPLOYED',
  HHS_COVID_IS_EMPLOYED_HEALTHCARE = 'HHS_COVID_IS_EMPLOYED_HEALTHCARE',
  HHS_COVID_IS_PREGNANT = 'HHS_COVID_IS_PREGNANT',
  HHS_COVID_IS_SYMPTOMATIC = 'HHS_COVID_IS_SYMPTOMATIC',
  HHS_COVID_LOCAL_ADDRESS = 'HHS_COVID_LOCAL_ADDRESS',
  HHS_COVID_OCCUPATION = 'HHS_COVID_OCCUPATION',
  HHS_COVID_POSITIVE_TEST_DATE = 'HHS_COVID_POSITIVE_TEST_DATE',
  HHS_COVID_PREVIOUSLY_POSITIVE = 'HHS_COVID_PREVIOUSLY_POSITIVE',
  HHS_COVID_SCHOOL_ADDRESS = 'HHS_COVID_SCHOOL_ADDRESS',
  HHS_COVID_SCHOOL_NAME = 'HHS_COVID_SCHOOL_NAME'
}

/** A connection to a list of `Questionnaire` values. */
export type QuestionnairesConnection = {
  __typename: 'QuestionnairesConnection';
  /** A list of edges which contains the `Questionnaire` and cursor to aid in pagination. */
  edges: Array<QuestionnairesEdge>;
  /** A list of `Questionnaire` objects. */
  nodes: Array<Questionnaire>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Questionnaire` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Questionnaire` edge in the connection. */
export type QuestionnairesEdge = {
  __typename: 'QuestionnairesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `Questionnaire` at the end of the edge. */
  node: Questionnaire;
};

/** Methods to use when ordering `Questionnaire`. */
export enum QuestionnairesOrderBy {
  MIGRATION_SOURCE_ASC = 'MIGRATION_SOURCE_ASC',
  MIGRATION_SOURCE_DESC = 'MIGRATION_SOURCE_DESC',
  NATURAL = 'NATURAL',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  QUESTIONNAIRE_ID_ASC = 'QUESTIONNAIRE_ID_ASC',
  QUESTIONNAIRE_ID_DESC = 'QUESTIONNAIRE_ID_DESC'
}

export enum RaceEnum {
  AFRICAN = 'AFRICAN',
  AFRICAN_AMERICAN = 'AFRICAN_AMERICAN',
  AMERICAN_INDIAN = 'AMERICAN_INDIAN',
  ASIAN = 'ASIAN',
  CAUCASIAN = 'CAUCASIAN',
  DECLINED = 'DECLINED',
  HISPANIC = 'HISPANIC',
  LATINO = 'LATINO',
  NATIVE_ALASKAN = 'NATIVE_ALASKAN',
  NATIVE_HAWAIIAN = 'NATIVE_HAWAIIAN',
  OTHER = 'OTHER',
  PACIFIC_ISLANDER = 'PACIFIC_ISLANDER',
  UNKNOWN = 'UNKNOWN'
}

export enum ReadyCoreStatusCodeEnum {
  BAD_REQUEST = 'BAD_REQUEST',
  DUPLICATE_RESOURCE_FOUND = 'DUPLICATE_RESOURCE_FOUND',
  INTERNAL_SERVER_ERROR = 'INTERNAL_SERVER_ERROR',
  OPERATION_SUCCESSFUL = 'OPERATION_SUCCESSFUL',
  RESOURCE_NOT_IMPLEMENTED = 'RESOURCE_NOT_IMPLEMENTED'
}

export type RescheduleAppointmentCreationPayload = {
  __typename: 'RescheduleAppointmentCreationPayload';
  appointmentId?: Maybe<Scalars['Int']>;
  error?: Maybe<Scalars['String']>;
};

export type RescheduleAppointmentInput = {
  appointment?: InputMaybe<CreateSkeduloAppointmentInput>;
  appointmentId?: InputMaybe<Scalars['Int']>;
  patients?: InputMaybe<Array<InputMaybe<CreateSkeduloPatientInput>>>;
  rescheduleReason?: InputMaybe<RescheduleReasonEnum>;
};

export enum RescheduleReasonEnum {
  ENGAGING_RESPONDERS = 'ENGAGING_RESPONDERS',
  INPUT_ERROR = 'INPUT_ERROR',
  LACK_OF_RESOURCES_CLINICIAN = 'LACK_OF_RESOURCES_CLINICIAN',
  LACK_OF_RESOURCES_READY_INITIATED = 'LACK_OF_RESOURCES_READY_INITIATED',
  LACK_OF_RESOURCES_RESPONDER = 'LACK_OF_RESOURCES_RESPONDER',
  PATIENT_WAIT_TIME_PATIENT_INITIATED = 'PATIENT_WAIT_TIME_PATIENT_INITIATED',
  TIME_NO_LONGER_WORKS_PATIENT_INITIATED = 'TIME_NO_LONGER_WORKS_PATIENT_INITIATED'
}

export enum ResponderAppointmentFilter {
  CANCELLED = 'CANCELLED',
  FUTURE = 'FUTURE',
  PAST = 'PAST',
  TODAY = 'TODAY'
}

/** Contains contains information about the responder role and mapping to user relation. */
export type ResponderRole = Node & {
  __typename: 'ResponderRole';
  /** Reads and enables pagination through a set of `AppointmentDispatch`. */
  appointmentDispatchesByResponderId: AppointmentDispatchesConnection;
  /** Reads and enables pagination through a set of `AppointmentDispatch`. */
  appointmentDispatchesByResponderIdList: Array<AppointmentDispatch>;
  /** Reads and enables pagination through a set of `Appointment`. */
  appointmentsByAppointmentDispatchResponderIdAndAppointmentId: ResponderRoleAppointmentsByAppointmentDispatchResponderIdAndAppointmentIdManyToManyConnection;
  /** Reads and enables pagination through a set of `Appointment`. */
  appointmentsByAppointmentDispatchResponderIdAndAppointmentIdList: Array<Appointment>;
  deputyId?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  registeredDob?: Maybe<Scalars['Date']>;
  registeredFirstName?: Maybe<Scalars['String']>;
  registeredLastName?: Maybe<Scalars['String']>;
  skeduloId?: Maybe<Scalars['UUID']>;
  updatedAt: Scalars['Datetime'];
  updatedBy?: Maybe<Scalars['Int']>;
  /** Reads a single `User` that is related to this `ResponderRole`. */
  user?: Maybe<User>;
  userId: Scalars['Int'];
};


/** Contains contains information about the responder role and mapping to user relation. */
export type ResponderRoleappointmentDispatchesByResponderIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<AppointmentDispatchCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AppointmentDispatchesOrderBy>>;
};


/** Contains contains information about the responder role and mapping to user relation. */
export type ResponderRoleappointmentDispatchesByResponderIdListArgs = {
  condition?: InputMaybe<AppointmentDispatchCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AppointmentDispatchesOrderBy>>;
};


/** Contains contains information about the responder role and mapping to user relation. */
export type ResponderRoleappointmentsByAppointmentDispatchResponderIdAndAppointmentIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<AppointmentCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AppointmentsOrderBy>>;
};


/** Contains contains information about the responder role and mapping to user relation. */
export type ResponderRoleappointmentsByAppointmentDispatchResponderIdAndAppointmentIdListArgs = {
  condition?: InputMaybe<AppointmentCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AppointmentsOrderBy>>;
};

/** A connection to a list of `Appointment` values, with data from `AppointmentDispatch`. */
export type ResponderRoleAppointmentsByAppointmentDispatchResponderIdAndAppointmentIdManyToManyConnection = {
  __typename: 'ResponderRoleAppointmentsByAppointmentDispatchResponderIdAndAppointmentIdManyToManyConnection';
  /** A list of edges which contains the `Appointment`, info from the `AppointmentDispatch`, and the cursor to aid in pagination. */
  edges: Array<ResponderRoleAppointmentsByAppointmentDispatchResponderIdAndAppointmentIdManyToManyEdge>;
  /** A list of `Appointment` objects. */
  nodes: Array<Appointment>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Appointment` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Appointment` edge in the connection, with data from `AppointmentDispatch`. */
export type ResponderRoleAppointmentsByAppointmentDispatchResponderIdAndAppointmentIdManyToManyEdge = {
  __typename: 'ResponderRoleAppointmentsByAppointmentDispatchResponderIdAndAppointmentIdManyToManyEdge';
  /** Reads and enables pagination through a set of `AppointmentDispatch`. */
  appointmentDispatches: AppointmentDispatchesConnection;
  /** Reads and enables pagination through a set of `AppointmentDispatch`. */
  appointmentDispatchesList: Array<AppointmentDispatch>;
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `Appointment` at the end of the edge. */
  node: Appointment;
};


/** A `Appointment` edge in the connection, with data from `AppointmentDispatch`. */
export type ResponderRoleAppointmentsByAppointmentDispatchResponderIdAndAppointmentIdManyToManyEdgeappointmentDispatchesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<AppointmentDispatchCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AppointmentDispatchesOrderBy>>;
};


/** A `Appointment` edge in the connection, with data from `AppointmentDispatch`. */
export type ResponderRoleAppointmentsByAppointmentDispatchResponderIdAndAppointmentIdManyToManyEdgeappointmentDispatchesListArgs = {
  condition?: InputMaybe<AppointmentDispatchCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AppointmentDispatchesOrderBy>>;
};

/**
 * A condition to be used against `ResponderRole` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type ResponderRoleCondition = {
  /** Checks for equality with the object’s `skeduloId` field. */
  skeduloId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars['Int']>;
};

/** A connection to a list of `ResponderRole` values. */
export type ResponderRolesConnection = {
  __typename: 'ResponderRolesConnection';
  /** A list of edges which contains the `ResponderRole` and cursor to aid in pagination. */
  edges: Array<ResponderRolesEdge>;
  /** A list of `ResponderRole` objects. */
  nodes: Array<ResponderRole>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ResponderRole` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `ResponderRole` edge in the connection. */
export type ResponderRolesEdge = {
  __typename: 'ResponderRolesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `ResponderRole` at the end of the edge. */
  node: ResponderRole;
};

/** Methods to use when ordering `ResponderRole`. */
export enum ResponderRolesOrderBy {
  NATURAL = 'NATURAL',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  SKEDULO_ID_ASC = 'SKEDULO_ID_ASC',
  SKEDULO_ID_DESC = 'SKEDULO_ID_DESC',
  USER_ID_ASC = 'USER_ID_ASC',
  USER_ID_DESC = 'USER_ID_DESC'
}

/** All input for the `revertTransitionEncounterTaskToClinicianReviewed` mutation. */
export type RevertTransitionEncounterTaskToClinicianReviewedInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  vTaskId: Scalars['Int'];
};

/** The output of our `revertTransitionEncounterTaskToClinicianReviewed` mutation. */
export type RevertTransitionEncounterTaskToClinicianReviewedPayload = {
  __typename: 'RevertTransitionEncounterTaskToClinicianReviewedPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  encounterTaskStatusEnum?: Maybe<EncounterTaskStatusEnum>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** All input for the `revertTransitionEncounterTaskToResponderCompleted` mutation. */
export type RevertTransitionEncounterTaskToResponderCompletedInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  vTaskId: Scalars['Int'];
};

/** The output of our `revertTransitionEncounterTaskToResponderCompleted` mutation. */
export type RevertTransitionEncounterTaskToResponderCompletedPayload = {
  __typename: 'RevertTransitionEncounterTaskToResponderCompletedPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  encounterTaskStatusEnum?: Maybe<EncounterTaskStatusEnum>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

export type ReviewOfSystem = Node & {
  __typename: 'ReviewOfSystem';
  createdAt: Scalars['Datetime'];
  encounterTaskId: Scalars['Int'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  reviewOfSystemId: Scalars['Int'];
  template: ReviewOfSystemTemplateEnum;
};

/**
 * A condition to be used against `ReviewOfSystem` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type ReviewOfSystemCondition = {
  /** Checks for equality with the object’s `encounterTaskId` field. */
  encounterTaskId?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `reviewOfSystemId` field. */
  reviewOfSystemId?: InputMaybe<Scalars['Int']>;
};

export type ReviewOfSystemEvaluationPayload = {
  __typename: 'ReviewOfSystemEvaluationPayload';
  key: Scalars['String'];
  value: Scalars['Boolean'];
};

export type ReviewOfSystemPayload = {
  __typename: 'ReviewOfSystemPayload';
  systems?: Maybe<Array<Maybe<ReviewOfSystemSystemPayload>>>;
  template?: Maybe<ReviewOfSystemTemplateEnum>;
};

export type ReviewOfSystemSystem = Node & {
  __typename: 'ReviewOfSystemSystem';
  createdAt: Scalars['Datetime'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  note?: Maybe<Scalars['String']>;
  reviewOfSystemId: Scalars['Int'];
  reviewOfSystemSystemId: Scalars['Int'];
  system: ReviewOfSystemSystemEnum;
};

/**
 * A condition to be used against `ReviewOfSystemSystem` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type ReviewOfSystemSystemCondition = {
  /** Checks for equality with the object’s `reviewOfSystemId` field. */
  reviewOfSystemId?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `reviewOfSystemSystemId` field. */
  reviewOfSystemSystemId?: InputMaybe<Scalars['Int']>;
};

export enum ReviewOfSystemSystemEnum {
  CARDIOVASCULAR = 'CARDIOVASCULAR',
  CONSTITUTIONAL = 'CONSTITUTIONAL',
  COVID_19_SCREENING = 'COVID_19_SCREENING',
  ENDOCRINE = 'ENDOCRINE',
  ENT = 'ENT',
  EYES = 'EYES',
  GASTROINTESTINAL = 'GASTROINTESTINAL',
  GENITOURINARY = 'GENITOURINARY',
  HEME_LYMPH = 'HEME_LYMPH',
  MUSCULOSKELETAL = 'MUSCULOSKELETAL',
  NEUROLOGICAL = 'NEUROLOGICAL',
  OB_GYN = 'OB_GYN',
  PSYCH = 'PSYCH',
  RESPIRATORY = 'RESPIRATORY',
  SKIN = 'SKIN'
}

export type ReviewOfSystemSystemPayload = {
  __typename: 'ReviewOfSystemSystemPayload';
  evaluations: Array<Maybe<ReviewOfSystemEvaluationPayload>>;
  note?: Maybe<Scalars['String']>;
  system: ReviewOfSystemSystemEnum;
};

/** A connection to a list of `ReviewOfSystemSystem` values. */
export type ReviewOfSystemSystemsConnection = {
  __typename: 'ReviewOfSystemSystemsConnection';
  /** A list of edges which contains the `ReviewOfSystemSystem` and cursor to aid in pagination. */
  edges: Array<ReviewOfSystemSystemsEdge>;
  /** A list of `ReviewOfSystemSystem` objects. */
  nodes: Array<ReviewOfSystemSystem>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ReviewOfSystemSystem` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `ReviewOfSystemSystem` edge in the connection. */
export type ReviewOfSystemSystemsEdge = {
  __typename: 'ReviewOfSystemSystemsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `ReviewOfSystemSystem` at the end of the edge. */
  node: ReviewOfSystemSystem;
};

/** Methods to use when ordering `ReviewOfSystemSystem`. */
export enum ReviewOfSystemSystemsOrderBy {
  NATURAL = 'NATURAL',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  REVIEW_OF_SYSTEM_ID_ASC = 'REVIEW_OF_SYSTEM_ID_ASC',
  REVIEW_OF_SYSTEM_ID_DESC = 'REVIEW_OF_SYSTEM_ID_DESC',
  REVIEW_OF_SYSTEM_SYSTEM_ID_ASC = 'REVIEW_OF_SYSTEM_SYSTEM_ID_ASC',
  REVIEW_OF_SYSTEM_SYSTEM_ID_DESC = 'REVIEW_OF_SYSTEM_SYSTEM_ID_DESC'
}

export enum ReviewOfSystemTemplateEnum {
  ALL = 'ALL',
  CONSTITUTIONAL = 'CONSTITUTIONAL',
  COVID_19 = 'COVID_19',
  GASTROINTESTINAL = 'GASTROINTESTINAL',
  GENERAL_ADULT = 'GENERAL_ADULT'
}

/** A connection to a list of `ReviewOfSystem` values. */
export type ReviewOfSystemsConnection = {
  __typename: 'ReviewOfSystemsConnection';
  /** A list of edges which contains the `ReviewOfSystem` and cursor to aid in pagination. */
  edges: Array<ReviewOfSystemsEdge>;
  /** A list of `ReviewOfSystem` objects. */
  nodes: Array<ReviewOfSystem>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ReviewOfSystem` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `ReviewOfSystem` edge in the connection. */
export type ReviewOfSystemsEdge = {
  __typename: 'ReviewOfSystemsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `ReviewOfSystem` at the end of the edge. */
  node: ReviewOfSystem;
};

/** Methods to use when ordering `ReviewOfSystem`. */
export enum ReviewOfSystemsOrderBy {
  ENCOUNTER_TASK_ID_ASC = 'ENCOUNTER_TASK_ID_ASC',
  ENCOUNTER_TASK_ID_DESC = 'ENCOUNTER_TASK_ID_DESC',
  NATURAL = 'NATURAL',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  REVIEW_OF_SYSTEM_ID_ASC = 'REVIEW_OF_SYSTEM_ID_ASC',
  REVIEW_OF_SYSTEM_ID_DESC = 'REVIEW_OF_SYSTEM_ID_DESC'
}

/** All input for the `revokeItRole` mutation. */
export type RevokeItRoleInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
};

/** The output of our `revokeItRole` mutation. */
export type RevokeItRolePayload = {
  __typename: 'RevokeItRolePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  user?: Maybe<User>;
  /** An edge for our `User`. May be used by Relay 1. */
  userEdge?: Maybe<UsersEdge>;
};


/** The output of our `revokeItRole` mutation. */
export type RevokeItRolePayloaduserEdgeArgs = {
  orderBy?: InputMaybe<Array<UsersOrderBy>>;
};

export type RevokeRoleInput = {
  patch: RevokeRolePatchRecordInput;
  userId: Scalars['Int'];
};

export type RevokeRolePatchRecordInput = {
  role?: InputMaybe<UserRoleEnum>;
};

export type RevokeRolePayload = {
  __typename: 'RevokeRolePayload';
  query?: Maybe<Query>;
  user?: Maybe<User>;
};

export type SaveChannelAttributionPayload = {
  __typename: 'SaveChannelAttributionPayload';
  channelAttribution?: Maybe<ChannelAttribution>;
};

export type SaveMarketInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  endTimes?: InputMaybe<Array<InputMaybe<Scalars['Time']>>>;
  frozenReason?: InputMaybe<Scalars['String']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isFrozen?: InputMaybe<Scalars['Boolean']>;
  launchTimestamp?: InputMaybe<Scalars['Datetime']>;
  marketId?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  operationalDays?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  scheduledFreezeEndTime?: InputMaybe<Scalars['Datetime']>;
  scheduledFreezeReason?: InputMaybe<Scalars['String']>;
  scheduledFreezeStartTime?: InputMaybe<Scalars['Datetime']>;
  startTimes?: InputMaybe<Array<InputMaybe<Scalars['Time']>>>;
  timezone?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

/** The output of our `SaveStandingOrder` mutation. */
export type SaveStandingOrderPayload = {
  __typename: 'SaveStandingOrderPayload';
  standingOrder?: Maybe<StandingOrder>;
};

export type SaveZipcodeInput = {
  city?: InputMaybe<Scalars['String']>;
  county?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  scheduledFreezeEndTime?: InputMaybe<Scalars['DateTime']>;
  scheduledFreezeReason?: InputMaybe<Scalars['String']>;
  scheduledFreezeStartTime?: InputMaybe<Scalars['DateTime']>;
  state?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  zipcode: Scalars['String'];
};

export type SaveZoneInput = {
  appointmentDurationAdjustment?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  frozenReason?: InputMaybe<Scalars['String']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isFrozen?: InputMaybe<Scalars['Boolean']>;
  launchTimestamp?: InputMaybe<Scalars['Date']>;
  marketId?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  scheduledFreezeEndTime?: InputMaybe<Scalars['DateTime']>;
  scheduledFreezeReason?: InputMaybe<Scalars['String']>;
  scheduledFreezeStartTime?: InputMaybe<Scalars['DateTime']>;
  skeduloRegionAreaId?: InputMaybe<Scalars['String']>;
  skeduloRegionId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  zoneId?: InputMaybe<Scalars['Int']>;
};

export enum SearchAllergyCodesOrderBy {
  CODE_ASC = 'CODE_ASC',
  CODE_DESC = 'CODE_DESC',
  NAME_ASC = 'NAME_ASC',
  NAME_DESC = 'NAME_DESC'
}

export enum SearchAllergyCodesTypeGroup {
  DRUG_ALLERGY = 'DRUG_ALLERGY',
  NON_DRUG_ALLERGY = 'NON_DRUG_ALLERGY'
}

export enum SearchAppointmentsOrderByEnum {
  SCHEDULED_FOR_ASC = 'SCHEDULED_FOR_ASC',
  SCHEDULED_FOR_DESC = 'SCHEDULED_FOR_DESC'
}

export enum SearchCliniciansOrderBy {
  NAME_ASC = 'NAME_ASC',
  NAME_DESC = 'NAME_DESC'
}

export enum SearchCptCodesOrderBy {
  CODE_ASC = 'CODE_ASC',
  CODE_DESC = 'CODE_DESC',
  NAME_ASC = 'NAME_ASC',
  NAME_DESC = 'NAME_DESC'
}

export enum SearchIcdCodesOrderBy {
  CODE_ASC = 'CODE_ASC',
  CODE_DESC = 'CODE_DESC',
  NAME_ASC = 'NAME_ASC',
  NAME_DESC = 'NAME_DESC'
}

export enum SearchPatientsOrderBy {
  FIRST_NAME_ASC = 'FIRST_NAME_ASC',
  FIRST_NAME_DESC = 'FIRST_NAME_DESC',
  GLOBAL_PATIENT_ID_ASC = 'GLOBAL_PATIENT_ID_ASC',
  GLOBAL_PATIENT_ID_DESC = 'GLOBAL_PATIENT_ID_DESC',
  LAST_NAME_ASC = 'LAST_NAME_ASC',
  LAST_NAME_DESC = 'LAST_NAME_DESC',
  PATIENT_ID_ASC = 'PATIENT_ID_ASC',
  PATIENT_ID_DESC = 'PATIENT_ID_DESC',
  PREFERRED_NAME_ASC = 'PREFERRED_NAME_ASC',
  PREFERRED_NAME_DESC = 'PREFERRED_NAME_DESC'
}

export enum SearchReactionCodesOrderBy {
  CODE_ASC = 'CODE_ASC',
  CODE_DESC = 'CODE_DESC',
  NAME_ASC = 'NAME_ASC',
  NAME_DESC = 'NAME_DESC'
}

export enum SearchRespondersOrderBy {
  FIRST_NAME_ASC = 'FIRST_NAME_ASC',
  FIRST_NAME_DESC = 'FIRST_NAME_DESC',
  LAST_NAME_ASC = 'LAST_NAME_ASC',
  LAST_NAME_DESC = 'LAST_NAME_DESC',
  USER_ID_ASC = 'USER_ID_ASC',
  USER_ID_DESC = 'USER_ID_DESC'
}

/** Contains information about the ReadyCore service lines */
export type ServiceLine = Node & {
  __typename: 'ServiceLine';
  /** Reads and enables pagination through a set of `Appointment`. */
  appointmentsByEncounterServiceLineIdAndAppointmentId: ServiceLineAppointmentsByEncounterServiceLineIdAndAppointmentIdManyToManyConnection;
  /** Reads and enables pagination through a set of `Appointment`. */
  appointmentsByEncounterServiceLineIdAndAppointmentIdList: Array<Appointment>;
  averageDuration?: Maybe<Interval>;
  createdAt: Scalars['Datetime'];
  /** Reads and enables pagination through a set of `Encounter`. */
  encounters: EncountersConnection;
  /** Reads and enables pagination through a set of `Encounter`. */
  encountersList: Array<Encounter>;
  /** Reads and enables pagination through a set of `InsuranceRecord`. */
  insuranceRecordsByEncounterServiceLineIdAndPrimaryInsurance: ServiceLineInsuranceRecordsByEncounterServiceLineIdAndPrimaryInsuranceManyToManyConnection;
  /** Reads and enables pagination through a set of `InsuranceRecord`. */
  insuranceRecordsByEncounterServiceLineIdAndPrimaryInsuranceList: Array<InsuranceRecord>;
  /** Reads and enables pagination through a set of `InsuranceRecord`. */
  insuranceRecordsByEncounterServiceLineIdAndSecondaryInsurance: ServiceLineInsuranceRecordsByEncounterServiceLineIdAndSecondaryInsuranceManyToManyConnection;
  /** Reads and enables pagination through a set of `InsuranceRecord`. */
  insuranceRecordsByEncounterServiceLineIdAndSecondaryInsuranceList: Array<InsuranceRecord>;
  isDeleted: Scalars['Boolean'];
  name: Scalars['String'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  /** Reads and enables pagination through a set of `Patient`. */
  patientsByEncounterServiceLineIdAndPatientId: ServiceLinePatientsByEncounterServiceLineIdAndPatientIdManyToManyConnection;
  /** Reads and enables pagination through a set of `Patient`. */
  patientsByEncounterServiceLineIdAndPatientIdList: Array<Patient>;
  priority: Scalars['Int'];
  segment?: Maybe<Scalars['String']>;
  serviceLineId: Scalars['Int'];
  subType: Scalars['String'];
};


/** Contains information about the ReadyCore service lines */
export type ServiceLineappointmentsByEncounterServiceLineIdAndAppointmentIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<AppointmentCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AppointmentsOrderBy>>;
};


/** Contains information about the ReadyCore service lines */
export type ServiceLineappointmentsByEncounterServiceLineIdAndAppointmentIdListArgs = {
  condition?: InputMaybe<AppointmentCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AppointmentsOrderBy>>;
};


/** Contains information about the ReadyCore service lines */
export type ServiceLineencountersArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<EncounterCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EncountersOrderBy>>;
};


/** Contains information about the ReadyCore service lines */
export type ServiceLineencountersListArgs = {
  condition?: InputMaybe<EncounterCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EncountersOrderBy>>;
};


/** Contains information about the ReadyCore service lines */
export type ServiceLineinsuranceRecordsByEncounterServiceLineIdAndPrimaryInsuranceArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<InsuranceRecordCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InsuranceRecordsOrderBy>>;
};


/** Contains information about the ReadyCore service lines */
export type ServiceLineinsuranceRecordsByEncounterServiceLineIdAndPrimaryInsuranceListArgs = {
  condition?: InputMaybe<InsuranceRecordCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InsuranceRecordsOrderBy>>;
};


/** Contains information about the ReadyCore service lines */
export type ServiceLineinsuranceRecordsByEncounterServiceLineIdAndSecondaryInsuranceArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<InsuranceRecordCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InsuranceRecordsOrderBy>>;
};


/** Contains information about the ReadyCore service lines */
export type ServiceLineinsuranceRecordsByEncounterServiceLineIdAndSecondaryInsuranceListArgs = {
  condition?: InputMaybe<InsuranceRecordCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InsuranceRecordsOrderBy>>;
};


/** Contains information about the ReadyCore service lines */
export type ServiceLinepatientsByEncounterServiceLineIdAndPatientIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<PatientCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PatientsOrderBy>>;
};


/** Contains information about the ReadyCore service lines */
export type ServiceLinepatientsByEncounterServiceLineIdAndPatientIdListArgs = {
  condition?: InputMaybe<PatientCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PatientsOrderBy>>;
};

/** A connection to a list of `Appointment` values, with data from `Encounter`. */
export type ServiceLineAppointmentsByEncounterServiceLineIdAndAppointmentIdManyToManyConnection = {
  __typename: 'ServiceLineAppointmentsByEncounterServiceLineIdAndAppointmentIdManyToManyConnection';
  /** A list of edges which contains the `Appointment`, info from the `Encounter`, and the cursor to aid in pagination. */
  edges: Array<ServiceLineAppointmentsByEncounterServiceLineIdAndAppointmentIdManyToManyEdge>;
  /** A list of `Appointment` objects. */
  nodes: Array<Appointment>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Appointment` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Appointment` edge in the connection, with data from `Encounter`. */
export type ServiceLineAppointmentsByEncounterServiceLineIdAndAppointmentIdManyToManyEdge = {
  __typename: 'ServiceLineAppointmentsByEncounterServiceLineIdAndAppointmentIdManyToManyEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** Reads and enables pagination through a set of `Encounter`. */
  encounters: EncountersConnection;
  /** Reads and enables pagination through a set of `Encounter`. */
  encountersList: Array<Encounter>;
  /** The `Appointment` at the end of the edge. */
  node: Appointment;
};


/** A `Appointment` edge in the connection, with data from `Encounter`. */
export type ServiceLineAppointmentsByEncounterServiceLineIdAndAppointmentIdManyToManyEdgeencountersArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<EncounterCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EncountersOrderBy>>;
};


/** A `Appointment` edge in the connection, with data from `Encounter`. */
export type ServiceLineAppointmentsByEncounterServiceLineIdAndAppointmentIdManyToManyEdgeencountersListArgs = {
  condition?: InputMaybe<EncounterCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EncountersOrderBy>>;
};

/**
 * A condition to be used against `ServiceLine` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type ServiceLineCondition = {
  /** Filters on records matching `serviceLineId` */
  ids?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Checks for equality with the object’s `serviceLineId` field. */
  serviceLineId?: InputMaybe<Scalars['Int']>;
};

/** A connection to a list of `InsuranceRecord` values, with data from `Encounter`. */
export type ServiceLineInsuranceRecordsByEncounterServiceLineIdAndPrimaryInsuranceManyToManyConnection = {
  __typename: 'ServiceLineInsuranceRecordsByEncounterServiceLineIdAndPrimaryInsuranceManyToManyConnection';
  /** A list of edges which contains the `InsuranceRecord`, info from the `Encounter`, and the cursor to aid in pagination. */
  edges: Array<ServiceLineInsuranceRecordsByEncounterServiceLineIdAndPrimaryInsuranceManyToManyEdge>;
  /** A list of `InsuranceRecord` objects. */
  nodes: Array<InsuranceRecord>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `InsuranceRecord` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `InsuranceRecord` edge in the connection, with data from `Encounter`. */
export type ServiceLineInsuranceRecordsByEncounterServiceLineIdAndPrimaryInsuranceManyToManyEdge = {
  __typename: 'ServiceLineInsuranceRecordsByEncounterServiceLineIdAndPrimaryInsuranceManyToManyEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** Reads and enables pagination through a set of `Encounter`. */
  encountersByPrimaryInsurance: EncountersConnection;
  /** Reads and enables pagination through a set of `Encounter`. */
  encountersByPrimaryInsuranceList: Array<Encounter>;
  /** The `InsuranceRecord` at the end of the edge. */
  node: InsuranceRecord;
};


/** A `InsuranceRecord` edge in the connection, with data from `Encounter`. */
export type ServiceLineInsuranceRecordsByEncounterServiceLineIdAndPrimaryInsuranceManyToManyEdgeencountersByPrimaryInsuranceArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<EncounterCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EncountersOrderBy>>;
};


/** A `InsuranceRecord` edge in the connection, with data from `Encounter`. */
export type ServiceLineInsuranceRecordsByEncounterServiceLineIdAndPrimaryInsuranceManyToManyEdgeencountersByPrimaryInsuranceListArgs = {
  condition?: InputMaybe<EncounterCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EncountersOrderBy>>;
};

/** A connection to a list of `InsuranceRecord` values, with data from `Encounter`. */
export type ServiceLineInsuranceRecordsByEncounterServiceLineIdAndSecondaryInsuranceManyToManyConnection = {
  __typename: 'ServiceLineInsuranceRecordsByEncounterServiceLineIdAndSecondaryInsuranceManyToManyConnection';
  /** A list of edges which contains the `InsuranceRecord`, info from the `Encounter`, and the cursor to aid in pagination. */
  edges: Array<ServiceLineInsuranceRecordsByEncounterServiceLineIdAndSecondaryInsuranceManyToManyEdge>;
  /** A list of `InsuranceRecord` objects. */
  nodes: Array<InsuranceRecord>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `InsuranceRecord` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `InsuranceRecord` edge in the connection, with data from `Encounter`. */
export type ServiceLineInsuranceRecordsByEncounterServiceLineIdAndSecondaryInsuranceManyToManyEdge = {
  __typename: 'ServiceLineInsuranceRecordsByEncounterServiceLineIdAndSecondaryInsuranceManyToManyEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** Reads and enables pagination through a set of `Encounter`. */
  encountersBySecondaryInsurance: EncountersConnection;
  /** Reads and enables pagination through a set of `Encounter`. */
  encountersBySecondaryInsuranceList: Array<Encounter>;
  /** The `InsuranceRecord` at the end of the edge. */
  node: InsuranceRecord;
};


/** A `InsuranceRecord` edge in the connection, with data from `Encounter`. */
export type ServiceLineInsuranceRecordsByEncounterServiceLineIdAndSecondaryInsuranceManyToManyEdgeencountersBySecondaryInsuranceArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<EncounterCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EncountersOrderBy>>;
};


/** A `InsuranceRecord` edge in the connection, with data from `Encounter`. */
export type ServiceLineInsuranceRecordsByEncounterServiceLineIdAndSecondaryInsuranceManyToManyEdgeencountersBySecondaryInsuranceListArgs = {
  condition?: InputMaybe<EncounterCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EncountersOrderBy>>;
};

/** A connection to a list of `Patient` values, with data from `Encounter`. */
export type ServiceLinePatientsByEncounterServiceLineIdAndPatientIdManyToManyConnection = {
  __typename: 'ServiceLinePatientsByEncounterServiceLineIdAndPatientIdManyToManyConnection';
  /** A list of edges which contains the `Patient`, info from the `Encounter`, and the cursor to aid in pagination. */
  edges: Array<ServiceLinePatientsByEncounterServiceLineIdAndPatientIdManyToManyEdge>;
  /** A list of `Patient` objects. */
  nodes: Array<Patient>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Patient` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Patient` edge in the connection, with data from `Encounter`. */
export type ServiceLinePatientsByEncounterServiceLineIdAndPatientIdManyToManyEdge = {
  __typename: 'ServiceLinePatientsByEncounterServiceLineIdAndPatientIdManyToManyEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** Reads and enables pagination through a set of `Encounter`. */
  encounters: EncountersConnection;
  /** Reads and enables pagination through a set of `Encounter`. */
  encountersList: Array<Encounter>;
  /** The `Patient` at the end of the edge. */
  node: Patient;
};


/** A `Patient` edge in the connection, with data from `Encounter`. */
export type ServiceLinePatientsByEncounterServiceLineIdAndPatientIdManyToManyEdgeencountersArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<EncounterCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EncountersOrderBy>>;
};


/** A `Patient` edge in the connection, with data from `Encounter`. */
export type ServiceLinePatientsByEncounterServiceLineIdAndPatientIdManyToManyEdgeencountersListArgs = {
  condition?: InputMaybe<EncounterCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EncountersOrderBy>>;
};

/** A connection to a list of `ServiceLine` values. */
export type ServiceLinesConnection = {
  __typename: 'ServiceLinesConnection';
  /** A list of edges which contains the `ServiceLine` and cursor to aid in pagination. */
  edges: Array<ServiceLinesEdge>;
  /** A list of `ServiceLine` objects. */
  nodes: Array<ServiceLine>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ServiceLine` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `ServiceLine` edge in the connection. */
export type ServiceLinesEdge = {
  __typename: 'ServiceLinesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `ServiceLine` at the end of the edge. */
  node: ServiceLine;
};

/** Methods to use when ordering `ServiceLine`. */
export enum ServiceLinesOrderBy {
  NATURAL = 'NATURAL',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  SERVICE_LINE_ID_ASC = 'SERVICE_LINE_ID_ASC',
  SERVICE_LINE_ID_DESC = 'SERVICE_LINE_ID_DESC'
}

export enum SexEnum {
  FEMALE = 'FEMALE',
  MALE = 'MALE',
  OTHER = 'OTHER'
}

export type SkeduloAppointmentCreationPayload = {
  __typename: 'SkeduloAppointmentCreationPayload';
  appointmentId?: Maybe<Scalars['Int']>;
  error?: Maybe<Scalars['String']>;
};

export type SkeduloAppointmentInput = {
  appointment?: InputMaybe<CreateSkeduloAppointmentInput>;
  patients?: InputMaybe<Array<InputMaybe<CreateSkeduloPatientInput>>>;
};

export type SkeduloEncounterInput = {
  channelAttributionId?: InputMaybe<Scalars['Int']>;
  genderRequirement?: InputMaybe<SexEnum>;
  modules?: InputMaybe<Array<InputMaybe<ModuleNameEnum>>>;
  paymentMode?: InputMaybe<EncounterPaymentModeEnum>;
  primaryInsurance?: InputMaybe<CreateSkeduloInsuranceInput>;
  primaryInsuranceId?: InputMaybe<Scalars['Int']>;
  reasonForEncounter?: InputMaybe<Scalars['String']>;
  secondaryInsurance?: InputMaybe<CreateSkeduloInsuranceInput>;
  secondaryInsuranceId?: InputMaybe<Scalars['Int']>;
  serviceLineId?: InputMaybe<Scalars['Int']>;
  stripeId?: InputMaybe<Scalars['String']>;
};

/** Contains information about standing orders for a test configuration */
export type StandingOrder = Node & {
  __typename: 'StandingOrder';
  clinician?: Maybe<User>;
  clinicianId: Scalars['Int'];
  createdAt: Scalars['Datetime'];
  diagnosisCodes?: Maybe<Array<Maybe<Scalars['String']>>>;
  endedAt?: Maybe<Scalars['Datetime']>;
  isDeleted: Scalars['Boolean'];
  lookupId?: Maybe<Scalars['Int']>;
  lookupType?: Maybe<StandingOrderLookupTypeEnum>;
  name: Scalars['String'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  number: Scalars['String'];
  orderUrl: Scalars['String'];
  procedureCodes?: Maybe<Array<Maybe<Scalars['String']>>>;
  standingOrderId: Scalars['Int'];
  startedAt?: Maybe<Scalars['Datetime']>;
  state: StateEnum;
  updatedAt: Scalars['Datetime'];
  version: Scalars['String'];
};

/**
 * A condition to be used against `StandingOrder` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type StandingOrderCondition = {
  /** Filters on records matching `lookupType` */
  lookupType?: InputMaybe<StandingOrderLookupTypeConditionEnum>;
  /** Checks for equality with the object’s `number` field. */
  number?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `standingOrderId` field. */
  standingOrderId?: InputMaybe<Scalars['Int']>;
};

/** All input for `CreateStandingOrderLookup`. */
export type StandingOrderLookupInput = {
  lookupId: Scalars['Int'];
  lookupType: StandingOrderLookupTypeEnum;
};

export enum StandingOrderLookupTypeConditionEnum {
  POINT_OF_CARE_TEST = 'POINT_OF_CARE_TEST',
  VACCINE = 'VACCINE'
}

export enum StandingOrderLookupTypeEnum {
  POINT_OF_CARE_TEST = 'POINT_OF_CARE_TEST',
  VACCINE = 'VACCINE'
}

/** A connection to a list of `StandingOrder` values. */
export type StandingOrdersConnection = {
  __typename: 'StandingOrdersConnection';
  /** A list of edges which contains the `StandingOrder` and cursor to aid in pagination. */
  edges: Array<StandingOrdersEdge>;
  /** A list of `StandingOrder` objects. */
  nodes: Array<StandingOrder>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `StandingOrder` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `StandingOrder` edge in the connection. */
export type StandingOrdersEdge = {
  __typename: 'StandingOrdersEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `StandingOrder` at the end of the edge. */
  node: StandingOrder;
};

/** Methods to use when ordering `StandingOrder`. */
export enum StandingOrdersOrderBy {
  NATURAL = 'NATURAL',
  NUMBER_ASC = 'NUMBER_ASC',
  NUMBER_DESC = 'NUMBER_DESC',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  STANDING_ORDER_ID_ASC = 'STANDING_ORDER_ID_ASC',
  STANDING_ORDER_ID_DESC = 'STANDING_ORDER_ID_DESC'
}

export enum StateEnum {
  AK = 'AK',
  AL = 'AL',
  AR = 'AR',
  AZ = 'AZ',
  CA = 'CA',
  CO = 'CO',
  CT = 'CT',
  DC = 'DC',
  DE = 'DE',
  FL = 'FL',
  GA = 'GA',
  HI = 'HI',
  IA = 'IA',
  ID = 'ID',
  IL = 'IL',
  IN = 'IN',
  KS = 'KS',
  KY = 'KY',
  LA = 'LA',
  MA = 'MA',
  MD = 'MD',
  ME = 'ME',
  MI = 'MI',
  MN = 'MN',
  MO = 'MO',
  MS = 'MS',
  MT = 'MT',
  NC = 'NC',
  ND = 'ND',
  NE = 'NE',
  NH = 'NH',
  NJ = 'NJ',
  NM = 'NM',
  NV = 'NV',
  NY = 'NY',
  OH = 'OH',
  OK = 'OK',
  OR = 'OR',
  PA = 'PA',
  RI = 'RI',
  SC = 'SC',
  SD = 'SD',
  TN = 'TN',
  TX = 'TX',
  UT = 'UT',
  VA = 'VA',
  VT = 'VT',
  WA = 'WA',
  WI = 'WI',
  WV = 'WV',
  WY = 'WY'
}

/** Contains contains information about the suipervisor role and mapping to user relation. */
export type SupervisorRole = Node & {
  __typename: 'SupervisorRole';
  isDeleted: Scalars['Boolean'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  registeredDob?: Maybe<Scalars['Date']>;
  registeredFirstName?: Maybe<Scalars['String']>;
  registeredLastName?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['Datetime']>;
  updatedBy?: Maybe<Scalars['Int']>;
  /** Reads a single `User` that is related to this `SupervisorRole`. */
  user?: Maybe<User>;
  userId: Scalars['Int'];
};

/**
 * A condition to be used against `SupervisorRole` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type SupervisorRoleCondition = {
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars['Int']>;
};

/** A connection to a list of `SupervisorRole` values. */
export type SupervisorRolesConnection = {
  __typename: 'SupervisorRolesConnection';
  /** A list of edges which contains the `SupervisorRole` and cursor to aid in pagination. */
  edges: Array<SupervisorRolesEdge>;
  /** A list of `SupervisorRole` objects. */
  nodes: Array<SupervisorRole>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `SupervisorRole` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `SupervisorRole` edge in the connection. */
export type SupervisorRolesEdge = {
  __typename: 'SupervisorRolesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `SupervisorRole` at the end of the edge. */
  node: SupervisorRole;
};

/** Methods to use when ordering `SupervisorRole`. */
export enum SupervisorRolesOrderBy {
  NATURAL = 'NATURAL',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  USER_ID_ASC = 'USER_ID_ASC',
  USER_ID_DESC = 'USER_ID_DESC'
}

/** All input for the `syncSkeduloJobToAppointmentDispatch` mutation. */
export type SyncSkeduloJobToAppointmentDispatchInput = {
  /** The AppointmentDispatch atPatientAt Timestamp */
  atPatientAt?: InputMaybe<Scalars['DateTime']>;
  /** The AppointmentDispatch cancelledAt Timestamp */
  cancelledAt?: InputMaybe<Scalars['DateTime']>;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The AppointmentDispatch completedAt Timestamp */
  completedAt?: InputMaybe<Scalars['DateTime']>;
  /** The AppointmentDispatch dispatchedAt Timestamp */
  dispatchedAt?: InputMaybe<Scalars['DateTime']>;
  /** The AppointmentDispatch enRouteAt Timestamp */
  enRouteAt?: InputMaybe<Scalars['DateTime']>;
  /** Unique ID that corresponds to the AppointmentDispatch skeduloJobAllocationId */
  jobAllocationId: Scalars['String'];
  /** Unique ID that corresponds to the Appointment skeduloJobId */
  jobId: Scalars['String'];
  /** The AppointmentDispatch onSceneAt Timestamp */
  onSceneAt?: InputMaybe<Scalars['DateTime']>;
  /** The AppointmentDispatch removedAt Timestamp */
  removedAt?: InputMaybe<Scalars['DateTime']>;
  /** Unique ID that corresponds to the Responder skeduloId */
  resourceId: Scalars['String'];
};

/** The output of our `syncSkeduloJobToAppointmentDispatch` mutation. */
export type SyncSkeduloJobToAppointmentDispatchPayload = {
  __typename: 'SyncSkeduloJobToAppointmentDispatchPayload';
  /** The `AppointmentDispatch` that was updated by this mutation. */
  appointmentDispatch?: Maybe<AppointmentDispatch>;
  /** String message containing information about errors or success. */
  message?: Maybe<Scalars['String']>;
  /** Flag indicating whether the sync was successful or not. */
  success?: Maybe<Scalars['Boolean']>;
};

export enum SystemOfOriginEnum {
  READY_CARE = 'READY_CARE',
  READY_HEALTH_1 = 'READY_HEALTH_1',
  READY_HEALTH_2 = 'READY_HEALTH_2',
  READY_OPS = 'READY_OPS',
  READY_WEBHOOKS = 'READY_WEBHOOKS',
  READY_ZEN = 'READY_ZEN',
  WEB_BOOKING = 'WEB_BOOKING'
}

/** Contains data related to Telehealth Meeting */
export type TelehealthMeeting = Node & {
  __typename: 'TelehealthMeeting';
  alternateConnectionMethod?: Maybe<TelehealthMeetingAlternateConnectionMethodEnum>;
  alternateConnectionReason?: Maybe<Scalars['String']>;
  clinician?: Maybe<User>;
  clinicianClaimedAt?: Maybe<Scalars['Datetime']>;
  clinicianId?: Maybe<Scalars['Int']>;
  clinicianRemovedAt?: Maybe<Scalars['Datetime']>;
  createdAt: Scalars['Datetime'];
  encounterTaskId: Scalars['Int'];
  inQueueAt?: Maybe<Scalars['Datetime']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  telehealthMeetingChildId?: Maybe<Scalars['Int']>;
  telehealthMeetingId: Scalars['Int'];
  updatedAt: Scalars['Datetime'];
  videoConference?: Maybe<VideoConference>;
  videoConferenceId?: Maybe<Scalars['Int']>;
};

export enum TelehealthMeetingAlternateConnectionMethodEnum {
  FAMILY_MEMBER_TELECONFERENCE = 'FAMILY_MEMBER_TELECONFERENCE',
  GOOGLE_MEET = 'GOOGLE_MEET',
  NON_READYHEALTH_ZOOM = 'NON_READYHEALTH_ZOOM',
  OTHER = 'OTHER'
}

/**
 * A condition to be used against `TelehealthMeeting` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type TelehealthMeetingCondition = {
  /** Checks for equality with the object’s `encounterTaskId` field. */
  encounterTaskId?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `telehealthMeetingChildId` field. */
  telehealthMeetingChildId?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `telehealthMeetingId` field. */
  telehealthMeetingId?: InputMaybe<Scalars['Int']>;
};

/** A connection to a list of `TelehealthMeeting` values. */
export type TelehealthMeetingsConnection = {
  __typename: 'TelehealthMeetingsConnection';
  /** A list of edges which contains the `TelehealthMeeting` and cursor to aid in pagination. */
  edges: Array<TelehealthMeetingsEdge>;
  /** A list of `TelehealthMeeting` objects. */
  nodes: Array<TelehealthMeeting>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `TelehealthMeeting` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `TelehealthMeeting` edge in the connection. */
export type TelehealthMeetingsEdge = {
  __typename: 'TelehealthMeetingsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `TelehealthMeeting` at the end of the edge. */
  node: TelehealthMeeting;
};

/** Methods to use when ordering `TelehealthMeeting`. */
export enum TelehealthMeetingsOrderBy {
  ENCOUNTER_TASK_ID_ASC = 'ENCOUNTER_TASK_ID_ASC',
  ENCOUNTER_TASK_ID_DESC = 'ENCOUNTER_TASK_ID_DESC',
  NATURAL = 'NATURAL',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  TELEHEALTH_MEETING_CHILD_ID_ASC = 'TELEHEALTH_MEETING_CHILD_ID_ASC',
  TELEHEALTH_MEETING_CHILD_ID_DESC = 'TELEHEALTH_MEETING_CHILD_ID_DESC',
  TELEHEALTH_MEETING_ID_ASC = 'TELEHEALTH_MEETING_ID_ASC',
  TELEHEALTH_MEETING_ID_DESC = 'TELEHEALTH_MEETING_ID_DESC'
}

export type UnclaimEncounterInput = {
  encounterId: Scalars['Int'];
};

export type UnclaimEncounterPayload = {
  __typename: 'UnclaimEncounterPayload';
  encounter?: Maybe<Encounter>;
};

/** All input for the `UpdateAppointmentByGlobalId` mutation. */
export type UpdateAppointmentByGlobalIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  globalId: Scalars['String'];
  patch: AppointmentPatch;
};

/** All input for the `updateAppointmentDispatchByNodeId` mutation. */
export type UpdateAppointmentDispatchByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `AppointmentDispatch` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `AppointmentDispatch` being updated. */
  patch: AppointmentDispatchPatch;
};

/** All input for the `updateAppointmentDispatch` mutation. */
export type UpdateAppointmentDispatchInput = {
  appointmentDispatchId: Scalars['Int'];
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** An object where the defined keys will be set on the `AppointmentDispatch` being updated. */
  patch: AppointmentDispatchPatch;
};

/** The output of our update `AppointmentDispatch` mutation. */
export type UpdateAppointmentDispatchPayload = {
  __typename: 'UpdateAppointmentDispatchPayload';
  /** Reads a single `Appointment` that is related to this `AppointmentDispatch`. */
  appointment?: Maybe<Appointment>;
  /** The `AppointmentDispatch` that was updated by this mutation. */
  appointmentDispatch?: Maybe<AppointmentDispatch>;
  /** An edge for our `AppointmentDispatch`. May be used by Relay 1. */
  appointmentDispatchEdge?: Maybe<AppointmentDispatchesEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `ResponderRole` that is related to this `AppointmentDispatch`. */
  responder?: Maybe<ResponderRole>;
};


/** The output of our update `AppointmentDispatch` mutation. */
export type UpdateAppointmentDispatchPayloadappointmentDispatchEdgeArgs = {
  orderBy?: InputMaybe<Array<AppointmentDispatchesOrderBy>>;
};

/** All input for the `updateAppointment` mutation. */
export type UpdateAppointmentInput = {
  appointmentId: Scalars['Int'];
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** An object where the defined keys will be set on the `Appointment` being updated. */
  patch: AppointmentPatch;
};

/** The output of our update `Appointment` mutation. */
export type UpdateAppointmentPayload = {
  __typename: 'UpdateAppointmentPayload';
  /** The `Appointment` that was updated by this mutation. */
  appointment?: Maybe<Appointment>;
  /** An edge for our `Appointment`. May be used by Relay 1. */
  appointmentEdge?: Maybe<AppointmentsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Market` that is related to this `Appointment`. */
  market?: Maybe<Market>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `Appointment`. */
  userByCreatedBy?: Maybe<User>;
};


/** The output of our update `Appointment` mutation. */
export type UpdateAppointmentPayloadappointmentEdgeArgs = {
  orderBy?: InputMaybe<Array<AppointmentsOrderBy>>;
};

/** All input for the `updateAppointmentTagByNodeId` mutation. */
export type UpdateAppointmentTagByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `AppointmentTag` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `AppointmentTag` being updated. */
  patch: AppointmentTagPatch;
};

/** All input for the `updateAppointmentTag` mutation. */
export type UpdateAppointmentTagInput = {
  appointmentTagId: Scalars['String'];
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** An object where the defined keys will be set on the `AppointmentTag` being updated. */
  patch: AppointmentTagPatch;
};

/** The output of our update `AppointmentTag` mutation. */
export type UpdateAppointmentTagPayload = {
  __typename: 'UpdateAppointmentTagPayload';
  /** The `AppointmentTag` that was updated by this mutation. */
  appointmentTag?: Maybe<AppointmentTag>;
  /** An edge for our `AppointmentTag`. May be used by Relay 1. */
  appointmentTagEdge?: Maybe<AppointmentTagsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `AppointmentTag` mutation. */
export type UpdateAppointmentTagPayloadappointmentTagEdgeArgs = {
  orderBy?: InputMaybe<Array<AppointmentTagsOrderBy>>;
};

/** All input for the `UpdateChannelAttribution` mutation. */
export type UpdateChannelAttributionInput = {
  channel?: InputMaybe<Scalars['String']>;
  channelAttributionId: Scalars['Int'];
  institutionType?: InputMaybe<ChannelAttributionInstitutionTypeEnum>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  marketIds: Array<InputMaybe<Scalars['Int']>>;
  referralType?: InputMaybe<ChannelAttributionReferralTypeEnum>;
  tagSystem?: InputMaybe<ChannelAttributionTagSystemEnum>;
  trackingNumber?: InputMaybe<Scalars['String']>;
};

/** All input for the `updateClinicByNodeId` mutation. */
export type UpdateClinicByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `Clinic` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `Clinic` being updated. */
  patch: ClinicPatch;
};

/** All input for the `updateClinic` mutation. */
export type UpdateClinicInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  clinicId: Scalars['Int'];
  /** An object where the defined keys will be set on the `Clinic` being updated. */
  patch: ClinicPatch;
};

/** The output of our update `Clinic` mutation. */
export type UpdateClinicPayload = {
  __typename: 'UpdateClinicPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `Clinic` that was updated by this mutation. */
  clinic?: Maybe<Clinic>;
  /** An edge for our `Clinic`. May be used by Relay 1. */
  clinicEdge?: Maybe<ClinicsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `Clinic` mutation. */
export type UpdateClinicPayloadclinicEdgeArgs = {
  orderBy?: InputMaybe<Array<ClinicsOrderBy>>;
};

/** All input for the `updateCodeSystemByNodeId` mutation. */
export type UpdateCodeSystemByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `CodeSystem` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `CodeSystem` being updated. */
  patch: CodeSystemPatch;
};

/** All input for the `updateCodeSystem` mutation. */
export type UpdateCodeSystemInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  codeSystemId: Scalars['Int'];
  /** An object where the defined keys will be set on the `CodeSystem` being updated. */
  patch: CodeSystemPatch;
};

/** The output of our update `CodeSystem` mutation. */
export type UpdateCodeSystemPayload = {
  __typename: 'UpdateCodeSystemPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `CodeSystem` that was updated by this mutation. */
  codeSystem?: Maybe<CodeSystem>;
  /** An edge for our `CodeSystem`. May be used by Relay 1. */
  codeSystemEdge?: Maybe<CodeSystemsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `CodeSystem` mutation. */
export type UpdateCodeSystemPayloadcodeSystemEdgeArgs = {
  orderBy?: InputMaybe<Array<CodeSystemsOrderBy>>;
};

/** All input for the `updateEncounterByNodeId` mutation. */
export type UpdateEncounterByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `Encounter` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `Encounter` being updated. */
  patch: EncounterPatch;
};

/** All input for the `updateEncounter` mutation. */
export type UpdateEncounterInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  encounterId: Scalars['Int'];
  /** An object where the defined keys will be set on the `Encounter` being updated. */
  patch: EncounterPatch;
};

/** The output of our update `Encounter` mutation. */
export type UpdateEncounterPayload = {
  __typename: 'UpdateEncounterPayload';
  /** Reads a single `Appointment` that is related to this `Encounter`. */
  appointment?: Maybe<Appointment>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `Encounter` that was updated by this mutation. */
  encounter?: Maybe<Encounter>;
  /** An edge for our `Encounter`. May be used by Relay 1. */
  encounterEdge?: Maybe<EncountersEdge>;
  /** Reads a single `Patient` that is related to this `Encounter`. */
  patient?: Maybe<Patient>;
  /** Reads a single `InsuranceRecord` that is related to this `Encounter`. */
  primaryInsuranceRecord?: Maybe<InsuranceRecord>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `InsuranceRecord` that is related to this `Encounter`. */
  secondaryInsuranceRecord?: Maybe<InsuranceRecord>;
  /** Reads a single `ServiceLine` that is related to this `Encounter`. */
  serviceLine?: Maybe<ServiceLine>;
};


/** The output of our update `Encounter` mutation. */
export type UpdateEncounterPayloadencounterEdgeArgs = {
  orderBy?: InputMaybe<Array<EncountersOrderBy>>;
};

/** All input for the `updateEncounterTaskAttachmentByNodeId` mutation. */
export type UpdateEncounterTaskAttachmentByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `EncounterTaskAttachment` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `EncounterTaskAttachment` being updated. */
  patch: EncounterTaskAttachmentPatch;
};

/** All input for the `updateEncounterTaskAttachment` mutation. */
export type UpdateEncounterTaskAttachmentInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  encounterTaskAttachmentId: Scalars['Int'];
  /** An object where the defined keys will be set on the `EncounterTaskAttachment` being updated. */
  patch: EncounterTaskAttachmentPatch;
};

/** The output of our update `EncounterTaskAttachment` mutation. */
export type UpdateEncounterTaskAttachmentPayload = {
  __typename: 'UpdateEncounterTaskAttachmentPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `EncounterTask` that is related to this `EncounterTaskAttachment`. */
  encounterTask?: Maybe<EncounterTask>;
  /** The `EncounterTaskAttachment` that was updated by this mutation. */
  encounterTaskAttachment?: Maybe<EncounterTaskAttachment>;
  /** An edge for our `EncounterTaskAttachment`. May be used by Relay 1. */
  encounterTaskAttachmentEdge?: Maybe<EncounterTaskAttachmentsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `EncounterTaskAttachment` mutation. */
export type UpdateEncounterTaskAttachmentPayloadencounterTaskAttachmentEdgeArgs = {
  orderBy?: InputMaybe<Array<EncounterTaskAttachmentsOrderBy>>;
};

/** All input for the `updateEncounterTaskByNodeId` mutation. */
export type UpdateEncounterTaskByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `EncounterTask` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `EncounterTask` being updated. */
  patch: EncounterTaskPatch;
};

/** All input for the `updateEncounterTask` mutation. */
export type UpdateEncounterTaskInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  encounterTaskId: Scalars['Int'];
  /** An object where the defined keys will be set on the `EncounterTask` being updated. */
  patch: EncounterTaskPatch;
};

/** The output of our update `EncounterTask` mutation. */
export type UpdateEncounterTaskPayload = {
  __typename: 'UpdateEncounterTaskPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Encounter` that is related to this `EncounterTask`. */
  encounter?: Maybe<Encounter>;
  /** The `EncounterTask` that was updated by this mutation. */
  encounterTask?: Maybe<EncounterTask>;
  /** An edge for our `EncounterTask`. May be used by Relay 1. */
  encounterTaskEdge?: Maybe<EncounterTasksEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `EncounterTask` mutation. */
export type UpdateEncounterTaskPayloadencounterTaskEdgeArgs = {
  orderBy?: InputMaybe<Array<EncounterTasksOrderBy>>;
};

/** All input for the `updateEncounterTaskTaskRoles` mutation. */
export type UpdateEncounterTaskTaskRolesInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  vEncounterId: Scalars['Int'];
};

/** All input for the `updateEncounterTaskTaskRolesOnEncounterComplete` mutation. */
export type UpdateEncounterTaskTaskRolesOnEncounterCompleteInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  vEncounterId: Scalars['Int'];
};

/** The output of our `updateEncounterTaskTaskRolesOnEncounterComplete` mutation. */
export type UpdateEncounterTaskTaskRolesOnEncounterCompletePayload = {
  __typename: 'UpdateEncounterTaskTaskRolesOnEncounterCompletePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our `updateEncounterTaskTaskRoles` mutation. */
export type UpdateEncounterTaskTaskRolesPayload = {
  __typename: 'UpdateEncounterTaskTaskRolesPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** All input for the `updateFeatureGateByNodeId` mutation. */
export type UpdateFeatureGateByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `FeatureGate` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `FeatureGate` being updated. */
  patch: FeatureGatePatch;
};

/** All input for the `updateFeatureGate` mutation. */
export type UpdateFeatureGateInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  featureId: Scalars['String'];
  /** An object where the defined keys will be set on the `FeatureGate` being updated. */
  patch: FeatureGatePatch;
};

/** The output of our update `FeatureGate` mutation. */
export type UpdateFeatureGatePayload = {
  __typename: 'UpdateFeatureGatePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `FeatureGate` that was updated by this mutation. */
  featureGate?: Maybe<FeatureGate>;
  /** An edge for our `FeatureGate`. May be used by Relay 1. */
  featureGateEdge?: Maybe<FeatureGatesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `FeatureGate` mutation. */
export type UpdateFeatureGatePayloadfeatureGateEdgeArgs = {
  orderBy?: InputMaybe<Array<FeatureGatesOrderBy>>;
};

/** All input for the `updateInsuranceRecordByNodeId` mutation. */
export type UpdateInsuranceRecordByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `InsuranceRecord` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `InsuranceRecord` being updated. */
  patch: InsuranceRecordPatch;
};

/** All input for the `updateInsuranceRecord` mutation. */
export type UpdateInsuranceRecordInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** Integer Primary Key for record */
  insuranceRecordId: Scalars['Int'];
  /** An object where the defined keys will be set on the `InsuranceRecord` being updated. */
  patch: InsuranceRecordPatch;
};

/** The output of our update `InsuranceRecord` mutation. */
export type UpdateInsuranceRecordPayload = {
  __typename: 'UpdateInsuranceRecordPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `InsuranceRecord` that was updated by this mutation. */
  insuranceRecord?: Maybe<InsuranceRecord>;
  /** An edge for our `InsuranceRecord`. May be used by Relay 1. */
  insuranceRecordEdge?: Maybe<InsuranceRecordsEdge>;
  /** Reads a single `Patient` that is related to this `InsuranceRecord`. */
  patient?: Maybe<Patient>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `InsuranceRecord` mutation. */
export type UpdateInsuranceRecordPayloadinsuranceRecordEdgeArgs = {
  orderBy?: InputMaybe<Array<InsuranceRecordsOrderBy>>;
};

/** All input for the `updateMarketClinicByNodeId` mutation. */
export type UpdateMarketClinicByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `MarketClinic` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `MarketClinic` being updated. */
  patch: MarketClinicPatch;
};

/** All input for the `updateMarketClinic` mutation. */
export type UpdateMarketClinicInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  clinicId: Scalars['Int'];
  marketId: Scalars['Int'];
  /** An object where the defined keys will be set on the `MarketClinic` being updated. */
  patch: MarketClinicPatch;
};

/** The output of our update `MarketClinic` mutation. */
export type UpdateMarketClinicPayload = {
  __typename: 'UpdateMarketClinicPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Market` that is related to this `MarketClinic`. */
  market?: Maybe<Market>;
  /** The `MarketClinic` that was updated by this mutation. */
  marketClinic?: Maybe<MarketClinic>;
  /** An edge for our `MarketClinic`. May be used by Relay 1. */
  marketClinicEdge?: Maybe<MarketClinicsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `MarketClinic` mutation. */
export type UpdateMarketClinicPayloadmarketClinicEdgeArgs = {
  orderBy?: InputMaybe<Array<MarketClinicsOrderBy>>;
};

/** All input for the `updateMedicalDirectorByNodeId` mutation. */
export type UpdateMedicalDirectorByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `MedicalDirector` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `MedicalDirector` being updated. */
  patch: MedicalDirectorPatch;
};

/** All input for the `updateMedicalDirector` mutation. */
export type UpdateMedicalDirectorInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  medicalDirectorId: Scalars['Int'];
  /** An object where the defined keys will be set on the `MedicalDirector` being updated. */
  patch: MedicalDirectorPatch;
};

/** The output of our update `MedicalDirector` mutation. */
export type UpdateMedicalDirectorPayload = {
  __typename: 'UpdateMedicalDirectorPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `MedicalDirector` that was updated by this mutation. */
  medicalDirector?: Maybe<MedicalDirector>;
  /** An edge for our `MedicalDirector`. May be used by Relay 1. */
  medicalDirectorEdge?: Maybe<MedicalDirectorsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `MedicalDirector` mutation. */
export type UpdateMedicalDirectorPayloadmedicalDirectorEdgeArgs = {
  orderBy?: InputMaybe<Array<MedicalDirectorsOrderBy>>;
};

/** All input for the `updatePatientAttachmentByNodeId` mutation. */
export type UpdatePatientAttachmentByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `PatientAttachment` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `PatientAttachment` being updated. */
  patch: PatientAttachmentPatch;
};

/** All input for the `updatePatientAttachment` mutation. */
export type UpdatePatientAttachmentInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** An object where the defined keys will be set on the `PatientAttachment` being updated. */
  patch: PatientAttachmentPatch;
  patientAttachmentId: Scalars['Int'];
};

/** The output of our update `PatientAttachment` mutation. */
export type UpdatePatientAttachmentPayload = {
  __typename: 'UpdatePatientAttachmentPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Patient` that is related to this `PatientAttachment`. */
  patient?: Maybe<Patient>;
  /** The `PatientAttachment` that was updated by this mutation. */
  patientAttachment?: Maybe<PatientAttachment>;
  /** An edge for our `PatientAttachment`. May be used by Relay 1. */
  patientAttachmentEdge?: Maybe<PatientAttachmentsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `PatientAttachment` mutation. */
export type UpdatePatientAttachmentPayloadpatientAttachmentEdgeArgs = {
  orderBy?: InputMaybe<Array<PatientAttachmentsOrderBy>>;
};

/** All input for the `updatePatient` mutation. */
export type UpdatePatientInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  patch: PatientPatchRecordInput;
  patientId: Scalars['Int'];
};

/** All input for the `updatePatientNote` mutation. */
export type UpdatePatientNoteInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  patch: PatientNotePatchRecordInput;
  patientNoteId: Scalars['Int'];
};

/** The output of our `updatePatientNote` mutation. */
export type UpdatePatientNotePayload = {
  __typename: 'UpdatePatientNotePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Patient` that is related to this `PatientNote`. */
  patient?: Maybe<Patient>;
  patientNote?: Maybe<PatientNote>;
  /** An edge for our `PatientNote`. May be used by Relay 1. */
  patientNoteEdge?: Maybe<PatientNotesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `PatientNote`. */
  userByCreatedBy?: Maybe<User>;
};


/** The output of our `updatePatientNote` mutation. */
export type UpdatePatientNotePayloadpatientNoteEdgeArgs = {
  orderBy?: InputMaybe<Array<PatientNotesOrderBy>>;
};

/** The output of our `updatePatient` mutation. */
export type UpdatePatientPayload = {
  __typename: 'UpdatePatientPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  patient?: Maybe<Patient>;
  /** An edge for our `Patient`. May be used by Relay 1. */
  patientEdge?: Maybe<PatientsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our `updatePatient` mutation. */
export type UpdatePatientPayloadpatientEdgeArgs = {
  orderBy?: InputMaybe<Array<PatientsOrderBy>>;
};

/** All input for the `updatePhysicalExamByNodeId` mutation. */
export type UpdatePhysicalExamByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `PhysicalExam` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `PhysicalExam` being updated. */
  patch: PhysicalExamPatch;
};

/** All input for the `updatePhysicalExam` mutation. */
export type UpdatePhysicalExamInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** An object where the defined keys will be set on the `PhysicalExam` being updated. */
  patch: PhysicalExamPatch;
  physicalExamId: Scalars['Int'];
};

/** The output of our update `PhysicalExam` mutation. */
export type UpdatePhysicalExamPayload = {
  __typename: 'UpdatePhysicalExamPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `PhysicalExam` that was updated by this mutation. */
  physicalExam?: Maybe<PhysicalExam>;
  /** An edge for our `PhysicalExam`. May be used by Relay 1. */
  physicalExamEdge?: Maybe<PhysicalExamsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `PhysicalExam` mutation. */
export type UpdatePhysicalExamPayloadphysicalExamEdgeArgs = {
  orderBy?: InputMaybe<Array<PhysicalExamsOrderBy>>;
};

/** All input for the `updateResponderDeputyId` mutation. */
export type UpdateResponderDeputyIdInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  deputyId: Scalars['String'];
  userId: Scalars['Int'];
};

/** The output of our `UpdateResponderDeputyId` mutation. */
export type UpdateResponderDeputyIdPayload = {
  __typename: 'UpdateResponderDeputyIdPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  user?: Maybe<User>;
};

/** All input for the `UpdateStandingOrderInput` mutation. */
export type UpdateStandingOrderInput = {
  clinicianId?: InputMaybe<Scalars['Int']>;
  diagnosisCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  endedAt?: InputMaybe<Scalars['Datetime']>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  lookup?: InputMaybe<StandingOrderLookupInput>;
  name?: InputMaybe<Scalars['String']>;
  number?: InputMaybe<Scalars['String']>;
  orderUrl?: InputMaybe<Scalars['String']>;
  procedureCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  startedAt?: InputMaybe<Scalars['Datetime']>;
  state?: InputMaybe<StateEnum>;
  version?: InputMaybe<Scalars['String']>;
};

export type UpdateUserInput = {
  patch: UserPatchRecordInput;
  userId: Scalars['Int'];
};

export type UpdateUserPayload = {
  __typename: 'UpdateUserPayload';
  query?: Maybe<Query>;
  user?: Maybe<User>;
};

export type UpdateVideoConferenceInput = {
  meetingEndTime?: InputMaybe<Scalars['Date']>;
  meetingId: Scalars['BigInt'];
  meetingStartTime?: InputMaybe<Scalars['Date']>;
};

export type UpdateVideoConferencePayload = {
  __typename: 'UpdateVideoConferencePayload';
  query?: Maybe<Query>;
  videoConference?: Maybe<VideoConference>;
};

export type UpsertClinicianSignaturePayload = {
  __typename: 'UpsertClinicianSignaturePayload';
  clientMutationId?: Maybe<Scalars['String']>;
  encounter?: Maybe<Encounter>;
  encounterSignature?: Maybe<EncounterSignature>;
  query?: Maybe<Query>;
};

export type UpsertEncounterTaskAttachmentImageInput = {
  encounterTaskAttachmentId?: InputMaybe<Scalars['Int']>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  url?: InputMaybe<Scalars['String']>;
};

export type UpsertEncounterTaskAttachmentInput = {
  description?: InputMaybe<Scalars['String']>;
  images?: InputMaybe<Array<InputMaybe<UpsertEncounterTaskAttachmentImageInput>>>;
  isRequired?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<EncounterTaskAttachmentTypeEnum>;
};

export type UpsertEncounterTaskBillingDiagnosticsInput = {
  procedureCodeReferenceIds?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
};

export type UpsertEncounterTaskChiefComplaintAndHpiInput = {
  chiefComplaint?: InputMaybe<Scalars['String']>;
  historyOfPresentIllness?: InputMaybe<Scalars['String']>;
  reviewOfSystems?: InputMaybe<Array<InputMaybe<UpsertReviewOfSystemInput>>>;
};

export type UpsertEncounterTaskDispositionInput = {
  activation?: InputMaybe<ActivationEnum>;
  clinicianIncluded?: InputMaybe<Scalars['Boolean']>;
  disposition?: InputMaybe<DispositionEnum>;
  patientInstructions?: InputMaybe<Array<InputMaybe<UpsertPatientInstructionInput>>>;
};

export type UpsertEncounterTaskInput = {
  attachments?: InputMaybe<Array<InputMaybe<UpsertEncounterTaskAttachmentInput>>>;
  billingDiagnostics?: InputMaybe<UpsertEncounterTaskBillingDiagnosticsInput>;
  chiefComplaintAndHpi?: InputMaybe<UpsertEncounterTaskChiefComplaintAndHpiInput>;
  clinicianReviewedAt?: InputMaybe<Scalars['DateTime']>;
  correctionReason?: InputMaybe<Scalars['String']>;
  disposition?: InputMaybe<UpsertEncounterTaskDispositionInput>;
  encounterTaskId: Scalars['Int'];
  inProgressAt?: InputMaybe<Scalars['DateTime']>;
  medicalDecisionMaking?: InputMaybe<UpsertEncounterTaskMedicalDecisionMakingInput>;
  patientAllergy?: InputMaybe<Array<InputMaybe<UpsertEncounterTaskPatientAllergyInput>>>;
  patientProblem?: InputMaybe<Array<InputMaybe<UpsertEncounterTaskPatientProblemInput>>>;
  paymentMode?: InputMaybe<UpsertEncounterTaskPaymentModeInput>;
  physicalExam?: InputMaybe<UpsertEncounterTaskPhysicalExamInput>;
  pointOfCareTest?: InputMaybe<UpsertEncounterTaskPointOfCareTestInput>;
  progressNote?: InputMaybe<UpsertEncounterTaskProgressNoteInput>;
  responderCompletedAt?: InputMaybe<Scalars['DateTime']>;
  skippedReason?: InputMaybe<Scalars['String']>;
  systemLastUpdatedBy: SystemOfOriginEnum;
  telehealthMeeting?: InputMaybe<UpsertEncounterTaskTelehealthMeetingInput>;
  vaccine?: InputMaybe<UpsertEncounterTaskVaccineInput>;
  vital?: InputMaybe<Array<InputMaybe<UpsertEncounterTaskVital>>>;
};

export type UpsertEncounterTaskMedicalDecisionMakingInput = {
  diagnosisCodeReferenceIds?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  note?: InputMaybe<Scalars['String']>;
};

export type UpsertEncounterTaskPatientAllergyInput = {
  allergicCriticalityId?: InputMaybe<Scalars['Int']>;
  allergicReactionId?: InputMaybe<Scalars['Int']>;
  allergicSeverityId?: InputMaybe<Scalars['Int']>;
  allergicStatusId?: InputMaybe<Scalars['Int']>;
  allergyId?: InputMaybe<Scalars['Int']>;
  endedAt?: InputMaybe<Scalars['Datetime']>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  note?: InputMaybe<Scalars['String']>;
  patientAllergyId?: InputMaybe<Scalars['Int']>;
  startedAt?: InputMaybe<Scalars['Datetime']>;
};

export type UpsertEncounterTaskPatientProblemInput = {
  endedAt?: InputMaybe<Scalars['Datetime']>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  note?: InputMaybe<Scalars['String']>;
  patientProblemId?: InputMaybe<Scalars['Int']>;
  problemStatusId?: InputMaybe<Scalars['Int']>;
  problemText?: InputMaybe<Scalars['String']>;
  startedAt?: InputMaybe<Scalars['Datetime']>;
};

export type UpsertEncounterTaskPayload = {
  __typename: 'UpsertEncounterTaskPayload';
  encounterTask?: Maybe<EncounterTask>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

export type UpsertEncounterTaskPaymentModeInput = {
  paymentMode: EncounterPaymentModeEnum;
};

export type UpsertEncounterTaskPhysicalExamInput = {
  encounterTaskId: Scalars['Int'];
  note: Scalars['String'];
  physicalExamId?: InputMaybe<Scalars['Int']>;
};

export type UpsertEncounterTaskPointOfCareTestInput = {
  attestedAt?: InputMaybe<Scalars['DateTime']>;
  attestedByRole?: InputMaybe<UserRoleEnum>;
  clinicianFirstName?: InputMaybe<Scalars['String']>;
  clinicianLastName?: InputMaybe<Scalars['String']>;
  expirationDate?: InputMaybe<Scalars['Date']>;
  humidity?: InputMaybe<Scalars['Int']>;
  internalControlAcceptable?: InputMaybe<Scalars['Boolean']>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  lotNumber?: InputMaybe<Scalars['String']>;
  result?: InputMaybe<Scalars['String']>;
  standingOrderAddedAt?: InputMaybe<Scalars['Date']>;
  standingOrderId?: InputMaybe<Scalars['Int']>;
  temperature?: InputMaybe<Scalars['Float']>;
};

export type UpsertEncounterTaskProgressNoteInput = {
  encounterTaskId: Scalars['Int'];
  note: Scalars['String'];
  progressNoteId?: InputMaybe<Scalars['Int']>;
};

export type UpsertEncounterTaskTelehealthMeetingInput = {
  alternateConnectionMethod?: InputMaybe<TelehealthMeetingAlternateConnectionMethodEnum>;
  alternateConnectionReason?: InputMaybe<Scalars['String']>;
};

export type UpsertEncounterTaskVaccineInput = {
  adverseReactions?: InputMaybe<Array<InputMaybe<VaccineAdverseReactionEnum>>>;
  contraindication?: InputMaybe<Scalars['Boolean']>;
  doseNumber?: InputMaybe<Scalars['Int']>;
  hadAdverseReaction?: InputMaybe<Scalars['Boolean']>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  location?: InputMaybe<VaccineLocationEnum>;
  lotExpiration?: InputMaybe<Scalars['DateTime']>;
  lotNumber?: InputMaybe<Scalars['String']>;
  otherAdverseReactions?: InputMaybe<Scalars['String']>;
  standingOrderAddedAt?: InputMaybe<Scalars['Date']>;
  standingOrderId?: InputMaybe<Scalars['Int']>;
  totalDoses?: InputMaybe<Scalars['Int']>;
  vaccineLookupId?: InputMaybe<Scalars['Int']>;
  visEdition?: InputMaybe<Scalars['DateTime']>;
  visReceived?: InputMaybe<Scalars['Boolean']>;
};

export type UpsertEncounterTaskVital = {
  result: Scalars['String'];
  vitalLookupType: VitalLookupTypeEnum;
};

export type UpsertMarketsInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  markets: Array<InputMaybe<SaveMarketInput>>;
};

export type UpsertMarketsPayload = {
  __typename: 'UpsertMarketsPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  markets?: Maybe<Array<Maybe<Market>>>;
  query?: Maybe<Query>;
};

export type UpsertPatientInstructionInput = {
  careInstructions?: InputMaybe<Scalars['String']>;
  excusedUntilDate?: InputMaybe<Scalars['Datetime']>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  levelOfCare?: InputMaybe<PatientInstructionLevelOfCareEnum>;
  levelOfCareOther?: InputMaybe<Scalars['String']>;
  medicalRestrictions?: InputMaybe<Scalars['String']>;
  patientInstructionId?: InputMaybe<Scalars['Int']>;
  relevantPastMedicalHistory?: InputMaybe<Scalars['String']>;
  timeframeUnit?: InputMaybe<PatientInstructionTimeframeEnum>;
  timeframeValue?: InputMaybe<Scalars['Int']>;
  type?: InputMaybe<PatientInstructionTypeEnum>;
};

export type UpsertResponderSignaturePayload = {
  __typename: 'UpsertResponderSignaturePayload';
  clientMutationId?: Maybe<Scalars['String']>;
  encounter?: Maybe<Encounter>;
  encounterSignature?: Maybe<EncounterSignature>;
  query?: Maybe<Query>;
};

export type UpsertReviewOfSystemEvaluationInput = {
  key: Scalars['String'];
  value: Scalars['Boolean'];
};

export type UpsertReviewOfSystemInput = {
  systems: Array<InputMaybe<UpsertReviewOfSystemSystemInput>>;
  template: ReviewOfSystemTemplateEnum;
};

export type UpsertReviewOfSystemSystemInput = {
  evaluations: Array<InputMaybe<UpsertReviewOfSystemEvaluationInput>>;
  note?: InputMaybe<Scalars['String']>;
  system: ReviewOfSystemSystemEnum;
};

/** All input for the `upsertUsers` mutation. */
export type UpsertUsersInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  userProfiles: Array<InputMaybe<UserProfileInput>>;
};

/** The output of our `upsertUsers` mutation. */
export type UpsertUsersPayload = {
  __typename: 'UpsertUsersPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

export type UpsertZipcodesInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  zipcodes: Array<InputMaybe<SaveZipcodeInput>>;
};

export type UpsertZipcodesPayload = {
  __typename: 'UpsertZipcodesPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  query?: Maybe<Query>;
  zipcodes?: Maybe<Array<Maybe<Zipcode>>>;
};

export type UpsertZoneZipcodeInput = {
  zipCodes: Array<InputMaybe<Scalars['ZipCode']>>;
  zoneId: Scalars['Int'];
};

export type UpsertZoneZipcodePayload = {
  __typename: 'UpsertZoneZipcodePayload';
  code?: Maybe<Scalars['String']>;
  zoneZipcodes?: Maybe<Array<Maybe<ZoneZipcode>>>;
};

export type UpsertZonesInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  zones: Array<InputMaybe<SaveZoneInput>>;
};

export type UpsertZonesPayload = {
  __typename: 'UpsertZonesPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  query?: Maybe<Query>;
  zones?: Maybe<Array<Maybe<Zone>>>;
};

/** Contains information about the user relation. */
export type User = Node & {
  __typename: 'User';
  /** Reads and enables pagination through a set of `Appointment`. */
  appointmentsByCreatedBy: AppointmentsConnection;
  /** Reads and enables pagination through a set of `Appointment`. */
  appointmentsByCreatedByList: Array<Appointment>;
  /** Reads a single `CerRole` that is related to this `User`. */
  cerRole?: Maybe<CerRole>;
  /**
   * Reads and enables pagination through a set of `CerRole`.
   * @deprecated Please use cerRole instead
   */
  cerRoles: CerRolesConnection;
  /** Reads a single `ClinicianRole` that is related to this `User`. */
  clinicianRole?: Maybe<ClinicianRole>;
  /**
   * Reads and enables pagination through a set of `ClinicianRole`.
   * @deprecated Please use clinicianRole instead
   */
  clinicianRoles: ClinicianRolesConnection;
  createdAt?: Maybe<Scalars['Datetime']>;
  credentials?: Maybe<Array<Maybe<CredentialsEnum>>>;
  deletedAt?: Maybe<Scalars['Datetime']>;
  dob?: Maybe<Scalars['Date']>;
  /** Only one email address can be active at a time, but email addresses can be re-used within the organization. */
  email?: Maybe<Scalars['String']>;
  /** Unique Employee ID that maps to the user Google ID. */
  employeeId?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  fullName?: Maybe<Scalars['String']>;
  gender?: Maybe<Scalars['String']>;
  isCer?: Maybe<Scalars['Boolean']>;
  /** Computed column on the user relation to indicate if user is clinician. */
  isClinician?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  /** Computed column on the user relation to indicate if user is it. */
  isIt?: Maybe<Scalars['Boolean']>;
  /** Computed column on the user relation to indicate if user has ops role. */
  isOps?: Maybe<Scalars['Boolean']>;
  isOutreach?: Maybe<Scalars['Boolean']>;
  /** Computed column on the user relation to indicate if user is responder. */
  isResponder?: Maybe<Scalars['Boolean']>;
  isSupervisor?: Maybe<Scalars['Boolean']>;
  /** Reads a single `ItRole` that is related to this `User`. */
  itRole?: Maybe<ItRole>;
  /**
   * Reads and enables pagination through a set of `ItRole`.
   * @deprecated Please use itRole instead
   */
  itRoles: ItRolesConnection;
  languages?: Maybe<Array<Maybe<LanguagesEnum>>>;
  lastLoginAt?: Maybe<Scalars['Datetime']>;
  lastName?: Maybe<Scalars['String']>;
  loginsCount?: Maybe<Scalars['Int']>;
  /** Reads and enables pagination through a set of `Market`. */
  marketsByAppointmentCreatedByAndMarketId: UserMarketsByAppointmentCreatedByAndMarketIdManyToManyConnection;
  /** Reads and enables pagination through a set of `Market`. */
  marketsByAppointmentCreatedByAndMarketIdList: Array<Market>;
  /** Meta column describing the data source from which the record migrated from. Default is null. */
  migrationSource?: Maybe<Scalars['String']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  npi?: Maybe<Scalars['String']>;
  /** Reads a single `OpsRole` that is related to this `User`. */
  opsRole?: Maybe<OpsRole>;
  /**
   * Reads and enables pagination through a set of `OpsRole`.
   * @deprecated Please use opsRole instead
   */
  opsRoles: OpsRolesConnection;
  /** Reads a single `OutreachRole` that is related to this `User`. */
  outreachRole?: Maybe<OutreachRole>;
  /**
   * Reads and enables pagination through a set of `OutreachRole`.
   * @deprecated Please use outreachRole instead
   */
  outreachRoles: OutreachRolesConnection;
  /** Reads and enables pagination through a set of `PatientNote`. */
  patientNotesByCreatedBy: PatientNotesConnection;
  /** Reads and enables pagination through a set of `PatientNote`. */
  patientNotesByCreatedByList: Array<PatientNote>;
  /** Reads and enables pagination through a set of `Patient`. */
  patientsByPatientNoteCreatedByAndPatientId: UserPatientsByPatientNoteCreatedByAndPatientIdManyToManyConnection;
  /** Reads and enables pagination through a set of `Patient`. */
  patientsByPatientNoteCreatedByAndPatientIdList: Array<Patient>;
  profilePictureUrl?: Maybe<Scalars['String']>;
  registeredFirstName?: Maybe<Scalars['String']>;
  registeredLastName?: Maybe<Scalars['String']>;
  /** Reads a single `ResponderRole` that is related to this `User`. */
  responderRole?: Maybe<ResponderRole>;
  /**
   * Reads and enables pagination through a set of `ResponderRole`.
   * @deprecated Please use responderRole instead
   */
  responderRoles: ResponderRolesConnection;
  roles: Array<UserRoleEnum>;
  /** Reads a single `SupervisorRole` that is related to this `User`. */
  supervisorRole?: Maybe<SupervisorRole>;
  /**
   * Reads and enables pagination through a set of `SupervisorRole`.
   * @deprecated Please use supervisorRole instead
   */
  supervisorRoles: SupervisorRolesConnection;
  updatedAt?: Maybe<Scalars['Datetime']>;
  /** Id is the primary key, auto-incrementing integer. */
  userId: Scalars['Int'];
  userIdentifiersList?: Maybe<Array<Maybe<UserIdentifier>>>;
  userMarketsList?: Maybe<Array<Maybe<Market>>>;
  /** Reads and enables pagination through a set of `UserPatient`. */
  userPatients: UserPatientsConnection;
  /** Reads and enables pagination through a set of `UserPatient`. */
  userPatientsList: Array<UserPatient>;
  userUuid: Scalars['UUID'];
};


/** Contains information about the user relation. */
export type UserappointmentsByCreatedByArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<AppointmentCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AppointmentsOrderBy>>;
};


/** Contains information about the user relation. */
export type UserappointmentsByCreatedByListArgs = {
  condition?: InputMaybe<AppointmentCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AppointmentsOrderBy>>;
};


/** Contains information about the user relation. */
export type UsercerRolesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<CerRoleCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CerRolesOrderBy>>;
};


/** Contains information about the user relation. */
export type UserclinicianRolesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ClinicianRoleCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ClinicianRolesOrderBy>>;
};


/** Contains information about the user relation. */
export type UseritRolesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ItRoleCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ItRolesOrderBy>>;
};


/** Contains information about the user relation. */
export type UsermarketsByAppointmentCreatedByAndMarketIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<MarketCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<MarketsOrderBy>>;
};


/** Contains information about the user relation. */
export type UsermarketsByAppointmentCreatedByAndMarketIdListArgs = {
  condition?: InputMaybe<MarketCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<MarketsOrderBy>>;
};


/** Contains information about the user relation. */
export type UseropsRolesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<OpsRoleCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<OpsRolesOrderBy>>;
};


/** Contains information about the user relation. */
export type UseroutreachRolesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<OutreachRoleCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<OutreachRolesOrderBy>>;
};


/** Contains information about the user relation. */
export type UserpatientNotesByCreatedByArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<PatientNoteCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PatientNotesOrderBy>>;
};


/** Contains information about the user relation. */
export type UserpatientNotesByCreatedByListArgs = {
  condition?: InputMaybe<PatientNoteCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PatientNotesOrderBy>>;
};


/** Contains information about the user relation. */
export type UserpatientsByPatientNoteCreatedByAndPatientIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<PatientCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PatientsOrderBy>>;
};


/** Contains information about the user relation. */
export type UserpatientsByPatientNoteCreatedByAndPatientIdListArgs = {
  condition?: InputMaybe<PatientCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PatientsOrderBy>>;
};


/** Contains information about the user relation. */
export type UserresponderRolesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ResponderRoleCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ResponderRolesOrderBy>>;
};


/** Contains information about the user relation. */
export type UsersupervisorRolesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<SupervisorRoleCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<SupervisorRolesOrderBy>>;
};


/** Contains information about the user relation. */
export type UseruserPatientsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<UserPatientCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserPatientsOrderBy>>;
};


/** Contains information about the user relation. */
export type UseruserPatientsListArgs = {
  condition?: InputMaybe<UserPatientCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserPatientsOrderBy>>;
};

/** A condition to be used against `User` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type UserCondition = {
  /** Checks for equality with the object’s `employeeId` field. */
  employeeId?: InputMaybe<Scalars['String']>;
  /** Filters to records matching isDeleted */
  isDeleted?: InputMaybe<Array<Scalars['Boolean']>>;
  /** Checks for equality with the object’s `migrationSource` field. */
  migrationSource?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `userUuid` field. */
  userUuid?: InputMaybe<Scalars['UUID']>;
};

/** Contains information about the mapping between ReadyCore user table and identifiers */
export type UserIdentifier = {
  __typename: 'UserIdentifier';
  endedAt?: Maybe<Scalars['Datetime']>;
  identifier: Scalars['String'];
  identifierType: IdentifierTypeEnum;
  isDeleted: Scalars['Boolean'];
  startedAt: Scalars['Datetime'];
  /** Reads a single `User` that is related to this `UserIdentifier`. */
  user?: Maybe<User>;
  userId: Scalars['Int'];
  userIdentifierId: Scalars['Int'];
};

/** Contains information about the mapping between ReadyCore user table and markets */
export type UserMarket = {
  __typename: 'UserMarket';
  isDeleted: Scalars['Boolean'];
  marketId: Scalars['Int'];
  updatedAt: Scalars['Datetime'];
  updatedBy?: Maybe<Scalars['Int']>;
  userId: Scalars['Int'];
  userMarketId: Scalars['Int'];
};

/** A connection to a list of `Market` values, with data from `Appointment`. */
export type UserMarketsByAppointmentCreatedByAndMarketIdManyToManyConnection = {
  __typename: 'UserMarketsByAppointmentCreatedByAndMarketIdManyToManyConnection';
  /** A list of edges which contains the `Market`, info from the `Appointment`, and the cursor to aid in pagination. */
  edges: Array<UserMarketsByAppointmentCreatedByAndMarketIdManyToManyEdge>;
  /** A list of `Market` objects. */
  nodes: Array<Market>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Market` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Market` edge in the connection, with data from `Appointment`. */
export type UserMarketsByAppointmentCreatedByAndMarketIdManyToManyEdge = {
  __typename: 'UserMarketsByAppointmentCreatedByAndMarketIdManyToManyEdge';
  /** Reads and enables pagination through a set of `Appointment`. */
  appointments: AppointmentsConnection;
  /** Reads and enables pagination through a set of `Appointment`. */
  appointmentsList: Array<Appointment>;
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `Market` at the end of the edge. */
  node: Market;
};


/** A `Market` edge in the connection, with data from `Appointment`. */
export type UserMarketsByAppointmentCreatedByAndMarketIdManyToManyEdgeappointmentsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<AppointmentCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AppointmentsOrderBy>>;
};


/** A `Market` edge in the connection, with data from `Appointment`. */
export type UserMarketsByAppointmentCreatedByAndMarketIdManyToManyEdgeappointmentsListArgs = {
  condition?: InputMaybe<AppointmentCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AppointmentsOrderBy>>;
};

/** A connection to a list of `UserMarket` values. */
export type UserMarketsConnection = {
  __typename: 'UserMarketsConnection';
  /** A list of edges which contains the `UserMarket` and cursor to aid in pagination. */
  edges: Array<UserMarketsEdge>;
  /** A list of `UserMarket` objects. */
  nodes: Array<UserMarket>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `UserMarket` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `UserMarket` edge in the connection. */
export type UserMarketsEdge = {
  __typename: 'UserMarketsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `UserMarket` at the end of the edge. */
  node: UserMarket;
};

/** Methods to use when ordering `UserMarket`. */
export enum UserMarketsOrderBy {
  NATURAL = 'NATURAL'
}

export type UserPatchRecordInput = {
  credentials?: InputMaybe<Array<InputMaybe<CredentialsEnum>>>;
  dob?: InputMaybe<Scalars['Date']>;
  markets?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  npi?: InputMaybe<Scalars['String']>;
  registeredFirstName?: InputMaybe<Scalars['String']>;
  registeredLastName?: InputMaybe<Scalars['String']>;
};

/** Contains information about the mapping between ReadyCore user table and patient table */
export type UserPatient = Node & {
  __typename: 'UserPatient';
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  patientId: Scalars['Int'];
  /** Reads a single `User` that is related to this `UserPatient`. */
  user?: Maybe<User>;
  userId: Scalars['Int'];
};

/**
 * A condition to be used against `UserPatient` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type UserPatientCondition = {
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars['Int']>;
};

/** A connection to a list of `Patient` values, with data from `PatientNote`. */
export type UserPatientsByPatientNoteCreatedByAndPatientIdManyToManyConnection = {
  __typename: 'UserPatientsByPatientNoteCreatedByAndPatientIdManyToManyConnection';
  /** A list of edges which contains the `Patient`, info from the `PatientNote`, and the cursor to aid in pagination. */
  edges: Array<UserPatientsByPatientNoteCreatedByAndPatientIdManyToManyEdge>;
  /** A list of `Patient` objects. */
  nodes: Array<Patient>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Patient` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Patient` edge in the connection, with data from `PatientNote`. */
export type UserPatientsByPatientNoteCreatedByAndPatientIdManyToManyEdge = {
  __typename: 'UserPatientsByPatientNoteCreatedByAndPatientIdManyToManyEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `Patient` at the end of the edge. */
  node: Patient;
  /** Reads and enables pagination through a set of `PatientNote`. */
  patientNotes: PatientNotesConnection;
  /** Reads and enables pagination through a set of `PatientNote`. */
  patientNotesList: Array<PatientNote>;
};


/** A `Patient` edge in the connection, with data from `PatientNote`. */
export type UserPatientsByPatientNoteCreatedByAndPatientIdManyToManyEdgepatientNotesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<PatientNoteCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PatientNotesOrderBy>>;
};


/** A `Patient` edge in the connection, with data from `PatientNote`. */
export type UserPatientsByPatientNoteCreatedByAndPatientIdManyToManyEdgepatientNotesListArgs = {
  condition?: InputMaybe<PatientNoteCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PatientNotesOrderBy>>;
};

/** A connection to a list of `UserPatient` values. */
export type UserPatientsConnection = {
  __typename: 'UserPatientsConnection';
  /** A list of edges which contains the `UserPatient` and cursor to aid in pagination. */
  edges: Array<UserPatientsEdge>;
  /** A list of `UserPatient` objects. */
  nodes: Array<UserPatient>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `UserPatient` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `UserPatient` edge in the connection. */
export type UserPatientsEdge = {
  __typename: 'UserPatientsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `UserPatient` at the end of the edge. */
  node: UserPatient;
};

/** Methods to use when ordering `UserPatient`. */
export enum UserPatientsOrderBy {
  NATURAL = 'NATURAL',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  USER_ID_ASC = 'USER_ID_ASC',
  USER_ID_DESC = 'USER_ID_DESC'
}

/** An input for mutations affecting `UserProfile` */
export type UserProfileInput = {
  email?: InputMaybe<Scalars['String']>;
  employeeId?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  lastLoginAt?: InputMaybe<Scalars['Datetime']>;
  lastName?: InputMaybe<Scalars['String']>;
  loginsCount?: InputMaybe<Scalars['Int']>;
  profilePictureUrl?: InputMaybe<Scalars['String']>;
};

export enum UserRoleEnum {
  CLINICIAN = 'CLINICIAN',
  IT = 'IT',
  RESPONDER = 'RESPONDER',
  SUPERVISOR = 'SUPERVISOR'
}

/** A connection to a list of `User` values. */
export type UsersConnection = {
  __typename: 'UsersConnection';
  /** A list of edges which contains the `User` and cursor to aid in pagination. */
  edges: Array<UsersEdge>;
  /** A list of `User` objects. */
  nodes: Array<User>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `User` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `User` edge in the connection. */
export type UsersEdge = {
  __typename: 'UsersEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `User` at the end of the edge. */
  node: User;
};

/** Methods to use when ordering `User`. */
export enum UsersOrderBy {
  EMAIL_ASC = 'EMAIL_ASC',
  EMAIL_DESC = 'EMAIL_DESC',
  EMPLOYEE_ID_ASC = 'EMPLOYEE_ID_ASC',
  EMPLOYEE_ID_DESC = 'EMPLOYEE_ID_DESC',
  MIGRATION_SOURCE_ASC = 'MIGRATION_SOURCE_ASC',
  MIGRATION_SOURCE_DESC = 'MIGRATION_SOURCE_DESC',
  NATURAL = 'NATURAL',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  USER_ID_ASC = 'USER_ID_ASC',
  USER_ID_DESC = 'USER_ID_DESC',
  USER_UUID_ASC = 'USER_UUID_ASC',
  USER_UUID_DESC = 'USER_UUID_DESC'
}

export type VRedoxPatientExport = {
  __typename: 'VRedoxPatientExport';
  addendum?: Maybe<Scalars['String']>;
  appointmentId?: Maybe<Scalars['Int']>;
  cptCode1?: Maybe<Scalars['String']>;
  cptCode2?: Maybe<Scalars['String']>;
  cptCode3?: Maybe<Scalars['String']>;
  cptCode4?: Maybe<Scalars['String']>;
  cptCode5?: Maybe<Scalars['String']>;
  disposition?: Maybe<DispositionEnum>;
  doctorname?: Maybe<Scalars['String']>;
  doctornpinumber?: Maybe<Scalars['String']>;
  dosagefrequencydescription?: Maybe<Scalars['String']>;
  druginfo?: Maybe<Scalars['String']>;
  encounterId?: Maybe<Scalars['Int']>;
  hpi?: Maybe<Scalars['String']>;
  icd10RegexMatches?: Maybe<Scalars['String']>;
  instructionFreetext?: Maybe<Scalars['String']>;
  mdm?: Maybe<Scalars['String']>;
  medhistorydosage?: Maybe<Scalars['String']>;
  medhistorydrug?: Maybe<Scalars['String']>;
  medhistoryfreq?: Maybe<Scalars['String']>;
  medhistoryndc?: Maybe<Scalars['String']>;
  medicalConditions?: Maybe<Scalars['String']>;
  ndcid?: Maybe<Scalars['String']>;
  patientfriendlysig?: Maybe<Scalars['String']>;
  prescriptiondate?: Maybe<Scalars['String']>;
  referraltext?: Maybe<Scalars['String']>;
  rosCardiovascularAnswer?: Maybe<Scalars['String']>;
  rosConstitutionalAnswer?: Maybe<Scalars['String']>;
  rosCovidAnswer?: Maybe<Scalars['String']>;
  rosEndocrineAnswer?: Maybe<Scalars['String']>;
  rosEntAnswer?: Maybe<Scalars['String']>;
  rosGastroAnswer?: Maybe<Scalars['String']>;
  rosGenitourinaryAnswer?: Maybe<Scalars['String']>;
  rosHemelymphAnswer?: Maybe<Scalars['String']>;
  rosMusculoskeletalAnswer?: Maybe<Scalars['String']>;
  rosNeurologicalAnswer?: Maybe<Scalars['String']>;
  rosObgynAnswer?: Maybe<Scalars['String']>;
  rosPsychAnswer?: Maybe<Scalars['String']>;
  rosRespiratoryAnswer?: Maybe<Scalars['String']>;
  rosSkinAnswer?: Maybe<Scalars['String']>;
  route?: Maybe<Scalars['String']>;
  socialHistoryAnswer?: Maybe<Scalars['String']>;
  socialHistoryQuestion?: Maybe<Scalars['String']>;
  visitDiagnosis?: Maybe<Scalars['String']>;
  visitDiagnosisDescription?: Maybe<Scalars['String']>;
};

/** A connection to a list of `VRedoxPatientExport` values. */
export type VRedoxPatientExportsConnection = {
  __typename: 'VRedoxPatientExportsConnection';
  /** A list of edges which contains the `VRedoxPatientExport` and cursor to aid in pagination. */
  edges: Array<VRedoxPatientExportsEdge>;
  /** A list of `VRedoxPatientExport` objects. */
  nodes: Array<VRedoxPatientExport>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `VRedoxPatientExport` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `VRedoxPatientExport` edge in the connection. */
export type VRedoxPatientExportsEdge = {
  __typename: 'VRedoxPatientExportsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `VRedoxPatientExport` at the end of the edge. */
  node: VRedoxPatientExport;
};

/** Methods to use when ordering `VRedoxPatientExport`. */
export enum VRedoxPatientExportsOrderBy {
  NATURAL = 'NATURAL'
}

/** Contains information about administered vaccines. */
export type Vaccine = Node & {
  __typename: 'Vaccine';
  adverseReactions?: Maybe<Array<Maybe<VaccineAdverseReactionEnum>>>;
  contraindication?: Maybe<Scalars['Boolean']>;
  createdAt: Scalars['Datetime'];
  doseNumber?: Maybe<Scalars['Int']>;
  encounterId: Scalars['Int'];
  /** Reads a single `EncounterTask` that is related to this `Vaccine`. */
  encounterTask?: Maybe<EncounterTask>;
  encounterTaskId: Scalars['Int'];
  hadAdverseReaction?: Maybe<Scalars['Boolean']>;
  isDeleted: Scalars['Boolean'];
  location?: Maybe<VaccineLocationEnum>;
  lotExpiration?: Maybe<Scalars['Date']>;
  lotNumber?: Maybe<Scalars['String']>;
  migrationSource?: Maybe<Scalars['String']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  orderedBy?: Maybe<Scalars['Int']>;
  otherAdverseReactions?: Maybe<Scalars['String']>;
  patientId: Scalars['Int'];
  standingOrder?: Maybe<StandingOrder>;
  standingOrderAddedAt?: Maybe<Scalars['Datetime']>;
  standingOrderId?: Maybe<Scalars['Int']>;
  systemLastUpdatedBy: SystemOfOriginEnum;
  totalDoses?: Maybe<Scalars['Int']>;
  updatedAt: Scalars['Datetime'];
  vaccineId: Scalars['Int'];
  vaccineLookupId: Scalars['Int'];
  visEdition?: Maybe<Scalars['Date']>;
  visReceived?: Maybe<Scalars['Boolean']>;
};

export enum VaccineAdverseReactionEnum {
  ALTERED_LEVEL_OF_CONSCIOUSNESS = 'ALTERED_LEVEL_OF_CONSCIOUSNESS',
  FACIAL_SWELLING = 'FACIAL_SWELLING',
  FEVER = 'FEVER',
  IRRITABILITY = 'IRRITABILITY',
  OTHER = 'OTHER',
  PAIN_AT_INJECTION_SITE = 'PAIN_AT_INJECTION_SITE',
  RASH = 'RASH',
  REDNESS_AT_INJECTION_SITE = 'REDNESS_AT_INJECTION_SITE',
  SHORTNESS_OF_BREATH = 'SHORTNESS_OF_BREATH',
  SWELLING_AT_INJECTION_SITE = 'SWELLING_AT_INJECTION_SITE',
  SYNCOPE = 'SYNCOPE'
}

export enum VaccineCategoryEnum {
  COVID = 'COVID',
  FLU = 'FLU'
}

/** A condition to be used against `Vaccine` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type VaccineCondition = {
  /** Checks for equality with the object’s `encounterTaskId` field. */
  encounterTaskId?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `migrationSource` field. */
  migrationSource?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `vaccineId` field. */
  vaccineId?: InputMaybe<Scalars['Int']>;
};

export enum VaccineLocationEnum {
  LEFT_ANTEROLATERAL_THIGH_MUSCLE = 'LEFT_ANTEROLATERAL_THIGH_MUSCLE',
  LEFT_DELTOID_MUSCLE = 'LEFT_DELTOID_MUSCLE',
  RIGHT_ANTEROLATERAL_THIGH_MUSCLE = 'RIGHT_ANTEROLATERAL_THIGH_MUSCLE',
  RIGHT_DELTOID_MUSCLE = 'RIGHT_DELTOID_MUSCLE'
}

/** Contains lookup information about vaccines and their related drug.. */
export type VaccineLookup = Node & {
  __typename: 'VaccineLookup';
  createdAt: Scalars['Datetime'];
  doseQuantity: Scalars['BigFloat'];
  doseUnits: Scalars['String'];
  drug?: Maybe<Drug>;
  drugId: Scalars['Int'];
  isDeleted: Scalars['Boolean'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  standingOrders?: Maybe<Array<Maybe<StandingOrder>>>;
  vaccineCategory: VaccineCategoryEnum;
  vaccineCode: Scalars['String'];
  vaccineCodeSystem: Scalars['String'];
  vaccineLookupId: Scalars['Int'];
  vaccineName: Scalars['String'];
};

/**
 * A condition to be used against `VaccineLookup` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type VaccineLookupCondition = {
  /** Checks for equality with the object’s `vaccineCode` field. */
  vaccineCode?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `vaccineLookupId` field. */
  vaccineLookupId?: InputMaybe<Scalars['Int']>;
};

/** A connection to a list of `VaccineLookup` values. */
export type VaccineLookupsConnection = {
  __typename: 'VaccineLookupsConnection';
  /** A list of edges which contains the `VaccineLookup` and cursor to aid in pagination. */
  edges: Array<VaccineLookupsEdge>;
  /** A list of `VaccineLookup` objects. */
  nodes: Array<VaccineLookup>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `VaccineLookup` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `VaccineLookup` edge in the connection. */
export type VaccineLookupsEdge = {
  __typename: 'VaccineLookupsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `VaccineLookup` at the end of the edge. */
  node: VaccineLookup;
};

/** Methods to use when ordering `VaccineLookup`. */
export enum VaccineLookupsOrderBy {
  NATURAL = 'NATURAL',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  VACCINE_CODE_ASC = 'VACCINE_CODE_ASC',
  VACCINE_CODE_DESC = 'VACCINE_CODE_DESC',
  VACCINE_LOOKUP_ID_ASC = 'VACCINE_LOOKUP_ID_ASC',
  VACCINE_LOOKUP_ID_DESC = 'VACCINE_LOOKUP_ID_DESC'
}

/** A connection to a list of `Vaccine` values. */
export type VaccinesConnection = {
  __typename: 'VaccinesConnection';
  /** A list of edges which contains the `Vaccine` and cursor to aid in pagination. */
  edges: Array<VaccinesEdge>;
  /** A list of `Vaccine` objects. */
  nodes: Array<Vaccine>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Vaccine` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Vaccine` edge in the connection. */
export type VaccinesEdge = {
  __typename: 'VaccinesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `Vaccine` at the end of the edge. */
  node: Vaccine;
};

/** Methods to use when ordering `Vaccine`. */
export enum VaccinesOrderBy {
  ENCOUNTER_TASK_ID_ASC = 'ENCOUNTER_TASK_ID_ASC',
  ENCOUNTER_TASK_ID_DESC = 'ENCOUNTER_TASK_ID_DESC',
  MIGRATION_SOURCE_ASC = 'MIGRATION_SOURCE_ASC',
  MIGRATION_SOURCE_DESC = 'MIGRATION_SOURCE_DESC',
  NATURAL = 'NATURAL',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  VACCINE_ID_ASC = 'VACCINE_ID_ASC',
  VACCINE_ID_DESC = 'VACCINE_ID_DESC'
}

/** Contains data related to Video Conference */
export type VideoConference = Node & {
  __typename: 'VideoConference';
  createdAt: Scalars['Datetime'];
  deletedAt?: Maybe<Scalars['Datetime']>;
  hostUrl: Scalars['String'];
  isDeleted: Scalars['Boolean'];
  meetingEndTime?: Maybe<Scalars['Datetime']>;
  meetingId: Scalars['BigInt'];
  meetingStartTime?: Maybe<Scalars['Datetime']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  participantUrl: Scalars['String'];
  /** calculates the video_conference status based off the set timestamp fields */
  status?: Maybe<VideoConferenceStatusEnum>;
  updatedAt: Scalars['Datetime'];
  videoConferenceId: Scalars['Int'];
};

/**
 * A condition to be used against `VideoConference` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type VideoConferenceCondition = {
  /** Checks for equality with the object’s `meetingId` field. */
  meetingId?: InputMaybe<Scalars['BigInt']>;
  /** Checks for equality with the object’s `videoConferenceId` field. */
  videoConferenceId?: InputMaybe<Scalars['Int']>;
};

export enum VideoConferenceStatusEnum {
  COMPLETED = 'COMPLETED',
  IN_PROGRESS = 'IN_PROGRESS',
  PENDING = 'PENDING'
}

/** A connection to a list of `VideoConference` values. */
export type VideoConferencesConnection = {
  __typename: 'VideoConferencesConnection';
  /** A list of edges which contains the `VideoConference` and cursor to aid in pagination. */
  edges: Array<VideoConferencesEdge>;
  /** A list of `VideoConference` objects. */
  nodes: Array<VideoConference>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `VideoConference` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `VideoConference` edge in the connection. */
export type VideoConferencesEdge = {
  __typename: 'VideoConferencesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `VideoConference` at the end of the edge. */
  node: VideoConference;
};

/** Methods to use when ordering `VideoConference`. */
export enum VideoConferencesOrderBy {
  MEETING_ID_ASC = 'MEETING_ID_ASC',
  MEETING_ID_DESC = 'MEETING_ID_DESC',
  NATURAL = 'NATURAL',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  VIDEO_CONFERENCE_ID_ASC = 'VIDEO_CONFERENCE_ID_ASC',
  VIDEO_CONFERENCE_ID_DESC = 'VIDEO_CONFERENCE_ID_DESC'
}

/** Contains information about the ReadyCore vital table */
export type Vital = Node & {
  __typename: 'Vital';
  createdAt: Scalars['Datetime'];
  encounterId?: Maybe<Scalars['Int']>;
  /** Reads a single `EncounterTask` that is related to this `Vital`. */
  encounterTask?: Maybe<EncounterTask>;
  encounterTaskId: Scalars['Int'];
  migrationSource?: Maybe<Scalars['String']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  patientId?: Maybe<Scalars['Int']>;
  result: Scalars['String'];
  systemLastUpdatedBy: SystemOfOriginEnum;
  updatedAt: Scalars['Datetime'];
  vitalId: Scalars['Int'];
  /** Reads a single `VitalLookup` that is related to this `Vital`. */
  vitalLookup?: Maybe<VitalLookup>;
  vitalLookupId: Scalars['Int'];
};

export enum VitalCategoryEnum {
  ADDITIONAL_SET = 'ADDITIONAL_SET',
  FIRST_SET = 'FIRST_SET'
}

/** A condition to be used against `Vital` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type VitalCondition = {
  /** Checks for equality with the object’s `encounterTaskId` field. */
  encounterTaskId?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `migrationSource` field. */
  migrationSource?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `vitalId` field. */
  vitalId?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `vitalLookupId` field. */
  vitalLookupId?: InputMaybe<Scalars['Int']>;
};

/** Contains information about the ReadyCore vital_lookup table */
export type VitalLookup = Node & {
  __typename: 'VitalLookup';
  code?: Maybe<Scalars['String']>;
  createdAt: Scalars['Datetime'];
  /** Reads and enables pagination through a set of `EncounterTask`. */
  encounterTasksByVitalVitalLookupIdAndEncounterTaskId: VitalLookupEncounterTasksByVitalVitalLookupIdAndEncounterTaskIdManyToManyConnection;
  /** Reads and enables pagination through a set of `EncounterTask`. */
  encounterTasksByVitalVitalLookupIdAndEncounterTaskIdList: Array<EncounterTask>;
  isDeleted: Scalars['Boolean'];
  name?: Maybe<Scalars['String']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  system?: Maybe<Scalars['String']>;
  unit?: Maybe<Scalars['String']>;
  vitalCategory: VitalCategoryEnum;
  vitalLookupId: Scalars['Int'];
  vitalType: VitalLookupTypeEnum;
  /** Reads and enables pagination through a set of `Vital`. */
  vitals: VitalsConnection;
  /** Reads and enables pagination through a set of `Vital`. */
  vitalsList: Array<Vital>;
};


/** Contains information about the ReadyCore vital_lookup table */
export type VitalLookupencounterTasksByVitalVitalLookupIdAndEncounterTaskIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<EncounterTaskCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EncounterTasksOrderBy>>;
};


/** Contains information about the ReadyCore vital_lookup table */
export type VitalLookupencounterTasksByVitalVitalLookupIdAndEncounterTaskIdListArgs = {
  condition?: InputMaybe<EncounterTaskCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EncounterTasksOrderBy>>;
};


/** Contains information about the ReadyCore vital_lookup table */
export type VitalLookupvitalsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<VitalCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VitalsOrderBy>>;
};


/** Contains information about the ReadyCore vital_lookup table */
export type VitalLookupvitalsListArgs = {
  condition?: InputMaybe<VitalCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VitalsOrderBy>>;
};

/**
 * A condition to be used against `VitalLookup` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type VitalLookupCondition = {
  /** Checks for equality with the object’s `vitalCategory` field. */
  vitalCategory?: InputMaybe<VitalCategoryEnum>;
  /** Checks for equality with the object’s `vitalLookupId` field. */
  vitalLookupId?: InputMaybe<Scalars['Int']>;
};

/** A connection to a list of `EncounterTask` values, with data from `Vital`. */
export type VitalLookupEncounterTasksByVitalVitalLookupIdAndEncounterTaskIdManyToManyConnection = {
  __typename: 'VitalLookupEncounterTasksByVitalVitalLookupIdAndEncounterTaskIdManyToManyConnection';
  /** A list of edges which contains the `EncounterTask`, info from the `Vital`, and the cursor to aid in pagination. */
  edges: Array<VitalLookupEncounterTasksByVitalVitalLookupIdAndEncounterTaskIdManyToManyEdge>;
  /** A list of `EncounterTask` objects. */
  nodes: Array<EncounterTask>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `EncounterTask` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `EncounterTask` edge in the connection, with data from `Vital`. */
export type VitalLookupEncounterTasksByVitalVitalLookupIdAndEncounterTaskIdManyToManyEdge = {
  __typename: 'VitalLookupEncounterTasksByVitalVitalLookupIdAndEncounterTaskIdManyToManyEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `EncounterTask` at the end of the edge. */
  node: EncounterTask;
  /** Reads and enables pagination through a set of `Vital`. */
  vitals: VitalsConnection;
  /** Reads and enables pagination through a set of `Vital`. */
  vitalsList: Array<Vital>;
};


/** A `EncounterTask` edge in the connection, with data from `Vital`. */
export type VitalLookupEncounterTasksByVitalVitalLookupIdAndEncounterTaskIdManyToManyEdgevitalsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<VitalCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VitalsOrderBy>>;
};


/** A `EncounterTask` edge in the connection, with data from `Vital`. */
export type VitalLookupEncounterTasksByVitalVitalLookupIdAndEncounterTaskIdManyToManyEdgevitalsListArgs = {
  condition?: InputMaybe<VitalCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VitalsOrderBy>>;
};

export enum VitalLookupTypeEnum {
  BLOOD_PRESSURE_LOCATION = 'BLOOD_PRESSURE_LOCATION',
  BODY_HEIGHT = 'BODY_HEIGHT',
  BODY_HEIGHT_MEASURED = 'BODY_HEIGHT_MEASURED',
  BODY_HEIGHT_STATED = 'BODY_HEIGHT_STATED',
  BODY_POSITION = 'BODY_POSITION',
  BODY_TEMPERATURE = 'BODY_TEMPERATURE',
  BODY_WEIGHT = 'BODY_WEIGHT',
  BODY_WEIGHT_MEASURED = 'BODY_WEIGHT_MEASURED',
  BODY_WEIGHT_STATED = 'BODY_WEIGHT_STATED',
  DIASTOLIC_BLOOD_PRESSURE = 'DIASTOLIC_BLOOD_PRESSURE',
  HEART_RATE = 'HEART_RATE',
  LUNG_SOUNDS = 'LUNG_SOUNDS',
  MEASURED_AT = 'MEASURED_AT',
  NOTE = 'NOTE',
  OXYGEN_SATURATION = 'OXYGEN_SATURATION',
  RESPIRATORY_RATE = 'RESPIRATORY_RATE',
  SYSTOLIC_BLOOD_PRESSURE = 'SYSTOLIC_BLOOD_PRESSURE'
}

/** A connection to a list of `VitalLookup` values. */
export type VitalLookupsConnection = {
  __typename: 'VitalLookupsConnection';
  /** A list of edges which contains the `VitalLookup` and cursor to aid in pagination. */
  edges: Array<VitalLookupsEdge>;
  /** A list of `VitalLookup` objects. */
  nodes: Array<VitalLookup>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `VitalLookup` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `VitalLookup` edge in the connection. */
export type VitalLookupsEdge = {
  __typename: 'VitalLookupsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `VitalLookup` at the end of the edge. */
  node: VitalLookup;
};

/** Methods to use when ordering `VitalLookup`. */
export enum VitalLookupsOrderBy {
  NATURAL = 'NATURAL',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  VITAL_CATEGORY_ASC = 'VITAL_CATEGORY_ASC',
  VITAL_CATEGORY_DESC = 'VITAL_CATEGORY_DESC',
  VITAL_LOOKUP_ID_ASC = 'VITAL_LOOKUP_ID_ASC',
  VITAL_LOOKUP_ID_DESC = 'VITAL_LOOKUP_ID_DESC'
}

/** A connection to a list of `Vital` values. */
export type VitalsConnection = {
  __typename: 'VitalsConnection';
  /** A list of edges which contains the `Vital` and cursor to aid in pagination. */
  edges: Array<VitalsEdge>;
  /** A list of `Vital` objects. */
  nodes: Array<Vital>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Vital` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Vital` edge in the connection. */
export type VitalsEdge = {
  __typename: 'VitalsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `Vital` at the end of the edge. */
  node: Vital;
};

/** Methods to use when ordering `Vital`. */
export enum VitalsOrderBy {
  ENCOUNTER_TASK_ID_ASC = 'ENCOUNTER_TASK_ID_ASC',
  ENCOUNTER_TASK_ID_DESC = 'ENCOUNTER_TASK_ID_DESC',
  MIGRATION_SOURCE_ASC = 'MIGRATION_SOURCE_ASC',
  MIGRATION_SOURCE_DESC = 'MIGRATION_SOURCE_DESC',
  NATURAL = 'NATURAL',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  VITAL_ID_ASC = 'VITAL_ID_ASC',
  VITAL_ID_DESC = 'VITAL_ID_DESC',
  VITAL_LOOKUP_ID_ASC = 'VITAL_LOOKUP_ID_ASC',
  VITAL_LOOKUP_ID_DESC = 'VITAL_LOOKUP_ID_DESC'
}

/** Contains information about the ReadyCore zipcode table */
export type Zipcode = Node & {
  __typename: 'Zipcode';
  city?: Maybe<Scalars['String']>;
  county?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['Datetime']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  scheduledFreezeById?: Maybe<Scalars['Int']>;
  scheduledFreezeByUser?: Maybe<User>;
  scheduledFreezeEndTime?: Maybe<Scalars['Datetime']>;
  scheduledFreezeReason?: Maybe<Scalars['String']>;
  scheduledFreezeStartTime?: Maybe<Scalars['Datetime']>;
  state?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['Datetime']>;
  zipCode: Scalars['String'];
  /** Reads and enables pagination through a set of `ZoneZipcode`. */
  zoneZipcodesByZipCode: ZoneZipcodesConnection;
  /** Reads and enables pagination through a set of `ZoneZipcode`. */
  zoneZipcodesByZipCodeList: Array<ZoneZipcode>;
  /** Reads and enables pagination through a set of `Zone`. */
  zones: ZipcodeZonesManyToManyConnection;
  /** Reads and enables pagination through a set of `Zone`. */
  zonesByZoneZipcodeZipCodeAndZoneIdList: Array<Zone>;
};


/** Contains information about the ReadyCore zipcode table */
export type ZipcodezoneZipcodesByZipCodeArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ZoneZipcodeCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ZoneZipcodesOrderBy>>;
};


/** Contains information about the ReadyCore zipcode table */
export type ZipcodezoneZipcodesByZipCodeListArgs = {
  condition?: InputMaybe<ZoneZipcodeCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ZoneZipcodesOrderBy>>;
};


/** Contains information about the ReadyCore zipcode table */
export type ZipcodezonesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ZoneCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ZonesOrderBy>>;
};


/** Contains information about the ReadyCore zipcode table */
export type ZipcodezonesByZoneZipcodeZipCodeAndZoneIdListArgs = {
  condition?: InputMaybe<ZoneCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ZonesOrderBy>>;
};

/** A condition to be used against `Zipcode` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type ZipcodeCondition = {
  /** Checks for equality with the object’s `zipCode` field. */
  zipCode?: InputMaybe<Scalars['String']>;
};

/** A connection to a list of `Zone` values, with data from `ZoneZipcode`. */
export type ZipcodeZonesManyToManyConnection = {
  __typename: 'ZipcodeZonesManyToManyConnection';
  /** A list of edges which contains the `Zone`, info from the `ZoneZipcode`, and the cursor to aid in pagination. */
  edges: Array<ZipcodeZonesManyToManyEdge>;
  /** A list of `Zone` objects. */
  nodes: Array<Zone>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Zone` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Zone` edge in the connection, with data from `ZoneZipcode`. */
export type ZipcodeZonesManyToManyEdge = {
  __typename: 'ZipcodeZonesManyToManyEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `Zone` at the end of the edge. */
  node: Zone;
};

/** A connection to a list of `Zipcode` values. */
export type ZipcodesConnection = {
  __typename: 'ZipcodesConnection';
  /** A list of edges which contains the `Zipcode` and cursor to aid in pagination. */
  edges: Array<ZipcodesEdge>;
  /** A list of `Zipcode` objects. */
  nodes: Array<Zipcode>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Zipcode` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Zipcode` edge in the connection. */
export type ZipcodesEdge = {
  __typename: 'ZipcodesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `Zipcode` at the end of the edge. */
  node: Zipcode;
};

/** Methods to use when ordering `Zipcode`. */
export enum ZipcodesOrderBy {
  NATURAL = 'NATURAL',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  ZIP_CODE_ASC = 'ZIP_CODE_ASC',
  ZIP_CODE_DESC = 'ZIP_CODE_DESC'
}

/** Contains a list of zip codes */
export type Zone = Node & {
  __typename: 'Zone';
  appointmentDurationAdjustment?: Maybe<Interval>;
  createdAt: Scalars['Datetime'];
  frozenById?: Maybe<Scalars['Int']>;
  frozenByUser?: Maybe<User>;
  frozenReason?: Maybe<Scalars['String']>;
  isActive: Scalars['Boolean'];
  isDeleted?: Maybe<Scalars['Boolean']>;
  isFrozen: Scalars['Boolean'];
  launchTimestamp?: Maybe<Scalars['Datetime']>;
  /** Reads a single `Market` that is related to this `Zone`. */
  market?: Maybe<Market>;
  marketId: Scalars['Int'];
  name: Scalars['String'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  scheduledFreezeById?: Maybe<Scalars['Int']>;
  scheduledFreezeByUser?: Maybe<User>;
  scheduledFreezeEndTime?: Maybe<Scalars['Datetime']>;
  scheduledFreezeReason?: Maybe<Scalars['String']>;
  scheduledFreezeStartTime?: Maybe<Scalars['Datetime']>;
  skeduloRegionAreaId?: Maybe<Scalars['String']>;
  skeduloRegionId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['Datetime']>;
  /** Reads and enables pagination through a set of `Zipcode`. */
  zipcodes: ZoneZipcodesManyToManyConnection;
  /** Reads and enables pagination through a set of `Zipcode`. */
  zipcodesByZoneZipcodeZoneIdAndZipCodeList: Array<Zipcode>;
  zoneId: Scalars['Int'];
  /** Reads and enables pagination through a set of `ZoneZipcode`. */
  zoneZipcodes: ZoneZipcodesConnection;
  /** Reads and enables pagination through a set of `ZoneZipcode`. */
  zoneZipcodesList: Array<ZoneZipcode>;
};


/** Contains a list of zip codes */
export type ZonezipcodesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ZipcodeCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ZipcodesOrderBy>>;
};


/** Contains a list of zip codes */
export type ZonezipcodesByZoneZipcodeZoneIdAndZipCodeListArgs = {
  condition?: InputMaybe<ZipcodeCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ZipcodesOrderBy>>;
};


/** Contains a list of zip codes */
export type ZonezoneZipcodesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ZoneZipcodeCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ZoneZipcodesOrderBy>>;
};


/** Contains a list of zip codes */
export type ZonezoneZipcodesListArgs = {
  condition?: InputMaybe<ZoneZipcodeCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ZoneZipcodesOrderBy>>;
};

/** A condition to be used against `Zone` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type ZoneCondition = {
  /** Checks for equality with the object’s `marketId` field. */
  marketId?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `zoneId` field. */
  zoneId?: InputMaybe<Scalars['Int']>;
};

/** Contains information about the mapping between the ReadyCore zone table and zipcode table */
export type ZoneZipcode = Node & {
  __typename: 'ZoneZipcode';
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  zipCode: Scalars['UsPostalCode'];
  /** Reads a single `Zipcode` that is related to this `ZoneZipcode`. */
  zipcodeByZipCode?: Maybe<Zipcode>;
  /** Reads a single `Zone` that is related to this `ZoneZipcode`. */
  zone?: Maybe<Zone>;
  zoneId: Scalars['Int'];
};

/**
 * A condition to be used against `ZoneZipcode` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type ZoneZipcodeCondition = {
  /** Checks for equality with the object’s `zipCode` field. */
  zipCode?: InputMaybe<Scalars['UsPostalCode']>;
  /** Checks for equality with the object’s `zoneId` field. */
  zoneId?: InputMaybe<Scalars['Int']>;
};

/** A connection to a list of `ZoneZipcode` values. */
export type ZoneZipcodesConnection = {
  __typename: 'ZoneZipcodesConnection';
  /** A list of edges which contains the `ZoneZipcode` and cursor to aid in pagination. */
  edges: Array<ZoneZipcodesEdge>;
  /** A list of `ZoneZipcode` objects. */
  nodes: Array<ZoneZipcode>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ZoneZipcode` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `ZoneZipcode` edge in the connection. */
export type ZoneZipcodesEdge = {
  __typename: 'ZoneZipcodesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `ZoneZipcode` at the end of the edge. */
  node: ZoneZipcode;
};

/** A connection to a list of `Zipcode` values, with data from `ZoneZipcode`. */
export type ZoneZipcodesManyToManyConnection = {
  __typename: 'ZoneZipcodesManyToManyConnection';
  /** A list of edges which contains the `Zipcode`, info from the `ZoneZipcode`, and the cursor to aid in pagination. */
  edges: Array<ZoneZipcodesManyToManyEdge>;
  /** A list of `Zipcode` objects. */
  nodes: Array<Zipcode>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Zipcode` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Zipcode` edge in the connection, with data from `ZoneZipcode`. */
export type ZoneZipcodesManyToManyEdge = {
  __typename: 'ZoneZipcodesManyToManyEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `Zipcode` at the end of the edge. */
  node: Zipcode;
};

/** Methods to use when ordering `ZoneZipcode`. */
export enum ZoneZipcodesOrderBy {
  NATURAL = 'NATURAL',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  ZIP_CODE_ASC = 'ZIP_CODE_ASC',
  ZIP_CODE_DESC = 'ZIP_CODE_DESC',
  ZONE_ID_ASC = 'ZONE_ID_ASC',
  ZONE_ID_DESC = 'ZONE_ID_DESC'
}

/** A connection to a list of `Zone` values. */
export type ZonesConnection = {
  __typename: 'ZonesConnection';
  /** A list of edges which contains the `Zone` and cursor to aid in pagination. */
  edges: Array<ZonesEdge>;
  /** A list of `Zone` objects. */
  nodes: Array<Zone>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Zone` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Zone` edge in the connection. */
export type ZonesEdge = {
  __typename: 'ZonesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `Zone` at the end of the edge. */
  node: Zone;
};

/** Methods to use when ordering `Zone`. */
export enum ZonesOrderBy {
  MARKET_ID_ASC = 'MARKET_ID_ASC',
  MARKET_ID_DESC = 'MARKET_ID_DESC',
  NAME_ASC = 'NAME_ASC',
  NAME_DESC = 'NAME_DESC',
  NATURAL = 'NATURAL',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  ZONE_ID_ASC = 'ZONE_ID_ASC',
  ZONE_ID_DESC = 'ZONE_ID_DESC'
}

export type GetAppointmentStatusQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAppointmentStatusQuery = { __typename: 'Query', appointment?: { __typename: 'Appointment', appointmentId: number, status?: AppointmentStatusEnum | null | undefined, humanizedStatus?: string | null | undefined } | null | undefined };

export type TestGetUserQueryVariables = Exact<{ [key: string]: never; }>;


export type TestGetUserQuery = { __typename: 'Query', user?: { __typename: 'User', userId: number, firstName?: string | null | undefined, lastName?: string | null | undefined, fullName?: string | null | undefined } | null | undefined };

export type SearchAllergyCodesQueryVariables = Exact<{
  searchTerm: Scalars['String'];
  allergyTypeGroup: SearchAllergyCodesTypeGroup;
}>;


export type SearchAllergyCodesQuery = { __typename: 'Query', searchAllergyCodes?: Array<{ __typename: 'Allergy', allergyId: number, name: string, code: string }> | null | undefined };

export type SearchReactionCodesQueryVariables = Exact<{
  searchTerm: Scalars['String'];
}>;


export type SearchReactionCodesQuery = { __typename: 'Query', searchReactionCodes?: Array<{ __typename: 'AllergicReaction', allergicReactionId: number, name: string, code: string }> | null | undefined };

export type AppointmentFieldsFragment = { __typename: 'Appointment', appointmentId: number, scheduledFor: any, address1?: string | null | undefined, address2?: string | null | undefined, unit?: string | null | undefined, city?: string | null | undefined, state?: string | null | undefined, zip?: string | null | undefined, contactName?: string | null | undefined, primaryPhone?: string | null | undefined, status?: AppointmentStatusEnum | null | undefined, humanizedStatus?: string | null | undefined, scheduledForDate?: string | null | undefined, scheduledForTime?: string | null | undefined, appointmentDispatchesList: Array<{ __typename: 'AppointmentDispatch', onSceneAt?: any | null | undefined, responder?: { __typename: 'ResponderRole', registeredFirstName?: string | null | undefined, registeredLastName?: string | null | undefined, user?: { __typename: 'User', credentials?: Array<CredentialsEnum | null | undefined> | null | undefined, registeredFirstName?: string | null | undefined, registeredLastName?: string | null | undefined, userId: number } | null | undefined } | null | undefined }>, market?: { __typename: 'Market', marketId: number, name: string } | null | undefined };

export type GetAppointmentDispatchesByResponderIdQueryVariables = Exact<{
  responderId: Scalars['Int'];
}>;


export type GetAppointmentDispatchesByResponderIdQuery = { __typename: 'Query', appointmentDispatchesList?: Array<{ __typename: 'AppointmentDispatch', status?: AppointmentDispatchStatusEnum | null | undefined, appointment?: { __typename: 'Appointment', appointmentId: number, scheduledFor: any, address1?: string | null | undefined, address2?: string | null | undefined, unit?: string | null | undefined, city?: string | null | undefined, state?: string | null | undefined, zip?: string | null | undefined, contactName?: string | null | undefined, primaryPhone?: string | null | undefined, status?: AppointmentStatusEnum | null | undefined, humanizedStatus?: string | null | undefined, scheduledForDate?: string | null | undefined, scheduledForTime?: string | null | undefined, encountersList: Array<{ __typename: 'Encounter', claimedAt?: any | null | undefined, clinicianIncluded?: boolean | null | undefined, clinicianStatus?: EncounterClinicianStatusEnum | null | undefined, disposition?: DispositionEnum | null | undefined, encounterId: number, inQueueAt?: any | null | undefined, migrationSource?: string | null | undefined, modules?: Array<ModuleNameEnum | null | undefined> | null | undefined, reasonForEncounter?: string | null | undefined, responderStatus?: EncounterResponderStatusEnum | null | undefined, humanizedClinicianStatus?: string | null | undefined, humanizedModuleEncounterTags?: Array<string | null | undefined> | null | undefined, humanizedResponderStatus?: string | null | undefined, visitId?: string | null | undefined, patient?: { __typename: 'Patient', address1?: string | null | undefined, address2?: string | null | undefined, cannotProvideSsn?: boolean | null | undefined, communicationNeed?: Array<CommunicationNeedEnum | null | undefined> | null | undefined, city?: string | null | undefined, dob?: any | null | undefined, email?: string | null | undefined, firstName?: string | null | undefined, genderIdentity?: GenderIdentityEnum | null | undefined, genderPronoun?: GenderPronounEnum | null | undefined, globalHumanId?: string | null | undefined, languages?: Array<LanguagesEnum | null | undefined> | null | undefined, middleName?: string | null | undefined, globalPatientId: string, hasPreferredName?: boolean | null | undefined, hasDifferentGenderIdentity?: boolean | null | undefined, lastName?: string | null | undefined, noSsnReason?: Array<NoSsnReasonEnum | null | undefined> | null | undefined, patientId: number, preferredName?: string | null | undefined, preferredPhoneNumber?: string | null | undefined, prefix?: string | null | undefined, races?: Array<RaceEnum | null | undefined> | null | undefined, sex?: SexEnum | null | undefined, specialInstructions?: string | null | undefined, ssnSerial?: string | null | undefined, state?: string | null | undefined, suffix?: PatientSuffixEnum | null | undefined, teladocPass?: string | null | undefined, teladocUser?: string | null | undefined, unit?: string | null | undefined, zip?: string | null | undefined, addressLine1?: string | null | undefined, addressLine2?: string | null | undefined, age?: number | null | undefined, fullName?: string | null | undefined, humanizedCommunicationNeed?: Array<string | null | undefined> | null | undefined, humanizedGenderIdentity?: string | null | undefined, humanizedGenderPronoun?: string | null | undefined, humanizedGlobalHumanId?: string | null | undefined, humanizedLanguages?: Array<string | null | undefined> | null | undefined, humanizedRaces?: Array<string | null | undefined> | null | undefined, humanizedSex?: string | null | undefined, humanizedNoSsnReason?: Array<string | null | undefined> | null | undefined } | null | undefined, channelAttribution?: { __typename: 'ChannelAttribution', channel: string, channelAttributionId: number, institutionType: ChannelAttributionInstitutionTypeEnum } | null | undefined, clinician?: { __typename: 'User', userId: number, firstName?: string | null | undefined, lastName?: string | null | undefined, fullName?: string | null | undefined } | null | undefined, serviceLine?: { __typename: 'ServiceLine', name: string, subType: string, serviceLineId: number } | null | undefined, primaryInsuranceRecord?: { __typename: 'InsuranceRecord', insuranceRecordId: number, company?: string | null | undefined } | null | undefined, encounterSignatures: { __typename: 'EncounterSignaturesConnection', nodes: Array<{ __typename: 'EncounterSignature', createdAt: any, operatingAsRole?: UserRoleEnum | null | undefined, user?: { __typename: 'User', userId: number, firstName?: string | null | undefined, lastName?: string | null | undefined, fullName?: string | null | undefined } | null | undefined }> }, addendaList: Array<{ __typename: 'Addendum', addendumId: number, createdAt: any, createdBy: number, note: string, deletedAt?: any | null | undefined, deletedBy?: number | null | undefined, user?: { __typename: 'User', userId: number, firstName?: string | null | undefined, lastName?: string | null | undefined, fullName?: string | null | undefined } | null | undefined }> }>, appointmentDispatchesList: Array<{ __typename: 'AppointmentDispatch', onSceneAt?: any | null | undefined, responder?: { __typename: 'ResponderRole', registeredFirstName?: string | null | undefined, registeredLastName?: string | null | undefined, user?: { __typename: 'User', credentials?: Array<CredentialsEnum | null | undefined> | null | undefined, registeredFirstName?: string | null | undefined, registeredLastName?: string | null | undefined, userId: number } | null | undefined } | null | undefined }>, market?: { __typename: 'Market', marketId: number, name: string } | null | undefined } | null | undefined }> | null | undefined };

export type GetAppointmentsByResponderIdQueryVariables = Exact<{
  responderId: Scalars['Int'];
  filter?: InputMaybe<ResponderAppointmentFilter>;
}>;


export type GetAppointmentsByResponderIdQuery = { __typename: 'Query', readResponderAppointments: Array<{ __typename: 'Appointment', appointmentId: number, scheduledFor: any, address1?: string | null | undefined, address2?: string | null | undefined, unit?: string | null | undefined, city?: string | null | undefined, state?: string | null | undefined, zip?: string | null | undefined, contactName?: string | null | undefined, primaryPhone?: string | null | undefined, status?: AppointmentStatusEnum | null | undefined, humanizedStatus?: string | null | undefined, scheduledForDate?: string | null | undefined, scheduledForTime?: string | null | undefined, encountersList: Array<{ __typename: 'Encounter', claimedAt?: any | null | undefined, clinicianIncluded?: boolean | null | undefined, clinicianStatus?: EncounterClinicianStatusEnum | null | undefined, disposition?: DispositionEnum | null | undefined, encounterId: number, inQueueAt?: any | null | undefined, migrationSource?: string | null | undefined, modules?: Array<ModuleNameEnum | null | undefined> | null | undefined, reasonForEncounter?: string | null | undefined, responderStatus?: EncounterResponderStatusEnum | null | undefined, humanizedClinicianStatus?: string | null | undefined, humanizedModuleEncounterTags?: Array<string | null | undefined> | null | undefined, humanizedResponderStatus?: string | null | undefined, visitId?: string | null | undefined, patient?: { __typename: 'Patient', address1?: string | null | undefined, address2?: string | null | undefined, cannotProvideSsn?: boolean | null | undefined, communicationNeed?: Array<CommunicationNeedEnum | null | undefined> | null | undefined, city?: string | null | undefined, dob?: any | null | undefined, email?: string | null | undefined, firstName?: string | null | undefined, genderIdentity?: GenderIdentityEnum | null | undefined, genderPronoun?: GenderPronounEnum | null | undefined, globalHumanId?: string | null | undefined, languages?: Array<LanguagesEnum | null | undefined> | null | undefined, middleName?: string | null | undefined, globalPatientId: string, hasPreferredName?: boolean | null | undefined, hasDifferentGenderIdentity?: boolean | null | undefined, lastName?: string | null | undefined, noSsnReason?: Array<NoSsnReasonEnum | null | undefined> | null | undefined, patientId: number, preferredName?: string | null | undefined, preferredPhoneNumber?: string | null | undefined, prefix?: string | null | undefined, races?: Array<RaceEnum | null | undefined> | null | undefined, sex?: SexEnum | null | undefined, specialInstructions?: string | null | undefined, ssnSerial?: string | null | undefined, state?: string | null | undefined, suffix?: PatientSuffixEnum | null | undefined, teladocPass?: string | null | undefined, teladocUser?: string | null | undefined, unit?: string | null | undefined, zip?: string | null | undefined, addressLine1?: string | null | undefined, addressLine2?: string | null | undefined, age?: number | null | undefined, fullName?: string | null | undefined, humanizedCommunicationNeed?: Array<string | null | undefined> | null | undefined, humanizedGenderIdentity?: string | null | undefined, humanizedGenderPronoun?: string | null | undefined, humanizedGlobalHumanId?: string | null | undefined, humanizedLanguages?: Array<string | null | undefined> | null | undefined, humanizedRaces?: Array<string | null | undefined> | null | undefined, humanizedSex?: string | null | undefined, humanizedNoSsnReason?: Array<string | null | undefined> | null | undefined } | null | undefined, channelAttribution?: { __typename: 'ChannelAttribution', channel: string, channelAttributionId: number, institutionType: ChannelAttributionInstitutionTypeEnum } | null | undefined, clinician?: { __typename: 'User', userId: number, firstName?: string | null | undefined, lastName?: string | null | undefined, fullName?: string | null | undefined } | null | undefined, serviceLine?: { __typename: 'ServiceLine', name: string, subType: string, serviceLineId: number } | null | undefined, primaryInsuranceRecord?: { __typename: 'InsuranceRecord', insuranceRecordId: number, company?: string | null | undefined } | null | undefined, encounterSignatures: { __typename: 'EncounterSignaturesConnection', nodes: Array<{ __typename: 'EncounterSignature', createdAt: any, operatingAsRole?: UserRoleEnum | null | undefined, user?: { __typename: 'User', userId: number, firstName?: string | null | undefined, lastName?: string | null | undefined, fullName?: string | null | undefined } | null | undefined }> }, addendaList: Array<{ __typename: 'Addendum', addendumId: number, createdAt: any, createdBy: number, note: string, deletedAt?: any | null | undefined, deletedBy?: number | null | undefined, user?: { __typename: 'User', userId: number, firstName?: string | null | undefined, lastName?: string | null | undefined, fullName?: string | null | undefined } | null | undefined }> }>, appointmentDispatchesList: Array<{ __typename: 'AppointmentDispatch', onSceneAt?: any | null | undefined, responder?: { __typename: 'ResponderRole', registeredFirstName?: string | null | undefined, registeredLastName?: string | null | undefined, user?: { __typename: 'User', credentials?: Array<CredentialsEnum | null | undefined> | null | undefined, registeredFirstName?: string | null | undefined, registeredLastName?: string | null | undefined, userId: number } | null | undefined } | null | undefined }>, market?: { __typename: 'Market', marketId: number, name: string } | null | undefined }> };

export type SearchCliniciansQueryVariables = Exact<{
  query: Scalars['String'];
}>;


export type SearchCliniciansQuery = { __typename: 'Query', searchClinicians?: Array<{ __typename: 'User', userId: number, firstName?: string | null | undefined, lastName?: string | null | undefined, fullName?: string | null | undefined }> | null | undefined };

export type GetCPTCodesBySearchTermQueryVariables = Exact<{
  activeDate: Scalars['Date'];
  searchTerm: Scalars['String'];
}>;


export type GetCPTCodesBySearchTermQuery = { __typename: 'Query', searchCPTCodes?: Array<{ __typename: 'ProcedureCodeReference', procedureCodeReferenceId: number, name: string, code: string }> | null | undefined };

export type GetDiagnosisCodeReferenceQueryVariables = Exact<{
  diagnosisCodeReferenceId: Scalars['Int'];
}>;


export type GetDiagnosisCodeReferenceQuery = { __typename: 'Query', diagnosisCodeReference?: { __typename: 'DiagnosisCodeReference', diagnosisCodeReferenceId: number, code: string, name: string } | null | undefined };

export type GetICDCodesBySearchTermQueryVariables = Exact<{
  activeDate: Scalars['Date'];
  searchTerm: Scalars['String'];
}>;


export type GetICDCodesBySearchTermQuery = { __typename: 'Query', searchICDCodes?: Array<{ __typename: 'DiagnosisCodeReference', code: string, diagnosisCodeReferenceId: number, name: string }> | null | undefined };

export type GetDoseSpotNotificationDetailsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetDoseSpotNotificationDetailsQuery = { __typename: 'Query', getDoseSpotNotificationDetails: { __typename: 'DoseSpotNotificationsResponse', notificationCount?: number | null | undefined, notificationsUrl?: string | null | undefined } };

export type GetDoseSpotUrlMutationVariables = Exact<{
  encounterId?: InputMaybe<Scalars['Int']>;
  marketId: Scalars['Int'];
  patientId: Scalars['Int'];
}>;


export type GetDoseSpotUrlMutation = { __typename: 'Mutation', generateDoseSpotURL?: string | null | undefined };

export type GetInProgressClinicianEncountersQueryVariables = Exact<{
  clinicianId?: InputMaybe<Scalars['Int']>;
  patientId: Scalars['Int'];
  scheduledForAfter: Scalars['String'];
  scheduledForBefore: Scalars['String'];
}>;


export type GetInProgressClinicianEncountersQuery = { __typename: 'Query', encounters?: { __typename: 'EncountersConnection', nodes: Array<{ __typename: 'Encounter', encounterId: number, patientId: number, appointment?: { __typename: 'Appointment', appointmentId: number, marketId: number } | null | undefined }> } | null | undefined };

export type EncounterFieldsFragment = { __typename: 'Encounter', claimedAt?: any | null | undefined, clinicianIncluded?: boolean | null | undefined, clinicianStatus?: EncounterClinicianStatusEnum | null | undefined, disposition?: DispositionEnum | null | undefined, encounterId: number, inQueueAt?: any | null | undefined, migrationSource?: string | null | undefined, modules?: Array<ModuleNameEnum | null | undefined> | null | undefined, reasonForEncounter?: string | null | undefined, responderStatus?: EncounterResponderStatusEnum | null | undefined, humanizedClinicianStatus?: string | null | undefined, humanizedModuleEncounterTags?: Array<string | null | undefined> | null | undefined, humanizedResponderStatus?: string | null | undefined, visitId?: string | null | undefined, channelAttribution?: { __typename: 'ChannelAttribution', channel: string, channelAttributionId: number, institutionType: ChannelAttributionInstitutionTypeEnum } | null | undefined, clinician?: { __typename: 'User', userId: number, firstName?: string | null | undefined, lastName?: string | null | undefined, fullName?: string | null | undefined } | null | undefined, serviceLine?: { __typename: 'ServiceLine', name: string, subType: string, serviceLineId: number } | null | undefined, primaryInsuranceRecord?: { __typename: 'InsuranceRecord', insuranceRecordId: number, company?: string | null | undefined } | null | undefined, encounterSignatures: { __typename: 'EncounterSignaturesConnection', nodes: Array<{ __typename: 'EncounterSignature', createdAt: any, operatingAsRole?: UserRoleEnum | null | undefined, user?: { __typename: 'User', userId: number, firstName?: string | null | undefined, lastName?: string | null | undefined, fullName?: string | null | undefined } | null | undefined }> }, addendaList: Array<{ __typename: 'Addendum', addendumId: number, createdAt: any, createdBy: number, note: string, deletedAt?: any | null | undefined, deletedBy?: number | null | undefined, user?: { __typename: 'User', userId: number, firstName?: string | null | undefined, lastName?: string | null | undefined, fullName?: string | null | undefined } | null | undefined }> };

export type EncounterPrintFieldsFragment = { __typename: 'Encounter', claimedAt?: any | null | undefined, clinicianStatus?: EncounterClinicianStatusEnum | null | undefined, disposition?: DispositionEnum | null | undefined, encounterId: number, modules?: Array<ModuleNameEnum | null | undefined> | null | undefined, paymentMode?: EncounterPaymentModeEnum | null | undefined, reasonForEncounter?: string | null | undefined, responderStatus?: EncounterResponderStatusEnum | null | undefined, humanizedClinicianStatus?: string | null | undefined, humanizedModuleEncounterTags?: Array<string | null | undefined> | null | undefined, humanizedResponderStatus?: string | null | undefined, visitId?: string | null | undefined, appointment?: { __typename: 'Appointment', appointmentId: number, scheduledFor: any, address1?: string | null | undefined, address2?: string | null | undefined, unit?: string | null | undefined, city?: string | null | undefined, state?: string | null | undefined, zip?: string | null | undefined, contactName?: string | null | undefined, primaryPhone?: string | null | undefined, status?: AppointmentStatusEnum | null | undefined, humanizedStatus?: string | null | undefined, scheduledForDate?: string | null | undefined, scheduledForTime?: string | null | undefined, appointmentDispatchesList: Array<{ __typename: 'AppointmentDispatch', onSceneAt?: any | null | undefined, responder?: { __typename: 'ResponderRole', registeredFirstName?: string | null | undefined, registeredLastName?: string | null | undefined, user?: { __typename: 'User', credentials?: Array<CredentialsEnum | null | undefined> | null | undefined, registeredFirstName?: string | null | undefined, registeredLastName?: string | null | undefined, userId: number } | null | undefined } | null | undefined }>, market?: { __typename: 'Market', marketId: number, name: string } | null | undefined } | null | undefined, channelAttribution?: { __typename: 'ChannelAttribution', channel: string, channelAttributionId: number, institutionType: ChannelAttributionInstitutionTypeEnum } | null | undefined, clinician?: { __typename: 'User', userId: number, credentials?: Array<CredentialsEnum | null | undefined> | null | undefined, firstName?: string | null | undefined, lastName?: string | null | undefined, fullName?: string | null | undefined } | null | undefined, patient?: { __typename: 'Patient', address1?: string | null | undefined, address2?: string | null | undefined, cannotProvideSsn?: boolean | null | undefined, communicationNeed?: Array<CommunicationNeedEnum | null | undefined> | null | undefined, city?: string | null | undefined, dob?: any | null | undefined, email?: string | null | undefined, firstName?: string | null | undefined, genderIdentity?: GenderIdentityEnum | null | undefined, genderPronoun?: GenderPronounEnum | null | undefined, globalHumanId?: string | null | undefined, languages?: Array<LanguagesEnum | null | undefined> | null | undefined, middleName?: string | null | undefined, globalPatientId: string, hasPreferredName?: boolean | null | undefined, hasDifferentGenderIdentity?: boolean | null | undefined, lastName?: string | null | undefined, noSsnReason?: Array<NoSsnReasonEnum | null | undefined> | null | undefined, patientId: number, preferredName?: string | null | undefined, preferredPhoneNumber?: string | null | undefined, prefix?: string | null | undefined, races?: Array<RaceEnum | null | undefined> | null | undefined, sex?: SexEnum | null | undefined, specialInstructions?: string | null | undefined, ssnSerial?: string | null | undefined, state?: string | null | undefined, suffix?: PatientSuffixEnum | null | undefined, teladocPass?: string | null | undefined, teladocUser?: string | null | undefined, unit?: string | null | undefined, zip?: string | null | undefined, addressLine1?: string | null | undefined, addressLine2?: string | null | undefined, age?: number | null | undefined, fullName?: string | null | undefined, humanizedCommunicationNeed?: Array<string | null | undefined> | null | undefined, humanizedGenderIdentity?: string | null | undefined, humanizedGenderPronoun?: string | null | undefined, humanizedGlobalHumanId?: string | null | undefined, humanizedLanguages?: Array<string | null | undefined> | null | undefined, humanizedRaces?: Array<string | null | undefined> | null | undefined, humanizedSex?: string | null | undefined, humanizedNoSsnReason?: Array<string | null | undefined> | null | undefined } | null | undefined, serviceLine?: { __typename: 'ServiceLine', name: string, subType: string, serviceLineId: number } | null | undefined, primaryInsuranceRecord?: { __typename: 'InsuranceRecord', insuranceRecordId: number, company?: string | null | undefined, planType?: string | null | undefined, memberId?: string | null | undefined, groupNumber?: string | null | undefined } | null | undefined, secondaryInsuranceRecord?: { __typename: 'InsuranceRecord', insuranceRecordId: number, company?: string | null | undefined, planType?: string | null | undefined, memberId?: string | null | undefined, groupNumber?: string | null | undefined } | null | undefined, encounterSignaturesList: Array<{ __typename: 'EncounterSignature', createdAt: any, operatingAsRole?: UserRoleEnum | null | undefined, user?: { __typename: 'User', userId: number, firstName?: string | null | undefined, lastName?: string | null | undefined, fullName?: string | null | undefined } | null | undefined }>, addendaList: Array<{ __typename: 'Addendum', addendumId: number, createdAt: any, createdBy: number, note: string, deletedAt?: any | null | undefined, deletedBy?: number | null | undefined, user?: { __typename: 'User', userId: number, firstName?: string | null | undefined, lastName?: string | null | undefined, fullName?: string | null | undefined } | null | undefined }> };

export type MinimizedEncounterTaskFieldsFragment = { __typename: 'EncounterTask', assigneeId?: number | null | undefined, clinicianReviewedAt?: any | null | undefined, clinicianReviewedBy?: number | null | undefined, dataCategory?: string | null | undefined, dataType: string, encounterTaskId: number, group: string, inProgressAt?: any | null | undefined, responderCompletedAt?: any | null | undefined, skippedReason?: string | null | undefined, status?: EncounterTaskStatusEnum | null | undefined, taskName: string, taskRoles: Array<UserRoleEnum | null | undefined>, updatedAt?: any | null | undefined, corrections?: Array<{ __typename: 'EncounterTaskCorrection', correctionReason: string, jsonValue: any } | null | undefined> | null | undefined };

export type ClaimEncounterMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type ClaimEncounterMutation = { __typename: 'Mutation', claimEncounter?: { __typename: 'ClaimEncounterPayload', encounter?: { __typename: 'Encounter', claimedAt?: any | null | undefined, clinicianIncluded?: boolean | null | undefined, clinicianStatus?: EncounterClinicianStatusEnum | null | undefined, disposition?: DispositionEnum | null | undefined, encounterId: number, inQueueAt?: any | null | undefined, migrationSource?: string | null | undefined, modules?: Array<ModuleNameEnum | null | undefined> | null | undefined, reasonForEncounter?: string | null | undefined, responderStatus?: EncounterResponderStatusEnum | null | undefined, humanizedClinicianStatus?: string | null | undefined, humanizedModuleEncounterTags?: Array<string | null | undefined> | null | undefined, humanizedResponderStatus?: string | null | undefined, visitId?: string | null | undefined, channelAttribution?: { __typename: 'ChannelAttribution', channel: string, channelAttributionId: number, institutionType: ChannelAttributionInstitutionTypeEnum } | null | undefined, clinician?: { __typename: 'User', userId: number, firstName?: string | null | undefined, lastName?: string | null | undefined, fullName?: string | null | undefined } | null | undefined, serviceLine?: { __typename: 'ServiceLine', name: string, subType: string, serviceLineId: number } | null | undefined, primaryInsuranceRecord?: { __typename: 'InsuranceRecord', insuranceRecordId: number, company?: string | null | undefined } | null | undefined, encounterSignatures: { __typename: 'EncounterSignaturesConnection', nodes: Array<{ __typename: 'EncounterSignature', createdAt: any, operatingAsRole?: UserRoleEnum | null | undefined, user?: { __typename: 'User', userId: number, firstName?: string | null | undefined, lastName?: string | null | undefined, fullName?: string | null | undefined } | null | undefined }> }, addendaList: Array<{ __typename: 'Addendum', addendumId: number, createdAt: any, createdBy: number, note: string, deletedAt?: any | null | undefined, deletedBy?: number | null | undefined, user?: { __typename: 'User', userId: number, firstName?: string | null | undefined, lastName?: string | null | undefined, fullName?: string | null | undefined } | null | undefined }> } | null | undefined } | null | undefined };

export type CreateAddendumMutationVariables = Exact<{
  encounterId: Scalars['Int'];
  note: Scalars['String'];
  user: Scalars['Int'];
}>;


export type CreateAddendumMutation = { __typename: 'Mutation', createAddendum?: { __typename: 'CreateAddendumPayload', query?: { __typename: 'Query', encounter?: { __typename: 'Encounter', claimedAt?: any | null | undefined, clinicianIncluded?: boolean | null | undefined, clinicianStatus?: EncounterClinicianStatusEnum | null | undefined, disposition?: DispositionEnum | null | undefined, encounterId: number, inQueueAt?: any | null | undefined, migrationSource?: string | null | undefined, modules?: Array<ModuleNameEnum | null | undefined> | null | undefined, reasonForEncounter?: string | null | undefined, responderStatus?: EncounterResponderStatusEnum | null | undefined, humanizedClinicianStatus?: string | null | undefined, humanizedModuleEncounterTags?: Array<string | null | undefined> | null | undefined, humanizedResponderStatus?: string | null | undefined, visitId?: string | null | undefined, encounterTasksList: Array<{ __typename: 'EncounterTask', assigneeId?: number | null | undefined, clinicianReviewedAt?: any | null | undefined, clinicianReviewedBy?: number | null | undefined, dataCategory?: string | null | undefined, dataType: string, encounterTaskId: number, group: string, inProgressAt?: any | null | undefined, responderCompletedAt?: any | null | undefined, skippedReason?: string | null | undefined, status?: EncounterTaskStatusEnum | null | undefined, taskName: string, taskRoles: Array<UserRoleEnum | null | undefined>, updatedAt?: any | null | undefined, corrections?: Array<{ __typename: 'EncounterTaskCorrection', correctionReason: string, jsonValue: any } | null | undefined> | null | undefined }>, channelAttribution?: { __typename: 'ChannelAttribution', channel: string, channelAttributionId: number, institutionType: ChannelAttributionInstitutionTypeEnum } | null | undefined, clinician?: { __typename: 'User', userId: number, firstName?: string | null | undefined, lastName?: string | null | undefined, fullName?: string | null | undefined } | null | undefined, serviceLine?: { __typename: 'ServiceLine', name: string, subType: string, serviceLineId: number } | null | undefined, primaryInsuranceRecord?: { __typename: 'InsuranceRecord', insuranceRecordId: number, company?: string | null | undefined } | null | undefined, encounterSignatures: { __typename: 'EncounterSignaturesConnection', nodes: Array<{ __typename: 'EncounterSignature', createdAt: any, operatingAsRole?: UserRoleEnum | null | undefined, user?: { __typename: 'User', userId: number, firstName?: string | null | undefined, lastName?: string | null | undefined, fullName?: string | null | undefined } | null | undefined }> }, addendaList: Array<{ __typename: 'Addendum', addendumId: number, createdAt: any, createdBy: number, note: string, deletedAt?: any | null | undefined, deletedBy?: number | null | undefined, user?: { __typename: 'User', userId: number, firstName?: string | null | undefined, lastName?: string | null | undefined, fullName?: string | null | undefined } | null | undefined }> } | null | undefined } | null | undefined } | null | undefined };

export type CreateClinicianEncounterSignatureMutationVariables = Exact<{
  userId: Scalars['Int'];
  encounterId: Scalars['Int'];
}>;


export type CreateClinicianEncounterSignatureMutation = { __typename: 'Mutation', createClinicianEncounterSignature?: { __typename: 'UpsertClinicianSignaturePayload', query?: { __typename: 'Query', encounter?: { __typename: 'Encounter', claimedAt?: any | null | undefined, clinicianIncluded?: boolean | null | undefined, clinicianStatus?: EncounterClinicianStatusEnum | null | undefined, disposition?: DispositionEnum | null | undefined, encounterId: number, inQueueAt?: any | null | undefined, migrationSource?: string | null | undefined, modules?: Array<ModuleNameEnum | null | undefined> | null | undefined, reasonForEncounter?: string | null | undefined, responderStatus?: EncounterResponderStatusEnum | null | undefined, humanizedClinicianStatus?: string | null | undefined, humanizedModuleEncounterTags?: Array<string | null | undefined> | null | undefined, humanizedResponderStatus?: string | null | undefined, visitId?: string | null | undefined, encounterTasksList: Array<{ __typename: 'EncounterTask', assigneeId?: number | null | undefined, clinicianReviewedAt?: any | null | undefined, clinicianReviewedBy?: number | null | undefined, dataCategory?: string | null | undefined, dataType: string, encounterTaskId: number, group: string, inProgressAt?: any | null | undefined, responderCompletedAt?: any | null | undefined, skippedReason?: string | null | undefined, status?: EncounterTaskStatusEnum | null | undefined, taskName: string, taskRoles: Array<UserRoleEnum | null | undefined>, updatedAt?: any | null | undefined, corrections?: Array<{ __typename: 'EncounterTaskCorrection', correctionReason: string, jsonValue: any } | null | undefined> | null | undefined }>, channelAttribution?: { __typename: 'ChannelAttribution', channel: string, channelAttributionId: number, institutionType: ChannelAttributionInstitutionTypeEnum } | null | undefined, clinician?: { __typename: 'User', userId: number, firstName?: string | null | undefined, lastName?: string | null | undefined, fullName?: string | null | undefined } | null | undefined, serviceLine?: { __typename: 'ServiceLine', name: string, subType: string, serviceLineId: number } | null | undefined, primaryInsuranceRecord?: { __typename: 'InsuranceRecord', insuranceRecordId: number, company?: string | null | undefined } | null | undefined, encounterSignatures: { __typename: 'EncounterSignaturesConnection', nodes: Array<{ __typename: 'EncounterSignature', createdAt: any, operatingAsRole?: UserRoleEnum | null | undefined, user?: { __typename: 'User', userId: number, firstName?: string | null | undefined, lastName?: string | null | undefined, fullName?: string | null | undefined } | null | undefined }> }, addendaList: Array<{ __typename: 'Addendum', addendumId: number, createdAt: any, createdBy: number, note: string, deletedAt?: any | null | undefined, deletedBy?: number | null | undefined, user?: { __typename: 'User', userId: number, firstName?: string | null | undefined, lastName?: string | null | undefined, fullName?: string | null | undefined } | null | undefined }> } | null | undefined } | null | undefined } | null | undefined };

export type CreateResponderEncounterSignatureMutationVariables = Exact<{
  userId: Scalars['Int'];
  encounterId: Scalars['Int'];
}>;


export type CreateResponderEncounterSignatureMutation = { __typename: 'Mutation', createResponderEncounterSignature?: { __typename: 'UpsertResponderSignaturePayload', query?: { __typename: 'Query', encounter?: { __typename: 'Encounter', claimedAt?: any | null | undefined, clinicianIncluded?: boolean | null | undefined, clinicianStatus?: EncounterClinicianStatusEnum | null | undefined, disposition?: DispositionEnum | null | undefined, encounterId: number, inQueueAt?: any | null | undefined, migrationSource?: string | null | undefined, modules?: Array<ModuleNameEnum | null | undefined> | null | undefined, reasonForEncounter?: string | null | undefined, responderStatus?: EncounterResponderStatusEnum | null | undefined, humanizedClinicianStatus?: string | null | undefined, humanizedModuleEncounterTags?: Array<string | null | undefined> | null | undefined, humanizedResponderStatus?: string | null | undefined, visitId?: string | null | undefined, encounterTasksList: Array<{ __typename: 'EncounterTask', assigneeId?: number | null | undefined, clinicianReviewedAt?: any | null | undefined, clinicianReviewedBy?: number | null | undefined, dataCategory?: string | null | undefined, dataType: string, encounterTaskId: number, group: string, inProgressAt?: any | null | undefined, responderCompletedAt?: any | null | undefined, skippedReason?: string | null | undefined, status?: EncounterTaskStatusEnum | null | undefined, taskName: string, taskRoles: Array<UserRoleEnum | null | undefined>, updatedAt?: any | null | undefined, corrections?: Array<{ __typename: 'EncounterTaskCorrection', correctionReason: string, jsonValue: any } | null | undefined> | null | undefined }>, channelAttribution?: { __typename: 'ChannelAttribution', channel: string, channelAttributionId: number, institutionType: ChannelAttributionInstitutionTypeEnum } | null | undefined, clinician?: { __typename: 'User', userId: number, firstName?: string | null | undefined, lastName?: string | null | undefined, fullName?: string | null | undefined } | null | undefined, serviceLine?: { __typename: 'ServiceLine', name: string, subType: string, serviceLineId: number } | null | undefined, primaryInsuranceRecord?: { __typename: 'InsuranceRecord', insuranceRecordId: number, company?: string | null | undefined } | null | undefined, encounterSignatures: { __typename: 'EncounterSignaturesConnection', nodes: Array<{ __typename: 'EncounterSignature', createdAt: any, operatingAsRole?: UserRoleEnum | null | undefined, user?: { __typename: 'User', userId: number, firstName?: string | null | undefined, lastName?: string | null | undefined, fullName?: string | null | undefined } | null | undefined }> }, addendaList: Array<{ __typename: 'Addendum', addendumId: number, createdAt: any, createdBy: number, note: string, deletedAt?: any | null | undefined, deletedBy?: number | null | undefined, user?: { __typename: 'User', userId: number, firstName?: string | null | undefined, lastName?: string | null | undefined, fullName?: string | null | undefined } | null | undefined }> } | null | undefined } | null | undefined } | null | undefined };

export type UpdateEncounterMutationVariables = Exact<{
  input: UpdateEncounterInput;
}>;


export type UpdateEncounterMutation = { __typename: 'Mutation', updateEncounter?: { __typename: 'UpdateEncounterPayload', encounter?: { __typename: 'Encounter', encounterId: number, clinician?: { __typename: 'User', firstName?: string | null | undefined, lastName?: string | null | undefined, userId: number } | null | undefined } | null | undefined } | null | undefined };

export type EncounterUpdatePaymentMethodMutationVariables = Exact<{
  encounterId: Scalars['Int'];
  noInsuranceReason?: InputMaybe<NoInsuranceReasonEnum>;
  paymentMode?: InputMaybe<EncounterPaymentModeEnum>;
  primaryInsuranceId?: InputMaybe<Scalars['Int']>;
  secondaryInsuranceId?: InputMaybe<Scalars['Int']>;
}>;


export type EncounterUpdatePaymentMethodMutation = { __typename: 'Mutation', updateEncounter?: { __typename: 'UpdateEncounterPayload', encounter?: { __typename: 'Encounter', encounterId: number, noInsuranceReason?: NoInsuranceReasonEnum | null | undefined, paymentMode?: EncounterPaymentModeEnum | null | undefined, primaryInsuranceRecord?: { __typename: 'InsuranceRecord', insuranceRecordId: number, packageId?: string | null | undefined, company?: string | null | undefined, planType?: string | null | undefined, memberId?: string | null | undefined, groupNumber?: string | null | undefined, relationshipToPolicyHolder?: string | null | undefined, policyHolderFirstName?: string | null | undefined, policyHolderLastName?: string | null | undefined, policyHolderGender?: SexEnum | null | undefined, policyHolderDob?: any | null | undefined, attachmentFrontUrl?: any | null | undefined, attachmentBackUrl?: any | null | undefined, noInsuranceCards?: boolean | null | undefined } | null | undefined, secondaryInsuranceRecord?: { __typename: 'InsuranceRecord', insuranceRecordId: number, packageId?: string | null | undefined, company?: string | null | undefined, planType?: string | null | undefined, memberId?: string | null | undefined, groupNumber?: string | null | undefined, relationshipToPolicyHolder?: string | null | undefined, policyHolderFirstName?: string | null | undefined, policyHolderLastName?: string | null | undefined, policyHolderGender?: SexEnum | null | undefined, policyHolderDob?: any | null | undefined, attachmentFrontUrl?: any | null | undefined, attachmentBackUrl?: any | null | undefined, noInsuranceCards?: boolean | null | undefined } | null | undefined } | null | undefined } | null | undefined };

export type UnclaimEncounterMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type UnclaimEncounterMutation = { __typename: 'Mutation', unclaimEncounter?: { __typename: 'UnclaimEncounterPayload', encounter?: { __typename: 'Encounter', claimedAt?: any | null | undefined, clinicianIncluded?: boolean | null | undefined, clinicianStatus?: EncounterClinicianStatusEnum | null | undefined, disposition?: DispositionEnum | null | undefined, encounterId: number, inQueueAt?: any | null | undefined, migrationSource?: string | null | undefined, modules?: Array<ModuleNameEnum | null | undefined> | null | undefined, reasonForEncounter?: string | null | undefined, responderStatus?: EncounterResponderStatusEnum | null | undefined, humanizedClinicianStatus?: string | null | undefined, humanizedModuleEncounterTags?: Array<string | null | undefined> | null | undefined, humanizedResponderStatus?: string | null | undefined, visitId?: string | null | undefined, channelAttribution?: { __typename: 'ChannelAttribution', channel: string, channelAttributionId: number, institutionType: ChannelAttributionInstitutionTypeEnum } | null | undefined, clinician?: { __typename: 'User', userId: number, firstName?: string | null | undefined, lastName?: string | null | undefined, fullName?: string | null | undefined } | null | undefined, serviceLine?: { __typename: 'ServiceLine', name: string, subType: string, serviceLineId: number } | null | undefined, primaryInsuranceRecord?: { __typename: 'InsuranceRecord', insuranceRecordId: number, company?: string | null | undefined } | null | undefined, encounterSignatures: { __typename: 'EncounterSignaturesConnection', nodes: Array<{ __typename: 'EncounterSignature', createdAt: any, operatingAsRole?: UserRoleEnum | null | undefined, user?: { __typename: 'User', userId: number, firstName?: string | null | undefined, lastName?: string | null | undefined, fullName?: string | null | undefined } | null | undefined }> }, addendaList: Array<{ __typename: 'Addendum', addendumId: number, createdAt: any, createdBy: number, note: string, deletedAt?: any | null | undefined, deletedBy?: number | null | undefined, user?: { __typename: 'User', userId: number, firstName?: string | null | undefined, lastName?: string | null | undefined, fullName?: string | null | undefined } | null | undefined }> } | null | undefined } | null | undefined };

export type GetEncounterByEncounterIdQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type GetEncounterByEncounterIdQuery = { __typename: 'Query', encounter?: { __typename: 'Encounter', claimedAt?: any | null | undefined, clinicianStatus?: EncounterClinicianStatusEnum | null | undefined, disposition?: DispositionEnum | null | undefined, encounterId: number, modules?: Array<ModuleNameEnum | null | undefined> | null | undefined, paymentMode?: EncounterPaymentModeEnum | null | undefined, reasonForEncounter?: string | null | undefined, responderStatus?: EncounterResponderStatusEnum | null | undefined, humanizedClinicianStatus?: string | null | undefined, humanizedModuleEncounterTags?: Array<string | null | undefined> | null | undefined, humanizedResponderStatus?: string | null | undefined, visitId?: string | null | undefined, appointment?: { __typename: 'Appointment', appointmentId: number, scheduledFor: any, address1?: string | null | undefined, address2?: string | null | undefined, unit?: string | null | undefined, city?: string | null | undefined, state?: string | null | undefined, zip?: string | null | undefined, contactName?: string | null | undefined, primaryPhone?: string | null | undefined, status?: AppointmentStatusEnum | null | undefined, humanizedStatus?: string | null | undefined, scheduledForDate?: string | null | undefined, scheduledForTime?: string | null | undefined, appointmentDispatchesList: Array<{ __typename: 'AppointmentDispatch', onSceneAt?: any | null | undefined, responder?: { __typename: 'ResponderRole', registeredFirstName?: string | null | undefined, registeredLastName?: string | null | undefined, user?: { __typename: 'User', credentials?: Array<CredentialsEnum | null | undefined> | null | undefined, registeredFirstName?: string | null | undefined, registeredLastName?: string | null | undefined, userId: number } | null | undefined } | null | undefined }>, market?: { __typename: 'Market', marketId: number, name: string } | null | undefined } | null | undefined, channelAttribution?: { __typename: 'ChannelAttribution', channel: string, channelAttributionId: number, institutionType: ChannelAttributionInstitutionTypeEnum } | null | undefined, clinician?: { __typename: 'User', userId: number, credentials?: Array<CredentialsEnum | null | undefined> | null | undefined, firstName?: string | null | undefined, lastName?: string | null | undefined, fullName?: string | null | undefined } | null | undefined, patient?: { __typename: 'Patient', address1?: string | null | undefined, address2?: string | null | undefined, cannotProvideSsn?: boolean | null | undefined, communicationNeed?: Array<CommunicationNeedEnum | null | undefined> | null | undefined, city?: string | null | undefined, dob?: any | null | undefined, email?: string | null | undefined, firstName?: string | null | undefined, genderIdentity?: GenderIdentityEnum | null | undefined, genderPronoun?: GenderPronounEnum | null | undefined, globalHumanId?: string | null | undefined, languages?: Array<LanguagesEnum | null | undefined> | null | undefined, middleName?: string | null | undefined, globalPatientId: string, hasPreferredName?: boolean | null | undefined, hasDifferentGenderIdentity?: boolean | null | undefined, lastName?: string | null | undefined, noSsnReason?: Array<NoSsnReasonEnum | null | undefined> | null | undefined, patientId: number, preferredName?: string | null | undefined, preferredPhoneNumber?: string | null | undefined, prefix?: string | null | undefined, races?: Array<RaceEnum | null | undefined> | null | undefined, sex?: SexEnum | null | undefined, specialInstructions?: string | null | undefined, ssnSerial?: string | null | undefined, state?: string | null | undefined, suffix?: PatientSuffixEnum | null | undefined, teladocPass?: string | null | undefined, teladocUser?: string | null | undefined, unit?: string | null | undefined, zip?: string | null | undefined, addressLine1?: string | null | undefined, addressLine2?: string | null | undefined, age?: number | null | undefined, fullName?: string | null | undefined, humanizedCommunicationNeed?: Array<string | null | undefined> | null | undefined, humanizedGenderIdentity?: string | null | undefined, humanizedGenderPronoun?: string | null | undefined, humanizedGlobalHumanId?: string | null | undefined, humanizedLanguages?: Array<string | null | undefined> | null | undefined, humanizedRaces?: Array<string | null | undefined> | null | undefined, humanizedSex?: string | null | undefined, humanizedNoSsnReason?: Array<string | null | undefined> | null | undefined } | null | undefined, serviceLine?: { __typename: 'ServiceLine', name: string, subType: string, serviceLineId: number } | null | undefined, primaryInsuranceRecord?: { __typename: 'InsuranceRecord', insuranceRecordId: number, company?: string | null | undefined, planType?: string | null | undefined, memberId?: string | null | undefined, groupNumber?: string | null | undefined } | null | undefined, secondaryInsuranceRecord?: { __typename: 'InsuranceRecord', insuranceRecordId: number, company?: string | null | undefined, planType?: string | null | undefined, memberId?: string | null | undefined, groupNumber?: string | null | undefined } | null | undefined, encounterSignaturesList: Array<{ __typename: 'EncounterSignature', createdAt: any, operatingAsRole?: UserRoleEnum | null | undefined, user?: { __typename: 'User', userId: number, firstName?: string | null | undefined, lastName?: string | null | undefined, fullName?: string | null | undefined } | null | undefined }>, addendaList: Array<{ __typename: 'Addendum', addendumId: number, createdAt: any, createdBy: number, note: string, deletedAt?: any | null | undefined, deletedBy?: number | null | undefined, user?: { __typename: 'User', userId: number, firstName?: string | null | undefined, lastName?: string | null | undefined, fullName?: string | null | undefined } | null | undefined }> } | null | undefined };

export type GetEncounterSearchFiltersQueryVariables = Exact<{ [key: string]: never; }>;


export type GetEncounterSearchFiltersQuery = { __typename: 'Query', marketsList?: Array<{ __typename: 'Market', marketId: number, name: string }> | null | undefined, serviceLinesList?: Array<{ __typename: 'ServiceLine', serviceLineId: number, name: string, subType: string }> | null | undefined };

export type GetEncountersByPatientIdQueryVariables = Exact<{
  id: Scalars['Int'];
  orderBy?: InputMaybe<Array<EncountersOrderBy> | EncountersOrderBy>;
}>;


export type GetEncountersByPatientIdQuery = { __typename: 'Query', encountersList?: Array<{ __typename: 'Encounter', claimedAt?: any | null | undefined, clinicianIncluded?: boolean | null | undefined, clinicianStatus?: EncounterClinicianStatusEnum | null | undefined, disposition?: DispositionEnum | null | undefined, encounterId: number, inQueueAt?: any | null | undefined, migrationSource?: string | null | undefined, modules?: Array<ModuleNameEnum | null | undefined> | null | undefined, reasonForEncounter?: string | null | undefined, responderStatus?: EncounterResponderStatusEnum | null | undefined, humanizedClinicianStatus?: string | null | undefined, humanizedModuleEncounterTags?: Array<string | null | undefined> | null | undefined, humanizedResponderStatus?: string | null | undefined, visitId?: string | null | undefined, encounterTasksList: Array<{ __typename: 'EncounterTask', encounterTaskId: number, status?: EncounterTaskStatusEnum | null | undefined, taskName: string }>, appointment?: { __typename: 'Appointment', appointmentId: number, marketId: number, scheduledFor: any, scheduledForDate?: string | null | undefined, scheduledForTime?: string | null | undefined } | null | undefined, channelAttribution?: { __typename: 'ChannelAttribution', channel: string, channelAttributionId: number, institutionType: ChannelAttributionInstitutionTypeEnum } | null | undefined, clinician?: { __typename: 'User', userId: number, firstName?: string | null | undefined, lastName?: string | null | undefined, fullName?: string | null | undefined } | null | undefined, serviceLine?: { __typename: 'ServiceLine', name: string, subType: string, serviceLineId: number } | null | undefined, primaryInsuranceRecord?: { __typename: 'InsuranceRecord', insuranceRecordId: number, company?: string | null | undefined } | null | undefined, encounterSignatures: { __typename: 'EncounterSignaturesConnection', nodes: Array<{ __typename: 'EncounterSignature', createdAt: any, operatingAsRole?: UserRoleEnum | null | undefined, user?: { __typename: 'User', userId: number, firstName?: string | null | undefined, lastName?: string | null | undefined, fullName?: string | null | undefined } | null | undefined }> }, addendaList: Array<{ __typename: 'Addendum', addendumId: number, createdAt: any, createdBy: number, note: string, deletedAt?: any | null | undefined, deletedBy?: number | null | undefined, user?: { __typename: 'User', userId: number, firstName?: string | null | undefined, lastName?: string | null | undefined, fullName?: string | null | undefined } | null | undefined }> }> | null | undefined };

export type GetEncountersByUserIdQueryVariables = Exact<{
  clinicianIds?: InputMaybe<Array<InputMaybe<Scalars['Int']>> | InputMaybe<Scalars['Int']>>;
  clinicianStatus?: InputMaybe<Array<InputMaybe<EncounterClinicianStatusConditionEnum>> | InputMaybe<EncounterClinicianStatusConditionEnum>>;
  responderId?: InputMaybe<Scalars['Int']>;
  patientId?: InputMaybe<Scalars['Int']>;
  includeResponderNames?: InputMaybe<Scalars['Boolean']>;
  includeTaskStatuses?: InputMaybe<Scalars['Boolean']>;
  scheduledForAfter?: InputMaybe<Scalars['String']>;
  scheduledForBefore?: InputMaybe<Scalars['String']>;
  marketId?: InputMaybe<Array<InputMaybe<Scalars['Int']>> | InputMaybe<Scalars['Int']>>;
  serviceLine?: InputMaybe<Array<InputMaybe<Scalars['Int']>> | InputMaybe<Scalars['Int']>>;
  offset: Scalars['Int'];
  limit?: InputMaybe<Scalars['Int']>;
  responderStatus?: InputMaybe<Array<InputMaybe<EncounterResponderStatusConditionEnum>> | InputMaybe<EncounterResponderStatusConditionEnum>>;
  appointmentStatus?: InputMaybe<Array<InputMaybe<EncounterAppointmentStatusConditionEnum>> | InputMaybe<EncounterAppointmentStatusConditionEnum>>;
  paymentMode?: InputMaybe<Array<InputMaybe<EncounterPaymentModeConditionEnum>> | InputMaybe<EncounterPaymentModeConditionEnum>>;
}>;


export type GetEncountersByUserIdQuery = { __typename: 'Query', encounters?: { __typename: 'EncountersConnection', nodes: Array<{ __typename: 'Encounter', claimedAt?: any | null | undefined, clinicianIncluded?: boolean | null | undefined, clinicianStatus?: EncounterClinicianStatusEnum | null | undefined, disposition?: DispositionEnum | null | undefined, encounterId: number, inQueueAt?: any | null | undefined, migrationSource?: string | null | undefined, modules?: Array<ModuleNameEnum | null | undefined> | null | undefined, reasonForEncounter?: string | null | undefined, responderStatus?: EncounterResponderStatusEnum | null | undefined, humanizedClinicianStatus?: string | null | undefined, humanizedModuleEncounterTags?: Array<string | null | undefined> | null | undefined, humanizedResponderStatus?: string | null | undefined, visitId?: string | null | undefined, encounterTasksList?: Array<{ __typename: 'EncounterTask', encounterTaskId: number, status?: EncounterTaskStatusEnum | null | undefined, taskRoles: Array<UserRoleEnum | null | undefined> }>, appointment?: { __typename: 'Appointment', appointmentId: number, scheduledFor: any, status?: AppointmentStatusEnum | null | undefined, humanizedStatus?: string | null | undefined, appointmentDispatchesList: Array<{ __typename: 'AppointmentDispatch', responder?: { __typename: 'ResponderRole', user?: { __typename: 'User', userId: number, firstName?: string | null | undefined, lastName?: string | null | undefined, fullName?: string | null | undefined } | null | undefined } | null | undefined }>, market?: { __typename: 'Market', marketId: number, name: string } | null | undefined } | null | undefined, patient?: { __typename: 'Patient', address1?: string | null | undefined, address2?: string | null | undefined, cannotProvideSsn?: boolean | null | undefined, communicationNeed?: Array<CommunicationNeedEnum | null | undefined> | null | undefined, city?: string | null | undefined, dob?: any | null | undefined, email?: string | null | undefined, firstName?: string | null | undefined, genderIdentity?: GenderIdentityEnum | null | undefined, genderPronoun?: GenderPronounEnum | null | undefined, globalHumanId?: string | null | undefined, languages?: Array<LanguagesEnum | null | undefined> | null | undefined, middleName?: string | null | undefined, globalPatientId: string, hasPreferredName?: boolean | null | undefined, hasDifferentGenderIdentity?: boolean | null | undefined, lastName?: string | null | undefined, noSsnReason?: Array<NoSsnReasonEnum | null | undefined> | null | undefined, patientId: number, preferredName?: string | null | undefined, preferredPhoneNumber?: string | null | undefined, prefix?: string | null | undefined, races?: Array<RaceEnum | null | undefined> | null | undefined, sex?: SexEnum | null | undefined, specialInstructions?: string | null | undefined, ssnSerial?: string | null | undefined, state?: string | null | undefined, suffix?: PatientSuffixEnum | null | undefined, teladocPass?: string | null | undefined, teladocUser?: string | null | undefined, unit?: string | null | undefined, zip?: string | null | undefined, addressLine1?: string | null | undefined, addressLine2?: string | null | undefined, age?: number | null | undefined, fullName?: string | null | undefined, humanizedCommunicationNeed?: Array<string | null | undefined> | null | undefined, humanizedGenderIdentity?: string | null | undefined, humanizedGenderPronoun?: string | null | undefined, humanizedGlobalHumanId?: string | null | undefined, humanizedLanguages?: Array<string | null | undefined> | null | undefined, humanizedRaces?: Array<string | null | undefined> | null | undefined, humanizedSex?: string | null | undefined, humanizedNoSsnReason?: Array<string | null | undefined> | null | undefined } | null | undefined, channelAttribution?: { __typename: 'ChannelAttribution', channel: string, channelAttributionId: number, institutionType: ChannelAttributionInstitutionTypeEnum } | null | undefined, clinician?: { __typename: 'User', userId: number, firstName?: string | null | undefined, lastName?: string | null | undefined, fullName?: string | null | undefined } | null | undefined, serviceLine?: { __typename: 'ServiceLine', name: string, subType: string, serviceLineId: number } | null | undefined, primaryInsuranceRecord?: { __typename: 'InsuranceRecord', insuranceRecordId: number, company?: string | null | undefined } | null | undefined, encounterSignatures: { __typename: 'EncounterSignaturesConnection', nodes: Array<{ __typename: 'EncounterSignature', createdAt: any, operatingAsRole?: UserRoleEnum | null | undefined, user?: { __typename: 'User', userId: number, firstName?: string | null | undefined, lastName?: string | null | undefined, fullName?: string | null | undefined } | null | undefined }> }, addendaList: Array<{ __typename: 'Addendum', addendumId: number, createdAt: any, createdBy: number, note: string, deletedAt?: any | null | undefined, deletedBy?: number | null | undefined, user?: { __typename: 'User', userId: number, firstName?: string | null | undefined, lastName?: string | null | undefined, fullName?: string | null | undefined } | null | undefined }> }> } | null | undefined, encountersCount?: { __typename: 'EncountersConnection', totalCount: number } | null | undefined };

export type StartEncounterQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type StartEncounterQuery = { __typename: 'Query', startEncounter: { __typename: 'Encounter', claimedAt?: any | null | undefined, clinicianIncluded?: boolean | null | undefined, clinicianStatus?: EncounterClinicianStatusEnum | null | undefined, disposition?: DispositionEnum | null | undefined, encounterId: number, inQueueAt?: any | null | undefined, migrationSource?: string | null | undefined, modules?: Array<ModuleNameEnum | null | undefined> | null | undefined, reasonForEncounter?: string | null | undefined, responderStatus?: EncounterResponderStatusEnum | null | undefined, humanizedClinicianStatus?: string | null | undefined, humanizedModuleEncounterTags?: Array<string | null | undefined> | null | undefined, humanizedResponderStatus?: string | null | undefined, visitId?: string | null | undefined, channelAttribution?: { __typename: 'ChannelAttribution', channel: string, channelAttributionId: number, institutionType: ChannelAttributionInstitutionTypeEnum } | null | undefined, clinician?: { __typename: 'User', userId: number, firstName?: string | null | undefined, lastName?: string | null | undefined, fullName?: string | null | undefined } | null | undefined, serviceLine?: { __typename: 'ServiceLine', name: string, subType: string, serviceLineId: number } | null | undefined, primaryInsuranceRecord?: { __typename: 'InsuranceRecord', insuranceRecordId: number, company?: string | null | undefined } | null | undefined, encounterSignatures: { __typename: 'EncounterSignaturesConnection', nodes: Array<{ __typename: 'EncounterSignature', createdAt: any, operatingAsRole?: UserRoleEnum | null | undefined, user?: { __typename: 'User', userId: number, firstName?: string | null | undefined, lastName?: string | null | undefined, fullName?: string | null | undefined } | null | undefined }> }, addendaList: Array<{ __typename: 'Addendum', addendumId: number, createdAt: any, createdBy: number, note: string, deletedAt?: any | null | undefined, deletedBy?: number | null | undefined, user?: { __typename: 'User', userId: number, firstName?: string | null | undefined, lastName?: string | null | undefined, fullName?: string | null | undefined } | null | undefined }> } };

export type EncounterTaskAttachmentFieldsFragment = { __typename: 'EncounterTaskAttachment', createdAt: any, description?: string | null | undefined, encounterId?: number | null | undefined, encounterTaskAttachmentId: number, encounterTaskId?: number | null | undefined, isDeleted: boolean, isRequired: boolean, type: EncounterTaskAttachmentTypeEnum, url?: string | null | undefined, patientId?: number | null | undefined };

export type EncounterTaskFieldsFragment = { __typename: 'EncounterTask', assigneeId?: number | null | undefined, dataCategory?: string | null | undefined, dataType: string, encounterTaskId: number, group: string, inProgressAt?: any | null | undefined, patientId: number, responderCompletedAt?: any | null | undefined, responderCompletedBy?: number | null | undefined, skippedReason?: string | null | undefined, status?: EncounterTaskStatusEnum | null | undefined, taskName: string, taskRoles: Array<UserRoleEnum | null | undefined>, updatedAt?: any | null | undefined, corrections?: Array<{ __typename: 'EncounterTaskCorrection', correctionReason: string, createdAt: any, createdBy: number, jsonValue: any } | null | undefined> | null | undefined, diagnosisCodeReferencesByPatientDiagnosisEncounterTaskIdAndDiagnosisCodeReferenceIdList: Array<{ __typename: 'DiagnosisCodeReference', code: string, name: string }>, encounter?: { __typename: 'Encounter', activation?: ActivationEnum | null | undefined, clinicianIncluded?: boolean | null | undefined, clinicianStatus?: EncounterClinicianStatusEnum | null | undefined, disposition?: DispositionEnum | null | undefined, encounterId: number, modules?: Array<ModuleNameEnum | null | undefined> | null | undefined, responderStatus?: EncounterResponderStatusEnum | null | undefined, humanizedModuleEncounterTags?: Array<string | null | undefined> | null | undefined, serviceLine?: { __typename: 'ServiceLine', name: string, serviceLineId: number, subType: string } | null | undefined, appointment?: { __typename: 'Appointment', appointmentId: number, scheduledFor: any, state?: string | null | undefined, market?: { __typename: 'Market', marketId: number } | null | undefined } | null | undefined, clinician?: { __typename: 'User', firstName?: string | null | undefined, lastName?: string | null | undefined, userId: number } | null | undefined, patient?: { __typename: 'Patient', age?: number | null | undefined, dob?: any | null | undefined, firstName?: string | null | undefined, humanizedGenderIdentity?: string | null | undefined, humanizedGenderPronoun?: string | null | undefined, humanizedRaces?: Array<string | null | undefined> | null | undefined, humanizedSex?: string | null | undefined, globalPatientId: string, lastName?: string | null | undefined, patientId: number, preferredName?: string | null | undefined, ssnSerial?: string | null | undefined, suffix?: PatientSuffixEnum | null | undefined, teladocPass?: string | null | undefined, teladocUser?: string | null | undefined, fullName?: string | null | undefined } | null | undefined } | null | undefined, encounterTaskAttachmentsList: Array<{ __typename: 'EncounterTaskAttachment', createdAt: any, description?: string | null | undefined, encounterId?: number | null | undefined, encounterTaskAttachmentId: number, encounterTaskId?: number | null | undefined, isDeleted: boolean, isRequired: boolean, type: EncounterTaskAttachmentTypeEnum, url?: string | null | undefined, patientId?: number | null | undefined }>, modifiedByResponders?: Array<{ __typename: 'User', credentials?: Array<CredentialsEnum | null | undefined> | null | undefined, firstName?: string | null | undefined, lastName?: string | null | undefined, userId: number } | null | undefined> | null | undefined };

export type EncounterTaskLookupFieldsFragment = { __typename: 'EncounterTask', patientAllergyList?: Array<{ __typename: 'PatientAllergy', patientAllergyId: number, isDeleted: boolean, startedAt: any, allergy?: { __typename: 'Allergy', allergyId: number, code: string, name: string, allergyType?: { __typename: 'AllergyType', name: string } | null | undefined } | null | undefined, allergicReaction?: { __typename: 'AllergicReaction', allergicReactionId: number, code: string, name: string } | null | undefined } | null | undefined> | null | undefined, billingDiagnosticsList?: Array<{ __typename: 'BillingDiagnostic', encounterTaskId?: number | null | undefined, deletedAt?: any | null | undefined, procedureCodeReference?: { __typename: 'ProcedureCodeReference', code: string, name: string, procedureCodeReferenceId: number } | null | undefined }>, chiefComplaintAndHpi?: { __typename: 'ChiefComplaintAndHpi', chiefComplaint?: string | null | undefined, chiefComplaintAndHpiId: number, historyOfPresentIllness?: string | null | undefined } | null | undefined, reviewOfSystems?: Array<{ __typename: 'ReviewOfSystemPayload', template?: ReviewOfSystemTemplateEnum | null | undefined, systems?: Array<{ __typename: 'ReviewOfSystemSystemPayload', note?: string | null | undefined, system: ReviewOfSystemSystemEnum, evaluations: Array<{ __typename: 'ReviewOfSystemEvaluationPayload', key: string, value: boolean } | null | undefined> } | null | undefined> | null | undefined } | null | undefined> | null | undefined, patientForm?: { __typename: 'PatientForm', fieldResponse?: any | null | undefined, fieldResponseJson?: any | null | undefined, formstackId?: string | null | undefined, patientFormId: number, signedAt?: any | null | undefined } | null | undefined, patientFormLookup?: { __typename: 'PatientFormLookup', patientFormLookupId: number, title?: string | null | undefined, formUrl?: string | null | undefined } | null | undefined, encounter?: { __typename: 'Encounter', encounterId: number, paymentMode?: EncounterPaymentModeEnum | null | undefined, noInsuranceReason?: NoInsuranceReasonEnum | null | undefined, stripeId?: string | null | undefined, primaryInsuranceRecord?: { __typename: 'InsuranceRecord', insuranceRecordId: number, packageId?: string | null | undefined, company?: string | null | undefined, planType?: string | null | undefined, memberId?: string | null | undefined, groupNumber?: string | null | undefined, relationshipToPolicyHolder?: string | null | undefined, policyHolderFirstName?: string | null | undefined, policyHolderLastName?: string | null | undefined, policyHolderGender?: SexEnum | null | undefined, policyHolderDob?: any | null | undefined, attachmentFrontUrl?: any | null | undefined, attachmentBackUrl?: any | null | undefined, noInsuranceCards?: boolean | null | undefined } | null | undefined, secondaryInsuranceRecord?: { __typename: 'InsuranceRecord', insuranceRecordId: number, packageId?: string | null | undefined, company?: string | null | undefined, planType?: string | null | undefined, memberId?: string | null | undefined, groupNumber?: string | null | undefined, relationshipToPolicyHolder?: string | null | undefined, policyHolderFirstName?: string | null | undefined, policyHolderLastName?: string | null | undefined, policyHolderGender?: SexEnum | null | undefined, policyHolderDob?: any | null | undefined, attachmentFrontUrl?: any | null | undefined, attachmentBackUrl?: any | null | undefined, noInsuranceCards?: boolean | null | undefined } | null | undefined } | null | undefined, medicalDecisionMaking?: { __typename: 'MedicalDecisionMaking', medicalDecisionMakingId: number, note?: string | null | undefined } | null | undefined, patientDiagnosesList?: Array<{ __typename: 'PatientDiagnosis', isDeleted: boolean, order: number, patientDiagnosisId: number, diagnosisCodeReference?: { __typename: 'DiagnosisCodeReference', diagnosisCodeReferenceId: number, name: string, code: string } | null | undefined }>, patientInstructions?: Array<{ __typename: 'PatientInstruction', patientInstructionId: number, careInstructions?: string | null | undefined, type: PatientInstructionTypeEnum, isDeleted: boolean } | null | undefined> | null | undefined, patientProblemList?: Array<{ __typename: 'PatientProblem', createdAt: any, isDeleted: boolean, patientProblemId: number, problemText?: string | null | undefined, startedAt?: any | null | undefined } | null | undefined> | null | undefined, physicalExam?: { __typename: 'PhysicalExam', physicalExamId: number, note?: string | null | undefined } | null | undefined, pointOfCareTest?: { __typename: 'PointOfCareTest', clinicianFirstName?: string | null | undefined, clinicianId?: number | null | undefined, clinicianLastName?: string | null | undefined, expirationDate?: any | null | undefined, humidity?: number | null | undefined, internalControlAcceptable?: boolean | null | undefined, isDeleted: boolean, lotNumber?: string | null | undefined, pointOfCareTestId: number, pointOfCareTestLookupId: number, result?: string | null | undefined, standingOrderAddedAt?: any | null | undefined, standingOrderId?: number | null | undefined, temperature?: number | null | undefined, criticalValueConfirmations?: Array<{ __typename: 'PoctCriticalValueConfirmation', attestedAt: any, attestedBy: number, operatingAsRole: UserRoleEnum, user?: { __typename: 'User', credentials?: Array<CredentialsEnum | null | undefined> | null | undefined, firstName?: string | null | undefined, lastName?: string | null | undefined, fullName?: string | null | undefined, userId: number } | null | undefined } | null | undefined> | null | undefined, standingOrder?: { __typename: 'StandingOrder', clinicianId: number, diagnosisCodes?: Array<string | null | undefined> | null | undefined, name: string, number: string, orderUrl: string, lookupId?: number | null | undefined, lookupType?: StandingOrderLookupTypeEnum | null | undefined, procedureCodes?: Array<string | null | undefined> | null | undefined, standingOrderId: number, startedAt?: any | null | undefined, endedAt?: any | null | undefined, state: StateEnum, version: string, clinician?: { __typename: 'User', userId: number, firstName?: string | null | undefined, lastName?: string | null | undefined } | null | undefined } | null | undefined } | null | undefined, pointOfCareTestLookup?: { __typename: 'PointOfCareTestLookup', code?: string | null | undefined, name: string, pointOfCareTestCategory: PointOfCareTestCategoryEnum, pointOfCareTestLookupId: number, system?: string | null | undefined, unit?: string | null | undefined, standingOrders?: Array<{ __typename: 'StandingOrder', clinicianId: number, diagnosisCodes?: Array<string | null | undefined> | null | undefined, name: string, number: string, orderUrl: string, lookupId?: number | null | undefined, lookupType?: StandingOrderLookupTypeEnum | null | undefined, procedureCodes?: Array<string | null | undefined> | null | undefined, standingOrderId: number, startedAt?: any | null | undefined, endedAt?: any | null | undefined, state: StateEnum, version: string, clinician?: { __typename: 'User', userId: number, firstName?: string | null | undefined, lastName?: string | null | undefined } | null | undefined } | null | undefined> | null | undefined } | null | undefined, progressNote?: { __typename: 'ProgressNote', note?: string | null | undefined, progressNoteId: number } | null | undefined, telehealthMeeting?: { __typename: 'TelehealthMeeting', telehealthMeetingId: number, alternateConnectionMethod?: TelehealthMeetingAlternateConnectionMethodEnum | null | undefined, alternateConnectionReason?: string | null | undefined, clinicianClaimedAt?: any | null | undefined, inQueueAt?: any | null | undefined, clinician?: { __typename: 'User', userId: number, firstName?: string | null | undefined, lastName?: string | null | undefined } | null | undefined, videoConference?: { __typename: 'VideoConference', videoConferenceId: number, status?: VideoConferenceStatusEnum | null | undefined, hostUrl: string, participantUrl: string, meetingStartTime?: any | null | undefined, meetingEndTime?: any | null | undefined, meetingId: any } | null | undefined } | null | undefined, vaccine?: { __typename: 'Vaccine', doseNumber?: number | null | undefined, adverseReactions?: Array<VaccineAdverseReactionEnum | null | undefined> | null | undefined, hadAdverseReaction?: boolean | null | undefined, contraindication?: boolean | null | undefined, location?: VaccineLocationEnum | null | undefined, lotExpiration?: any | null | undefined, lotNumber?: string | null | undefined, otherAdverseReactions?: string | null | undefined, orderedBy?: number | null | undefined, standingOrderAddedAt?: any | null | undefined, standingOrderId?: number | null | undefined, totalDoses?: number | null | undefined, vaccineId: number, vaccineLookupId: number, visEdition?: any | null | undefined, visReceived?: boolean | null | undefined, standingOrder?: { __typename: 'StandingOrder', clinicianId: number, diagnosisCodes?: Array<string | null | undefined> | null | undefined, name: string, number: string, orderUrl: string, lookupId?: number | null | undefined, lookupType?: StandingOrderLookupTypeEnum | null | undefined, procedureCodes?: Array<string | null | undefined> | null | undefined, standingOrderId: number, startedAt?: any | null | undefined, endedAt?: any | null | undefined, state: StateEnum, version: string, clinician?: { __typename: 'User', userId: number, firstName?: string | null | undefined, lastName?: string | null | undefined } | null | undefined } | null | undefined } | null | undefined, vaccineLookups?: Array<{ __typename: 'VaccineLookup', vaccineLookupId: number, doseQuantity: any, doseUnits: string, drug?: { __typename: 'Drug', drugId: number, drugName: string, manufacturerName: string, routeName: string } | null | undefined, standingOrders?: Array<{ __typename: 'StandingOrder', clinicianId: number, diagnosisCodes?: Array<string | null | undefined> | null | undefined, name: string, number: string, orderUrl: string, lookupId?: number | null | undefined, lookupType?: StandingOrderLookupTypeEnum | null | undefined, procedureCodes?: Array<string | null | undefined> | null | undefined, standingOrderId: number, startedAt?: any | null | undefined, endedAt?: any | null | undefined, state: StateEnum, version: string, clinician?: { __typename: 'User', userId: number, firstName?: string | null | undefined, lastName?: string | null | undefined } | null | undefined } | null | undefined> | null | undefined } | null | undefined> | null | undefined, vitalsList?: Array<{ __typename: 'Vital', vitalId: number, result: string, vitalLookup?: { __typename: 'VitalLookup', name?: string | null | undefined, unit?: string | null | undefined, vitalCategory: VitalCategoryEnum, vitalLookupId: number, vitalType: VitalLookupTypeEnum } | null | undefined }> };

export type CreateEncounterTaskAttachmentMutationVariables = Exact<{
  input: CreateEncounterTaskAttachmentInput;
}>;


export type CreateEncounterTaskAttachmentMutation = { __typename: 'Mutation', createEncounterTaskAttachment?: { __typename: 'CreateEncounterTaskAttachmentPayload', encounterTask?: { __typename: 'EncounterTask', assigneeId?: number | null | undefined, dataCategory?: string | null | undefined, dataType: string, encounterTaskId: number, group: string, inProgressAt?: any | null | undefined, patientId: number, responderCompletedAt?: any | null | undefined, responderCompletedBy?: number | null | undefined, skippedReason?: string | null | undefined, status?: EncounterTaskStatusEnum | null | undefined, taskName: string, taskRoles: Array<UserRoleEnum | null | undefined>, updatedAt?: any | null | undefined, corrections?: Array<{ __typename: 'EncounterTaskCorrection', correctionReason: string, createdAt: any, createdBy: number, jsonValue: any } | null | undefined> | null | undefined, diagnosisCodeReferencesByPatientDiagnosisEncounterTaskIdAndDiagnosisCodeReferenceIdList: Array<{ __typename: 'DiagnosisCodeReference', code: string, name: string }>, encounter?: { __typename: 'Encounter', activation?: ActivationEnum | null | undefined, clinicianIncluded?: boolean | null | undefined, clinicianStatus?: EncounterClinicianStatusEnum | null | undefined, disposition?: DispositionEnum | null | undefined, encounterId: number, modules?: Array<ModuleNameEnum | null | undefined> | null | undefined, responderStatus?: EncounterResponderStatusEnum | null | undefined, humanizedModuleEncounterTags?: Array<string | null | undefined> | null | undefined, serviceLine?: { __typename: 'ServiceLine', name: string, serviceLineId: number, subType: string } | null | undefined, appointment?: { __typename: 'Appointment', appointmentId: number, scheduledFor: any, state?: string | null | undefined, market?: { __typename: 'Market', marketId: number } | null | undefined } | null | undefined, clinician?: { __typename: 'User', firstName?: string | null | undefined, lastName?: string | null | undefined, userId: number } | null | undefined, patient?: { __typename: 'Patient', age?: number | null | undefined, dob?: any | null | undefined, firstName?: string | null | undefined, humanizedGenderIdentity?: string | null | undefined, humanizedGenderPronoun?: string | null | undefined, humanizedRaces?: Array<string | null | undefined> | null | undefined, humanizedSex?: string | null | undefined, globalPatientId: string, lastName?: string | null | undefined, patientId: number, preferredName?: string | null | undefined, ssnSerial?: string | null | undefined, suffix?: PatientSuffixEnum | null | undefined, teladocPass?: string | null | undefined, teladocUser?: string | null | undefined, fullName?: string | null | undefined } | null | undefined } | null | undefined, encounterTaskAttachmentsList: Array<{ __typename: 'EncounterTaskAttachment', createdAt: any, description?: string | null | undefined, encounterId?: number | null | undefined, encounterTaskAttachmentId: number, encounterTaskId?: number | null | undefined, isDeleted: boolean, isRequired: boolean, type: EncounterTaskAttachmentTypeEnum, url?: string | null | undefined, patientId?: number | null | undefined }>, modifiedByResponders?: Array<{ __typename: 'User', credentials?: Array<CredentialsEnum | null | undefined> | null | undefined, firstName?: string | null | undefined, lastName?: string | null | undefined, userId: number } | null | undefined> | null | undefined } | null | undefined } | null | undefined };

export type UpdateEncounterTaskMutationVariables = Exact<{
  input: UpdateEncounterTaskInput;
  isAllergiesTask?: InputMaybe<Scalars['Boolean']>;
  isChiefComplaintAndHpiTask?: InputMaybe<Scalars['Boolean']>;
  isClinicianBillingTask?: InputMaybe<Scalars['Boolean']>;
  isDispositionTask?: InputMaybe<Scalars['Boolean']>;
  isMedicalConditionTask?: InputMaybe<Scalars['Boolean']>;
  isMedicalDecisionMakingTask?: InputMaybe<Scalars['Boolean']>;
  isPatientFormTask?: InputMaybe<Scalars['Boolean']>;
  isPaymentMethodTask?: InputMaybe<Scalars['Boolean']>;
  isPhysicalExamTask?: InputMaybe<Scalars['Boolean']>;
  isPointOfCareTestTask?: InputMaybe<Scalars['Boolean']>;
  isProgressNoteTask?: InputMaybe<Scalars['Boolean']>;
  isTelehealthTask?: InputMaybe<Scalars['Boolean']>;
  isVaccineTask?: InputMaybe<Scalars['Boolean']>;
  isVitalTask?: InputMaybe<Scalars['Boolean']>;
}>;


export type UpdateEncounterTaskMutation = { __typename: 'Mutation', updateEncounterTask?: { __typename: 'UpdateEncounterTaskPayload', encounterTask?: { __typename: 'EncounterTask', assigneeId?: number | null | undefined, dataCategory?: string | null | undefined, dataType: string, encounterTaskId: number, group: string, inProgressAt?: any | null | undefined, patientId: number, responderCompletedAt?: any | null | undefined, responderCompletedBy?: number | null | undefined, skippedReason?: string | null | undefined, status?: EncounterTaskStatusEnum | null | undefined, taskName: string, taskRoles: Array<UserRoleEnum | null | undefined>, updatedAt?: any | null | undefined, corrections?: Array<{ __typename: 'EncounterTaskCorrection', correctionReason: string, createdAt: any, createdBy: number, jsonValue: any } | null | undefined> | null | undefined, diagnosisCodeReferencesByPatientDiagnosisEncounterTaskIdAndDiagnosisCodeReferenceIdList: Array<{ __typename: 'DiagnosisCodeReference', code: string, name: string }>, encounter?: { __typename: 'Encounter', activation?: ActivationEnum | null | undefined, clinicianIncluded?: boolean | null | undefined, clinicianStatus?: EncounterClinicianStatusEnum | null | undefined, disposition?: DispositionEnum | null | undefined, encounterId: number, modules?: Array<ModuleNameEnum | null | undefined> | null | undefined, responderStatus?: EncounterResponderStatusEnum | null | undefined, humanizedModuleEncounterTags?: Array<string | null | undefined> | null | undefined, paymentMode?: EncounterPaymentModeEnum | null | undefined, noInsuranceReason?: NoInsuranceReasonEnum | null | undefined, stripeId?: string | null | undefined, serviceLine?: { __typename: 'ServiceLine', name: string, serviceLineId: number, subType: string } | null | undefined, appointment?: { __typename: 'Appointment', appointmentId: number, scheduledFor: any, state?: string | null | undefined, market?: { __typename: 'Market', marketId: number } | null | undefined } | null | undefined, clinician?: { __typename: 'User', firstName?: string | null | undefined, lastName?: string | null | undefined, userId: number } | null | undefined, patient?: { __typename: 'Patient', age?: number | null | undefined, dob?: any | null | undefined, firstName?: string | null | undefined, humanizedGenderIdentity?: string | null | undefined, humanizedGenderPronoun?: string | null | undefined, humanizedRaces?: Array<string | null | undefined> | null | undefined, humanizedSex?: string | null | undefined, globalPatientId: string, lastName?: string | null | undefined, patientId: number, preferredName?: string | null | undefined, ssnSerial?: string | null | undefined, suffix?: PatientSuffixEnum | null | undefined, teladocPass?: string | null | undefined, teladocUser?: string | null | undefined, fullName?: string | null | undefined } | null | undefined, primaryInsuranceRecord?: { __typename: 'InsuranceRecord', insuranceRecordId: number, packageId?: string | null | undefined, company?: string | null | undefined, planType?: string | null | undefined, memberId?: string | null | undefined, groupNumber?: string | null | undefined, relationshipToPolicyHolder?: string | null | undefined, policyHolderFirstName?: string | null | undefined, policyHolderLastName?: string | null | undefined, policyHolderGender?: SexEnum | null | undefined, policyHolderDob?: any | null | undefined, attachmentFrontUrl?: any | null | undefined, attachmentBackUrl?: any | null | undefined, noInsuranceCards?: boolean | null | undefined } | null | undefined, secondaryInsuranceRecord?: { __typename: 'InsuranceRecord', insuranceRecordId: number, packageId?: string | null | undefined, company?: string | null | undefined, planType?: string | null | undefined, memberId?: string | null | undefined, groupNumber?: string | null | undefined, relationshipToPolicyHolder?: string | null | undefined, policyHolderFirstName?: string | null | undefined, policyHolderLastName?: string | null | undefined, policyHolderGender?: SexEnum | null | undefined, policyHolderDob?: any | null | undefined, attachmentFrontUrl?: any | null | undefined, attachmentBackUrl?: any | null | undefined, noInsuranceCards?: boolean | null | undefined } | null | undefined } | null | undefined, encounterTaskAttachmentsList: Array<{ __typename: 'EncounterTaskAttachment', createdAt: any, description?: string | null | undefined, encounterId?: number | null | undefined, encounterTaskAttachmentId: number, encounterTaskId?: number | null | undefined, isDeleted: boolean, isRequired: boolean, type: EncounterTaskAttachmentTypeEnum, url?: string | null | undefined, patientId?: number | null | undefined }>, modifiedByResponders?: Array<{ __typename: 'User', credentials?: Array<CredentialsEnum | null | undefined> | null | undefined, firstName?: string | null | undefined, lastName?: string | null | undefined, userId: number } | null | undefined> | null | undefined, patientAllergyList?: Array<{ __typename: 'PatientAllergy', patientAllergyId: number, isDeleted: boolean, startedAt: any, allergy?: { __typename: 'Allergy', allergyId: number, code: string, name: string, allergyType?: { __typename: 'AllergyType', name: string } | null | undefined } | null | undefined, allergicReaction?: { __typename: 'AllergicReaction', allergicReactionId: number, code: string, name: string } | null | undefined } | null | undefined> | null | undefined, billingDiagnosticsList?: Array<{ __typename: 'BillingDiagnostic', encounterTaskId?: number | null | undefined, deletedAt?: any | null | undefined, procedureCodeReference?: { __typename: 'ProcedureCodeReference', code: string, name: string, procedureCodeReferenceId: number } | null | undefined }>, chiefComplaintAndHpi?: { __typename: 'ChiefComplaintAndHpi', chiefComplaint?: string | null | undefined, chiefComplaintAndHpiId: number, historyOfPresentIllness?: string | null | undefined } | null | undefined, reviewOfSystems?: Array<{ __typename: 'ReviewOfSystemPayload', template?: ReviewOfSystemTemplateEnum | null | undefined, systems?: Array<{ __typename: 'ReviewOfSystemSystemPayload', note?: string | null | undefined, system: ReviewOfSystemSystemEnum, evaluations: Array<{ __typename: 'ReviewOfSystemEvaluationPayload', key: string, value: boolean } | null | undefined> } | null | undefined> | null | undefined } | null | undefined> | null | undefined, patientForm?: { __typename: 'PatientForm', fieldResponse?: any | null | undefined, fieldResponseJson?: any | null | undefined, formstackId?: string | null | undefined, patientFormId: number, signedAt?: any | null | undefined } | null | undefined, patientFormLookup?: { __typename: 'PatientFormLookup', patientFormLookupId: number, title?: string | null | undefined, formUrl?: string | null | undefined } | null | undefined, medicalDecisionMaking?: { __typename: 'MedicalDecisionMaking', medicalDecisionMakingId: number, note?: string | null | undefined } | null | undefined, patientDiagnosesList?: Array<{ __typename: 'PatientDiagnosis', isDeleted: boolean, order: number, patientDiagnosisId: number, diagnosisCodeReference?: { __typename: 'DiagnosisCodeReference', diagnosisCodeReferenceId: number, name: string, code: string } | null | undefined }>, patientInstructions?: Array<{ __typename: 'PatientInstruction', patientInstructionId: number, careInstructions?: string | null | undefined, type: PatientInstructionTypeEnum, isDeleted: boolean } | null | undefined> | null | undefined, patientProblemList?: Array<{ __typename: 'PatientProblem', createdAt: any, isDeleted: boolean, patientProblemId: number, problemText?: string | null | undefined, startedAt?: any | null | undefined } | null | undefined> | null | undefined, physicalExam?: { __typename: 'PhysicalExam', physicalExamId: number, note?: string | null | undefined } | null | undefined, pointOfCareTest?: { __typename: 'PointOfCareTest', clinicianFirstName?: string | null | undefined, clinicianId?: number | null | undefined, clinicianLastName?: string | null | undefined, expirationDate?: any | null | undefined, humidity?: number | null | undefined, internalControlAcceptable?: boolean | null | undefined, isDeleted: boolean, lotNumber?: string | null | undefined, pointOfCareTestId: number, pointOfCareTestLookupId: number, result?: string | null | undefined, standingOrderAddedAt?: any | null | undefined, standingOrderId?: number | null | undefined, temperature?: number | null | undefined, criticalValueConfirmations?: Array<{ __typename: 'PoctCriticalValueConfirmation', attestedAt: any, attestedBy: number, operatingAsRole: UserRoleEnum, user?: { __typename: 'User', credentials?: Array<CredentialsEnum | null | undefined> | null | undefined, firstName?: string | null | undefined, lastName?: string | null | undefined, fullName?: string | null | undefined, userId: number } | null | undefined } | null | undefined> | null | undefined, standingOrder?: { __typename: 'StandingOrder', clinicianId: number, diagnosisCodes?: Array<string | null | undefined> | null | undefined, name: string, number: string, orderUrl: string, lookupId?: number | null | undefined, lookupType?: StandingOrderLookupTypeEnum | null | undefined, procedureCodes?: Array<string | null | undefined> | null | undefined, standingOrderId: number, startedAt?: any | null | undefined, endedAt?: any | null | undefined, state: StateEnum, version: string, clinician?: { __typename: 'User', userId: number, firstName?: string | null | undefined, lastName?: string | null | undefined } | null | undefined } | null | undefined } | null | undefined, pointOfCareTestLookup?: { __typename: 'PointOfCareTestLookup', code?: string | null | undefined, name: string, pointOfCareTestCategory: PointOfCareTestCategoryEnum, pointOfCareTestLookupId: number, system?: string | null | undefined, unit?: string | null | undefined, standingOrders?: Array<{ __typename: 'StandingOrder', clinicianId: number, diagnosisCodes?: Array<string | null | undefined> | null | undefined, name: string, number: string, orderUrl: string, lookupId?: number | null | undefined, lookupType?: StandingOrderLookupTypeEnum | null | undefined, procedureCodes?: Array<string | null | undefined> | null | undefined, standingOrderId: number, startedAt?: any | null | undefined, endedAt?: any | null | undefined, state: StateEnum, version: string, clinician?: { __typename: 'User', userId: number, firstName?: string | null | undefined, lastName?: string | null | undefined } | null | undefined } | null | undefined> | null | undefined } | null | undefined, progressNote?: { __typename: 'ProgressNote', note?: string | null | undefined, progressNoteId: number } | null | undefined, telehealthMeeting?: { __typename: 'TelehealthMeeting', telehealthMeetingId: number, alternateConnectionMethod?: TelehealthMeetingAlternateConnectionMethodEnum | null | undefined, alternateConnectionReason?: string | null | undefined, clinicianClaimedAt?: any | null | undefined, inQueueAt?: any | null | undefined, clinician?: { __typename: 'User', userId: number, firstName?: string | null | undefined, lastName?: string | null | undefined } | null | undefined, videoConference?: { __typename: 'VideoConference', videoConferenceId: number, status?: VideoConferenceStatusEnum | null | undefined, hostUrl: string, participantUrl: string, meetingStartTime?: any | null | undefined, meetingEndTime?: any | null | undefined, meetingId: any } | null | undefined } | null | undefined, vaccine?: { __typename: 'Vaccine', doseNumber?: number | null | undefined, adverseReactions?: Array<VaccineAdverseReactionEnum | null | undefined> | null | undefined, hadAdverseReaction?: boolean | null | undefined, contraindication?: boolean | null | undefined, location?: VaccineLocationEnum | null | undefined, lotExpiration?: any | null | undefined, lotNumber?: string | null | undefined, otherAdverseReactions?: string | null | undefined, orderedBy?: number | null | undefined, standingOrderAddedAt?: any | null | undefined, standingOrderId?: number | null | undefined, totalDoses?: number | null | undefined, vaccineId: number, vaccineLookupId: number, visEdition?: any | null | undefined, visReceived?: boolean | null | undefined, standingOrder?: { __typename: 'StandingOrder', clinicianId: number, diagnosisCodes?: Array<string | null | undefined> | null | undefined, name: string, number: string, orderUrl: string, lookupId?: number | null | undefined, lookupType?: StandingOrderLookupTypeEnum | null | undefined, procedureCodes?: Array<string | null | undefined> | null | undefined, standingOrderId: number, startedAt?: any | null | undefined, endedAt?: any | null | undefined, state: StateEnum, version: string, clinician?: { __typename: 'User', userId: number, firstName?: string | null | undefined, lastName?: string | null | undefined } | null | undefined } | null | undefined } | null | undefined, vaccineLookups?: Array<{ __typename: 'VaccineLookup', vaccineLookupId: number, doseQuantity: any, doseUnits: string, drug?: { __typename: 'Drug', drugId: number, drugName: string, manufacturerName: string, routeName: string } | null | undefined, standingOrders?: Array<{ __typename: 'StandingOrder', clinicianId: number, diagnosisCodes?: Array<string | null | undefined> | null | undefined, name: string, number: string, orderUrl: string, lookupId?: number | null | undefined, lookupType?: StandingOrderLookupTypeEnum | null | undefined, procedureCodes?: Array<string | null | undefined> | null | undefined, standingOrderId: number, startedAt?: any | null | undefined, endedAt?: any | null | undefined, state: StateEnum, version: string, clinician?: { __typename: 'User', userId: number, firstName?: string | null | undefined, lastName?: string | null | undefined } | null | undefined } | null | undefined> | null | undefined } | null | undefined> | null | undefined, vitalsList?: Array<{ __typename: 'Vital', vitalId: number, result: string, vitalLookup?: { __typename: 'VitalLookup', name?: string | null | undefined, unit?: string | null | undefined, vitalCategory: VitalCategoryEnum, vitalLookupId: number, vitalType: VitalLookupTypeEnum } | null | undefined }> } | null | undefined } | null | undefined };

export type UpdateEncounterTaskAttachmentMutationVariables = Exact<{
  input: UpdateEncounterTaskAttachmentInput;
}>;


export type UpdateEncounterTaskAttachmentMutation = { __typename: 'Mutation', updateEncounterTaskAttachment?: { __typename: 'UpdateEncounterTaskAttachmentPayload', encounterTask?: { __typename: 'EncounterTask', assigneeId?: number | null | undefined, dataCategory?: string | null | undefined, dataType: string, encounterTaskId: number, group: string, inProgressAt?: any | null | undefined, patientId: number, responderCompletedAt?: any | null | undefined, responderCompletedBy?: number | null | undefined, skippedReason?: string | null | undefined, status?: EncounterTaskStatusEnum | null | undefined, taskName: string, taskRoles: Array<UserRoleEnum | null | undefined>, updatedAt?: any | null | undefined, corrections?: Array<{ __typename: 'EncounterTaskCorrection', correctionReason: string, createdAt: any, createdBy: number, jsonValue: any } | null | undefined> | null | undefined, diagnosisCodeReferencesByPatientDiagnosisEncounterTaskIdAndDiagnosisCodeReferenceIdList: Array<{ __typename: 'DiagnosisCodeReference', code: string, name: string }>, encounter?: { __typename: 'Encounter', activation?: ActivationEnum | null | undefined, clinicianIncluded?: boolean | null | undefined, clinicianStatus?: EncounterClinicianStatusEnum | null | undefined, disposition?: DispositionEnum | null | undefined, encounterId: number, modules?: Array<ModuleNameEnum | null | undefined> | null | undefined, responderStatus?: EncounterResponderStatusEnum | null | undefined, humanizedModuleEncounterTags?: Array<string | null | undefined> | null | undefined, serviceLine?: { __typename: 'ServiceLine', name: string, serviceLineId: number, subType: string } | null | undefined, appointment?: { __typename: 'Appointment', appointmentId: number, scheduledFor: any, state?: string | null | undefined, market?: { __typename: 'Market', marketId: number } | null | undefined } | null | undefined, clinician?: { __typename: 'User', firstName?: string | null | undefined, lastName?: string | null | undefined, userId: number } | null | undefined, patient?: { __typename: 'Patient', age?: number | null | undefined, dob?: any | null | undefined, firstName?: string | null | undefined, humanizedGenderIdentity?: string | null | undefined, humanizedGenderPronoun?: string | null | undefined, humanizedRaces?: Array<string | null | undefined> | null | undefined, humanizedSex?: string | null | undefined, globalPatientId: string, lastName?: string | null | undefined, patientId: number, preferredName?: string | null | undefined, ssnSerial?: string | null | undefined, suffix?: PatientSuffixEnum | null | undefined, teladocPass?: string | null | undefined, teladocUser?: string | null | undefined, fullName?: string | null | undefined } | null | undefined } | null | undefined, encounterTaskAttachmentsList: Array<{ __typename: 'EncounterTaskAttachment', createdAt: any, description?: string | null | undefined, encounterId?: number | null | undefined, encounterTaskAttachmentId: number, encounterTaskId?: number | null | undefined, isDeleted: boolean, isRequired: boolean, type: EncounterTaskAttachmentTypeEnum, url?: string | null | undefined, patientId?: number | null | undefined }>, modifiedByResponders?: Array<{ __typename: 'User', credentials?: Array<CredentialsEnum | null | undefined> | null | undefined, firstName?: string | null | undefined, lastName?: string | null | undefined, userId: number } | null | undefined> | null | undefined } | null | undefined } | null | undefined };

export type UpsertEncounterTaskMutationVariables = Exact<{
  input: UpsertEncounterTaskInput;
  isAllergiesTask?: InputMaybe<Scalars['Boolean']>;
  isChiefComplaintAndHpiTask?: InputMaybe<Scalars['Boolean']>;
  isClinicianBillingTask?: InputMaybe<Scalars['Boolean']>;
  isDispositionTask?: InputMaybe<Scalars['Boolean']>;
  isMedicalConditionTask?: InputMaybe<Scalars['Boolean']>;
  isMedicalDecisionMakingTask?: InputMaybe<Scalars['Boolean']>;
  isPatientFormTask?: InputMaybe<Scalars['Boolean']>;
  isPaymentMethodTask?: InputMaybe<Scalars['Boolean']>;
  isPhysicalExamTask?: InputMaybe<Scalars['Boolean']>;
  isPointOfCareTestTask?: InputMaybe<Scalars['Boolean']>;
  isProgressNoteTask?: InputMaybe<Scalars['Boolean']>;
  isTelehealthTask?: InputMaybe<Scalars['Boolean']>;
  isVaccineTask?: InputMaybe<Scalars['Boolean']>;
  isVitalTask?: InputMaybe<Scalars['Boolean']>;
}>;


export type UpsertEncounterTaskMutation = { __typename: 'Mutation', upsertEncounterTask?: { __typename: 'UpsertEncounterTaskPayload', encounterTask?: { __typename: 'EncounterTask', assigneeId?: number | null | undefined, dataCategory?: string | null | undefined, dataType: string, encounterTaskId: number, group: string, inProgressAt?: any | null | undefined, patientId: number, responderCompletedAt?: any | null | undefined, responderCompletedBy?: number | null | undefined, skippedReason?: string | null | undefined, status?: EncounterTaskStatusEnum | null | undefined, taskName: string, taskRoles: Array<UserRoleEnum | null | undefined>, updatedAt?: any | null | undefined, corrections?: Array<{ __typename: 'EncounterTaskCorrection', correctionReason: string, createdAt: any, createdBy: number, jsonValue: any } | null | undefined> | null | undefined, diagnosisCodeReferencesByPatientDiagnosisEncounterTaskIdAndDiagnosisCodeReferenceIdList: Array<{ __typename: 'DiagnosisCodeReference', code: string, name: string }>, encounter?: { __typename: 'Encounter', activation?: ActivationEnum | null | undefined, clinicianIncluded?: boolean | null | undefined, clinicianStatus?: EncounterClinicianStatusEnum | null | undefined, disposition?: DispositionEnum | null | undefined, encounterId: number, modules?: Array<ModuleNameEnum | null | undefined> | null | undefined, responderStatus?: EncounterResponderStatusEnum | null | undefined, humanizedModuleEncounterTags?: Array<string | null | undefined> | null | undefined, paymentMode?: EncounterPaymentModeEnum | null | undefined, noInsuranceReason?: NoInsuranceReasonEnum | null | undefined, stripeId?: string | null | undefined, serviceLine?: { __typename: 'ServiceLine', name: string, serviceLineId: number, subType: string } | null | undefined, appointment?: { __typename: 'Appointment', appointmentId: number, scheduledFor: any, state?: string | null | undefined, market?: { __typename: 'Market', marketId: number } | null | undefined } | null | undefined, clinician?: { __typename: 'User', firstName?: string | null | undefined, lastName?: string | null | undefined, userId: number } | null | undefined, patient?: { __typename: 'Patient', age?: number | null | undefined, dob?: any | null | undefined, firstName?: string | null | undefined, humanizedGenderIdentity?: string | null | undefined, humanizedGenderPronoun?: string | null | undefined, humanizedRaces?: Array<string | null | undefined> | null | undefined, humanizedSex?: string | null | undefined, globalPatientId: string, lastName?: string | null | undefined, patientId: number, preferredName?: string | null | undefined, ssnSerial?: string | null | undefined, suffix?: PatientSuffixEnum | null | undefined, teladocPass?: string | null | undefined, teladocUser?: string | null | undefined, fullName?: string | null | undefined } | null | undefined, primaryInsuranceRecord?: { __typename: 'InsuranceRecord', insuranceRecordId: number, packageId?: string | null | undefined, company?: string | null | undefined, planType?: string | null | undefined, memberId?: string | null | undefined, groupNumber?: string | null | undefined, relationshipToPolicyHolder?: string | null | undefined, policyHolderFirstName?: string | null | undefined, policyHolderLastName?: string | null | undefined, policyHolderGender?: SexEnum | null | undefined, policyHolderDob?: any | null | undefined, attachmentFrontUrl?: any | null | undefined, attachmentBackUrl?: any | null | undefined, noInsuranceCards?: boolean | null | undefined } | null | undefined, secondaryInsuranceRecord?: { __typename: 'InsuranceRecord', insuranceRecordId: number, packageId?: string | null | undefined, company?: string | null | undefined, planType?: string | null | undefined, memberId?: string | null | undefined, groupNumber?: string | null | undefined, relationshipToPolicyHolder?: string | null | undefined, policyHolderFirstName?: string | null | undefined, policyHolderLastName?: string | null | undefined, policyHolderGender?: SexEnum | null | undefined, policyHolderDob?: any | null | undefined, attachmentFrontUrl?: any | null | undefined, attachmentBackUrl?: any | null | undefined, noInsuranceCards?: boolean | null | undefined } | null | undefined } | null | undefined, encounterTaskAttachmentsList: Array<{ __typename: 'EncounterTaskAttachment', createdAt: any, description?: string | null | undefined, encounterId?: number | null | undefined, encounterTaskAttachmentId: number, encounterTaskId?: number | null | undefined, isDeleted: boolean, isRequired: boolean, type: EncounterTaskAttachmentTypeEnum, url?: string | null | undefined, patientId?: number | null | undefined }>, modifiedByResponders?: Array<{ __typename: 'User', credentials?: Array<CredentialsEnum | null | undefined> | null | undefined, firstName?: string | null | undefined, lastName?: string | null | undefined, userId: number } | null | undefined> | null | undefined, patientAllergyList?: Array<{ __typename: 'PatientAllergy', patientAllergyId: number, isDeleted: boolean, startedAt: any, allergy?: { __typename: 'Allergy', allergyId: number, code: string, name: string, allergyType?: { __typename: 'AllergyType', name: string } | null | undefined } | null | undefined, allergicReaction?: { __typename: 'AllergicReaction', allergicReactionId: number, code: string, name: string } | null | undefined } | null | undefined> | null | undefined, billingDiagnosticsList?: Array<{ __typename: 'BillingDiagnostic', encounterTaskId?: number | null | undefined, deletedAt?: any | null | undefined, procedureCodeReference?: { __typename: 'ProcedureCodeReference', code: string, name: string, procedureCodeReferenceId: number } | null | undefined }>, chiefComplaintAndHpi?: { __typename: 'ChiefComplaintAndHpi', chiefComplaint?: string | null | undefined, chiefComplaintAndHpiId: number, historyOfPresentIllness?: string | null | undefined } | null | undefined, reviewOfSystems?: Array<{ __typename: 'ReviewOfSystemPayload', template?: ReviewOfSystemTemplateEnum | null | undefined, systems?: Array<{ __typename: 'ReviewOfSystemSystemPayload', note?: string | null | undefined, system: ReviewOfSystemSystemEnum, evaluations: Array<{ __typename: 'ReviewOfSystemEvaluationPayload', key: string, value: boolean } | null | undefined> } | null | undefined> | null | undefined } | null | undefined> | null | undefined, patientForm?: { __typename: 'PatientForm', fieldResponse?: any | null | undefined, fieldResponseJson?: any | null | undefined, formstackId?: string | null | undefined, patientFormId: number, signedAt?: any | null | undefined } | null | undefined, patientFormLookup?: { __typename: 'PatientFormLookup', patientFormLookupId: number, title?: string | null | undefined, formUrl?: string | null | undefined } | null | undefined, medicalDecisionMaking?: { __typename: 'MedicalDecisionMaking', medicalDecisionMakingId: number, note?: string | null | undefined } | null | undefined, patientDiagnosesList?: Array<{ __typename: 'PatientDiagnosis', isDeleted: boolean, order: number, patientDiagnosisId: number, diagnosisCodeReference?: { __typename: 'DiagnosisCodeReference', diagnosisCodeReferenceId: number, name: string, code: string } | null | undefined }>, patientInstructions?: Array<{ __typename: 'PatientInstruction', patientInstructionId: number, careInstructions?: string | null | undefined, type: PatientInstructionTypeEnum, isDeleted: boolean } | null | undefined> | null | undefined, patientProblemList?: Array<{ __typename: 'PatientProblem', createdAt: any, isDeleted: boolean, patientProblemId: number, problemText?: string | null | undefined, startedAt?: any | null | undefined } | null | undefined> | null | undefined, physicalExam?: { __typename: 'PhysicalExam', physicalExamId: number, note?: string | null | undefined } | null | undefined, pointOfCareTest?: { __typename: 'PointOfCareTest', clinicianFirstName?: string | null | undefined, clinicianId?: number | null | undefined, clinicianLastName?: string | null | undefined, expirationDate?: any | null | undefined, humidity?: number | null | undefined, internalControlAcceptable?: boolean | null | undefined, isDeleted: boolean, lotNumber?: string | null | undefined, pointOfCareTestId: number, pointOfCareTestLookupId: number, result?: string | null | undefined, standingOrderAddedAt?: any | null | undefined, standingOrderId?: number | null | undefined, temperature?: number | null | undefined, criticalValueConfirmations?: Array<{ __typename: 'PoctCriticalValueConfirmation', attestedAt: any, attestedBy: number, operatingAsRole: UserRoleEnum, user?: { __typename: 'User', credentials?: Array<CredentialsEnum | null | undefined> | null | undefined, firstName?: string | null | undefined, lastName?: string | null | undefined, fullName?: string | null | undefined, userId: number } | null | undefined } | null | undefined> | null | undefined, standingOrder?: { __typename: 'StandingOrder', clinicianId: number, diagnosisCodes?: Array<string | null | undefined> | null | undefined, name: string, number: string, orderUrl: string, lookupId?: number | null | undefined, lookupType?: StandingOrderLookupTypeEnum | null | undefined, procedureCodes?: Array<string | null | undefined> | null | undefined, standingOrderId: number, startedAt?: any | null | undefined, endedAt?: any | null | undefined, state: StateEnum, version: string, clinician?: { __typename: 'User', userId: number, firstName?: string | null | undefined, lastName?: string | null | undefined } | null | undefined } | null | undefined } | null | undefined, pointOfCareTestLookup?: { __typename: 'PointOfCareTestLookup', code?: string | null | undefined, name: string, pointOfCareTestCategory: PointOfCareTestCategoryEnum, pointOfCareTestLookupId: number, system?: string | null | undefined, unit?: string | null | undefined, standingOrders?: Array<{ __typename: 'StandingOrder', clinicianId: number, diagnosisCodes?: Array<string | null | undefined> | null | undefined, name: string, number: string, orderUrl: string, lookupId?: number | null | undefined, lookupType?: StandingOrderLookupTypeEnum | null | undefined, procedureCodes?: Array<string | null | undefined> | null | undefined, standingOrderId: number, startedAt?: any | null | undefined, endedAt?: any | null | undefined, state: StateEnum, version: string, clinician?: { __typename: 'User', userId: number, firstName?: string | null | undefined, lastName?: string | null | undefined } | null | undefined } | null | undefined> | null | undefined } | null | undefined, progressNote?: { __typename: 'ProgressNote', note?: string | null | undefined, progressNoteId: number } | null | undefined, telehealthMeeting?: { __typename: 'TelehealthMeeting', telehealthMeetingId: number, alternateConnectionMethod?: TelehealthMeetingAlternateConnectionMethodEnum | null | undefined, alternateConnectionReason?: string | null | undefined, clinicianClaimedAt?: any | null | undefined, inQueueAt?: any | null | undefined, clinician?: { __typename: 'User', userId: number, firstName?: string | null | undefined, lastName?: string | null | undefined } | null | undefined, videoConference?: { __typename: 'VideoConference', videoConferenceId: number, status?: VideoConferenceStatusEnum | null | undefined, hostUrl: string, participantUrl: string, meetingStartTime?: any | null | undefined, meetingEndTime?: any | null | undefined, meetingId: any } | null | undefined } | null | undefined, vaccine?: { __typename: 'Vaccine', doseNumber?: number | null | undefined, adverseReactions?: Array<VaccineAdverseReactionEnum | null | undefined> | null | undefined, hadAdverseReaction?: boolean | null | undefined, contraindication?: boolean | null | undefined, location?: VaccineLocationEnum | null | undefined, lotExpiration?: any | null | undefined, lotNumber?: string | null | undefined, otherAdverseReactions?: string | null | undefined, orderedBy?: number | null | undefined, standingOrderAddedAt?: any | null | undefined, standingOrderId?: number | null | undefined, totalDoses?: number | null | undefined, vaccineId: number, vaccineLookupId: number, visEdition?: any | null | undefined, visReceived?: boolean | null | undefined, standingOrder?: { __typename: 'StandingOrder', clinicianId: number, diagnosisCodes?: Array<string | null | undefined> | null | undefined, name: string, number: string, orderUrl: string, lookupId?: number | null | undefined, lookupType?: StandingOrderLookupTypeEnum | null | undefined, procedureCodes?: Array<string | null | undefined> | null | undefined, standingOrderId: number, startedAt?: any | null | undefined, endedAt?: any | null | undefined, state: StateEnum, version: string, clinician?: { __typename: 'User', userId: number, firstName?: string | null | undefined, lastName?: string | null | undefined } | null | undefined } | null | undefined } | null | undefined, vaccineLookups?: Array<{ __typename: 'VaccineLookup', vaccineLookupId: number, doseQuantity: any, doseUnits: string, drug?: { __typename: 'Drug', drugId: number, drugName: string, manufacturerName: string, routeName: string } | null | undefined, standingOrders?: Array<{ __typename: 'StandingOrder', clinicianId: number, diagnosisCodes?: Array<string | null | undefined> | null | undefined, name: string, number: string, orderUrl: string, lookupId?: number | null | undefined, lookupType?: StandingOrderLookupTypeEnum | null | undefined, procedureCodes?: Array<string | null | undefined> | null | undefined, standingOrderId: number, startedAt?: any | null | undefined, endedAt?: any | null | undefined, state: StateEnum, version: string, clinician?: { __typename: 'User', userId: number, firstName?: string | null | undefined, lastName?: string | null | undefined } | null | undefined } | null | undefined> | null | undefined } | null | undefined> | null | undefined, vitalsList?: Array<{ __typename: 'Vital', vitalId: number, result: string, vitalLookup?: { __typename: 'VitalLookup', name?: string | null | undefined, unit?: string | null | undefined, vitalCategory: VitalCategoryEnum, vitalLookupId: number, vitalType: VitalLookupTypeEnum } | null | undefined }> } | null | undefined } | null | undefined };

export type CreateAddOnTaskQueryVariables = Exact<{
  id: Scalars['Int'];
  moduleName: ModuleNameEnum;
}>;


export type CreateAddOnTaskQuery = { __typename: 'Query', createAddOnTask: { __typename: 'Encounter', claimedAt?: any | null | undefined, clinicianIncluded?: boolean | null | undefined, clinicianStatus?: EncounterClinicianStatusEnum | null | undefined, disposition?: DispositionEnum | null | undefined, encounterId: number, inQueueAt?: any | null | undefined, migrationSource?: string | null | undefined, modules?: Array<ModuleNameEnum | null | undefined> | null | undefined, reasonForEncounter?: string | null | undefined, responderStatus?: EncounterResponderStatusEnum | null | undefined, humanizedClinicianStatus?: string | null | undefined, humanizedModuleEncounterTags?: Array<string | null | undefined> | null | undefined, humanizedResponderStatus?: string | null | undefined, visitId?: string | null | undefined, channelAttribution?: { __typename: 'ChannelAttribution', channel: string, channelAttributionId: number, institutionType: ChannelAttributionInstitutionTypeEnum } | null | undefined, clinician?: { __typename: 'User', userId: number, firstName?: string | null | undefined, lastName?: string | null | undefined, fullName?: string | null | undefined } | null | undefined, serviceLine?: { __typename: 'ServiceLine', name: string, subType: string, serviceLineId: number } | null | undefined, primaryInsuranceRecord?: { __typename: 'InsuranceRecord', insuranceRecordId: number, company?: string | null | undefined } | null | undefined, encounterSignatures: { __typename: 'EncounterSignaturesConnection', nodes: Array<{ __typename: 'EncounterSignature', createdAt: any, operatingAsRole?: UserRoleEnum | null | undefined, user?: { __typename: 'User', userId: number, firstName?: string | null | undefined, lastName?: string | null | undefined, fullName?: string | null | undefined } | null | undefined }> }, addendaList: Array<{ __typename: 'Addendum', addendumId: number, createdAt: any, createdBy: number, note: string, deletedAt?: any | null | undefined, deletedBy?: number | null | undefined, user?: { __typename: 'User', userId: number, firstName?: string | null | undefined, lastName?: string | null | undefined, fullName?: string | null | undefined } | null | undefined }> } };

export type GetEncounterTaskAttachmentsByEncounterTaskIdQueryVariables = Exact<{
  id?: InputMaybe<Array<InputMaybe<Scalars['Int']>> | InputMaybe<Scalars['Int']>>;
}>;


export type GetEncounterTaskAttachmentsByEncounterTaskIdQuery = { __typename: 'Query', encounterTaskAttachmentsList?: Array<{ __typename: 'EncounterTaskAttachment', createdAt: any, description?: string | null | undefined, encounterId?: number | null | undefined, encounterTaskAttachmentId: number, encounterTaskId?: number | null | undefined, isDeleted: boolean, isRequired: boolean, type: EncounterTaskAttachmentTypeEnum, url?: string | null | undefined, patientId?: number | null | undefined }> | null | undefined };

export type GetEncounterTaskByEncounterTaskIdQueryVariables = Exact<{
  id: Scalars['Int'];
  isAllergiesTask?: InputMaybe<Scalars['Boolean']>;
  isChiefComplaintAndHpiTask?: InputMaybe<Scalars['Boolean']>;
  isClinicianBillingTask?: InputMaybe<Scalars['Boolean']>;
  isDispositionTask?: InputMaybe<Scalars['Boolean']>;
  isMedicalConditionTask?: InputMaybe<Scalars['Boolean']>;
  isMedicalDecisionMakingTask?: InputMaybe<Scalars['Boolean']>;
  isPatientFormTask?: InputMaybe<Scalars['Boolean']>;
  isPaymentMethodTask?: InputMaybe<Scalars['Boolean']>;
  isPhysicalExamTask?: InputMaybe<Scalars['Boolean']>;
  isPointOfCareTestTask?: InputMaybe<Scalars['Boolean']>;
  isProgressNoteTask?: InputMaybe<Scalars['Boolean']>;
  isTelehealthTask?: InputMaybe<Scalars['Boolean']>;
  isVaccineTask?: InputMaybe<Scalars['Boolean']>;
  isVitalTask?: InputMaybe<Scalars['Boolean']>;
}>;


export type GetEncounterTaskByEncounterTaskIdQuery = { __typename: 'Query', encounterTask?: { __typename: 'EncounterTask', assigneeId?: number | null | undefined, dataCategory?: string | null | undefined, dataType: string, encounterTaskId: number, group: string, inProgressAt?: any | null | undefined, patientId: number, responderCompletedAt?: any | null | undefined, responderCompletedBy?: number | null | undefined, skippedReason?: string | null | undefined, status?: EncounterTaskStatusEnum | null | undefined, taskName: string, taskRoles: Array<UserRoleEnum | null | undefined>, updatedAt?: any | null | undefined, corrections?: Array<{ __typename: 'EncounterTaskCorrection', correctionReason: string, createdAt: any, createdBy: number, jsonValue: any } | null | undefined> | null | undefined, diagnosisCodeReferencesByPatientDiagnosisEncounterTaskIdAndDiagnosisCodeReferenceIdList: Array<{ __typename: 'DiagnosisCodeReference', code: string, name: string }>, encounter?: { __typename: 'Encounter', activation?: ActivationEnum | null | undefined, clinicianIncluded?: boolean | null | undefined, clinicianStatus?: EncounterClinicianStatusEnum | null | undefined, disposition?: DispositionEnum | null | undefined, encounterId: number, modules?: Array<ModuleNameEnum | null | undefined> | null | undefined, responderStatus?: EncounterResponderStatusEnum | null | undefined, humanizedModuleEncounterTags?: Array<string | null | undefined> | null | undefined, paymentMode?: EncounterPaymentModeEnum | null | undefined, noInsuranceReason?: NoInsuranceReasonEnum | null | undefined, stripeId?: string | null | undefined, serviceLine?: { __typename: 'ServiceLine', name: string, serviceLineId: number, subType: string } | null | undefined, appointment?: { __typename: 'Appointment', appointmentId: number, scheduledFor: any, state?: string | null | undefined, market?: { __typename: 'Market', marketId: number } | null | undefined } | null | undefined, clinician?: { __typename: 'User', firstName?: string | null | undefined, lastName?: string | null | undefined, userId: number } | null | undefined, patient?: { __typename: 'Patient', age?: number | null | undefined, dob?: any | null | undefined, firstName?: string | null | undefined, humanizedGenderIdentity?: string | null | undefined, humanizedGenderPronoun?: string | null | undefined, humanizedRaces?: Array<string | null | undefined> | null | undefined, humanizedSex?: string | null | undefined, globalPatientId: string, lastName?: string | null | undefined, patientId: number, preferredName?: string | null | undefined, ssnSerial?: string | null | undefined, suffix?: PatientSuffixEnum | null | undefined, teladocPass?: string | null | undefined, teladocUser?: string | null | undefined, fullName?: string | null | undefined } | null | undefined, primaryInsuranceRecord?: { __typename: 'InsuranceRecord', insuranceRecordId: number, packageId?: string | null | undefined, company?: string | null | undefined, planType?: string | null | undefined, memberId?: string | null | undefined, groupNumber?: string | null | undefined, relationshipToPolicyHolder?: string | null | undefined, policyHolderFirstName?: string | null | undefined, policyHolderLastName?: string | null | undefined, policyHolderGender?: SexEnum | null | undefined, policyHolderDob?: any | null | undefined, attachmentFrontUrl?: any | null | undefined, attachmentBackUrl?: any | null | undefined, noInsuranceCards?: boolean | null | undefined } | null | undefined, secondaryInsuranceRecord?: { __typename: 'InsuranceRecord', insuranceRecordId: number, packageId?: string | null | undefined, company?: string | null | undefined, planType?: string | null | undefined, memberId?: string | null | undefined, groupNumber?: string | null | undefined, relationshipToPolicyHolder?: string | null | undefined, policyHolderFirstName?: string | null | undefined, policyHolderLastName?: string | null | undefined, policyHolderGender?: SexEnum | null | undefined, policyHolderDob?: any | null | undefined, attachmentFrontUrl?: any | null | undefined, attachmentBackUrl?: any | null | undefined, noInsuranceCards?: boolean | null | undefined } | null | undefined } | null | undefined, encounterTaskAttachmentsList: Array<{ __typename: 'EncounterTaskAttachment', createdAt: any, description?: string | null | undefined, encounterId?: number | null | undefined, encounterTaskAttachmentId: number, encounterTaskId?: number | null | undefined, isDeleted: boolean, isRequired: boolean, type: EncounterTaskAttachmentTypeEnum, url?: string | null | undefined, patientId?: number | null | undefined }>, modifiedByResponders?: Array<{ __typename: 'User', credentials?: Array<CredentialsEnum | null | undefined> | null | undefined, firstName?: string | null | undefined, lastName?: string | null | undefined, userId: number } | null | undefined> | null | undefined, patientAllergyList?: Array<{ __typename: 'PatientAllergy', patientAllergyId: number, isDeleted: boolean, startedAt: any, allergy?: { __typename: 'Allergy', allergyId: number, code: string, name: string, allergyType?: { __typename: 'AllergyType', name: string } | null | undefined } | null | undefined, allergicReaction?: { __typename: 'AllergicReaction', allergicReactionId: number, code: string, name: string } | null | undefined } | null | undefined> | null | undefined, billingDiagnosticsList?: Array<{ __typename: 'BillingDiagnostic', encounterTaskId?: number | null | undefined, deletedAt?: any | null | undefined, procedureCodeReference?: { __typename: 'ProcedureCodeReference', code: string, name: string, procedureCodeReferenceId: number } | null | undefined }>, chiefComplaintAndHpi?: { __typename: 'ChiefComplaintAndHpi', chiefComplaint?: string | null | undefined, chiefComplaintAndHpiId: number, historyOfPresentIllness?: string | null | undefined } | null | undefined, reviewOfSystems?: Array<{ __typename: 'ReviewOfSystemPayload', template?: ReviewOfSystemTemplateEnum | null | undefined, systems?: Array<{ __typename: 'ReviewOfSystemSystemPayload', note?: string | null | undefined, system: ReviewOfSystemSystemEnum, evaluations: Array<{ __typename: 'ReviewOfSystemEvaluationPayload', key: string, value: boolean } | null | undefined> } | null | undefined> | null | undefined } | null | undefined> | null | undefined, patientForm?: { __typename: 'PatientForm', fieldResponse?: any | null | undefined, fieldResponseJson?: any | null | undefined, formstackId?: string | null | undefined, patientFormId: number, signedAt?: any | null | undefined } | null | undefined, patientFormLookup?: { __typename: 'PatientFormLookup', patientFormLookupId: number, title?: string | null | undefined, formUrl?: string | null | undefined } | null | undefined, medicalDecisionMaking?: { __typename: 'MedicalDecisionMaking', medicalDecisionMakingId: number, note?: string | null | undefined } | null | undefined, patientDiagnosesList?: Array<{ __typename: 'PatientDiagnosis', isDeleted: boolean, order: number, patientDiagnosisId: number, diagnosisCodeReference?: { __typename: 'DiagnosisCodeReference', diagnosisCodeReferenceId: number, name: string, code: string } | null | undefined }>, patientInstructions?: Array<{ __typename: 'PatientInstruction', patientInstructionId: number, careInstructions?: string | null | undefined, type: PatientInstructionTypeEnum, isDeleted: boolean } | null | undefined> | null | undefined, patientProblemList?: Array<{ __typename: 'PatientProblem', createdAt: any, isDeleted: boolean, patientProblemId: number, problemText?: string | null | undefined, startedAt?: any | null | undefined } | null | undefined> | null | undefined, physicalExam?: { __typename: 'PhysicalExam', physicalExamId: number, note?: string | null | undefined } | null | undefined, pointOfCareTest?: { __typename: 'PointOfCareTest', clinicianFirstName?: string | null | undefined, clinicianId?: number | null | undefined, clinicianLastName?: string | null | undefined, expirationDate?: any | null | undefined, humidity?: number | null | undefined, internalControlAcceptable?: boolean | null | undefined, isDeleted: boolean, lotNumber?: string | null | undefined, pointOfCareTestId: number, pointOfCareTestLookupId: number, result?: string | null | undefined, standingOrderAddedAt?: any | null | undefined, standingOrderId?: number | null | undefined, temperature?: number | null | undefined, criticalValueConfirmations?: Array<{ __typename: 'PoctCriticalValueConfirmation', attestedAt: any, attestedBy: number, operatingAsRole: UserRoleEnum, user?: { __typename: 'User', credentials?: Array<CredentialsEnum | null | undefined> | null | undefined, firstName?: string | null | undefined, lastName?: string | null | undefined, fullName?: string | null | undefined, userId: number } | null | undefined } | null | undefined> | null | undefined, standingOrder?: { __typename: 'StandingOrder', clinicianId: number, diagnosisCodes?: Array<string | null | undefined> | null | undefined, name: string, number: string, orderUrl: string, lookupId?: number | null | undefined, lookupType?: StandingOrderLookupTypeEnum | null | undefined, procedureCodes?: Array<string | null | undefined> | null | undefined, standingOrderId: number, startedAt?: any | null | undefined, endedAt?: any | null | undefined, state: StateEnum, version: string, clinician?: { __typename: 'User', userId: number, firstName?: string | null | undefined, lastName?: string | null | undefined } | null | undefined } | null | undefined } | null | undefined, pointOfCareTestLookup?: { __typename: 'PointOfCareTestLookup', code?: string | null | undefined, name: string, pointOfCareTestCategory: PointOfCareTestCategoryEnum, pointOfCareTestLookupId: number, system?: string | null | undefined, unit?: string | null | undefined, standingOrders?: Array<{ __typename: 'StandingOrder', clinicianId: number, diagnosisCodes?: Array<string | null | undefined> | null | undefined, name: string, number: string, orderUrl: string, lookupId?: number | null | undefined, lookupType?: StandingOrderLookupTypeEnum | null | undefined, procedureCodes?: Array<string | null | undefined> | null | undefined, standingOrderId: number, startedAt?: any | null | undefined, endedAt?: any | null | undefined, state: StateEnum, version: string, clinician?: { __typename: 'User', userId: number, firstName?: string | null | undefined, lastName?: string | null | undefined } | null | undefined } | null | undefined> | null | undefined } | null | undefined, progressNote?: { __typename: 'ProgressNote', note?: string | null | undefined, progressNoteId: number } | null | undefined, telehealthMeeting?: { __typename: 'TelehealthMeeting', telehealthMeetingId: number, alternateConnectionMethod?: TelehealthMeetingAlternateConnectionMethodEnum | null | undefined, alternateConnectionReason?: string | null | undefined, clinicianClaimedAt?: any | null | undefined, inQueueAt?: any | null | undefined, clinician?: { __typename: 'User', userId: number, firstName?: string | null | undefined, lastName?: string | null | undefined } | null | undefined, videoConference?: { __typename: 'VideoConference', videoConferenceId: number, status?: VideoConferenceStatusEnum | null | undefined, hostUrl: string, participantUrl: string, meetingStartTime?: any | null | undefined, meetingEndTime?: any | null | undefined, meetingId: any } | null | undefined } | null | undefined, vaccine?: { __typename: 'Vaccine', doseNumber?: number | null | undefined, adverseReactions?: Array<VaccineAdverseReactionEnum | null | undefined> | null | undefined, hadAdverseReaction?: boolean | null | undefined, contraindication?: boolean | null | undefined, location?: VaccineLocationEnum | null | undefined, lotExpiration?: any | null | undefined, lotNumber?: string | null | undefined, otherAdverseReactions?: string | null | undefined, orderedBy?: number | null | undefined, standingOrderAddedAt?: any | null | undefined, standingOrderId?: number | null | undefined, totalDoses?: number | null | undefined, vaccineId: number, vaccineLookupId: number, visEdition?: any | null | undefined, visReceived?: boolean | null | undefined, standingOrder?: { __typename: 'StandingOrder', clinicianId: number, diagnosisCodes?: Array<string | null | undefined> | null | undefined, name: string, number: string, orderUrl: string, lookupId?: number | null | undefined, lookupType?: StandingOrderLookupTypeEnum | null | undefined, procedureCodes?: Array<string | null | undefined> | null | undefined, standingOrderId: number, startedAt?: any | null | undefined, endedAt?: any | null | undefined, state: StateEnum, version: string, clinician?: { __typename: 'User', userId: number, firstName?: string | null | undefined, lastName?: string | null | undefined } | null | undefined } | null | undefined } | null | undefined, vaccineLookups?: Array<{ __typename: 'VaccineLookup', vaccineLookupId: number, doseQuantity: any, doseUnits: string, drug?: { __typename: 'Drug', drugId: number, drugName: string, manufacturerName: string, routeName: string } | null | undefined, standingOrders?: Array<{ __typename: 'StandingOrder', clinicianId: number, diagnosisCodes?: Array<string | null | undefined> | null | undefined, name: string, number: string, orderUrl: string, lookupId?: number | null | undefined, lookupType?: StandingOrderLookupTypeEnum | null | undefined, procedureCodes?: Array<string | null | undefined> | null | undefined, standingOrderId: number, startedAt?: any | null | undefined, endedAt?: any | null | undefined, state: StateEnum, version: string, clinician?: { __typename: 'User', userId: number, firstName?: string | null | undefined, lastName?: string | null | undefined } | null | undefined } | null | undefined> | null | undefined } | null | undefined> | null | undefined, vitalsList?: Array<{ __typename: 'Vital', vitalId: number, result: string, vitalLookup?: { __typename: 'VitalLookup', name?: string | null | undefined, unit?: string | null | undefined, vitalCategory: VitalCategoryEnum, vitalLookupId: number, vitalType: VitalLookupTypeEnum } | null | undefined }> } | null | undefined };

export type GetEncounterTasksByEncounterIdQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type GetEncounterTasksByEncounterIdQuery = { __typename: 'Query', encounterTasksList?: Array<{ __typename: 'EncounterTask', assigneeId?: number | null | undefined, dataCategory?: string | null | undefined, dataType: string, encounterTaskId: number, group: string, inProgressAt?: any | null | undefined, patientId: number, responderCompletedAt?: any | null | undefined, responderCompletedBy?: number | null | undefined, skippedReason?: string | null | undefined, status?: EncounterTaskStatusEnum | null | undefined, taskName: string, taskRoles: Array<UserRoleEnum | null | undefined>, updatedAt?: any | null | undefined, corrections?: Array<{ __typename: 'EncounterTaskCorrection', correctionReason: string, createdAt: any, createdBy: number, jsonValue: any } | null | undefined> | null | undefined, diagnosisCodeReferencesByPatientDiagnosisEncounterTaskIdAndDiagnosisCodeReferenceIdList: Array<{ __typename: 'DiagnosisCodeReference', code: string, name: string }>, encounter?: { __typename: 'Encounter', activation?: ActivationEnum | null | undefined, clinicianIncluded?: boolean | null | undefined, clinicianStatus?: EncounterClinicianStatusEnum | null | undefined, disposition?: DispositionEnum | null | undefined, encounterId: number, modules?: Array<ModuleNameEnum | null | undefined> | null | undefined, responderStatus?: EncounterResponderStatusEnum | null | undefined, humanizedModuleEncounterTags?: Array<string | null | undefined> | null | undefined, serviceLine?: { __typename: 'ServiceLine', name: string, serviceLineId: number, subType: string } | null | undefined, appointment?: { __typename: 'Appointment', appointmentId: number, scheduledFor: any, state?: string | null | undefined, market?: { __typename: 'Market', marketId: number } | null | undefined } | null | undefined, clinician?: { __typename: 'User', firstName?: string | null | undefined, lastName?: string | null | undefined, userId: number } | null | undefined, patient?: { __typename: 'Patient', age?: number | null | undefined, dob?: any | null | undefined, firstName?: string | null | undefined, humanizedGenderIdentity?: string | null | undefined, humanizedGenderPronoun?: string | null | undefined, humanizedRaces?: Array<string | null | undefined> | null | undefined, humanizedSex?: string | null | undefined, globalPatientId: string, lastName?: string | null | undefined, patientId: number, preferredName?: string | null | undefined, ssnSerial?: string | null | undefined, suffix?: PatientSuffixEnum | null | undefined, teladocPass?: string | null | undefined, teladocUser?: string | null | undefined, fullName?: string | null | undefined } | null | undefined } | null | undefined, encounterTaskAttachmentsList: Array<{ __typename: 'EncounterTaskAttachment', createdAt: any, description?: string | null | undefined, encounterId?: number | null | undefined, encounterTaskAttachmentId: number, encounterTaskId?: number | null | undefined, isDeleted: boolean, isRequired: boolean, type: EncounterTaskAttachmentTypeEnum, url?: string | null | undefined, patientId?: number | null | undefined }>, modifiedByResponders?: Array<{ __typename: 'User', credentials?: Array<CredentialsEnum | null | undefined> | null | undefined, firstName?: string | null | undefined, lastName?: string | null | undefined, userId: number } | null | undefined> | null | undefined }> | null | undefined };

export type InsuranceRecordFieldsFragment = { __typename: 'InsuranceRecord', insuranceRecordId: number, packageId?: string | null | undefined, company?: string | null | undefined, planType?: string | null | undefined, memberId?: string | null | undefined, groupNumber?: string | null | undefined, relationshipToPolicyHolder?: string | null | undefined, policyHolderFirstName?: string | null | undefined, policyHolderLastName?: string | null | undefined, policyHolderGender?: SexEnum | null | undefined, policyHolderDob?: any | null | undefined, attachmentFrontUrl?: any | null | undefined, attachmentBackUrl?: any | null | undefined, noInsuranceCards?: boolean | null | undefined };

export type CreateInsuranceRecordMutationVariables = Exact<{
  patientId: Scalars['Int'];
  packageId?: InputMaybe<Scalars['String']>;
  company?: InputMaybe<Scalars['String']>;
  planType?: InputMaybe<Scalars['String']>;
  memberId?: InputMaybe<Scalars['String']>;
  groupNumber?: InputMaybe<Scalars['String']>;
  relationshipToPolicyHolder?: InputMaybe<Scalars['String']>;
  policyHolderFirstName?: InputMaybe<Scalars['String']>;
  policyHolderLastName?: InputMaybe<Scalars['String']>;
  policyHolderGender?: InputMaybe<SexEnum>;
  policyHolderDob?: InputMaybe<Scalars['Date']>;
  attachmentBackUrl?: InputMaybe<Scalars['JSON']>;
  attachmentFrontUrl?: InputMaybe<Scalars['JSON']>;
  noInsuranceCards?: InputMaybe<Scalars['Boolean']>;
}>;


export type CreateInsuranceRecordMutation = { __typename: 'Mutation', createInsuranceRecord?: { __typename: 'CreateInsuranceRecordPayload', insuranceRecord?: { __typename: 'InsuranceRecord', insuranceRecordId: number, packageId?: string | null | undefined, company?: string | null | undefined, planType?: string | null | undefined, memberId?: string | null | undefined, groupNumber?: string | null | undefined, relationshipToPolicyHolder?: string | null | undefined, policyHolderFirstName?: string | null | undefined, policyHolderLastName?: string | null | undefined, policyHolderGender?: SexEnum | null | undefined, policyHolderDob?: any | null | undefined, attachmentFrontUrl?: any | null | undefined, attachmentBackUrl?: any | null | undefined, noInsuranceCards?: boolean | null | undefined } | null | undefined } | null | undefined };

export type UpdateInsuranceRecordMutationVariables = Exact<{
  insuranceRecordId: Scalars['Int'];
  packageId?: InputMaybe<Scalars['String']>;
  company?: InputMaybe<Scalars['String']>;
  planType?: InputMaybe<Scalars['String']>;
  memberId?: InputMaybe<Scalars['String']>;
  groupNumber?: InputMaybe<Scalars['String']>;
  relationshipToPolicyHolder?: InputMaybe<Scalars['String']>;
  policyHolderFirstName?: InputMaybe<Scalars['String']>;
  policyHolderLastName?: InputMaybe<Scalars['String']>;
  policyHolderGender?: InputMaybe<SexEnum>;
  policyHolderDob?: InputMaybe<Scalars['Date']>;
  attachmentBackUrl?: InputMaybe<Scalars['JSON']>;
  attachmentFrontUrl?: InputMaybe<Scalars['JSON']>;
  noInsuranceCards?: InputMaybe<Scalars['Boolean']>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
}>;


export type UpdateInsuranceRecordMutation = { __typename: 'Mutation', updateInsuranceRecord?: { __typename: 'UpdateInsuranceRecordPayload', insuranceRecord?: { __typename: 'InsuranceRecord', insuranceRecordId: number, packageId?: string | null | undefined, company?: string | null | undefined, planType?: string | null | undefined, memberId?: string | null | undefined, groupNumber?: string | null | undefined, relationshipToPolicyHolder?: string | null | undefined, policyHolderFirstName?: string | null | undefined, policyHolderLastName?: string | null | undefined, policyHolderGender?: SexEnum | null | undefined, policyHolderDob?: any | null | undefined, attachmentFrontUrl?: any | null | undefined, attachmentBackUrl?: any | null | undefined, noInsuranceCards?: boolean | null | undefined } | null | undefined } | null | undefined };

export type GetMarketsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMarketsQuery = { __typename: 'Query', marketsList?: Array<{ __typename: 'Market', name: string, marketId: number }> | null | undefined };

export type PatientFieldsFragment = { __typename: 'Patient', address1?: string | null | undefined, address2?: string | null | undefined, cannotProvideSsn?: boolean | null | undefined, communicationNeed?: Array<CommunicationNeedEnum | null | undefined> | null | undefined, city?: string | null | undefined, dob?: any | null | undefined, email?: string | null | undefined, firstName?: string | null | undefined, genderIdentity?: GenderIdentityEnum | null | undefined, genderPronoun?: GenderPronounEnum | null | undefined, globalHumanId?: string | null | undefined, languages?: Array<LanguagesEnum | null | undefined> | null | undefined, middleName?: string | null | undefined, globalPatientId: string, hasPreferredName?: boolean | null | undefined, hasDifferentGenderIdentity?: boolean | null | undefined, lastName?: string | null | undefined, noSsnReason?: Array<NoSsnReasonEnum | null | undefined> | null | undefined, patientId: number, preferredName?: string | null | undefined, preferredPhoneNumber?: string | null | undefined, prefix?: string | null | undefined, races?: Array<RaceEnum | null | undefined> | null | undefined, sex?: SexEnum | null | undefined, specialInstructions?: string | null | undefined, ssnSerial?: string | null | undefined, state?: string | null | undefined, suffix?: PatientSuffixEnum | null | undefined, teladocPass?: string | null | undefined, teladocUser?: string | null | undefined, unit?: string | null | undefined, zip?: string | null | undefined, addressLine1?: string | null | undefined, addressLine2?: string | null | undefined, age?: number | null | undefined, fullName?: string | null | undefined, humanizedCommunicationNeed?: Array<string | null | undefined> | null | undefined, humanizedGenderIdentity?: string | null | undefined, humanizedGenderPronoun?: string | null | undefined, humanizedGlobalHumanId?: string | null | undefined, humanizedLanguages?: Array<string | null | undefined> | null | undefined, humanizedRaces?: Array<string | null | undefined> | null | undefined, humanizedSex?: string | null | undefined, humanizedNoSsnReason?: Array<string | null | undefined> | null | undefined };

export type PatientNoteFieldsFragment = { __typename: 'PatientNote', note: string, createdAt: any, isHighPriority?: boolean | null | undefined, migrationSource?: string | null | undefined, patientNoteId: number, formattedCreatedAt?: string | null | undefined, userByCreatedBy?: { __typename: 'User', firstName?: string | null | undefined, lastName?: string | null | undefined, userId: number } | null | undefined };

export type PatientCreateEmrAuditLogsMutationVariables = Exact<{
  logs?: InputMaybe<Array<InputMaybe<EmrAuditLogInput>> | InputMaybe<EmrAuditLogInput>>;
}>;


export type PatientCreateEmrAuditLogsMutation = { __typename: 'Mutation', createEmrAuditLogs?: { __typename: 'EmrAuditLogPayload', msg?: string | null | undefined } | null | undefined };

export type PatientCreatePatientNoteMutationVariables = Exact<{
  input: CreatePatientNoteInput;
}>;


export type PatientCreatePatientNoteMutation = { __typename: 'Mutation', createPatientNote?: { __typename: 'CreatePatientNotePayload', patient?: { __typename: 'Patient', address1?: string | null | undefined, address2?: string | null | undefined, cannotProvideSsn?: boolean | null | undefined, communicationNeed?: Array<CommunicationNeedEnum | null | undefined> | null | undefined, city?: string | null | undefined, dob?: any | null | undefined, email?: string | null | undefined, firstName?: string | null | undefined, genderIdentity?: GenderIdentityEnum | null | undefined, genderPronoun?: GenderPronounEnum | null | undefined, globalHumanId?: string | null | undefined, languages?: Array<LanguagesEnum | null | undefined> | null | undefined, middleName?: string | null | undefined, globalPatientId: string, hasPreferredName?: boolean | null | undefined, hasDifferentGenderIdentity?: boolean | null | undefined, lastName?: string | null | undefined, noSsnReason?: Array<NoSsnReasonEnum | null | undefined> | null | undefined, patientId: number, preferredName?: string | null | undefined, preferredPhoneNumber?: string | null | undefined, prefix?: string | null | undefined, races?: Array<RaceEnum | null | undefined> | null | undefined, sex?: SexEnum | null | undefined, specialInstructions?: string | null | undefined, ssnSerial?: string | null | undefined, state?: string | null | undefined, suffix?: PatientSuffixEnum | null | undefined, teladocPass?: string | null | undefined, teladocUser?: string | null | undefined, unit?: string | null | undefined, zip?: string | null | undefined, addressLine1?: string | null | undefined, addressLine2?: string | null | undefined, age?: number | null | undefined, fullName?: string | null | undefined, humanizedCommunicationNeed?: Array<string | null | undefined> | null | undefined, humanizedGenderIdentity?: string | null | undefined, humanizedGenderPronoun?: string | null | undefined, humanizedGlobalHumanId?: string | null | undefined, humanizedLanguages?: Array<string | null | undefined> | null | undefined, humanizedRaces?: Array<string | null | undefined> | null | undefined, humanizedSex?: string | null | undefined, humanizedNoSsnReason?: Array<string | null | undefined> | null | undefined, patientNotesList: Array<{ __typename: 'PatientNote', note: string, createdAt: any, isHighPriority?: boolean | null | undefined, migrationSource?: string | null | undefined, patientNoteId: number, formattedCreatedAt?: string | null | undefined, userByCreatedBy?: { __typename: 'User', firstName?: string | null | undefined, lastName?: string | null | undefined, userId: number } | null | undefined }> } | null | undefined } | null | undefined };

export type PatientUpdatePatientMutationVariables = Exact<{
  input: UpdatePatientInput;
}>;


export type PatientUpdatePatientMutation = { __typename: 'Mutation', updatePatient?: { __typename: 'UpdatePatientPayload', patient?: { __typename: 'Patient', address1?: string | null | undefined, address2?: string | null | undefined, cannotProvideSsn?: boolean | null | undefined, communicationNeed?: Array<CommunicationNeedEnum | null | undefined> | null | undefined, city?: string | null | undefined, dob?: any | null | undefined, email?: string | null | undefined, firstName?: string | null | undefined, genderIdentity?: GenderIdentityEnum | null | undefined, genderPronoun?: GenderPronounEnum | null | undefined, globalHumanId?: string | null | undefined, languages?: Array<LanguagesEnum | null | undefined> | null | undefined, middleName?: string | null | undefined, globalPatientId: string, hasPreferredName?: boolean | null | undefined, hasDifferentGenderIdentity?: boolean | null | undefined, lastName?: string | null | undefined, noSsnReason?: Array<NoSsnReasonEnum | null | undefined> | null | undefined, patientId: number, preferredName?: string | null | undefined, preferredPhoneNumber?: string | null | undefined, prefix?: string | null | undefined, races?: Array<RaceEnum | null | undefined> | null | undefined, sex?: SexEnum | null | undefined, specialInstructions?: string | null | undefined, ssnSerial?: string | null | undefined, state?: string | null | undefined, suffix?: PatientSuffixEnum | null | undefined, teladocPass?: string | null | undefined, teladocUser?: string | null | undefined, unit?: string | null | undefined, zip?: string | null | undefined, addressLine1?: string | null | undefined, addressLine2?: string | null | undefined, age?: number | null | undefined, fullName?: string | null | undefined, humanizedCommunicationNeed?: Array<string | null | undefined> | null | undefined, humanizedGenderIdentity?: string | null | undefined, humanizedGenderPronoun?: string | null | undefined, humanizedGlobalHumanId?: string | null | undefined, humanizedLanguages?: Array<string | null | undefined> | null | undefined, humanizedRaces?: Array<string | null | undefined> | null | undefined, humanizedSex?: string | null | undefined, humanizedNoSsnReason?: Array<string | null | undefined> | null | undefined } | null | undefined } | null | undefined };

export type GetPatientByGlobalPatientIdQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetPatientByGlobalPatientIdQuery = { __typename: 'Query', patientByGlobalPatientId?: { __typename: 'Patient', address1?: string | null | undefined, address2?: string | null | undefined, cannotProvideSsn?: boolean | null | undefined, communicationNeed?: Array<CommunicationNeedEnum | null | undefined> | null | undefined, city?: string | null | undefined, dob?: any | null | undefined, email?: string | null | undefined, firstName?: string | null | undefined, genderIdentity?: GenderIdentityEnum | null | undefined, genderPronoun?: GenderPronounEnum | null | undefined, globalHumanId?: string | null | undefined, languages?: Array<LanguagesEnum | null | undefined> | null | undefined, middleName?: string | null | undefined, globalPatientId: string, hasPreferredName?: boolean | null | undefined, hasDifferentGenderIdentity?: boolean | null | undefined, lastName?: string | null | undefined, noSsnReason?: Array<NoSsnReasonEnum | null | undefined> | null | undefined, patientId: number, preferredName?: string | null | undefined, preferredPhoneNumber?: string | null | undefined, prefix?: string | null | undefined, races?: Array<RaceEnum | null | undefined> | null | undefined, sex?: SexEnum | null | undefined, specialInstructions?: string | null | undefined, ssnSerial?: string | null | undefined, state?: string | null | undefined, suffix?: PatientSuffixEnum | null | undefined, teladocPass?: string | null | undefined, teladocUser?: string | null | undefined, unit?: string | null | undefined, zip?: string | null | undefined, addressLine1?: string | null | undefined, addressLine2?: string | null | undefined, age?: number | null | undefined, fullName?: string | null | undefined, humanizedCommunicationNeed?: Array<string | null | undefined> | null | undefined, humanizedGenderIdentity?: string | null | undefined, humanizedGenderPronoun?: string | null | undefined, humanizedGlobalHumanId?: string | null | undefined, humanizedLanguages?: Array<string | null | undefined> | null | undefined, humanizedRaces?: Array<string | null | undefined> | null | undefined, humanizedSex?: string | null | undefined, humanizedNoSsnReason?: Array<string | null | undefined> | null | undefined, encountersList: Array<{ __typename: 'Encounter', encounterId: number, appointment?: { __typename: 'Appointment', appointmentId: number, scheduledFor: any, marketId: number } | null | undefined }>, patientNotesList: Array<{ __typename: 'PatientNote', note: string, createdAt: any, isHighPriority?: boolean | null | undefined, migrationSource?: string | null | undefined, patientNoteId: number, formattedCreatedAt?: string | null | undefined, userByCreatedBy?: { __typename: 'User', firstName?: string | null | undefined, lastName?: string | null | undefined, userId: number } | null | undefined }> } | null | undefined };

export type GetPatientByPatientIdQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type GetPatientByPatientIdQuery = { __typename: 'Query', patient?: { __typename: 'Patient', address1?: string | null | undefined, address2?: string | null | undefined, cannotProvideSsn?: boolean | null | undefined, communicationNeed?: Array<CommunicationNeedEnum | null | undefined> | null | undefined, city?: string | null | undefined, dob?: any | null | undefined, email?: string | null | undefined, firstName?: string | null | undefined, genderIdentity?: GenderIdentityEnum | null | undefined, genderPronoun?: GenderPronounEnum | null | undefined, globalHumanId?: string | null | undefined, languages?: Array<LanguagesEnum | null | undefined> | null | undefined, middleName?: string | null | undefined, globalPatientId: string, hasPreferredName?: boolean | null | undefined, hasDifferentGenderIdentity?: boolean | null | undefined, lastName?: string | null | undefined, noSsnReason?: Array<NoSsnReasonEnum | null | undefined> | null | undefined, patientId: number, preferredName?: string | null | undefined, preferredPhoneNumber?: string | null | undefined, prefix?: string | null | undefined, races?: Array<RaceEnum | null | undefined> | null | undefined, sex?: SexEnum | null | undefined, specialInstructions?: string | null | undefined, ssnSerial?: string | null | undefined, state?: string | null | undefined, suffix?: PatientSuffixEnum | null | undefined, teladocPass?: string | null | undefined, teladocUser?: string | null | undefined, unit?: string | null | undefined, zip?: string | null | undefined, addressLine1?: string | null | undefined, addressLine2?: string | null | undefined, age?: number | null | undefined, fullName?: string | null | undefined, humanizedCommunicationNeed?: Array<string | null | undefined> | null | undefined, humanizedGenderIdentity?: string | null | undefined, humanizedGenderPronoun?: string | null | undefined, humanizedGlobalHumanId?: string | null | undefined, humanizedLanguages?: Array<string | null | undefined> | null | undefined, humanizedRaces?: Array<string | null | undefined> | null | undefined, humanizedSex?: string | null | undefined, humanizedNoSsnReason?: Array<string | null | undefined> | null | undefined } | null | undefined };

export type PatientUpdatePatientNoteMutationVariables = Exact<{
  input: UpdatePatientNoteInput;
}>;


export type PatientUpdatePatientNoteMutation = { __typename: 'Mutation', updatePatientNote?: { __typename: 'UpdatePatientNotePayload', patient?: { __typename: 'Patient', address1?: string | null | undefined, address2?: string | null | undefined, cannotProvideSsn?: boolean | null | undefined, communicationNeed?: Array<CommunicationNeedEnum | null | undefined> | null | undefined, city?: string | null | undefined, dob?: any | null | undefined, email?: string | null | undefined, firstName?: string | null | undefined, genderIdentity?: GenderIdentityEnum | null | undefined, genderPronoun?: GenderPronounEnum | null | undefined, globalHumanId?: string | null | undefined, languages?: Array<LanguagesEnum | null | undefined> | null | undefined, middleName?: string | null | undefined, globalPatientId: string, hasPreferredName?: boolean | null | undefined, hasDifferentGenderIdentity?: boolean | null | undefined, lastName?: string | null | undefined, noSsnReason?: Array<NoSsnReasonEnum | null | undefined> | null | undefined, patientId: number, preferredName?: string | null | undefined, preferredPhoneNumber?: string | null | undefined, prefix?: string | null | undefined, races?: Array<RaceEnum | null | undefined> | null | undefined, sex?: SexEnum | null | undefined, specialInstructions?: string | null | undefined, ssnSerial?: string | null | undefined, state?: string | null | undefined, suffix?: PatientSuffixEnum | null | undefined, teladocPass?: string | null | undefined, teladocUser?: string | null | undefined, unit?: string | null | undefined, zip?: string | null | undefined, addressLine1?: string | null | undefined, addressLine2?: string | null | undefined, age?: number | null | undefined, fullName?: string | null | undefined, humanizedCommunicationNeed?: Array<string | null | undefined> | null | undefined, humanizedGenderIdentity?: string | null | undefined, humanizedGenderPronoun?: string | null | undefined, humanizedGlobalHumanId?: string | null | undefined, humanizedLanguages?: Array<string | null | undefined> | null | undefined, humanizedRaces?: Array<string | null | undefined> | null | undefined, humanizedSex?: string | null | undefined, humanizedNoSsnReason?: Array<string | null | undefined> | null | undefined, patientNotesList: Array<{ __typename: 'PatientNote', note: string, createdAt: any, isHighPriority?: boolean | null | undefined, migrationSource?: string | null | undefined, patientNoteId: number, formattedCreatedAt?: string | null | undefined, userByCreatedBy?: { __typename: 'User', firstName?: string | null | undefined, lastName?: string | null | undefined, userId: number } | null | undefined }> } | null | undefined } | null | undefined };

export type SearchPatientsQueryVariables = Exact<{
  query: Scalars['String'];
}>;


export type SearchPatientsQuery = { __typename: 'Query', searchPatients?: Array<{ __typename: 'Patient', patientId: number, globalHumanId?: string | null | undefined, globalPatientId: string, firstName?: string | null | undefined, lastName?: string | null | undefined, preferredName?: string | null | undefined, fullName?: string | null | undefined, humanizedGlobalHumanId?: string | null | undefined, dob?: any | null | undefined }> | null | undefined };

export type GetRespondersByNameQueryVariables = Exact<{
  nameQuery: Scalars['String'];
}>;


export type GetRespondersByNameQuery = { __typename: 'Query', searchResponders?: Array<{ __typename: 'User', credentials?: Array<CredentialsEnum | null | undefined> | null | undefined, dob?: any | null | undefined, email?: string | null | undefined, employeeId?: string | null | undefined, firstName?: string | null | undefined, isClinician?: boolean | null | undefined, isDeleted?: boolean | null | undefined, isIt?: boolean | null | undefined, isResponder?: boolean | null | undefined, isSupervisor?: boolean | null | undefined, lastLoginAt?: any | null | undefined, lastName?: string | null | undefined, profilePictureUrl?: string | null | undefined, registeredFirstName?: string | null | undefined, registeredLastName?: string | null | undefined, userId: number, roles: Array<UserRoleEnum>, fullName?: string | null | undefined, userIdentifiersList?: Array<{ __typename: 'UserIdentifier', identifier: string, identifierType: IdentifierTypeEnum, userIdentifierId: number } | null | undefined> | null | undefined, userMarketsList?: Array<{ __typename: 'Market', marketId: number, name: string } | null | undefined> | null | undefined }> | null | undefined };

export type StandingOrderFieldsFragment = { __typename: 'StandingOrder', clinicianId: number, diagnosisCodes?: Array<string | null | undefined> | null | undefined, name: string, number: string, orderUrl: string, lookupId?: number | null | undefined, lookupType?: StandingOrderLookupTypeEnum | null | undefined, procedureCodes?: Array<string | null | undefined> | null | undefined, standingOrderId: number, startedAt?: any | null | undefined, endedAt?: any | null | undefined, state: StateEnum, version: string, clinician?: { __typename: 'User', userId: number, firstName?: string | null | undefined, lastName?: string | null | undefined } | null | undefined };

export type GetStandingOrderByStandingOrderIdQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type GetStandingOrderByStandingOrderIdQuery = { __typename: 'Query', standingOrder?: { __typename: 'StandingOrder', clinicianId: number, diagnosisCodes?: Array<string | null | undefined> | null | undefined, name: string, number: string, orderUrl: string, lookupId?: number | null | undefined, lookupType?: StandingOrderLookupTypeEnum | null | undefined, procedureCodes?: Array<string | null | undefined> | null | undefined, standingOrderId: number, startedAt?: any | null | undefined, endedAt?: any | null | undefined, state: StateEnum, version: string, clinician?: { __typename: 'User', userId: number, firstName?: string | null | undefined, lastName?: string | null | undefined } | null | undefined } | null | undefined };

export type GetStandingOrdersQueryVariables = Exact<{
  lookupType: StandingOrderLookupTypeConditionEnum;
}>;


export type GetStandingOrdersQuery = { __typename: 'Query', standingOrdersList?: Array<{ __typename: 'StandingOrder', clinicianId: number, diagnosisCodes?: Array<string | null | undefined> | null | undefined, name: string, number: string, orderUrl: string, lookupId?: number | null | undefined, lookupType?: StandingOrderLookupTypeEnum | null | undefined, procedureCodes?: Array<string | null | undefined> | null | undefined, standingOrderId: number, startedAt?: any | null | undefined, endedAt?: any | null | undefined, state: StateEnum, version: string, clinician?: { __typename: 'User', userId: number, firstName?: string | null | undefined, lastName?: string | null | undefined } | null | undefined }> | null | undefined };

export type TelehealthMeetingFieldsFragment = { __typename: 'TelehealthMeeting', telehealthMeetingId: number, alternateConnectionMethod?: TelehealthMeetingAlternateConnectionMethodEnum | null | undefined, alternateConnectionReason?: string | null | undefined, clinicianClaimedAt?: any | null | undefined, inQueueAt?: any | null | undefined, clinician?: { __typename: 'User', userId: number, firstName?: string | null | undefined, lastName?: string | null | undefined } | null | undefined, videoConference?: { __typename: 'VideoConference', videoConferenceId: number, status?: VideoConferenceStatusEnum | null | undefined, hostUrl: string, participantUrl: string, meetingStartTime?: any | null | undefined, meetingEndTime?: any | null | undefined, meetingId: any } | null | undefined };

export type JoinTelehealthMeetingMutationVariables = Exact<{
  encounterTaskId: Scalars['Int'];
}>;


export type JoinTelehealthMeetingMutation = { __typename: 'Mutation', joinTelehealthMeeting?: { __typename: 'JoinTelehealthMeetingPayload', telehealthMeeting?: { __typename: 'TelehealthMeeting', telehealthMeetingId: number, alternateConnectionMethod?: TelehealthMeetingAlternateConnectionMethodEnum | null | undefined, alternateConnectionReason?: string | null | undefined, clinicianClaimedAt?: any | null | undefined, inQueueAt?: any | null | undefined, clinician?: { __typename: 'User', userId: number, firstName?: string | null | undefined, lastName?: string | null | undefined } | null | undefined, videoConference?: { __typename: 'VideoConference', videoConferenceId: number, status?: VideoConferenceStatusEnum | null | undefined, hostUrl: string, participantUrl: string, meetingStartTime?: any | null | undefined, meetingEndTime?: any | null | undefined, meetingId: any } | null | undefined } | null | undefined } | null | undefined };

export type GetTelehealthMeetingQueryVariables = Exact<{
  telehealthMeetingId: Scalars['Int'];
}>;


export type GetTelehealthMeetingQuery = { __typename: 'Query', telehealthMeeting?: { __typename: 'TelehealthMeeting', telehealthMeetingId: number, alternateConnectionMethod?: TelehealthMeetingAlternateConnectionMethodEnum | null | undefined, alternateConnectionReason?: string | null | undefined, clinicianClaimedAt?: any | null | undefined, inQueueAt?: any | null | undefined, clinician?: { __typename: 'User', userId: number, firstName?: string | null | undefined, lastName?: string | null | undefined } | null | undefined, videoConference?: { __typename: 'VideoConference', videoConferenceId: number, status?: VideoConferenceStatusEnum | null | undefined, hostUrl: string, participantUrl: string, meetingStartTime?: any | null | undefined, meetingEndTime?: any | null | undefined, meetingId: any } | null | undefined } | null | undefined };

export type UserFieldsFragment = { __typename: 'User', credentials?: Array<CredentialsEnum | null | undefined> | null | undefined, dob?: any | null | undefined, email?: string | null | undefined, employeeId?: string | null | undefined, firstName?: string | null | undefined, isClinician?: boolean | null | undefined, isDeleted?: boolean | null | undefined, isIt?: boolean | null | undefined, isResponder?: boolean | null | undefined, isSupervisor?: boolean | null | undefined, lastLoginAt?: any | null | undefined, lastName?: string | null | undefined, profilePictureUrl?: string | null | undefined, registeredFirstName?: string | null | undefined, registeredLastName?: string | null | undefined, userId: number, roles: Array<UserRoleEnum>, fullName?: string | null | undefined, userIdentifiersList?: Array<{ __typename: 'UserIdentifier', identifier: string, identifierType: IdentifierTypeEnum, userIdentifierId: number } | null | undefined> | null | undefined, userMarketsList?: Array<{ __typename: 'Market', marketId: number, name: string } | null | undefined> | null | undefined };

export type UpdateUserMutationVariables = Exact<{
  input: UpdateUserInput;
}>;


export type UpdateUserMutation = { __typename: 'Mutation', updateUser?: { __typename: 'UpdateUserPayload', user?: { __typename: 'User', credentials?: Array<CredentialsEnum | null | undefined> | null | undefined, dob?: any | null | undefined, email?: string | null | undefined, employeeId?: string | null | undefined, firstName?: string | null | undefined, isClinician?: boolean | null | undefined, isDeleted?: boolean | null | undefined, isIt?: boolean | null | undefined, isResponder?: boolean | null | undefined, isSupervisor?: boolean | null | undefined, lastLoginAt?: any | null | undefined, lastName?: string | null | undefined, profilePictureUrl?: string | null | undefined, registeredFirstName?: string | null | undefined, registeredLastName?: string | null | undefined, userId: number, roles: Array<UserRoleEnum>, fullName?: string | null | undefined, userIdentifiersList?: Array<{ __typename: 'UserIdentifier', identifier: string, identifierType: IdentifierTypeEnum, userIdentifierId: number } | null | undefined> | null | undefined, userMarketsList?: Array<{ __typename: 'Market', marketId: number, name: string } | null | undefined> | null | undefined } | null | undefined } | null | undefined };

export type UserGrantRoleMutationVariables = Exact<{
  input: GrantRoleInput;
}>;


export type UserGrantRoleMutation = { __typename: 'Mutation', grantRole?: { __typename: 'GrantRolePayload', user?: { __typename: 'User', credentials?: Array<CredentialsEnum | null | undefined> | null | undefined, dob?: any | null | undefined, email?: string | null | undefined, employeeId?: string | null | undefined, firstName?: string | null | undefined, isClinician?: boolean | null | undefined, isDeleted?: boolean | null | undefined, isIt?: boolean | null | undefined, isResponder?: boolean | null | undefined, isSupervisor?: boolean | null | undefined, lastLoginAt?: any | null | undefined, lastName?: string | null | undefined, profilePictureUrl?: string | null | undefined, registeredFirstName?: string | null | undefined, registeredLastName?: string | null | undefined, userId: number, roles: Array<UserRoleEnum>, fullName?: string | null | undefined, userIdentifiersList?: Array<{ __typename: 'UserIdentifier', identifier: string, identifierType: IdentifierTypeEnum, userIdentifierId: number } | null | undefined> | null | undefined, userMarketsList?: Array<{ __typename: 'Market', marketId: number, name: string } | null | undefined> | null | undefined } | null | undefined } | null | undefined };

export type UserRevokeRoleMutationVariables = Exact<{
  input: RevokeRoleInput;
}>;


export type UserRevokeRoleMutation = { __typename: 'Mutation', revokeRole?: { __typename: 'RevokeRolePayload', user?: { __typename: 'User', credentials?: Array<CredentialsEnum | null | undefined> | null | undefined, dob?: any | null | undefined, email?: string | null | undefined, employeeId?: string | null | undefined, firstName?: string | null | undefined, isClinician?: boolean | null | undefined, isDeleted?: boolean | null | undefined, isIt?: boolean | null | undefined, isResponder?: boolean | null | undefined, isSupervisor?: boolean | null | undefined, lastLoginAt?: any | null | undefined, lastName?: string | null | undefined, profilePictureUrl?: string | null | undefined, registeredFirstName?: string | null | undefined, registeredLastName?: string | null | undefined, userId: number, roles: Array<UserRoleEnum>, fullName?: string | null | undefined, userIdentifiersList?: Array<{ __typename: 'UserIdentifier', identifier: string, identifierType: IdentifierTypeEnum, userIdentifierId: number } | null | undefined> | null | undefined, userMarketsList?: Array<{ __typename: 'Market', marketId: number, name: string } | null | undefined> | null | undefined } | null | undefined } | null | undefined };

export type GetCurrentUserQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCurrentUserQuery = { __typename: 'Query', getCurrentUser?: { __typename: 'User', credentials?: Array<CredentialsEnum | null | undefined> | null | undefined, dob?: any | null | undefined, email?: string | null | undefined, employeeId?: string | null | undefined, firstName?: string | null | undefined, isClinician?: boolean | null | undefined, isDeleted?: boolean | null | undefined, isIt?: boolean | null | undefined, isResponder?: boolean | null | undefined, isSupervisor?: boolean | null | undefined, lastLoginAt?: any | null | undefined, lastName?: string | null | undefined, profilePictureUrl?: string | null | undefined, registeredFirstName?: string | null | undefined, registeredLastName?: string | null | undefined, userId: number, roles: Array<UserRoleEnum>, fullName?: string | null | undefined, userIdentifiersList?: Array<{ __typename: 'UserIdentifier', identifier: string, identifierType: IdentifierTypeEnum, userIdentifierId: number } | null | undefined> | null | undefined, userMarketsList?: Array<{ __typename: 'Market', marketId: number, name: string } | null | undefined> | null | undefined } | null | undefined };

export type GetUserQueryVariables = Exact<{
  userId: Scalars['Int'];
}>;


export type GetUserQuery = { __typename: 'Query', user?: { __typename: 'User', credentials?: Array<CredentialsEnum | null | undefined> | null | undefined, dob?: any | null | undefined, email?: string | null | undefined, employeeId?: string | null | undefined, firstName?: string | null | undefined, isClinician?: boolean | null | undefined, isDeleted?: boolean | null | undefined, isIt?: boolean | null | undefined, isResponder?: boolean | null | undefined, isSupervisor?: boolean | null | undefined, lastLoginAt?: any | null | undefined, lastName?: string | null | undefined, profilePictureUrl?: string | null | undefined, registeredFirstName?: string | null | undefined, registeredLastName?: string | null | undefined, userId: number, roles: Array<UserRoleEnum>, fullName?: string | null | undefined, userIdentifiersList?: Array<{ __typename: 'UserIdentifier', identifier: string, identifierType: IdentifierTypeEnum, userIdentifierId: number } | null | undefined> | null | undefined, userMarketsList?: Array<{ __typename: 'Market', marketId: number, name: string } | null | undefined> | null | undefined } | null | undefined };

export type GetUsersQueryVariables = Exact<{
  orderBy?: InputMaybe<Array<UsersOrderBy> | UsersOrderBy>;
}>;


export type GetUsersQuery = { __typename: 'Query', usersList?: Array<{ __typename: 'User', credentials?: Array<CredentialsEnum | null | undefined> | null | undefined, dob?: any | null | undefined, email?: string | null | undefined, employeeId?: string | null | undefined, firstName?: string | null | undefined, isClinician?: boolean | null | undefined, isDeleted?: boolean | null | undefined, isIt?: boolean | null | undefined, isResponder?: boolean | null | undefined, isSupervisor?: boolean | null | undefined, lastLoginAt?: any | null | undefined, lastName?: string | null | undefined, profilePictureUrl?: string | null | undefined, registeredFirstName?: string | null | undefined, registeredLastName?: string | null | undefined, userId: number, roles: Array<UserRoleEnum>, fullName?: string | null | undefined, userIdentifiersList?: Array<{ __typename: 'UserIdentifier', identifier: string, identifierType: IdentifierTypeEnum, userIdentifierId: number } | null | undefined> | null | undefined, userMarketsList?: Array<{ __typename: 'Market', marketId: number, name: string } | null | undefined> | null | undefined }> | null | undefined };

export type VaccineFieldsFragment = { __typename: 'Vaccine', doseNumber?: number | null | undefined, adverseReactions?: Array<VaccineAdverseReactionEnum | null | undefined> | null | undefined, hadAdverseReaction?: boolean | null | undefined, contraindication?: boolean | null | undefined, location?: VaccineLocationEnum | null | undefined, lotExpiration?: any | null | undefined, lotNumber?: string | null | undefined, otherAdverseReactions?: string | null | undefined, orderedBy?: number | null | undefined, standingOrderAddedAt?: any | null | undefined, standingOrderId?: number | null | undefined, totalDoses?: number | null | undefined, vaccineId: number, vaccineLookupId: number, visEdition?: any | null | undefined, visReceived?: boolean | null | undefined, standingOrder?: { __typename: 'StandingOrder', clinicianId: number, diagnosisCodes?: Array<string | null | undefined> | null | undefined, name: string, number: string, orderUrl: string, lookupId?: number | null | undefined, lookupType?: StandingOrderLookupTypeEnum | null | undefined, procedureCodes?: Array<string | null | undefined> | null | undefined, standingOrderId: number, startedAt?: any | null | undefined, endedAt?: any | null | undefined, state: StateEnum, version: string, clinician?: { __typename: 'User', userId: number, firstName?: string | null | undefined, lastName?: string | null | undefined } | null | undefined } | null | undefined };

export type VaccineLookupFieldsFragment = { __typename: 'VaccineLookup', vaccineLookupId: number, doseQuantity: any, doseUnits: string, drug?: { __typename: 'Drug', drugId: number, drugName: string, manufacturerName: string, routeName: string } | null | undefined, standingOrders?: Array<{ __typename: 'StandingOrder', clinicianId: number, diagnosisCodes?: Array<string | null | undefined> | null | undefined, name: string, number: string, orderUrl: string, lookupId?: number | null | undefined, lookupType?: StandingOrderLookupTypeEnum | null | undefined, procedureCodes?: Array<string | null | undefined> | null | undefined, standingOrderId: number, startedAt?: any | null | undefined, endedAt?: any | null | undefined, state: StateEnum, version: string, clinician?: { __typename: 'User', userId: number, firstName?: string | null | undefined, lastName?: string | null | undefined } | null | undefined } | null | undefined> | null | undefined };

export type VitalsLookupFieldsFragment = { __typename: 'Vital', vitalId: number, result: string, vitalLookup?: { __typename: 'VitalLookup', name?: string | null | undefined, unit?: string | null | undefined, vitalCategory: VitalCategoryEnum, vitalLookupId: number, vitalType: VitalLookupTypeEnum } | null | undefined };

export const EncounterFieldsFragmentDoc = gql`
    fragment EncounterFields on Encounter {
  __typename
  channelAttribution {
    channel
    channelAttributionId
    institutionType
  }
  claimedAt
  clinician {
    __typename
    userId
    firstName
    lastName
    fullName @client
  }
  clinicianIncluded
  clinicianStatus
  disposition
  encounterId
  inQueueAt
  migrationSource
  modules
  serviceLine {
    name
    subType
    serviceLineId
  }
  primaryInsuranceRecord {
    __typename
    insuranceRecordId
    company
  }
  reasonForEncounter
  responderStatus
  humanizedClinicianStatus @client
  humanizedModuleEncounterTags @client
  humanizedResponderStatus @client
  visitId @client
  encounterSignatures {
    nodes {
      createdAt
      operatingAsRole
      user {
        userId
        firstName
        lastName
        fullName @client
      }
    }
  }
  addendaList {
    addendumId
    createdAt
    createdBy
    note
    deletedAt
    deletedBy
    user {
      userId
      firstName
      lastName
      fullName @client
    }
  }
}
    `;
export const AppointmentFieldsFragmentDoc = gql`
    fragment AppointmentFields on Appointment {
  __typename
  appointmentId
  appointmentDispatchesList {
    onSceneAt
    responder {
      registeredFirstName
      registeredLastName
      user {
        credentials
        registeredFirstName
        registeredLastName
        userId
      }
    }
  }
  scheduledFor
  address1
  address2
  unit
  city
  state
  zip
  contactName
  primaryPhone
  status
  market {
    __typename
    marketId
    name
  }
  humanizedStatus @client
  scheduledForDate @client
  scheduledForTime @client
}
    `;
export const PatientFieldsFragmentDoc = gql`
    fragment PatientFields on Patient {
  __typename
  address1
  address2
  cannotProvideSsn
  communicationNeed
  city
  dob
  email
  firstName
  genderIdentity
  genderPronoun
  globalHumanId
  languages
  middleName
  globalPatientId
  hasPreferredName
  hasDifferentGenderIdentity
  lastName
  noSsnReason
  patientId
  preferredName
  preferredPhoneNumber
  prefix
  races
  sex
  specialInstructions
  ssnSerial
  state
  suffix
  teladocPass
  teladocUser
  unit
  zip
  addressLine1 @client
  addressLine2 @client
  age @client
  fullName @client
  humanizedCommunicationNeed @client
  humanizedGenderIdentity @client
  humanizedGenderPronoun @client
  humanizedGlobalHumanId @client
  humanizedLanguages @client
  humanizedRaces @client
  humanizedSex @client
  humanizedNoSsnReason @client
}
    `;
export const EncounterPrintFieldsFragmentDoc = gql`
    fragment EncounterPrintFields on Encounter {
  __typename
  appointment {
    ...AppointmentFields
  }
  channelAttribution {
    channel
    channelAttributionId
    institutionType
  }
  claimedAt
  clinician {
    __typename
    userId
    credentials
    firstName
    lastName
    fullName @client
  }
  clinicianStatus
  disposition
  encounterId
  modules
  paymentMode
  patient {
    ...PatientFields
  }
  serviceLine {
    name
    subType
    serviceLineId
  }
  primaryInsuranceRecord {
    __typename
    insuranceRecordId
    company
    planType
    memberId
    groupNumber
  }
  secondaryInsuranceRecord {
    __typename
    insuranceRecordId
    company
    planType
    memberId
    groupNumber
  }
  reasonForEncounter
  responderStatus
  humanizedClinicianStatus @client
  humanizedModuleEncounterTags @client
  humanizedResponderStatus @client
  visitId @client
  encounterSignaturesList {
    createdAt
    operatingAsRole
    user {
      userId
      firstName
      lastName
      fullName @client
    }
  }
  addendaList {
    addendumId
    createdAt
    createdBy
    note
    deletedAt
    deletedBy
    user {
      userId
      firstName
      lastName
      fullName @client
    }
  }
}
    ${AppointmentFieldsFragmentDoc}
${PatientFieldsFragmentDoc}`;
export const MinimizedEncounterTaskFieldsFragmentDoc = gql`
    fragment MinimizedEncounterTaskFields on EncounterTask {
  __typename
  assigneeId
  corrections {
    __typename
    correctionReason
    jsonValue
  }
  clinicianReviewedAt
  clinicianReviewedBy
  dataCategory
  dataType
  encounterTaskId
  group
  inProgressAt
  responderCompletedAt
  skippedReason
  status
  taskName
  taskRoles
  updatedAt
}
    `;
export const EncounterTaskAttachmentFieldsFragmentDoc = gql`
    fragment EncounterTaskAttachmentFields on EncounterTaskAttachment {
  __typename
  createdAt
  description
  encounterId
  encounterTaskAttachmentId
  encounterTaskId
  isDeleted
  isRequired
  type
  url
  patientId
}
    `;
export const EncounterTaskFieldsFragmentDoc = gql`
    fragment EncounterTaskFields on EncounterTask {
  __typename
  assigneeId
  corrections {
    __typename
    correctionReason
    createdAt
    createdBy
    jsonValue
  }
  dataCategory
  dataType
  diagnosisCodeReferencesByPatientDiagnosisEncounterTaskIdAndDiagnosisCodeReferenceIdList {
    code
    name
  }
  encounter {
    __typename
    activation
    clinicianIncluded
    clinicianStatus
    disposition
    encounterId
    modules
    responderStatus
    serviceLine {
      __typename
      name
      serviceLineId
      subType
    }
    appointment {
      __typename
      appointmentId
      scheduledFor
      state
      market {
        __typename
        marketId
      }
    }
    clinician {
      __typename
      firstName
      lastName
      userId
    }
    patient {
      __typename
      age @client
      dob @client
      firstName
      humanizedGenderIdentity @client
      humanizedGenderPronoun @client
      humanizedRaces @client
      humanizedSex @client
      globalPatientId
      lastName
      patientId
      preferredName
      ssnSerial
      suffix
      teladocPass
      teladocUser
      fullName @client
    }
    humanizedModuleEncounterTags @client
  }
  encounterTaskAttachmentsList(condition: {isDeleted: false}) {
    ...EncounterTaskAttachmentFields
  }
  encounterTaskId
  group
  inProgressAt
  modifiedByResponders {
    credentials
    firstName
    lastName
    userId
  }
  patientId
  responderCompletedAt
  responderCompletedBy
  skippedReason
  status
  taskName
  taskRoles
  updatedAt
}
    ${EncounterTaskAttachmentFieldsFragmentDoc}`;
export const InsuranceRecordFieldsFragmentDoc = gql`
    fragment InsuranceRecordFields on InsuranceRecord {
  __typename
  insuranceRecordId
  packageId
  company
  planType
  memberId
  groupNumber
  relationshipToPolicyHolder
  policyHolderFirstName
  policyHolderLastName
  policyHolderGender
  policyHolderDob
  attachmentFrontUrl
  attachmentBackUrl
  noInsuranceCards
}
    `;
export const StandingOrderFieldsFragmentDoc = gql`
    fragment StandingOrderFields on StandingOrder {
  __typename
  clinicianId
  diagnosisCodes
  name
  number
  orderUrl
  lookupId
  lookupType
  procedureCodes
  standingOrderId
  startedAt
  endedAt
  state
  version
  clinician {
    userId
    firstName
    lastName
  }
}
    `;
export const TelehealthMeetingFieldsFragmentDoc = gql`
    fragment TelehealthMeetingFields on TelehealthMeeting {
  __typename
  telehealthMeetingId
  alternateConnectionMethod
  alternateConnectionReason
  clinicianClaimedAt
  clinician {
    __typename
    userId
    firstName
    lastName
  }
  inQueueAt
  videoConference {
    __typename
    videoConferenceId
    status
    hostUrl
    participantUrl
    meetingStartTime
    meetingEndTime
    meetingId
  }
}
    `;
export const VaccineFieldsFragmentDoc = gql`
    fragment VaccineFields on Vaccine {
  __typename
  doseNumber
  adverseReactions
  hadAdverseReaction
  contraindication
  location
  lotExpiration
  lotNumber
  otherAdverseReactions
  orderedBy
  standingOrder {
    ...StandingOrderFields
  }
  standingOrderAddedAt
  standingOrderId
  totalDoses
  vaccineId
  vaccineLookupId
  visEdition
  visReceived
}
    ${StandingOrderFieldsFragmentDoc}`;
export const VaccineLookupFieldsFragmentDoc = gql`
    fragment VaccineLookupFields on VaccineLookup {
  __typename
  vaccineLookupId
  doseQuantity
  doseUnits
  drug {
    drugId
    drugName
    manufacturerName
    routeName
  }
  standingOrders {
    ...StandingOrderFields
  }
}
    ${StandingOrderFieldsFragmentDoc}`;
export const VitalsLookupFieldsFragmentDoc = gql`
    fragment VitalsLookupFields on Vital {
  __typename
  vitalId
  result
  vitalLookup {
    __typename
    name
    unit
    vitalCategory
    vitalLookupId
    vitalType
  }
}
    `;
export const EncounterTaskLookupFieldsFragmentDoc = gql`
    fragment EncounterTaskLookupFields on EncounterTask {
  patientAllergyList @include(if: $isAllergiesTask) {
    __typename
    patientAllergyId
    isDeleted
    allergy {
      __typename
      allergyId
      code
      name
      allergyType {
        name
      }
    }
    allergicReaction {
      __typename
      allergicReactionId
      code
      name
    }
    startedAt
  }
  billingDiagnosticsList @include(if: $isClinicianBillingTask) {
    __typename
    procedureCodeReference {
      __typename
      code
      name
      procedureCodeReferenceId
    }
    encounterTaskId
    deletedAt
  }
  chiefComplaintAndHpi @include(if: $isChiefComplaintAndHpiTask) {
    __typename
    chiefComplaint
    chiefComplaintAndHpiId
    historyOfPresentIllness
  }
  reviewOfSystems @include(if: $isChiefComplaintAndHpiTask) {
    __typename
    template
    systems {
      __typename
      evaluations {
        __typename
        key
        value
      }
      note
      system
    }
  }
  patientForm @include(if: $isPatientFormTask) {
    __typename
    fieldResponse
    fieldResponseJson
    formstackId
    patientFormId
    signedAt
  }
  patientFormLookup @include(if: $isPatientFormTask) {
    __typename
    patientFormLookupId
    title
    formUrl
  }
  encounter @include(if: $isPaymentMethodTask) {
    __typename
    encounterId
    paymentMode
    noInsuranceReason
    stripeId
    primaryInsuranceRecord {
      ...InsuranceRecordFields
    }
    secondaryInsuranceRecord {
      ...InsuranceRecordFields
    }
  }
  medicalDecisionMaking @include(if: $isMedicalDecisionMakingTask) {
    __typename
    medicalDecisionMakingId
    note
  }
  patientDiagnosesList @include(if: $isMedicalDecisionMakingTask) {
    __typename
    diagnosisCodeReference {
      __typename
      diagnosisCodeReferenceId
      name
      code
    }
    isDeleted
    order
    patientDiagnosisId
  }
  patientInstructions @include(if: $isDispositionTask) {
    __typename
    patientInstructionId
    careInstructions
    type
    isDeleted
  }
  patientProblemList @include(if: $isMedicalConditionTask) {
    __typename
    createdAt
    isDeleted
    patientProblemId
    problemText
    startedAt
  }
  physicalExam @include(if: $isPhysicalExamTask) {
    __typename
    physicalExamId
    note
  }
  pointOfCareTest @include(if: $isPointOfCareTestTask) {
    __typename
    clinicianFirstName
    clinicianId
    clinicianLastName
    criticalValueConfirmations {
      __typename
      attestedAt
      attestedBy
      operatingAsRole
      user {
        __typename
        credentials
        firstName
        lastName
        fullName @client
        userId
      }
    }
    expirationDate
    humidity
    internalControlAcceptable
    isDeleted
    lotNumber
    pointOfCareTestId
    pointOfCareTestLookupId
    result
    standingOrder {
      ...StandingOrderFields
    }
    standingOrderAddedAt
    standingOrderId
    temperature
  }
  pointOfCareTestLookup @include(if: $isPointOfCareTestTask) {
    __typename
    code
    name
    pointOfCareTestCategory
    pointOfCareTestLookupId
    standingOrders {
      ...StandingOrderFields
    }
    system
    unit
  }
  progressNote @include(if: $isProgressNoteTask) {
    __typename
    note
    progressNoteId
  }
  telehealthMeeting @include(if: $isTelehealthTask) {
    ...TelehealthMeetingFields
  }
  vaccine @include(if: $isVaccineTask) {
    ...VaccineFields
  }
  vaccineLookups @include(if: $isVaccineTask) {
    ...VaccineLookupFields
  }
  vitalsList @include(if: $isVitalTask) {
    ...VitalsLookupFields
  }
}
    ${InsuranceRecordFieldsFragmentDoc}
${StandingOrderFieldsFragmentDoc}
${TelehealthMeetingFieldsFragmentDoc}
${VaccineFieldsFragmentDoc}
${VaccineLookupFieldsFragmentDoc}
${VitalsLookupFieldsFragmentDoc}`;
export const PatientNoteFieldsFragmentDoc = gql`
    fragment PatientNoteFields on PatientNote {
  __typename
  note
  createdAt
  isHighPriority
  migrationSource
  patientNoteId
  userByCreatedBy {
    firstName
    lastName
    userId
  }
  formattedCreatedAt @client
}
    `;
export const UserFieldsFragmentDoc = gql`
    fragment UserFields on User {
  __typename
  credentials
  dob
  email
  employeeId
  firstName
  isClinician
  isDeleted
  isIt
  isResponder
  isSupervisor
  lastLoginAt
  lastName
  profilePictureUrl
  registeredFirstName
  registeredLastName
  userId
  userIdentifiersList {
    identifier
    identifierType
    userIdentifierId
  }
  userMarketsList {
    marketId
    name
  }
  roles @client
  fullName @client
}
    `;
export const GetAppointmentStatusDocument = gql`
    query GetAppointmentStatus {
  appointment(appointmentId: 1) {
    __typename
    appointmentId
    status
    humanizedStatus
  }
}
    `;

/**
 * __useGetAppointmentStatusQuery__
 *
 * To run a query within a React component, call `useGetAppointmentStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAppointmentStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAppointmentStatusQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAppointmentStatusQuery(baseOptions?: Apollo.QueryHookOptions<GetAppointmentStatusQuery, GetAppointmentStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAppointmentStatusQuery, GetAppointmentStatusQueryVariables>(GetAppointmentStatusDocument, options);
      }
export function useGetAppointmentStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAppointmentStatusQuery, GetAppointmentStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAppointmentStatusQuery, GetAppointmentStatusQueryVariables>(GetAppointmentStatusDocument, options);
        }
export type GetAppointmentStatusQueryHookResult = ReturnType<typeof useGetAppointmentStatusQuery>;
export type GetAppointmentStatusLazyQueryHookResult = ReturnType<typeof useGetAppointmentStatusLazyQuery>;
export type GetAppointmentStatusQueryResult = Apollo.QueryResult<GetAppointmentStatusQuery, GetAppointmentStatusQueryVariables>;
export function refetchGetAppointmentStatusQuery(variables?: GetAppointmentStatusQueryVariables) {
      return { query: GetAppointmentStatusDocument, variables: variables }
    }
export const TestGetUserDocument = gql`
    query TestGetUser {
  user(userId: 1) {
    __typename
    userId
    firstName
    lastName
    fullName
  }
}
    `;

/**
 * __useTestGetUserQuery__
 *
 * To run a query within a React component, call `useTestGetUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useTestGetUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTestGetUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useTestGetUserQuery(baseOptions?: Apollo.QueryHookOptions<TestGetUserQuery, TestGetUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TestGetUserQuery, TestGetUserQueryVariables>(TestGetUserDocument, options);
      }
export function useTestGetUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TestGetUserQuery, TestGetUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TestGetUserQuery, TestGetUserQueryVariables>(TestGetUserDocument, options);
        }
export type TestGetUserQueryHookResult = ReturnType<typeof useTestGetUserQuery>;
export type TestGetUserLazyQueryHookResult = ReturnType<typeof useTestGetUserLazyQuery>;
export type TestGetUserQueryResult = Apollo.QueryResult<TestGetUserQuery, TestGetUserQueryVariables>;
export function refetchTestGetUserQuery(variables?: TestGetUserQueryVariables) {
      return { query: TestGetUserDocument, variables: variables }
    }
export const SearchAllergyCodesDocument = gql`
    query SearchAllergyCodes($searchTerm: String!, $allergyTypeGroup: SearchAllergyCodesTypeGroup!) {
  searchAllergyCodes(
    searchTerms: $searchTerm
    allergyTypeGroup: $allergyTypeGroup
  ) {
    __typename
    allergyId
    name
    code
  }
}
    `;

/**
 * __useSearchAllergyCodesQuery__
 *
 * To run a query within a React component, call `useSearchAllergyCodesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchAllergyCodesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchAllergyCodesQuery({
 *   variables: {
 *      searchTerm: // value for 'searchTerm'
 *      allergyTypeGroup: // value for 'allergyTypeGroup'
 *   },
 * });
 */
export function useSearchAllergyCodesQuery(baseOptions: Apollo.QueryHookOptions<SearchAllergyCodesQuery, SearchAllergyCodesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchAllergyCodesQuery, SearchAllergyCodesQueryVariables>(SearchAllergyCodesDocument, options);
      }
export function useSearchAllergyCodesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchAllergyCodesQuery, SearchAllergyCodesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchAllergyCodesQuery, SearchAllergyCodesQueryVariables>(SearchAllergyCodesDocument, options);
        }
export type SearchAllergyCodesQueryHookResult = ReturnType<typeof useSearchAllergyCodesQuery>;
export type SearchAllergyCodesLazyQueryHookResult = ReturnType<typeof useSearchAllergyCodesLazyQuery>;
export type SearchAllergyCodesQueryResult = Apollo.QueryResult<SearchAllergyCodesQuery, SearchAllergyCodesQueryVariables>;
export function refetchSearchAllergyCodesQuery(variables: SearchAllergyCodesQueryVariables) {
      return { query: SearchAllergyCodesDocument, variables: variables }
    }
export const SearchReactionCodesDocument = gql`
    query SearchReactionCodes($searchTerm: String!) {
  searchReactionCodes(searchTerms: $searchTerm) {
    __typename
    allergicReactionId
    name
    code
  }
}
    `;

/**
 * __useSearchReactionCodesQuery__
 *
 * To run a query within a React component, call `useSearchReactionCodesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchReactionCodesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchReactionCodesQuery({
 *   variables: {
 *      searchTerm: // value for 'searchTerm'
 *   },
 * });
 */
export function useSearchReactionCodesQuery(baseOptions: Apollo.QueryHookOptions<SearchReactionCodesQuery, SearchReactionCodesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchReactionCodesQuery, SearchReactionCodesQueryVariables>(SearchReactionCodesDocument, options);
      }
export function useSearchReactionCodesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchReactionCodesQuery, SearchReactionCodesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchReactionCodesQuery, SearchReactionCodesQueryVariables>(SearchReactionCodesDocument, options);
        }
export type SearchReactionCodesQueryHookResult = ReturnType<typeof useSearchReactionCodesQuery>;
export type SearchReactionCodesLazyQueryHookResult = ReturnType<typeof useSearchReactionCodesLazyQuery>;
export type SearchReactionCodesQueryResult = Apollo.QueryResult<SearchReactionCodesQuery, SearchReactionCodesQueryVariables>;
export function refetchSearchReactionCodesQuery(variables: SearchReactionCodesQueryVariables) {
      return { query: SearchReactionCodesDocument, variables: variables }
    }
export const GetAppointmentDispatchesByResponderIdDocument = gql`
    query GetAppointmentDispatchesByResponderId($responderId: Int!) {
  appointmentDispatchesList(
    condition: {responderId: $responderId, statusIsNot: REMOVED}
  ) {
    __typename
    status
    appointment {
      ...AppointmentFields
      encountersList {
        ...EncounterFields
        patient {
          ...PatientFields
        }
      }
    }
  }
}
    ${AppointmentFieldsFragmentDoc}
${EncounterFieldsFragmentDoc}
${PatientFieldsFragmentDoc}`;

/**
 * __useGetAppointmentDispatchesByResponderIdQuery__
 *
 * To run a query within a React component, call `useGetAppointmentDispatchesByResponderIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAppointmentDispatchesByResponderIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAppointmentDispatchesByResponderIdQuery({
 *   variables: {
 *      responderId: // value for 'responderId'
 *   },
 * });
 */
export function useGetAppointmentDispatchesByResponderIdQuery(baseOptions: Apollo.QueryHookOptions<GetAppointmentDispatchesByResponderIdQuery, GetAppointmentDispatchesByResponderIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAppointmentDispatchesByResponderIdQuery, GetAppointmentDispatchesByResponderIdQueryVariables>(GetAppointmentDispatchesByResponderIdDocument, options);
      }
export function useGetAppointmentDispatchesByResponderIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAppointmentDispatchesByResponderIdQuery, GetAppointmentDispatchesByResponderIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAppointmentDispatchesByResponderIdQuery, GetAppointmentDispatchesByResponderIdQueryVariables>(GetAppointmentDispatchesByResponderIdDocument, options);
        }
export type GetAppointmentDispatchesByResponderIdQueryHookResult = ReturnType<typeof useGetAppointmentDispatchesByResponderIdQuery>;
export type GetAppointmentDispatchesByResponderIdLazyQueryHookResult = ReturnType<typeof useGetAppointmentDispatchesByResponderIdLazyQuery>;
export type GetAppointmentDispatchesByResponderIdQueryResult = Apollo.QueryResult<GetAppointmentDispatchesByResponderIdQuery, GetAppointmentDispatchesByResponderIdQueryVariables>;
export function refetchGetAppointmentDispatchesByResponderIdQuery(variables: GetAppointmentDispatchesByResponderIdQueryVariables) {
      return { query: GetAppointmentDispatchesByResponderIdDocument, variables: variables }
    }
export const GetAppointmentsByResponderIdDocument = gql`
    query GetAppointmentsByResponderId($responderId: Int!, $filter: ResponderAppointmentFilter) {
  readResponderAppointments(responderId: $responderId, filter: $filter) @client {
    ...AppointmentFields
    encountersList {
      ...EncounterFields
      patient {
        ...PatientFields
      }
    }
  }
}
    ${AppointmentFieldsFragmentDoc}
${EncounterFieldsFragmentDoc}
${PatientFieldsFragmentDoc}`;

/**
 * __useGetAppointmentsByResponderIdQuery__
 *
 * To run a query within a React component, call `useGetAppointmentsByResponderIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAppointmentsByResponderIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAppointmentsByResponderIdQuery({
 *   variables: {
 *      responderId: // value for 'responderId'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetAppointmentsByResponderIdQuery(baseOptions: Apollo.QueryHookOptions<GetAppointmentsByResponderIdQuery, GetAppointmentsByResponderIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAppointmentsByResponderIdQuery, GetAppointmentsByResponderIdQueryVariables>(GetAppointmentsByResponderIdDocument, options);
      }
export function useGetAppointmentsByResponderIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAppointmentsByResponderIdQuery, GetAppointmentsByResponderIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAppointmentsByResponderIdQuery, GetAppointmentsByResponderIdQueryVariables>(GetAppointmentsByResponderIdDocument, options);
        }
export type GetAppointmentsByResponderIdQueryHookResult = ReturnType<typeof useGetAppointmentsByResponderIdQuery>;
export type GetAppointmentsByResponderIdLazyQueryHookResult = ReturnType<typeof useGetAppointmentsByResponderIdLazyQuery>;
export type GetAppointmentsByResponderIdQueryResult = Apollo.QueryResult<GetAppointmentsByResponderIdQuery, GetAppointmentsByResponderIdQueryVariables>;
export function refetchGetAppointmentsByResponderIdQuery(variables: GetAppointmentsByResponderIdQueryVariables) {
      return { query: GetAppointmentsByResponderIdDocument, variables: variables }
    }
export const SearchCliniciansDocument = gql`
    query SearchClinicians($query: String!) {
  searchClinicians(nameQuery: $query, orderBy: NAME_ASC) {
    __typename
    userId
    firstName
    lastName
    fullName @client
  }
}
    `;

/**
 * __useSearchCliniciansQuery__
 *
 * To run a query within a React component, call `useSearchCliniciansQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchCliniciansQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchCliniciansQuery({
 *   variables: {
 *      query: // value for 'query'
 *   },
 * });
 */
export function useSearchCliniciansQuery(baseOptions: Apollo.QueryHookOptions<SearchCliniciansQuery, SearchCliniciansQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchCliniciansQuery, SearchCliniciansQueryVariables>(SearchCliniciansDocument, options);
      }
export function useSearchCliniciansLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchCliniciansQuery, SearchCliniciansQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchCliniciansQuery, SearchCliniciansQueryVariables>(SearchCliniciansDocument, options);
        }
export type SearchCliniciansQueryHookResult = ReturnType<typeof useSearchCliniciansQuery>;
export type SearchCliniciansLazyQueryHookResult = ReturnType<typeof useSearchCliniciansLazyQuery>;
export type SearchCliniciansQueryResult = Apollo.QueryResult<SearchCliniciansQuery, SearchCliniciansQueryVariables>;
export function refetchSearchCliniciansQuery(variables: SearchCliniciansQueryVariables) {
      return { query: SearchCliniciansDocument, variables: variables }
    }
export const GetCPTCodesBySearchTermDocument = gql`
    query GetCPTCodesBySearchTerm($activeDate: Date!, $searchTerm: String!) {
  searchCPTCodes(activeDate: $activeDate, searchTerms: $searchTerm) {
    __typename
    procedureCodeReferenceId
    name
    code
  }
}
    `;

/**
 * __useGetCPTCodesBySearchTermQuery__
 *
 * To run a query within a React component, call `useGetCPTCodesBySearchTermQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCPTCodesBySearchTermQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCPTCodesBySearchTermQuery({
 *   variables: {
 *      activeDate: // value for 'activeDate'
 *      searchTerm: // value for 'searchTerm'
 *   },
 * });
 */
export function useGetCPTCodesBySearchTermQuery(baseOptions: Apollo.QueryHookOptions<GetCPTCodesBySearchTermQuery, GetCPTCodesBySearchTermQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCPTCodesBySearchTermQuery, GetCPTCodesBySearchTermQueryVariables>(GetCPTCodesBySearchTermDocument, options);
      }
export function useGetCPTCodesBySearchTermLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCPTCodesBySearchTermQuery, GetCPTCodesBySearchTermQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCPTCodesBySearchTermQuery, GetCPTCodesBySearchTermQueryVariables>(GetCPTCodesBySearchTermDocument, options);
        }
export type GetCPTCodesBySearchTermQueryHookResult = ReturnType<typeof useGetCPTCodesBySearchTermQuery>;
export type GetCPTCodesBySearchTermLazyQueryHookResult = ReturnType<typeof useGetCPTCodesBySearchTermLazyQuery>;
export type GetCPTCodesBySearchTermQueryResult = Apollo.QueryResult<GetCPTCodesBySearchTermQuery, GetCPTCodesBySearchTermQueryVariables>;
export function refetchGetCPTCodesBySearchTermQuery(variables: GetCPTCodesBySearchTermQueryVariables) {
      return { query: GetCPTCodesBySearchTermDocument, variables: variables }
    }
export const GetDiagnosisCodeReferenceDocument = gql`
    query GetDiagnosisCodeReference($diagnosisCodeReferenceId: Int!) {
  diagnosisCodeReference(diagnosisCodeReferenceId: $diagnosisCodeReferenceId) {
    __typename
    diagnosisCodeReferenceId
    code
    name
  }
}
    `;

/**
 * __useGetDiagnosisCodeReferenceQuery__
 *
 * To run a query within a React component, call `useGetDiagnosisCodeReferenceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDiagnosisCodeReferenceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDiagnosisCodeReferenceQuery({
 *   variables: {
 *      diagnosisCodeReferenceId: // value for 'diagnosisCodeReferenceId'
 *   },
 * });
 */
export function useGetDiagnosisCodeReferenceQuery(baseOptions: Apollo.QueryHookOptions<GetDiagnosisCodeReferenceQuery, GetDiagnosisCodeReferenceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDiagnosisCodeReferenceQuery, GetDiagnosisCodeReferenceQueryVariables>(GetDiagnosisCodeReferenceDocument, options);
      }
export function useGetDiagnosisCodeReferenceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDiagnosisCodeReferenceQuery, GetDiagnosisCodeReferenceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDiagnosisCodeReferenceQuery, GetDiagnosisCodeReferenceQueryVariables>(GetDiagnosisCodeReferenceDocument, options);
        }
export type GetDiagnosisCodeReferenceQueryHookResult = ReturnType<typeof useGetDiagnosisCodeReferenceQuery>;
export type GetDiagnosisCodeReferenceLazyQueryHookResult = ReturnType<typeof useGetDiagnosisCodeReferenceLazyQuery>;
export type GetDiagnosisCodeReferenceQueryResult = Apollo.QueryResult<GetDiagnosisCodeReferenceQuery, GetDiagnosisCodeReferenceQueryVariables>;
export function refetchGetDiagnosisCodeReferenceQuery(variables: GetDiagnosisCodeReferenceQueryVariables) {
      return { query: GetDiagnosisCodeReferenceDocument, variables: variables }
    }
export const GetICDCodesBySearchTermDocument = gql`
    query GetICDCodesBySearchTerm($activeDate: Date!, $searchTerm: String!) {
  searchICDCodes(
    activeDate: $activeDate
    searchTerms: $searchTerm
    orderBy: NAME_ASC
    limit: 10
  ) {
    __typename
    code
    diagnosisCodeReferenceId
    name
  }
}
    `;

/**
 * __useGetICDCodesBySearchTermQuery__
 *
 * To run a query within a React component, call `useGetICDCodesBySearchTermQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetICDCodesBySearchTermQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetICDCodesBySearchTermQuery({
 *   variables: {
 *      activeDate: // value for 'activeDate'
 *      searchTerm: // value for 'searchTerm'
 *   },
 * });
 */
export function useGetICDCodesBySearchTermQuery(baseOptions: Apollo.QueryHookOptions<GetICDCodesBySearchTermQuery, GetICDCodesBySearchTermQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetICDCodesBySearchTermQuery, GetICDCodesBySearchTermQueryVariables>(GetICDCodesBySearchTermDocument, options);
      }
export function useGetICDCodesBySearchTermLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetICDCodesBySearchTermQuery, GetICDCodesBySearchTermQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetICDCodesBySearchTermQuery, GetICDCodesBySearchTermQueryVariables>(GetICDCodesBySearchTermDocument, options);
        }
export type GetICDCodesBySearchTermQueryHookResult = ReturnType<typeof useGetICDCodesBySearchTermQuery>;
export type GetICDCodesBySearchTermLazyQueryHookResult = ReturnType<typeof useGetICDCodesBySearchTermLazyQuery>;
export type GetICDCodesBySearchTermQueryResult = Apollo.QueryResult<GetICDCodesBySearchTermQuery, GetICDCodesBySearchTermQueryVariables>;
export function refetchGetICDCodesBySearchTermQuery(variables: GetICDCodesBySearchTermQueryVariables) {
      return { query: GetICDCodesBySearchTermDocument, variables: variables }
    }
export const GetDoseSpotNotificationDetailsDocument = gql`
    query GetDoseSpotNotificationDetails {
  getDoseSpotNotificationDetails {
    notificationCount
    notificationsUrl
  }
}
    `;

/**
 * __useGetDoseSpotNotificationDetailsQuery__
 *
 * To run a query within a React component, call `useGetDoseSpotNotificationDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDoseSpotNotificationDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDoseSpotNotificationDetailsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetDoseSpotNotificationDetailsQuery(baseOptions?: Apollo.QueryHookOptions<GetDoseSpotNotificationDetailsQuery, GetDoseSpotNotificationDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDoseSpotNotificationDetailsQuery, GetDoseSpotNotificationDetailsQueryVariables>(GetDoseSpotNotificationDetailsDocument, options);
      }
export function useGetDoseSpotNotificationDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDoseSpotNotificationDetailsQuery, GetDoseSpotNotificationDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDoseSpotNotificationDetailsQuery, GetDoseSpotNotificationDetailsQueryVariables>(GetDoseSpotNotificationDetailsDocument, options);
        }
export type GetDoseSpotNotificationDetailsQueryHookResult = ReturnType<typeof useGetDoseSpotNotificationDetailsQuery>;
export type GetDoseSpotNotificationDetailsLazyQueryHookResult = ReturnType<typeof useGetDoseSpotNotificationDetailsLazyQuery>;
export type GetDoseSpotNotificationDetailsQueryResult = Apollo.QueryResult<GetDoseSpotNotificationDetailsQuery, GetDoseSpotNotificationDetailsQueryVariables>;
export function refetchGetDoseSpotNotificationDetailsQuery(variables?: GetDoseSpotNotificationDetailsQueryVariables) {
      return { query: GetDoseSpotNotificationDetailsDocument, variables: variables }
    }
export const GetDoseSpotUrlDocument = gql`
    mutation GetDoseSpotUrl($encounterId: Int, $marketId: Int!, $patientId: Int!) {
  generateDoseSpotURL(
    input: {encounterId: $encounterId, marketId: $marketId, patientId: $patientId}
  )
}
    `;
export type GetDoseSpotUrlMutationFn = Apollo.MutationFunction<GetDoseSpotUrlMutation, GetDoseSpotUrlMutationVariables>;

/**
 * __useGetDoseSpotUrlMutation__
 *
 * To run a mutation, you first call `useGetDoseSpotUrlMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGetDoseSpotUrlMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [getDoseSpotUrlMutation, { data, loading, error }] = useGetDoseSpotUrlMutation({
 *   variables: {
 *      encounterId: // value for 'encounterId'
 *      marketId: // value for 'marketId'
 *      patientId: // value for 'patientId'
 *   },
 * });
 */
export function useGetDoseSpotUrlMutation(baseOptions?: Apollo.MutationHookOptions<GetDoseSpotUrlMutation, GetDoseSpotUrlMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GetDoseSpotUrlMutation, GetDoseSpotUrlMutationVariables>(GetDoseSpotUrlDocument, options);
      }
export type GetDoseSpotUrlMutationHookResult = ReturnType<typeof useGetDoseSpotUrlMutation>;
export type GetDoseSpotUrlMutationResult = Apollo.MutationResult<GetDoseSpotUrlMutation>;
export type GetDoseSpotUrlMutationOptions = Apollo.BaseMutationOptions<GetDoseSpotUrlMutation, GetDoseSpotUrlMutationVariables>;
export const GetInProgressClinicianEncountersDocument = gql`
    query GetInProgressClinicianEncounters($clinicianId: Int, $patientId: Int!, $scheduledForAfter: String!, $scheduledForBefore: String!) {
  encounters(
    condition: {clinicianIds: [$clinicianId], patientId: $patientId, scheduledForAfter: $scheduledForAfter, scheduledForBefore: $scheduledForBefore, clinicianStatus: IN_PROGRESS}
  ) {
    nodes {
      __typename
      encounterId
      patientId
      appointment {
        __typename
        appointmentId
        marketId
      }
    }
  }
}
    `;

/**
 * __useGetInProgressClinicianEncountersQuery__
 *
 * To run a query within a React component, call `useGetInProgressClinicianEncountersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInProgressClinicianEncountersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInProgressClinicianEncountersQuery({
 *   variables: {
 *      clinicianId: // value for 'clinicianId'
 *      patientId: // value for 'patientId'
 *      scheduledForAfter: // value for 'scheduledForAfter'
 *      scheduledForBefore: // value for 'scheduledForBefore'
 *   },
 * });
 */
export function useGetInProgressClinicianEncountersQuery(baseOptions: Apollo.QueryHookOptions<GetInProgressClinicianEncountersQuery, GetInProgressClinicianEncountersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInProgressClinicianEncountersQuery, GetInProgressClinicianEncountersQueryVariables>(GetInProgressClinicianEncountersDocument, options);
      }
export function useGetInProgressClinicianEncountersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInProgressClinicianEncountersQuery, GetInProgressClinicianEncountersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInProgressClinicianEncountersQuery, GetInProgressClinicianEncountersQueryVariables>(GetInProgressClinicianEncountersDocument, options);
        }
export type GetInProgressClinicianEncountersQueryHookResult = ReturnType<typeof useGetInProgressClinicianEncountersQuery>;
export type GetInProgressClinicianEncountersLazyQueryHookResult = ReturnType<typeof useGetInProgressClinicianEncountersLazyQuery>;
export type GetInProgressClinicianEncountersQueryResult = Apollo.QueryResult<GetInProgressClinicianEncountersQuery, GetInProgressClinicianEncountersQueryVariables>;
export function refetchGetInProgressClinicianEncountersQuery(variables: GetInProgressClinicianEncountersQueryVariables) {
      return { query: GetInProgressClinicianEncountersDocument, variables: variables }
    }
export const ClaimEncounterDocument = gql`
    mutation ClaimEncounter($id: Int!) {
  claimEncounter(input: {encounterId: $id}) {
    encounter {
      ...EncounterFields
    }
  }
}
    ${EncounterFieldsFragmentDoc}`;
export type ClaimEncounterMutationFn = Apollo.MutationFunction<ClaimEncounterMutation, ClaimEncounterMutationVariables>;

/**
 * __useClaimEncounterMutation__
 *
 * To run a mutation, you first call `useClaimEncounterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useClaimEncounterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [claimEncounterMutation, { data, loading, error }] = useClaimEncounterMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useClaimEncounterMutation(baseOptions?: Apollo.MutationHookOptions<ClaimEncounterMutation, ClaimEncounterMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ClaimEncounterMutation, ClaimEncounterMutationVariables>(ClaimEncounterDocument, options);
      }
export type ClaimEncounterMutationHookResult = ReturnType<typeof useClaimEncounterMutation>;
export type ClaimEncounterMutationResult = Apollo.MutationResult<ClaimEncounterMutation>;
export type ClaimEncounterMutationOptions = Apollo.BaseMutationOptions<ClaimEncounterMutation, ClaimEncounterMutationVariables>;
export const CreateAddendumDocument = gql`
    mutation CreateAddendum($encounterId: Int!, $note: String!, $user: Int!) {
  createAddendum(input: {encounterId: $encounterId, note: $note, userId: $user}) {
    query {
      encounter(encounterId: $encounterId) {
        ...EncounterFields
        encounterTasksList {
          ...MinimizedEncounterTaskFields
        }
      }
    }
  }
}
    ${EncounterFieldsFragmentDoc}
${MinimizedEncounterTaskFieldsFragmentDoc}`;
export type CreateAddendumMutationFn = Apollo.MutationFunction<CreateAddendumMutation, CreateAddendumMutationVariables>;

/**
 * __useCreateAddendumMutation__
 *
 * To run a mutation, you first call `useCreateAddendumMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAddendumMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAddendumMutation, { data, loading, error }] = useCreateAddendumMutation({
 *   variables: {
 *      encounterId: // value for 'encounterId'
 *      note: // value for 'note'
 *      user: // value for 'user'
 *   },
 * });
 */
export function useCreateAddendumMutation(baseOptions?: Apollo.MutationHookOptions<CreateAddendumMutation, CreateAddendumMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAddendumMutation, CreateAddendumMutationVariables>(CreateAddendumDocument, options);
      }
export type CreateAddendumMutationHookResult = ReturnType<typeof useCreateAddendumMutation>;
export type CreateAddendumMutationResult = Apollo.MutationResult<CreateAddendumMutation>;
export type CreateAddendumMutationOptions = Apollo.BaseMutationOptions<CreateAddendumMutation, CreateAddendumMutationVariables>;
export const CreateClinicianEncounterSignatureDocument = gql`
    mutation CreateClinicianEncounterSignature($userId: Int!, $encounterId: Int!) {
  createClinicianEncounterSignature(
    input: {userId: $userId, encounterId: $encounterId}
  ) {
    query {
      encounter(encounterId: $encounterId) {
        ...EncounterFields
        encounterTasksList {
          ...MinimizedEncounterTaskFields
        }
      }
    }
  }
}
    ${EncounterFieldsFragmentDoc}
${MinimizedEncounterTaskFieldsFragmentDoc}`;
export type CreateClinicianEncounterSignatureMutationFn = Apollo.MutationFunction<CreateClinicianEncounterSignatureMutation, CreateClinicianEncounterSignatureMutationVariables>;

/**
 * __useCreateClinicianEncounterSignatureMutation__
 *
 * To run a mutation, you first call `useCreateClinicianEncounterSignatureMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateClinicianEncounterSignatureMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createClinicianEncounterSignatureMutation, { data, loading, error }] = useCreateClinicianEncounterSignatureMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      encounterId: // value for 'encounterId'
 *   },
 * });
 */
export function useCreateClinicianEncounterSignatureMutation(baseOptions?: Apollo.MutationHookOptions<CreateClinicianEncounterSignatureMutation, CreateClinicianEncounterSignatureMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateClinicianEncounterSignatureMutation, CreateClinicianEncounterSignatureMutationVariables>(CreateClinicianEncounterSignatureDocument, options);
      }
export type CreateClinicianEncounterSignatureMutationHookResult = ReturnType<typeof useCreateClinicianEncounterSignatureMutation>;
export type CreateClinicianEncounterSignatureMutationResult = Apollo.MutationResult<CreateClinicianEncounterSignatureMutation>;
export type CreateClinicianEncounterSignatureMutationOptions = Apollo.BaseMutationOptions<CreateClinicianEncounterSignatureMutation, CreateClinicianEncounterSignatureMutationVariables>;
export const CreateResponderEncounterSignatureDocument = gql`
    mutation CreateResponderEncounterSignature($userId: Int!, $encounterId: Int!) {
  createResponderEncounterSignature(
    input: {userId: $userId, encounterId: $encounterId}
  ) {
    query {
      encounter(encounterId: $encounterId) {
        ...EncounterFields
        encounterTasksList {
          ...MinimizedEncounterTaskFields
        }
      }
    }
  }
}
    ${EncounterFieldsFragmentDoc}
${MinimizedEncounterTaskFieldsFragmentDoc}`;
export type CreateResponderEncounterSignatureMutationFn = Apollo.MutationFunction<CreateResponderEncounterSignatureMutation, CreateResponderEncounterSignatureMutationVariables>;

/**
 * __useCreateResponderEncounterSignatureMutation__
 *
 * To run a mutation, you first call `useCreateResponderEncounterSignatureMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateResponderEncounterSignatureMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createResponderEncounterSignatureMutation, { data, loading, error }] = useCreateResponderEncounterSignatureMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      encounterId: // value for 'encounterId'
 *   },
 * });
 */
export function useCreateResponderEncounterSignatureMutation(baseOptions?: Apollo.MutationHookOptions<CreateResponderEncounterSignatureMutation, CreateResponderEncounterSignatureMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateResponderEncounterSignatureMutation, CreateResponderEncounterSignatureMutationVariables>(CreateResponderEncounterSignatureDocument, options);
      }
export type CreateResponderEncounterSignatureMutationHookResult = ReturnType<typeof useCreateResponderEncounterSignatureMutation>;
export type CreateResponderEncounterSignatureMutationResult = Apollo.MutationResult<CreateResponderEncounterSignatureMutation>;
export type CreateResponderEncounterSignatureMutationOptions = Apollo.BaseMutationOptions<CreateResponderEncounterSignatureMutation, CreateResponderEncounterSignatureMutationVariables>;
export const UpdateEncounterDocument = gql`
    mutation UpdateEncounter($input: UpdateEncounterInput!) {
  updateEncounter(input: $input) {
    encounter {
      __typename
      encounterId
      clinician {
        __typename
        firstName
        lastName
        userId
      }
    }
  }
}
    `;
export type UpdateEncounterMutationFn = Apollo.MutationFunction<UpdateEncounterMutation, UpdateEncounterMutationVariables>;

/**
 * __useUpdateEncounterMutation__
 *
 * To run a mutation, you first call `useUpdateEncounterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEncounterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEncounterMutation, { data, loading, error }] = useUpdateEncounterMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateEncounterMutation(baseOptions?: Apollo.MutationHookOptions<UpdateEncounterMutation, UpdateEncounterMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateEncounterMutation, UpdateEncounterMutationVariables>(UpdateEncounterDocument, options);
      }
export type UpdateEncounterMutationHookResult = ReturnType<typeof useUpdateEncounterMutation>;
export type UpdateEncounterMutationResult = Apollo.MutationResult<UpdateEncounterMutation>;
export type UpdateEncounterMutationOptions = Apollo.BaseMutationOptions<UpdateEncounterMutation, UpdateEncounterMutationVariables>;
export const EncounterUpdatePaymentMethodDocument = gql`
    mutation EncounterUpdatePaymentMethod($encounterId: Int!, $noInsuranceReason: NoInsuranceReasonEnum, $paymentMode: EncounterPaymentModeEnum, $primaryInsuranceId: Int, $secondaryInsuranceId: Int) {
  updateEncounter(
    input: {patch: {paymentMode: $paymentMode, noInsuranceReason: $noInsuranceReason, primaryInsurance: $primaryInsuranceId, secondaryInsurance: $secondaryInsuranceId}, encounterId: $encounterId}
  ) {
    encounter {
      __typename
      encounterId
      noInsuranceReason
      paymentMode
      primaryInsuranceRecord {
        ...InsuranceRecordFields
      }
      secondaryInsuranceRecord {
        ...InsuranceRecordFields
      }
    }
  }
}
    ${InsuranceRecordFieldsFragmentDoc}`;
export type EncounterUpdatePaymentMethodMutationFn = Apollo.MutationFunction<EncounterUpdatePaymentMethodMutation, EncounterUpdatePaymentMethodMutationVariables>;

/**
 * __useEncounterUpdatePaymentMethodMutation__
 *
 * To run a mutation, you first call `useEncounterUpdatePaymentMethodMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEncounterUpdatePaymentMethodMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [encounterUpdatePaymentMethodMutation, { data, loading, error }] = useEncounterUpdatePaymentMethodMutation({
 *   variables: {
 *      encounterId: // value for 'encounterId'
 *      noInsuranceReason: // value for 'noInsuranceReason'
 *      paymentMode: // value for 'paymentMode'
 *      primaryInsuranceId: // value for 'primaryInsuranceId'
 *      secondaryInsuranceId: // value for 'secondaryInsuranceId'
 *   },
 * });
 */
export function useEncounterUpdatePaymentMethodMutation(baseOptions?: Apollo.MutationHookOptions<EncounterUpdatePaymentMethodMutation, EncounterUpdatePaymentMethodMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EncounterUpdatePaymentMethodMutation, EncounterUpdatePaymentMethodMutationVariables>(EncounterUpdatePaymentMethodDocument, options);
      }
export type EncounterUpdatePaymentMethodMutationHookResult = ReturnType<typeof useEncounterUpdatePaymentMethodMutation>;
export type EncounterUpdatePaymentMethodMutationResult = Apollo.MutationResult<EncounterUpdatePaymentMethodMutation>;
export type EncounterUpdatePaymentMethodMutationOptions = Apollo.BaseMutationOptions<EncounterUpdatePaymentMethodMutation, EncounterUpdatePaymentMethodMutationVariables>;
export const UnclaimEncounterDocument = gql`
    mutation UnclaimEncounter($id: Int!) {
  unclaimEncounter(input: {encounterId: $id}) {
    encounter {
      ...EncounterFields
    }
  }
}
    ${EncounterFieldsFragmentDoc}`;
export type UnclaimEncounterMutationFn = Apollo.MutationFunction<UnclaimEncounterMutation, UnclaimEncounterMutationVariables>;

/**
 * __useUnclaimEncounterMutation__
 *
 * To run a mutation, you first call `useUnclaimEncounterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnclaimEncounterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unclaimEncounterMutation, { data, loading, error }] = useUnclaimEncounterMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUnclaimEncounterMutation(baseOptions?: Apollo.MutationHookOptions<UnclaimEncounterMutation, UnclaimEncounterMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnclaimEncounterMutation, UnclaimEncounterMutationVariables>(UnclaimEncounterDocument, options);
      }
export type UnclaimEncounterMutationHookResult = ReturnType<typeof useUnclaimEncounterMutation>;
export type UnclaimEncounterMutationResult = Apollo.MutationResult<UnclaimEncounterMutation>;
export type UnclaimEncounterMutationOptions = Apollo.BaseMutationOptions<UnclaimEncounterMutation, UnclaimEncounterMutationVariables>;
export const GetEncounterByEncounterIdDocument = gql`
    query GetEncounterByEncounterId($id: Int!) {
  encounter(encounterId: $id) {
    ...EncounterPrintFields
  }
}
    ${EncounterPrintFieldsFragmentDoc}`;

/**
 * __useGetEncounterByEncounterIdQuery__
 *
 * To run a query within a React component, call `useGetEncounterByEncounterIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEncounterByEncounterIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEncounterByEncounterIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetEncounterByEncounterIdQuery(baseOptions: Apollo.QueryHookOptions<GetEncounterByEncounterIdQuery, GetEncounterByEncounterIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEncounterByEncounterIdQuery, GetEncounterByEncounterIdQueryVariables>(GetEncounterByEncounterIdDocument, options);
      }
export function useGetEncounterByEncounterIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEncounterByEncounterIdQuery, GetEncounterByEncounterIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEncounterByEncounterIdQuery, GetEncounterByEncounterIdQueryVariables>(GetEncounterByEncounterIdDocument, options);
        }
export type GetEncounterByEncounterIdQueryHookResult = ReturnType<typeof useGetEncounterByEncounterIdQuery>;
export type GetEncounterByEncounterIdLazyQueryHookResult = ReturnType<typeof useGetEncounterByEncounterIdLazyQuery>;
export type GetEncounterByEncounterIdQueryResult = Apollo.QueryResult<GetEncounterByEncounterIdQuery, GetEncounterByEncounterIdQueryVariables>;
export function refetchGetEncounterByEncounterIdQuery(variables: GetEncounterByEncounterIdQueryVariables) {
      return { query: GetEncounterByEncounterIdDocument, variables: variables }
    }
export const GetEncounterSearchFiltersDocument = gql`
    query GetEncounterSearchFilters {
  marketsList(orderBy: NAME_ASC) {
    __typename
    marketId
    name
  }
  serviceLinesList(orderBy: NATURAL) {
    __typename
    serviceLineId
    name
    subType
  }
}
    `;

/**
 * __useGetEncounterSearchFiltersQuery__
 *
 * To run a query within a React component, call `useGetEncounterSearchFiltersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEncounterSearchFiltersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEncounterSearchFiltersQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetEncounterSearchFiltersQuery(baseOptions?: Apollo.QueryHookOptions<GetEncounterSearchFiltersQuery, GetEncounterSearchFiltersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEncounterSearchFiltersQuery, GetEncounterSearchFiltersQueryVariables>(GetEncounterSearchFiltersDocument, options);
      }
export function useGetEncounterSearchFiltersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEncounterSearchFiltersQuery, GetEncounterSearchFiltersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEncounterSearchFiltersQuery, GetEncounterSearchFiltersQueryVariables>(GetEncounterSearchFiltersDocument, options);
        }
export type GetEncounterSearchFiltersQueryHookResult = ReturnType<typeof useGetEncounterSearchFiltersQuery>;
export type GetEncounterSearchFiltersLazyQueryHookResult = ReturnType<typeof useGetEncounterSearchFiltersLazyQuery>;
export type GetEncounterSearchFiltersQueryResult = Apollo.QueryResult<GetEncounterSearchFiltersQuery, GetEncounterSearchFiltersQueryVariables>;
export function refetchGetEncounterSearchFiltersQuery(variables?: GetEncounterSearchFiltersQueryVariables) {
      return { query: GetEncounterSearchFiltersDocument, variables: variables }
    }
export const GetEncountersByPatientIdDocument = gql`
    query GetEncountersByPatientId($id: Int!, $orderBy: [EncountersOrderBy!]) {
  encountersList(condition: {patientId: $id}, orderBy: $orderBy) {
    ...EncounterFields
    encounterTasksList {
      encounterTaskId
      status
      taskName
    }
    appointment {
      __typename
      appointmentId
      marketId
      scheduledFor
      scheduledForDate @client
      scheduledForTime @client
    }
  }
}
    ${EncounterFieldsFragmentDoc}`;

/**
 * __useGetEncountersByPatientIdQuery__
 *
 * To run a query within a React component, call `useGetEncountersByPatientIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEncountersByPatientIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEncountersByPatientIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useGetEncountersByPatientIdQuery(baseOptions: Apollo.QueryHookOptions<GetEncountersByPatientIdQuery, GetEncountersByPatientIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEncountersByPatientIdQuery, GetEncountersByPatientIdQueryVariables>(GetEncountersByPatientIdDocument, options);
      }
export function useGetEncountersByPatientIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEncountersByPatientIdQuery, GetEncountersByPatientIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEncountersByPatientIdQuery, GetEncountersByPatientIdQueryVariables>(GetEncountersByPatientIdDocument, options);
        }
export type GetEncountersByPatientIdQueryHookResult = ReturnType<typeof useGetEncountersByPatientIdQuery>;
export type GetEncountersByPatientIdLazyQueryHookResult = ReturnType<typeof useGetEncountersByPatientIdLazyQuery>;
export type GetEncountersByPatientIdQueryResult = Apollo.QueryResult<GetEncountersByPatientIdQuery, GetEncountersByPatientIdQueryVariables>;
export function refetchGetEncountersByPatientIdQuery(variables: GetEncountersByPatientIdQueryVariables) {
      return { query: GetEncountersByPatientIdDocument, variables: variables }
    }
export const GetEncountersByUserIdDocument = gql`
    query GetEncountersByUserId($clinicianIds: [Int], $clinicianStatus: [EncounterClinicianStatusConditionEnum], $responderId: Int, $patientId: Int, $includeResponderNames: Boolean = false, $includeTaskStatuses: Boolean = false, $scheduledForAfter: String, $scheduledForBefore: String, $marketId: [Int], $serviceLine: [Int], $offset: Int!, $limit: Int = 25, $responderStatus: [EncounterResponderStatusConditionEnum], $appointmentStatus: [EncounterAppointmentStatusConditionEnum], $paymentMode: [EncounterPaymentModeConditionEnum]) {
  encounters(
    condition: {clinicianIds: $clinicianIds, clinicianStatus: $clinicianStatus, responderId: $responderId, patientId: $patientId, scheduledForBefore: $scheduledForBefore, scheduledForAfter: $scheduledForAfter, marketId: $marketId, serviceLine: $serviceLine, responderStatus: $responderStatus, appointmentStatus: $appointmentStatus, paymentMode: $paymentMode}
    orderBy: SCHEDULED_FOR_DESC
    offset: $offset
    first: $limit
  ) {
    __typename
    nodes {
      ...EncounterFields
      encounterTasksList @include(if: $includeTaskStatuses) {
        __typename
        encounterTaskId
        status
        taskRoles
      }
      appointment {
        __typename
        appointmentId
        appointmentDispatchesList(condition: {statusIsNot: [REMOVED, PENDING_DISPATCH]}) {
          __typename
          responder @include(if: $includeResponderNames) {
            __typename
            user {
              __typename
              userId
              firstName
              lastName
              fullName @client
            }
          }
        }
        market {
          __typename
          marketId
          name
        }
        scheduledFor
        status
        humanizedStatus @client
      }
      patient {
        ...PatientFields
      }
    }
  }
  encountersCount: encounters(
    condition: {clinicianIds: $clinicianIds, clinicianStatus: $clinicianStatus, responderId: $responderId, patientId: $patientId, scheduledForBefore: $scheduledForBefore, scheduledForAfter: $scheduledForAfter, marketId: $marketId, serviceLine: $serviceLine, responderStatus: $responderStatus, appointmentStatus: $appointmentStatus, paymentMode: $paymentMode}
  ) {
    totalCount
  }
}
    ${EncounterFieldsFragmentDoc}
${PatientFieldsFragmentDoc}`;

/**
 * __useGetEncountersByUserIdQuery__
 *
 * To run a query within a React component, call `useGetEncountersByUserIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEncountersByUserIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEncountersByUserIdQuery({
 *   variables: {
 *      clinicianIds: // value for 'clinicianIds'
 *      clinicianStatus: // value for 'clinicianStatus'
 *      responderId: // value for 'responderId'
 *      patientId: // value for 'patientId'
 *      includeResponderNames: // value for 'includeResponderNames'
 *      includeTaskStatuses: // value for 'includeTaskStatuses'
 *      scheduledForAfter: // value for 'scheduledForAfter'
 *      scheduledForBefore: // value for 'scheduledForBefore'
 *      marketId: // value for 'marketId'
 *      serviceLine: // value for 'serviceLine'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      responderStatus: // value for 'responderStatus'
 *      appointmentStatus: // value for 'appointmentStatus'
 *      paymentMode: // value for 'paymentMode'
 *   },
 * });
 */
export function useGetEncountersByUserIdQuery(baseOptions: Apollo.QueryHookOptions<GetEncountersByUserIdQuery, GetEncountersByUserIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEncountersByUserIdQuery, GetEncountersByUserIdQueryVariables>(GetEncountersByUserIdDocument, options);
      }
export function useGetEncountersByUserIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEncountersByUserIdQuery, GetEncountersByUserIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEncountersByUserIdQuery, GetEncountersByUserIdQueryVariables>(GetEncountersByUserIdDocument, options);
        }
export type GetEncountersByUserIdQueryHookResult = ReturnType<typeof useGetEncountersByUserIdQuery>;
export type GetEncountersByUserIdLazyQueryHookResult = ReturnType<typeof useGetEncountersByUserIdLazyQuery>;
export type GetEncountersByUserIdQueryResult = Apollo.QueryResult<GetEncountersByUserIdQuery, GetEncountersByUserIdQueryVariables>;
export function refetchGetEncountersByUserIdQuery(variables: GetEncountersByUserIdQueryVariables) {
      return { query: GetEncountersByUserIdDocument, variables: variables }
    }
export const StartEncounterDocument = gql`
    query StartEncounter($id: Int!) {
  startEncounter(encounterId: $id) {
    ...EncounterFields
  }
}
    ${EncounterFieldsFragmentDoc}`;

/**
 * __useStartEncounterQuery__
 *
 * To run a query within a React component, call `useStartEncounterQuery` and pass it any options that fit your needs.
 * When your component renders, `useStartEncounterQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStartEncounterQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useStartEncounterQuery(baseOptions: Apollo.QueryHookOptions<StartEncounterQuery, StartEncounterQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StartEncounterQuery, StartEncounterQueryVariables>(StartEncounterDocument, options);
      }
export function useStartEncounterLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StartEncounterQuery, StartEncounterQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StartEncounterQuery, StartEncounterQueryVariables>(StartEncounterDocument, options);
        }
export type StartEncounterQueryHookResult = ReturnType<typeof useStartEncounterQuery>;
export type StartEncounterLazyQueryHookResult = ReturnType<typeof useStartEncounterLazyQuery>;
export type StartEncounterQueryResult = Apollo.QueryResult<StartEncounterQuery, StartEncounterQueryVariables>;
export function refetchStartEncounterQuery(variables: StartEncounterQueryVariables) {
      return { query: StartEncounterDocument, variables: variables }
    }
export const CreateEncounterTaskAttachmentDocument = gql`
    mutation CreateEncounterTaskAttachment($input: CreateEncounterTaskAttachmentInput!) {
  createEncounterTaskAttachment(input: $input) {
    encounterTask {
      ...EncounterTaskFields
    }
  }
}
    ${EncounterTaskFieldsFragmentDoc}`;
export type CreateEncounterTaskAttachmentMutationFn = Apollo.MutationFunction<CreateEncounterTaskAttachmentMutation, CreateEncounterTaskAttachmentMutationVariables>;

/**
 * __useCreateEncounterTaskAttachmentMutation__
 *
 * To run a mutation, you first call `useCreateEncounterTaskAttachmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateEncounterTaskAttachmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createEncounterTaskAttachmentMutation, { data, loading, error }] = useCreateEncounterTaskAttachmentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateEncounterTaskAttachmentMutation(baseOptions?: Apollo.MutationHookOptions<CreateEncounterTaskAttachmentMutation, CreateEncounterTaskAttachmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateEncounterTaskAttachmentMutation, CreateEncounterTaskAttachmentMutationVariables>(CreateEncounterTaskAttachmentDocument, options);
      }
export type CreateEncounterTaskAttachmentMutationHookResult = ReturnType<typeof useCreateEncounterTaskAttachmentMutation>;
export type CreateEncounterTaskAttachmentMutationResult = Apollo.MutationResult<CreateEncounterTaskAttachmentMutation>;
export type CreateEncounterTaskAttachmentMutationOptions = Apollo.BaseMutationOptions<CreateEncounterTaskAttachmentMutation, CreateEncounterTaskAttachmentMutationVariables>;
export const UpdateEncounterTaskDocument = gql`
    mutation UpdateEncounterTask($input: UpdateEncounterTaskInput!, $isAllergiesTask: Boolean = false, $isChiefComplaintAndHpiTask: Boolean = false, $isClinicianBillingTask: Boolean = false, $isDispositionTask: Boolean = false, $isMedicalConditionTask: Boolean = false, $isMedicalDecisionMakingTask: Boolean = false, $isPatientFormTask: Boolean = false, $isPaymentMethodTask: Boolean = false, $isPhysicalExamTask: Boolean = false, $isPointOfCareTestTask: Boolean = false, $isProgressNoteTask: Boolean = false, $isTelehealthTask: Boolean = false, $isVaccineTask: Boolean = false, $isVitalTask: Boolean = false) {
  updateEncounterTask(input: $input) {
    encounterTask {
      ...EncounterTaskFields
      ...EncounterTaskLookupFields
    }
  }
}
    ${EncounterTaskFieldsFragmentDoc}
${EncounterTaskLookupFieldsFragmentDoc}`;
export type UpdateEncounterTaskMutationFn = Apollo.MutationFunction<UpdateEncounterTaskMutation, UpdateEncounterTaskMutationVariables>;

/**
 * __useUpdateEncounterTaskMutation__
 *
 * To run a mutation, you first call `useUpdateEncounterTaskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEncounterTaskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEncounterTaskMutation, { data, loading, error }] = useUpdateEncounterTaskMutation({
 *   variables: {
 *      input: // value for 'input'
 *      isAllergiesTask: // value for 'isAllergiesTask'
 *      isChiefComplaintAndHpiTask: // value for 'isChiefComplaintAndHpiTask'
 *      isClinicianBillingTask: // value for 'isClinicianBillingTask'
 *      isDispositionTask: // value for 'isDispositionTask'
 *      isMedicalConditionTask: // value for 'isMedicalConditionTask'
 *      isMedicalDecisionMakingTask: // value for 'isMedicalDecisionMakingTask'
 *      isPatientFormTask: // value for 'isPatientFormTask'
 *      isPaymentMethodTask: // value for 'isPaymentMethodTask'
 *      isPhysicalExamTask: // value for 'isPhysicalExamTask'
 *      isPointOfCareTestTask: // value for 'isPointOfCareTestTask'
 *      isProgressNoteTask: // value for 'isProgressNoteTask'
 *      isTelehealthTask: // value for 'isTelehealthTask'
 *      isVaccineTask: // value for 'isVaccineTask'
 *      isVitalTask: // value for 'isVitalTask'
 *   },
 * });
 */
export function useUpdateEncounterTaskMutation(baseOptions?: Apollo.MutationHookOptions<UpdateEncounterTaskMutation, UpdateEncounterTaskMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateEncounterTaskMutation, UpdateEncounterTaskMutationVariables>(UpdateEncounterTaskDocument, options);
      }
export type UpdateEncounterTaskMutationHookResult = ReturnType<typeof useUpdateEncounterTaskMutation>;
export type UpdateEncounterTaskMutationResult = Apollo.MutationResult<UpdateEncounterTaskMutation>;
export type UpdateEncounterTaskMutationOptions = Apollo.BaseMutationOptions<UpdateEncounterTaskMutation, UpdateEncounterTaskMutationVariables>;
export const UpdateEncounterTaskAttachmentDocument = gql`
    mutation UpdateEncounterTaskAttachment($input: UpdateEncounterTaskAttachmentInput!) {
  updateEncounterTaskAttachment(input: $input) {
    encounterTask {
      ...EncounterTaskFields
    }
  }
}
    ${EncounterTaskFieldsFragmentDoc}`;
export type UpdateEncounterTaskAttachmentMutationFn = Apollo.MutationFunction<UpdateEncounterTaskAttachmentMutation, UpdateEncounterTaskAttachmentMutationVariables>;

/**
 * __useUpdateEncounterTaskAttachmentMutation__
 *
 * To run a mutation, you first call `useUpdateEncounterTaskAttachmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEncounterTaskAttachmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEncounterTaskAttachmentMutation, { data, loading, error }] = useUpdateEncounterTaskAttachmentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateEncounterTaskAttachmentMutation(baseOptions?: Apollo.MutationHookOptions<UpdateEncounterTaskAttachmentMutation, UpdateEncounterTaskAttachmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateEncounterTaskAttachmentMutation, UpdateEncounterTaskAttachmentMutationVariables>(UpdateEncounterTaskAttachmentDocument, options);
      }
export type UpdateEncounterTaskAttachmentMutationHookResult = ReturnType<typeof useUpdateEncounterTaskAttachmentMutation>;
export type UpdateEncounterTaskAttachmentMutationResult = Apollo.MutationResult<UpdateEncounterTaskAttachmentMutation>;
export type UpdateEncounterTaskAttachmentMutationOptions = Apollo.BaseMutationOptions<UpdateEncounterTaskAttachmentMutation, UpdateEncounterTaskAttachmentMutationVariables>;
export const UpsertEncounterTaskDocument = gql`
    mutation UpsertEncounterTask($input: UpsertEncounterTaskInput!, $isAllergiesTask: Boolean = false, $isChiefComplaintAndHpiTask: Boolean = false, $isClinicianBillingTask: Boolean = false, $isDispositionTask: Boolean = false, $isMedicalConditionTask: Boolean = false, $isMedicalDecisionMakingTask: Boolean = false, $isPatientFormTask: Boolean = false, $isPaymentMethodTask: Boolean = false, $isPhysicalExamTask: Boolean = false, $isPointOfCareTestTask: Boolean = false, $isProgressNoteTask: Boolean = false, $isTelehealthTask: Boolean = false, $isVaccineTask: Boolean = false, $isVitalTask: Boolean = false) {
  upsertEncounterTask(input: $input) {
    encounterTask {
      ...EncounterTaskFields
      ...EncounterTaskLookupFields
    }
  }
}
    ${EncounterTaskFieldsFragmentDoc}
${EncounterTaskLookupFieldsFragmentDoc}`;
export type UpsertEncounterTaskMutationFn = Apollo.MutationFunction<UpsertEncounterTaskMutation, UpsertEncounterTaskMutationVariables>;

/**
 * __useUpsertEncounterTaskMutation__
 *
 * To run a mutation, you first call `useUpsertEncounterTaskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertEncounterTaskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertEncounterTaskMutation, { data, loading, error }] = useUpsertEncounterTaskMutation({
 *   variables: {
 *      input: // value for 'input'
 *      isAllergiesTask: // value for 'isAllergiesTask'
 *      isChiefComplaintAndHpiTask: // value for 'isChiefComplaintAndHpiTask'
 *      isClinicianBillingTask: // value for 'isClinicianBillingTask'
 *      isDispositionTask: // value for 'isDispositionTask'
 *      isMedicalConditionTask: // value for 'isMedicalConditionTask'
 *      isMedicalDecisionMakingTask: // value for 'isMedicalDecisionMakingTask'
 *      isPatientFormTask: // value for 'isPatientFormTask'
 *      isPaymentMethodTask: // value for 'isPaymentMethodTask'
 *      isPhysicalExamTask: // value for 'isPhysicalExamTask'
 *      isPointOfCareTestTask: // value for 'isPointOfCareTestTask'
 *      isProgressNoteTask: // value for 'isProgressNoteTask'
 *      isTelehealthTask: // value for 'isTelehealthTask'
 *      isVaccineTask: // value for 'isVaccineTask'
 *      isVitalTask: // value for 'isVitalTask'
 *   },
 * });
 */
export function useUpsertEncounterTaskMutation(baseOptions?: Apollo.MutationHookOptions<UpsertEncounterTaskMutation, UpsertEncounterTaskMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertEncounterTaskMutation, UpsertEncounterTaskMutationVariables>(UpsertEncounterTaskDocument, options);
      }
export type UpsertEncounterTaskMutationHookResult = ReturnType<typeof useUpsertEncounterTaskMutation>;
export type UpsertEncounterTaskMutationResult = Apollo.MutationResult<UpsertEncounterTaskMutation>;
export type UpsertEncounterTaskMutationOptions = Apollo.BaseMutationOptions<UpsertEncounterTaskMutation, UpsertEncounterTaskMutationVariables>;
export const CreateAddOnTaskDocument = gql`
    query CreateAddOnTask($id: Int!, $moduleName: ModuleNameEnum!) {
  createAddOnTask(encounterId: $id, moduleName: $moduleName) {
    ...EncounterFields
  }
}
    ${EncounterFieldsFragmentDoc}`;

/**
 * __useCreateAddOnTaskQuery__
 *
 * To run a query within a React component, call `useCreateAddOnTaskQuery` and pass it any options that fit your needs.
 * When your component renders, `useCreateAddOnTaskQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCreateAddOnTaskQuery({
 *   variables: {
 *      id: // value for 'id'
 *      moduleName: // value for 'moduleName'
 *   },
 * });
 */
export function useCreateAddOnTaskQuery(baseOptions: Apollo.QueryHookOptions<CreateAddOnTaskQuery, CreateAddOnTaskQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CreateAddOnTaskQuery, CreateAddOnTaskQueryVariables>(CreateAddOnTaskDocument, options);
      }
export function useCreateAddOnTaskLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CreateAddOnTaskQuery, CreateAddOnTaskQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CreateAddOnTaskQuery, CreateAddOnTaskQueryVariables>(CreateAddOnTaskDocument, options);
        }
export type CreateAddOnTaskQueryHookResult = ReturnType<typeof useCreateAddOnTaskQuery>;
export type CreateAddOnTaskLazyQueryHookResult = ReturnType<typeof useCreateAddOnTaskLazyQuery>;
export type CreateAddOnTaskQueryResult = Apollo.QueryResult<CreateAddOnTaskQuery, CreateAddOnTaskQueryVariables>;
export function refetchCreateAddOnTaskQuery(variables: CreateAddOnTaskQueryVariables) {
      return { query: CreateAddOnTaskDocument, variables: variables }
    }
export const GetEncounterTaskAttachmentsByEncounterTaskIdDocument = gql`
    query GetEncounterTaskAttachmentsByEncounterTaskId($id: [Int]) {
  encounterTaskAttachmentsList(condition: {encounterTaskIds: $id}) {
    ...EncounterTaskAttachmentFields
  }
}
    ${EncounterTaskAttachmentFieldsFragmentDoc}`;

/**
 * __useGetEncounterTaskAttachmentsByEncounterTaskIdQuery__
 *
 * To run a query within a React component, call `useGetEncounterTaskAttachmentsByEncounterTaskIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEncounterTaskAttachmentsByEncounterTaskIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEncounterTaskAttachmentsByEncounterTaskIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetEncounterTaskAttachmentsByEncounterTaskIdQuery(baseOptions?: Apollo.QueryHookOptions<GetEncounterTaskAttachmentsByEncounterTaskIdQuery, GetEncounterTaskAttachmentsByEncounterTaskIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEncounterTaskAttachmentsByEncounterTaskIdQuery, GetEncounterTaskAttachmentsByEncounterTaskIdQueryVariables>(GetEncounterTaskAttachmentsByEncounterTaskIdDocument, options);
      }
export function useGetEncounterTaskAttachmentsByEncounterTaskIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEncounterTaskAttachmentsByEncounterTaskIdQuery, GetEncounterTaskAttachmentsByEncounterTaskIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEncounterTaskAttachmentsByEncounterTaskIdQuery, GetEncounterTaskAttachmentsByEncounterTaskIdQueryVariables>(GetEncounterTaskAttachmentsByEncounterTaskIdDocument, options);
        }
export type GetEncounterTaskAttachmentsByEncounterTaskIdQueryHookResult = ReturnType<typeof useGetEncounterTaskAttachmentsByEncounterTaskIdQuery>;
export type GetEncounterTaskAttachmentsByEncounterTaskIdLazyQueryHookResult = ReturnType<typeof useGetEncounterTaskAttachmentsByEncounterTaskIdLazyQuery>;
export type GetEncounterTaskAttachmentsByEncounterTaskIdQueryResult = Apollo.QueryResult<GetEncounterTaskAttachmentsByEncounterTaskIdQuery, GetEncounterTaskAttachmentsByEncounterTaskIdQueryVariables>;
export function refetchGetEncounterTaskAttachmentsByEncounterTaskIdQuery(variables?: GetEncounterTaskAttachmentsByEncounterTaskIdQueryVariables) {
      return { query: GetEncounterTaskAttachmentsByEncounterTaskIdDocument, variables: variables }
    }
export const GetEncounterTaskByEncounterTaskIdDocument = gql`
    query GetEncounterTaskByEncounterTaskId($id: Int!, $isAllergiesTask: Boolean = false, $isChiefComplaintAndHpiTask: Boolean = false, $isClinicianBillingTask: Boolean = false, $isDispositionTask: Boolean = false, $isMedicalConditionTask: Boolean = false, $isMedicalDecisionMakingTask: Boolean = false, $isPatientFormTask: Boolean = false, $isPaymentMethodTask: Boolean = false, $isPhysicalExamTask: Boolean = false, $isPointOfCareTestTask: Boolean = false, $isProgressNoteTask: Boolean = false, $isTelehealthTask: Boolean = false, $isVaccineTask: Boolean = false, $isVitalTask: Boolean = false) {
  encounterTask(encounterTaskId: $id) {
    ...EncounterTaskFields
    ...EncounterTaskLookupFields
  }
}
    ${EncounterTaskFieldsFragmentDoc}
${EncounterTaskLookupFieldsFragmentDoc}`;

/**
 * __useGetEncounterTaskByEncounterTaskIdQuery__
 *
 * To run a query within a React component, call `useGetEncounterTaskByEncounterTaskIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEncounterTaskByEncounterTaskIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEncounterTaskByEncounterTaskIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *      isAllergiesTask: // value for 'isAllergiesTask'
 *      isChiefComplaintAndHpiTask: // value for 'isChiefComplaintAndHpiTask'
 *      isClinicianBillingTask: // value for 'isClinicianBillingTask'
 *      isDispositionTask: // value for 'isDispositionTask'
 *      isMedicalConditionTask: // value for 'isMedicalConditionTask'
 *      isMedicalDecisionMakingTask: // value for 'isMedicalDecisionMakingTask'
 *      isPatientFormTask: // value for 'isPatientFormTask'
 *      isPaymentMethodTask: // value for 'isPaymentMethodTask'
 *      isPhysicalExamTask: // value for 'isPhysicalExamTask'
 *      isPointOfCareTestTask: // value for 'isPointOfCareTestTask'
 *      isProgressNoteTask: // value for 'isProgressNoteTask'
 *      isTelehealthTask: // value for 'isTelehealthTask'
 *      isVaccineTask: // value for 'isVaccineTask'
 *      isVitalTask: // value for 'isVitalTask'
 *   },
 * });
 */
export function useGetEncounterTaskByEncounterTaskIdQuery(baseOptions: Apollo.QueryHookOptions<GetEncounterTaskByEncounterTaskIdQuery, GetEncounterTaskByEncounterTaskIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEncounterTaskByEncounterTaskIdQuery, GetEncounterTaskByEncounterTaskIdQueryVariables>(GetEncounterTaskByEncounterTaskIdDocument, options);
      }
export function useGetEncounterTaskByEncounterTaskIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEncounterTaskByEncounterTaskIdQuery, GetEncounterTaskByEncounterTaskIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEncounterTaskByEncounterTaskIdQuery, GetEncounterTaskByEncounterTaskIdQueryVariables>(GetEncounterTaskByEncounterTaskIdDocument, options);
        }
export type GetEncounterTaskByEncounterTaskIdQueryHookResult = ReturnType<typeof useGetEncounterTaskByEncounterTaskIdQuery>;
export type GetEncounterTaskByEncounterTaskIdLazyQueryHookResult = ReturnType<typeof useGetEncounterTaskByEncounterTaskIdLazyQuery>;
export type GetEncounterTaskByEncounterTaskIdQueryResult = Apollo.QueryResult<GetEncounterTaskByEncounterTaskIdQuery, GetEncounterTaskByEncounterTaskIdQueryVariables>;
export function refetchGetEncounterTaskByEncounterTaskIdQuery(variables: GetEncounterTaskByEncounterTaskIdQueryVariables) {
      return { query: GetEncounterTaskByEncounterTaskIdDocument, variables: variables }
    }
export const GetEncounterTasksByEncounterIdDocument = gql`
    query GetEncounterTasksByEncounterId($id: Int!) {
  encounterTasksList(condition: {encounterId: $id}) {
    ...EncounterTaskFields
  }
}
    ${EncounterTaskFieldsFragmentDoc}`;

/**
 * __useGetEncounterTasksByEncounterIdQuery__
 *
 * To run a query within a React component, call `useGetEncounterTasksByEncounterIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEncounterTasksByEncounterIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEncounterTasksByEncounterIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetEncounterTasksByEncounterIdQuery(baseOptions: Apollo.QueryHookOptions<GetEncounterTasksByEncounterIdQuery, GetEncounterTasksByEncounterIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEncounterTasksByEncounterIdQuery, GetEncounterTasksByEncounterIdQueryVariables>(GetEncounterTasksByEncounterIdDocument, options);
      }
export function useGetEncounterTasksByEncounterIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEncounterTasksByEncounterIdQuery, GetEncounterTasksByEncounterIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEncounterTasksByEncounterIdQuery, GetEncounterTasksByEncounterIdQueryVariables>(GetEncounterTasksByEncounterIdDocument, options);
        }
export type GetEncounterTasksByEncounterIdQueryHookResult = ReturnType<typeof useGetEncounterTasksByEncounterIdQuery>;
export type GetEncounterTasksByEncounterIdLazyQueryHookResult = ReturnType<typeof useGetEncounterTasksByEncounterIdLazyQuery>;
export type GetEncounterTasksByEncounterIdQueryResult = Apollo.QueryResult<GetEncounterTasksByEncounterIdQuery, GetEncounterTasksByEncounterIdQueryVariables>;
export function refetchGetEncounterTasksByEncounterIdQuery(variables: GetEncounterTasksByEncounterIdQueryVariables) {
      return { query: GetEncounterTasksByEncounterIdDocument, variables: variables }
    }
export const CreateInsuranceRecordDocument = gql`
    mutation CreateInsuranceRecord($patientId: Int!, $packageId: String, $company: String, $planType: String, $memberId: String, $groupNumber: String, $relationshipToPolicyHolder: String, $policyHolderFirstName: String, $policyHolderLastName: String, $policyHolderGender: SexEnum, $policyHolderDob: Date, $attachmentBackUrl: JSON, $attachmentFrontUrl: JSON, $noInsuranceCards: Boolean) {
  createInsuranceRecord(
    input: {insuranceRecord: {patientId: $patientId, packageId: $packageId, company: $company, planType: $planType, memberId: $memberId, groupNumber: $groupNumber, relationshipToPolicyHolder: $relationshipToPolicyHolder, policyHolderFirstName: $policyHolderFirstName, policyHolderLastName: $policyHolderLastName, policyHolderGender: $policyHolderGender, policyHolderDob: $policyHolderDob, attachmentBackUrl: $attachmentBackUrl, attachmentFrontUrl: $attachmentFrontUrl, noInsuranceCards: $noInsuranceCards}}
  ) {
    insuranceRecord {
      ...InsuranceRecordFields
    }
  }
}
    ${InsuranceRecordFieldsFragmentDoc}`;
export type CreateInsuranceRecordMutationFn = Apollo.MutationFunction<CreateInsuranceRecordMutation, CreateInsuranceRecordMutationVariables>;

/**
 * __useCreateInsuranceRecordMutation__
 *
 * To run a mutation, you first call `useCreateInsuranceRecordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateInsuranceRecordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createInsuranceRecordMutation, { data, loading, error }] = useCreateInsuranceRecordMutation({
 *   variables: {
 *      patientId: // value for 'patientId'
 *      packageId: // value for 'packageId'
 *      company: // value for 'company'
 *      planType: // value for 'planType'
 *      memberId: // value for 'memberId'
 *      groupNumber: // value for 'groupNumber'
 *      relationshipToPolicyHolder: // value for 'relationshipToPolicyHolder'
 *      policyHolderFirstName: // value for 'policyHolderFirstName'
 *      policyHolderLastName: // value for 'policyHolderLastName'
 *      policyHolderGender: // value for 'policyHolderGender'
 *      policyHolderDob: // value for 'policyHolderDob'
 *      attachmentBackUrl: // value for 'attachmentBackUrl'
 *      attachmentFrontUrl: // value for 'attachmentFrontUrl'
 *      noInsuranceCards: // value for 'noInsuranceCards'
 *   },
 * });
 */
export function useCreateInsuranceRecordMutation(baseOptions?: Apollo.MutationHookOptions<CreateInsuranceRecordMutation, CreateInsuranceRecordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateInsuranceRecordMutation, CreateInsuranceRecordMutationVariables>(CreateInsuranceRecordDocument, options);
      }
export type CreateInsuranceRecordMutationHookResult = ReturnType<typeof useCreateInsuranceRecordMutation>;
export type CreateInsuranceRecordMutationResult = Apollo.MutationResult<CreateInsuranceRecordMutation>;
export type CreateInsuranceRecordMutationOptions = Apollo.BaseMutationOptions<CreateInsuranceRecordMutation, CreateInsuranceRecordMutationVariables>;
export const UpdateInsuranceRecordDocument = gql`
    mutation UpdateInsuranceRecord($insuranceRecordId: Int!, $packageId: String, $company: String, $planType: String, $memberId: String, $groupNumber: String, $relationshipToPolicyHolder: String, $policyHolderFirstName: String, $policyHolderLastName: String, $policyHolderGender: SexEnum, $policyHolderDob: Date, $attachmentBackUrl: JSON, $attachmentFrontUrl: JSON, $noInsuranceCards: Boolean, $isDeleted: Boolean) {
  updateInsuranceRecord(
    input: {patch: {packageId: $packageId, company: $company, planType: $planType, memberId: $memberId, groupNumber: $groupNumber, relationshipToPolicyHolder: $relationshipToPolicyHolder, policyHolderFirstName: $policyHolderFirstName, policyHolderLastName: $policyHolderLastName, policyHolderGender: $policyHolderGender, policyHolderDob: $policyHolderDob, attachmentBackUrl: $attachmentBackUrl, attachmentFrontUrl: $attachmentFrontUrl, noInsuranceCards: $noInsuranceCards, isDeleted: $isDeleted}, insuranceRecordId: $insuranceRecordId}
  ) {
    insuranceRecord {
      ...InsuranceRecordFields
    }
  }
}
    ${InsuranceRecordFieldsFragmentDoc}`;
export type UpdateInsuranceRecordMutationFn = Apollo.MutationFunction<UpdateInsuranceRecordMutation, UpdateInsuranceRecordMutationVariables>;

/**
 * __useUpdateInsuranceRecordMutation__
 *
 * To run a mutation, you first call `useUpdateInsuranceRecordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateInsuranceRecordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateInsuranceRecordMutation, { data, loading, error }] = useUpdateInsuranceRecordMutation({
 *   variables: {
 *      insuranceRecordId: // value for 'insuranceRecordId'
 *      packageId: // value for 'packageId'
 *      company: // value for 'company'
 *      planType: // value for 'planType'
 *      memberId: // value for 'memberId'
 *      groupNumber: // value for 'groupNumber'
 *      relationshipToPolicyHolder: // value for 'relationshipToPolicyHolder'
 *      policyHolderFirstName: // value for 'policyHolderFirstName'
 *      policyHolderLastName: // value for 'policyHolderLastName'
 *      policyHolderGender: // value for 'policyHolderGender'
 *      policyHolderDob: // value for 'policyHolderDob'
 *      attachmentBackUrl: // value for 'attachmentBackUrl'
 *      attachmentFrontUrl: // value for 'attachmentFrontUrl'
 *      noInsuranceCards: // value for 'noInsuranceCards'
 *      isDeleted: // value for 'isDeleted'
 *   },
 * });
 */
export function useUpdateInsuranceRecordMutation(baseOptions?: Apollo.MutationHookOptions<UpdateInsuranceRecordMutation, UpdateInsuranceRecordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateInsuranceRecordMutation, UpdateInsuranceRecordMutationVariables>(UpdateInsuranceRecordDocument, options);
      }
export type UpdateInsuranceRecordMutationHookResult = ReturnType<typeof useUpdateInsuranceRecordMutation>;
export type UpdateInsuranceRecordMutationResult = Apollo.MutationResult<UpdateInsuranceRecordMutation>;
export type UpdateInsuranceRecordMutationOptions = Apollo.BaseMutationOptions<UpdateInsuranceRecordMutation, UpdateInsuranceRecordMutationVariables>;
export const GetMarketsDocument = gql`
    query GetMarkets {
  marketsList(condition: {isDeleted: false}, orderBy: NAME_ASC) {
    name
    marketId
  }
}
    `;

/**
 * __useGetMarketsQuery__
 *
 * To run a query within a React component, call `useGetMarketsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMarketsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMarketsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMarketsQuery(baseOptions?: Apollo.QueryHookOptions<GetMarketsQuery, GetMarketsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMarketsQuery, GetMarketsQueryVariables>(GetMarketsDocument, options);
      }
export function useGetMarketsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMarketsQuery, GetMarketsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMarketsQuery, GetMarketsQueryVariables>(GetMarketsDocument, options);
        }
export type GetMarketsQueryHookResult = ReturnType<typeof useGetMarketsQuery>;
export type GetMarketsLazyQueryHookResult = ReturnType<typeof useGetMarketsLazyQuery>;
export type GetMarketsQueryResult = Apollo.QueryResult<GetMarketsQuery, GetMarketsQueryVariables>;
export function refetchGetMarketsQuery(variables?: GetMarketsQueryVariables) {
      return { query: GetMarketsDocument, variables: variables }
    }
export const PatientCreateEmrAuditLogsDocument = gql`
    mutation PatientCreateEmrAuditLogs($logs: [EmrAuditLogInput]) {
  createEmrAuditLogs(logs: $logs) {
    msg
  }
}
    `;
export type PatientCreateEmrAuditLogsMutationFn = Apollo.MutationFunction<PatientCreateEmrAuditLogsMutation, PatientCreateEmrAuditLogsMutationVariables>;

/**
 * __usePatientCreateEmrAuditLogsMutation__
 *
 * To run a mutation, you first call `usePatientCreateEmrAuditLogsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePatientCreateEmrAuditLogsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [patientCreateEmrAuditLogsMutation, { data, loading, error }] = usePatientCreateEmrAuditLogsMutation({
 *   variables: {
 *      logs: // value for 'logs'
 *   },
 * });
 */
export function usePatientCreateEmrAuditLogsMutation(baseOptions?: Apollo.MutationHookOptions<PatientCreateEmrAuditLogsMutation, PatientCreateEmrAuditLogsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PatientCreateEmrAuditLogsMutation, PatientCreateEmrAuditLogsMutationVariables>(PatientCreateEmrAuditLogsDocument, options);
      }
export type PatientCreateEmrAuditLogsMutationHookResult = ReturnType<typeof usePatientCreateEmrAuditLogsMutation>;
export type PatientCreateEmrAuditLogsMutationResult = Apollo.MutationResult<PatientCreateEmrAuditLogsMutation>;
export type PatientCreateEmrAuditLogsMutationOptions = Apollo.BaseMutationOptions<PatientCreateEmrAuditLogsMutation, PatientCreateEmrAuditLogsMutationVariables>;
export const PatientCreatePatientNoteDocument = gql`
    mutation PatientCreatePatientNote($input: CreatePatientNoteInput!) {
  createPatientNote(input: $input) {
    patient {
      ...PatientFields
      patientNotesList(orderBy: PATIENT_NOTE_ID_DESC, condition: {isDeleted: false}) {
        ...PatientNoteFields
      }
    }
  }
}
    ${PatientFieldsFragmentDoc}
${PatientNoteFieldsFragmentDoc}`;
export type PatientCreatePatientNoteMutationFn = Apollo.MutationFunction<PatientCreatePatientNoteMutation, PatientCreatePatientNoteMutationVariables>;

/**
 * __usePatientCreatePatientNoteMutation__
 *
 * To run a mutation, you first call `usePatientCreatePatientNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePatientCreatePatientNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [patientCreatePatientNoteMutation, { data, loading, error }] = usePatientCreatePatientNoteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePatientCreatePatientNoteMutation(baseOptions?: Apollo.MutationHookOptions<PatientCreatePatientNoteMutation, PatientCreatePatientNoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PatientCreatePatientNoteMutation, PatientCreatePatientNoteMutationVariables>(PatientCreatePatientNoteDocument, options);
      }
export type PatientCreatePatientNoteMutationHookResult = ReturnType<typeof usePatientCreatePatientNoteMutation>;
export type PatientCreatePatientNoteMutationResult = Apollo.MutationResult<PatientCreatePatientNoteMutation>;
export type PatientCreatePatientNoteMutationOptions = Apollo.BaseMutationOptions<PatientCreatePatientNoteMutation, PatientCreatePatientNoteMutationVariables>;
export const PatientUpdatePatientMutationDocument = gql`
    mutation PatientUpdatePatientMutation($input: UpdatePatientInput!) {
  updatePatient(input: $input) {
    patient {
      ...PatientFields
    }
  }
}
    ${PatientFieldsFragmentDoc}`;
export type PatientUpdatePatientMutationMutationFn = Apollo.MutationFunction<PatientUpdatePatientMutation, PatientUpdatePatientMutationVariables>;

/**
 * __usePatientUpdatePatientMutation__
 *
 * To run a mutation, you first call `usePatientUpdatePatientMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePatientUpdatePatientMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [patientUpdatePatientMutation, { data, loading, error }] = usePatientUpdatePatientMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePatientUpdatePatientMutation(baseOptions?: Apollo.MutationHookOptions<PatientUpdatePatientMutation, PatientUpdatePatientMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PatientUpdatePatientMutation, PatientUpdatePatientMutationVariables>(PatientUpdatePatientMutationDocument, options);
      }
export type PatientUpdatePatientMutationHookResult = ReturnType<typeof usePatientUpdatePatientMutation>;
export type PatientUpdatePatientMutationMutationResult = Apollo.MutationResult<PatientUpdatePatientMutation>;
export type PatientUpdatePatientMutationMutationOptions = Apollo.BaseMutationOptions<PatientUpdatePatientMutation, PatientUpdatePatientMutationVariables>;
export const GetPatientByGlobalPatientIdDocument = gql`
    query GetPatientByGlobalPatientId($id: String!) {
  patientByGlobalPatientId(globalPatientId: $id) {
    ...PatientFields
    encountersList {
      __typename
      encounterId
      appointment {
        __typename
        appointmentId
        scheduledFor
        marketId
      }
    }
    patientNotesList(orderBy: PATIENT_NOTE_ID_DESC, condition: {isDeleted: false}) {
      ...PatientNoteFields
    }
  }
}
    ${PatientFieldsFragmentDoc}
${PatientNoteFieldsFragmentDoc}`;

/**
 * __useGetPatientByGlobalPatientIdQuery__
 *
 * To run a query within a React component, call `useGetPatientByGlobalPatientIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPatientByGlobalPatientIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPatientByGlobalPatientIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetPatientByGlobalPatientIdQuery(baseOptions: Apollo.QueryHookOptions<GetPatientByGlobalPatientIdQuery, GetPatientByGlobalPatientIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPatientByGlobalPatientIdQuery, GetPatientByGlobalPatientIdQueryVariables>(GetPatientByGlobalPatientIdDocument, options);
      }
export function useGetPatientByGlobalPatientIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPatientByGlobalPatientIdQuery, GetPatientByGlobalPatientIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPatientByGlobalPatientIdQuery, GetPatientByGlobalPatientIdQueryVariables>(GetPatientByGlobalPatientIdDocument, options);
        }
export type GetPatientByGlobalPatientIdQueryHookResult = ReturnType<typeof useGetPatientByGlobalPatientIdQuery>;
export type GetPatientByGlobalPatientIdLazyQueryHookResult = ReturnType<typeof useGetPatientByGlobalPatientIdLazyQuery>;
export type GetPatientByGlobalPatientIdQueryResult = Apollo.QueryResult<GetPatientByGlobalPatientIdQuery, GetPatientByGlobalPatientIdQueryVariables>;
export function refetchGetPatientByGlobalPatientIdQuery(variables: GetPatientByGlobalPatientIdQueryVariables) {
      return { query: GetPatientByGlobalPatientIdDocument, variables: variables }
    }
export const GetPatientByPatientIdDocument = gql`
    query GetPatientByPatientId($id: Int!) {
  patient(patientId: $id) {
    ...PatientFields
  }
}
    ${PatientFieldsFragmentDoc}`;

/**
 * __useGetPatientByPatientIdQuery__
 *
 * To run a query within a React component, call `useGetPatientByPatientIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPatientByPatientIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPatientByPatientIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetPatientByPatientIdQuery(baseOptions: Apollo.QueryHookOptions<GetPatientByPatientIdQuery, GetPatientByPatientIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPatientByPatientIdQuery, GetPatientByPatientIdQueryVariables>(GetPatientByPatientIdDocument, options);
      }
export function useGetPatientByPatientIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPatientByPatientIdQuery, GetPatientByPatientIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPatientByPatientIdQuery, GetPatientByPatientIdQueryVariables>(GetPatientByPatientIdDocument, options);
        }
export type GetPatientByPatientIdQueryHookResult = ReturnType<typeof useGetPatientByPatientIdQuery>;
export type GetPatientByPatientIdLazyQueryHookResult = ReturnType<typeof useGetPatientByPatientIdLazyQuery>;
export type GetPatientByPatientIdQueryResult = Apollo.QueryResult<GetPatientByPatientIdQuery, GetPatientByPatientIdQueryVariables>;
export function refetchGetPatientByPatientIdQuery(variables: GetPatientByPatientIdQueryVariables) {
      return { query: GetPatientByPatientIdDocument, variables: variables }
    }
export const PatientUpdatePatientNoteDocument = gql`
    mutation PatientUpdatePatientNote($input: UpdatePatientNoteInput!) {
  updatePatientNote(input: $input) {
    patient {
      ...PatientFields
      patientNotesList(orderBy: PATIENT_NOTE_ID_DESC, condition: {isDeleted: false}) {
        ...PatientNoteFields
      }
    }
  }
}
    ${PatientFieldsFragmentDoc}
${PatientNoteFieldsFragmentDoc}`;
export type PatientUpdatePatientNoteMutationFn = Apollo.MutationFunction<PatientUpdatePatientNoteMutation, PatientUpdatePatientNoteMutationVariables>;

/**
 * __usePatientUpdatePatientNoteMutation__
 *
 * To run a mutation, you first call `usePatientUpdatePatientNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePatientUpdatePatientNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [patientUpdatePatientNoteMutation, { data, loading, error }] = usePatientUpdatePatientNoteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePatientUpdatePatientNoteMutation(baseOptions?: Apollo.MutationHookOptions<PatientUpdatePatientNoteMutation, PatientUpdatePatientNoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PatientUpdatePatientNoteMutation, PatientUpdatePatientNoteMutationVariables>(PatientUpdatePatientNoteDocument, options);
      }
export type PatientUpdatePatientNoteMutationHookResult = ReturnType<typeof usePatientUpdatePatientNoteMutation>;
export type PatientUpdatePatientNoteMutationResult = Apollo.MutationResult<PatientUpdatePatientNoteMutation>;
export type PatientUpdatePatientNoteMutationOptions = Apollo.BaseMutationOptions<PatientUpdatePatientNoteMutation, PatientUpdatePatientNoteMutationVariables>;
export const SearchPatientsDocument = gql`
    query SearchPatients($query: String!) {
  searchPatients(nameQuery: $query, orderBy: GLOBAL_PATIENT_ID_ASC) {
    __typename
    patientId
    globalHumanId
    globalPatientId
    firstName
    lastName
    preferredName
    fullName @client
    humanizedGlobalHumanId @client
    dob
  }
}
    `;

/**
 * __useSearchPatientsQuery__
 *
 * To run a query within a React component, call `useSearchPatientsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchPatientsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchPatientsQuery({
 *   variables: {
 *      query: // value for 'query'
 *   },
 * });
 */
export function useSearchPatientsQuery(baseOptions: Apollo.QueryHookOptions<SearchPatientsQuery, SearchPatientsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchPatientsQuery, SearchPatientsQueryVariables>(SearchPatientsDocument, options);
      }
export function useSearchPatientsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchPatientsQuery, SearchPatientsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchPatientsQuery, SearchPatientsQueryVariables>(SearchPatientsDocument, options);
        }
export type SearchPatientsQueryHookResult = ReturnType<typeof useSearchPatientsQuery>;
export type SearchPatientsLazyQueryHookResult = ReturnType<typeof useSearchPatientsLazyQuery>;
export type SearchPatientsQueryResult = Apollo.QueryResult<SearchPatientsQuery, SearchPatientsQueryVariables>;
export function refetchSearchPatientsQuery(variables: SearchPatientsQueryVariables) {
      return { query: SearchPatientsDocument, variables: variables }
    }
export const GetRespondersByNameQueryDocument = gql`
    query GetRespondersByNameQuery($nameQuery: String!) {
  searchResponders(nameQuery: $nameQuery) {
    ...UserFields
  }
}
    ${UserFieldsFragmentDoc}`;

/**
 * __useGetRespondersByNameQuery__
 *
 * To run a query within a React component, call `useGetRespondersByNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRespondersByNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRespondersByNameQuery({
 *   variables: {
 *      nameQuery: // value for 'nameQuery'
 *   },
 * });
 */
export function useGetRespondersByNameQuery(baseOptions: Apollo.QueryHookOptions<GetRespondersByNameQuery, GetRespondersByNameQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRespondersByNameQuery, GetRespondersByNameQueryVariables>(GetRespondersByNameQueryDocument, options);
      }
export function useGetRespondersByNameQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRespondersByNameQuery, GetRespondersByNameQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRespondersByNameQuery, GetRespondersByNameQueryVariables>(GetRespondersByNameQueryDocument, options);
        }
export type GetRespondersByNameQueryHookResult = ReturnType<typeof useGetRespondersByNameQuery>;
export type GetRespondersByNameQueryLazyQueryHookResult = ReturnType<typeof useGetRespondersByNameQueryLazyQuery>;
export type GetRespondersByNameQueryQueryResult = Apollo.QueryResult<GetRespondersByNameQuery, GetRespondersByNameQueryVariables>;
export function refetchGetRespondersByNameQuery(variables: GetRespondersByNameQueryVariables) {
      return { query: GetRespondersByNameQueryDocument, variables: variables }
    }
export const GetStandingOrderByStandingOrderIdDocument = gql`
    query GetStandingOrderByStandingOrderId($id: Int!) {
  standingOrder(standingOrderId: $id) {
    ...StandingOrderFields
  }
}
    ${StandingOrderFieldsFragmentDoc}`;

/**
 * __useGetStandingOrderByStandingOrderIdQuery__
 *
 * To run a query within a React component, call `useGetStandingOrderByStandingOrderIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStandingOrderByStandingOrderIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStandingOrderByStandingOrderIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetStandingOrderByStandingOrderIdQuery(baseOptions: Apollo.QueryHookOptions<GetStandingOrderByStandingOrderIdQuery, GetStandingOrderByStandingOrderIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStandingOrderByStandingOrderIdQuery, GetStandingOrderByStandingOrderIdQueryVariables>(GetStandingOrderByStandingOrderIdDocument, options);
      }
export function useGetStandingOrderByStandingOrderIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStandingOrderByStandingOrderIdQuery, GetStandingOrderByStandingOrderIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStandingOrderByStandingOrderIdQuery, GetStandingOrderByStandingOrderIdQueryVariables>(GetStandingOrderByStandingOrderIdDocument, options);
        }
export type GetStandingOrderByStandingOrderIdQueryHookResult = ReturnType<typeof useGetStandingOrderByStandingOrderIdQuery>;
export type GetStandingOrderByStandingOrderIdLazyQueryHookResult = ReturnType<typeof useGetStandingOrderByStandingOrderIdLazyQuery>;
export type GetStandingOrderByStandingOrderIdQueryResult = Apollo.QueryResult<GetStandingOrderByStandingOrderIdQuery, GetStandingOrderByStandingOrderIdQueryVariables>;
export function refetchGetStandingOrderByStandingOrderIdQuery(variables: GetStandingOrderByStandingOrderIdQueryVariables) {
      return { query: GetStandingOrderByStandingOrderIdDocument, variables: variables }
    }
export const GetStandingOrdersDocument = gql`
    query GetStandingOrders($lookupType: StandingOrderLookupTypeConditionEnum!) {
  standingOrdersList(condition: {lookupType: $lookupType}) {
    ...StandingOrderFields
  }
}
    ${StandingOrderFieldsFragmentDoc}`;

/**
 * __useGetStandingOrdersQuery__
 *
 * To run a query within a React component, call `useGetStandingOrdersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStandingOrdersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStandingOrdersQuery({
 *   variables: {
 *      lookupType: // value for 'lookupType'
 *   },
 * });
 */
export function useGetStandingOrdersQuery(baseOptions: Apollo.QueryHookOptions<GetStandingOrdersQuery, GetStandingOrdersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStandingOrdersQuery, GetStandingOrdersQueryVariables>(GetStandingOrdersDocument, options);
      }
export function useGetStandingOrdersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStandingOrdersQuery, GetStandingOrdersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStandingOrdersQuery, GetStandingOrdersQueryVariables>(GetStandingOrdersDocument, options);
        }
export type GetStandingOrdersQueryHookResult = ReturnType<typeof useGetStandingOrdersQuery>;
export type GetStandingOrdersLazyQueryHookResult = ReturnType<typeof useGetStandingOrdersLazyQuery>;
export type GetStandingOrdersQueryResult = Apollo.QueryResult<GetStandingOrdersQuery, GetStandingOrdersQueryVariables>;
export function refetchGetStandingOrdersQuery(variables: GetStandingOrdersQueryVariables) {
      return { query: GetStandingOrdersDocument, variables: variables }
    }
export const JoinTelehealthMeetingDocument = gql`
    mutation JoinTelehealthMeeting($encounterTaskId: Int!) {
  joinTelehealthMeeting(input: {encounterTaskId: $encounterTaskId}) {
    telehealthMeeting {
      ...TelehealthMeetingFields
    }
  }
}
    ${TelehealthMeetingFieldsFragmentDoc}`;
export type JoinTelehealthMeetingMutationFn = Apollo.MutationFunction<JoinTelehealthMeetingMutation, JoinTelehealthMeetingMutationVariables>;

/**
 * __useJoinTelehealthMeetingMutation__
 *
 * To run a mutation, you first call `useJoinTelehealthMeetingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useJoinTelehealthMeetingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [joinTelehealthMeetingMutation, { data, loading, error }] = useJoinTelehealthMeetingMutation({
 *   variables: {
 *      encounterTaskId: // value for 'encounterTaskId'
 *   },
 * });
 */
export function useJoinTelehealthMeetingMutation(baseOptions?: Apollo.MutationHookOptions<JoinTelehealthMeetingMutation, JoinTelehealthMeetingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<JoinTelehealthMeetingMutation, JoinTelehealthMeetingMutationVariables>(JoinTelehealthMeetingDocument, options);
      }
export type JoinTelehealthMeetingMutationHookResult = ReturnType<typeof useJoinTelehealthMeetingMutation>;
export type JoinTelehealthMeetingMutationResult = Apollo.MutationResult<JoinTelehealthMeetingMutation>;
export type JoinTelehealthMeetingMutationOptions = Apollo.BaseMutationOptions<JoinTelehealthMeetingMutation, JoinTelehealthMeetingMutationVariables>;
export const GetTelehealthMeetingDocument = gql`
    query GetTelehealthMeeting($telehealthMeetingId: Int!) {
  telehealthMeeting(telehealthMeetingId: $telehealthMeetingId) {
    ...TelehealthMeetingFields
  }
}
    ${TelehealthMeetingFieldsFragmentDoc}`;

/**
 * __useGetTelehealthMeetingQuery__
 *
 * To run a query within a React component, call `useGetTelehealthMeetingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTelehealthMeetingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTelehealthMeetingQuery({
 *   variables: {
 *      telehealthMeetingId: // value for 'telehealthMeetingId'
 *   },
 * });
 */
export function useGetTelehealthMeetingQuery(baseOptions: Apollo.QueryHookOptions<GetTelehealthMeetingQuery, GetTelehealthMeetingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTelehealthMeetingQuery, GetTelehealthMeetingQueryVariables>(GetTelehealthMeetingDocument, options);
      }
export function useGetTelehealthMeetingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTelehealthMeetingQuery, GetTelehealthMeetingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTelehealthMeetingQuery, GetTelehealthMeetingQueryVariables>(GetTelehealthMeetingDocument, options);
        }
export type GetTelehealthMeetingQueryHookResult = ReturnType<typeof useGetTelehealthMeetingQuery>;
export type GetTelehealthMeetingLazyQueryHookResult = ReturnType<typeof useGetTelehealthMeetingLazyQuery>;
export type GetTelehealthMeetingQueryResult = Apollo.QueryResult<GetTelehealthMeetingQuery, GetTelehealthMeetingQueryVariables>;
export function refetchGetTelehealthMeetingQuery(variables: GetTelehealthMeetingQueryVariables) {
      return { query: GetTelehealthMeetingDocument, variables: variables }
    }
export const UpdateUserDocument = gql`
    mutation UpdateUser($input: UpdateUserInput!) {
  updateUser(input: $input) {
    user {
      ...UserFields
    }
  }
}
    ${UserFieldsFragmentDoc}`;
export type UpdateUserMutationFn = Apollo.MutationFunction<UpdateUserMutation, UpdateUserMutationVariables>;

/**
 * __useUpdateUserMutation__
 *
 * To run a mutation, you first call `useUpdateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserMutation, { data, loading, error }] = useUpdateUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateUserMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserMutation, UpdateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserMutation, UpdateUserMutationVariables>(UpdateUserDocument, options);
      }
export type UpdateUserMutationHookResult = ReturnType<typeof useUpdateUserMutation>;
export type UpdateUserMutationResult = Apollo.MutationResult<UpdateUserMutation>;
export type UpdateUserMutationOptions = Apollo.BaseMutationOptions<UpdateUserMutation, UpdateUserMutationVariables>;
export const UserGrantRoleMutationDocument = gql`
    mutation UserGrantRoleMutation($input: GrantRoleInput!) {
  grantRole(input: $input) {
    user {
      ...UserFields
    }
  }
}
    ${UserFieldsFragmentDoc}`;
export type UserGrantRoleMutationMutationFn = Apollo.MutationFunction<UserGrantRoleMutation, UserGrantRoleMutationVariables>;

/**
 * __useUserGrantRoleMutation__
 *
 * To run a mutation, you first call `useUserGrantRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserGrantRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userGrantRoleMutation, { data, loading, error }] = useUserGrantRoleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUserGrantRoleMutation(baseOptions?: Apollo.MutationHookOptions<UserGrantRoleMutation, UserGrantRoleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UserGrantRoleMutation, UserGrantRoleMutationVariables>(UserGrantRoleMutationDocument, options);
      }
export type UserGrantRoleMutationHookResult = ReturnType<typeof useUserGrantRoleMutation>;
export type UserGrantRoleMutationMutationResult = Apollo.MutationResult<UserGrantRoleMutation>;
export type UserGrantRoleMutationMutationOptions = Apollo.BaseMutationOptions<UserGrantRoleMutation, UserGrantRoleMutationVariables>;
export const UserRevokeRoleMutationDocument = gql`
    mutation UserRevokeRoleMutation($input: RevokeRoleInput!) {
  revokeRole(input: $input) {
    user {
      ...UserFields
    }
  }
}
    ${UserFieldsFragmentDoc}`;
export type UserRevokeRoleMutationMutationFn = Apollo.MutationFunction<UserRevokeRoleMutation, UserRevokeRoleMutationVariables>;

/**
 * __useUserRevokeRoleMutation__
 *
 * To run a mutation, you first call `useUserRevokeRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserRevokeRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userRevokeRoleMutation, { data, loading, error }] = useUserRevokeRoleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUserRevokeRoleMutation(baseOptions?: Apollo.MutationHookOptions<UserRevokeRoleMutation, UserRevokeRoleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UserRevokeRoleMutation, UserRevokeRoleMutationVariables>(UserRevokeRoleMutationDocument, options);
      }
export type UserRevokeRoleMutationHookResult = ReturnType<typeof useUserRevokeRoleMutation>;
export type UserRevokeRoleMutationMutationResult = Apollo.MutationResult<UserRevokeRoleMutation>;
export type UserRevokeRoleMutationMutationOptions = Apollo.BaseMutationOptions<UserRevokeRoleMutation, UserRevokeRoleMutationVariables>;
export const GetCurrentUserDocument = gql`
    query GetCurrentUser {
  getCurrentUser {
    ...UserFields
  }
}
    ${UserFieldsFragmentDoc}`;

/**
 * __useGetCurrentUserQuery__
 *
 * To run a query within a React component, call `useGetCurrentUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCurrentUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCurrentUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCurrentUserQuery(baseOptions?: Apollo.QueryHookOptions<GetCurrentUserQuery, GetCurrentUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCurrentUserQuery, GetCurrentUserQueryVariables>(GetCurrentUserDocument, options);
      }
export function useGetCurrentUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCurrentUserQuery, GetCurrentUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCurrentUserQuery, GetCurrentUserQueryVariables>(GetCurrentUserDocument, options);
        }
export type GetCurrentUserQueryHookResult = ReturnType<typeof useGetCurrentUserQuery>;
export type GetCurrentUserLazyQueryHookResult = ReturnType<typeof useGetCurrentUserLazyQuery>;
export type GetCurrentUserQueryResult = Apollo.QueryResult<GetCurrentUserQuery, GetCurrentUserQueryVariables>;
export function refetchGetCurrentUserQuery(variables?: GetCurrentUserQueryVariables) {
      return { query: GetCurrentUserDocument, variables: variables }
    }
export const GetUserDocument = gql`
    query GetUser($userId: Int!) {
  user(userId: $userId) {
    ...UserFields
  }
}
    ${UserFieldsFragmentDoc}`;

/**
 * __useGetUserQuery__
 *
 * To run a query within a React component, call `useGetUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetUserQuery(baseOptions: Apollo.QueryHookOptions<GetUserQuery, GetUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserQuery, GetUserQueryVariables>(GetUserDocument, options);
      }
export function useGetUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserQuery, GetUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserQuery, GetUserQueryVariables>(GetUserDocument, options);
        }
export type GetUserQueryHookResult = ReturnType<typeof useGetUserQuery>;
export type GetUserLazyQueryHookResult = ReturnType<typeof useGetUserLazyQuery>;
export type GetUserQueryResult = Apollo.QueryResult<GetUserQuery, GetUserQueryVariables>;
export function refetchGetUserQuery(variables: GetUserQueryVariables) {
      return { query: GetUserDocument, variables: variables }
    }
export const GetUsersDocument = gql`
    query GetUsers($orderBy: [UsersOrderBy!]) {
  usersList(condition: {isDeleted: false}, orderBy: $orderBy) {
    ...UserFields
  }
}
    ${UserFieldsFragmentDoc}`;

/**
 * __useGetUsersQuery__
 *
 * To run a query within a React component, call `useGetUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUsersQuery({
 *   variables: {
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useGetUsersQuery(baseOptions?: Apollo.QueryHookOptions<GetUsersQuery, GetUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUsersQuery, GetUsersQueryVariables>(GetUsersDocument, options);
      }
export function useGetUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUsersQuery, GetUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUsersQuery, GetUsersQueryVariables>(GetUsersDocument, options);
        }
export type GetUsersQueryHookResult = ReturnType<typeof useGetUsersQuery>;
export type GetUsersLazyQueryHookResult = ReturnType<typeof useGetUsersLazyQuery>;
export type GetUsersQueryResult = Apollo.QueryResult<GetUsersQuery, GetUsersQueryVariables>;
export function refetchGetUsersQuery(variables?: GetUsersQueryVariables) {
      return { query: GetUsersDocument, variables: variables }
    }